/* THIS IS A GENERATED FILE, DO NOT EDIT */
import * as GraphqlTypes from "./mainTypes";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const ESignatureObjectAccountFieldsFragmentDoc = gql`
    fragment ESignatureObjectAccountFields on AccountObjectType {
  id
  name
}
    `;
export const ESignatureObjectOfferingFieldsFragmentDoc = gql`
    fragment ESignatureObjectOfferingFields on OfferingObjectType {
  id
  name
}
    `;
export const AddressFieldsFragmentDoc = gql`
    fragment AddressFields on AddressObjectType {
  street
  street2
  street3
  city
  state {
    objectName
    objectType
    objectId
  }
  country {
    objectName
    objectType
    objectId
  }
  postalCode
}
    `;
export const AccountWatchlistInvestorDataFieldsFragmentDoc = gql`
    fragment AccountWatchlistInvestorDataFields on AccountObjectType {
  name
  taxId
  mailingAddress {
    ...AddressFields
  }
  domicileAddress {
    ...AddressFields
  }
  inceptionDate
}
    ${AddressFieldsFragmentDoc}`;
export const IndividualDiligenceDataFragmentFragmentDoc = gql`
    fragment IndividualDiligenceDataFragment on IndividualDiligenceDataObjectType {
  emailAddress
  taxId
  employer
  jobTitle
  dateOfBirth
  phoneNumber
  name
  isUsPerson
  mailingAddress {
    ...AddressFields
  }
  domicileAddress {
    ...AddressFields
  }
}
    ${AddressFieldsFragmentDoc}`;
export const InstitutionDiligenceDataFragmentFragmentDoc = gql`
    fragment InstitutionDiligenceDataFragment on InstitutionDiligenceDataObjectType {
  name
  dateOfOrganization
  taxId
  organizationJurisdiction
  mailingAddress {
    ...AddressFields
  }
  domicileAddress {
    ...AddressFields
  }
}
    ${AddressFieldsFragmentDoc}`;
export const StaffActivationInvalidTokenFragmentFragmentDoc = gql`
    fragment StaffActivationInvalidTokenFragment on StaffActivationTokenInvalidObject {
  errorCode
}
    `;
export const StaffActivationDetailsFragmentFragmentDoc = gql`
    fragment StaffActivationDetailsFragment on StaffActivationDetailsObject {
  user {
    id
    emailAddress
    fullName
  }
}
    `;
export const StoredEmailResponseFragmentDoc = gql`
    fragment StoredEmailResponse on CreateStoredEmailResponse {
  ... on StoredEmailObjectType {
    hashIdentifier
    id
  }
  ... on StoredEmailAlreadyExistsResponse {
    errorCode
    message
    storedEmailId
  }
}
    `;
export const RegardingFragmentDoc = gql`
    fragment Regarding on RegardingObjectType {
  ... on ContactObjectType {
    id
    fullName
  }
  ... on ProspectObjectType {
    id
    title
  }
}
    `;
export const ContactActivityFeedFragmentDoc = gql`
    fragment ContactActivityFeed on ContactActivityFeedObjectType {
  __typename
  ... on NoteObjectType {
    id
    summary
    text
    date
    noteType
    createdAt
    owner {
      id
      fullName
    }
    regarding {
      ...Regarding
    }
  }
  ... on StoredEmailObjectType {
    id
    dateSent
    sender
    subject
    bodyText
    activityFeedOwnerName
    regarding {
      ...Regarding
    }
  }
  ... on EmailObjectType {
    id
    emailSubject: subject
    sentDate: dateSent
    senderName
    bodyText
    batchType
    regarding {
      ...Regarding
    }
    recipientInfo {
      id
      name
      objectType
    }
  }
  ... on CalendarEventObjectType {
    id
    title
    description
    startDatetime
    endDatetime
    createdAt
    user {
      id
      fullName
    }
  }
}
    ${RegardingFragmentDoc}`;
export const DeleteFieldAccessRoleFieldsFragmentDoc = gql`
    fragment DeleteFieldAccessRoleFields on DeleteFieldAccessRoleResponse {
  __typename
  ... on MutationErrorResponse {
    errorCode
    message
  }
  ... on DeleteFieldAccessRoleObject {
    fieldAccessRoleId
  }
}
    `;
export const GetEmailBatchCapitalCallFragmentDoc = gql`
    fragment GetEmailBatchCapitalCall on CapitalCallBatchObjectType {
  id
  description
  effectiveDate
  status
  viewRoute
}
    `;
export const GetEmailBatchDistributionFragmentDoc = gql`
    fragment GetEmailBatchDistribution on DistributionBatchObjectType {
  id
  description
  effectiveDate
  status
  viewRoute
}
    `;
export const GetEmailBatchManagementFeeFragmentDoc = gql`
    fragment GetEmailBatchManagementFee on ManagementFeeBatchObjectType {
  id
  description
  dateDue
  viewRoute
}
    `;
export const GetEmailBatchNetIncomeFragmentDoc = gql`
    fragment GetEmailBatchNetIncome on NetIncomeBatchObjectType {
  id
  description
  effectiveDate
  viewRoute
}
    `;
export const GetEmailBatchTransactionFragmentDoc = gql`
    fragment GetEmailBatchTransaction on TransactionBatchObjectType {
  id
  description
  effectiveDate
  viewRoute
}
    `;
export const GetEmailBatchNavFragmentDoc = gql`
    fragment GetEmailBatchNav on NavBatchObjectType {
  id
  description
  effectiveDate
  viewRoute
}
    `;
export const GetEmailBatchUnitValueFragmentDoc = gql`
    fragment GetEmailBatchUnitValue on UnitValueBatchObjectType {
  id
  description
  effectiveDate
  viewRoute
}
    `;
export const UserLookerDashboardFragmentDoc = gql`
    fragment UserLookerDashboard on UserLookerViewObjectType {
  id
  title
  enabled
}
    `;
export const EditUserLookerViewFieldsFragmentDoc = gql`
    fragment EditUserLookerViewFields on EditUserLookerViewResponse {
  __typename
  ... on MutationErrorResponse {
    errorCode
    message
  }
  ... on EditUserLookerViewObject {
    lookerViews {
      ...UserLookerDashboard
    }
  }
}
    ${UserLookerDashboardFragmentDoc}`;
export const LpOfferingFolderSimpleFieldsFragmentDoc = gql`
    fragment LPOfferingFolderSimpleFields on DocumentFolder {
  id
  name
  createdAt
  modifiedAt
  state
  breadcrumb {
    id
    name
    calculatedRestrictDownload
  }
}
    `;
export const LpOfferingDocumentFieldsFragmentDoc = gql`
    fragment LPOfferingDocumentFields on FolderDocument {
  id
  name
  createdAt
  logicalDate
  documentView {
    id
    firstOpened
    lastOpened
  }
  isCollection
  documentCollectionMemberCount
  currentUpload(dataRoomKey: $dataRoomKey) {
    size
    extension
    source
  }
  calculatedRestrictDownload
}
    `;
export const LpOfferingDocumentFolderFieldsFragmentDoc = gql`
    fragment LPOfferingDocumentFolderFields on DocumentFolder {
  ...LPOfferingFolderSimpleFields
  documents(sort: [FOLDER_SORT_RANK_ASC, CREATED_AT_DESC]) {
    edges {
      node {
        ...LPOfferingDocumentFields
      }
    }
  }
  folders(sortBy: FOLDER_SORT_RANK_ASC) {
    edges {
      node {
        ...LPOfferingFolderSimpleFields
        itemCountForPortal
      }
    }
  }
}
    ${LpOfferingFolderSimpleFieldsFragmentDoc}
${LpOfferingDocumentFieldsFragmentDoc}`;
export const PortalLoginRedirectFragmentFragmentDoc = gql`
    fragment PortalLoginRedirectFragment on PortalLoginRedirectObjectType {
  globalInviteToken
  isStaffUser
}
    `;
export const DateRoomDocumentFolderDetailsFragmentDoc = gql`
    fragment DateRoomDocumentFolderDetails on DataRoomDetailsObjectType {
  parentOffering {
    id
    documentFolder(folderId: $relativeRootFolderId, dataRoomKey: $dataRoomKey) {
      ...LPOfferingDocumentFolderFields
      ...PortalLoginRedirectFragment
    }
  }
}
    ${LpOfferingDocumentFolderFieldsFragmentDoc}
${PortalLoginRedirectFragmentFragmentDoc}`;
export const DataRoomRootFolderFragmentFragmentDoc = gql`
    fragment DataRoomRootFolderFragment on DocumentFolder {
  id
  itemCountForPortal
}
    `;
export const DataRoomDetailsFragmentDoc = gql`
    fragment DataRoomDetails on DataRoomDetailsObjectType {
  subscriptionCount
  gpArena {
    id
    name
    contactEmail
    contactPhone
    websiteUrl
    headerLogoUrl
  }
  dataRoom {
    id
    summary
    description
    published
    size
    minimum
    unitSize
    capTotal
    capEquity
    holdTime
    closingDate
    irrMin
    irrMax
    cocMin
    cocMax
    equityMultipleMin
    equityMultipleMax
    locations {
      id
      caption
      street
      street2
      street3
      city
      state {
        id
        code
      }
      postalCode
      country {
        id
        name
      }
      region
      latitude
      longitude
    }
    extensionFields {
      extensionField {
        id
        name
      }
      values {
        enumValue {
          enumValueLabel
        }
      }
    }
    metrics {
      label {
        id
        labelText
      }
      value
    }
    photos {
      id
      title
      caption
      largePhotoUrl: photoUrl(width: 744, height: 400, option: 1)
      mediumPhotoUrl: photoUrl(width: 500, height: 281, option: 1)
      smallPhotoUrl: photoUrl(width: 374, height: 210, option: 1)
      photoUrl
    }
    videoEmbedCode
    restrictDownloadOptions
  }
  parentOffering {
    id
    lpDisplayName
    currency {
      id
      code
      fullName
      symbol
    }
    prospects {
      edges {
        node {
          id
          prospectContactNameConcatenation
          prospectContactMaps {
            id
            dataRoomKey
          }
        }
      }
    }
    documentFolder(dataRoomKey: $dataRoomKey) {
      ...DataRoomRootFolderFragment
    }
  }
}
    ${DataRoomRootFolderFragmentFragmentDoc}`;
export const DataRoomArenaFragmentFragmentDoc = gql`
    fragment DataRoomArenaFragment on ArenaObjectType {
  id
  contactEmail
  headerLogoUrl
  name
}
    `;
export const DataRoomNoAccessFragmentDoc = gql`
    fragment DataRoomNoAccess on DataRoomNoAccessObjectType {
  canAccessDataRoom
  hasUnauthenticatedAccessOnly
  gpArena {
    ...DataRoomArenaFragment
  }
}
    ${DataRoomArenaFragmentFragmentDoc}`;
export const DataRoomAccreditationRequiredFragmentDoc = gql`
    fragment DataRoomAccreditationRequired on DataRoomAccreditationRequiredObjectType {
  gpArena {
    ...DataRoomArenaFragment
  }
}
    ${DataRoomArenaFragmentFragmentDoc}`;
export const DataRoomRedirectFragmentDoc = gql`
    fragment DataRoomRedirect on DataRoomRedirectObjectType {
  gpArena {
    ...DataRoomArenaFragment
  }
  globalInviteToken
  isStaffUser
}
    ${DataRoomArenaFragmentFragmentDoc}`;
export const DataRoomAccessNdaRequiredFragmentDoc = gql`
    fragment DataRoomAccessNdaRequired on DataRoomAccessNdaRequiredObjectType {
  nda {
    id
    name
    customerName
    agreementText
  }
  offeringName
  gpArena {
    ...DataRoomArenaFragment
  }
}
    ${DataRoomArenaFragmentFragmentDoc}`;
export const DeqAccountInfoFragmentDoc = gql`
    fragment DEQAccountInfo on AccountObjectType {
  id
  name
  disregardedEntity
  disregardedEntityUltimateBeneficialOwner
  disregardedEntityUltimateBeneficialOwnerTaxId
}
    `;
export const HomePageInvestmentPositionTotalsFragmentDoc = gql`
    fragment HomePageInvestmentPositionTotals on TransactionTotalsObjectTypeBase {
  amountCommitted {
    monies
  }
  lifetimeCapitalContributed {
    monies
  }
  lifetimeAmountDistributed {
    monies
  }
  accountValue {
    monies
  }
  lifetimeCapitalOut @include(if: $needLifetimeCapitalOut) {
    monies
  }
  capitalAccountBalance @include(if: $needCapitalAccountBalance) {
    monies
  }
  unfundedCommitment @include(if: $needUnfundedCommitment) {
    monies
  }
  investedEquityBalance @include(if: $needInvestedEquityBalance) {
    monies
  }
  remainingRecallable @include(if: $needRemainingRecallable) {
    monies
  }
  lifetimeAmountCalled @include(if: $needLifetimeAmountCalled) {
    monies
  }
  lifetimeAmountCalledAgainstCommitment @include(if: $needLifetimeAmountCalledAgainstCommitment) {
    monies
  }
  totalOutstandingCapitalCalled @include(if: $needTotalOutstandingCapitalCalled) {
    monies
  }
  lifetimeCapitalContributedAgainstCommitment @include(if: $needLifetimeCapitalContributedAgainstCommitment) {
    monies
  }
  lifetimeAmountRecalled @include(if: $needLifetimeAmountRecalled) {
    monies
  }
  contributionsExcessCommitment @include(if: $needContributionsExcessCommitment) {
    monies
  }
  navBalance @include(if: $needNavBalance) {
    monies
  }
  amountRecallable @include(if: $needAmountRecallable) {
    monies
  }
  lifetimeAmountReturned @include(if: $needLifetimeAmountReturned) {
    monies
  }
  lifetimeAmountPassedThrough @include(if: $needLifetimeAmountPassedThrough) {
    monies
  }
  lifetimeWithheld @include(if: $needLifetimeWithheld) {
    monies
  }
  unitCount @include(if: $needUnitCount)
}
    `;
export const RiskProfileValueFragmentDoc = gql`
    fragment RiskProfileValue on TimeSeriesStringObjectType {
  riskProfileValue: value
}
    `;
export const PercentLeasedValueFragmentDoc = gql`
    fragment PercentLeasedValue on TimeSeriesFloatObjectType {
  percentLeasedValue: value
}
    `;
export const NavValueFragmentDoc = gql`
    fragment NavValue on TimeSeriesWalletObjectType {
  navValue: value {
    monies
  }
}
    `;
export const SingleManagerInvestmentTreeNodeFieldsWithLocationDataFragmentDoc = gql`
    fragment SingleManagerInvestmentTreeNodeFieldsWithLocationData on InvestmentTreeNode {
  objectId
  linkedObject {
    ... on AssetObjectType {
      id
      locations {
        edges {
          node {
            id
            latitude
            longitude
          }
        }
      }
    }
  }
}
    `;
export const WalletFieldsFragmentDoc = gql`
    fragment WalletFields on Wallet {
  monies
}
    `;
export const InvestmentExtensionFieldsFragmentDoc = gql`
    fragment InvestmentExtensionFields on ExtensionFieldTuple {
  extensionField {
    id
    name
    extensionFieldTypeId
  }
  values {
    stringValue
    intValue
    floatValue
    dateValue
    currencyValue {
      ...WalletFields
    }
    enumValue {
      enumValueLabel
    }
  }
}
    ${WalletFieldsFragmentDoc}`;
export const InvestmentPositionTransactionTotalsFragmentDoc = gql`
    fragment InvestmentPositionTransactionTotals on TransactionTotalsObjectTypeBase {
  amountCommitted @include(if: $needAmountCommitted) {
    ...WalletFields
  }
  lifetimeAmountCalled @include(if: $needLifetimeAmountCalled) {
    ...WalletFields
  }
  lifetimeAmountCalledAgainstCommitment @include(if: $needLifetimeAmountCalledAgainstCommitment) {
    ...WalletFields
  }
  totalOutstandingCapitalCalled @include(if: $needTotalOutstandingCapitalCalled) {
    ...WalletFields
  }
  lifetimeAmountDistributed @include(if: $needLifetimeAmountDistributed) {
    ...WalletFields
  }
  lifetimeCapitalContributed @include(if: $needLifetimeCapitalContributed) {
    ...WalletFields
  }
  lifetimeCapitalContributedAgainstCommitment @include(if: $needLifetimeCapitalContributedAgainstCommitment) {
    ...WalletFields
  }
  lifetimeAmountRecalled @include(if: $needLifetimeAmountRecalled) {
    ...WalletFields
  }
  contributionsExcessCommitment @include(if: $needContributionsExcessCommitment) {
    ...WalletFields
  }
  lifetimeCapitalOut @include(if: $needLifetimeCapitalOut) {
    ...WalletFields
  }
  navBalance @include(if: $needNavBalance) {
    ...WalletFields
  }
  lifetimeAmountReturned @include(if: $needLifetimeAmountReturned) {
    ...WalletFields
  }
  lifetimeAmountPassedThrough @include(if: $needLifetimeAmountPassedThrough) {
    ...WalletFields
  }
  lifetimeWithheld @include(if: $needLifetimeWithheld) {
    ...WalletFields
  }
  amountRecallable @include(if: $needAmountRecallable) {
    ...WalletFields
  }
  remainingRecallable @include(if: $needRemainingRecallable) {
    ...WalletFields
  }
  accountValue @include(if: $needAccountValue) {
    ...WalletFields
  }
  capitalAccountBalance @include(if: $needCapitalAccountBalance) {
    ...WalletFields
  }
  unitCount @include(if: $needUnitCount)
}
    ${WalletFieldsFragmentDoc}`;
export const SingleManagerInvestmentTreeNodeFieldsFragmentDoc = gql`
    fragment SingleManagerInvestmentTreeNodeFields on InvestmentTreeNode {
  objectId
  parentObjectId
  linkedObject {
    __typename
    ... on PositionObjectType {
      id
      status
      extensionFields @include(if: $includePositionCustomFields) {
        ...InvestmentExtensionFields
      }
      account {
        name
        extensionFields @include(if: $includeAccountCustomFields) {
          ...InvestmentExtensionFields
        }
      }
      investmentEntity {
        id
        lpDisplayName
        perfMetricsAsOfDate
        entityCollection {
          id
          name
        }
        type {
          id
          name
        }
        arena {
          id
          name
        }
        thumbnail {
          photoUrl(
            width: $thumbnailWidth
            height: $thumbnailHeight
            option: $thumbnailOptions
          )
        }
        extensionFields @include(if: $includeEntityCustomFields) {
          ...InvestmentExtensionFields
        }
      }
      investorGroup {
        id
        name
        latestUnitValues {
          id
        }
      }
      performanceMetrics {
        irrEstimated
      }
      transactionTotals(currency: $currency) @include(if: $includePositionTransactionTotals) {
        ...InvestmentPositionTransactionTotals
      }
    }
  }
}
    ${InvestmentExtensionFieldsFragmentDoc}
${InvestmentPositionTransactionTotalsFragmentDoc}`;
export const SingleManagerInvestmentCommonFieldsFragmentDoc = gql`
    fragment SingleManagerInvestmentCommonFields on InvestmentObjectType {
  percentOwnership
  ownershipUnit {
    id
    precisionPortal
  }
  commitment {
    ...WalletFields
  }
  units
  unitValue {
    ...WalletFields
  }
  unfundedCommitment {
    ...WalletFields
  }
  contributions {
    ...WalletFields
  }
  rollovers {
    ...WalletFields
  }
  redemptions {
    ...WalletFields
  }
  distributions {
    ...WalletFields
  }
  value {
    ...WalletFields
  }
  totalExposure {
    ...WalletFields
  }
  equityBalance {
    ...WalletFields
  }
  valueLabel
  valueIsSold
  irr
  irr1yr
  irr3yr
  irr5yr
  irr10yr
  dpi
  rvpi
  tvpi
  cocYield
  lastTransactionDate
}
    ${WalletFieldsFragmentDoc}`;
export const UnifiedPortalActivationErrorFragmentFragmentDoc = gql`
    fragment UnifiedPortalActivationErrorFragment on UnifiedPortalActivationError {
  message
}
    `;
export const UnifiedPortalDocumentActivationRedirectObjectFragmentFragmentDoc = gql`
    fragment UnifiedPortalDocumentActivationRedirectObjectFragment on UnifiedPortalDocumentActivationRedirectObject {
  activationToken
}
    `;
export const UnifiedPortalDocumentActivationDetailsObjectFragmentFragmentDoc = gql`
    fragment UnifiedPortalDocumentActivationDetailsObjectFragment on UnifiedPortalDocumentActivationDetailsObject {
  inactiveContactDetails {
    id
    emailAddress
    fullName
  }
  activeContactDetails {
    id
    emailAddress
  }
  gpArena {
    id
    name
    contactEmail
    contactPhone
    secondLevelDomain
    headerLogoUrl
    logoWideUrl
  }
}
    `;
export const UnifiedPortalActivationDetailsFragmentFragmentDoc = gql`
    fragment UnifiedPortalActivationDetailsFragment on UnifiedPortalActivationDetails {
  user {
    id
    emailAddress
    fullName
  }
  shouldRedirectToLogin
  hasActiveManagerAccount
  hasUnlinkedManagerAccount
  gpArena {
    id
    name
    contactEmail
    contactPhone
    secondLevelDomain
    headerLogoUrl
    logoWideUrl
  }
}
    `;
export const InvestorTransactionsFeedObjectFieldsFragmentDoc = gql`
    fragment InvestorTransactionsFeedObjectFields on ActivityFeedObjectType {
  ... on CapitalCallObjectType {
    id
    batch {
      id
      effectiveDate
      description
      entity {
        lpDisplayName
        __typename
      }
      __typename
    }
    position {
      id
      entityCurrency
      account {
        id
        name
        __typename
      }
      __typename
    }
    contributions {
      edges {
        node {
          id
          amountReceived {
            monies
            __typename
          }
          paymentDate
          __typename
        }
        __typename
      }
      __typename
    }
    amount {
      monies
      __typename
    }
    email {
      id
      __typename
    }
    __typename
  }
  ... on DistributionObjectType {
    id
    batch {
      id
      effectiveDate
      description
      entity {
        id
        lpDisplayName
        __typename
      }
      __typename
    }
    position {
      id
      entityCurrency
      account {
        id
        name
        __typename
      }
      __typename
    }
    amount: amountDistributed {
      monies
      __typename
    }
    email {
      id
      __typename
    }
    __typename
  }
  ... on EmailObjectType {
    id
    dateSent
    senderName
    subject
    __typename
  }
  ... on NetIncomeObjectType {
    id
    amount {
      monies
      __typename
    }
    batch {
      id
      effectiveDate
      description
      entity {
        lpDisplayName
        __typename
      }
      __typename
    }
    position {
      id
      entityCurrency
      account {
        id
        name
        __typename
      }
      __typename
    }
    email {
      id
      __typename
    }
    __typename
  }
  ... on TransactionObjectType {
    id
    batch {
      id
      effectiveDate
      description
      entity {
        id
        lpDisplayName
        __typename
      }
      transactionType {
        id
        name
        __typename
      }
      __typename
    }
    position {
      id
      entityCurrency
      account {
        id
        name
        __typename
      }
      __typename
    }
    amount: amountReceived {
      monies
      __typename
    }
    __typename
  }
  ... on NoteObjectType {
    id
    __typename
  }
  ... on StoredEmailObjectType {
    id
    __typename
  }
  ... on CalendarEventObjectType {
    id
    title
    description
    startDatetime
    endDatetime
    createdAt
    user {
      id
      fullName
    }
    __typename
  }
  __typename
}
    `;
export const PortalNdaFragmentDoc = gql`
    fragment PortalNda on NdaObjectType {
  id
  name
  customerName
  signedByCurrentUser
  agreementText
}
    `;
export const PortalDocumentFragmentDoc = gql`
    fragment PortalDocument on DocumentObjectType {
  id
  displayName
  downloadName
  sortingDate
  downloadUrl
  previewUrl
  isDownloadRestricted(dataRoomKey: $dataRoomKey)
  lpDocumentView {
    id
    firstOpened
    lastOpened
  }
  currentVersion {
    id
    contentType
    size
    extension
    source
  }
  account {
    id
    name
    lpDisplayName
  }
  userAccountsWithDocumentAccess {
    id
    name
    lpDisplayName
  }
  entity {
    id
    name
    lpDisplayName
  }
  hasAccessViaMultipleEntities
  offering {
    id
    name
  }
  arena {
    id
    name
  }
  category {
    id
    name
  }
  ndaId
  nda {
    ...PortalNda
  }
  isNdaSignedByCurrentUser(dataRoomKey: $dataRoomKey) @include(if: $isDownloadNdaEnabled)
}
    ${PortalNdaFragmentDoc}`;
export const UnauthenticatedDocumentFragmentDoc = gql`
    fragment UnauthenticatedDocument on DocumentObjectType {
  currentVersion {
    id
    contentType
    size
    extension
  }
  id
  displayName
  downloadName
  previewUrl(
    downloadKey: $downloadKey
    dataRoomKey: $dataRoomKey
    viewToken: $viewToken
  )
  downloadUrl(
    downloadKey: $downloadKey
    dataRoomKey: $dataRoomKey
    viewToken: $viewToken
  )
  isDownloadRestricted(dataRoomKey: $dataRoomKey)
}
    `;
export const UnauthenticatedNdaFragmentDoc = gql`
    fragment UnauthenticatedNda on NdaObjectType {
  id
  name
  customerName
  agreementText
}
    `;
export const DocumentNdaRequiredResponseFragmentDoc = gql`
    fragment DocumentNdaRequiredResponse on DocumentNDASignatureRequiredResponse {
  errorCode
  message
  nda {
    ...UnauthenticatedNda
  }
  ndaId
}
    ${UnauthenticatedNdaFragmentDoc}`;
export const DocumentActivationRequiredResponseFragmentDoc = gql`
    fragment DocumentActivationRequiredResponse on DocumentPortalActivationRequiredResponse {
  errorCode
  message
  globalInviteToken
}
    `;
export const ActivityFeedObjectFieldsFragmentDoc = gql`
    fragment ActivityFeedObjectFields on ActivityFeedObjectType {
  ... on CapitalCallObjectType {
    id
    batch {
      id
      effectiveDate
      description
      entity {
        lpDisplayName
      }
    }
    position {
      id
      entityCurrency
      account {
        id
        name
      }
    }
    contributions {
      edges {
        node {
          id
          amountReceived {
            monies
          }
          paymentDate
        }
      }
    }
    amount {
      monies
    }
    email {
      id
    }
  }
  ... on DistributionObjectType {
    id
    batch {
      id
      effectiveDate
      description
      entity {
        id
        lpDisplayName
      }
    }
    position {
      id
      entityCurrency
      account {
        id
        name
      }
    }
    amount: amountDistributed {
      monies
    }
    email {
      id
    }
  }
  ... on EmailObjectType {
    id
    dateSent
    senderName
    subject
  }
  ... on NetIncomeObjectType {
    id
    amount {
      monies
    }
    batch {
      id
      effectiveDate
      description
      entity {
        lpDisplayName
      }
    }
    email {
      id
    }
  }
  ... on TransactionObjectType {
    id
    batch {
      id
      effectiveDate
      description
      entity {
        id
        lpDisplayName
      }
      transactionType {
        id
        name
      }
    }
    position {
      id
      entityCurrency
      account {
        id
        name
      }
    }
    amount: amountReceived {
      monies
    }
  }
  ... on NoteObjectType {
    id
  }
  ... on StoredEmailObjectType {
    id
  }
  ... on CalendarEventObjectType {
    id
    title
    description
    startDatetime
    endDatetime
    createdAt
    user {
      id
      fullName
    }
  }
}
    `;
export const SnapshotFieldsFragmentDoc = gql`
    fragment SnapshotFields on OwnershipSnapshotObjectType {
  deltaDirection
  accountValue {
    monies
  }
  percentOwnership
  unitBalance
  transactionAmount {
    monies
  }
}
    `;
export const PositionExtensionFieldsFragmentDoc = gql`
    fragment PositionExtensionFields on PositionObjectType {
  extensionFields {
    extensionField {
      id
      name
      extensionFieldTypeId
      isMultivalued
      enumName
      enumValues {
        id
        resourceId
        enumName
        enumValueCode
        enumValueLabel
      }
    }
    values {
      id
      intValue
      floatValue
      stringValue
      dateValue
      currencyValue {
        monies
      }
      extensionFieldEnum {
        id
        resourceId
        enumName
        enumValueCode
        enumValueLabel
        sortOrder
      }
      enumValue {
        id
        resourceId
        enumName
        enumValueCode
        enumValueLabel
      }
    }
  }
}
    `;
export const UnifiedPortalUnauthTermsAndPolicyErrorFragmentFragmentDoc = gql`
    fragment UnifiedPortalUnauthTermsAndPolicyErrorFragment on UnifiedPortalUnauthTermsAndPolicyError {
  errorCode
}
    `;
export const UnifiedPortalUnauthTermsAndPolicyObjectFragmentFragmentDoc = gql`
    fragment UnifiedPortalUnauthTermsAndPolicyObjectFragment on UnifiedPortalUnauthTermsAndPolicyObject {
  gpArena {
    id
    name
    domain
    clientTos
    clientPrivacyPolicy
  }
}
    `;
export const AssetWithLocationFragmentDoc = gql`
    fragment AssetWithLocation on AssetObjectType {
  id
  isSold
  name
  locations {
    edges {
      node {
        id
        caption
        city
        street
        street2
        street3
        postalCode
        latitude
        longitude
        countryId
        stateId
        region
      }
    }
  }
}
    `;
export const CashFlowHistoryDataFragmentDoc = gql`
    fragment CashFlowHistoryData on CashflowHistoryChartObjectType {
  useContributionsLabel
  contributions {
    date
    runningTotal {
      monies
    }
    transactions {
      id
      amountReceived {
        monies
      }
      capitalCall {
        id
        amountReceived {
          monies
        }
        batch {
          id
          description
          effectiveDate
        }
      }
      batch {
        id
        description
      }
    }
  }
  redemptions {
    date
    runningTotal {
      monies
    }
    transactions {
      id
      amountReceived {
        monies
      }
      batch {
        id
        description
      }
    }
  }
  distributions {
    date
    runningTotal {
      monies
    }
    distributions {
      id
      amountDistributed {
        monies
      }
      batch {
        id
        description
      }
    }
  }
  commitmentDeltas {
    date
    runningTotal {
      monies
    }
    deltas {
      id
      deltaAmountCommitted {
        monies
      }
      fromPosition {
        id
      }
      toPosition {
        id
      }
      fromAccountName
      toAccountName
    }
  }
}
    `;
export const ArenaTermsAndPpDetailsFragmentFragmentDoc = gql`
    fragment ArenaTermsAndPPDetailsFragment on UnifiedPortalActivationDetails {
  user {
    id
    emailAddress
  }
  gpArena {
    id
    clientTos
    clientPrivacyPolicy
  }
  linkedGpArenaNames
  shouldRedirectToLogin
  hasActiveManagerAccount
}
    `;
export const SubscriptionRedirectErrorFragmentDoc = gql`
    fragment SubscriptionRedirectError on SubscriptionRedirectUrlError {
  message
}
    `;
export const SubscriptionRedirectUrlFragmentDoc = gql`
    fragment SubscriptionRedirectUrl on SubscriptionRedirectUrlObject {
  redirectUrl
  isUnifiedPortalUrl
}
    `;
export const SubscriptionEmbeddedEnvelopeDetailsFragmentFragmentDoc = gql`
    fragment SubscriptionEmbeddedEnvelopeDetailsFragment on EnvelopeDetails {
  ... on SubscriptionEmbeddedEnvelopeDetails {
    offeringId
    offeringName
    prospectId
    prospectTitle
  }
}
    `;
export const ESignatureEntityEnvelopeDetailsFragmentFragmentDoc = gql`
    fragment ESignatureEntityEnvelopeDetailsFragment on EnvelopeDetails {
  ... on ESignatureEntityEnvelopeDetails {
    requestTemplateId
    requestTemplateTitle
    entityId
    entityName
    positionTitles
  }
}
    `;
export const ESignatureOfferingEnvelopeDetailsFragmentFragmentDoc = gql`
    fragment ESignatureOfferingEnvelopeDetailsFragment on EnvelopeDetails {
  ... on ESignatureOfferingEnvelopeDetails {
    requestTemplateId
    requestTemplateTitle
    offeringId
    offeringName
    prospectTitles
  }
}
    `;
export const AssetSelectorAssetFragmentDoc = gql`
    fragment AssetSelectorAsset on AssetObjectType {
  id
  name
  entity {
    id
    name
  }
  assetReportTemplate {
    id
    name
  }
}
    `;
export const ModuleFieldFragmentFragmentDoc = gql`
    fragment moduleFieldFragment on AssetReportTemplateModuleFieldObjectType {
  id
  resourceId
  templateField
  relativePeriod
  assetExtensionFieldId
}
    `;
export const ModuleFragmentFragmentDoc = gql`
    fragment moduleFragment on AssetReportTemplateModuleObjectType {
  id
  title
  enabled
  titleEnabled
  assetReportTemplateModuleType
  moduleFields {
    edges {
      node {
        ...moduleFieldFragment
      }
    }
  }
}
    ${ModuleFieldFragmentFragmentDoc}`;
export const EditAssetReportTemplateResponseFieldsFragmentDoc = gql`
    fragment EditAssetReportTemplateResponseFields on AssetReportTemplateResponseOrError {
  ... on AssetReportTemplateObjectType {
    id
    name
    stationery {
      id
    }
  }
  ... on MutationErrorResponse {
    errorCode
    message
  }
}
    `;
export const DeleteAssetReportTemplateResponseFieldsFragmentDoc = gql`
    fragment DeleteAssetReportTemplateResponseFields on AssetReportTemplateResponseOrError {
  ... on AssetReportTemplateObjectType {
    id
    name
    assets {
      edges {
        node {
          id
          name
        }
      }
    }
  }
  ... on MutationErrorResponse {
    errorCode
    message
  }
}
    `;
export const DocumentFieldsFragmentDoc = gql`
    fragment DocumentFields on DocumentObjectType {
  id
  name
  sortingDate
  category {
    id
    name
  }
}
    `;
export const PositionFieldsFragmentDoc = gql`
    fragment PositionFields on PositionObjectType {
  id
  account {
    name
  }
}
    `;
export const ProspectFieldsFragmentDoc = gql`
    fragment ProspectFields on ProspectObjectType {
  title
}
    `;
export const SignerContactFieldsFragmentDoc = gql`
    fragment SignerContactFields on ContactObjectType {
  id
  fullName
  primaryEmail {
    id
    emailAddress
  }
  thumbnail {
    id
    photoUrl
  }
}
    `;
export const OfferingDocumentFieldsFragmentDoc = gql`
    fragment OfferingDocumentFields on FolderDocument {
  id
  name
  createdAt
  logicalDate
  calculatedSharedWithAllProspects
  calculatedSharedWithProspectIds
  calculatedRestrictDownload
  sharedWithContactsCount
  isCollection
  shareNotInheritable
  documentCollectionMemberCount
  currentUpload {
    extension
    size
  }
}
    `;
export const CreateFolderDocumentFieldsFragmentDoc = gql`
    fragment CreateFolderDocumentFields on CreateFolderDocumentsResponse {
  __typename
  ... on MutationErrorResponse {
    errorCode
    message
  }
  ... on FolderDocumentResults {
    documents {
      ... on FolderDocument {
        ...OfferingDocumentFields
      }
      ... on FolderDocumentError {
        errors
        errorCode
        message
        documentName
      }
    }
  }
}
    ${OfferingDocumentFieldsFragmentDoc}`;
export const BreadcrumbFieldsFragmentDoc = gql`
    fragment BreadcrumbFields on Breadcrumb {
  id
  name
  calculatedRequiresLogin
  calculatedSharedWithAllProspects
  calculatedSharedWithProspectIds
  calculatedRestrictDownload
}
    `;
export const OfferingFolderSimpleFieldsFragmentDoc = gql`
    fragment OfferingFolderSimpleFields on DocumentFolder {
  id
  soaId
  name
  createdAt
  modifiedAt
  state
  sharedWithProspectIds
  parentFolderId
  breadcrumb {
    ...BreadcrumbFields
  }
}
    ${BreadcrumbFieldsFragmentDoc}`;
export const OfferingDocumentFolderFieldsFragmentDoc = gql`
    fragment OfferingDocumentFolderFields on DocumentFolder {
  ...OfferingFolderSimpleFields
  documents(sort: [FOLDER_SORT_RANK_ASC, CREATED_AT_DESC]) {
    count
    edges {
      node {
        ...OfferingDocumentFields
      }
    }
  }
  folders(sortBy: FOLDER_SORT_RANK_ASC) {
    count
    edges {
      node {
        ...OfferingFolderSimpleFields
        documentCount
        folders {
          count
        }
      }
    }
  }
}
    ${OfferingFolderSimpleFieldsFragmentDoc}
${OfferingDocumentFieldsFragmentDoc}`;
export const ProspectFolderSimpleFieldsFragmentDoc = gql`
    fragment ProspectFolderSimpleFields on DocumentFolder {
  id
  name
  createdAt
  modifiedAt
  breadcrumb {
    id
    name
  }
}
    `;
export const DocumentShareFragmentFragmentDoc = gql`
    fragment DocumentShareFragment on DocumentShareObjectType {
  id
  firstDownloaded
  lastDownloaded
  email {
    id
    dateSent
  }
}
    `;
export const DocumentViewFragmentFragmentDoc = gql`
    fragment DocumentViewFragment on DocumentViewObjectType {
  id
  firstOpened
  lastOpened
}
    `;
export const ProspectDocumentFieldsFragmentDoc = gql`
    fragment ProspectDocumentFields on FolderDocument {
  id
  name
  createdAt
  logicalDate
  currentUpload {
    extension
  }
  documentShare {
    ...DocumentShareFragment
  }
  documentView {
    ...DocumentViewFragment
  }
}
    ${DocumentShareFragmentFragmentDoc}
${DocumentViewFragmentFragmentDoc}`;
export const ProspectDocumentFolderFieldsFragmentDoc = gql`
    fragment ProspectDocumentFolderFields on DocumentFolder {
  ...ProspectFolderSimpleFields
  documents(sort: [FOLDER_SORT_RANK_ASC, CREATED_AT_DESC]) {
    count
    edges {
      node {
        ...ProspectDocumentFields
      }
    }
  }
  folders(sortBy: FOLDER_SORT_RANK_ASC) {
    count
    edges {
      node {
        ...ProspectFolderSimpleFields
        documents {
          count
        }
        folders {
          count
        }
      }
    }
  }
}
    ${ProspectFolderSimpleFieldsFragmentDoc}
${ProspectDocumentFieldsFragmentDoc}`;
export const TwrPeriodMetricFragmentDoc = gql`
    fragment TwrPeriodMetric on TwrPeriodMetricDetailsObjectType {
  ... on TwrPeriodMetricStaffObjectType {
    metric {
      id
      grossIncome
      grossAppreciation
      netIncome
      netAppreciation
      unclassifiedIncome
      grossIncomeOverride
      grossAppreciationOverride
      netIncomeOverride
      netAppreciationOverride
      twrPeriod
      weightedAverageEquity {
        monies
      }
      weightedAverageEquityOverride {
        monies
      }
    }
    isWithinTwrDateRange
  }
}
    `;
export const TimeSeriesStringFragmentDoc = gql`
    fragment TimeSeriesString on TimeSeriesStringObjectType {
  stringVal: value
}
    `;
export const TimeSeriesFloatFragmentDoc = gql`
    fragment TimeSeriesFloat on TimeSeriesFloatObjectType {
  floatVal: value
}
    `;
export const TimeSeriesDateFragmentDoc = gql`
    fragment TimeSeriesDate on TimeSeriesDateObjectType {
  dateVal: value
}
    `;
export const TimeSeriesIntFragmentDoc = gql`
    fragment TimeSeriesInt on TimeSeriesIntObjectType {
  intVal: value
}
    `;
export const TimeSeriesRangeFragmentDoc = gql`
    fragment TimeSeriesRange on TimeSeriesRangeObjectType {
  minVal: minValue
  maxVal: maxValue
}
    `;
export const TimeSeriesWalletFragmentDoc = gql`
    fragment TimeSeriesWallet on TimeSeriesWalletObjectType {
  walletVal: value {
    monies
  }
}
    `;
export const TimeSeriesFieldsFragmentDoc = gql`
    fragment TimeSeriesFields on TimeSeriesFieldWrapperObjectType {
  typeName
  label
  dataType
  ...TimeSeriesString
  ...TimeSeriesFloat
  ...TimeSeriesDate
  ...TimeSeriesInt
  ...TimeSeriesRange
  ...TimeSeriesWallet
}
    ${TimeSeriesStringFragmentDoc}
${TimeSeriesFloatFragmentDoc}
${TimeSeriesDateFragmentDoc}
${TimeSeriesIntFragmentDoc}
${TimeSeriesRangeFragmentDoc}
${TimeSeriesWalletFragmentDoc}`;
export const LoanHistoricalTimeSeriesFragmentDoc = gql`
    fragment LoanHistoricalTimeSeries on LoanObjectType {
  timeSeries(timeSeriesTypeNames: $loanTimeSeriesTypeNames) {
    asOfDate
    values {
      ...TimeSeriesFields
    }
  }
  timeSeriesProjections(timeSeriesTypeNames: $loanProjectionTypeNames) {
    asOfDate
    values {
      ...TimeSeriesFields
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;
export const CurrencyFieldsFragmentDoc = gql`
    fragment CurrencyFields on CurrencyObjectType {
  id
  code
  fullName
  symbol
  flagUnicode
}
    `;
export const LoanFieldsFragmentDoc = gql`
    fragment LoanFields on LoanObjectType {
  id
  amortizationMonths
  borrowerName
  description
  entityIsLender
  extendedMaturityDate
  extensionOptions
  extensionsGranted
  firstPrincipalPaymentDate
  floatingRateFloor
  interestRateDescription
  interestOnlyMonths
  lender
  lenderType
  lienPosition
  loanIndex
  loanType
  originationDate
  originationFee
  maturityDate
  minimumLoanInterestYield
  name
  partialReleaseConditions
  paymentType
  paymentDueDate
  payoffDate
  prepaymentPenalty
  swapsCaps
  thirdPartyFee
  canEdit
  currency {
    ...CurrencyFields
  }
  totalAmount {
    monies
  }
  initialAmount {
    monies
  }
  finalAmount {
    monies
  }
  futureFunding {
    monies
  }
  entity {
    id
    name
    currency {
      ...CurrencyFields
    }
  }
  assetAllocations {
    assetId
    assetName
    allocationPct
  }
}
    ${CurrencyFieldsFragmentDoc}`;
export const LoanCurrentTimeSeriesFragmentDoc = gql`
    fragment LoanCurrentTimeSeries on LoanObjectType {
  latestTimeSeries(timeSeriesTypeNames: $loanTimeSeriesTypeNames) {
    asOfDate
    values {
      ...TimeSeriesFields
    }
  }
  latestTimeSeriesProjections(timeSeriesTypeNames: $loanProjectionTypeNames) {
    asOfDate
    values {
      ...TimeSeriesFields
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;
export const LoanMetricPeriodsFragmentDoc = gql`
    fragment LoanMetricPeriods on LoanObjectType {
  loanMetricPeriods {
    edges {
      node {
        id
        period
        values {
          id
          value {
            monies
          }
          metric {
            id
            name
            label
          }
        }
      }
    }
  }
}
    `;
export const FieldsForLoanDisplayFragmentDoc = gql`
    fragment FieldsForLoanDisplay on LoanObjectType {
  ...LoanFields
  ...LoanCurrentTimeSeries
  ...LoanMetricPeriods
}
    ${LoanFieldsFragmentDoc}
${LoanCurrentTimeSeriesFragmentDoc}
${LoanMetricPeriodsFragmentDoc}`;
export const AccountFieldsFragmentDoc = gql`
    fragment AccountFields on AccountObjectType {
  id
  name
  type {
    id
    name
  }
  taxId
  taxIdRedacted
  legalEntityName
  isInvestmentEntity
  status
}
    `;
export const ArenaFieldsFragmentDoc = gql`
    fragment ArenaFields on ArenaObjectType {
  id
  name
  domain
  emailDomain
  isIdsTermsOfServiceSigned
  packagingEdition {
    id
    name
    label
  }
  capitalCallEmailDistributionListId
  capitalActivityEmailDistributionListId
  distributionEmailDistributionListId
  reportEmailDistributionListId
  netIncomeEmailDistributionListId
  managementFeeEmailDistributionListId
  capitalCallDocumentCategoryId
  capitalActivityDocumentCategoryId
  distributionDocumentCategoryId
  statementDocumentCategoryId
  netIncomeDocumentCategoryId
  netNoticeDocumentCategoryId
  lookerVerificationRecordValue
  lookerAcmeRecordValue
  lookerInstanceId
  lookerApiKeyIdValue
  lookerApiKeySecretValue
}
    `;
export const EditArenaFieldsFragmentDoc = gql`
    fragment EditArenaFields on EditArenaResponse {
  __typename
  ... on MutationErrorResponse {
    errorCode
    message
  }
  ... on EditArenaObject {
    arena {
      ...ArenaFields
      features {
        hasTransferAccounting
        hasPortalInvites
        hasYardiImImport
        hasParallelFunds
        hasSubscriptions
        hasUnifiedLpSubscription
        hasEditableLpPaymentPreferences
        hasAdvancedPermissions
        hasYardiVoyagerIntegration
        hasFundAdmin
        hasCustomerEmailServer
        hasEmailServiceProviderMailgun
        hasOutlookIntegration
        hasAnalytics
        hasInsightEtl
        hasNetIncomeSettings
        hasNetAssetValueSettings
        hasOpenEndFundSettings
        hasAccountValuesSettings
        supportsComprehensiveAuditLog
        supportsCustomDataFields
        supportsDynamicSubscriptionQuestions
        supportsIlpaNotices
        supportsMultipleNda
        supportsMultipleStationery
        supportsProspectTableCustomization
        supportsTimeWeightedReturn
        supportsWatermarking
        hasAutomatedPayments
        hasOperatingCompanies
        hasUnifiedPortalPreview
        hasSso
        hasNewOwnershipTypes
        hasAutoSubscribeLeads
        supportsEntityLevelContacts
        requireLpAccreditationAndPreferences
        showFundAdminDeliverablesModule
        showFaAccountingTab
        hasGpxIntegration
        hasDynamicSubscriptions
        hasDynamicSubscriptionsCustomSections
        mappingTabAdminSettings
        hasGpxIntegrationExport
        hasProspectOptimization
        hasHubspotIntegration
        hasGlDataForSoi
        hasLpcmAutomaticUpdateAndRemoval
        hasContactLastUpdateOptimization
        hasExternalAuthentication
        hasEditAndDeleteActivity
        hasZapierIntegration
        hasBankAccountShowSwiftUi
        hasSwiftPayments
        hasBulkCountersign
        hasCountersignerGroups
        showOwnershipTabWithNewLogic
        enablePublishToDataFabric
        useDocusignOauthFor2fa
        hasSftpDocumentPosting
        hasCreditAppIntegration
        hasFullCrmProAndEnterprise
        hasFullCrmSponsor
      }
    }
    provisioningJob {
      id
    }
  }
}
    ${ArenaFieldsFragmentDoc}`;
export const AssetThumbnailFragmentDoc = gql`
    fragment AssetThumbnail on AssetObjectType {
  thumbnail {
    id
    photoUrl(width: $thumbnailWidth, height: $thumbnailHeight, option: $photoOption)
  }
}
    `;
export const LocationFieldsFragmentDoc = gql`
    fragment LocationFields on LocationObjectType {
  id
  caption
  street
  street2
  street3
  city
  postalCode
  latitude
  longitude
  explicitLatLon
  state {
    id
    code
    name
    ncreifRegion
    ncreifDivision
  }
  region
  country {
    id
    name
    alpha2code
    code
  }
  marketName
  submarketName
  marketTier
  opportunityZone
}
    `;
export const AssetLocationsFragmentDoc = gql`
    fragment AssetLocations on AssetObjectType {
  locations {
    edges {
      node {
        ...LocationFields
      }
    }
  }
}
    ${LocationFieldsFragmentDoc}`;
export const PhotoFieldsFragmentDoc = gql`
    fragment PhotoFields on PhotoObjectType {
  id
  name
  title
  caption
  index: sortOrder
  photoUrl
}
    `;
export const AssetPhotosFragmentDoc = gql`
    fragment AssetPhotos on AssetObjectType {
  photos {
    edges {
      node {
        ...PhotoFields
      }
    }
  }
}
    ${PhotoFieldsFragmentDoc}`;
export const ProductTypeAndSizeFieldsFragmentDoc = gql`
    fragment ProductTypeAndSizeFields on ProductTypeAndSizeObjectType {
  id
  resourceId
  productType
  productSubtype
  navAllocation
  grossSqft
  netSqft
  parcelSqft
  parcelAcres
  parcelNumber
  floorCount
  keyCount
  bedCount
  buildingCount
  unitCount
  lotCount
  studioUnitCount
  oneBedroomUnitCount
  twoBedroomUnitCount
  threeBedroomUnitCount
  fourBedroomUnitCount
  commercialUnitCount
  climateControlled
  driveUpAccess
  indoorStorageAccess
  cropTypes
}
    `;
export const AssetProductTypesFragmentDoc = gql`
    fragment AssetProductTypes on AssetObjectType {
  productTypes {
    edges {
      node {
        ...ProductTypeAndSizeFields
      }
    }
  }
}
    ${ProductTypeAndSizeFieldsFragmentDoc}`;
export const AssetOverviewFragmentDoc = gql`
    fragment AssetOverview on AssetObjectType {
  name
  description
  currency {
    ...CurrencyFields
  }
  entity {
    id
    published
    currency {
      ...CurrencyFields
    }
  }
  websiteUrl
  yearBuiltOrRenovated
  yearBuilt
  yearRenovated
  propertyManager
  developer
  ageRestricted
  classUponEntry
  classUponStabilization
  expectedHoldYears
  expectedHoldMonths
  businessStrategy
  generalContractor
  zoning
  parkingSpaces
  published
  canEdit
}
    ${CurrencyFieldsFragmentDoc}`;
export const AssetStateCbsaFragmentDoc = gql`
    fragment AssetStateCBSA on AssetObjectType {
  stateCbsa {
    id
    name
  }
}
    `;
export const AssetAcquisitionsFragmentDoc = gql`
    fragment AssetAcquisitions on AssetObjectType {
  acquisitions {
    edges {
      node {
        id
        description
        dateAcquired
        percentAcquired
        price {
          monies
        }
        netPurchasePrice {
          monies
        }
        listPrice {
          monies
        }
        replacementCost {
          monies
        }
        initialCapEquity {
          monies
        }
        initialCapDebt {
          monies
        }
        seller
        acquisitionSource
        pctManagerFee
        pctThirdPartyFee
        timeSeriesAtAcquisitionDate(timeSeriesTypeNames: $assetTimeSeriesTypeNames) {
          values {
            ...TimeSeriesFields
          }
          asOfDate
        }
      }
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;
export const DispositionFieldsFragmentDoc = gql`
    fragment DispositionFields on AssetDispositionObjectType {
  id
  assetId
  dateDisposed
  description
  percentDisposed
  buyer
  finalIrr
  finalMultiple
  pctManagerFee
  pctThirdPartyFee
  price {
    monies
  }
  netSalePrice {
    monies
  }
  netProceeds {
    monies
  }
  finalCapEquity {
    monies
  }
  finalCapDebt {
    monies
  }
  timeSeriesAtDispositionDate(timeSeriesTypeNames: $assetTimeSeriesTypeNames) {
    values {
      ...TimeSeriesFields
    }
    asOfDate
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;
export const AssetDispositionsFragmentDoc = gql`
    fragment AssetDispositions on AssetObjectType {
  dispositions {
    edges {
      node {
        ...DispositionFields
      }
    }
  }
}
    ${DispositionFieldsFragmentDoc}`;
export const AssetKeyDatesActualsFragmentDoc = gql`
    fragment AssetKeyDatesActuals on AssetObjectType {
  landLoanCloseDate
  constructionLoanCloseDate
  siteWorkStartDate
  siteWorkEndDate
  verticalConstructionStartDate
  verticalConstructionEndDate
  certificateOfOccupancyDate
  grandOpeningDate
  firstOccupancyDate
  stabilizationDate
  firstDistributionDate
  permanentFinancingDate
  saleDate
}
    `;
export const AssetFieldsFragmentDoc = gql`
    fragment AssetFields on AssetObjectType {
  id
  name
  isSold
  visible
  ...AssetThumbnail
  ...AssetLocations
  ...AssetPhotos
  ...AssetProductTypes
  ...AssetOverview
  ...AssetStateCBSA
  ...AssetAcquisitions
  ...AssetDispositions
  ...AssetKeyDatesActuals
}
    ${AssetThumbnailFragmentDoc}
${AssetLocationsFragmentDoc}
${AssetPhotosFragmentDoc}
${AssetProductTypesFragmentDoc}
${AssetOverviewFragmentDoc}
${AssetStateCbsaFragmentDoc}
${AssetAcquisitionsFragmentDoc}
${AssetDispositionsFragmentDoc}
${AssetKeyDatesActualsFragmentDoc}`;
export const AssetsFragmentDoc = gql`
    fragment Assets on AccountObjectType {
  assets {
    edges {
      node {
        ...AssetFields
      }
    }
  }
}
    ${AssetFieldsFragmentDoc}`;
export const ExtensionFieldsFragmentDoc = gql`
    fragment ExtensionFields on AssetObjectType {
  extensionFields {
    extensionField {
      id
      name
      extensionFieldTypeId
      isMultivalued
      enumValues {
        enumName
        enumValueCode
        enumValueLabel
      }
    }
    values {
      id
      intValue
      floatValue
      stringValue
      dateValue
      currencyValue {
        monies
      }
      extensionFieldEnum {
        id
        resourceId
        enumName
        enumValueCode
        enumValueLabel
        sortOrder
      }
    }
  }
}
    `;
export const DeleteAssetFieldsFragmentDoc = gql`
    fragment DeleteAssetFields on DeleteAssetResponse {
  __typename
  ... on MutationErrorResponse {
    errorCode
    message
  }
  ... on DeleteAssetObject {
    asset {
      id
      entity {
        id
        assetsIndirect {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export const DeleteAssetLocationFieldsFragmentDoc = gql`
    fragment DeleteAssetLocationFields on DeleteAssetLocationResponse {
  __typename
  ... on MutationErrorResponse {
    errorCode
    message
  }
  ... on DeleteAssetLocationObject {
    location {
      id
      asset {
        id
      }
    }
  }
}
    `;
export const SecurityFieldsFragmentDoc = gql`
    fragment SecurityFields on SecurityTotals {
  date
  unitCount
  unitCost {
    monies
  }
  unitValue {
    monies
  }
  cost {
    monies
  }
  fairValue {
    monies
  }
  unrealizedGain {
    monies
  }
}
    `;
export const AsyncJobFieldsFragmentDoc = gql`
    fragment AsyncJobFields on AsyncJobObjectType {
  id
  jobType
  status
  startTime
  endTime
  data
}
    `;
export const CapitalCallBatchFieldsFragmentDoc = gql`
    fragment CapitalCallBatchFields on CapitalCallBatchObjectType {
  id
  effectiveDate
  description
  remittanceInstructions
  status
}
    `;
export const OrganizationContactFieldsFragmentDoc = gql`
    fragment OrganizationContactFields on ContactObjectType {
  id
  contactType
  firstName
  lastName
  fullName
  jobTitle
  staff {
    id
  }
}
    `;
export const ContactThumbnailFieldsFragmentDoc = gql`
    fragment ContactThumbnailFields on ContactPhotoObjectType {
  photoUrl(width: $thumbnailWidth, height: $thumbnailHeight)
}
    `;
export const ContactFieldsFragmentDoc = gql`
    fragment ContactFields on ContactObjectType {
  id
  contactType
  firstName
  lastName
  fullName
  staff {
    id
  }
  jobTitle
  primaryEmail {
    emailAddress
  }
  emails {
    emailAddress
  }
  company {
    ...OrganizationContactFields
  }
  thumbnail {
    ...ContactThumbnailFields
  }
}
    ${OrganizationContactFieldsFragmentDoc}
${ContactThumbnailFieldsFragmentDoc}`;
export const ContactExtensionFieldsFragmentDoc = gql`
    fragment ContactExtensionFields on ExtensionFieldTuple {
  extensionField {
    id
    name
    extensionFieldTypeId
    isMultivalued
    enumValues {
      enumName
      enumValueCode
      enumValueLabel
    }
  }
  values {
    id
    intValue
    floatValue
    stringValue
    dateValue
    currencyValue {
      monies
    }
    extensionFieldEnum {
      id
      resourceId
      enumName
      enumValueCode
      enumValueLabel
      sortOrder
    }
  }
}
    `;
export const ContactAddressFieldsFragmentDoc = gql`
    fragment ContactAddressFields on ContactAddressObjectType {
  id
  addressType
  street
  street2
  street3
  city
  state {
    objectName
  }
  country {
    objectName
  }
  postalCode
  region
}
    `;
export const PastEmployerContactFieldsFragmentDoc = gql`
    fragment PastEmployerContactFields on ContactObjectType {
  id
  firstName
  lastName
  fullName
}
    `;
export const PastEmploymentFieldsFragmentDoc = gql`
    fragment PastEmploymentFields on PastEmploymentObjectType {
  id
  jobTitle
  employerName
  employer {
    ...PastEmployerContactFields
  }
}
    ${PastEmployerContactFieldsFragmentDoc}`;
export const PersonContactDetailsFragmentDoc = gql`
    fragment PersonContactDetails on ContactObjectType {
  id
  firstName
  lastName
  fullName
  title
  salutationName
  contactType
  companyName
  websiteUrl
  linkedinUrl
  staff {
    ...ContactFields
  }
  jobTitle
  primaryEmail {
    emailAddress
  }
  company {
    ...OrganizationContactFields
  }
  thumbnail {
    ...ContactThumbnailFields
  }
  extensionFields {
    ...ContactExtensionFields
  }
  addresses {
    ...ContactAddressFields
  }
  emails {
    id
    emailAddress
    emailType
  }
  phones {
    id
    phoneNumber
    phoneType
  }
  faxes {
    id
    phoneNumber
    phoneType
  }
  assignee {
    fullName
  }
  pastEmployments {
    ...PastEmploymentFields
  }
  acceptedEmailDomains
  referrer {
    id
    fullName
  }
  referrerName
  referred {
    id
    fullName
  }
  relations {
    id
    relatedContact {
      id
      fullName
    }
    contact {
      id
      fullName
    }
    label
    inverseLabel
  }
  notes
}
    ${ContactFieldsFragmentDoc}
${OrganizationContactFieldsFragmentDoc}
${ContactThumbnailFieldsFragmentDoc}
${ContactExtensionFieldsFragmentDoc}
${ContactAddressFieldsFragmentDoc}
${PastEmploymentFieldsFragmentDoc}`;
export const ContactTypeaheadFieldsFragmentDoc = gql`
    fragment ContactTypeaheadFields on ContactObjectType {
  id
  contactType
  firstName
  lastName
  fullName
  jobTitle
}
    `;
export const ContactEmailFieldsFragmentDoc = gql`
    fragment ContactEmailFields on ContactEmailAddressObjectType {
  id
  emailAddress
  emailType
}
    `;
export const DistributionBatchFieldsFragmentDoc = gql`
    fragment DistributionBatchFields on DistributionBatchObjectType {
  id
  dateRecallable
  effectiveDate
  description
  excludeFromYield
  periodEndDate
}
    `;
export const DistributionTypeFieldsFragmentDoc = gql`
    fragment DistributionTypeFields on DistributionTypeObjectType {
  id
  name
  isReturnOfCapital
  isWithholding
  sortOrder
  excludeFromYield
}
    `;
export const DistributionDetailFieldsFragmentDoc = gql`
    fragment DistributionDetailFields on DistributionDetailObjectType {
  id
  amountDistributed {
    monies
  }
  amountRecallable {
    monies
  }
  sortOrder
  transactionType {
    ...DistributionTypeFields
  }
}
    ${DistributionTypeFieldsFragmentDoc}`;
export const EmailFieldsFragmentDoc = gql`
    fragment EmailFields on EmailObjectType {
  id
  bodyHtml
  bodyText
  dateSent
  errorCount
  investmentName
  lastError
  emailType
  sendFailed
  senderName
  senderEmailAddress
  subject
}
    `;
export const DistributionFieldsFragmentDoc = gql`
    fragment DistributionFields on DistributionObjectType {
  id
  amountDistributed {
    monies
  }
  amountAdjustments {
    monies
  }
  batch {
    ...DistributionBatchFields
  }
  details {
    edges {
      node {
        ...DistributionDetailFields
      }
    }
  }
  email {
    ...EmailFields
  }
  uploadedAccountName
}
    ${DistributionBatchFieldsFragmentDoc}
${DistributionDetailFieldsFragmentDoc}
${EmailFieldsFragmentDoc}`;
export const DocumentVersionFieldsFragmentDoc = gql`
    fragment DocumentVersionFields on DocumentVersionObjectType {
  id
  name
  downloadUrl
  extension
  createdAt
}
    `;
export const DocumentCategoryFieldsFragmentDoc = gql`
    fragment DocumentCategoryFields on DocumentCategoryObjectType {
  id
  name
}
    `;
export const EmailDistributionListFieldsFragmentDoc = gql`
    fragment EmailDistributionListFields on EmailDistributionListObjectType {
  id
  name
}
    `;
export const EntityCollectionFieldsFragmentDoc = gql`
    fragment EntityCollectionFields on EntityCollectionObjectType {
  id
  name
}
    `;
export const EntitySubTypeFieldsFragmentDoc = gql`
    fragment EntitySubTypeFields on EntitySubTypeObjectType {
  id
  name
}
    `;
export const ExtensionFieldValueFragmentDoc = gql`
    fragment ExtensionFieldValue on ExtensionFieldValueObjectType {
  id
  intValue
  floatValue
  stringValue
  dateValue
  enumValue {
    id
    enumName
    enumValueCode
    enumValueLabel
  }
}
    `;
export const ComputedEntityFieldsFragmentDoc = gql`
    fragment ComputedEntityFields on AccountObjectType {
  isRoot
  positionCount
  committed {
    monies
  }
  contributed {
    monies
  }
  capitalOut {
    monies
  }
  type {
    id
    name
  }
}
    `;
export const EntityPerformanceMetricsFragmentDoc = gql`
    fragment EntityPerformanceMetrics on AccountObjectType {
  performanceMetrics {
    id
    effectiveDate
    irr
    dpi
    rvpi
    tvpi
    cocYield
  }
}
    `;
export const SubAndOwnedEntitiesFragmentDoc = gql`
    fragment SubAndOwnedEntities on AccountObjectType {
  subEntities {
    id
    name
  }
  ownedEntities {
    id
    name
    description
    published
    overviewAndFinancialsPublished
    overviewAndFinancialsVisible
  }
}
    `;
export const KbaChoiceFieldsFragmentDoc = gql`
    fragment KBAChoiceFields on KBAChoiceObjectType {
  choiceId
  choiceText
}
    `;
export const KbaQuestionFieldsFragmentDoc = gql`
    fragment KbaQuestionFields on KbaQuestionObjectType {
  id
  questionId
  questionText
  choices {
    ...KBAChoiceFields
  }
}
    ${KbaChoiceFieldsFragmentDoc}`;
export const KbaQuestionSetFieldsFragmentDoc = gql`
    fragment KbaQuestionSetFields on KbaQuestionSetObjectType {
  id
  questionSetId
  conversationId
  questions {
    ...KbaQuestionFields
  }
}
    ${KbaQuestionFieldsFragmentDoc}`;
export const SubmitKbaResponseFragmentDoc = gql`
    fragment SubmitKBAResponse on AcceptOrRejectKbaChoices {
  conversationId
  isPassed
  questionSetId
}
    `;
export const SubmitKbaResponseV2FragmentDoc = gql`
    fragment SubmitKBAResponseV2 on AcceptOrRejectKbaChoicesV2 {
  conversationId
  isPassed
  questionSetId
}
    `;
export const SubscriptionInvestorDiligencesObjectFieldsFragmentDoc = gql`
    fragment SubscriptionInvestorDiligencesObjectFields on SubscriptionObjectType {
  arenaName
  accountName
}
    `;
export const LexisNexisAccountInfoFieldsFragmentDoc = gql`
    fragment LexisNexisAccountInfoFields on LexisNexisAccountInfoObjectType {
  uuid
  companyName
  address
}
    `;
export const LexisNexisIndividualInfoFieldsFragmentDoc = gql`
    fragment LexisNexisIndividualInfoFields on LexisNexisIndividualInfoObjectType {
  uuid
  name
  address
  dateOfBirth
}
    `;
export const IndividualInvestorDataFragmentFragmentDoc = gql`
    fragment IndividualInvestorDataFragment on IndividualInvestorDataObjectType {
  emailAddress
  taxId
  employer
  jobTitle
  dateOfBirth
  phoneNumber
  name
  isUsPerson
  mailingAddress {
    ...AddressFields
  }
  domicileAddress {
    ...AddressFields
  }
}
    ${AddressFieldsFragmentDoc}`;
export const SignerFieldsFragmentFragmentDoc = gql`
    fragment SignerFieldsFragment on CounterpartyObjectType {
  name
  mailingAddress {
    ...AddressFields
  }
}
    ${AddressFieldsFragmentDoc}`;
export const CommonCompanyDataFragmentFragmentDoc = gql`
    fragment CommonCompanyDataFragment on CommonCompanyInvestorDataInterface {
  dateOfOrganization
  signatories {
    ...SignerFieldsFragment
  }
  beneficiaries {
    ...SignerFieldsFragment
  }
}
    ${SignerFieldsFragmentFragmentDoc}`;
export const PartnershipInvestorDataFragmentFragmentDoc = gql`
    fragment PartnershipInvestorDataFragment on LLCPartnershipInvestorDataObjectType {
  taxId
  organizationJurisdiction
  name
  isUsPerson
  mailingAddress {
    ...AddressFields
  }
  domicileAddress {
    ...AddressFields
  }
  ...CommonCompanyDataFragment
}
    ${AddressFieldsFragmentDoc}
${CommonCompanyDataFragmentFragmentDoc}`;
export const TrustInvestorDataFragmentFragmentDoc = gql`
    fragment TrustInvestorDataFragment on TrustInvestorDataObjectType {
  taxId
  name
  isUsPerson
  mailingAddress {
    ...AddressFields
  }
  domicileAddress {
    ...AddressFields
  }
  dateOfOrganization
  signatories {
    ...SignerFieldsFragment
  }
  beneficiaries {
    ...SignerFieldsFragment
  }
}
    ${AddressFieldsFragmentDoc}
${SignerFieldsFragmentFragmentDoc}`;
export const KycDocumentVersionActivityObjectFieldsFragmentDoc = gql`
    fragment KycDocumentVersionActivityObjectFields on KycDocumentVersionActivityObjectType {
  comment
  id
  createdAt
  activityType
  owner {
    fullName
    id
  }
}
    `;
export const KycDocumentVersionFragmentDoc = gql`
    fragment KycDocumentVersion on KycDocumentVersionObjectType {
  id
  kycDocumentId
  documentVersion {
    id
    name
  }
}
    `;
export const KycDocumentFieldsFragmentDoc = gql`
    fragment KycDocumentFields on KycDocumentObjectType {
  id
  status
  externalReferenceKey
  subscriptionNonSignedLpUploadedDocumentId
  investorDiligenceId
  arenaId
  label
  documentType
  documentInfo {
    ...IndividualInvestorDataFragment
    ...PartnershipInvestorDataFragment
    ...TrustInvestorDataFragment
    __typename
  }
  currentKycDocumentVersion {
    currentRequestKycDocumentVersionActivity {
      ...KycDocumentVersionActivityObjectFields
    }
    ...KycDocumentVersion
  }
}
    ${IndividualInvestorDataFragmentFragmentDoc}
${PartnershipInvestorDataFragmentFragmentDoc}
${TrustInvestorDataFragmentFragmentDoc}
${KycDocumentVersionActivityObjectFieldsFragmentDoc}
${KycDocumentVersionFragmentDoc}`;
export const KeyIndividualFieldsFragmentDoc = gql`
    fragment KeyIndividualFields on KeyIndividualObjectType {
  name
  emailAddress
  uuid
  isCurrentUser
  hasSentInvite
  identityDocumentName
  identityDocumentVersionId
  identityDocumentVersionCreatedAt
  requestedRedo {
    id
    isComplete
    reason
  }
  kbaStatus
  alertId
  __typename
}
    `;
export const PaymentBankFieldsFragmentDoc = gql`
    fragment PaymentBankFields on PaymentBankObjectType {
  name
  isFincenSpecialMeasure
  address {
    ...AddressFields
  }
}
    ${AddressFieldsFragmentDoc}`;
export const KeyInstitutionFieldsFragmentDoc = gql`
    fragment KeyInstitutionFields on KeyInstitutionObjectType {
  uuid
  name
  alertId
}
    `;
export const InvestorDiligenceObjectFieldsFragmentDoc = gql`
    fragment InvestorDiligenceObjectFields on InvestorDiligenceObjectType {
  id
  investorDiligenceType
  status
  arenaId
  dateSubmitted
  keyIndividuals {
    ...KeyIndividualFields
  }
  paymentBanks {
    ...PaymentBankFields
  }
  keyInstitutions {
    ...KeyInstitutionFields
  }
}
    ${KeyIndividualFieldsFragmentDoc}
${PaymentBankFieldsFragmentDoc}
${KeyInstitutionFieldsFragmentDoc}`;
export const AccountObjectFieldsFragmentDoc = gql`
    fragment AccountObjectFields on AccountObjectType {
  name
}
    `;
export const SubscriptionInvestorDiligenceObjectFieldsFragmentDoc = gql`
    fragment SubscriptionInvestorDiligenceObjectFields on SubscriptionObjectType {
  accountName
}
    `;
export const InvestorDiligenceObjectTypeFieldsFragmentDoc = gql`
    fragment InvestorDiligenceObjectTypeFields on InvestorDiligenceObjectType {
  lexisNexisInfo {
    accountInfo {
      ...LexisNexisAccountInfoFields
    }
    individualInfo {
      ...LexisNexisIndividualInfoFields
    }
  }
  kycDetails {
    edges {
      node {
        id
        externalReferenceKey
        kbaStatus
      }
    }
  }
  kycDocuments {
    edges {
      node {
        ...KycDocumentFields
      }
    }
  }
  investorDiligenceSteps {
    entity
    individuals
    supplemental
    kba
  }
  ...InvestorDiligenceObjectFields
  investorData {
    ...AccountObjectFields
    ...IndividualInvestorDataFragment
    ...PartnershipInvestorDataFragment
    ...TrustInvestorDataFragment
    __typename
  }
  investorDiligenceObject {
    __typename
    ...SubscriptionInvestorDiligenceObjectFields
    ...AccountObjectFields
  }
}
    ${LexisNexisAccountInfoFieldsFragmentDoc}
${LexisNexisIndividualInfoFieldsFragmentDoc}
${KycDocumentFieldsFragmentDoc}
${InvestorDiligenceObjectFieldsFragmentDoc}
${AccountObjectFieldsFragmentDoc}
${IndividualInvestorDataFragmentFragmentDoc}
${PartnershipInvestorDataFragmentFragmentDoc}
${TrustInvestorDataFragmentFragmentDoc}
${SubscriptionInvestorDiligenceObjectFieldsFragmentDoc}`;
export const KycDocumentWithActivitiesFragmentDoc = gql`
    fragment KycDocumentWithActivities on KycDocumentObjectType {
  ...KycDocumentFields
  kycDocumentActivities {
    edges {
      node {
        ...KycDocumentVersionActivityObjectFields
      }
    }
  }
}
    ${KycDocumentFieldsFragmentDoc}
${KycDocumentVersionActivityObjectFieldsFragmentDoc}`;
export const SubscriptionObjectProspectFieldsFragmentDoc = gql`
    fragment SubscriptionObjectProspectFields on SubscriptionObjectType {
  prospect {
    id
    title
    offeringName
  }
}
    `;
export const SubscriptionRecurringAccountObjectFieldsFragmentDoc = gql`
    fragment SubscriptionRecurringAccountObjectFields on AccountObjectType {
  name
  id
  arenaId
  arena {
    name
    activeOfferings {
      edges {
        node {
          name
        }
      }
    }
  }
}
    `;
export const ManagementFeeBatchFieldsFragmentDoc = gql`
    fragment ManagementFeeBatchFields on ManagementFeeBatchObjectType {
  id
  dateDue
  description
  remittanceInstructions
}
    `;
export const ManagementFeeTypeGroupFieldsFragmentDoc = gql`
    fragment ManagementFeeTypeGroupFields on ManagementFeeTypeGroupObjectType {
  id
  name
  sortOrder
}
    `;
export const ManagementFeeTypeFieldsFragmentDoc = gql`
    fragment ManagementFeeTypeFields on ManagementFeeTypeObjectType {
  id
  name
  sortOrder
  group {
    ...ManagementFeeTypeGroupFields
  }
}
    ${ManagementFeeTypeGroupFieldsFragmentDoc}`;
export const ManagementFeeDetailFieldsFragmentDoc = gql`
    fragment ManagementFeeDetailFields on ManagementFeeDetailObjectType {
  id
  amount {
    monies
  }
  sortOrder
  transactionType {
    ...ManagementFeeTypeFields
  }
}
    ${ManagementFeeTypeFieldsFragmentDoc}`;
export const ManagementFeeFieldsFragmentDoc = gql`
    fragment ManagementFeeFields on ManagementFeeObjectType {
  id
  batch {
    ...ManagementFeeBatchFields
  }
  notes
  hasDefaulted
  uploadedAccountName
  details {
    edges {
      node {
        ...ManagementFeeDetailFields
      }
    }
  }
  email {
    ...EmailFields
  }
}
    ${ManagementFeeBatchFieldsFragmentDoc}
${ManagementFeeDetailFieldsFragmentDoc}
${EmailFieldsFragmentDoc}`;
export const OfferingFieldsFragmentDoc = gql`
    fragment OfferingFields on OfferingObjectType {
  id
  name
}
    `;
export const OfferingFieldsExtendedFragmentDoc = gql`
    fragment OfferingFieldsExtended on OfferingObjectType {
  id
  name
  currency {
    code
    fullName
    id
    symbol
  }
}
    `;
export const OperatingCompanyDetailsFieldsFragmentDoc = gql`
    fragment OperatingCompanyDetailsFields on OperatingCompanyDetailsObjectType {
  id
  companyDescription
  primaryMarket
  naicsSector
  naicsIndustryGroup
  hqCountry {
    id
    name
  }
  hqState {
    id
    name
  }
  fiscalYearEnd
  boardSeats
  website
  basicInformationNotes
  sector
  industry
}
    `;
export const ProfitLossEntryFieldsFragmentDoc = gql`
    fragment ProfitLossEntryFields on ProfitLossEntryObjectType {
  sourceLabel
  categoryLabel
  categoryKey
  wallet {
    monies
  }
}
    `;
export const ProfitLossPeriodFragmentDoc = gql`
    fragment ProfitLossPeriod on ProfitLossPeriodObjectType {
  year
  period
  comment
  entries {
    ...ProfitLossEntryFields
  }
}
    ${ProfitLossEntryFieldsFragmentDoc}`;
export const EntityProfitLossPeriodsFragmentDoc = gql`
    fragment EntityProfitLossPeriods on AccountObjectType {
  profitLossPeriods(plCategories: $plCategories) {
    ...ProfitLossPeriod
  }
}
    ${ProfitLossPeriodFragmentDoc}`;
export const SubscriptionCcLogDumpFieldsFragmentDoc = gql`
    fragment SubscriptionCCLogDumpFields on SubscriptionObjectType {
  id
  status
  ccLogDump {
    accountContactsInfo
    accountInfo
    additionalContactsInfo
    counterparties
    docusignData
    paymentInfo
  }
}
    `;
export const InvestorDiligenceFieldsFragmentDoc = gql`
    fragment InvestorDiligenceFields on InvestorDiligenceObjectType {
  objectType
  investorDiligenceType
  status
  id
}
    `;
export const GpSignedDocumentFieldsFragmentDoc = gql`
    fragment GpSignedDocumentFields on GpSignedDocumentObjectType {
  label
  subscriptionDocumentId
  isTaxForm
  lpDocumentVersionId
  lpDocumentUploadedDate
}
    `;
export const LpNonSignedDocumentFieldsFragmentDoc = gql`
    fragment LpNonSignedDocumentFields on LpNonSignedDocumentObjectType {
  documentType
  label
  contactUuid
  lpDocumentName
  lpDocumentVersionId
  lpDocumentUploadedDate
  isRemovable
  requestedRedo {
    id
    isComplete
    reason
  }
}
    `;
export const TaxFormOptionFieldsFragmentDoc = gql`
    fragment TaxFormOptionFields on TaxFormFieldOptionObjectType {
  label
  value
  staticDirFilepath
}
    `;
export const InvestorSignatureRecipientFieldsFragmentDoc = gql`
    fragment InvestorSignatureRecipientFields on InvestorSignatureRecipientObjectType {
  uuid
  email
  name
}
    `;
export const EnvelopePollFieldsFragmentDoc = gql`
    fragment EnvelopePollFields on EnvelopePollObjectType {
  errorMessage
  complete
}
    `;
export const DocusignDataFieldsFragmentDoc = gql`
    fragment DocusignDataFields on DocusignDataObjectType {
  status
  designatedSigner
  uiMessage
  docusignErrorCode
}
    `;
export const SubscriptionObjectFieldsFragmentDoc = gql`
    fragment SubscriptionObjectFields on SubscriptionObjectType {
  id
  isDocusignStarted
  arenaName
  arenaSupportEmail
  arenaSupportPhone
  allowPrintSignature
  canInitiateElectronicSignatures
  alert
  lpHasUploadedAllDocs
  taxFormType
  expectsTaxDocument
  expectsFormationDocument
  chosenDesignatedSigner
  allowDocusignSubmission
  incompleteMessage
  status
  subscriptionCompletionPrintMessage
  subscriptionCompletionMessage
  isInvestorDiligenceEnabled
  accountType
  hasMultipleDesignatedSignerOptions
  envelopePoll {
    ...EnvelopePollFields
  }
  docusignData {
    ...DocusignDataFields
  }
  arena {
    contactEmail
    contactPhone
  }
}
    ${EnvelopePollFieldsFragmentDoc}
${DocusignDataFieldsFragmentDoc}`;
export const KycInviteObjectFieldsFragmentDoc = gql`
    fragment KycInviteObjectFields on KycInviteObjectType {
  id
  arenaName
  keyIndividual {
    ...KeyIndividualFields
  }
  subscription {
    status
    accountName
    kycDetail {
      kbaStatus
    }
    subscriberInfo {
      name
      email
    }
    offeringName
  }
}
    ${KeyIndividualFieldsFragmentDoc}`;
export const TagFieldsFragmentDoc = gql`
    fragment TagFields on TagObjectType {
  id
  tagText
}
    `;
export const TagsFragmentDoc = gql`
    fragment Tags on TaggableObjectType {
  tags {
    edges {
      tag: node {
        ...TagFields
      }
    }
  }
}
    ${TagFieldsFragmentDoc}`;
export const AssetTimeSeriesFragmentDoc = gql`
    fragment AssetTimeSeries on AssetObjectType {
  timeSeries(timeSeriesTypeNames: $assetTimeSeriesTypeNames) {
    asOfDate
    values {
      ...TimeSeriesFields
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;
export const AssetLatestTimeSeriesFragmentDoc = gql`
    fragment AssetLatestTimeSeries on AssetObjectType {
  latestTimeSeries(timeSeriesTypeNames: $assetTimeSeriesTypeNames) {
    asOfDate
    values {
      ...TimeSeriesFields
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;
export const AssetTimeSeriesProjectionsFragmentDoc = gql`
    fragment AssetTimeSeriesProjections on AssetObjectType {
  timeSeriesProjections(timeSeriesTypeNames: $assetTimeSeriesTypeNames) {
    asOfDate
    values {
      ...TimeSeriesFields
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;
export const AssetLatestTimeSeriesProjectionsFragmentDoc = gql`
    fragment AssetLatestTimeSeriesProjections on AssetObjectType {
  latestTimeSeriesProjections(timeSeriesTypeNames: $assetTimeSeriesTypeNames) {
    asOfDate
    values {
      ...TimeSeriesFields
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;
export const EntityTimeSeriesFragmentDoc = gql`
    fragment EntityTimeSeries on AccountObjectType {
  timeSeries(timeSeriesTypeNames: $entityTimeSeriesTypeNames) {
    asOfDate
    values {
      ...TimeSeriesFields
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;
export const EntityLatestTimeSeriesFragmentDoc = gql`
    fragment EntityLatestTimeSeries on AccountObjectType {
  latestTimeSeries(timeSeriesTypeNames: $entityTimeSeriesTypeNames) {
    asOfDate
    values {
      ...TimeSeriesFields
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;
export const EntityTimeSeriesProjectionsFragmentDoc = gql`
    fragment EntityTimeSeriesProjections on AccountObjectType {
  timeSeriesProjections(timeSeriesTypeNames: $entityTimeSeriesTypeNames) {
    asOfDate
    values {
      ...TimeSeriesFields
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;
export const EntityLatestTimeSeriesProjectionsFragmentDoc = gql`
    fragment EntityLatestTimeSeriesProjections on AccountObjectType {
  latestTimeSeriesProjections(timeSeriesTypeNames: $entityTimeSeriesTypeNames) {
    asOfDate
    values {
      ...TimeSeriesFields
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;
export const TransactionInstanceBatchFieldsFragmentDoc = gql`
    fragment TransactionInstanceBatchFields on TransactionInstanceBatchObjectType {
  ... on CapitalCallBatchObjectType {
    id
    noun
    viewRoute
    description
  }
  ... on DistributionBatchObjectType {
    id
    noun
    viewRoute
    description
  }
  ... on ManagementFeeBatchObjectType {
    id
    noun
    viewRoute
    description
  }
  ... on NavBatchObjectType {
    id
    noun
    viewRoute
    description
  }
  ... on NetIncomeBatchObjectType {
    id
    noun
    viewRoute
    description
  }
  ... on TransactionBatchObjectType {
    id
    noun
    viewRoute
    description
  }
  ... on UnitValueBatchObjectType {
    id
    noun
    viewRoute
    description
  }
}
    `;
export const TransactionBatchFieldsFragmentDoc = gql`
    fragment TransactionBatchFields on TransactionBatchObjectType {
  id
  effectiveDate
  description
}
    `;
export const EntityFieldsFragmentDoc = gql`
    fragment EntityFields on AccountObjectType {
  id
  name
  status
  isPartial
}
    `;
export const TransactionTypeFieldsFragmentDoc = gql`
    fragment TransactionTypeFields on TransactionTypeObjectType {
  id
  name
  isPositive
  isNegative
  sortOrder
  isSubType
  affectsOwnership
  affectsCommitment
  excludeFromMetrics
}
    `;
export const AllTransactionBatchFieldsFragmentDoc = gql`
    fragment AllTransactionBatchFields on TransactionBatchObjectType {
  ...TransactionBatchFields
  instances {
    edges {
      node {
        id
        allAmounts {
          monies
        }
        amountReceived {
          monies
        }
        paymentDate
        paymentMethod
        pricePerUnit {
          monies
        }
        description
        notes
      }
    }
  }
  rowDescription
  entity {
    ...EntityFields
  }
  transactionType {
    ...TransactionTypeFields
  }
}
    ${TransactionBatchFieldsFragmentDoc}
${EntityFieldsFragmentDoc}
${TransactionTypeFieldsFragmentDoc}`;
export const TransactionDetailFieldsFragmentDoc = gql`
    fragment TransactionDetailFields on TransactionDetailObjectType {
  id
  amount {
    monies
  }
  sortOrder
  transactionType {
    ...TransactionTypeFields
  }
}
    ${TransactionTypeFieldsFragmentDoc}`;
export const TransactionFieldsFragmentDoc = gql`
    fragment TransactionFields on TransactionObjectType {
  id
  allAmounts {
    monies
  }
  amountReceived {
    monies
  }
  paymentDate
  paymentMethod
  pricePerUnit {
    monies
  }
  description
  notes
  batch {
    ...AllTransactionBatchFields
  }
  details {
    edges {
      node {
        ...TransactionDetailFields
      }
    }
  }
}
    ${AllTransactionBatchFieldsFragmentDoc}
${TransactionDetailFieldsFragmentDoc}`;
export const TransactionDescriptionFieldsFragmentDoc = gql`
    fragment TransactionDescriptionFields on TransactionDescriptionResponse {
  __typename
  ... on TransactionDescriptionNotFoundResponse {
    id
    errorCode
    message
  }
  ... on TransactionDescriptionObjectType {
    id
    description
  }
}
    `;
export const GpLiteTwrPeriodMetricFragmentDoc = gql`
    fragment GpLiteTwrPeriodMetric on TwrPeriodMetricDetailsObjectType {
  ... on TwrPeriodMetricStaffObjectType {
    metric {
      id
      grossIncome
      grossAppreciation
      netIncome
      netAppreciation
      grossIncomeOverride
      grossAppreciationOverride
      netIncomeOverride
      netAppreciationOverride
      weightedAverageEquity {
        monies
      }
      weightedAverageEquityOverride {
        monies
      }
    }
  }
}
    `;
export const PortalTwrPeriodMetricsFragmentDoc = gql`
    fragment PortalTwrPeriodMetrics on TwrPeriodMetricPortalObjectType {
  grossIncome
  isGrossIncomeOverridden
  grossAppreciation
  isGrossAppreciationOverridden
  totalGross
  netIncome
  isNetIncomeOverridden
  netAppreciation
  isNetAppreciationOverridden
  totalNet
  totalGrossNet
  unclassifiedIncome
  period
}
    `;
export const PortalTwrPeriodHeaderAndMetricsFragmentDoc = gql`
    fragment PortalTwrPeriodHeaderAndMetrics on TwrPeriodMetricsTableObjectType {
  id
  headers
  metrics {
    ...PortalTwrPeriodMetrics
  }
}
    ${PortalTwrPeriodMetricsFragmentDoc}`;
export const PortalTwrSummaryHeaderAndMetricsFragmentDoc = gql`
    fragment PortalTwrSummaryHeaderAndMetrics on TwrSummaryMetricsObjectType {
  id
  header {
    periodColumnName
    metricsColumnNames
  }
  rows {
    period
    metrics
  }
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on UserObjectType {
  id
  fullName
  firstName
  lastName
  emailAddress
  lastLogin
  newsletterSubscribed
  newsletterSubscriptionType
  isActive
  hasLinkedGlobalUser
  twoFaEnabled
  twoFaPhoneNumber
  currentTwoFaMethods
  globalUserId
}
    `;
export const RoleFieldsFragmentDoc = gql`
    fragment RoleFields on RoleObjectType {
  id
  name
}
    `;
export const GroupFieldsFragmentDoc = gql`
    fragment GroupFields on GroupObjectType {
  id
  title
  roles {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;
export const AddCommentDocument = gql`
    mutation AddComment($investorDiligenceId: ID!, $comment: String!, $commentType: InvestorDiligenceCommentTypesEnum) {
  investorDiligenceOps {
    addComment(
      investorDiligenceId: $investorDiligenceId
      comment: $comment
      commentType: $commentType
    ) {
      investorDiligenceComment {
        comment
        id
        createdAt
        owner {
          id
          fullName
        }
      }
    }
  }
}
    `;
export type AddCommentMutationFn = Apollo.MutationFunction<GraphqlTypes.AddCommentMutation, GraphqlTypes.AddCommentMutationVariables>;

/**
 * __useAddCommentMutation__
 *
 * To run a mutation, you first call `useAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentMutation, { data, loading, error }] = useAddCommentMutation({
 *   variables: {
 *      investorDiligenceId: // value for 'investorDiligenceId'
 *      comment: // value for 'comment'
 *      commentType: // value for 'commentType'
 *   },
 * });
 */
export function useAddCommentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddCommentMutation, GraphqlTypes.AddCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddCommentMutation, GraphqlTypes.AddCommentMutationVariables>(AddCommentDocument, options);
      }
export type AddCommentMutationHookResult = ReturnType<typeof useAddCommentMutation>;
export type AddCommentMutationResult = Apollo.MutationResult<GraphqlTypes.AddCommentMutation>;
export type AddCommentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddCommentMutation, GraphqlTypes.AddCommentMutationVariables>;
export const GetWatchlistRiskScoreDocument = gql`
    query GetWatchlistRiskScore($id: ID!) {
  prospect(id: $id) {
    offeringName
    id
    subscription {
      status
      id
      investorDiligenceWatchlist {
        id
        arenaId
        isHighRiskAcknowledged
        isAcknowledgementAllowed
        investorDiligenceComments(sort: CREATED_AT_DESC) {
          edges {
            node {
              id
              comment
              createdAt
              owner {
                id
                fullName
              }
            }
          }
        }
        riskScore {
          score
          status
          asOfDate
        }
      }
    }
  }
}
    `;

/**
 * __useGetWatchlistRiskScoreQuery__
 *
 * To run a query within a React component, call `useGetWatchlistRiskScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWatchlistRiskScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWatchlistRiskScoreQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWatchlistRiskScoreQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetWatchlistRiskScoreQuery, GraphqlTypes.GetWatchlistRiskScoreQueryVariables> & ({ variables: GraphqlTypes.GetWatchlistRiskScoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetWatchlistRiskScoreQuery, GraphqlTypes.GetWatchlistRiskScoreQueryVariables>(GetWatchlistRiskScoreDocument, options);
      }
export function useGetWatchlistRiskScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetWatchlistRiskScoreQuery, GraphqlTypes.GetWatchlistRiskScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetWatchlistRiskScoreQuery, GraphqlTypes.GetWatchlistRiskScoreQueryVariables>(GetWatchlistRiskScoreDocument, options);
        }
// @ts-ignore
export function useGetWatchlistRiskScoreSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWatchlistRiskScoreQuery, GraphqlTypes.GetWatchlistRiskScoreQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetWatchlistRiskScoreQuery, GraphqlTypes.GetWatchlistRiskScoreQueryVariables>;
export function useGetWatchlistRiskScoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWatchlistRiskScoreQuery, GraphqlTypes.GetWatchlistRiskScoreQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetWatchlistRiskScoreQuery | undefined, GraphqlTypes.GetWatchlistRiskScoreQueryVariables>;
export function useGetWatchlistRiskScoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWatchlistRiskScoreQuery, GraphqlTypes.GetWatchlistRiskScoreQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetWatchlistRiskScoreQuery, GraphqlTypes.GetWatchlistRiskScoreQueryVariables>(GetWatchlistRiskScoreDocument, options);
        }
export type GetWatchlistRiskScoreQueryHookResult = ReturnType<typeof useGetWatchlistRiskScoreQuery>;
export type GetWatchlistRiskScoreLazyQueryHookResult = ReturnType<typeof useGetWatchlistRiskScoreLazyQuery>;
export type GetWatchlistRiskScoreSuspenseQueryHookResult = ReturnType<typeof useGetWatchlistRiskScoreSuspenseQuery>;
export type GetWatchlistRiskScoreQueryResult = Apollo.QueryResult<GraphqlTypes.GetWatchlistRiskScoreQuery, GraphqlTypes.GetWatchlistRiskScoreQueryVariables>;
export const GetWatchlistRiskScoreFromAccountDocument = gql`
    query GetWatchlistRiskScoreFromAccount($id: ID!) {
  account(id: $id) {
    id
    name
    investorDiligenceWatchlist {
      id
      arenaId
      isHighRiskAcknowledged
      isAcknowledgementAllowed
      investorDiligenceComments(sort: CREATED_AT_DESC) {
        edges {
          node {
            id
            comment
            createdAt
            owner {
              id
              fullName
            }
          }
        }
      }
      riskScore {
        score
        status
        asOfDate
      }
    }
  }
}
    `;

/**
 * __useGetWatchlistRiskScoreFromAccountQuery__
 *
 * To run a query within a React component, call `useGetWatchlistRiskScoreFromAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWatchlistRiskScoreFromAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWatchlistRiskScoreFromAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWatchlistRiskScoreFromAccountQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetWatchlistRiskScoreFromAccountQuery, GraphqlTypes.GetWatchlistRiskScoreFromAccountQueryVariables> & ({ variables: GraphqlTypes.GetWatchlistRiskScoreFromAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetWatchlistRiskScoreFromAccountQuery, GraphqlTypes.GetWatchlistRiskScoreFromAccountQueryVariables>(GetWatchlistRiskScoreFromAccountDocument, options);
      }
export function useGetWatchlistRiskScoreFromAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetWatchlistRiskScoreFromAccountQuery, GraphqlTypes.GetWatchlistRiskScoreFromAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetWatchlistRiskScoreFromAccountQuery, GraphqlTypes.GetWatchlistRiskScoreFromAccountQueryVariables>(GetWatchlistRiskScoreFromAccountDocument, options);
        }
// @ts-ignore
export function useGetWatchlistRiskScoreFromAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWatchlistRiskScoreFromAccountQuery, GraphqlTypes.GetWatchlistRiskScoreFromAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetWatchlistRiskScoreFromAccountQuery, GraphqlTypes.GetWatchlistRiskScoreFromAccountQueryVariables>;
export function useGetWatchlistRiskScoreFromAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWatchlistRiskScoreFromAccountQuery, GraphqlTypes.GetWatchlistRiskScoreFromAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetWatchlistRiskScoreFromAccountQuery | undefined, GraphqlTypes.GetWatchlistRiskScoreFromAccountQueryVariables>;
export function useGetWatchlistRiskScoreFromAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWatchlistRiskScoreFromAccountQuery, GraphqlTypes.GetWatchlistRiskScoreFromAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetWatchlistRiskScoreFromAccountQuery, GraphqlTypes.GetWatchlistRiskScoreFromAccountQueryVariables>(GetWatchlistRiskScoreFromAccountDocument, options);
        }
export type GetWatchlistRiskScoreFromAccountQueryHookResult = ReturnType<typeof useGetWatchlistRiskScoreFromAccountQuery>;
export type GetWatchlistRiskScoreFromAccountLazyQueryHookResult = ReturnType<typeof useGetWatchlistRiskScoreFromAccountLazyQuery>;
export type GetWatchlistRiskScoreFromAccountSuspenseQueryHookResult = ReturnType<typeof useGetWatchlistRiskScoreFromAccountSuspenseQuery>;
export type GetWatchlistRiskScoreFromAccountQueryResult = Apollo.QueryResult<GraphqlTypes.GetWatchlistRiskScoreFromAccountQuery, GraphqlTypes.GetWatchlistRiskScoreFromAccountQueryVariables>;
export const LoginDocument = gql`
    mutation Login($loginInput: LoginInput!) {
  login(objectInput: $loginInput) {
    ... on LoginObject {
      user {
        id
      }
      csrfToken
    }
    ... on LoginStaffEmailUpgradeRequiredResponse {
      message
      redirectLocation
    }
    ... on LoginVerificationRequiredResponse {
      message
      twoFaType
      twoFaSmsLastFourDigits
      hasMultipleManagers
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<GraphqlTypes.LoginMutation, GraphqlTypes.LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      loginInput: // value for 'loginInput'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.LoginMutation, GraphqlTypes.LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.LoginMutation, GraphqlTypes.LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<GraphqlTypes.LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.LoginMutation, GraphqlTypes.LoginMutationVariables>;
export const ResetPasswordRequestDocument = gql`
    mutation ResetPasswordRequest($resetPasswordRequestInput: ResetPasswordRequestInput!) {
  resetPasswordRequest(objectInput: $resetPasswordRequestInput) {
    result {
      ... on ResetPasswordRequestResponse {
        message
      }
      ... on MutationErrorResponse {
        errorCode
        message
      }
    }
  }
}
    `;
export type ResetPasswordRequestMutationFn = Apollo.MutationFunction<GraphqlTypes.ResetPasswordRequestMutation, GraphqlTypes.ResetPasswordRequestMutationVariables>;

/**
 * __useResetPasswordRequestMutation__
 *
 * To run a mutation, you first call `useResetPasswordRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordRequestMutation, { data, loading, error }] = useResetPasswordRequestMutation({
 *   variables: {
 *      resetPasswordRequestInput: // value for 'resetPasswordRequestInput'
 *   },
 * });
 */
export function useResetPasswordRequestMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ResetPasswordRequestMutation, GraphqlTypes.ResetPasswordRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ResetPasswordRequestMutation, GraphqlTypes.ResetPasswordRequestMutationVariables>(ResetPasswordRequestDocument, options);
      }
export type ResetPasswordRequestMutationHookResult = ReturnType<typeof useResetPasswordRequestMutation>;
export type ResetPasswordRequestMutationResult = Apollo.MutationResult<GraphqlTypes.ResetPasswordRequestMutation>;
export type ResetPasswordRequestMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ResetPasswordRequestMutation, GraphqlTypes.ResetPasswordRequestMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    csrfToken
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<GraphqlTypes.LogoutMutation, GraphqlTypes.LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.LogoutMutation, GraphqlTypes.LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.LogoutMutation, GraphqlTypes.LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<GraphqlTypes.LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.LogoutMutation, GraphqlTypes.LogoutMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($resetPasswordInput: ResetPasswordInput!) {
  resetPassword(objectInput: $resetPasswordInput) {
    result {
      ... on ResetPasswordResponse {
        message
      }
      ... on MutationErrorResponse {
        errorCode
        message
      }
    }
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<GraphqlTypes.ResetPasswordMutation, GraphqlTypes.ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      resetPasswordInput: // value for 'resetPasswordInput'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ResetPasswordMutation, GraphqlTypes.ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ResetPasswordMutation, GraphqlTypes.ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<GraphqlTypes.ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ResetPasswordMutation, GraphqlTypes.ResetPasswordMutationVariables>;
export const GetFinalizedESignatureDocument = gql`
    query GetFinalizedESignature($id: ID!) {
  eSignatureRequestTemplate(id: $id) {
    id
    eSignatureRequests {
      count
    }
  }
}
    `;

/**
 * __useGetFinalizedESignatureQuery__
 *
 * To run a query within a React component, call `useGetFinalizedESignatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinalizedESignatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinalizedESignatureQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFinalizedESignatureQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFinalizedESignatureQuery, GraphqlTypes.GetFinalizedESignatureQueryVariables> & ({ variables: GraphqlTypes.GetFinalizedESignatureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFinalizedESignatureQuery, GraphqlTypes.GetFinalizedESignatureQueryVariables>(GetFinalizedESignatureDocument, options);
      }
export function useGetFinalizedESignatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFinalizedESignatureQuery, GraphqlTypes.GetFinalizedESignatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFinalizedESignatureQuery, GraphqlTypes.GetFinalizedESignatureQueryVariables>(GetFinalizedESignatureDocument, options);
        }
// @ts-ignore
export function useGetFinalizedESignatureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFinalizedESignatureQuery, GraphqlTypes.GetFinalizedESignatureQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFinalizedESignatureQuery, GraphqlTypes.GetFinalizedESignatureQueryVariables>;
export function useGetFinalizedESignatureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFinalizedESignatureQuery, GraphqlTypes.GetFinalizedESignatureQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFinalizedESignatureQuery | undefined, GraphqlTypes.GetFinalizedESignatureQueryVariables>;
export function useGetFinalizedESignatureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFinalizedESignatureQuery, GraphqlTypes.GetFinalizedESignatureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFinalizedESignatureQuery, GraphqlTypes.GetFinalizedESignatureQueryVariables>(GetFinalizedESignatureDocument, options);
        }
export type GetFinalizedESignatureQueryHookResult = ReturnType<typeof useGetFinalizedESignatureQuery>;
export type GetFinalizedESignatureLazyQueryHookResult = ReturnType<typeof useGetFinalizedESignatureLazyQuery>;
export type GetFinalizedESignatureSuspenseQueryHookResult = ReturnType<typeof useGetFinalizedESignatureSuspenseQuery>;
export type GetFinalizedESignatureQueryResult = Apollo.QueryResult<GraphqlTypes.GetFinalizedESignatureQuery, GraphqlTypes.GetFinalizedESignatureQueryVariables>;
export const SaveInitialSetupDocument = gql`
    mutation SaveInitialSetup($template: InitialSetupInputObjectType!) {
  eSignatureOps {
    submitInitialSetup(objectInput: $template) {
      eSignatureRequestTemplate {
        id
        title
        objectId
        objectType
        status
        documentCategoryId
        documentCollectionId
      }
    }
  }
}
    `;
export type SaveInitialSetupMutationFn = Apollo.MutationFunction<GraphqlTypes.SaveInitialSetupMutation, GraphqlTypes.SaveInitialSetupMutationVariables>;

/**
 * __useSaveInitialSetupMutation__
 *
 * To run a mutation, you first call `useSaveInitialSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInitialSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInitialSetupMutation, { data, loading, error }] = useSaveInitialSetupMutation({
 *   variables: {
 *      template: // value for 'template'
 *   },
 * });
 */
export function useSaveInitialSetupMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SaveInitialSetupMutation, GraphqlTypes.SaveInitialSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SaveInitialSetupMutation, GraphqlTypes.SaveInitialSetupMutationVariables>(SaveInitialSetupDocument, options);
      }
export type SaveInitialSetupMutationHookResult = ReturnType<typeof useSaveInitialSetupMutation>;
export type SaveInitialSetupMutationResult = Apollo.MutationResult<GraphqlTypes.SaveInitialSetupMutation>;
export type SaveInitialSetupMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SaveInitialSetupMutation, GraphqlTypes.SaveInitialSetupMutationVariables>;
export const GetDocumentCategoriesForESignatureSetupDocument = gql`
    query GetDocumentCategoriesForESignatureSetup($filters: DocumentCategoriesFilters) {
  documentCategories(filters: $filters) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetDocumentCategoriesForESignatureSetupQuery__
 *
 * To run a query within a React component, call `useGetDocumentCategoriesForESignatureSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentCategoriesForESignatureSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentCategoriesForESignatureSetupQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDocumentCategoriesForESignatureSetupQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentCategoriesForESignatureSetupQuery, GraphqlTypes.GetDocumentCategoriesForESignatureSetupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentCategoriesForESignatureSetupQuery, GraphqlTypes.GetDocumentCategoriesForESignatureSetupQueryVariables>(GetDocumentCategoriesForESignatureSetupDocument, options);
      }
export function useGetDocumentCategoriesForESignatureSetupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForESignatureSetupQuery, GraphqlTypes.GetDocumentCategoriesForESignatureSetupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentCategoriesForESignatureSetupQuery, GraphqlTypes.GetDocumentCategoriesForESignatureSetupQueryVariables>(GetDocumentCategoriesForESignatureSetupDocument, options);
        }
// @ts-ignore
export function useGetDocumentCategoriesForESignatureSetupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForESignatureSetupQuery, GraphqlTypes.GetDocumentCategoriesForESignatureSetupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentCategoriesForESignatureSetupQuery, GraphqlTypes.GetDocumentCategoriesForESignatureSetupQueryVariables>;
export function useGetDocumentCategoriesForESignatureSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForESignatureSetupQuery, GraphqlTypes.GetDocumentCategoriesForESignatureSetupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentCategoriesForESignatureSetupQuery | undefined, GraphqlTypes.GetDocumentCategoriesForESignatureSetupQueryVariables>;
export function useGetDocumentCategoriesForESignatureSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForESignatureSetupQuery, GraphqlTypes.GetDocumentCategoriesForESignatureSetupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentCategoriesForESignatureSetupQuery, GraphqlTypes.GetDocumentCategoriesForESignatureSetupQueryVariables>(GetDocumentCategoriesForESignatureSetupDocument, options);
        }
export type GetDocumentCategoriesForESignatureSetupQueryHookResult = ReturnType<typeof useGetDocumentCategoriesForESignatureSetupQuery>;
export type GetDocumentCategoriesForESignatureSetupLazyQueryHookResult = ReturnType<typeof useGetDocumentCategoriesForESignatureSetupLazyQuery>;
export type GetDocumentCategoriesForESignatureSetupSuspenseQueryHookResult = ReturnType<typeof useGetDocumentCategoriesForESignatureSetupSuspenseQuery>;
export type GetDocumentCategoriesForESignatureSetupQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentCategoriesForESignatureSetupQuery, GraphqlTypes.GetDocumentCategoriesForESignatureSetupQueryVariables>;
export const GetESigDraftAndDocumentCategoriesDocument = gql`
    query GetESigDraftAndDocumentCategories($eSigId: ID!, $filters: DocumentCategoriesFilters) {
  documentCategories(filters: $filters) {
    edges {
      node {
        id
        name
      }
    }
  }
  eSignatureRequestTemplate(id: $eSigId) {
    id
    objectId
    objectType
    currentValidatedStep
    title
    documentCategoryId
    eSignatureDocument {
      id
      documentCollectionId
      documentVersion {
        id
        name
        size
        contentType
        createdAt
        extension
      }
      folderId
    }
  }
}
    `;

/**
 * __useGetESigDraftAndDocumentCategoriesQuery__
 *
 * To run a query within a React component, call `useGetESigDraftAndDocumentCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetESigDraftAndDocumentCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetESigDraftAndDocumentCategoriesQuery({
 *   variables: {
 *      eSigId: // value for 'eSigId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetESigDraftAndDocumentCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetESigDraftAndDocumentCategoriesQuery, GraphqlTypes.GetESigDraftAndDocumentCategoriesQueryVariables> & ({ variables: GraphqlTypes.GetESigDraftAndDocumentCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetESigDraftAndDocumentCategoriesQuery, GraphqlTypes.GetESigDraftAndDocumentCategoriesQueryVariables>(GetESigDraftAndDocumentCategoriesDocument, options);
      }
export function useGetESigDraftAndDocumentCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetESigDraftAndDocumentCategoriesQuery, GraphqlTypes.GetESigDraftAndDocumentCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetESigDraftAndDocumentCategoriesQuery, GraphqlTypes.GetESigDraftAndDocumentCategoriesQueryVariables>(GetESigDraftAndDocumentCategoriesDocument, options);
        }
// @ts-ignore
export function useGetESigDraftAndDocumentCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESigDraftAndDocumentCategoriesQuery, GraphqlTypes.GetESigDraftAndDocumentCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESigDraftAndDocumentCategoriesQuery, GraphqlTypes.GetESigDraftAndDocumentCategoriesQueryVariables>;
export function useGetESigDraftAndDocumentCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESigDraftAndDocumentCategoriesQuery, GraphqlTypes.GetESigDraftAndDocumentCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESigDraftAndDocumentCategoriesQuery | undefined, GraphqlTypes.GetESigDraftAndDocumentCategoriesQueryVariables>;
export function useGetESigDraftAndDocumentCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESigDraftAndDocumentCategoriesQuery, GraphqlTypes.GetESigDraftAndDocumentCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetESigDraftAndDocumentCategoriesQuery, GraphqlTypes.GetESigDraftAndDocumentCategoriesQueryVariables>(GetESigDraftAndDocumentCategoriesDocument, options);
        }
export type GetESigDraftAndDocumentCategoriesQueryHookResult = ReturnType<typeof useGetESigDraftAndDocumentCategoriesQuery>;
export type GetESigDraftAndDocumentCategoriesLazyQueryHookResult = ReturnType<typeof useGetESigDraftAndDocumentCategoriesLazyQuery>;
export type GetESigDraftAndDocumentCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetESigDraftAndDocumentCategoriesSuspenseQuery>;
export type GetESigDraftAndDocumentCategoriesQueryResult = Apollo.QueryResult<GraphqlTypes.GetESigDraftAndDocumentCategoriesQuery, GraphqlTypes.GetESigDraftAndDocumentCategoriesQueryVariables>;
export const GetAllSubfoldersPathsForESignatureSetupDocument = gql`
    query GetAllSubfoldersPathsForESignatureSetup($id: ID!) {
  offering(id: $id) {
    documentFolder(folderId: null) {
      ... on DocumentFolder {
        id
        soaId
        name
        folders(depth: -1) {
          edges {
            node {
              breadcrumb {
                id
                name
              }
              id
              soaId
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllSubfoldersPathsForESignatureSetupQuery__
 *
 * To run a query within a React component, call `useGetAllSubfoldersPathsForESignatureSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSubfoldersPathsForESignatureSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSubfoldersPathsForESignatureSetupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllSubfoldersPathsForESignatureSetupQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQuery, GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQueryVariables> & ({ variables: GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQuery, GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQueryVariables>(GetAllSubfoldersPathsForESignatureSetupDocument, options);
      }
export function useGetAllSubfoldersPathsForESignatureSetupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQuery, GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQuery, GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQueryVariables>(GetAllSubfoldersPathsForESignatureSetupDocument, options);
        }
// @ts-ignore
export function useGetAllSubfoldersPathsForESignatureSetupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQuery, GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQuery, GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQueryVariables>;
export function useGetAllSubfoldersPathsForESignatureSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQuery, GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQuery | undefined, GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQueryVariables>;
export function useGetAllSubfoldersPathsForESignatureSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQuery, GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQuery, GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQueryVariables>(GetAllSubfoldersPathsForESignatureSetupDocument, options);
        }
export type GetAllSubfoldersPathsForESignatureSetupQueryHookResult = ReturnType<typeof useGetAllSubfoldersPathsForESignatureSetupQuery>;
export type GetAllSubfoldersPathsForESignatureSetupLazyQueryHookResult = ReturnType<typeof useGetAllSubfoldersPathsForESignatureSetupLazyQuery>;
export type GetAllSubfoldersPathsForESignatureSetupSuspenseQueryHookResult = ReturnType<typeof useGetAllSubfoldersPathsForESignatureSetupSuspenseQuery>;
export type GetAllSubfoldersPathsForESignatureSetupQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQuery, GraphqlTypes.GetAllSubfoldersPathsForESignatureSetupQueryVariables>;
export const GetESigDraftAndAllSubfoldersPathsDocument = gql`
    query GetESigDraftAndAllSubfoldersPaths($id: ID!, $eSigId: ID!) {
  offering(id: $id) {
    documentFolder(folderId: null) {
      ... on DocumentFolder {
        id
        soaId
        name
        folders(depth: -1) {
          edges {
            node {
              breadcrumb {
                id
                name
              }
              id
              soaId
              name
            }
          }
        }
      }
    }
  }
  eSignatureRequestTemplate(id: $eSigId) {
    id
    objectId
    objectType
    currentValidatedStep
    title
    documentCategoryId
    eSignatureDocument {
      id
      documentCollectionId
      documentVersion {
        id
        name
        size
        contentType
        createdAt
        extension
      }
      folderId
    }
  }
}
    `;

/**
 * __useGetESigDraftAndAllSubfoldersPathsQuery__
 *
 * To run a query within a React component, call `useGetESigDraftAndAllSubfoldersPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetESigDraftAndAllSubfoldersPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetESigDraftAndAllSubfoldersPathsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      eSigId: // value for 'eSigId'
 *   },
 * });
 */
export function useGetESigDraftAndAllSubfoldersPathsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQuery, GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQueryVariables> & ({ variables: GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQuery, GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQueryVariables>(GetESigDraftAndAllSubfoldersPathsDocument, options);
      }
export function useGetESigDraftAndAllSubfoldersPathsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQuery, GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQuery, GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQueryVariables>(GetESigDraftAndAllSubfoldersPathsDocument, options);
        }
// @ts-ignore
export function useGetESigDraftAndAllSubfoldersPathsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQuery, GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQuery, GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQueryVariables>;
export function useGetESigDraftAndAllSubfoldersPathsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQuery, GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQuery | undefined, GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQueryVariables>;
export function useGetESigDraftAndAllSubfoldersPathsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQuery, GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQuery, GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQueryVariables>(GetESigDraftAndAllSubfoldersPathsDocument, options);
        }
export type GetESigDraftAndAllSubfoldersPathsQueryHookResult = ReturnType<typeof useGetESigDraftAndAllSubfoldersPathsQuery>;
export type GetESigDraftAndAllSubfoldersPathsLazyQueryHookResult = ReturnType<typeof useGetESigDraftAndAllSubfoldersPathsLazyQuery>;
export type GetESigDraftAndAllSubfoldersPathsSuspenseQueryHookResult = ReturnType<typeof useGetESigDraftAndAllSubfoldersPathsSuspenseQuery>;
export type GetESigDraftAndAllSubfoldersPathsQueryResult = Apollo.QueryResult<GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQuery, GraphqlTypes.GetESigDraftAndAllSubfoldersPathsQueryVariables>;
export const GetRecipientAccountsDocument = gql`
    query GetRecipientAccounts($id: ID!, $eSignatureRequestTemplateId: ID!, $first: Int, $after: String) {
  eSignatureRequestTemplate(id: $eSignatureRequestTemplateId) {
    id
    documentCategoryId
    eSignatureDocument {
      requiresLpSignature
    }
    eSignatureRequests {
      edges {
        node {
          id
          eSignatureRecipients {
            edges {
              node {
                id
                objectId
                objectType
                eSignatureLpSigners {
                  edges {
                    node {
                      id
                      isDesignatedFormFiller
                      contact {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  investmentEntity(id: $id) {
    id
    positions: owningInvestorPositions(first: $first, after: $after) {
      count
      edges {
        node {
          __typename
          id
          investorGroup {
            id
            name
          }
          account {
            id
            name
            accountContactMaps {
              id
              isMainContact
              isAdminContact
              contact {
                id
                fullName
              }
              accountId
            }
            contacts {
              edges {
                node {
                  id
                  fullName
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRecipientAccountsQuery__
 *
 * To run a query within a React component, call `useGetRecipientAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipientAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipientAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      eSignatureRequestTemplateId: // value for 'eSignatureRequestTemplateId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetRecipientAccountsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetRecipientAccountsQuery, GraphqlTypes.GetRecipientAccountsQueryVariables> & ({ variables: GraphqlTypes.GetRecipientAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRecipientAccountsQuery, GraphqlTypes.GetRecipientAccountsQueryVariables>(GetRecipientAccountsDocument, options);
      }
export function useGetRecipientAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRecipientAccountsQuery, GraphqlTypes.GetRecipientAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRecipientAccountsQuery, GraphqlTypes.GetRecipientAccountsQueryVariables>(GetRecipientAccountsDocument, options);
        }
// @ts-ignore
export function useGetRecipientAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecipientAccountsQuery, GraphqlTypes.GetRecipientAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRecipientAccountsQuery, GraphqlTypes.GetRecipientAccountsQueryVariables>;
export function useGetRecipientAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecipientAccountsQuery, GraphqlTypes.GetRecipientAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRecipientAccountsQuery | undefined, GraphqlTypes.GetRecipientAccountsQueryVariables>;
export function useGetRecipientAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecipientAccountsQuery, GraphqlTypes.GetRecipientAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRecipientAccountsQuery, GraphqlTypes.GetRecipientAccountsQueryVariables>(GetRecipientAccountsDocument, options);
        }
export type GetRecipientAccountsQueryHookResult = ReturnType<typeof useGetRecipientAccountsQuery>;
export type GetRecipientAccountsLazyQueryHookResult = ReturnType<typeof useGetRecipientAccountsLazyQuery>;
export type GetRecipientAccountsSuspenseQueryHookResult = ReturnType<typeof useGetRecipientAccountsSuspenseQuery>;
export type GetRecipientAccountsQueryResult = Apollo.QueryResult<GraphqlTypes.GetRecipientAccountsQuery, GraphqlTypes.GetRecipientAccountsQueryVariables>;
export const GetRecipientProspectsDocument = gql`
    query GetRecipientProspects($id: ID!, $eSignatureRequestTemplateId: ID!, $first: Int, $after: String) {
  eSignatureRequestTemplate(id: $eSignatureRequestTemplateId) {
    id
    documentCategoryId
    eSignatureDocument {
      requiresLpSignature
    }
    eSignatureRequests {
      edges {
        node {
          eSignatureRecipients {
            edges {
              node {
                id
                objectId
                objectType
                eSignatureLpSigners {
                  edges {
                    node {
                      id
                      isDesignatedFormFiller
                      contact {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  offering(id: $id) {
    id
    prospects(first: $first, after: $after) {
      count
      edges {
        node {
          id
          __typename
          name: title
          prospectContactMaps {
            id
            contact {
              id
              fullName
            }
            prospectId
            isMainContact
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRecipientProspectsQuery__
 *
 * To run a query within a React component, call `useGetRecipientProspectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipientProspectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipientProspectsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      eSignatureRequestTemplateId: // value for 'eSignatureRequestTemplateId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetRecipientProspectsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetRecipientProspectsQuery, GraphqlTypes.GetRecipientProspectsQueryVariables> & ({ variables: GraphqlTypes.GetRecipientProspectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRecipientProspectsQuery, GraphqlTypes.GetRecipientProspectsQueryVariables>(GetRecipientProspectsDocument, options);
      }
export function useGetRecipientProspectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRecipientProspectsQuery, GraphqlTypes.GetRecipientProspectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRecipientProspectsQuery, GraphqlTypes.GetRecipientProspectsQueryVariables>(GetRecipientProspectsDocument, options);
        }
// @ts-ignore
export function useGetRecipientProspectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecipientProspectsQuery, GraphqlTypes.GetRecipientProspectsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRecipientProspectsQuery, GraphqlTypes.GetRecipientProspectsQueryVariables>;
export function useGetRecipientProspectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecipientProspectsQuery, GraphqlTypes.GetRecipientProspectsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRecipientProspectsQuery | undefined, GraphqlTypes.GetRecipientProspectsQueryVariables>;
export function useGetRecipientProspectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecipientProspectsQuery, GraphqlTypes.GetRecipientProspectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRecipientProspectsQuery, GraphqlTypes.GetRecipientProspectsQueryVariables>(GetRecipientProspectsDocument, options);
        }
export type GetRecipientProspectsQueryHookResult = ReturnType<typeof useGetRecipientProspectsQuery>;
export type GetRecipientProspectsLazyQueryHookResult = ReturnType<typeof useGetRecipientProspectsLazyQuery>;
export type GetRecipientProspectsSuspenseQueryHookResult = ReturnType<typeof useGetRecipientProspectsSuspenseQuery>;
export type GetRecipientProspectsQueryResult = Apollo.QueryResult<GraphqlTypes.GetRecipientProspectsQuery, GraphqlTypes.GetRecipientProspectsQueryVariables>;
export const SearchRecipientsAccountsDocument = gql`
    query SearchRecipientsAccounts($entityId: ID!, $eSignatureRequestTemplateId: ID!, $term: String!, $first: Int, $after: String) {
  eSignatureRequestTemplate(id: $eSignatureRequestTemplateId) {
    id
    eSignatureDocument {
      requiresLpSignature
    }
    documentCategoryId
    eSignatureRequests {
      edges {
        node {
          id
          eSignatureRecipients {
            edges {
              node {
                id
                objectId
                objectType
                eSignatureLpSigners {
                  edges {
                    node {
                      id
                      isDesignatedFormFiller
                      contact {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  searchPositions(term: $term, entityId: $entityId, first: $first, after: $after) {
    count
    edges {
      node {
        id
        __typename
        investorGroup {
          id
          name
        }
        account {
          id
          name
          accountContactMaps {
            id
            isMainContact
            isAdminContact
            contact {
              id
              fullName
            }
            accountId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchRecipientsAccountsQuery__
 *
 * To run a query within a React component, call `useSearchRecipientsAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRecipientsAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchRecipientsAccountsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      eSignatureRequestTemplateId: // value for 'eSignatureRequestTemplateId'
 *      term: // value for 'term'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchRecipientsAccountsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchRecipientsAccountsQuery, GraphqlTypes.SearchRecipientsAccountsQueryVariables> & ({ variables: GraphqlTypes.SearchRecipientsAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchRecipientsAccountsQuery, GraphqlTypes.SearchRecipientsAccountsQueryVariables>(SearchRecipientsAccountsDocument, options);
      }
export function useSearchRecipientsAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchRecipientsAccountsQuery, GraphqlTypes.SearchRecipientsAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchRecipientsAccountsQuery, GraphqlTypes.SearchRecipientsAccountsQueryVariables>(SearchRecipientsAccountsDocument, options);
        }
// @ts-ignore
export function useSearchRecipientsAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchRecipientsAccountsQuery, GraphqlTypes.SearchRecipientsAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchRecipientsAccountsQuery, GraphqlTypes.SearchRecipientsAccountsQueryVariables>;
export function useSearchRecipientsAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchRecipientsAccountsQuery, GraphqlTypes.SearchRecipientsAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchRecipientsAccountsQuery | undefined, GraphqlTypes.SearchRecipientsAccountsQueryVariables>;
export function useSearchRecipientsAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchRecipientsAccountsQuery, GraphqlTypes.SearchRecipientsAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchRecipientsAccountsQuery, GraphqlTypes.SearchRecipientsAccountsQueryVariables>(SearchRecipientsAccountsDocument, options);
        }
export type SearchRecipientsAccountsQueryHookResult = ReturnType<typeof useSearchRecipientsAccountsQuery>;
export type SearchRecipientsAccountsLazyQueryHookResult = ReturnType<typeof useSearchRecipientsAccountsLazyQuery>;
export type SearchRecipientsAccountsSuspenseQueryHookResult = ReturnType<typeof useSearchRecipientsAccountsSuspenseQuery>;
export type SearchRecipientsAccountsQueryResult = Apollo.QueryResult<GraphqlTypes.SearchRecipientsAccountsQuery, GraphqlTypes.SearchRecipientsAccountsQueryVariables>;
export const SearchRecipientProspectsDocument = gql`
    query SearchRecipientProspects($term: String!, $offeringId: ID!, $eSignatureRequestTemplateId: ID!, $first: Int, $after: String) {
  eSignatureRequestTemplate(id: $eSignatureRequestTemplateId) {
    id
    eSignatureDocument {
      requiresLpSignature
    }
    eSignatureRequests {
      edges {
        node {
          id
          eSignatureRecipients {
            edges {
              node {
                id
                objectId
                objectType
                eSignatureLpSigners {
                  edges {
                    node {
                      id
                      isDesignatedFormFiller
                      contact {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  searchProspectsByOffering(
    term: $term
    offeringId: $offeringId
    first: $first
    after: $after
  ) {
    count
    edges {
      node {
        id
        name: title
        prospectContactMaps {
          id
          contactId
          prospectId
          isMainContact
          contact {
            id
            fullName
          }
        }
        __typename
        contacts {
          edges {
            node {
              id
              fullName
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchRecipientProspectsQuery__
 *
 * To run a query within a React component, call `useSearchRecipientProspectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRecipientProspectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchRecipientProspectsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      offeringId: // value for 'offeringId'
 *      eSignatureRequestTemplateId: // value for 'eSignatureRequestTemplateId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchRecipientProspectsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchRecipientProspectsQuery, GraphqlTypes.SearchRecipientProspectsQueryVariables> & ({ variables: GraphqlTypes.SearchRecipientProspectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchRecipientProspectsQuery, GraphqlTypes.SearchRecipientProspectsQueryVariables>(SearchRecipientProspectsDocument, options);
      }
export function useSearchRecipientProspectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchRecipientProspectsQuery, GraphqlTypes.SearchRecipientProspectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchRecipientProspectsQuery, GraphqlTypes.SearchRecipientProspectsQueryVariables>(SearchRecipientProspectsDocument, options);
        }
// @ts-ignore
export function useSearchRecipientProspectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchRecipientProspectsQuery, GraphqlTypes.SearchRecipientProspectsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchRecipientProspectsQuery, GraphqlTypes.SearchRecipientProspectsQueryVariables>;
export function useSearchRecipientProspectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchRecipientProspectsQuery, GraphqlTypes.SearchRecipientProspectsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchRecipientProspectsQuery | undefined, GraphqlTypes.SearchRecipientProspectsQueryVariables>;
export function useSearchRecipientProspectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchRecipientProspectsQuery, GraphqlTypes.SearchRecipientProspectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchRecipientProspectsQuery, GraphqlTypes.SearchRecipientProspectsQueryVariables>(SearchRecipientProspectsDocument, options);
        }
export type SearchRecipientProspectsQueryHookResult = ReturnType<typeof useSearchRecipientProspectsQuery>;
export type SearchRecipientProspectsLazyQueryHookResult = ReturnType<typeof useSearchRecipientProspectsLazyQuery>;
export type SearchRecipientProspectsSuspenseQueryHookResult = ReturnType<typeof useSearchRecipientProspectsSuspenseQuery>;
export type SearchRecipientProspectsQueryResult = Apollo.QueryResult<GraphqlTypes.SearchRecipientProspectsQuery, GraphqlTypes.SearchRecipientProspectsQueryVariables>;
export const SaveSubmitRecipientsDocument = gql`
    mutation SaveSubmitRecipients($input: SubmitESignatureRecipientsInputObjectType!) {
  eSignatureOps {
    submitRecipients(objectInput: $input) {
      eSignatureRequests {
        id
        eSignatureRequestRecipients {
          edges {
            node {
              id
              eSignatureLpSigners {
                edges {
                  node {
                    id
                    contact {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type SaveSubmitRecipientsMutationFn = Apollo.MutationFunction<GraphqlTypes.SaveSubmitRecipientsMutation, GraphqlTypes.SaveSubmitRecipientsMutationVariables>;

/**
 * __useSaveSubmitRecipientsMutation__
 *
 * To run a mutation, you first call `useSaveSubmitRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSubmitRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSubmitRecipientsMutation, { data, loading, error }] = useSaveSubmitRecipientsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSubmitRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SaveSubmitRecipientsMutation, GraphqlTypes.SaveSubmitRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SaveSubmitRecipientsMutation, GraphqlTypes.SaveSubmitRecipientsMutationVariables>(SaveSubmitRecipientsDocument, options);
      }
export type SaveSubmitRecipientsMutationHookResult = ReturnType<typeof useSaveSubmitRecipientsMutation>;
export type SaveSubmitRecipientsMutationResult = Apollo.MutationResult<GraphqlTypes.SaveSubmitRecipientsMutation>;
export type SaveSubmitRecipientsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SaveSubmitRecipientsMutation, GraphqlTypes.SaveSubmitRecipientsMutationVariables>;
export const SubmitSignatureSettingsDocument = gql`
    mutation SubmitSignatureSettings($input: SubmitSignatureSettingsInputObjectType!) {
  eSignatureOps {
    submitSignatureSettings(objectInput: $input) {
      eSignatureDocument {
        id
        generateSignatureBlocks
        requiresGpSignature
        requiresLpSignature
        lpSignatureIntro
        gpSignatureIntro
        gpSignatureConclusion
      }
      eSignatureRequestTemplate {
        id
        chainOfSigningAuthority
        currentValidatedStep
      }
      eSignatureRequestTemplateGpSigners {
        id
        title
        user {
          fullName
        }
      }
    }
  }
}
    `;
export type SubmitSignatureSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.SubmitSignatureSettingsMutation, GraphqlTypes.SubmitSignatureSettingsMutationVariables>;

/**
 * __useSubmitSignatureSettingsMutation__
 *
 * To run a mutation, you first call `useSubmitSignatureSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSignatureSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSignatureSettingsMutation, { data, loading, error }] = useSubmitSignatureSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSignatureSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubmitSignatureSettingsMutation, GraphqlTypes.SubmitSignatureSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubmitSignatureSettingsMutation, GraphqlTypes.SubmitSignatureSettingsMutationVariables>(SubmitSignatureSettingsDocument, options);
      }
export type SubmitSignatureSettingsMutationHookResult = ReturnType<typeof useSubmitSignatureSettingsMutation>;
export type SubmitSignatureSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.SubmitSignatureSettingsMutation>;
export type SubmitSignatureSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubmitSignatureSettingsMutation, GraphqlTypes.SubmitSignatureSettingsMutationVariables>;
export const GetESignatureSettingsDocument = gql`
    query GetESignatureSettings($id: ID!, $filters: ESignatureRequestTemplateGpSignerFilters!) {
  eSignatureRequestTemplateGpSigners(filters: $filters) {
    edges {
      node {
        title
        isEmbedded
        user {
          fullName
          id
        }
      }
    }
  }
  eSignatureRequestTemplate(id: $id) {
    id
    chainOfSigningAuthority
    currentValidatedStep
    allowedGpSigners {
      id
      fullName
      title
    }
    eSignatureDocument {
      documentVersionId
      generateSignatureBlocks
      requiresLpSignature
      requiresGpSignature
      lpSignatureIntro
      gpSignatureIntro
      gpSignatureConclusion
      title
      documentCategoryId
      documentCollectionId
      id
    }
  }
  currentArena {
    id
    name
  }
}
    `;

/**
 * __useGetESignatureSettingsQuery__
 *
 * To run a query within a React component, call `useGetESignatureSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetESignatureSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetESignatureSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetESignatureSettingsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetESignatureSettingsQuery, GraphqlTypes.GetESignatureSettingsQueryVariables> & ({ variables: GraphqlTypes.GetESignatureSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetESignatureSettingsQuery, GraphqlTypes.GetESignatureSettingsQueryVariables>(GetESignatureSettingsDocument, options);
      }
export function useGetESignatureSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetESignatureSettingsQuery, GraphqlTypes.GetESignatureSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetESignatureSettingsQuery, GraphqlTypes.GetESignatureSettingsQueryVariables>(GetESignatureSettingsDocument, options);
        }
// @ts-ignore
export function useGetESignatureSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureSettingsQuery, GraphqlTypes.GetESignatureSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureSettingsQuery, GraphqlTypes.GetESignatureSettingsQueryVariables>;
export function useGetESignatureSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureSettingsQuery, GraphqlTypes.GetESignatureSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureSettingsQuery | undefined, GraphqlTypes.GetESignatureSettingsQueryVariables>;
export function useGetESignatureSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureSettingsQuery, GraphqlTypes.GetESignatureSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetESignatureSettingsQuery, GraphqlTypes.GetESignatureSettingsQueryVariables>(GetESignatureSettingsDocument, options);
        }
export type GetESignatureSettingsQueryHookResult = ReturnType<typeof useGetESignatureSettingsQuery>;
export type GetESignatureSettingsLazyQueryHookResult = ReturnType<typeof useGetESignatureSettingsLazyQuery>;
export type GetESignatureSettingsSuspenseQueryHookResult = ReturnType<typeof useGetESignatureSettingsSuspenseQuery>;
export type GetESignatureSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetESignatureSettingsQuery, GraphqlTypes.GetESignatureSettingsQueryVariables>;
export const GetValidatedStepDocument = gql`
    query GetValidatedStep($id: ID!) {
  eSignatureRequestTemplate(id: $id) {
    id
    currentValidatedStep
    eSignatureObject {
      ...ESignatureObjectAccountFields
      ...ESignatureObjectOfferingFields
      __typename
    }
  }
}
    ${ESignatureObjectAccountFieldsFragmentDoc}
${ESignatureObjectOfferingFieldsFragmentDoc}`;

/**
 * __useGetValidatedStepQuery__
 *
 * To run a query within a React component, call `useGetValidatedStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidatedStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidatedStepQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetValidatedStepQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetValidatedStepQuery, GraphqlTypes.GetValidatedStepQueryVariables> & ({ variables: GraphqlTypes.GetValidatedStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetValidatedStepQuery, GraphqlTypes.GetValidatedStepQueryVariables>(GetValidatedStepDocument, options);
      }
export function useGetValidatedStepLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetValidatedStepQuery, GraphqlTypes.GetValidatedStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetValidatedStepQuery, GraphqlTypes.GetValidatedStepQueryVariables>(GetValidatedStepDocument, options);
        }
// @ts-ignore
export function useGetValidatedStepSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetValidatedStepQuery, GraphqlTypes.GetValidatedStepQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetValidatedStepQuery, GraphqlTypes.GetValidatedStepQueryVariables>;
export function useGetValidatedStepSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetValidatedStepQuery, GraphqlTypes.GetValidatedStepQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetValidatedStepQuery | undefined, GraphqlTypes.GetValidatedStepQueryVariables>;
export function useGetValidatedStepSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetValidatedStepQuery, GraphqlTypes.GetValidatedStepQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetValidatedStepQuery, GraphqlTypes.GetValidatedStepQueryVariables>(GetValidatedStepDocument, options);
        }
export type GetValidatedStepQueryHookResult = ReturnType<typeof useGetValidatedStepQuery>;
export type GetValidatedStepLazyQueryHookResult = ReturnType<typeof useGetValidatedStepLazyQuery>;
export type GetValidatedStepSuspenseQueryHookResult = ReturnType<typeof useGetValidatedStepSuspenseQuery>;
export type GetValidatedStepQueryResult = Apollo.QueryResult<GraphqlTypes.GetValidatedStepQuery, GraphqlTypes.GetValidatedStepQueryVariables>;
export const GetInvestorDiligencesDocument = gql`
    query GetInvestorDiligences {
  investorDiligences {
    edges {
      node {
        id
        investorDiligenceType
        category
        status
        arenaId
        dateSubmitted
        objectType
        reviewer {
          fullName
          emailAddress
        }
        peerReviewer {
          fullName
          emailAddress
        }
        investorDiligenceObject {
          __typename
          ...SubscriptionInvestorDiligencesObjectFields
          ...SubscriptionRecurringAccountObjectFields
          ...SubscriptionObjectProspectFields
        }
      }
    }
  }
  kycStats {
    kycCustomerCount
    kycEntityCount
  }
}
    ${SubscriptionInvestorDiligencesObjectFieldsFragmentDoc}
${SubscriptionRecurringAccountObjectFieldsFragmentDoc}
${SubscriptionObjectProspectFieldsFragmentDoc}`;

/**
 * __useGetInvestorDiligencesQuery__
 *
 * To run a query within a React component, call `useGetInvestorDiligencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestorDiligencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestorDiligencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvestorDiligencesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetInvestorDiligencesQuery, GraphqlTypes.GetInvestorDiligencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestorDiligencesQuery, GraphqlTypes.GetInvestorDiligencesQueryVariables>(GetInvestorDiligencesDocument, options);
      }
export function useGetInvestorDiligencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestorDiligencesQuery, GraphqlTypes.GetInvestorDiligencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestorDiligencesQuery, GraphqlTypes.GetInvestorDiligencesQueryVariables>(GetInvestorDiligencesDocument, options);
        }
// @ts-ignore
export function useGetInvestorDiligencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorDiligencesQuery, GraphqlTypes.GetInvestorDiligencesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestorDiligencesQuery, GraphqlTypes.GetInvestorDiligencesQueryVariables>;
export function useGetInvestorDiligencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorDiligencesQuery, GraphqlTypes.GetInvestorDiligencesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestorDiligencesQuery | undefined, GraphqlTypes.GetInvestorDiligencesQueryVariables>;
export function useGetInvestorDiligencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorDiligencesQuery, GraphqlTypes.GetInvestorDiligencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestorDiligencesQuery, GraphqlTypes.GetInvestorDiligencesQueryVariables>(GetInvestorDiligencesDocument, options);
        }
export type GetInvestorDiligencesQueryHookResult = ReturnType<typeof useGetInvestorDiligencesQuery>;
export type GetInvestorDiligencesLazyQueryHookResult = ReturnType<typeof useGetInvestorDiligencesLazyQuery>;
export type GetInvestorDiligencesSuspenseQueryHookResult = ReturnType<typeof useGetInvestorDiligencesSuspenseQuery>;
export type GetInvestorDiligencesQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestorDiligencesQuery, GraphqlTypes.GetInvestorDiligencesQueryVariables>;
export const DownloadAnalystAuditLogDocument = gql`
    mutation DownloadAnalystAuditLog($startDate: DateTime!, $endDate: DateTime!) {
  investorDiligenceOps {
    downloadAnalystAuditLog(startDate: $startDate, endDate: $endDate) {
      job {
        id
        data
      }
    }
  }
}
    `;
export type DownloadAnalystAuditLogMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadAnalystAuditLogMutation, GraphqlTypes.DownloadAnalystAuditLogMutationVariables>;

/**
 * __useDownloadAnalystAuditLogMutation__
 *
 * To run a mutation, you first call `useDownloadAnalystAuditLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAnalystAuditLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAnalystAuditLogMutation, { data, loading, error }] = useDownloadAnalystAuditLogMutation({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useDownloadAnalystAuditLogMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadAnalystAuditLogMutation, GraphqlTypes.DownloadAnalystAuditLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadAnalystAuditLogMutation, GraphqlTypes.DownloadAnalystAuditLogMutationVariables>(DownloadAnalystAuditLogDocument, options);
      }
export type DownloadAnalystAuditLogMutationHookResult = ReturnType<typeof useDownloadAnalystAuditLogMutation>;
export type DownloadAnalystAuditLogMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadAnalystAuditLogMutation>;
export type DownloadAnalystAuditLogMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadAnalystAuditLogMutation, GraphqlTypes.DownloadAnalystAuditLogMutationVariables>;
export const DownloadActiveCaseLogDocument = gql`
    mutation DownloadActiveCaseLog($startDate: DateTime!, $endDate: DateTime!) {
  investorDiligenceOps {
    downloadActiveCaseLog(startDate: $startDate, endDate: $endDate) {
      job {
        id
        data
      }
    }
  }
}
    `;
export type DownloadActiveCaseLogMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadActiveCaseLogMutation, GraphqlTypes.DownloadActiveCaseLogMutationVariables>;

/**
 * __useDownloadActiveCaseLogMutation__
 *
 * To run a mutation, you first call `useDownloadActiveCaseLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadActiveCaseLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadActiveCaseLogMutation, { data, loading, error }] = useDownloadActiveCaseLogMutation({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useDownloadActiveCaseLogMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadActiveCaseLogMutation, GraphqlTypes.DownloadActiveCaseLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadActiveCaseLogMutation, GraphqlTypes.DownloadActiveCaseLogMutationVariables>(DownloadActiveCaseLogDocument, options);
      }
export type DownloadActiveCaseLogMutationHookResult = ReturnType<typeof useDownloadActiveCaseLogMutation>;
export type DownloadActiveCaseLogMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadActiveCaseLogMutation>;
export type DownloadActiveCaseLogMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadActiveCaseLogMutation, GraphqlTypes.DownloadActiveCaseLogMutationVariables>;
export const GetAuditLogDownloadUrlDocument = gql`
    query GetAuditLogDownloadUrl($asyncJobId: ID!) {
  auditLogDownloadUrl(asyncJobId: $asyncJobId)
}
    `;

/**
 * __useGetAuditLogDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetAuditLogDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditLogDownloadUrlQuery({
 *   variables: {
 *      asyncJobId: // value for 'asyncJobId'
 *   },
 * });
 */
export function useGetAuditLogDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAuditLogDownloadUrlQuery, GraphqlTypes.GetAuditLogDownloadUrlQueryVariables> & ({ variables: GraphqlTypes.GetAuditLogDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAuditLogDownloadUrlQuery, GraphqlTypes.GetAuditLogDownloadUrlQueryVariables>(GetAuditLogDownloadUrlDocument, options);
      }
export function useGetAuditLogDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAuditLogDownloadUrlQuery, GraphqlTypes.GetAuditLogDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAuditLogDownloadUrlQuery, GraphqlTypes.GetAuditLogDownloadUrlQueryVariables>(GetAuditLogDownloadUrlDocument, options);
        }
// @ts-ignore
export function useGetAuditLogDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAuditLogDownloadUrlQuery, GraphqlTypes.GetAuditLogDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAuditLogDownloadUrlQuery, GraphqlTypes.GetAuditLogDownloadUrlQueryVariables>;
export function useGetAuditLogDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAuditLogDownloadUrlQuery, GraphqlTypes.GetAuditLogDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAuditLogDownloadUrlQuery | undefined, GraphqlTypes.GetAuditLogDownloadUrlQueryVariables>;
export function useGetAuditLogDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAuditLogDownloadUrlQuery, GraphqlTypes.GetAuditLogDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAuditLogDownloadUrlQuery, GraphqlTypes.GetAuditLogDownloadUrlQueryVariables>(GetAuditLogDownloadUrlDocument, options);
        }
export type GetAuditLogDownloadUrlQueryHookResult = ReturnType<typeof useGetAuditLogDownloadUrlQuery>;
export type GetAuditLogDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetAuditLogDownloadUrlLazyQuery>;
export type GetAuditLogDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetAuditLogDownloadUrlSuspenseQuery>;
export type GetAuditLogDownloadUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetAuditLogDownloadUrlQuery, GraphqlTypes.GetAuditLogDownloadUrlQueryVariables>;
export const AcceptOrRejectKycDocumentVersionDocument = gql`
    mutation AcceptOrRejectKycDocumentVersion($arenaId: ID!, $investorDiligenceId: ID!, $kycDocumentVersionId: ID!, $isAccept: Boolean!, $comment: String) {
  investorDiligenceOps {
    acceptOrRejectKycDocumentVersion(
      arenaId: $arenaId
      investorDiligenceId: $investorDiligenceId
      kycDocumentVersionId: $kycDocumentVersionId
      isAccept: $isAccept
      comment: $comment
    ) {
      kycDocumentVersion {
        ...KycDocumentVersion
      }
    }
  }
}
    ${KycDocumentVersionFragmentDoc}`;
export type AcceptOrRejectKycDocumentVersionMutationFn = Apollo.MutationFunction<GraphqlTypes.AcceptOrRejectKycDocumentVersionMutation, GraphqlTypes.AcceptOrRejectKycDocumentVersionMutationVariables>;

/**
 * __useAcceptOrRejectKycDocumentVersionMutation__
 *
 * To run a mutation, you first call `useAcceptOrRejectKycDocumentVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOrRejectKycDocumentVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOrRejectKycDocumentVersionMutation, { data, loading, error }] = useAcceptOrRejectKycDocumentVersionMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      investorDiligenceId: // value for 'investorDiligenceId'
 *      kycDocumentVersionId: // value for 'kycDocumentVersionId'
 *      isAccept: // value for 'isAccept'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAcceptOrRejectKycDocumentVersionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AcceptOrRejectKycDocumentVersionMutation, GraphqlTypes.AcceptOrRejectKycDocumentVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AcceptOrRejectKycDocumentVersionMutation, GraphqlTypes.AcceptOrRejectKycDocumentVersionMutationVariables>(AcceptOrRejectKycDocumentVersionDocument, options);
      }
export type AcceptOrRejectKycDocumentVersionMutationHookResult = ReturnType<typeof useAcceptOrRejectKycDocumentVersionMutation>;
export type AcceptOrRejectKycDocumentVersionMutationResult = Apollo.MutationResult<GraphqlTypes.AcceptOrRejectKycDocumentVersionMutation>;
export type AcceptOrRejectKycDocumentVersionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AcceptOrRejectKycDocumentVersionMutation, GraphqlTypes.AcceptOrRejectKycDocumentVersionMutationVariables>;
export const AddDocumentCommentDocument = gql`
    mutation AddDocumentComment($arenaId: ID!, $kycDocumentVersionId: ID!, $comment: String!) {
  investorDiligenceOps {
    addDocumentComment(
      arenaId: $arenaId
      kycDocumentVersionId: $kycDocumentVersionId
      comment: $comment
    ) {
      kycDocumentVersionActivity {
        ...KycDocumentVersionActivityObjectFields
      }
    }
  }
}
    ${KycDocumentVersionActivityObjectFieldsFragmentDoc}`;
export type AddDocumentCommentMutationFn = Apollo.MutationFunction<GraphqlTypes.AddDocumentCommentMutation, GraphqlTypes.AddDocumentCommentMutationVariables>;

/**
 * __useAddDocumentCommentMutation__
 *
 * To run a mutation, you first call `useAddDocumentCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDocumentCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDocumentCommentMutation, { data, loading, error }] = useAddDocumentCommentMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      kycDocumentVersionId: // value for 'kycDocumentVersionId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddDocumentCommentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddDocumentCommentMutation, GraphqlTypes.AddDocumentCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddDocumentCommentMutation, GraphqlTypes.AddDocumentCommentMutationVariables>(AddDocumentCommentDocument, options);
      }
export type AddDocumentCommentMutationHookResult = ReturnType<typeof useAddDocumentCommentMutation>;
export type AddDocumentCommentMutationResult = Apollo.MutationResult<GraphqlTypes.AddDocumentCommentMutation>;
export type AddDocumentCommentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddDocumentCommentMutation, GraphqlTypes.AddDocumentCommentMutationVariables>;
export const EditActivityDocument = gql`
    mutation EditActivity($arenaId: ID!, $kycDocumentVersionActivityId: ID!, $comment: String!) {
  investorDiligenceOps {
    editActivity(
      arenaId: $arenaId
      kycDocumentVersionActivityId: $kycDocumentVersionActivityId
      comment: $comment
    ) {
      kycDocumentVersionActivity {
        ...KycDocumentVersionActivityObjectFields
      }
    }
  }
}
    ${KycDocumentVersionActivityObjectFieldsFragmentDoc}`;
export type EditActivityMutationFn = Apollo.MutationFunction<GraphqlTypes.EditActivityMutation, GraphqlTypes.EditActivityMutationVariables>;

/**
 * __useEditActivityMutation__
 *
 * To run a mutation, you first call `useEditActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editActivityMutation, { data, loading, error }] = useEditActivityMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      kycDocumentVersionActivityId: // value for 'kycDocumentVersionActivityId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useEditActivityMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditActivityMutation, GraphqlTypes.EditActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditActivityMutation, GraphqlTypes.EditActivityMutationVariables>(EditActivityDocument, options);
      }
export type EditActivityMutationHookResult = ReturnType<typeof useEditActivityMutation>;
export type EditActivityMutationResult = Apollo.MutationResult<GraphqlTypes.EditActivityMutation>;
export type EditActivityMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditActivityMutation, GraphqlTypes.EditActivityMutationVariables>;
export const DeleteActivityDocument = gql`
    mutation DeleteActivity($arenaId: ID!, $kycDocumentVersionActivityId: ID!) {
  investorDiligenceOps {
    deleteActivity(
      arenaId: $arenaId
      kycDocumentVersionActivityId: $kycDocumentVersionActivityId
    ) {
      kycDocumentVersionActivity {
        ...KycDocumentVersionActivityObjectFields
      }
    }
  }
}
    ${KycDocumentVersionActivityObjectFieldsFragmentDoc}`;
export type DeleteActivityMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteActivityMutation, GraphqlTypes.DeleteActivityMutationVariables>;

/**
 * __useDeleteActivityMutation__
 *
 * To run a mutation, you first call `useDeleteActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActivityMutation, { data, loading, error }] = useDeleteActivityMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      kycDocumentVersionActivityId: // value for 'kycDocumentVersionActivityId'
 *   },
 * });
 */
export function useDeleteActivityMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteActivityMutation, GraphqlTypes.DeleteActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteActivityMutation, GraphqlTypes.DeleteActivityMutationVariables>(DeleteActivityDocument, options);
      }
export type DeleteActivityMutationHookResult = ReturnType<typeof useDeleteActivityMutation>;
export type DeleteActivityMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteActivityMutation>;
export type DeleteActivityMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteActivityMutation, GraphqlTypes.DeleteActivityMutationVariables>;
export const KycDocumentActivitiesDocument = gql`
    query KycDocumentActivities($id: ID!, $arenaId: ID!) {
  kycDocument(id: $id, arenaId: $arenaId) {
    ...KycDocumentWithActivities
  }
}
    ${KycDocumentWithActivitiesFragmentDoc}`;

/**
 * __useKycDocumentActivitiesQuery__
 *
 * To run a query within a React component, call `useKycDocumentActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useKycDocumentActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKycDocumentActivitiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useKycDocumentActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.KycDocumentActivitiesQuery, GraphqlTypes.KycDocumentActivitiesQueryVariables> & ({ variables: GraphqlTypes.KycDocumentActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.KycDocumentActivitiesQuery, GraphqlTypes.KycDocumentActivitiesQueryVariables>(KycDocumentActivitiesDocument, options);
      }
export function useKycDocumentActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.KycDocumentActivitiesQuery, GraphqlTypes.KycDocumentActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.KycDocumentActivitiesQuery, GraphqlTypes.KycDocumentActivitiesQueryVariables>(KycDocumentActivitiesDocument, options);
        }
// @ts-ignore
export function useKycDocumentActivitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.KycDocumentActivitiesQuery, GraphqlTypes.KycDocumentActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.KycDocumentActivitiesQuery, GraphqlTypes.KycDocumentActivitiesQueryVariables>;
export function useKycDocumentActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.KycDocumentActivitiesQuery, GraphqlTypes.KycDocumentActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.KycDocumentActivitiesQuery | undefined, GraphqlTypes.KycDocumentActivitiesQueryVariables>;
export function useKycDocumentActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.KycDocumentActivitiesQuery, GraphqlTypes.KycDocumentActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.KycDocumentActivitiesQuery, GraphqlTypes.KycDocumentActivitiesQueryVariables>(KycDocumentActivitiesDocument, options);
        }
export type KycDocumentActivitiesQueryHookResult = ReturnType<typeof useKycDocumentActivitiesQuery>;
export type KycDocumentActivitiesLazyQueryHookResult = ReturnType<typeof useKycDocumentActivitiesLazyQuery>;
export type KycDocumentActivitiesSuspenseQueryHookResult = ReturnType<typeof useKycDocumentActivitiesSuspenseQuery>;
export type KycDocumentActivitiesQueryResult = Apollo.QueryResult<GraphqlTypes.KycDocumentActivitiesQuery, GraphqlTypes.KycDocumentActivitiesQueryVariables>;
export const InvestorDiligenceDocument = gql`
    query InvestorDiligence($id: ID!, $arenaId: ID!) {
  currentUser {
    id
  }
  investorDiligence(id: $id, arenaId: $arenaId) {
    ...InvestorDiligenceObjectTypeFields
  }
}
    ${InvestorDiligenceObjectTypeFieldsFragmentDoc}`;

/**
 * __useInvestorDiligenceQuery__
 *
 * To run a query within a React component, call `useInvestorDiligenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorDiligenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorDiligenceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useInvestorDiligenceQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.InvestorDiligenceQuery, GraphqlTypes.InvestorDiligenceQueryVariables> & ({ variables: GraphqlTypes.InvestorDiligenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.InvestorDiligenceQuery, GraphqlTypes.InvestorDiligenceQueryVariables>(InvestorDiligenceDocument, options);
      }
export function useInvestorDiligenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.InvestorDiligenceQuery, GraphqlTypes.InvestorDiligenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.InvestorDiligenceQuery, GraphqlTypes.InvestorDiligenceQueryVariables>(InvestorDiligenceDocument, options);
        }
// @ts-ignore
export function useInvestorDiligenceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.InvestorDiligenceQuery, GraphqlTypes.InvestorDiligenceQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.InvestorDiligenceQuery, GraphqlTypes.InvestorDiligenceQueryVariables>;
export function useInvestorDiligenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.InvestorDiligenceQuery, GraphqlTypes.InvestorDiligenceQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.InvestorDiligenceQuery | undefined, GraphqlTypes.InvestorDiligenceQueryVariables>;
export function useInvestorDiligenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.InvestorDiligenceQuery, GraphqlTypes.InvestorDiligenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.InvestorDiligenceQuery, GraphqlTypes.InvestorDiligenceQueryVariables>(InvestorDiligenceDocument, options);
        }
export type InvestorDiligenceQueryHookResult = ReturnType<typeof useInvestorDiligenceQuery>;
export type InvestorDiligenceLazyQueryHookResult = ReturnType<typeof useInvestorDiligenceLazyQuery>;
export type InvestorDiligenceSuspenseQueryHookResult = ReturnType<typeof useInvestorDiligenceSuspenseQuery>;
export type InvestorDiligenceQueryResult = Apollo.QueryResult<GraphqlTypes.InvestorDiligenceQuery, GraphqlTypes.InvestorDiligenceQueryVariables>;
export const TransitionDocumentVersionToStatusDocument = gql`
    mutation TransitionDocumentVersionToStatus($arenaId: ID!, $diligenceId: ID!, $kycDocumentVersionId: ID!, $status: KycDocumentStatus!, $comment: String) {
  apiFirstDiligenceOps {
    transitionDocumentVersionToStatus(
      arenaId: $arenaId
      diligenceId: $diligenceId
      kycDocumentVersionId: $kycDocumentVersionId
      status: $status
      comment: $comment
    ) {
      kycDocumentVersion {
        id
        kycDocumentId
        name
      }
    }
  }
}
    `;
export type TransitionDocumentVersionToStatusMutationFn = Apollo.MutationFunction<GraphqlTypes.TransitionDocumentVersionToStatusMutation, GraphqlTypes.TransitionDocumentVersionToStatusMutationVariables>;

/**
 * __useTransitionDocumentVersionToStatusMutation__
 *
 * To run a mutation, you first call `useTransitionDocumentVersionToStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionDocumentVersionToStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionDocumentVersionToStatusMutation, { data, loading, error }] = useTransitionDocumentVersionToStatusMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      diligenceId: // value for 'diligenceId'
 *      kycDocumentVersionId: // value for 'kycDocumentVersionId'
 *      status: // value for 'status'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useTransitionDocumentVersionToStatusMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.TransitionDocumentVersionToStatusMutation, GraphqlTypes.TransitionDocumentVersionToStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.TransitionDocumentVersionToStatusMutation, GraphqlTypes.TransitionDocumentVersionToStatusMutationVariables>(TransitionDocumentVersionToStatusDocument, options);
      }
export type TransitionDocumentVersionToStatusMutationHookResult = ReturnType<typeof useTransitionDocumentVersionToStatusMutation>;
export type TransitionDocumentVersionToStatusMutationResult = Apollo.MutationResult<GraphqlTypes.TransitionDocumentVersionToStatusMutation>;
export type TransitionDocumentVersionToStatusMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.TransitionDocumentVersionToStatusMutation, GraphqlTypes.TransitionDocumentVersionToStatusMutationVariables>;
export const AddKycApiFirstDocumentCommentDocument = gql`
    mutation AddKycApiFirstDocumentComment($arenaId: ID!, $kycDocumentVersionId: ID!, $comment: String!) {
  apiFirstDiligenceOps {
    addDocumentComment(
      arenaId: $arenaId
      kycDocumentVersionId: $kycDocumentVersionId
      comment: $comment
    ) {
      kycDocumentVersionActivity {
        comment
        id
        createdAt
        activityType
        owner {
          fullName
          id
        }
      }
    }
  }
}
    `;
export type AddKycApiFirstDocumentCommentMutationFn = Apollo.MutationFunction<GraphqlTypes.AddKycApiFirstDocumentCommentMutation, GraphqlTypes.AddKycApiFirstDocumentCommentMutationVariables>;

/**
 * __useAddKycApiFirstDocumentCommentMutation__
 *
 * To run a mutation, you first call `useAddKycApiFirstDocumentCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddKycApiFirstDocumentCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addKycApiFirstDocumentCommentMutation, { data, loading, error }] = useAddKycApiFirstDocumentCommentMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      kycDocumentVersionId: // value for 'kycDocumentVersionId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddKycApiFirstDocumentCommentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddKycApiFirstDocumentCommentMutation, GraphqlTypes.AddKycApiFirstDocumentCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddKycApiFirstDocumentCommentMutation, GraphqlTypes.AddKycApiFirstDocumentCommentMutationVariables>(AddKycApiFirstDocumentCommentDocument, options);
      }
export type AddKycApiFirstDocumentCommentMutationHookResult = ReturnType<typeof useAddKycApiFirstDocumentCommentMutation>;
export type AddKycApiFirstDocumentCommentMutationResult = Apollo.MutationResult<GraphqlTypes.AddKycApiFirstDocumentCommentMutation>;
export type AddKycApiFirstDocumentCommentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddKycApiFirstDocumentCommentMutation, GraphqlTypes.AddKycApiFirstDocumentCommentMutationVariables>;
export const EditKycApiFirstActivityDocument = gql`
    mutation EditKycApiFirstActivity($arenaId: ID!, $kycDocumentVersionActivityId: ID!, $comment: String!) {
  apiFirstDiligenceOps {
    editActivity(
      arenaId: $arenaId
      kycDocumentVersionActivityId: $kycDocumentVersionActivityId
      comment: $comment
    ) {
      kycDocumentVersionActivity {
        comment
        id
        createdAt
        activityType
        owner {
          fullName
          id
        }
      }
    }
  }
}
    `;
export type EditKycApiFirstActivityMutationFn = Apollo.MutationFunction<GraphqlTypes.EditKycApiFirstActivityMutation, GraphqlTypes.EditKycApiFirstActivityMutationVariables>;

/**
 * __useEditKycApiFirstActivityMutation__
 *
 * To run a mutation, you first call `useEditKycApiFirstActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditKycApiFirstActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editKycApiFirstActivityMutation, { data, loading, error }] = useEditKycApiFirstActivityMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      kycDocumentVersionActivityId: // value for 'kycDocumentVersionActivityId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useEditKycApiFirstActivityMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditKycApiFirstActivityMutation, GraphqlTypes.EditKycApiFirstActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditKycApiFirstActivityMutation, GraphqlTypes.EditKycApiFirstActivityMutationVariables>(EditKycApiFirstActivityDocument, options);
      }
export type EditKycApiFirstActivityMutationHookResult = ReturnType<typeof useEditKycApiFirstActivityMutation>;
export type EditKycApiFirstActivityMutationResult = Apollo.MutationResult<GraphqlTypes.EditKycApiFirstActivityMutation>;
export type EditKycApiFirstActivityMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditKycApiFirstActivityMutation, GraphqlTypes.EditKycApiFirstActivityMutationVariables>;
export const DeleteKycApiFirstActivityDocument = gql`
    mutation DeleteKycApiFirstActivity($arenaId: ID!, $kycDocumentVersionActivityId: ID!) {
  apiFirstDiligenceOps {
    deleteActivity(
      arenaId: $arenaId
      kycDocumentVersionActivityId: $kycDocumentVersionActivityId
    ) {
      kycDocumentVersionActivity {
        comment
        id
        createdAt
        activityType
        owner {
          fullName
          id
        }
      }
    }
  }
}
    `;
export type DeleteKycApiFirstActivityMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteKycApiFirstActivityMutation, GraphqlTypes.DeleteKycApiFirstActivityMutationVariables>;

/**
 * __useDeleteKycApiFirstActivityMutation__
 *
 * To run a mutation, you first call `useDeleteKycApiFirstActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKycApiFirstActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKycApiFirstActivityMutation, { data, loading, error }] = useDeleteKycApiFirstActivityMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      kycDocumentVersionActivityId: // value for 'kycDocumentVersionActivityId'
 *   },
 * });
 */
export function useDeleteKycApiFirstActivityMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteKycApiFirstActivityMutation, GraphqlTypes.DeleteKycApiFirstActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteKycApiFirstActivityMutation, GraphqlTypes.DeleteKycApiFirstActivityMutationVariables>(DeleteKycApiFirstActivityDocument, options);
      }
export type DeleteKycApiFirstActivityMutationHookResult = ReturnType<typeof useDeleteKycApiFirstActivityMutation>;
export type DeleteKycApiFirstActivityMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteKycApiFirstActivityMutation>;
export type DeleteKycApiFirstActivityMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteKycApiFirstActivityMutation, GraphqlTypes.DeleteKycApiFirstActivityMutationVariables>;
export const GetKycApiFirstDocumentActivitiesDocument = gql`
    query GetKycApiFirstDocumentActivities($id: ID!, $arenaId: ID!) {
  apiFirstKycDocument(id: $id, arenaId: $arenaId) {
    id
    kycDocumentActivities {
      edges {
        node {
          id
          comment
          createdAt
          activityType
          owner {
            fullName
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetKycApiFirstDocumentActivitiesQuery__
 *
 * To run a query within a React component, call `useGetKycApiFirstDocumentActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKycApiFirstDocumentActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKycApiFirstDocumentActivitiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetKycApiFirstDocumentActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetKycApiFirstDocumentActivitiesQuery, GraphqlTypes.GetKycApiFirstDocumentActivitiesQueryVariables> & ({ variables: GraphqlTypes.GetKycApiFirstDocumentActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetKycApiFirstDocumentActivitiesQuery, GraphqlTypes.GetKycApiFirstDocumentActivitiesQueryVariables>(GetKycApiFirstDocumentActivitiesDocument, options);
      }
export function useGetKycApiFirstDocumentActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetKycApiFirstDocumentActivitiesQuery, GraphqlTypes.GetKycApiFirstDocumentActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetKycApiFirstDocumentActivitiesQuery, GraphqlTypes.GetKycApiFirstDocumentActivitiesQueryVariables>(GetKycApiFirstDocumentActivitiesDocument, options);
        }
// @ts-ignore
export function useGetKycApiFirstDocumentActivitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKycApiFirstDocumentActivitiesQuery, GraphqlTypes.GetKycApiFirstDocumentActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetKycApiFirstDocumentActivitiesQuery, GraphqlTypes.GetKycApiFirstDocumentActivitiesQueryVariables>;
export function useGetKycApiFirstDocumentActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKycApiFirstDocumentActivitiesQuery, GraphqlTypes.GetKycApiFirstDocumentActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetKycApiFirstDocumentActivitiesQuery | undefined, GraphqlTypes.GetKycApiFirstDocumentActivitiesQueryVariables>;
export function useGetKycApiFirstDocumentActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKycApiFirstDocumentActivitiesQuery, GraphqlTypes.GetKycApiFirstDocumentActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetKycApiFirstDocumentActivitiesQuery, GraphqlTypes.GetKycApiFirstDocumentActivitiesQueryVariables>(GetKycApiFirstDocumentActivitiesDocument, options);
        }
export type GetKycApiFirstDocumentActivitiesQueryHookResult = ReturnType<typeof useGetKycApiFirstDocumentActivitiesQuery>;
export type GetKycApiFirstDocumentActivitiesLazyQueryHookResult = ReturnType<typeof useGetKycApiFirstDocumentActivitiesLazyQuery>;
export type GetKycApiFirstDocumentActivitiesSuspenseQueryHookResult = ReturnType<typeof useGetKycApiFirstDocumentActivitiesSuspenseQuery>;
export type GetKycApiFirstDocumentActivitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetKycApiFirstDocumentActivitiesQuery, GraphqlTypes.GetKycApiFirstDocumentActivitiesQueryVariables>;
export const ApiFirstDiligenceDocument = gql`
    query ApiFirstDiligence($id: ID!, $arenaId: ID!) {
  currentUser {
    id
  }
  apiFirstKycDiligence(id: $id, arenaId: $arenaId) {
    name
    investorDiligenceSteps {
      entity
      individuals
      supplemental
      kba
    }
    kycDetails {
      edges {
        node {
          id
          externalReferenceKey
          kbaStatus
          info {
            firstName
            lastName
            name
            emailAddress
            taxId
            isPrimary
            isUsJurisdiction
            organizationJurisdiction
            dateOfOrganization
            dateOfBirth
            phoneNumber
            domicileAddress {
              streetAddress1
              streetAddress2
              city
              state
              country
              postalCode
            }
            address {
              streetAddress1
              streetAddress2
              city
              state
              country
              postalCode
            }
          }
        }
      }
    }
    kycDocuments {
      edges {
        node {
          id
          status
          externalReferenceKey
          arenaId
          label
          documentType
          kycDetailId
          currentKycDocumentVersion {
            name
            currentRequestKycDocumentVersionActivity {
              comment
              id
              createdAt
              activityType
              owner {
                fullName
                id
              }
            }
            id
            kycDocumentId
          }
        }
      }
    }
    id
    investorDiligenceType
    status
    arenaId
    otherInfo
    keyIndividuals {
      name
      emailAddress
      kycDetail {
        id
      }
      __typename
    }
  }
}
    `;

/**
 * __useApiFirstDiligenceQuery__
 *
 * To run a query within a React component, call `useApiFirstDiligenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiFirstDiligenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiFirstDiligenceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useApiFirstDiligenceQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ApiFirstDiligenceQuery, GraphqlTypes.ApiFirstDiligenceQueryVariables> & ({ variables: GraphqlTypes.ApiFirstDiligenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ApiFirstDiligenceQuery, GraphqlTypes.ApiFirstDiligenceQueryVariables>(ApiFirstDiligenceDocument, options);
      }
export function useApiFirstDiligenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ApiFirstDiligenceQuery, GraphqlTypes.ApiFirstDiligenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ApiFirstDiligenceQuery, GraphqlTypes.ApiFirstDiligenceQueryVariables>(ApiFirstDiligenceDocument, options);
        }
// @ts-ignore
export function useApiFirstDiligenceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ApiFirstDiligenceQuery, GraphqlTypes.ApiFirstDiligenceQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ApiFirstDiligenceQuery, GraphqlTypes.ApiFirstDiligenceQueryVariables>;
export function useApiFirstDiligenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ApiFirstDiligenceQuery, GraphqlTypes.ApiFirstDiligenceQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ApiFirstDiligenceQuery | undefined, GraphqlTypes.ApiFirstDiligenceQueryVariables>;
export function useApiFirstDiligenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ApiFirstDiligenceQuery, GraphqlTypes.ApiFirstDiligenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ApiFirstDiligenceQuery, GraphqlTypes.ApiFirstDiligenceQueryVariables>(ApiFirstDiligenceDocument, options);
        }
export type ApiFirstDiligenceQueryHookResult = ReturnType<typeof useApiFirstDiligenceQuery>;
export type ApiFirstDiligenceLazyQueryHookResult = ReturnType<typeof useApiFirstDiligenceLazyQuery>;
export type ApiFirstDiligenceSuspenseQueryHookResult = ReturnType<typeof useApiFirstDiligenceSuspenseQuery>;
export type ApiFirstDiligenceQueryResult = Apollo.QueryResult<GraphqlTypes.ApiFirstDiligenceQuery, GraphqlTypes.ApiFirstDiligenceQueryVariables>;
export const ApiFirstDiligenceManualDocument = gql`
    query ApiFirstDiligenceManual($id: ID!, $arenaId: ID!) {
  currentUser {
    id
  }
  apiFirstDiligence(id: $id, arenaId: $arenaId) {
    id
    investorDiligenceType
    name
    status
    arenaId
    arenaName
    objectType
    otherInfo
  }
}
    `;

/**
 * __useApiFirstDiligenceManualQuery__
 *
 * To run a query within a React component, call `useApiFirstDiligenceManualQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiFirstDiligenceManualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiFirstDiligenceManualQuery({
 *   variables: {
 *      id: // value for 'id'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useApiFirstDiligenceManualQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ApiFirstDiligenceManualQuery, GraphqlTypes.ApiFirstDiligenceManualQueryVariables> & ({ variables: GraphqlTypes.ApiFirstDiligenceManualQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ApiFirstDiligenceManualQuery, GraphqlTypes.ApiFirstDiligenceManualQueryVariables>(ApiFirstDiligenceManualDocument, options);
      }
export function useApiFirstDiligenceManualLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ApiFirstDiligenceManualQuery, GraphqlTypes.ApiFirstDiligenceManualQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ApiFirstDiligenceManualQuery, GraphqlTypes.ApiFirstDiligenceManualQueryVariables>(ApiFirstDiligenceManualDocument, options);
        }
// @ts-ignore
export function useApiFirstDiligenceManualSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ApiFirstDiligenceManualQuery, GraphqlTypes.ApiFirstDiligenceManualQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ApiFirstDiligenceManualQuery, GraphqlTypes.ApiFirstDiligenceManualQueryVariables>;
export function useApiFirstDiligenceManualSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ApiFirstDiligenceManualQuery, GraphqlTypes.ApiFirstDiligenceManualQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ApiFirstDiligenceManualQuery | undefined, GraphqlTypes.ApiFirstDiligenceManualQueryVariables>;
export function useApiFirstDiligenceManualSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ApiFirstDiligenceManualQuery, GraphqlTypes.ApiFirstDiligenceManualQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ApiFirstDiligenceManualQuery, GraphqlTypes.ApiFirstDiligenceManualQueryVariables>(ApiFirstDiligenceManualDocument, options);
        }
export type ApiFirstDiligenceManualQueryHookResult = ReturnType<typeof useApiFirstDiligenceManualQuery>;
export type ApiFirstDiligenceManualLazyQueryHookResult = ReturnType<typeof useApiFirstDiligenceManualLazyQuery>;
export type ApiFirstDiligenceManualSuspenseQueryHookResult = ReturnType<typeof useApiFirstDiligenceManualSuspenseQuery>;
export type ApiFirstDiligenceManualQueryResult = Apollo.QueryResult<GraphqlTypes.ApiFirstDiligenceManualQuery, GraphqlTypes.ApiFirstDiligenceManualQueryVariables>;
export const GetApiFirstDiligencesDocument = gql`
    query GetApiFirstDiligences {
  apiFirstDiligences {
    edges {
      node {
        id
        name
        investorDiligenceType
        status
        arenaId
        arenaName
        dateSubmitted
        objectType
        reviewer {
          fullName
          emailAddress
        }
        peerReviewer {
          fullName
          emailAddress
        }
      }
    }
  }
}
    `;

/**
 * __useGetApiFirstDiligencesQuery__
 *
 * To run a query within a React component, call `useGetApiFirstDiligencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiFirstDiligencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiFirstDiligencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApiFirstDiligencesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetApiFirstDiligencesQuery, GraphqlTypes.GetApiFirstDiligencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetApiFirstDiligencesQuery, GraphqlTypes.GetApiFirstDiligencesQueryVariables>(GetApiFirstDiligencesDocument, options);
      }
export function useGetApiFirstDiligencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetApiFirstDiligencesQuery, GraphqlTypes.GetApiFirstDiligencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetApiFirstDiligencesQuery, GraphqlTypes.GetApiFirstDiligencesQueryVariables>(GetApiFirstDiligencesDocument, options);
        }
// @ts-ignore
export function useGetApiFirstDiligencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetApiFirstDiligencesQuery, GraphqlTypes.GetApiFirstDiligencesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetApiFirstDiligencesQuery, GraphqlTypes.GetApiFirstDiligencesQueryVariables>;
export function useGetApiFirstDiligencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetApiFirstDiligencesQuery, GraphqlTypes.GetApiFirstDiligencesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetApiFirstDiligencesQuery | undefined, GraphqlTypes.GetApiFirstDiligencesQueryVariables>;
export function useGetApiFirstDiligencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetApiFirstDiligencesQuery, GraphqlTypes.GetApiFirstDiligencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetApiFirstDiligencesQuery, GraphqlTypes.GetApiFirstDiligencesQueryVariables>(GetApiFirstDiligencesDocument, options);
        }
export type GetApiFirstDiligencesQueryHookResult = ReturnType<typeof useGetApiFirstDiligencesQuery>;
export type GetApiFirstDiligencesLazyQueryHookResult = ReturnType<typeof useGetApiFirstDiligencesLazyQuery>;
export type GetApiFirstDiligencesSuspenseQueryHookResult = ReturnType<typeof useGetApiFirstDiligencesSuspenseQuery>;
export type GetApiFirstDiligencesQueryResult = Apollo.QueryResult<GraphqlTypes.GetApiFirstDiligencesQuery, GraphqlTypes.GetApiFirstDiligencesQueryVariables>;
export const InvestorDiligenceWatchlistQueryDocument = gql`
    query InvestorDiligenceWatchlistQuery($id: ID!, $arenaId: ID!) {
  currentUser {
    id
  }
  investorDiligence(id: $id, arenaId: $arenaId) {
    kycDetails {
      edges {
        node {
          id
          externalReferenceKey
          kbaStatus
        }
      }
    }
    id
    investorDiligenceType
    status
    arenaId
    investorData {
      ...AccountWatchlistInvestorDataFields
      ...IndividualInvestorDataFragment
      ...PartnershipInvestorDataFragment
      ...TrustInvestorDataFragment
      __typename
    }
    keyIndividuals {
      ...KeyIndividualFields
    }
    paymentBanks {
      ...PaymentBankFields
    }
    keyInstitutions {
      ...KeyInstitutionFields
    }
    investorDiligenceObject {
      __typename
      ...SubscriptionInvestorDiligenceObjectFields
      ...AccountObjectFields
    }
  }
}
    ${AccountWatchlistInvestorDataFieldsFragmentDoc}
${IndividualInvestorDataFragmentFragmentDoc}
${PartnershipInvestorDataFragmentFragmentDoc}
${TrustInvestorDataFragmentFragmentDoc}
${KeyIndividualFieldsFragmentDoc}
${PaymentBankFieldsFragmentDoc}
${KeyInstitutionFieldsFragmentDoc}
${SubscriptionInvestorDiligenceObjectFieldsFragmentDoc}
${AccountObjectFieldsFragmentDoc}`;

/**
 * __useInvestorDiligenceWatchlistQueryQuery__
 *
 * To run a query within a React component, call `useInvestorDiligenceWatchlistQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorDiligenceWatchlistQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorDiligenceWatchlistQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useInvestorDiligenceWatchlistQueryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.InvestorDiligenceWatchlistQueryQuery, GraphqlTypes.InvestorDiligenceWatchlistQueryQueryVariables> & ({ variables: GraphqlTypes.InvestorDiligenceWatchlistQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.InvestorDiligenceWatchlistQueryQuery, GraphqlTypes.InvestorDiligenceWatchlistQueryQueryVariables>(InvestorDiligenceWatchlistQueryDocument, options);
      }
export function useInvestorDiligenceWatchlistQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.InvestorDiligenceWatchlistQueryQuery, GraphqlTypes.InvestorDiligenceWatchlistQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.InvestorDiligenceWatchlistQueryQuery, GraphqlTypes.InvestorDiligenceWatchlistQueryQueryVariables>(InvestorDiligenceWatchlistQueryDocument, options);
        }
// @ts-ignore
export function useInvestorDiligenceWatchlistQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.InvestorDiligenceWatchlistQueryQuery, GraphqlTypes.InvestorDiligenceWatchlistQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.InvestorDiligenceWatchlistQueryQuery, GraphqlTypes.InvestorDiligenceWatchlistQueryQueryVariables>;
export function useInvestorDiligenceWatchlistQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.InvestorDiligenceWatchlistQueryQuery, GraphqlTypes.InvestorDiligenceWatchlistQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.InvestorDiligenceWatchlistQueryQuery | undefined, GraphqlTypes.InvestorDiligenceWatchlistQueryQueryVariables>;
export function useInvestorDiligenceWatchlistQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.InvestorDiligenceWatchlistQueryQuery, GraphqlTypes.InvestorDiligenceWatchlistQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.InvestorDiligenceWatchlistQueryQuery, GraphqlTypes.InvestorDiligenceWatchlistQueryQueryVariables>(InvestorDiligenceWatchlistQueryDocument, options);
        }
export type InvestorDiligenceWatchlistQueryQueryHookResult = ReturnType<typeof useInvestorDiligenceWatchlistQueryQuery>;
export type InvestorDiligenceWatchlistQueryLazyQueryHookResult = ReturnType<typeof useInvestorDiligenceWatchlistQueryLazyQuery>;
export type InvestorDiligenceWatchlistQuerySuspenseQueryHookResult = ReturnType<typeof useInvestorDiligenceWatchlistQuerySuspenseQuery>;
export type InvestorDiligenceWatchlistQueryQueryResult = Apollo.QueryResult<GraphqlTypes.InvestorDiligenceWatchlistQueryQuery, GraphqlTypes.InvestorDiligenceWatchlistQueryQueryVariables>;
export const ApiFirstDiligenceWatchlistDocument = gql`
    query ApiFirstDiligenceWatchlist($id: ID!, $arenaId: ID!) {
  currentUser {
    id
  }
  apiFirstWatchlistDiligence(id: $id, arenaId: $arenaId) {
    id
    investorDiligenceType
    name
    status
    arenaId
    keyIndividuals {
      name
      emailAddress
      uuid
      alertId
      __typename
    }
    diligenceData {
      ...IndividualDiligenceDataFragment
      ...InstitutionDiligenceDataFragment
      __typename
    }
    paymentBanks {
      name
      isFincenSpecialMeasure
      country
    }
    keyInstitutions {
      uuid
      name
      alertId
    }
  }
}
    ${IndividualDiligenceDataFragmentFragmentDoc}
${InstitutionDiligenceDataFragmentFragmentDoc}`;

/**
 * __useApiFirstDiligenceWatchlistQuery__
 *
 * To run a query within a React component, call `useApiFirstDiligenceWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiFirstDiligenceWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiFirstDiligenceWatchlistQuery({
 *   variables: {
 *      id: // value for 'id'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useApiFirstDiligenceWatchlistQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ApiFirstDiligenceWatchlistQuery, GraphqlTypes.ApiFirstDiligenceWatchlistQueryVariables> & ({ variables: GraphqlTypes.ApiFirstDiligenceWatchlistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ApiFirstDiligenceWatchlistQuery, GraphqlTypes.ApiFirstDiligenceWatchlistQueryVariables>(ApiFirstDiligenceWatchlistDocument, options);
      }
export function useApiFirstDiligenceWatchlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ApiFirstDiligenceWatchlistQuery, GraphqlTypes.ApiFirstDiligenceWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ApiFirstDiligenceWatchlistQuery, GraphqlTypes.ApiFirstDiligenceWatchlistQueryVariables>(ApiFirstDiligenceWatchlistDocument, options);
        }
// @ts-ignore
export function useApiFirstDiligenceWatchlistSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ApiFirstDiligenceWatchlistQuery, GraphqlTypes.ApiFirstDiligenceWatchlistQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ApiFirstDiligenceWatchlistQuery, GraphqlTypes.ApiFirstDiligenceWatchlistQueryVariables>;
export function useApiFirstDiligenceWatchlistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ApiFirstDiligenceWatchlistQuery, GraphqlTypes.ApiFirstDiligenceWatchlistQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ApiFirstDiligenceWatchlistQuery | undefined, GraphqlTypes.ApiFirstDiligenceWatchlistQueryVariables>;
export function useApiFirstDiligenceWatchlistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ApiFirstDiligenceWatchlistQuery, GraphqlTypes.ApiFirstDiligenceWatchlistQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ApiFirstDiligenceWatchlistQuery, GraphqlTypes.ApiFirstDiligenceWatchlistQueryVariables>(ApiFirstDiligenceWatchlistDocument, options);
        }
export type ApiFirstDiligenceWatchlistQueryHookResult = ReturnType<typeof useApiFirstDiligenceWatchlistQuery>;
export type ApiFirstDiligenceWatchlistLazyQueryHookResult = ReturnType<typeof useApiFirstDiligenceWatchlistLazyQuery>;
export type ApiFirstDiligenceWatchlistSuspenseQueryHookResult = ReturnType<typeof useApiFirstDiligenceWatchlistSuspenseQuery>;
export type ApiFirstDiligenceWatchlistQueryResult = Apollo.QueryResult<GraphqlTypes.ApiFirstDiligenceWatchlistQuery, GraphqlTypes.ApiFirstDiligenceWatchlistQueryVariables>;
export const AcceptOrRejectInvestorDiligenceDocument = gql`
    mutation AcceptOrRejectInvestorDiligence($arenaId: ID!, $investorDiligenceId: ID!, $isAccept: Boolean!) {
  investorDiligenceOps {
    acceptOrRejectInvestorDiligence(
      arenaId: $arenaId
      investorDiligenceId: $investorDiligenceId
      isAccept: $isAccept
    ) {
      investorDiligence {
        id
      }
    }
  }
}
    `;
export type AcceptOrRejectInvestorDiligenceMutationFn = Apollo.MutationFunction<GraphqlTypes.AcceptOrRejectInvestorDiligenceMutation, GraphqlTypes.AcceptOrRejectInvestorDiligenceMutationVariables>;

/**
 * __useAcceptOrRejectInvestorDiligenceMutation__
 *
 * To run a mutation, you first call `useAcceptOrRejectInvestorDiligenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOrRejectInvestorDiligenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOrRejectInvestorDiligenceMutation, { data, loading, error }] = useAcceptOrRejectInvestorDiligenceMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      investorDiligenceId: // value for 'investorDiligenceId'
 *      isAccept: // value for 'isAccept'
 *   },
 * });
 */
export function useAcceptOrRejectInvestorDiligenceMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AcceptOrRejectInvestorDiligenceMutation, GraphqlTypes.AcceptOrRejectInvestorDiligenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AcceptOrRejectInvestorDiligenceMutation, GraphqlTypes.AcceptOrRejectInvestorDiligenceMutationVariables>(AcceptOrRejectInvestorDiligenceDocument, options);
      }
export type AcceptOrRejectInvestorDiligenceMutationHookResult = ReturnType<typeof useAcceptOrRejectInvestorDiligenceMutation>;
export type AcceptOrRejectInvestorDiligenceMutationResult = Apollo.MutationResult<GraphqlTypes.AcceptOrRejectInvestorDiligenceMutation>;
export type AcceptOrRejectInvestorDiligenceMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AcceptOrRejectInvestorDiligenceMutation, GraphqlTypes.AcceptOrRejectInvestorDiligenceMutationVariables>;
export const TransitionApiFirstDiligenceToStatusDocument = gql`
    mutation TransitionApiFirstDiligenceToStatus($arenaId: ID!, $diligenceId: ID!, $statuses: [InvestorDiligenceStatus!]!) {
  apiFirstDiligenceOps {
    transitionDiligenceToStatus(
      arenaId: $arenaId
      diligenceId: $diligenceId
      statuses: $statuses
    ) {
      diligence {
        id
      }
    }
  }
}
    `;
export type TransitionApiFirstDiligenceToStatusMutationFn = Apollo.MutationFunction<GraphqlTypes.TransitionApiFirstDiligenceToStatusMutation, GraphqlTypes.TransitionApiFirstDiligenceToStatusMutationVariables>;

/**
 * __useTransitionApiFirstDiligenceToStatusMutation__
 *
 * To run a mutation, you first call `useTransitionApiFirstDiligenceToStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionApiFirstDiligenceToStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionApiFirstDiligenceToStatusMutation, { data, loading, error }] = useTransitionApiFirstDiligenceToStatusMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      diligenceId: // value for 'diligenceId'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useTransitionApiFirstDiligenceToStatusMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.TransitionApiFirstDiligenceToStatusMutation, GraphqlTypes.TransitionApiFirstDiligenceToStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.TransitionApiFirstDiligenceToStatusMutation, GraphqlTypes.TransitionApiFirstDiligenceToStatusMutationVariables>(TransitionApiFirstDiligenceToStatusDocument, options);
      }
export type TransitionApiFirstDiligenceToStatusMutationHookResult = ReturnType<typeof useTransitionApiFirstDiligenceToStatusMutation>;
export type TransitionApiFirstDiligenceToStatusMutationResult = Apollo.MutationResult<GraphqlTypes.TransitionApiFirstDiligenceToStatusMutation>;
export type TransitionApiFirstDiligenceToStatusMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.TransitionApiFirstDiligenceToStatusMutation, GraphqlTypes.TransitionApiFirstDiligenceToStatusMutationVariables>;
export const CurrentStaffUserDocument = gql`
    query CurrentStaffUser {
  currentUser {
    id
    fullName
  }
}
    `;

/**
 * __useCurrentStaffUserQuery__
 *
 * To run a query within a React component, call `useCurrentStaffUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentStaffUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentStaffUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentStaffUserQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.CurrentStaffUserQuery, GraphqlTypes.CurrentStaffUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CurrentStaffUserQuery, GraphqlTypes.CurrentStaffUserQueryVariables>(CurrentStaffUserDocument, options);
      }
export function useCurrentStaffUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CurrentStaffUserQuery, GraphqlTypes.CurrentStaffUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CurrentStaffUserQuery, GraphqlTypes.CurrentStaffUserQueryVariables>(CurrentStaffUserDocument, options);
        }
// @ts-ignore
export function useCurrentStaffUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrentStaffUserQuery, GraphqlTypes.CurrentStaffUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CurrentStaffUserQuery, GraphqlTypes.CurrentStaffUserQueryVariables>;
export function useCurrentStaffUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrentStaffUserQuery, GraphqlTypes.CurrentStaffUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CurrentStaffUserQuery | undefined, GraphqlTypes.CurrentStaffUserQueryVariables>;
export function useCurrentStaffUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrentStaffUserQuery, GraphqlTypes.CurrentStaffUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CurrentStaffUserQuery, GraphqlTypes.CurrentStaffUserQueryVariables>(CurrentStaffUserDocument, options);
        }
export type CurrentStaffUserQueryHookResult = ReturnType<typeof useCurrentStaffUserQuery>;
export type CurrentStaffUserLazyQueryHookResult = ReturnType<typeof useCurrentStaffUserLazyQuery>;
export type CurrentStaffUserSuspenseQueryHookResult = ReturnType<typeof useCurrentStaffUserSuspenseQuery>;
export type CurrentStaffUserQueryResult = Apollo.QueryResult<GraphqlTypes.CurrentStaffUserQuery, GraphqlTypes.CurrentStaffUserQueryVariables>;
export const InvestorDiligencePermissionsDocument = gql`
    query InvestorDiligencePermissions($id: ID!, $arenaId: ID!) {
  currentUser {
    id
    fullName
  }
  investorDiligence(id: $id, arenaId: $arenaId) {
    reviewerUserId
    peerReviewerUserId
  }
}
    `;

/**
 * __useInvestorDiligencePermissionsQuery__
 *
 * To run a query within a React component, call `useInvestorDiligencePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorDiligencePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorDiligencePermissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useInvestorDiligencePermissionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.InvestorDiligencePermissionsQuery, GraphqlTypes.InvestorDiligencePermissionsQueryVariables> & ({ variables: GraphqlTypes.InvestorDiligencePermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.InvestorDiligencePermissionsQuery, GraphqlTypes.InvestorDiligencePermissionsQueryVariables>(InvestorDiligencePermissionsDocument, options);
      }
export function useInvestorDiligencePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.InvestorDiligencePermissionsQuery, GraphqlTypes.InvestorDiligencePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.InvestorDiligencePermissionsQuery, GraphqlTypes.InvestorDiligencePermissionsQueryVariables>(InvestorDiligencePermissionsDocument, options);
        }
// @ts-ignore
export function useInvestorDiligencePermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.InvestorDiligencePermissionsQuery, GraphqlTypes.InvestorDiligencePermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.InvestorDiligencePermissionsQuery, GraphqlTypes.InvestorDiligencePermissionsQueryVariables>;
export function useInvestorDiligencePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.InvestorDiligencePermissionsQuery, GraphqlTypes.InvestorDiligencePermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.InvestorDiligencePermissionsQuery | undefined, GraphqlTypes.InvestorDiligencePermissionsQueryVariables>;
export function useInvestorDiligencePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.InvestorDiligencePermissionsQuery, GraphqlTypes.InvestorDiligencePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.InvestorDiligencePermissionsQuery, GraphqlTypes.InvestorDiligencePermissionsQueryVariables>(InvestorDiligencePermissionsDocument, options);
        }
export type InvestorDiligencePermissionsQueryHookResult = ReturnType<typeof useInvestorDiligencePermissionsQuery>;
export type InvestorDiligencePermissionsLazyQueryHookResult = ReturnType<typeof useInvestorDiligencePermissionsLazyQuery>;
export type InvestorDiligencePermissionsSuspenseQueryHookResult = ReturnType<typeof useInvestorDiligencePermissionsSuspenseQuery>;
export type InvestorDiligencePermissionsQueryResult = Apollo.QueryResult<GraphqlTypes.InvestorDiligencePermissionsQuery, GraphqlTypes.InvestorDiligencePermissionsQueryVariables>;
export const UpdateUserTwoFaDocument = gql`
    mutation UpdateUserTwoFa($objectInput: UpdateUserTwoFaInput!) {
  updateUserTwoFa(objectInput: $objectInput) {
    __typename
    ... on MutationSuccessResponse {
      didSucceed
    }
  }
}
    `;
export type UpdateUserTwoFaMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateUserTwoFaMutation, GraphqlTypes.UpdateUserTwoFaMutationVariables>;

/**
 * __useUpdateUserTwoFaMutation__
 *
 * To run a mutation, you first call `useUpdateUserTwoFaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTwoFaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTwoFaMutation, { data, loading, error }] = useUpdateUserTwoFaMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateUserTwoFaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateUserTwoFaMutation, GraphqlTypes.UpdateUserTwoFaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateUserTwoFaMutation, GraphqlTypes.UpdateUserTwoFaMutationVariables>(UpdateUserTwoFaDocument, options);
      }
export type UpdateUserTwoFaMutationHookResult = ReturnType<typeof useUpdateUserTwoFaMutation>;
export type UpdateUserTwoFaMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateUserTwoFaMutation>;
export type UpdateUserTwoFaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateUserTwoFaMutation, GraphqlTypes.UpdateUserTwoFaMutationVariables>;
export const UpdateStaffUserPasswordDocument = gql`
    mutation UpdateStaffUserPassword($objectInput: UpdateStaffUserPasswordInput!) {
  updateStaffUserPassword(objectInput: $objectInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on MutationSuccessResponse {
      didSucceed
    }
  }
}
    `;
export type UpdateStaffUserPasswordMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateStaffUserPasswordMutation, GraphqlTypes.UpdateStaffUserPasswordMutationVariables>;

/**
 * __useUpdateStaffUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateStaffUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStaffUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStaffUserPasswordMutation, { data, loading, error }] = useUpdateStaffUserPasswordMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateStaffUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateStaffUserPasswordMutation, GraphqlTypes.UpdateStaffUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateStaffUserPasswordMutation, GraphqlTypes.UpdateStaffUserPasswordMutationVariables>(UpdateStaffUserPasswordDocument, options);
      }
export type UpdateStaffUserPasswordMutationHookResult = ReturnType<typeof useUpdateStaffUserPasswordMutation>;
export type UpdateStaffUserPasswordMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateStaffUserPasswordMutation>;
export type UpdateStaffUserPasswordMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateStaffUserPasswordMutation, GraphqlTypes.UpdateStaffUserPasswordMutationVariables>;
export const GetStaffActivationDetailsDocument = gql`
    query GetStaffActivationDetails($code: String!) {
  staffActivationDetails(code: $code) {
    ...StaffActivationInvalidTokenFragment
    ...StaffActivationDetailsFragment
  }
}
    ${StaffActivationInvalidTokenFragmentFragmentDoc}
${StaffActivationDetailsFragmentFragmentDoc}`;

/**
 * __useGetStaffActivationDetailsQuery__
 *
 * To run a query within a React component, call `useGetStaffActivationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffActivationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffActivationDetailsQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetStaffActivationDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetStaffActivationDetailsQuery, GraphqlTypes.GetStaffActivationDetailsQueryVariables> & ({ variables: GraphqlTypes.GetStaffActivationDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetStaffActivationDetailsQuery, GraphqlTypes.GetStaffActivationDetailsQueryVariables>(GetStaffActivationDetailsDocument, options);
      }
export function useGetStaffActivationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetStaffActivationDetailsQuery, GraphqlTypes.GetStaffActivationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetStaffActivationDetailsQuery, GraphqlTypes.GetStaffActivationDetailsQueryVariables>(GetStaffActivationDetailsDocument, options);
        }
// @ts-ignore
export function useGetStaffActivationDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffActivationDetailsQuery, GraphqlTypes.GetStaffActivationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStaffActivationDetailsQuery, GraphqlTypes.GetStaffActivationDetailsQueryVariables>;
export function useGetStaffActivationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffActivationDetailsQuery, GraphqlTypes.GetStaffActivationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStaffActivationDetailsQuery | undefined, GraphqlTypes.GetStaffActivationDetailsQueryVariables>;
export function useGetStaffActivationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffActivationDetailsQuery, GraphqlTypes.GetStaffActivationDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetStaffActivationDetailsQuery, GraphqlTypes.GetStaffActivationDetailsQueryVariables>(GetStaffActivationDetailsDocument, options);
        }
export type GetStaffActivationDetailsQueryHookResult = ReturnType<typeof useGetStaffActivationDetailsQuery>;
export type GetStaffActivationDetailsLazyQueryHookResult = ReturnType<typeof useGetStaffActivationDetailsLazyQuery>;
export type GetStaffActivationDetailsSuspenseQueryHookResult = ReturnType<typeof useGetStaffActivationDetailsSuspenseQuery>;
export type GetStaffActivationDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetStaffActivationDetailsQuery, GraphqlTypes.GetStaffActivationDetailsQueryVariables>;
export const GetSsoStatusForLoginDocument = gql`
    query GetSsoStatusForLogin {
  unauthenticatedSsoconfig {
    providerType
    name
    status
  }
}
    `;

/**
 * __useGetSsoStatusForLoginQuery__
 *
 * To run a query within a React component, call `useGetSsoStatusForLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSsoStatusForLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSsoStatusForLoginQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSsoStatusForLoginQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetSsoStatusForLoginQuery, GraphqlTypes.GetSsoStatusForLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSsoStatusForLoginQuery, GraphqlTypes.GetSsoStatusForLoginQueryVariables>(GetSsoStatusForLoginDocument, options);
      }
export function useGetSsoStatusForLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSsoStatusForLoginQuery, GraphqlTypes.GetSsoStatusForLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSsoStatusForLoginQuery, GraphqlTypes.GetSsoStatusForLoginQueryVariables>(GetSsoStatusForLoginDocument, options);
        }
// @ts-ignore
export function useGetSsoStatusForLoginSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoStatusForLoginQuery, GraphqlTypes.GetSsoStatusForLoginQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSsoStatusForLoginQuery, GraphqlTypes.GetSsoStatusForLoginQueryVariables>;
export function useGetSsoStatusForLoginSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoStatusForLoginQuery, GraphqlTypes.GetSsoStatusForLoginQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSsoStatusForLoginQuery | undefined, GraphqlTypes.GetSsoStatusForLoginQueryVariables>;
export function useGetSsoStatusForLoginSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoStatusForLoginQuery, GraphqlTypes.GetSsoStatusForLoginQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSsoStatusForLoginQuery, GraphqlTypes.GetSsoStatusForLoginQueryVariables>(GetSsoStatusForLoginDocument, options);
        }
export type GetSsoStatusForLoginQueryHookResult = ReturnType<typeof useGetSsoStatusForLoginQuery>;
export type GetSsoStatusForLoginLazyQueryHookResult = ReturnType<typeof useGetSsoStatusForLoginLazyQuery>;
export type GetSsoStatusForLoginSuspenseQueryHookResult = ReturnType<typeof useGetSsoStatusForLoginSuspenseQuery>;
export type GetSsoStatusForLoginQueryResult = Apollo.QueryResult<GraphqlTypes.GetSsoStatusForLoginQuery, GraphqlTypes.GetSsoStatusForLoginQueryVariables>;
export const GetStatusPageIncidentsDocument = gql`
    query GetStatusPageIncidents {
  statusPageIncidents {
    statusPageUrl
    incidentIds
  }
}
    `;

/**
 * __useGetStatusPageIncidentsQuery__
 *
 * To run a query within a React component, call `useGetStatusPageIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusPageIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusPageIncidentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatusPageIncidentsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetStatusPageIncidentsQuery, GraphqlTypes.GetStatusPageIncidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetStatusPageIncidentsQuery, GraphqlTypes.GetStatusPageIncidentsQueryVariables>(GetStatusPageIncidentsDocument, options);
      }
export function useGetStatusPageIncidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetStatusPageIncidentsQuery, GraphqlTypes.GetStatusPageIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetStatusPageIncidentsQuery, GraphqlTypes.GetStatusPageIncidentsQueryVariables>(GetStatusPageIncidentsDocument, options);
        }
// @ts-ignore
export function useGetStatusPageIncidentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStatusPageIncidentsQuery, GraphqlTypes.GetStatusPageIncidentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStatusPageIncidentsQuery, GraphqlTypes.GetStatusPageIncidentsQueryVariables>;
export function useGetStatusPageIncidentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStatusPageIncidentsQuery, GraphqlTypes.GetStatusPageIncidentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStatusPageIncidentsQuery | undefined, GraphqlTypes.GetStatusPageIncidentsQueryVariables>;
export function useGetStatusPageIncidentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStatusPageIncidentsQuery, GraphqlTypes.GetStatusPageIncidentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetStatusPageIncidentsQuery, GraphqlTypes.GetStatusPageIncidentsQueryVariables>(GetStatusPageIncidentsDocument, options);
        }
export type GetStatusPageIncidentsQueryHookResult = ReturnType<typeof useGetStatusPageIncidentsQuery>;
export type GetStatusPageIncidentsLazyQueryHookResult = ReturnType<typeof useGetStatusPageIncidentsLazyQuery>;
export type GetStatusPageIncidentsSuspenseQueryHookResult = ReturnType<typeof useGetStatusPageIncidentsSuspenseQuery>;
export type GetStatusPageIncidentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetStatusPageIncidentsQuery, GraphqlTypes.GetStatusPageIncidentsQueryVariables>;
export const CreateStoredEmailDocument = gql`
    mutation CreateStoredEmail($sender: String!, $date: DateTime!, $subject: String!, $to: [String!]!, $cc: [String!]!, $bcc: [String!]!, $recipient: String!, $bodyHtml: String!, $bodyText: String!, $headers: String, $participants: [ID!], $unrecognizedEmails: [StoredEmailUnknownAddressInputObjectType!], $attachments: [OutlookAttachmentInputObjectType!]) {
  storedEmailOps {
    createStoredEmail(
      sender: $sender
      date: $date
      subject: $subject
      to: $to
      cc: $cc
      bcc: $bcc
      recipient: $recipient
      bodyHtml: $bodyHtml
      bodyText: $bodyText
      headers: $headers
      participants: $participants
      unrecognizedEmails: $unrecognizedEmails
      attachments: $attachments
    ) {
      response {
        ...StoredEmailResponse
      }
    }
  }
}
    ${StoredEmailResponseFragmentDoc}`;
export type CreateStoredEmailMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateStoredEmailMutation, GraphqlTypes.CreateStoredEmailMutationVariables>;

/**
 * __useCreateStoredEmailMutation__
 *
 * To run a mutation, you first call `useCreateStoredEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoredEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoredEmailMutation, { data, loading, error }] = useCreateStoredEmailMutation({
 *   variables: {
 *      sender: // value for 'sender'
 *      date: // value for 'date'
 *      subject: // value for 'subject'
 *      to: // value for 'to'
 *      cc: // value for 'cc'
 *      bcc: // value for 'bcc'
 *      recipient: // value for 'recipient'
 *      bodyHtml: // value for 'bodyHtml'
 *      bodyText: // value for 'bodyText'
 *      headers: // value for 'headers'
 *      participants: // value for 'participants'
 *      unrecognizedEmails: // value for 'unrecognizedEmails'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useCreateStoredEmailMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateStoredEmailMutation, GraphqlTypes.CreateStoredEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateStoredEmailMutation, GraphqlTypes.CreateStoredEmailMutationVariables>(CreateStoredEmailDocument, options);
      }
export type CreateStoredEmailMutationHookResult = ReturnType<typeof useCreateStoredEmailMutation>;
export type CreateStoredEmailMutationResult = Apollo.MutationResult<GraphqlTypes.CreateStoredEmailMutation>;
export type CreateStoredEmailMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateStoredEmailMutation, GraphqlTypes.CreateStoredEmailMutationVariables>;
export const UpdateStoredEmailParticipantsDocument = gql`
    mutation UpdateStoredEmailParticipants($storedEmailId: ID!, $participants: [ID!]) {
  storedEmailOps {
    updateStoredEmailParticipants(
      storedEmailId: $storedEmailId
      participants: $participants
    ) {
      storedEmail {
        id
      }
    }
  }
}
    `;
export type UpdateStoredEmailParticipantsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateStoredEmailParticipantsMutation, GraphqlTypes.UpdateStoredEmailParticipantsMutationVariables>;

/**
 * __useUpdateStoredEmailParticipantsMutation__
 *
 * To run a mutation, you first call `useUpdateStoredEmailParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoredEmailParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoredEmailParticipantsMutation, { data, loading, error }] = useUpdateStoredEmailParticipantsMutation({
 *   variables: {
 *      storedEmailId: // value for 'storedEmailId'
 *      participants: // value for 'participants'
 *   },
 * });
 */
export function useUpdateStoredEmailParticipantsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateStoredEmailParticipantsMutation, GraphqlTypes.UpdateStoredEmailParticipantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateStoredEmailParticipantsMutation, GraphqlTypes.UpdateStoredEmailParticipantsMutationVariables>(UpdateStoredEmailParticipantsDocument, options);
      }
export type UpdateStoredEmailParticipantsMutationHookResult = ReturnType<typeof useUpdateStoredEmailParticipantsMutation>;
export type UpdateStoredEmailParticipantsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateStoredEmailParticipantsMutation>;
export type UpdateStoredEmailParticipantsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateStoredEmailParticipantsMutation, GraphqlTypes.UpdateStoredEmailParticipantsMutationVariables>;
export const CreateOrUpdatePendingStoredEmailDocument = gql`
    mutation CreateOrUpdatePendingStoredEmail($pendingStoredEmailId: ID, $participants: [ID!]!, $unrecognizedEmails: [StoredEmailUnknownAddressInputObjectType!]) {
  storedEmailOps {
    createOrUpdatePendingStoredEmail(
      pendingStoredEmailId: $pendingStoredEmailId
      participants: $participants
      unrecognizedEmails: $unrecognizedEmails
    ) {
      pendingStoredEmail {
        id
      }
    }
  }
}
    `;
export type CreateOrUpdatePendingStoredEmailMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateOrUpdatePendingStoredEmailMutation, GraphqlTypes.CreateOrUpdatePendingStoredEmailMutationVariables>;

/**
 * __useCreateOrUpdatePendingStoredEmailMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdatePendingStoredEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdatePendingStoredEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdatePendingStoredEmailMutation, { data, loading, error }] = useCreateOrUpdatePendingStoredEmailMutation({
 *   variables: {
 *      pendingStoredEmailId: // value for 'pendingStoredEmailId'
 *      participants: // value for 'participants'
 *      unrecognizedEmails: // value for 'unrecognizedEmails'
 *   },
 * });
 */
export function useCreateOrUpdatePendingStoredEmailMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateOrUpdatePendingStoredEmailMutation, GraphqlTypes.CreateOrUpdatePendingStoredEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateOrUpdatePendingStoredEmailMutation, GraphqlTypes.CreateOrUpdatePendingStoredEmailMutationVariables>(CreateOrUpdatePendingStoredEmailDocument, options);
      }
export type CreateOrUpdatePendingStoredEmailMutationHookResult = ReturnType<typeof useCreateOrUpdatePendingStoredEmailMutation>;
export type CreateOrUpdatePendingStoredEmailMutationResult = Apollo.MutationResult<GraphqlTypes.CreateOrUpdatePendingStoredEmailMutation>;
export type CreateOrUpdatePendingStoredEmailMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateOrUpdatePendingStoredEmailMutation, GraphqlTypes.CreateOrUpdatePendingStoredEmailMutationVariables>;
export const CreateOrUpdateNoteDocument = gql`
    mutation CreateOrUpdateNote($noteInput: NoteInput!) {
  noteOps {
    createOrUpdateNote(noteInput: $noteInput) {
      ... on NoteObjectType {
        id
      }
      ... on MutationErrorResponse {
        message
      }
    }
  }
}
    `;
export type CreateOrUpdateNoteMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateOrUpdateNoteMutation, GraphqlTypes.CreateOrUpdateNoteMutationVariables>;

/**
 * __useCreateOrUpdateNoteMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateNoteMutation, { data, loading, error }] = useCreateOrUpdateNoteMutation({
 *   variables: {
 *      noteInput: // value for 'noteInput'
 *   },
 * });
 */
export function useCreateOrUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateOrUpdateNoteMutation, GraphqlTypes.CreateOrUpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateOrUpdateNoteMutation, GraphqlTypes.CreateOrUpdateNoteMutationVariables>(CreateOrUpdateNoteDocument, options);
      }
export type CreateOrUpdateNoteMutationHookResult = ReturnType<typeof useCreateOrUpdateNoteMutation>;
export type CreateOrUpdateNoteMutationResult = Apollo.MutationResult<GraphqlTypes.CreateOrUpdateNoteMutation>;
export type CreateOrUpdateNoteMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateOrUpdateNoteMutation, GraphqlTypes.CreateOrUpdateNoteMutationVariables>;
export const OutlookLogOutDocument = gql`
    mutation OutlookLogOut {
  authOps {
    outlookLogOut {
      success
    }
  }
}
    `;
export type OutlookLogOutMutationFn = Apollo.MutationFunction<GraphqlTypes.OutlookLogOutMutation, GraphqlTypes.OutlookLogOutMutationVariables>;

/**
 * __useOutlookLogOutMutation__
 *
 * To run a mutation, you first call `useOutlookLogOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOutlookLogOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [outlookLogOutMutation, { data, loading, error }] = useOutlookLogOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useOutlookLogOutMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.OutlookLogOutMutation, GraphqlTypes.OutlookLogOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.OutlookLogOutMutation, GraphqlTypes.OutlookLogOutMutationVariables>(OutlookLogOutDocument, options);
      }
export type OutlookLogOutMutationHookResult = ReturnType<typeof useOutlookLogOutMutation>;
export type OutlookLogOutMutationResult = Apollo.MutationResult<GraphqlTypes.OutlookLogOutMutation>;
export type OutlookLogOutMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.OutlookLogOutMutation, GraphqlTypes.OutlookLogOutMutationVariables>;
export const SetUserFlagsDocument = gql`
    mutation SetUserFlags($features: UserFeaturesInput!) {
  userFlagOps {
    setUserFlags(features: $features) {
      userFeatures {
        hasOutlookAutoLogging
      }
    }
  }
}
    `;
export type SetUserFlagsMutationFn = Apollo.MutationFunction<GraphqlTypes.SetUserFlagsMutation, GraphqlTypes.SetUserFlagsMutationVariables>;

/**
 * __useSetUserFlagsMutation__
 *
 * To run a mutation, you first call `useSetUserFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserFlagsMutation, { data, loading, error }] = useSetUserFlagsMutation({
 *   variables: {
 *      features: // value for 'features'
 *   },
 * });
 */
export function useSetUserFlagsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetUserFlagsMutation, GraphqlTypes.SetUserFlagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetUserFlagsMutation, GraphqlTypes.SetUserFlagsMutationVariables>(SetUserFlagsDocument, options);
      }
export type SetUserFlagsMutationHookResult = ReturnType<typeof useSetUserFlagsMutation>;
export type SetUserFlagsMutationResult = Apollo.MutationResult<GraphqlTypes.SetUserFlagsMutation>;
export type SetUserFlagsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetUserFlagsMutation, GraphqlTypes.SetUserFlagsMutationVariables>;
export const GetContactsByEmailDocument = gql`
    query GetContactsByEmail($emails: [String!]!, $thumbnailWidth: Int = 64, $thumbnailHeight: Int = 64) {
  contacts(emails: $emails) {
    edges {
      node {
        ...ContactFields
      }
    }
  }
}
    ${ContactFieldsFragmentDoc}`;

/**
 * __useGetContactsByEmailQuery__
 *
 * To run a query within a React component, call `useGetContactsByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsByEmailQuery({
 *   variables: {
 *      emails: // value for 'emails'
 *      thumbnailWidth: // value for 'thumbnailWidth'
 *      thumbnailHeight: // value for 'thumbnailHeight'
 *   },
 * });
 */
export function useGetContactsByEmailQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactsByEmailQuery, GraphqlTypes.GetContactsByEmailQueryVariables> & ({ variables: GraphqlTypes.GetContactsByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactsByEmailQuery, GraphqlTypes.GetContactsByEmailQueryVariables>(GetContactsByEmailDocument, options);
      }
export function useGetContactsByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactsByEmailQuery, GraphqlTypes.GetContactsByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactsByEmailQuery, GraphqlTypes.GetContactsByEmailQueryVariables>(GetContactsByEmailDocument, options);
        }
// @ts-ignore
export function useGetContactsByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsByEmailQuery, GraphqlTypes.GetContactsByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsByEmailQuery, GraphqlTypes.GetContactsByEmailQueryVariables>;
export function useGetContactsByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsByEmailQuery, GraphqlTypes.GetContactsByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsByEmailQuery | undefined, GraphqlTypes.GetContactsByEmailQueryVariables>;
export function useGetContactsByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsByEmailQuery, GraphqlTypes.GetContactsByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactsByEmailQuery, GraphqlTypes.GetContactsByEmailQueryVariables>(GetContactsByEmailDocument, options);
        }
export type GetContactsByEmailQueryHookResult = ReturnType<typeof useGetContactsByEmailQuery>;
export type GetContactsByEmailLazyQueryHookResult = ReturnType<typeof useGetContactsByEmailLazyQuery>;
export type GetContactsByEmailSuspenseQueryHookResult = ReturnType<typeof useGetContactsByEmailSuspenseQuery>;
export type GetContactsByEmailQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactsByEmailQuery, GraphqlTypes.GetContactsByEmailQueryVariables>;
export const GetEmailRecipientsInfoDocument = gql`
    query GetEmailRecipientsInfo($emails: [String!]!, $thumbnailWidth: Int = 64, $thumbnailHeight: Int = 64) {
  emailRecipientsInfo(emails: $emails) {
    contacts {
      ...ContactFields
    }
    unrecognizedEmails
  }
}
    ${ContactFieldsFragmentDoc}`;

/**
 * __useGetEmailRecipientsInfoQuery__
 *
 * To run a query within a React component, call `useGetEmailRecipientsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailRecipientsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailRecipientsInfoQuery({
 *   variables: {
 *      emails: // value for 'emails'
 *      thumbnailWidth: // value for 'thumbnailWidth'
 *      thumbnailHeight: // value for 'thumbnailHeight'
 *   },
 * });
 */
export function useGetEmailRecipientsInfoQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEmailRecipientsInfoQuery, GraphqlTypes.GetEmailRecipientsInfoQueryVariables> & ({ variables: GraphqlTypes.GetEmailRecipientsInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEmailRecipientsInfoQuery, GraphqlTypes.GetEmailRecipientsInfoQueryVariables>(GetEmailRecipientsInfoDocument, options);
      }
export function useGetEmailRecipientsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEmailRecipientsInfoQuery, GraphqlTypes.GetEmailRecipientsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEmailRecipientsInfoQuery, GraphqlTypes.GetEmailRecipientsInfoQueryVariables>(GetEmailRecipientsInfoDocument, options);
        }
// @ts-ignore
export function useGetEmailRecipientsInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailRecipientsInfoQuery, GraphqlTypes.GetEmailRecipientsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailRecipientsInfoQuery, GraphqlTypes.GetEmailRecipientsInfoQueryVariables>;
export function useGetEmailRecipientsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailRecipientsInfoQuery, GraphqlTypes.GetEmailRecipientsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailRecipientsInfoQuery | undefined, GraphqlTypes.GetEmailRecipientsInfoQueryVariables>;
export function useGetEmailRecipientsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailRecipientsInfoQuery, GraphqlTypes.GetEmailRecipientsInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEmailRecipientsInfoQuery, GraphqlTypes.GetEmailRecipientsInfoQueryVariables>(GetEmailRecipientsInfoDocument, options);
        }
export type GetEmailRecipientsInfoQueryHookResult = ReturnType<typeof useGetEmailRecipientsInfoQuery>;
export type GetEmailRecipientsInfoLazyQueryHookResult = ReturnType<typeof useGetEmailRecipientsInfoLazyQuery>;
export type GetEmailRecipientsInfoSuspenseQueryHookResult = ReturnType<typeof useGetEmailRecipientsInfoSuspenseQuery>;
export type GetEmailRecipientsInfoQueryResult = Apollo.QueryResult<GraphqlTypes.GetEmailRecipientsInfoQuery, GraphqlTypes.GetEmailRecipientsInfoQueryVariables>;
export const GetContactDocument = gql`
    query GetContact($id: ID!, $thumbnailWidth: Int = 64, $thumbnailHeight: Int = 64) {
  contact(id: $id) {
    ...ContactFields
  }
}
    ${ContactFieldsFragmentDoc}`;

/**
 * __useGetContactQuery__
 *
 * To run a query within a React component, call `useGetContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *      thumbnailWidth: // value for 'thumbnailWidth'
 *      thumbnailHeight: // value for 'thumbnailHeight'
 *   },
 * });
 */
export function useGetContactQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactQuery, GraphqlTypes.GetContactQueryVariables> & ({ variables: GraphqlTypes.GetContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactQuery, GraphqlTypes.GetContactQueryVariables>(GetContactDocument, options);
      }
export function useGetContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactQuery, GraphqlTypes.GetContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactQuery, GraphqlTypes.GetContactQueryVariables>(GetContactDocument, options);
        }
// @ts-ignore
export function useGetContactSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactQuery, GraphqlTypes.GetContactQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactQuery, GraphqlTypes.GetContactQueryVariables>;
export function useGetContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactQuery, GraphqlTypes.GetContactQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactQuery | undefined, GraphqlTypes.GetContactQueryVariables>;
export function useGetContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactQuery, GraphqlTypes.GetContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactQuery, GraphqlTypes.GetContactQueryVariables>(GetContactDocument, options);
        }
export type GetContactQueryHookResult = ReturnType<typeof useGetContactQuery>;
export type GetContactLazyQueryHookResult = ReturnType<typeof useGetContactLazyQuery>;
export type GetContactSuspenseQueryHookResult = ReturnType<typeof useGetContactSuspenseQuery>;
export type GetContactQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactQuery, GraphqlTypes.GetContactQueryVariables>;
export const GetContactDetailsDocument = gql`
    query GetContactDetails($id: ID!, $thumbnailWidth: Int = 64, $thumbnailHeight: Int = 64) {
  contact(id: $id) {
    ...PersonContactDetails
  }
}
    ${PersonContactDetailsFragmentDoc}`;

/**
 * __useGetContactDetailsQuery__
 *
 * To run a query within a React component, call `useGetContactDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      thumbnailWidth: // value for 'thumbnailWidth'
 *      thumbnailHeight: // value for 'thumbnailHeight'
 *   },
 * });
 */
export function useGetContactDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactDetailsQuery, GraphqlTypes.GetContactDetailsQueryVariables> & ({ variables: GraphqlTypes.GetContactDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactDetailsQuery, GraphqlTypes.GetContactDetailsQueryVariables>(GetContactDetailsDocument, options);
      }
export function useGetContactDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactDetailsQuery, GraphqlTypes.GetContactDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactDetailsQuery, GraphqlTypes.GetContactDetailsQueryVariables>(GetContactDetailsDocument, options);
        }
// @ts-ignore
export function useGetContactDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactDetailsQuery, GraphqlTypes.GetContactDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactDetailsQuery, GraphqlTypes.GetContactDetailsQueryVariables>;
export function useGetContactDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactDetailsQuery, GraphqlTypes.GetContactDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactDetailsQuery | undefined, GraphqlTypes.GetContactDetailsQueryVariables>;
export function useGetContactDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactDetailsQuery, GraphqlTypes.GetContactDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactDetailsQuery, GraphqlTypes.GetContactDetailsQueryVariables>(GetContactDetailsDocument, options);
        }
export type GetContactDetailsQueryHookResult = ReturnType<typeof useGetContactDetailsQuery>;
export type GetContactDetailsLazyQueryHookResult = ReturnType<typeof useGetContactDetailsLazyQuery>;
export type GetContactDetailsSuspenseQueryHookResult = ReturnType<typeof useGetContactDetailsSuspenseQuery>;
export type GetContactDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactDetailsQuery, GraphqlTypes.GetContactDetailsQueryVariables>;
export const GetOutlookPermissionsDocument = gql`
    query GetOutlookPermissions {
  userPermissions {
    canManageOffering
    canViewEntityGroups
    canManageContact
  }
}
    `;

/**
 * __useGetOutlookPermissionsQuery__
 *
 * To run a query within a React component, call `useGetOutlookPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutlookPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutlookPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOutlookPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetOutlookPermissionsQuery, GraphqlTypes.GetOutlookPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOutlookPermissionsQuery, GraphqlTypes.GetOutlookPermissionsQueryVariables>(GetOutlookPermissionsDocument, options);
      }
export function useGetOutlookPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOutlookPermissionsQuery, GraphqlTypes.GetOutlookPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOutlookPermissionsQuery, GraphqlTypes.GetOutlookPermissionsQueryVariables>(GetOutlookPermissionsDocument, options);
        }
// @ts-ignore
export function useGetOutlookPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOutlookPermissionsQuery, GraphqlTypes.GetOutlookPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOutlookPermissionsQuery, GraphqlTypes.GetOutlookPermissionsQueryVariables>;
export function useGetOutlookPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOutlookPermissionsQuery, GraphqlTypes.GetOutlookPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOutlookPermissionsQuery | undefined, GraphqlTypes.GetOutlookPermissionsQueryVariables>;
export function useGetOutlookPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOutlookPermissionsQuery, GraphqlTypes.GetOutlookPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOutlookPermissionsQuery, GraphqlTypes.GetOutlookPermissionsQueryVariables>(GetOutlookPermissionsDocument, options);
        }
export type GetOutlookPermissionsQueryHookResult = ReturnType<typeof useGetOutlookPermissionsQuery>;
export type GetOutlookPermissionsLazyQueryHookResult = ReturnType<typeof useGetOutlookPermissionsLazyQuery>;
export type GetOutlookPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetOutlookPermissionsSuspenseQuery>;
export type GetOutlookPermissionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetOutlookPermissionsQuery, GraphqlTypes.GetOutlookPermissionsQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    id
    emailAddress
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentUserQuery | undefined, GraphqlTypes.GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>;
export const GetArenaSupportInfoDocument = gql`
    query GetArenaSupportInfo {
  currentArena {
    id
    supportPhone
    supportEmail
    secondLevelDomain
  }
}
    `;

/**
 * __useGetArenaSupportInfoQuery__
 *
 * To run a query within a React component, call `useGetArenaSupportInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaSupportInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaSupportInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetArenaSupportInfoQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetArenaSupportInfoQuery, GraphqlTypes.GetArenaSupportInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaSupportInfoQuery, GraphqlTypes.GetArenaSupportInfoQueryVariables>(GetArenaSupportInfoDocument, options);
      }
export function useGetArenaSupportInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaSupportInfoQuery, GraphqlTypes.GetArenaSupportInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaSupportInfoQuery, GraphqlTypes.GetArenaSupportInfoQueryVariables>(GetArenaSupportInfoDocument, options);
        }
// @ts-ignore
export function useGetArenaSupportInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaSupportInfoQuery, GraphqlTypes.GetArenaSupportInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaSupportInfoQuery, GraphqlTypes.GetArenaSupportInfoQueryVariables>;
export function useGetArenaSupportInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaSupportInfoQuery, GraphqlTypes.GetArenaSupportInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaSupportInfoQuery | undefined, GraphqlTypes.GetArenaSupportInfoQueryVariables>;
export function useGetArenaSupportInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaSupportInfoQuery, GraphqlTypes.GetArenaSupportInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaSupportInfoQuery, GraphqlTypes.GetArenaSupportInfoQueryVariables>(GetArenaSupportInfoDocument, options);
        }
export type GetArenaSupportInfoQueryHookResult = ReturnType<typeof useGetArenaSupportInfoQuery>;
export type GetArenaSupportInfoLazyQueryHookResult = ReturnType<typeof useGetArenaSupportInfoLazyQuery>;
export type GetArenaSupportInfoSuspenseQueryHookResult = ReturnType<typeof useGetArenaSupportInfoSuspenseQuery>;
export type GetArenaSupportInfoQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaSupportInfoQuery, GraphqlTypes.GetArenaSupportInfoQueryVariables>;
export const GetMetadataForPendingEmailDocument = gql`
    query GetMetadataForPendingEmail($id: ID!) {
  pendingStoredEmail(id: $id) {
    contacts {
      ...ContactTypeaheadFields
      company {
        ...ContactTypeaheadFields
      }
    }
    entities {
      ...AccountFields
    }
    offerings {
      ...OfferingFields
    }
    unrecognizedEmails {
      emailAddress
    }
  }
}
    ${ContactTypeaheadFieldsFragmentDoc}
${AccountFieldsFragmentDoc}
${OfferingFieldsFragmentDoc}`;

/**
 * __useGetMetadataForPendingEmailQuery__
 *
 * To run a query within a React component, call `useGetMetadataForPendingEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetadataForPendingEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetadataForPendingEmailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMetadataForPendingEmailQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetMetadataForPendingEmailQuery, GraphqlTypes.GetMetadataForPendingEmailQueryVariables> & ({ variables: GraphqlTypes.GetMetadataForPendingEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetMetadataForPendingEmailQuery, GraphqlTypes.GetMetadataForPendingEmailQueryVariables>(GetMetadataForPendingEmailDocument, options);
      }
export function useGetMetadataForPendingEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetMetadataForPendingEmailQuery, GraphqlTypes.GetMetadataForPendingEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetMetadataForPendingEmailQuery, GraphqlTypes.GetMetadataForPendingEmailQueryVariables>(GetMetadataForPendingEmailDocument, options);
        }
// @ts-ignore
export function useGetMetadataForPendingEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMetadataForPendingEmailQuery, GraphqlTypes.GetMetadataForPendingEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetMetadataForPendingEmailQuery, GraphqlTypes.GetMetadataForPendingEmailQueryVariables>;
export function useGetMetadataForPendingEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMetadataForPendingEmailQuery, GraphqlTypes.GetMetadataForPendingEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetMetadataForPendingEmailQuery | undefined, GraphqlTypes.GetMetadataForPendingEmailQueryVariables>;
export function useGetMetadataForPendingEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMetadataForPendingEmailQuery, GraphqlTypes.GetMetadataForPendingEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetMetadataForPendingEmailQuery, GraphqlTypes.GetMetadataForPendingEmailQueryVariables>(GetMetadataForPendingEmailDocument, options);
        }
export type GetMetadataForPendingEmailQueryHookResult = ReturnType<typeof useGetMetadataForPendingEmailQuery>;
export type GetMetadataForPendingEmailLazyQueryHookResult = ReturnType<typeof useGetMetadataForPendingEmailLazyQuery>;
export type GetMetadataForPendingEmailSuspenseQueryHookResult = ReturnType<typeof useGetMetadataForPendingEmailSuspenseQuery>;
export type GetMetadataForPendingEmailQueryResult = Apollo.QueryResult<GraphqlTypes.GetMetadataForPendingEmailQuery, GraphqlTypes.GetMetadataForPendingEmailQueryVariables>;
export const GetStoredEmailParticipantsDocument = gql`
    query getStoredEmailParticipants($storedEmailId: ID!) {
  storedEmail(id: $storedEmailId) {
    people {
      edges {
        node {
          ...ContactTypeaheadFields
          company {
            ...ContactTypeaheadFields
          }
        }
      }
    }
    organizations {
      edges {
        node {
          ...ContactTypeaheadFields
        }
      }
    }
    offerings {
      ...OfferingFields
    }
    entities {
      ...AccountFields
    }
  }
}
    ${ContactTypeaheadFieldsFragmentDoc}
${OfferingFieldsFragmentDoc}
${AccountFieldsFragmentDoc}`;

/**
 * __useGetStoredEmailParticipantsQuery__
 *
 * To run a query within a React component, call `useGetStoredEmailParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoredEmailParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoredEmailParticipantsQuery({
 *   variables: {
 *      storedEmailId: // value for 'storedEmailId'
 *   },
 * });
 */
export function useGetStoredEmailParticipantsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetStoredEmailParticipantsQuery, GraphqlTypes.GetStoredEmailParticipantsQueryVariables> & ({ variables: GraphqlTypes.GetStoredEmailParticipantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetStoredEmailParticipantsQuery, GraphqlTypes.GetStoredEmailParticipantsQueryVariables>(GetStoredEmailParticipantsDocument, options);
      }
export function useGetStoredEmailParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetStoredEmailParticipantsQuery, GraphqlTypes.GetStoredEmailParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetStoredEmailParticipantsQuery, GraphqlTypes.GetStoredEmailParticipantsQueryVariables>(GetStoredEmailParticipantsDocument, options);
        }
// @ts-ignore
export function useGetStoredEmailParticipantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStoredEmailParticipantsQuery, GraphqlTypes.GetStoredEmailParticipantsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStoredEmailParticipantsQuery, GraphqlTypes.GetStoredEmailParticipantsQueryVariables>;
export function useGetStoredEmailParticipantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStoredEmailParticipantsQuery, GraphqlTypes.GetStoredEmailParticipantsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStoredEmailParticipantsQuery | undefined, GraphqlTypes.GetStoredEmailParticipantsQueryVariables>;
export function useGetStoredEmailParticipantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStoredEmailParticipantsQuery, GraphqlTypes.GetStoredEmailParticipantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetStoredEmailParticipantsQuery, GraphqlTypes.GetStoredEmailParticipantsQueryVariables>(GetStoredEmailParticipantsDocument, options);
        }
export type GetStoredEmailParticipantsQueryHookResult = ReturnType<typeof useGetStoredEmailParticipantsQuery>;
export type GetStoredEmailParticipantsLazyQueryHookResult = ReturnType<typeof useGetStoredEmailParticipantsLazyQuery>;
export type GetStoredEmailParticipantsSuspenseQueryHookResult = ReturnType<typeof useGetStoredEmailParticipantsSuspenseQuery>;
export type GetStoredEmailParticipantsQueryResult = Apollo.QueryResult<GraphqlTypes.GetStoredEmailParticipantsQuery, GraphqlTypes.GetStoredEmailParticipantsQueryVariables>;
export const GetStoredEmailFromHashDocument = gql`
    query GetStoredEmailFromHash($fromAddress: String!, $toAddresses: [String!]!, $subject: String!, $bodyHtml: String!, $date: DateTime!) {
  storedEmail(
    fromAddress: $fromAddress
    toAddresses: $toAddresses
    subject: $subject
    bodyHtml: $bodyHtml
    date: $date
  ) {
    id
  }
}
    `;

/**
 * __useGetStoredEmailFromHashQuery__
 *
 * To run a query within a React component, call `useGetStoredEmailFromHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoredEmailFromHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoredEmailFromHashQuery({
 *   variables: {
 *      fromAddress: // value for 'fromAddress'
 *      toAddresses: // value for 'toAddresses'
 *      subject: // value for 'subject'
 *      bodyHtml: // value for 'bodyHtml'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetStoredEmailFromHashQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetStoredEmailFromHashQuery, GraphqlTypes.GetStoredEmailFromHashQueryVariables> & ({ variables: GraphqlTypes.GetStoredEmailFromHashQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetStoredEmailFromHashQuery, GraphqlTypes.GetStoredEmailFromHashQueryVariables>(GetStoredEmailFromHashDocument, options);
      }
export function useGetStoredEmailFromHashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetStoredEmailFromHashQuery, GraphqlTypes.GetStoredEmailFromHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetStoredEmailFromHashQuery, GraphqlTypes.GetStoredEmailFromHashQueryVariables>(GetStoredEmailFromHashDocument, options);
        }
// @ts-ignore
export function useGetStoredEmailFromHashSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStoredEmailFromHashQuery, GraphqlTypes.GetStoredEmailFromHashQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStoredEmailFromHashQuery, GraphqlTypes.GetStoredEmailFromHashQueryVariables>;
export function useGetStoredEmailFromHashSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStoredEmailFromHashQuery, GraphqlTypes.GetStoredEmailFromHashQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStoredEmailFromHashQuery | undefined, GraphqlTypes.GetStoredEmailFromHashQueryVariables>;
export function useGetStoredEmailFromHashSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStoredEmailFromHashQuery, GraphqlTypes.GetStoredEmailFromHashQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetStoredEmailFromHashQuery, GraphqlTypes.GetStoredEmailFromHashQueryVariables>(GetStoredEmailFromHashDocument, options);
        }
export type GetStoredEmailFromHashQueryHookResult = ReturnType<typeof useGetStoredEmailFromHashQuery>;
export type GetStoredEmailFromHashLazyQueryHookResult = ReturnType<typeof useGetStoredEmailFromHashLazyQuery>;
export type GetStoredEmailFromHashSuspenseQueryHookResult = ReturnType<typeof useGetStoredEmailFromHashSuspenseQuery>;
export type GetStoredEmailFromHashQueryResult = Apollo.QueryResult<GraphqlTypes.GetStoredEmailFromHashQuery, GraphqlTypes.GetStoredEmailFromHashQueryVariables>;
export const GetContactActivityFeedDocument = gql`
    query GetContactActivityFeed($id: ID!, $maxTextBlobLength: Int) {
  contact(id: $id, maxTextBlobLength: $maxTextBlobLength) {
    id
    activityFeed {
      ...ContactActivityFeed
    }
  }
}
    ${ContactActivityFeedFragmentDoc}`;

/**
 * __useGetContactActivityFeedQuery__
 *
 * To run a query within a React component, call `useGetContactActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactActivityFeedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      maxTextBlobLength: // value for 'maxTextBlobLength'
 *   },
 * });
 */
export function useGetContactActivityFeedQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactActivityFeedQuery, GraphqlTypes.GetContactActivityFeedQueryVariables> & ({ variables: GraphqlTypes.GetContactActivityFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactActivityFeedQuery, GraphqlTypes.GetContactActivityFeedQueryVariables>(GetContactActivityFeedDocument, options);
      }
export function useGetContactActivityFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactActivityFeedQuery, GraphqlTypes.GetContactActivityFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactActivityFeedQuery, GraphqlTypes.GetContactActivityFeedQueryVariables>(GetContactActivityFeedDocument, options);
        }
// @ts-ignore
export function useGetContactActivityFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactActivityFeedQuery, GraphqlTypes.GetContactActivityFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactActivityFeedQuery, GraphqlTypes.GetContactActivityFeedQueryVariables>;
export function useGetContactActivityFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactActivityFeedQuery, GraphqlTypes.GetContactActivityFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactActivityFeedQuery | undefined, GraphqlTypes.GetContactActivityFeedQueryVariables>;
export function useGetContactActivityFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactActivityFeedQuery, GraphqlTypes.GetContactActivityFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactActivityFeedQuery, GraphqlTypes.GetContactActivityFeedQueryVariables>(GetContactActivityFeedDocument, options);
        }
export type GetContactActivityFeedQueryHookResult = ReturnType<typeof useGetContactActivityFeedQuery>;
export type GetContactActivityFeedLazyQueryHookResult = ReturnType<typeof useGetContactActivityFeedLazyQuery>;
export type GetContactActivityFeedSuspenseQueryHookResult = ReturnType<typeof useGetContactActivityFeedSuspenseQuery>;
export type GetContactActivityFeedQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactActivityFeedQuery, GraphqlTypes.GetContactActivityFeedQueryVariables>;
export const GetAutoLoggingFeatureFlagDocument = gql`
    query GetAutoLoggingFeatureFlag {
  userFeatures {
    hasOutlookAutoLogging
  }
}
    `;

/**
 * __useGetAutoLoggingFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetAutoLoggingFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoLoggingFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoLoggingFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAutoLoggingFeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAutoLoggingFeatureFlagQuery, GraphqlTypes.GetAutoLoggingFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAutoLoggingFeatureFlagQuery, GraphqlTypes.GetAutoLoggingFeatureFlagQueryVariables>(GetAutoLoggingFeatureFlagDocument, options);
      }
export function useGetAutoLoggingFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAutoLoggingFeatureFlagQuery, GraphqlTypes.GetAutoLoggingFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAutoLoggingFeatureFlagQuery, GraphqlTypes.GetAutoLoggingFeatureFlagQueryVariables>(GetAutoLoggingFeatureFlagDocument, options);
        }
// @ts-ignore
export function useGetAutoLoggingFeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAutoLoggingFeatureFlagQuery, GraphqlTypes.GetAutoLoggingFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAutoLoggingFeatureFlagQuery, GraphqlTypes.GetAutoLoggingFeatureFlagQueryVariables>;
export function useGetAutoLoggingFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAutoLoggingFeatureFlagQuery, GraphqlTypes.GetAutoLoggingFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAutoLoggingFeatureFlagQuery | undefined, GraphqlTypes.GetAutoLoggingFeatureFlagQueryVariables>;
export function useGetAutoLoggingFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAutoLoggingFeatureFlagQuery, GraphqlTypes.GetAutoLoggingFeatureFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAutoLoggingFeatureFlagQuery, GraphqlTypes.GetAutoLoggingFeatureFlagQueryVariables>(GetAutoLoggingFeatureFlagDocument, options);
        }
export type GetAutoLoggingFeatureFlagQueryHookResult = ReturnType<typeof useGetAutoLoggingFeatureFlagQuery>;
export type GetAutoLoggingFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetAutoLoggingFeatureFlagLazyQuery>;
export type GetAutoLoggingFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetAutoLoggingFeatureFlagSuspenseQuery>;
export type GetAutoLoggingFeatureFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GetAutoLoggingFeatureFlagQuery, GraphqlTypes.GetAutoLoggingFeatureFlagQueryVariables>;
export const GetNoteDocument = gql`
    query GetNote($id: ID!) {
  note(id: $id) {
    id
    text
    entities {
      ...AccountFields
    }
    offerings {
      ...OfferingFields
    }
    organizations {
      ...ContactTypeaheadFields
    }
  }
}
    ${AccountFieldsFragmentDoc}
${OfferingFieldsFragmentDoc}
${ContactTypeaheadFieldsFragmentDoc}`;

/**
 * __useGetNoteQuery__
 *
 * To run a query within a React component, call `useGetNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNoteQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetNoteQuery, GraphqlTypes.GetNoteQueryVariables> & ({ variables: GraphqlTypes.GetNoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNoteQuery, GraphqlTypes.GetNoteQueryVariables>(GetNoteDocument, options);
      }
export function useGetNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNoteQuery, GraphqlTypes.GetNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNoteQuery, GraphqlTypes.GetNoteQueryVariables>(GetNoteDocument, options);
        }
// @ts-ignore
export function useGetNoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNoteQuery, GraphqlTypes.GetNoteQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNoteQuery, GraphqlTypes.GetNoteQueryVariables>;
export function useGetNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNoteQuery, GraphqlTypes.GetNoteQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNoteQuery | undefined, GraphqlTypes.GetNoteQueryVariables>;
export function useGetNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNoteQuery, GraphqlTypes.GetNoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNoteQuery, GraphqlTypes.GetNoteQueryVariables>(GetNoteDocument, options);
        }
export type GetNoteQueryHookResult = ReturnType<typeof useGetNoteQuery>;
export type GetNoteLazyQueryHookResult = ReturnType<typeof useGetNoteLazyQuery>;
export type GetNoteSuspenseQueryHookResult = ReturnType<typeof useGetNoteSuspenseQuery>;
export type GetNoteQueryResult = Apollo.QueryResult<GraphqlTypes.GetNoteQuery, GraphqlTypes.GetNoteQueryVariables>;
export const GetSearchedContactsDocument = gql`
    query GetSearchedContacts($term: String!, $excludeIds: [ID]!) {
  searchedContacts(term: $term, excludeIds: $excludeIds) {
    result {
      id
      label
      isOrg
    }
  }
}
    `;

/**
 * __useGetSearchedContactsQuery__
 *
 * To run a query within a React component, call `useGetSearchedContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchedContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchedContactsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      excludeIds: // value for 'excludeIds'
 *   },
 * });
 */
export function useGetSearchedContactsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSearchedContactsQuery, GraphqlTypes.GetSearchedContactsQueryVariables> & ({ variables: GraphqlTypes.GetSearchedContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSearchedContactsQuery, GraphqlTypes.GetSearchedContactsQueryVariables>(GetSearchedContactsDocument, options);
      }
export function useGetSearchedContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSearchedContactsQuery, GraphqlTypes.GetSearchedContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSearchedContactsQuery, GraphqlTypes.GetSearchedContactsQueryVariables>(GetSearchedContactsDocument, options);
        }
// @ts-ignore
export function useGetSearchedContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSearchedContactsQuery, GraphqlTypes.GetSearchedContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSearchedContactsQuery, GraphqlTypes.GetSearchedContactsQueryVariables>;
export function useGetSearchedContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSearchedContactsQuery, GraphqlTypes.GetSearchedContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSearchedContactsQuery | undefined, GraphqlTypes.GetSearchedContactsQueryVariables>;
export function useGetSearchedContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSearchedContactsQuery, GraphqlTypes.GetSearchedContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSearchedContactsQuery, GraphqlTypes.GetSearchedContactsQueryVariables>(GetSearchedContactsDocument, options);
        }
export type GetSearchedContactsQueryHookResult = ReturnType<typeof useGetSearchedContactsQuery>;
export type GetSearchedContactsLazyQueryHookResult = ReturnType<typeof useGetSearchedContactsLazyQuery>;
export type GetSearchedContactsSuspenseQueryHookResult = ReturnType<typeof useGetSearchedContactsSuspenseQuery>;
export type GetSearchedContactsQueryResult = Apollo.QueryResult<GraphqlTypes.GetSearchedContactsQuery, GraphqlTypes.GetSearchedContactsQueryVariables>;
export const GetAccountRelationLabelsDocument = gql`
    query GetAccountRelationLabels {
  accountRelationLabels {
    result {
      id
      label
    }
  }
}
    `;

/**
 * __useGetAccountRelationLabelsQuery__
 *
 * To run a query within a React component, call `useGetAccountRelationLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountRelationLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountRelationLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountRelationLabelsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAccountRelationLabelsQuery, GraphqlTypes.GetAccountRelationLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountRelationLabelsQuery, GraphqlTypes.GetAccountRelationLabelsQueryVariables>(GetAccountRelationLabelsDocument, options);
      }
export function useGetAccountRelationLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountRelationLabelsQuery, GraphqlTypes.GetAccountRelationLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountRelationLabelsQuery, GraphqlTypes.GetAccountRelationLabelsQueryVariables>(GetAccountRelationLabelsDocument, options);
        }
// @ts-ignore
export function useGetAccountRelationLabelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountRelationLabelsQuery, GraphqlTypes.GetAccountRelationLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountRelationLabelsQuery, GraphqlTypes.GetAccountRelationLabelsQueryVariables>;
export function useGetAccountRelationLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountRelationLabelsQuery, GraphqlTypes.GetAccountRelationLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountRelationLabelsQuery | undefined, GraphqlTypes.GetAccountRelationLabelsQueryVariables>;
export function useGetAccountRelationLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountRelationLabelsQuery, GraphqlTypes.GetAccountRelationLabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountRelationLabelsQuery, GraphqlTypes.GetAccountRelationLabelsQueryVariables>(GetAccountRelationLabelsDocument, options);
        }
export type GetAccountRelationLabelsQueryHookResult = ReturnType<typeof useGetAccountRelationLabelsQuery>;
export type GetAccountRelationLabelsLazyQueryHookResult = ReturnType<typeof useGetAccountRelationLabelsLazyQuery>;
export type GetAccountRelationLabelsSuspenseQueryHookResult = ReturnType<typeof useGetAccountRelationLabelsSuspenseQuery>;
export type GetAccountRelationLabelsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountRelationLabelsQuery, GraphqlTypes.GetAccountRelationLabelsQueryVariables>;
export const GetStaffEmailDistributionListsDocument = gql`
    query GetStaffEmailDistributionLists($arenaId: ID) {
  staffEmailDistributionLists(arenaId: $arenaId) {
    edges {
      node {
        id
        name
        newContactDefault
      }
    }
  }
}
    `;

/**
 * __useGetStaffEmailDistributionListsQuery__
 *
 * To run a query within a React component, call `useGetStaffEmailDistributionListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffEmailDistributionListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffEmailDistributionListsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetStaffEmailDistributionListsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetStaffEmailDistributionListsQuery, GraphqlTypes.GetStaffEmailDistributionListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetStaffEmailDistributionListsQuery, GraphqlTypes.GetStaffEmailDistributionListsQueryVariables>(GetStaffEmailDistributionListsDocument, options);
      }
export function useGetStaffEmailDistributionListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetStaffEmailDistributionListsQuery, GraphqlTypes.GetStaffEmailDistributionListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetStaffEmailDistributionListsQuery, GraphqlTypes.GetStaffEmailDistributionListsQueryVariables>(GetStaffEmailDistributionListsDocument, options);
        }
// @ts-ignore
export function useGetStaffEmailDistributionListsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffEmailDistributionListsQuery, GraphqlTypes.GetStaffEmailDistributionListsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStaffEmailDistributionListsQuery, GraphqlTypes.GetStaffEmailDistributionListsQueryVariables>;
export function useGetStaffEmailDistributionListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffEmailDistributionListsQuery, GraphqlTypes.GetStaffEmailDistributionListsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStaffEmailDistributionListsQuery | undefined, GraphqlTypes.GetStaffEmailDistributionListsQueryVariables>;
export function useGetStaffEmailDistributionListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffEmailDistributionListsQuery, GraphqlTypes.GetStaffEmailDistributionListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetStaffEmailDistributionListsQuery, GraphqlTypes.GetStaffEmailDistributionListsQueryVariables>(GetStaffEmailDistributionListsDocument, options);
        }
export type GetStaffEmailDistributionListsQueryHookResult = ReturnType<typeof useGetStaffEmailDistributionListsQuery>;
export type GetStaffEmailDistributionListsLazyQueryHookResult = ReturnType<typeof useGetStaffEmailDistributionListsLazyQuery>;
export type GetStaffEmailDistributionListsSuspenseQueryHookResult = ReturnType<typeof useGetStaffEmailDistributionListsSuspenseQuery>;
export type GetStaffEmailDistributionListsQueryResult = Apollo.QueryResult<GraphqlTypes.GetStaffEmailDistributionListsQuery, GraphqlTypes.GetStaffEmailDistributionListsQueryVariables>;
export const ManageAccountsContactsDocument = gql`
    mutation ManageAccountsContacts($accountIds: [ID]!, $contactIds: [ID]!, $isMainContact: Boolean, $isAdminContact: Boolean, $emailDistributionIds: [String]!, $label: String, $isRemove: Boolean) {
  accountOps {
    manageContacts(
      accountIds: $accountIds
      contactIds: $contactIds
      isMainContact: $isMainContact
      isAdminContact: $isAdminContact
      emailDistributionIds: $emailDistributionIds
      label: $label
      isRemove: $isRemove
    ) {
      hasExistingContact
    }
  }
}
    `;
export type ManageAccountsContactsMutationFn = Apollo.MutationFunction<GraphqlTypes.ManageAccountsContactsMutation, GraphqlTypes.ManageAccountsContactsMutationVariables>;

/**
 * __useManageAccountsContactsMutation__
 *
 * To run a mutation, you first call `useManageAccountsContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageAccountsContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageAccountsContactsMutation, { data, loading, error }] = useManageAccountsContactsMutation({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *      contactIds: // value for 'contactIds'
 *      isMainContact: // value for 'isMainContact'
 *      isAdminContact: // value for 'isAdminContact'
 *      emailDistributionIds: // value for 'emailDistributionIds'
 *      label: // value for 'label'
 *      isRemove: // value for 'isRemove'
 *   },
 * });
 */
export function useManageAccountsContactsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ManageAccountsContactsMutation, GraphqlTypes.ManageAccountsContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ManageAccountsContactsMutation, GraphqlTypes.ManageAccountsContactsMutationVariables>(ManageAccountsContactsDocument, options);
      }
export type ManageAccountsContactsMutationHookResult = ReturnType<typeof useManageAccountsContactsMutation>;
export type ManageAccountsContactsMutationResult = Apollo.MutationResult<GraphqlTypes.ManageAccountsContactsMutation>;
export type ManageAccountsContactsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ManageAccountsContactsMutation, GraphqlTypes.ManageAccountsContactsMutationVariables>;
export const GetAccountsUpdatePermissionDocument = gql`
    query getAccountsUpdatePermission($ids: [ID]!) {
  accountsUpdatePermission(ids: $ids) {
    canUpdate
  }
}
    `;

/**
 * __useGetAccountsUpdatePermissionQuery__
 *
 * To run a query within a React component, call `useGetAccountsUpdatePermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsUpdatePermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsUpdatePermissionQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetAccountsUpdatePermissionQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAccountsUpdatePermissionQuery, GraphqlTypes.GetAccountsUpdatePermissionQueryVariables> & ({ variables: GraphqlTypes.GetAccountsUpdatePermissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountsUpdatePermissionQuery, GraphqlTypes.GetAccountsUpdatePermissionQueryVariables>(GetAccountsUpdatePermissionDocument, options);
      }
export function useGetAccountsUpdatePermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountsUpdatePermissionQuery, GraphqlTypes.GetAccountsUpdatePermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountsUpdatePermissionQuery, GraphqlTypes.GetAccountsUpdatePermissionQueryVariables>(GetAccountsUpdatePermissionDocument, options);
        }
// @ts-ignore
export function useGetAccountsUpdatePermissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountsUpdatePermissionQuery, GraphqlTypes.GetAccountsUpdatePermissionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountsUpdatePermissionQuery, GraphqlTypes.GetAccountsUpdatePermissionQueryVariables>;
export function useGetAccountsUpdatePermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountsUpdatePermissionQuery, GraphqlTypes.GetAccountsUpdatePermissionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountsUpdatePermissionQuery | undefined, GraphqlTypes.GetAccountsUpdatePermissionQueryVariables>;
export function useGetAccountsUpdatePermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountsUpdatePermissionQuery, GraphqlTypes.GetAccountsUpdatePermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountsUpdatePermissionQuery, GraphqlTypes.GetAccountsUpdatePermissionQueryVariables>(GetAccountsUpdatePermissionDocument, options);
        }
export type GetAccountsUpdatePermissionQueryHookResult = ReturnType<typeof useGetAccountsUpdatePermissionQuery>;
export type GetAccountsUpdatePermissionLazyQueryHookResult = ReturnType<typeof useGetAccountsUpdatePermissionLazyQuery>;
export type GetAccountsUpdatePermissionSuspenseQueryHookResult = ReturnType<typeof useGetAccountsUpdatePermissionSuspenseQuery>;
export type GetAccountsUpdatePermissionQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountsUpdatePermissionQuery, GraphqlTypes.GetAccountsUpdatePermissionQueryVariables>;
export const SaveAccountContactsGridViewDocument = gql`
    mutation SaveAccountContactsGridView($saveGridViewInput: SaveGridViewInput!) {
  saveGridView(saveGridViewInput: $saveGridViewInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type SaveAccountContactsGridViewMutationFn = Apollo.MutationFunction<GraphqlTypes.SaveAccountContactsGridViewMutation, GraphqlTypes.SaveAccountContactsGridViewMutationVariables>;

/**
 * __useSaveAccountContactsGridViewMutation__
 *
 * To run a mutation, you first call `useSaveAccountContactsGridViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAccountContactsGridViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAccountContactsGridViewMutation, { data, loading, error }] = useSaveAccountContactsGridViewMutation({
 *   variables: {
 *      saveGridViewInput: // value for 'saveGridViewInput'
 *   },
 * });
 */
export function useSaveAccountContactsGridViewMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SaveAccountContactsGridViewMutation, GraphqlTypes.SaveAccountContactsGridViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SaveAccountContactsGridViewMutation, GraphqlTypes.SaveAccountContactsGridViewMutationVariables>(SaveAccountContactsGridViewDocument, options);
      }
export type SaveAccountContactsGridViewMutationHookResult = ReturnType<typeof useSaveAccountContactsGridViewMutation>;
export type SaveAccountContactsGridViewMutationResult = Apollo.MutationResult<GraphqlTypes.SaveAccountContactsGridViewMutation>;
export type SaveAccountContactsGridViewMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SaveAccountContactsGridViewMutation, GraphqlTypes.SaveAccountContactsGridViewMutationVariables>;
export const GetAccountContactsGridViewDocument = gql`
    query GetAccountContactsGridView {
  userGridView(tableType: AccountContacts) {
    columnOrder {
      orderedColIds
    }
    columnVisibility {
      hiddenColIds
    }
    columnSizing {
      colId
      flex
      width
    }
    columnPinning {
      leftColIds
      rightColIds
    }
    columnSort {
      colId
      isAscending
    }
    setFilters {
      field
      selected
      quantifier
    }
    textFilters {
      field
      text
      textFilterType
    }
    numberFilters {
      field
      filter
      filterTo
      numberFilterType
    }
    locationFilters {
      field
      coordinates {
        latitude
        longitude
        radius
        locationId
        locationName
        radiusType
      }
      stateName
      countryName
    }
    extensionFieldFilters {
      textFilters {
        extensionFieldId
        text
        textFilterType
      }
      intFilters {
        extensionFieldId
        numberFilterType
        filter
        filterTo
      }
      floatFilters {
        extensionFieldId
        numberFilterType
        filter
        filterTo
      }
      dateFilters {
        extensionFieldId
        dateFilterType
        filter
        filterTo
      }
      enumFilters {
        extensionFieldId
        enumValueIds
      }
    }
  }
}
    `;

/**
 * __useGetAccountContactsGridViewQuery__
 *
 * To run a query within a React component, call `useGetAccountContactsGridViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountContactsGridViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountContactsGridViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountContactsGridViewQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAccountContactsGridViewQuery, GraphqlTypes.GetAccountContactsGridViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountContactsGridViewQuery, GraphqlTypes.GetAccountContactsGridViewQueryVariables>(GetAccountContactsGridViewDocument, options);
      }
export function useGetAccountContactsGridViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountContactsGridViewQuery, GraphqlTypes.GetAccountContactsGridViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountContactsGridViewQuery, GraphqlTypes.GetAccountContactsGridViewQueryVariables>(GetAccountContactsGridViewDocument, options);
        }
// @ts-ignore
export function useGetAccountContactsGridViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsGridViewQuery, GraphqlTypes.GetAccountContactsGridViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountContactsGridViewQuery, GraphqlTypes.GetAccountContactsGridViewQueryVariables>;
export function useGetAccountContactsGridViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsGridViewQuery, GraphqlTypes.GetAccountContactsGridViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountContactsGridViewQuery | undefined, GraphqlTypes.GetAccountContactsGridViewQueryVariables>;
export function useGetAccountContactsGridViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsGridViewQuery, GraphqlTypes.GetAccountContactsGridViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountContactsGridViewQuery, GraphqlTypes.GetAccountContactsGridViewQueryVariables>(GetAccountContactsGridViewDocument, options);
        }
export type GetAccountContactsGridViewQueryHookResult = ReturnType<typeof useGetAccountContactsGridViewQuery>;
export type GetAccountContactsGridViewLazyQueryHookResult = ReturnType<typeof useGetAccountContactsGridViewLazyQuery>;
export type GetAccountContactsGridViewSuspenseQueryHookResult = ReturnType<typeof useGetAccountContactsGridViewSuspenseQuery>;
export type GetAccountContactsGridViewQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountContactsGridViewQuery, GraphqlTypes.GetAccountContactsGridViewQueryVariables>;
export const SaveApprovalsGridViewDocument = gql`
    mutation SaveApprovalsGridView($saveGridViewInput: SaveGridViewInput!) {
  saveGridView(saveGridViewInput: $saveGridViewInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type SaveApprovalsGridViewMutationFn = Apollo.MutationFunction<GraphqlTypes.SaveApprovalsGridViewMutation, GraphqlTypes.SaveApprovalsGridViewMutationVariables>;

/**
 * __useSaveApprovalsGridViewMutation__
 *
 * To run a mutation, you first call `useSaveApprovalsGridViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveApprovalsGridViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveApprovalsGridViewMutation, { data, loading, error }] = useSaveApprovalsGridViewMutation({
 *   variables: {
 *      saveGridViewInput: // value for 'saveGridViewInput'
 *   },
 * });
 */
export function useSaveApprovalsGridViewMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SaveApprovalsGridViewMutation, GraphqlTypes.SaveApprovalsGridViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SaveApprovalsGridViewMutation, GraphqlTypes.SaveApprovalsGridViewMutationVariables>(SaveApprovalsGridViewDocument, options);
      }
export type SaveApprovalsGridViewMutationHookResult = ReturnType<typeof useSaveApprovalsGridViewMutation>;
export type SaveApprovalsGridViewMutationResult = Apollo.MutationResult<GraphqlTypes.SaveApprovalsGridViewMutation>;
export type SaveApprovalsGridViewMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SaveApprovalsGridViewMutation, GraphqlTypes.SaveApprovalsGridViewMutationVariables>;
export const GetUserApprovalsViewDocument = gql`
    query GetUserApprovalsView {
  userGridView(tableType: ApprovalRequests) {
    columnOrder {
      orderedColIds
    }
    columnVisibility {
      hiddenColIds
    }
    columnSizing {
      colId
      flex
      width
    }
    columnPinning {
      leftColIds
      rightColIds
    }
    setFilters {
      field
      selected
      quantifier
    }
    textFilters {
      field
      text
      textFilterType
    }
  }
}
    `;

/**
 * __useGetUserApprovalsViewQuery__
 *
 * To run a query within a React component, call `useGetUserApprovalsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserApprovalsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserApprovalsViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserApprovalsViewQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetUserApprovalsViewQuery, GraphqlTypes.GetUserApprovalsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUserApprovalsViewQuery, GraphqlTypes.GetUserApprovalsViewQueryVariables>(GetUserApprovalsViewDocument, options);
      }
export function useGetUserApprovalsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUserApprovalsViewQuery, GraphqlTypes.GetUserApprovalsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUserApprovalsViewQuery, GraphqlTypes.GetUserApprovalsViewQueryVariables>(GetUserApprovalsViewDocument, options);
        }
// @ts-ignore
export function useGetUserApprovalsViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserApprovalsViewQuery, GraphqlTypes.GetUserApprovalsViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserApprovalsViewQuery, GraphqlTypes.GetUserApprovalsViewQueryVariables>;
export function useGetUserApprovalsViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserApprovalsViewQuery, GraphqlTypes.GetUserApprovalsViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserApprovalsViewQuery | undefined, GraphqlTypes.GetUserApprovalsViewQueryVariables>;
export function useGetUserApprovalsViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserApprovalsViewQuery, GraphqlTypes.GetUserApprovalsViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUserApprovalsViewQuery, GraphqlTypes.GetUserApprovalsViewQueryVariables>(GetUserApprovalsViewDocument, options);
        }
export type GetUserApprovalsViewQueryHookResult = ReturnType<typeof useGetUserApprovalsViewQuery>;
export type GetUserApprovalsViewLazyQueryHookResult = ReturnType<typeof useGetUserApprovalsViewLazyQuery>;
export type GetUserApprovalsViewSuspenseQueryHookResult = ReturnType<typeof useGetUserApprovalsViewSuspenseQuery>;
export type GetUserApprovalsViewQueryResult = Apollo.QueryResult<GraphqlTypes.GetUserApprovalsViewQuery, GraphqlTypes.GetUserApprovalsViewQueryVariables>;
export const AuthorizeExtensionFieldsUploadDocument = gql`
    mutation AuthorizeExtensionFieldsUpload($authorizeUploadInput: AuthorizeExtensionFieldsInput!) {
  authorizeExtensionFieldsUpload(authorizeUploadInput: $authorizeUploadInput) {
    result {
      authorized
      clientMsg
    }
  }
}
    `;
export type AuthorizeExtensionFieldsUploadMutationFn = Apollo.MutationFunction<GraphqlTypes.AuthorizeExtensionFieldsUploadMutation, GraphqlTypes.AuthorizeExtensionFieldsUploadMutationVariables>;

/**
 * __useAuthorizeExtensionFieldsUploadMutation__
 *
 * To run a mutation, you first call `useAuthorizeExtensionFieldsUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthorizeExtensionFieldsUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authorizeExtensionFieldsUploadMutation, { data, loading, error }] = useAuthorizeExtensionFieldsUploadMutation({
 *   variables: {
 *      authorizeUploadInput: // value for 'authorizeUploadInput'
 *   },
 * });
 */
export function useAuthorizeExtensionFieldsUploadMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AuthorizeExtensionFieldsUploadMutation, GraphqlTypes.AuthorizeExtensionFieldsUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AuthorizeExtensionFieldsUploadMutation, GraphqlTypes.AuthorizeExtensionFieldsUploadMutationVariables>(AuthorizeExtensionFieldsUploadDocument, options);
      }
export type AuthorizeExtensionFieldsUploadMutationHookResult = ReturnType<typeof useAuthorizeExtensionFieldsUploadMutation>;
export type AuthorizeExtensionFieldsUploadMutationResult = Apollo.MutationResult<GraphqlTypes.AuthorizeExtensionFieldsUploadMutation>;
export type AuthorizeExtensionFieldsUploadMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AuthorizeExtensionFieldsUploadMutation, GraphqlTypes.AuthorizeExtensionFieldsUploadMutationVariables>;
export const ExportExtensionFieldsDocument = gql`
    mutation ExportExtensionFields($objectType: JSQObjectType!, $objectIds: [ID!]!, $entityId: ID) {
  exportExtensionFields(
    exportInput: {objectType: $objectType, objectIds: $objectIds, includeApiEditOnly: false, entityId: $entityId}
  ) {
    result {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on AsyncJobObjectType {
        id
      }
    }
  }
}
    `;
export type ExportExtensionFieldsMutationFn = Apollo.MutationFunction<GraphqlTypes.ExportExtensionFieldsMutation, GraphqlTypes.ExportExtensionFieldsMutationVariables>;

/**
 * __useExportExtensionFieldsMutation__
 *
 * To run a mutation, you first call `useExportExtensionFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportExtensionFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportExtensionFieldsMutation, { data, loading, error }] = useExportExtensionFieldsMutation({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      objectIds: // value for 'objectIds'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useExportExtensionFieldsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExportExtensionFieldsMutation, GraphqlTypes.ExportExtensionFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExportExtensionFieldsMutation, GraphqlTypes.ExportExtensionFieldsMutationVariables>(ExportExtensionFieldsDocument, options);
      }
export type ExportExtensionFieldsMutationHookResult = ReturnType<typeof useExportExtensionFieldsMutation>;
export type ExportExtensionFieldsMutationResult = Apollo.MutationResult<GraphqlTypes.ExportExtensionFieldsMutation>;
export type ExportExtensionFieldsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExportExtensionFieldsMutation, GraphqlTypes.ExportExtensionFieldsMutationVariables>;
export const GetUniqueIdentifiersDocument = gql`
    query GetUniqueIdentifiers($objectType: JSQObjectType!, $entityId: ID, $isAccount: Boolean) {
  uniqueIdentifiers(
    objectType: $objectType
    entityId: $entityId
    isAccount: $isAccount
  ) {
    names
  }
}
    `;

/**
 * __useGetUniqueIdentifiersQuery__
 *
 * To run a query within a React component, call `useGetUniqueIdentifiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqueIdentifiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqueIdentifiersQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      entityId: // value for 'entityId'
 *      isAccount: // value for 'isAccount'
 *   },
 * });
 */
export function useGetUniqueIdentifiersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUniqueIdentifiersQuery, GraphqlTypes.GetUniqueIdentifiersQueryVariables> & ({ variables: GraphqlTypes.GetUniqueIdentifiersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUniqueIdentifiersQuery, GraphqlTypes.GetUniqueIdentifiersQueryVariables>(GetUniqueIdentifiersDocument, options);
      }
export function useGetUniqueIdentifiersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUniqueIdentifiersQuery, GraphqlTypes.GetUniqueIdentifiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUniqueIdentifiersQuery, GraphqlTypes.GetUniqueIdentifiersQueryVariables>(GetUniqueIdentifiersDocument, options);
        }
// @ts-ignore
export function useGetUniqueIdentifiersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUniqueIdentifiersQuery, GraphqlTypes.GetUniqueIdentifiersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUniqueIdentifiersQuery, GraphqlTypes.GetUniqueIdentifiersQueryVariables>;
export function useGetUniqueIdentifiersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUniqueIdentifiersQuery, GraphqlTypes.GetUniqueIdentifiersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUniqueIdentifiersQuery | undefined, GraphqlTypes.GetUniqueIdentifiersQueryVariables>;
export function useGetUniqueIdentifiersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUniqueIdentifiersQuery, GraphqlTypes.GetUniqueIdentifiersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUniqueIdentifiersQuery, GraphqlTypes.GetUniqueIdentifiersQueryVariables>(GetUniqueIdentifiersDocument, options);
        }
export type GetUniqueIdentifiersQueryHookResult = ReturnType<typeof useGetUniqueIdentifiersQuery>;
export type GetUniqueIdentifiersLazyQueryHookResult = ReturnType<typeof useGetUniqueIdentifiersLazyQuery>;
export type GetUniqueIdentifiersSuspenseQueryHookResult = ReturnType<typeof useGetUniqueIdentifiersSuspenseQuery>;
export type GetUniqueIdentifiersQueryResult = Apollo.QueryResult<GraphqlTypes.GetUniqueIdentifiersQuery, GraphqlTypes.GetUniqueIdentifiersQueryVariables>;
export const GetExtensionFieldsDocument = gql`
    query GetExtensionFields($objectType: JSQObjectType!) {
  extensionFields(objectType: $objectType, includeApiEditOnly: false) {
    name
    id
  }
}
    `;

/**
 * __useGetExtensionFieldsQuery__
 *
 * To run a query within a React component, call `useGetExtensionFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtensionFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtensionFieldsQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useGetExtensionFieldsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetExtensionFieldsQuery, GraphqlTypes.GetExtensionFieldsQueryVariables> & ({ variables: GraphqlTypes.GetExtensionFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetExtensionFieldsQuery, GraphqlTypes.GetExtensionFieldsQueryVariables>(GetExtensionFieldsDocument, options);
      }
export function useGetExtensionFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetExtensionFieldsQuery, GraphqlTypes.GetExtensionFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetExtensionFieldsQuery, GraphqlTypes.GetExtensionFieldsQueryVariables>(GetExtensionFieldsDocument, options);
        }
// @ts-ignore
export function useGetExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionFieldsQuery, GraphqlTypes.GetExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExtensionFieldsQuery, GraphqlTypes.GetExtensionFieldsQueryVariables>;
export function useGetExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionFieldsQuery, GraphqlTypes.GetExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExtensionFieldsQuery | undefined, GraphqlTypes.GetExtensionFieldsQueryVariables>;
export function useGetExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionFieldsQuery, GraphqlTypes.GetExtensionFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetExtensionFieldsQuery, GraphqlTypes.GetExtensionFieldsQueryVariables>(GetExtensionFieldsDocument, options);
        }
export type GetExtensionFieldsQueryHookResult = ReturnType<typeof useGetExtensionFieldsQuery>;
export type GetExtensionFieldsLazyQueryHookResult = ReturnType<typeof useGetExtensionFieldsLazyQuery>;
export type GetExtensionFieldsSuspenseQueryHookResult = ReturnType<typeof useGetExtensionFieldsSuspenseQuery>;
export type GetExtensionFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetExtensionFieldsQuery, GraphqlTypes.GetExtensionFieldsQueryVariables>;
export const GetEditableExtensionFieldsDocument = gql`
    query GetEditableExtensionFields($objectType: JSQObjectType!) {
  editableExtensionFields(objectType: $objectType, includeApiEditOnly: false) {
    name
    id
  }
}
    `;

/**
 * __useGetEditableExtensionFieldsQuery__
 *
 * To run a query within a React component, call `useGetEditableExtensionFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditableExtensionFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditableExtensionFieldsQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useGetEditableExtensionFieldsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEditableExtensionFieldsQuery, GraphqlTypes.GetEditableExtensionFieldsQueryVariables> & ({ variables: GraphqlTypes.GetEditableExtensionFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEditableExtensionFieldsQuery, GraphqlTypes.GetEditableExtensionFieldsQueryVariables>(GetEditableExtensionFieldsDocument, options);
      }
export function useGetEditableExtensionFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEditableExtensionFieldsQuery, GraphqlTypes.GetEditableExtensionFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEditableExtensionFieldsQuery, GraphqlTypes.GetEditableExtensionFieldsQueryVariables>(GetEditableExtensionFieldsDocument, options);
        }
// @ts-ignore
export function useGetEditableExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditableExtensionFieldsQuery, GraphqlTypes.GetEditableExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEditableExtensionFieldsQuery, GraphqlTypes.GetEditableExtensionFieldsQueryVariables>;
export function useGetEditableExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditableExtensionFieldsQuery, GraphqlTypes.GetEditableExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEditableExtensionFieldsQuery | undefined, GraphqlTypes.GetEditableExtensionFieldsQueryVariables>;
export function useGetEditableExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditableExtensionFieldsQuery, GraphqlTypes.GetEditableExtensionFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEditableExtensionFieldsQuery, GraphqlTypes.GetEditableExtensionFieldsQueryVariables>(GetEditableExtensionFieldsDocument, options);
        }
export type GetEditableExtensionFieldsQueryHookResult = ReturnType<typeof useGetEditableExtensionFieldsQuery>;
export type GetEditableExtensionFieldsLazyQueryHookResult = ReturnType<typeof useGetEditableExtensionFieldsLazyQuery>;
export type GetEditableExtensionFieldsSuspenseQueryHookResult = ReturnType<typeof useGetEditableExtensionFieldsSuspenseQuery>;
export type GetEditableExtensionFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEditableExtensionFieldsQuery, GraphqlTypes.GetEditableExtensionFieldsQueryVariables>;
export const GetExtensionFieldsUrlDocument = gql`
    query GetExtensionFieldsUrl($asyncJobId: ID!) {
  extensionFieldsUrl(asyncJobId: $asyncJobId)
}
    `;

/**
 * __useGetExtensionFieldsUrlQuery__
 *
 * To run a query within a React component, call `useGetExtensionFieldsUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtensionFieldsUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtensionFieldsUrlQuery({
 *   variables: {
 *      asyncJobId: // value for 'asyncJobId'
 *   },
 * });
 */
export function useGetExtensionFieldsUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetExtensionFieldsUrlQuery, GraphqlTypes.GetExtensionFieldsUrlQueryVariables> & ({ variables: GraphqlTypes.GetExtensionFieldsUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetExtensionFieldsUrlQuery, GraphqlTypes.GetExtensionFieldsUrlQueryVariables>(GetExtensionFieldsUrlDocument, options);
      }
export function useGetExtensionFieldsUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetExtensionFieldsUrlQuery, GraphqlTypes.GetExtensionFieldsUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetExtensionFieldsUrlQuery, GraphqlTypes.GetExtensionFieldsUrlQueryVariables>(GetExtensionFieldsUrlDocument, options);
        }
// @ts-ignore
export function useGetExtensionFieldsUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionFieldsUrlQuery, GraphqlTypes.GetExtensionFieldsUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExtensionFieldsUrlQuery, GraphqlTypes.GetExtensionFieldsUrlQueryVariables>;
export function useGetExtensionFieldsUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionFieldsUrlQuery, GraphqlTypes.GetExtensionFieldsUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExtensionFieldsUrlQuery | undefined, GraphqlTypes.GetExtensionFieldsUrlQueryVariables>;
export function useGetExtensionFieldsUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionFieldsUrlQuery, GraphqlTypes.GetExtensionFieldsUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetExtensionFieldsUrlQuery, GraphqlTypes.GetExtensionFieldsUrlQueryVariables>(GetExtensionFieldsUrlDocument, options);
        }
export type GetExtensionFieldsUrlQueryHookResult = ReturnType<typeof useGetExtensionFieldsUrlQuery>;
export type GetExtensionFieldsUrlLazyQueryHookResult = ReturnType<typeof useGetExtensionFieldsUrlLazyQuery>;
export type GetExtensionFieldsUrlSuspenseQueryHookResult = ReturnType<typeof useGetExtensionFieldsUrlSuspenseQuery>;
export type GetExtensionFieldsUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetExtensionFieldsUrlQuery, GraphqlTypes.GetExtensionFieldsUrlQueryVariables>;
export const ParseSpreadsheetHeadersDocument = gql`
    mutation ParseSpreadsheetHeaders($fileUuid: String!, $sheetName: String!, $itemName: String) {
  importOps {
    parseSpreadsheet(
      fileUuid: $fileUuid
      sheetName: $sheetName
      itemName: $itemName
    ) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on ParseSpreadsheetObject {
        fileUuid
        headers
        sampleValues
      }
    }
  }
}
    `;
export type ParseSpreadsheetHeadersMutationFn = Apollo.MutationFunction<GraphqlTypes.ParseSpreadsheetHeadersMutation, GraphqlTypes.ParseSpreadsheetHeadersMutationVariables>;

/**
 * __useParseSpreadsheetHeadersMutation__
 *
 * To run a mutation, you first call `useParseSpreadsheetHeadersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParseSpreadsheetHeadersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parseSpreadsheetHeadersMutation, { data, loading, error }] = useParseSpreadsheetHeadersMutation({
 *   variables: {
 *      fileUuid: // value for 'fileUuid'
 *      sheetName: // value for 'sheetName'
 *      itemName: // value for 'itemName'
 *   },
 * });
 */
export function useParseSpreadsheetHeadersMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ParseSpreadsheetHeadersMutation, GraphqlTypes.ParseSpreadsheetHeadersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ParseSpreadsheetHeadersMutation, GraphqlTypes.ParseSpreadsheetHeadersMutationVariables>(ParseSpreadsheetHeadersDocument, options);
      }
export type ParseSpreadsheetHeadersMutationHookResult = ReturnType<typeof useParseSpreadsheetHeadersMutation>;
export type ParseSpreadsheetHeadersMutationResult = Apollo.MutationResult<GraphqlTypes.ParseSpreadsheetHeadersMutation>;
export type ParseSpreadsheetHeadersMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ParseSpreadsheetHeadersMutation, GraphqlTypes.ParseSpreadsheetHeadersMutationVariables>;
export const ImportExtensionFieldsDocument = gql`
    mutation ImportExtensionFields($importInput: ImportExtensionFieldsInput!) {
  importExtensionFields(importInput: $importInput) {
    result {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on AsyncJobObjectType {
        id
      }
    }
  }
}
    `;
export type ImportExtensionFieldsMutationFn = Apollo.MutationFunction<GraphqlTypes.ImportExtensionFieldsMutation, GraphqlTypes.ImportExtensionFieldsMutationVariables>;

/**
 * __useImportExtensionFieldsMutation__
 *
 * To run a mutation, you first call `useImportExtensionFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportExtensionFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importExtensionFieldsMutation, { data, loading, error }] = useImportExtensionFieldsMutation({
 *   variables: {
 *      importInput: // value for 'importInput'
 *   },
 * });
 */
export function useImportExtensionFieldsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ImportExtensionFieldsMutation, GraphqlTypes.ImportExtensionFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ImportExtensionFieldsMutation, GraphqlTypes.ImportExtensionFieldsMutationVariables>(ImportExtensionFieldsDocument, options);
      }
export type ImportExtensionFieldsMutationHookResult = ReturnType<typeof useImportExtensionFieldsMutation>;
export type ImportExtensionFieldsMutationResult = Apollo.MutationResult<GraphqlTypes.ImportExtensionFieldsMutation>;
export type ImportExtensionFieldsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ImportExtensionFieldsMutation, GraphqlTypes.ImportExtensionFieldsMutationVariables>;
export const PublishTransactionBatchesDocument = gql`
    mutation publishTransactionBatches($batches: PublishTransactionBatches!, $entityIds: [ID]) {
  transactionOps {
    publishTransactionBatches(batches: $batches, entityIds: $entityIds) {
      success
    }
  }
}
    `;
export type PublishTransactionBatchesMutationFn = Apollo.MutationFunction<GraphqlTypes.PublishTransactionBatchesMutation, GraphqlTypes.PublishTransactionBatchesMutationVariables>;

/**
 * __usePublishTransactionBatchesMutation__
 *
 * To run a mutation, you first call `usePublishTransactionBatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishTransactionBatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishTransactionBatchesMutation, { data, loading, error }] = usePublishTransactionBatchesMutation({
 *   variables: {
 *      batches: // value for 'batches'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function usePublishTransactionBatchesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PublishTransactionBatchesMutation, GraphqlTypes.PublishTransactionBatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PublishTransactionBatchesMutation, GraphqlTypes.PublishTransactionBatchesMutationVariables>(PublishTransactionBatchesDocument, options);
      }
export type PublishTransactionBatchesMutationHookResult = ReturnType<typeof usePublishTransactionBatchesMutation>;
export type PublishTransactionBatchesMutationResult = Apollo.MutationResult<GraphqlTypes.PublishTransactionBatchesMutation>;
export type PublishTransactionBatchesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PublishTransactionBatchesMutation, GraphqlTypes.PublishTransactionBatchesMutationVariables>;
export const ContactFormConfigGetExtensionFieldsDocument = gql`
    query ContactFormConfigGetExtensionFields($objectType: JSQObjectType!) {
  extensionFields(objectType: $objectType, includeApiEditOnly: false) {
    id
    name
    extensionFieldTypeId
  }
}
    `;

/**
 * __useContactFormConfigGetExtensionFieldsQuery__
 *
 * To run a query within a React component, call `useContactFormConfigGetExtensionFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactFormConfigGetExtensionFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactFormConfigGetExtensionFieldsQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useContactFormConfigGetExtensionFieldsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ContactFormConfigGetExtensionFieldsQuery, GraphqlTypes.ContactFormConfigGetExtensionFieldsQueryVariables> & ({ variables: GraphqlTypes.ContactFormConfigGetExtensionFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ContactFormConfigGetExtensionFieldsQuery, GraphqlTypes.ContactFormConfigGetExtensionFieldsQueryVariables>(ContactFormConfigGetExtensionFieldsDocument, options);
      }
export function useContactFormConfigGetExtensionFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ContactFormConfigGetExtensionFieldsQuery, GraphqlTypes.ContactFormConfigGetExtensionFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ContactFormConfigGetExtensionFieldsQuery, GraphqlTypes.ContactFormConfigGetExtensionFieldsQueryVariables>(ContactFormConfigGetExtensionFieldsDocument, options);
        }
// @ts-ignore
export function useContactFormConfigGetExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactFormConfigGetExtensionFieldsQuery, GraphqlTypes.ContactFormConfigGetExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactFormConfigGetExtensionFieldsQuery, GraphqlTypes.ContactFormConfigGetExtensionFieldsQueryVariables>;
export function useContactFormConfigGetExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactFormConfigGetExtensionFieldsQuery, GraphqlTypes.ContactFormConfigGetExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactFormConfigGetExtensionFieldsQuery | undefined, GraphqlTypes.ContactFormConfigGetExtensionFieldsQueryVariables>;
export function useContactFormConfigGetExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactFormConfigGetExtensionFieldsQuery, GraphqlTypes.ContactFormConfigGetExtensionFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ContactFormConfigGetExtensionFieldsQuery, GraphqlTypes.ContactFormConfigGetExtensionFieldsQueryVariables>(ContactFormConfigGetExtensionFieldsDocument, options);
        }
export type ContactFormConfigGetExtensionFieldsQueryHookResult = ReturnType<typeof useContactFormConfigGetExtensionFieldsQuery>;
export type ContactFormConfigGetExtensionFieldsLazyQueryHookResult = ReturnType<typeof useContactFormConfigGetExtensionFieldsLazyQuery>;
export type ContactFormConfigGetExtensionFieldsSuspenseQueryHookResult = ReturnType<typeof useContactFormConfigGetExtensionFieldsSuspenseQuery>;
export type ContactFormConfigGetExtensionFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.ContactFormConfigGetExtensionFieldsQuery, GraphqlTypes.ContactFormConfigGetExtensionFieldsQueryVariables>;
export const GetEditArenaDevFeatureFlagsDocument = gql`
    query GetEditArenaDevFeatureFlags {
  devFeatures {
    subscriptionBulkCountersign
  }
}
    `;

/**
 * __useGetEditArenaDevFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetEditArenaDevFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditArenaDevFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditArenaDevFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEditArenaDevFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>(GetEditArenaDevFeatureFlagsDocument, options);
      }
export function useGetEditArenaDevFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>(GetEditArenaDevFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useGetEditArenaDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>;
export function useGetEditArenaDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery | undefined, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>;
export function useGetEditArenaDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>(GetEditArenaDevFeatureFlagsDocument, options);
        }
export type GetEditArenaDevFeatureFlagsQueryHookResult = ReturnType<typeof useGetEditArenaDevFeatureFlagsQuery>;
export type GetEditArenaDevFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetEditArenaDevFeatureFlagsLazyQuery>;
export type GetEditArenaDevFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useGetEditArenaDevFeatureFlagsSuspenseQuery>;
export type GetEditArenaDevFeatureFlagsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>;
export const GetNumericExtensionFieldsDocument = gql`
    query GetNumericExtensionFields($objectType: JSQObjectType!, $extensionFieldTypes: [ExtensionFieldType!], $isVisibleInPortal: Boolean) {
  extensionFields(
    objectType: $objectType
    extensionFieldTypes: $extensionFieldTypes
    isVisibleInPortal: $isVisibleInPortal
  ) {
    id
    name
    extensionFieldTypeId
    enumName
    description
    isMultivalued
    enumValues {
      enumName
      enumValueCode
      enumValueLabel
    }
    activeEnumValues {
      enumName
      enumValueCode
      enumValueLabel
    }
  }
}
    `;

/**
 * __useGetNumericExtensionFieldsQuery__
 *
 * To run a query within a React component, call `useGetNumericExtensionFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumericExtensionFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumericExtensionFieldsQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      extensionFieldTypes: // value for 'extensionFieldTypes'
 *      isVisibleInPortal: // value for 'isVisibleInPortal'
 *   },
 * });
 */
export function useGetNumericExtensionFieldsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetNumericExtensionFieldsQuery, GraphqlTypes.GetNumericExtensionFieldsQueryVariables> & ({ variables: GraphqlTypes.GetNumericExtensionFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNumericExtensionFieldsQuery, GraphqlTypes.GetNumericExtensionFieldsQueryVariables>(GetNumericExtensionFieldsDocument, options);
      }
export function useGetNumericExtensionFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNumericExtensionFieldsQuery, GraphqlTypes.GetNumericExtensionFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNumericExtensionFieldsQuery, GraphqlTypes.GetNumericExtensionFieldsQueryVariables>(GetNumericExtensionFieldsDocument, options);
        }
// @ts-ignore
export function useGetNumericExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNumericExtensionFieldsQuery, GraphqlTypes.GetNumericExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNumericExtensionFieldsQuery, GraphqlTypes.GetNumericExtensionFieldsQueryVariables>;
export function useGetNumericExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNumericExtensionFieldsQuery, GraphqlTypes.GetNumericExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNumericExtensionFieldsQuery | undefined, GraphqlTypes.GetNumericExtensionFieldsQueryVariables>;
export function useGetNumericExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNumericExtensionFieldsQuery, GraphqlTypes.GetNumericExtensionFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNumericExtensionFieldsQuery, GraphqlTypes.GetNumericExtensionFieldsQueryVariables>(GetNumericExtensionFieldsDocument, options);
        }
export type GetNumericExtensionFieldsQueryHookResult = ReturnType<typeof useGetNumericExtensionFieldsQuery>;
export type GetNumericExtensionFieldsLazyQueryHookResult = ReturnType<typeof useGetNumericExtensionFieldsLazyQuery>;
export type GetNumericExtensionFieldsSuspenseQueryHookResult = ReturnType<typeof useGetNumericExtensionFieldsSuspenseQuery>;
export type GetNumericExtensionFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetNumericExtensionFieldsQuery, GraphqlTypes.GetNumericExtensionFieldsQueryVariables>;
export const GetContactInvestmentsFieldsForHeroMetricsDocument = gql`
    query GetContactInvestmentsFieldsForHeroMetrics {
  contactInvestmentsFields {
    fieldName
    label
  }
}
    `;

/**
 * __useGetContactInvestmentsFieldsForHeroMetricsQuery__
 *
 * To run a query within a React component, call `useGetContactInvestmentsFieldsForHeroMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactInvestmentsFieldsForHeroMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactInvestmentsFieldsForHeroMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactInvestmentsFieldsForHeroMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQuery, GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQuery, GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQueryVariables>(GetContactInvestmentsFieldsForHeroMetricsDocument, options);
      }
export function useGetContactInvestmentsFieldsForHeroMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQuery, GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQuery, GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQueryVariables>(GetContactInvestmentsFieldsForHeroMetricsDocument, options);
        }
// @ts-ignore
export function useGetContactInvestmentsFieldsForHeroMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQuery, GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQuery, GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQueryVariables>;
export function useGetContactInvestmentsFieldsForHeroMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQuery, GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQuery | undefined, GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQueryVariables>;
export function useGetContactInvestmentsFieldsForHeroMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQuery, GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQuery, GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQueryVariables>(GetContactInvestmentsFieldsForHeroMetricsDocument, options);
        }
export type GetContactInvestmentsFieldsForHeroMetricsQueryHookResult = ReturnType<typeof useGetContactInvestmentsFieldsForHeroMetricsQuery>;
export type GetContactInvestmentsFieldsForHeroMetricsLazyQueryHookResult = ReturnType<typeof useGetContactInvestmentsFieldsForHeroMetricsLazyQuery>;
export type GetContactInvestmentsFieldsForHeroMetricsSuspenseQueryHookResult = ReturnType<typeof useGetContactInvestmentsFieldsForHeroMetricsSuspenseQuery>;
export type GetContactInvestmentsFieldsForHeroMetricsQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQuery, GraphqlTypes.GetContactInvestmentsFieldsForHeroMetricsQueryVariables>;
export const GetPortalHeroMetricsRestrictedFieldsDocument = gql`
    query GetPortalHeroMetricsRestrictedFields {
  currentArena {
    portalHeroMetricsConfig {
      restrictedCustomFields {
        extensionFieldId
      }
    }
  }
}
    `;

/**
 * __useGetPortalHeroMetricsRestrictedFieldsQuery__
 *
 * To run a query within a React component, call `useGetPortalHeroMetricsRestrictedFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalHeroMetricsRestrictedFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalHeroMetricsRestrictedFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPortalHeroMetricsRestrictedFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQuery, GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQuery, GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQueryVariables>(GetPortalHeroMetricsRestrictedFieldsDocument, options);
      }
export function useGetPortalHeroMetricsRestrictedFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQuery, GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQuery, GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQueryVariables>(GetPortalHeroMetricsRestrictedFieldsDocument, options);
        }
// @ts-ignore
export function useGetPortalHeroMetricsRestrictedFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQuery, GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQuery, GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQueryVariables>;
export function useGetPortalHeroMetricsRestrictedFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQuery, GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQuery | undefined, GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQueryVariables>;
export function useGetPortalHeroMetricsRestrictedFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQuery, GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQuery, GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQueryVariables>(GetPortalHeroMetricsRestrictedFieldsDocument, options);
        }
export type GetPortalHeroMetricsRestrictedFieldsQueryHookResult = ReturnType<typeof useGetPortalHeroMetricsRestrictedFieldsQuery>;
export type GetPortalHeroMetricsRestrictedFieldsLazyQueryHookResult = ReturnType<typeof useGetPortalHeroMetricsRestrictedFieldsLazyQuery>;
export type GetPortalHeroMetricsRestrictedFieldsSuspenseQueryHookResult = ReturnType<typeof useGetPortalHeroMetricsRestrictedFieldsSuspenseQuery>;
export type GetPortalHeroMetricsRestrictedFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQuery, GraphqlTypes.GetPortalHeroMetricsRestrictedFieldsQueryVariables>;
export const GetCurrentArenaPortalHeroMetricsDocument = gql`
    query GetCurrentArenaPortalHeroMetrics($currency: CurrencyCode, $investmentFilter: InvestmentFilter) {
  currentArena {
    portalHeroMetricsConfig {
      title
      isTitleVisible
      filterVisibility
      canFilterVisibility
      portalHeroMetricsFields {
        id
        fieldName
        fieldType
        metricValue(currency: $currency, investmentFilter: $investmentFilter)
        extensionField {
          id
          extensionFieldTypeId
        }
        contactInvestmentsFieldName
      }
    }
  }
}
    `;

/**
 * __useGetCurrentArenaPortalHeroMetricsQuery__
 *
 * To run a query within a React component, call `useGetCurrentArenaPortalHeroMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentArenaPortalHeroMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentArenaPortalHeroMetricsQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *      investmentFilter: // value for 'investmentFilter'
 *   },
 * });
 */
export function useGetCurrentArenaPortalHeroMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrentArenaPortalHeroMetricsQuery, GraphqlTypes.GetCurrentArenaPortalHeroMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrentArenaPortalHeroMetricsQuery, GraphqlTypes.GetCurrentArenaPortalHeroMetricsQueryVariables>(GetCurrentArenaPortalHeroMetricsDocument, options);
      }
export function useGetCurrentArenaPortalHeroMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrentArenaPortalHeroMetricsQuery, GraphqlTypes.GetCurrentArenaPortalHeroMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrentArenaPortalHeroMetricsQuery, GraphqlTypes.GetCurrentArenaPortalHeroMetricsQueryVariables>(GetCurrentArenaPortalHeroMetricsDocument, options);
        }
// @ts-ignore
export function useGetCurrentArenaPortalHeroMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaPortalHeroMetricsQuery, GraphqlTypes.GetCurrentArenaPortalHeroMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentArenaPortalHeroMetricsQuery, GraphqlTypes.GetCurrentArenaPortalHeroMetricsQueryVariables>;
export function useGetCurrentArenaPortalHeroMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaPortalHeroMetricsQuery, GraphqlTypes.GetCurrentArenaPortalHeroMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentArenaPortalHeroMetricsQuery | undefined, GraphqlTypes.GetCurrentArenaPortalHeroMetricsQueryVariables>;
export function useGetCurrentArenaPortalHeroMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaPortalHeroMetricsQuery, GraphqlTypes.GetCurrentArenaPortalHeroMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrentArenaPortalHeroMetricsQuery, GraphqlTypes.GetCurrentArenaPortalHeroMetricsQueryVariables>(GetCurrentArenaPortalHeroMetricsDocument, options);
        }
export type GetCurrentArenaPortalHeroMetricsQueryHookResult = ReturnType<typeof useGetCurrentArenaPortalHeroMetricsQuery>;
export type GetCurrentArenaPortalHeroMetricsLazyQueryHookResult = ReturnType<typeof useGetCurrentArenaPortalHeroMetricsLazyQuery>;
export type GetCurrentArenaPortalHeroMetricsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentArenaPortalHeroMetricsSuspenseQuery>;
export type GetCurrentArenaPortalHeroMetricsQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrentArenaPortalHeroMetricsQuery, GraphqlTypes.GetCurrentArenaPortalHeroMetricsQueryVariables>;
export const CreateFieldAccessRoleDocument = gql`
    mutation CreateFieldAccessRole($name: String!) {
  fieldAccessOps {
    createFieldAccessRole(name: $name) {
      fieldAccessRole {
        name
        id
        isDefault
      }
    }
  }
}
    `;
export type CreateFieldAccessRoleMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateFieldAccessRoleMutation, GraphqlTypes.CreateFieldAccessRoleMutationVariables>;

/**
 * __useCreateFieldAccessRoleMutation__
 *
 * To run a mutation, you first call `useCreateFieldAccessRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFieldAccessRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFieldAccessRoleMutation, { data, loading, error }] = useCreateFieldAccessRoleMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateFieldAccessRoleMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateFieldAccessRoleMutation, GraphqlTypes.CreateFieldAccessRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateFieldAccessRoleMutation, GraphqlTypes.CreateFieldAccessRoleMutationVariables>(CreateFieldAccessRoleDocument, options);
      }
export type CreateFieldAccessRoleMutationHookResult = ReturnType<typeof useCreateFieldAccessRoleMutation>;
export type CreateFieldAccessRoleMutationResult = Apollo.MutationResult<GraphqlTypes.CreateFieldAccessRoleMutation>;
export type CreateFieldAccessRoleMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateFieldAccessRoleMutation, GraphqlTypes.CreateFieldAccessRoleMutationVariables>;
export const UpdateFieldAccessRoleDocument = gql`
    mutation UpdateFieldAccessRole($roleId: String!, $makeDefault: Boolean!, $name: String!) {
  fieldAccessOps {
    updateFieldAccessRole(roleId: $roleId, makeDefault: $makeDefault, name: $name) {
      fieldAccessRole {
        name
        id
        isDefault
      }
    }
  }
}
    `;
export type UpdateFieldAccessRoleMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateFieldAccessRoleMutation, GraphqlTypes.UpdateFieldAccessRoleMutationVariables>;

/**
 * __useUpdateFieldAccessRoleMutation__
 *
 * To run a mutation, you first call `useUpdateFieldAccessRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFieldAccessRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFieldAccessRoleMutation, { data, loading, error }] = useUpdateFieldAccessRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      makeDefault: // value for 'makeDefault'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateFieldAccessRoleMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateFieldAccessRoleMutation, GraphqlTypes.UpdateFieldAccessRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateFieldAccessRoleMutation, GraphqlTypes.UpdateFieldAccessRoleMutationVariables>(UpdateFieldAccessRoleDocument, options);
      }
export type UpdateFieldAccessRoleMutationHookResult = ReturnType<typeof useUpdateFieldAccessRoleMutation>;
export type UpdateFieldAccessRoleMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateFieldAccessRoleMutation>;
export type UpdateFieldAccessRoleMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateFieldAccessRoleMutation, GraphqlTypes.UpdateFieldAccessRoleMutationVariables>;
export const DeleteFieldAccessRoleDocument = gql`
    mutation DeleteFieldAccessRole($roleId: ID!) {
  fieldAccessOps {
    deleteFieldAccessRole(roleId: $roleId) {
      accessRoleIdOrError {
        ...DeleteFieldAccessRoleFields
      }
    }
  }
}
    ${DeleteFieldAccessRoleFieldsFragmentDoc}`;
export type DeleteFieldAccessRoleMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteFieldAccessRoleMutation, GraphqlTypes.DeleteFieldAccessRoleMutationVariables>;

/**
 * __useDeleteFieldAccessRoleMutation__
 *
 * To run a mutation, you first call `useDeleteFieldAccessRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFieldAccessRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFieldAccessRoleMutation, { data, loading, error }] = useDeleteFieldAccessRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useDeleteFieldAccessRoleMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteFieldAccessRoleMutation, GraphqlTypes.DeleteFieldAccessRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteFieldAccessRoleMutation, GraphqlTypes.DeleteFieldAccessRoleMutationVariables>(DeleteFieldAccessRoleDocument, options);
      }
export type DeleteFieldAccessRoleMutationHookResult = ReturnType<typeof useDeleteFieldAccessRoleMutation>;
export type DeleteFieldAccessRoleMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteFieldAccessRoleMutation>;
export type DeleteFieldAccessRoleMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteFieldAccessRoleMutation, GraphqlTypes.DeleteFieldAccessRoleMutationVariables>;
export const GetFieldAccessRolesDocument = gql`
    query GetFieldAccessRoles {
  currentArena {
    features {
      hasDataAccessRoleUse
    }
  }
  unusedContactsCount
  fieldAccessRoles {
    contactUsageCount
    id
    isDefault
    name
    restrictedFieldCount
  }
}
    `;

/**
 * __useGetFieldAccessRolesQuery__
 *
 * To run a query within a React component, call `useGetFieldAccessRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldAccessRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldAccessRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFieldAccessRolesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetFieldAccessRolesQuery, GraphqlTypes.GetFieldAccessRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFieldAccessRolesQuery, GraphqlTypes.GetFieldAccessRolesQueryVariables>(GetFieldAccessRolesDocument, options);
      }
export function useGetFieldAccessRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFieldAccessRolesQuery, GraphqlTypes.GetFieldAccessRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFieldAccessRolesQuery, GraphqlTypes.GetFieldAccessRolesQueryVariables>(GetFieldAccessRolesDocument, options);
        }
// @ts-ignore
export function useGetFieldAccessRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFieldAccessRolesQuery, GraphqlTypes.GetFieldAccessRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFieldAccessRolesQuery, GraphqlTypes.GetFieldAccessRolesQueryVariables>;
export function useGetFieldAccessRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFieldAccessRolesQuery, GraphqlTypes.GetFieldAccessRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFieldAccessRolesQuery | undefined, GraphqlTypes.GetFieldAccessRolesQueryVariables>;
export function useGetFieldAccessRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFieldAccessRolesQuery, GraphqlTypes.GetFieldAccessRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFieldAccessRolesQuery, GraphqlTypes.GetFieldAccessRolesQueryVariables>(GetFieldAccessRolesDocument, options);
        }
export type GetFieldAccessRolesQueryHookResult = ReturnType<typeof useGetFieldAccessRolesQuery>;
export type GetFieldAccessRolesLazyQueryHookResult = ReturnType<typeof useGetFieldAccessRolesLazyQuery>;
export type GetFieldAccessRolesSuspenseQueryHookResult = ReturnType<typeof useGetFieldAccessRolesSuspenseQuery>;
export type GetFieldAccessRolesQueryResult = Apollo.QueryResult<GraphqlTypes.GetFieldAccessRolesQuery, GraphqlTypes.GetFieldAccessRolesQueryVariables>;
export const CreateDistributionInstanceDocument = gql`
    mutation CreateDistributionInstance($input: CreateDistributionInstanceInput!) {
  distributionOps {
    createDistributionInstance(input: $input) {
      id
      batch {
        id
        description
      }
      position {
        id
        account {
          id
          name
        }
      }
      details {
        edges {
          node {
            id
            transactionType {
              id
              name
            }
            amountDistributed {
              monies
            }
            amountRecallable {
              monies
            }
          }
        }
      }
    }
  }
}
    `;
export type CreateDistributionInstanceMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateDistributionInstanceMutation, GraphqlTypes.CreateDistributionInstanceMutationVariables>;

/**
 * __useCreateDistributionInstanceMutation__
 *
 * To run a mutation, you first call `useCreateDistributionInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDistributionInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDistributionInstanceMutation, { data, loading, error }] = useCreateDistributionInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDistributionInstanceMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateDistributionInstanceMutation, GraphqlTypes.CreateDistributionInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateDistributionInstanceMutation, GraphqlTypes.CreateDistributionInstanceMutationVariables>(CreateDistributionInstanceDocument, options);
      }
export type CreateDistributionInstanceMutationHookResult = ReturnType<typeof useCreateDistributionInstanceMutation>;
export type CreateDistributionInstanceMutationResult = Apollo.MutationResult<GraphqlTypes.CreateDistributionInstanceMutation>;
export type CreateDistributionInstanceMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateDistributionInstanceMutation, GraphqlTypes.CreateDistributionInstanceMutationVariables>;
export const DeleteEditorTemplateDocument = gql`
    mutation DeleteEditorTemplate($editorTemplateInput: DeleteEditorTemplateInput!) {
  editorTemplateOps {
    deleteEditorTemplate(editorTemplateInput: $editorTemplateInput) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on EditorTemplateObjectType {
        id
        name
      }
    }
  }
}
    `;
export type DeleteEditorTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteEditorTemplateMutation, GraphqlTypes.DeleteEditorTemplateMutationVariables>;

/**
 * __useDeleteEditorTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteEditorTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEditorTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEditorTemplateMutation, { data, loading, error }] = useDeleteEditorTemplateMutation({
 *   variables: {
 *      editorTemplateInput: // value for 'editorTemplateInput'
 *   },
 * });
 */
export function useDeleteEditorTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteEditorTemplateMutation, GraphqlTypes.DeleteEditorTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteEditorTemplateMutation, GraphqlTypes.DeleteEditorTemplateMutationVariables>(DeleteEditorTemplateDocument, options);
      }
export type DeleteEditorTemplateMutationHookResult = ReturnType<typeof useDeleteEditorTemplateMutation>;
export type DeleteEditorTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteEditorTemplateMutation>;
export type DeleteEditorTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteEditorTemplateMutation, GraphqlTypes.DeleteEditorTemplateMutationVariables>;
export const GetEditorTemplatesDocument = gql`
    query GetEditorTemplates($templateTypes: [String]!, $objectType: Int!, $objectId: Int, $sort: [EditorTemplateObjectTypeSortEnum], $before: String, $after: String, $first: Int, $last: Int) {
  editorTemplates(
    templateTypes: $templateTypes
    objectType: $objectType
    objectId: $objectId
    sort: $sort
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        id
        name
        htmlBody
        objectType
        templateMetadata
        templateType
        savedToAllObjects
        createdAt
        modifiedAt
        owner {
          id
          fullName
        }
        objectMaps {
          globalObjectId
          objectType
        }
      }
      cursor
    }
    count
  }
}
    `;

/**
 * __useGetEditorTemplatesQuery__
 *
 * To run a query within a React component, call `useGetEditorTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditorTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditorTemplatesQuery({
 *   variables: {
 *      templateTypes: // value for 'templateTypes'
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *      sort: // value for 'sort'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetEditorTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEditorTemplatesQuery, GraphqlTypes.GetEditorTemplatesQueryVariables> & ({ variables: GraphqlTypes.GetEditorTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEditorTemplatesQuery, GraphqlTypes.GetEditorTemplatesQueryVariables>(GetEditorTemplatesDocument, options);
      }
export function useGetEditorTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEditorTemplatesQuery, GraphqlTypes.GetEditorTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEditorTemplatesQuery, GraphqlTypes.GetEditorTemplatesQueryVariables>(GetEditorTemplatesDocument, options);
        }
// @ts-ignore
export function useGetEditorTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditorTemplatesQuery, GraphqlTypes.GetEditorTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEditorTemplatesQuery, GraphqlTypes.GetEditorTemplatesQueryVariables>;
export function useGetEditorTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditorTemplatesQuery, GraphqlTypes.GetEditorTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEditorTemplatesQuery | undefined, GraphqlTypes.GetEditorTemplatesQueryVariables>;
export function useGetEditorTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditorTemplatesQuery, GraphqlTypes.GetEditorTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEditorTemplatesQuery, GraphqlTypes.GetEditorTemplatesQueryVariables>(GetEditorTemplatesDocument, options);
        }
export type GetEditorTemplatesQueryHookResult = ReturnType<typeof useGetEditorTemplatesQuery>;
export type GetEditorTemplatesLazyQueryHookResult = ReturnType<typeof useGetEditorTemplatesLazyQuery>;
export type GetEditorTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetEditorTemplatesSuspenseQuery>;
export type GetEditorTemplatesQueryResult = Apollo.QueryResult<GraphqlTypes.GetEditorTemplatesQuery, GraphqlTypes.GetEditorTemplatesQueryVariables>;
export const GetEmailMergeFieldsDocument = gql`
    query GetEmailMergeFields($objectInput: EmailMergeFieldsInput!) {
  emailMergeFields(objectInput: $objectInput)
}
    `;

/**
 * __useGetEmailMergeFieldsQuery__
 *
 * To run a query within a React component, call `useGetEmailMergeFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailMergeFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailMergeFieldsQuery({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useGetEmailMergeFieldsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEmailMergeFieldsQuery, GraphqlTypes.GetEmailMergeFieldsQueryVariables> & ({ variables: GraphqlTypes.GetEmailMergeFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEmailMergeFieldsQuery, GraphqlTypes.GetEmailMergeFieldsQueryVariables>(GetEmailMergeFieldsDocument, options);
      }
export function useGetEmailMergeFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEmailMergeFieldsQuery, GraphqlTypes.GetEmailMergeFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEmailMergeFieldsQuery, GraphqlTypes.GetEmailMergeFieldsQueryVariables>(GetEmailMergeFieldsDocument, options);
        }
// @ts-ignore
export function useGetEmailMergeFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailMergeFieldsQuery, GraphqlTypes.GetEmailMergeFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailMergeFieldsQuery, GraphqlTypes.GetEmailMergeFieldsQueryVariables>;
export function useGetEmailMergeFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailMergeFieldsQuery, GraphqlTypes.GetEmailMergeFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailMergeFieldsQuery | undefined, GraphqlTypes.GetEmailMergeFieldsQueryVariables>;
export function useGetEmailMergeFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailMergeFieldsQuery, GraphqlTypes.GetEmailMergeFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEmailMergeFieldsQuery, GraphqlTypes.GetEmailMergeFieldsQueryVariables>(GetEmailMergeFieldsDocument, options);
        }
export type GetEmailMergeFieldsQueryHookResult = ReturnType<typeof useGetEmailMergeFieldsQuery>;
export type GetEmailMergeFieldsLazyQueryHookResult = ReturnType<typeof useGetEmailMergeFieldsLazyQuery>;
export type GetEmailMergeFieldsSuspenseQueryHookResult = ReturnType<typeof useGetEmailMergeFieldsSuspenseQuery>;
export type GetEmailMergeFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEmailMergeFieldsQuery, GraphqlTypes.GetEmailMergeFieldsQueryVariables>;
export const CreateDocumentVersionDocument = gql`
    mutation CreateDocumentVersion($objectInput: CreateDocumentVersionInput!) {
  createDocumentVersion(objectInput: $objectInput) {
    ... on DocumentVersionObjectType {
      id
      downloadUrl
      embedUrl
      directDownloadUrl
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type CreateDocumentVersionMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateDocumentVersionMutation, GraphqlTypes.CreateDocumentVersionMutationVariables>;

/**
 * __useCreateDocumentVersionMutation__
 *
 * To run a mutation, you first call `useCreateDocumentVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentVersionMutation, { data, loading, error }] = useCreateDocumentVersionMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useCreateDocumentVersionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateDocumentVersionMutation, GraphqlTypes.CreateDocumentVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateDocumentVersionMutation, GraphqlTypes.CreateDocumentVersionMutationVariables>(CreateDocumentVersionDocument, options);
      }
export type CreateDocumentVersionMutationHookResult = ReturnType<typeof useCreateDocumentVersionMutation>;
export type CreateDocumentVersionMutationResult = Apollo.MutationResult<GraphqlTypes.CreateDocumentVersionMutation>;
export type CreateDocumentVersionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateDocumentVersionMutation, GraphqlTypes.CreateDocumentVersionMutationVariables>;
export const GetEmailBatchDocument = gql`
    query getEmailBatch($id: ID!) {
  emailBatch(id: $id) {
    id
    objectId
    objectType
    recipientObjectType
    attachedDocuments {
      ... on RestrictedDocumentObjectType {
        id
      }
      ... on DocumentObjectType {
        id
      }
    }
    recipients {
      toAddresses {
        emailAddress
        name
        error
      }
      ccAddresses {
        emailAddress
        name
        error
      }
      bccAddresses {
        emailAddress
        name
        error
      }
      recipientTitle
      recipientObjectId
      recipientObjectType
    }
    unpublishedTransactions {
      ...GetEmailBatchCapitalCall
      ...GetEmailBatchDistribution
      ...GetEmailBatchManagementFee
      ...GetEmailBatchNetIncome
      ...GetEmailBatchTransaction
      ...GetEmailBatchNav
      ...GetEmailBatchUnitValue
    }
    publishedTransactions {
      ...GetEmailBatchCapitalCall
      ...GetEmailBatchDistribution
      ...GetEmailBatchManagementFee
      ...GetEmailBatchNetIncome
      ...GetEmailBatchTransaction
      ...GetEmailBatchNav
      ...GetEmailBatchUnitValue
    }
    publicationDocument {
      id
    }
    publication {
      id
    }
    userCanPublishEmailBatchTransactions
    approvedDocumentsInfo {
      approvedDocuments {
        id
        name
        currentVersion {
          size
        }
        isCollection
      }
      userCanPublish
    }
    hasUnattachedPublicationDocument
    templateType
    emailDistributionList {
      name
    }
    emailGranularity
    contactRecipientMap
  }
}
    ${GetEmailBatchCapitalCallFragmentDoc}
${GetEmailBatchDistributionFragmentDoc}
${GetEmailBatchManagementFeeFragmentDoc}
${GetEmailBatchNetIncomeFragmentDoc}
${GetEmailBatchTransactionFragmentDoc}
${GetEmailBatchNavFragmentDoc}
${GetEmailBatchUnitValueFragmentDoc}`;

/**
 * __useGetEmailBatchQuery__
 *
 * To run a query within a React component, call `useGetEmailBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailBatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmailBatchQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEmailBatchQuery, GraphqlTypes.GetEmailBatchQueryVariables> & ({ variables: GraphqlTypes.GetEmailBatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEmailBatchQuery, GraphqlTypes.GetEmailBatchQueryVariables>(GetEmailBatchDocument, options);
      }
export function useGetEmailBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEmailBatchQuery, GraphqlTypes.GetEmailBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEmailBatchQuery, GraphqlTypes.GetEmailBatchQueryVariables>(GetEmailBatchDocument, options);
        }
// @ts-ignore
export function useGetEmailBatchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailBatchQuery, GraphqlTypes.GetEmailBatchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailBatchQuery, GraphqlTypes.GetEmailBatchQueryVariables>;
export function useGetEmailBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailBatchQuery, GraphqlTypes.GetEmailBatchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailBatchQuery | undefined, GraphqlTypes.GetEmailBatchQueryVariables>;
export function useGetEmailBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailBatchQuery, GraphqlTypes.GetEmailBatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEmailBatchQuery, GraphqlTypes.GetEmailBatchQueryVariables>(GetEmailBatchDocument, options);
        }
export type GetEmailBatchQueryHookResult = ReturnType<typeof useGetEmailBatchQuery>;
export type GetEmailBatchLazyQueryHookResult = ReturnType<typeof useGetEmailBatchLazyQuery>;
export type GetEmailBatchSuspenseQueryHookResult = ReturnType<typeof useGetEmailBatchSuspenseQuery>;
export type GetEmailBatchQueryResult = Apollo.QueryResult<GraphqlTypes.GetEmailBatchQuery, GraphqlTypes.GetEmailBatchQueryVariables>;
export const SetManagedEmailServiceProviderDocument = gql`
    mutation SetManagedEmailServiceProvider($emailDomain: String!, $sharedAccountName: String, $sharedAccountEmailAddress: String, $requireConfirmationBeforeEmailSend: Boolean) {
  emailSettingsOps {
    setManagedEmailSettings(
      emailDomain: $emailDomain
      sharedAccountName: $sharedAccountName
      sharedAccountEmailAddress: $sharedAccountEmailAddress
      requireConfirmationBeforeEmailSend: $requireConfirmationBeforeEmailSend
    ) {
      error
      emailSettings {
        id
        emailSettingsVerificationState
        emailDomain
        sharedAccountName
        sharedAccountEmailAddress
        cnameRecord1 {
          id
          host
          value
          isVerified
        }
        cnameRecord2 {
          id
          host
          value
          isVerified
        }
        orgSmtpAuthMethod
        smtpHost
        smtpUserName
        smtpPasswordIsSet
        requireConfirmationBeforeEmailSend
      }
    }
  }
}
    `;
export type SetManagedEmailServiceProviderMutationFn = Apollo.MutationFunction<GraphqlTypes.SetManagedEmailServiceProviderMutation, GraphqlTypes.SetManagedEmailServiceProviderMutationVariables>;

/**
 * __useSetManagedEmailServiceProviderMutation__
 *
 * To run a mutation, you first call `useSetManagedEmailServiceProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetManagedEmailServiceProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setManagedEmailServiceProviderMutation, { data, loading, error }] = useSetManagedEmailServiceProviderMutation({
 *   variables: {
 *      emailDomain: // value for 'emailDomain'
 *      sharedAccountName: // value for 'sharedAccountName'
 *      sharedAccountEmailAddress: // value for 'sharedAccountEmailAddress'
 *      requireConfirmationBeforeEmailSend: // value for 'requireConfirmationBeforeEmailSend'
 *   },
 * });
 */
export function useSetManagedEmailServiceProviderMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetManagedEmailServiceProviderMutation, GraphqlTypes.SetManagedEmailServiceProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetManagedEmailServiceProviderMutation, GraphqlTypes.SetManagedEmailServiceProviderMutationVariables>(SetManagedEmailServiceProviderDocument, options);
      }
export type SetManagedEmailServiceProviderMutationHookResult = ReturnType<typeof useSetManagedEmailServiceProviderMutation>;
export type SetManagedEmailServiceProviderMutationResult = Apollo.MutationResult<GraphqlTypes.SetManagedEmailServiceProviderMutation>;
export type SetManagedEmailServiceProviderMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetManagedEmailServiceProviderMutation, GraphqlTypes.SetManagedEmailServiceProviderMutationVariables>;
export const SetOrgSmtpEmailSettingsDocument = gql`
    mutation SetOrgSmtpEmailSettings($emailDomain: String!, $smtpHost: String!, $sharedAccountName: String!, $sharedAccountEmailAddress: String!, $authMethod: OrgSmtpAuthMethods!, $smtpUserName: String, $smtpPassword: String, $tenantId: String, $clientId: String, $clientSecret: String, $requireConfirmationBeforeEmailSend: Boolean) {
  emailSettingsOps {
    setOrgSmtpEmailSettings(
      emailDomain: $emailDomain
      smtpHost: $smtpHost
      sharedAccountName: $sharedAccountName
      sharedAccountEmailAddress: $sharedAccountEmailAddress
      authMethod: $authMethod
      smtpUserName: $smtpUserName
      smtpPassword: $smtpPassword
      tenantId: $tenantId
      clientId: $clientId
      clientSecret: $clientSecret
      requireConfirmationBeforeEmailSend: $requireConfirmationBeforeEmailSend
    ) {
      error
      emailSettings {
        id
        emailSettingsVerificationState
        emailDomain
        sharedAccountName
        sharedAccountEmailAddress
        cnameRecord1 {
          id
          host
          value
          isVerified
        }
        cnameRecord2 {
          id
          host
          value
          isVerified
        }
        orgSmtpAuthMethod
        smtpHost
        smtpUserName
        smtpPasswordIsSet
        tenantId
        clientId
        requireConfirmationBeforeEmailSend
      }
    }
  }
}
    `;
export type SetOrgSmtpEmailSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.SetOrgSmtpEmailSettingsMutation, GraphqlTypes.SetOrgSmtpEmailSettingsMutationVariables>;

/**
 * __useSetOrgSmtpEmailSettingsMutation__
 *
 * To run a mutation, you first call `useSetOrgSmtpEmailSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrgSmtpEmailSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrgSmtpEmailSettingsMutation, { data, loading, error }] = useSetOrgSmtpEmailSettingsMutation({
 *   variables: {
 *      emailDomain: // value for 'emailDomain'
 *      smtpHost: // value for 'smtpHost'
 *      sharedAccountName: // value for 'sharedAccountName'
 *      sharedAccountEmailAddress: // value for 'sharedAccountEmailAddress'
 *      authMethod: // value for 'authMethod'
 *      smtpUserName: // value for 'smtpUserName'
 *      smtpPassword: // value for 'smtpPassword'
 *      tenantId: // value for 'tenantId'
 *      clientId: // value for 'clientId'
 *      clientSecret: // value for 'clientSecret'
 *      requireConfirmationBeforeEmailSend: // value for 'requireConfirmationBeforeEmailSend'
 *   },
 * });
 */
export function useSetOrgSmtpEmailSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetOrgSmtpEmailSettingsMutation, GraphqlTypes.SetOrgSmtpEmailSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetOrgSmtpEmailSettingsMutation, GraphqlTypes.SetOrgSmtpEmailSettingsMutationVariables>(SetOrgSmtpEmailSettingsDocument, options);
      }
export type SetOrgSmtpEmailSettingsMutationHookResult = ReturnType<typeof useSetOrgSmtpEmailSettingsMutation>;
export type SetOrgSmtpEmailSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.SetOrgSmtpEmailSettingsMutation>;
export type SetOrgSmtpEmailSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetOrgSmtpEmailSettingsMutation, GraphqlTypes.SetOrgSmtpEmailSettingsMutationVariables>;
export const StartOrgSmtpVerificationJobDocument = gql`
    mutation StartOrgSmtpVerificationJob {
  emailSettingsOps {
    startOrgSmtpVerificationJob {
      job {
        id
      }
    }
  }
}
    `;
export type StartOrgSmtpVerificationJobMutationFn = Apollo.MutationFunction<GraphqlTypes.StartOrgSmtpVerificationJobMutation, GraphqlTypes.StartOrgSmtpVerificationJobMutationVariables>;

/**
 * __useStartOrgSmtpVerificationJobMutation__
 *
 * To run a mutation, you first call `useStartOrgSmtpVerificationJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOrgSmtpVerificationJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOrgSmtpVerificationJobMutation, { data, loading, error }] = useStartOrgSmtpVerificationJobMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartOrgSmtpVerificationJobMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.StartOrgSmtpVerificationJobMutation, GraphqlTypes.StartOrgSmtpVerificationJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.StartOrgSmtpVerificationJobMutation, GraphqlTypes.StartOrgSmtpVerificationJobMutationVariables>(StartOrgSmtpVerificationJobDocument, options);
      }
export type StartOrgSmtpVerificationJobMutationHookResult = ReturnType<typeof useStartOrgSmtpVerificationJobMutation>;
export type StartOrgSmtpVerificationJobMutationResult = Apollo.MutationResult<GraphqlTypes.StartOrgSmtpVerificationJobMutation>;
export type StartOrgSmtpVerificationJobMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.StartOrgSmtpVerificationJobMutation, GraphqlTypes.StartOrgSmtpVerificationJobMutationVariables>;
export const StartSendManagedEmailDnsInstructionEmailJobDocument = gql`
    mutation StartSendManagedEmailDnsInstructionEmailJob {
  emailSettingsOps {
    startSendManagedEmailDnsInstructionEmailJob {
      job {
        id
      }
    }
  }
}
    `;
export type StartSendManagedEmailDnsInstructionEmailJobMutationFn = Apollo.MutationFunction<GraphqlTypes.StartSendManagedEmailDnsInstructionEmailJobMutation, GraphqlTypes.StartSendManagedEmailDnsInstructionEmailJobMutationVariables>;

/**
 * __useStartSendManagedEmailDnsInstructionEmailJobMutation__
 *
 * To run a mutation, you first call `useStartSendManagedEmailDnsInstructionEmailJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSendManagedEmailDnsInstructionEmailJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSendManagedEmailDnsInstructionEmailJobMutation, { data, loading, error }] = useStartSendManagedEmailDnsInstructionEmailJobMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartSendManagedEmailDnsInstructionEmailJobMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.StartSendManagedEmailDnsInstructionEmailJobMutation, GraphqlTypes.StartSendManagedEmailDnsInstructionEmailJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.StartSendManagedEmailDnsInstructionEmailJobMutation, GraphqlTypes.StartSendManagedEmailDnsInstructionEmailJobMutationVariables>(StartSendManagedEmailDnsInstructionEmailJobDocument, options);
      }
export type StartSendManagedEmailDnsInstructionEmailJobMutationHookResult = ReturnType<typeof useStartSendManagedEmailDnsInstructionEmailJobMutation>;
export type StartSendManagedEmailDnsInstructionEmailJobMutationResult = Apollo.MutationResult<GraphqlTypes.StartSendManagedEmailDnsInstructionEmailJobMutation>;
export type StartSendManagedEmailDnsInstructionEmailJobMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.StartSendManagedEmailDnsInstructionEmailJobMutation, GraphqlTypes.StartSendManagedEmailDnsInstructionEmailJobMutationVariables>;
export const GetEmailSettingsDocument = gql`
    query GetEmailSettings {
  emailSettings {
    id
    emailSettingsVerificationState
    emailDomain
    sharedAccountName
    sharedAccountEmailAddress
    cnameRecord1 {
      id
      host
      value
      isVerified
    }
    cnameRecord2 {
      id
      host
      value
      isVerified
    }
    orgSmtpAuthMethod
    smtpHost
    smtpUserName
    smtpPasswordIsSet
    tenantId
    clientId
    requireConfirmationBeforeEmailSend
    defaultEmailGranularityAccounts
    defaultEmailGranularityPositions
    defaultEmailSender
  }
}
    `;

/**
 * __useGetEmailSettingsQuery__
 *
 * To run a query within a React component, call `useGetEmailSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEmailSettingsQuery, GraphqlTypes.GetEmailSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEmailSettingsQuery, GraphqlTypes.GetEmailSettingsQueryVariables>(GetEmailSettingsDocument, options);
      }
export function useGetEmailSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEmailSettingsQuery, GraphqlTypes.GetEmailSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEmailSettingsQuery, GraphqlTypes.GetEmailSettingsQueryVariables>(GetEmailSettingsDocument, options);
        }
// @ts-ignore
export function useGetEmailSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailSettingsQuery, GraphqlTypes.GetEmailSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailSettingsQuery, GraphqlTypes.GetEmailSettingsQueryVariables>;
export function useGetEmailSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailSettingsQuery, GraphqlTypes.GetEmailSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailSettingsQuery | undefined, GraphqlTypes.GetEmailSettingsQueryVariables>;
export function useGetEmailSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailSettingsQuery, GraphqlTypes.GetEmailSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEmailSettingsQuery, GraphqlTypes.GetEmailSettingsQueryVariables>(GetEmailSettingsDocument, options);
        }
export type GetEmailSettingsQueryHookResult = ReturnType<typeof useGetEmailSettingsQuery>;
export type GetEmailSettingsLazyQueryHookResult = ReturnType<typeof useGetEmailSettingsLazyQuery>;
export type GetEmailSettingsSuspenseQueryHookResult = ReturnType<typeof useGetEmailSettingsSuspenseQuery>;
export type GetEmailSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEmailSettingsQuery, GraphqlTypes.GetEmailSettingsQueryVariables>;
export const GetESignatureLpSignerDocument = gql`
    query GetESignatureLpSigner($id: ID!) {
  eSignatureLpSigner(id: $id) {
    id
    recipientView {
      url
    }
  }
}
    `;

/**
 * __useGetESignatureLpSignerQuery__
 *
 * To run a query within a React component, call `useGetESignatureLpSignerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetESignatureLpSignerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetESignatureLpSignerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetESignatureLpSignerQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetESignatureLpSignerQuery, GraphqlTypes.GetESignatureLpSignerQueryVariables> & ({ variables: GraphqlTypes.GetESignatureLpSignerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetESignatureLpSignerQuery, GraphqlTypes.GetESignatureLpSignerQueryVariables>(GetESignatureLpSignerDocument, options);
      }
export function useGetESignatureLpSignerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetESignatureLpSignerQuery, GraphqlTypes.GetESignatureLpSignerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetESignatureLpSignerQuery, GraphqlTypes.GetESignatureLpSignerQueryVariables>(GetESignatureLpSignerDocument, options);
        }
// @ts-ignore
export function useGetESignatureLpSignerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureLpSignerQuery, GraphqlTypes.GetESignatureLpSignerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureLpSignerQuery, GraphqlTypes.GetESignatureLpSignerQueryVariables>;
export function useGetESignatureLpSignerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureLpSignerQuery, GraphqlTypes.GetESignatureLpSignerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureLpSignerQuery | undefined, GraphqlTypes.GetESignatureLpSignerQueryVariables>;
export function useGetESignatureLpSignerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureLpSignerQuery, GraphqlTypes.GetESignatureLpSignerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetESignatureLpSignerQuery, GraphqlTypes.GetESignatureLpSignerQueryVariables>(GetESignatureLpSignerDocument, options);
        }
export type GetESignatureLpSignerQueryHookResult = ReturnType<typeof useGetESignatureLpSignerQuery>;
export type GetESignatureLpSignerLazyQueryHookResult = ReturnType<typeof useGetESignatureLpSignerLazyQuery>;
export type GetESignatureLpSignerSuspenseQueryHookResult = ReturnType<typeof useGetESignatureLpSignerSuspenseQuery>;
export type GetESignatureLpSignerQueryResult = Apollo.QueryResult<GraphqlTypes.GetESignatureLpSignerQuery, GraphqlTypes.GetESignatureLpSignerQueryVariables>;
export const GetESignatureLpSignerRequestDetailsDocument = gql`
    query GetESignatureLpSignerRequestDetails($id: ID!) {
  eSignatureLpSigner(id: $id) {
    id
    eSignatureRequest {
      id
      soboUserId
    }
  }
  currentArena {
    id
    name
    docusignUserId
  }
}
    `;

/**
 * __useGetESignatureLpSignerRequestDetailsQuery__
 *
 * To run a query within a React component, call `useGetESignatureLpSignerRequestDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetESignatureLpSignerRequestDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetESignatureLpSignerRequestDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetESignatureLpSignerRequestDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetESignatureLpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsQueryVariables> & ({ variables: GraphqlTypes.GetESignatureLpSignerRequestDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetESignatureLpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsQueryVariables>(GetESignatureLpSignerRequestDetailsDocument, options);
      }
export function useGetESignatureLpSignerRequestDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetESignatureLpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetESignatureLpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsQueryVariables>(GetESignatureLpSignerRequestDetailsDocument, options);
        }
// @ts-ignore
export function useGetESignatureLpSignerRequestDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureLpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureLpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsQueryVariables>;
export function useGetESignatureLpSignerRequestDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureLpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureLpSignerRequestDetailsQuery | undefined, GraphqlTypes.GetESignatureLpSignerRequestDetailsQueryVariables>;
export function useGetESignatureLpSignerRequestDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureLpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetESignatureLpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsQueryVariables>(GetESignatureLpSignerRequestDetailsDocument, options);
        }
export type GetESignatureLpSignerRequestDetailsQueryHookResult = ReturnType<typeof useGetESignatureLpSignerRequestDetailsQuery>;
export type GetESignatureLpSignerRequestDetailsLazyQueryHookResult = ReturnType<typeof useGetESignatureLpSignerRequestDetailsLazyQuery>;
export type GetESignatureLpSignerRequestDetailsSuspenseQueryHookResult = ReturnType<typeof useGetESignatureLpSignerRequestDetailsSuspenseQuery>;
export type GetESignatureLpSignerRequestDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetESignatureLpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsQueryVariables>;
export const AccountExportDocument = gql`
    mutation AccountExport($accountIds: [ID], $queryString: String, $includeTaxId: Boolean, $includeExternalId: Boolean, $onlyActivePositions: Boolean) {
  accountOps {
    accountExport(
      accountIds: $accountIds
      queryString: $queryString
      includeTaxId: $includeTaxId
      includeExternalId: $includeExternalId
      onlyActivePositions: $onlyActivePositions
    ) {
      arenaName
      job {
        id
      }
    }
  }
}
    `;
export type AccountExportMutationFn = Apollo.MutationFunction<GraphqlTypes.AccountExportMutation, GraphqlTypes.AccountExportMutationVariables>;

/**
 * __useAccountExportMutation__
 *
 * To run a mutation, you first call `useAccountExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountExportMutation, { data, loading, error }] = useAccountExportMutation({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *      queryString: // value for 'queryString'
 *      includeTaxId: // value for 'includeTaxId'
 *      includeExternalId: // value for 'includeExternalId'
 *      onlyActivePositions: // value for 'onlyActivePositions'
 *   },
 * });
 */
export function useAccountExportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AccountExportMutation, GraphqlTypes.AccountExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AccountExportMutation, GraphqlTypes.AccountExportMutationVariables>(AccountExportDocument, options);
      }
export type AccountExportMutationHookResult = ReturnType<typeof useAccountExportMutation>;
export type AccountExportMutationResult = Apollo.MutationResult<GraphqlTypes.AccountExportMutation>;
export type AccountExportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AccountExportMutation, GraphqlTypes.AccountExportMutationVariables>;
export const GetExportFileUrlDocument = gql`
    query GetExportFileUrl($asyncJobId: ID!) {
  exportFileUrl(asyncJobId: $asyncJobId)
}
    `;

/**
 * __useGetExportFileUrlQuery__
 *
 * To run a query within a React component, call `useGetExportFileUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportFileUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportFileUrlQuery({
 *   variables: {
 *      asyncJobId: // value for 'asyncJobId'
 *   },
 * });
 */
export function useGetExportFileUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetExportFileUrlQuery, GraphqlTypes.GetExportFileUrlQueryVariables> & ({ variables: GraphqlTypes.GetExportFileUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetExportFileUrlQuery, GraphqlTypes.GetExportFileUrlQueryVariables>(GetExportFileUrlDocument, options);
      }
export function useGetExportFileUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetExportFileUrlQuery, GraphqlTypes.GetExportFileUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetExportFileUrlQuery, GraphqlTypes.GetExportFileUrlQueryVariables>(GetExportFileUrlDocument, options);
        }
// @ts-ignore
export function useGetExportFileUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExportFileUrlQuery, GraphqlTypes.GetExportFileUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExportFileUrlQuery, GraphqlTypes.GetExportFileUrlQueryVariables>;
export function useGetExportFileUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExportFileUrlQuery, GraphqlTypes.GetExportFileUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExportFileUrlQuery | undefined, GraphqlTypes.GetExportFileUrlQueryVariables>;
export function useGetExportFileUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExportFileUrlQuery, GraphqlTypes.GetExportFileUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetExportFileUrlQuery, GraphqlTypes.GetExportFileUrlQueryVariables>(GetExportFileUrlDocument, options);
        }
export type GetExportFileUrlQueryHookResult = ReturnType<typeof useGetExportFileUrlQuery>;
export type GetExportFileUrlLazyQueryHookResult = ReturnType<typeof useGetExportFileUrlLazyQuery>;
export type GetExportFileUrlSuspenseQueryHookResult = ReturnType<typeof useGetExportFileUrlSuspenseQuery>;
export type GetExportFileUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetExportFileUrlQuery, GraphqlTypes.GetExportFileUrlQueryVariables>;
export const CommunicationSettingsExportDocument = gql`
    mutation CommunicationSettingsExport($accountIds: [ID], $queryString: String) {
  accountOps {
    communicationSettingsExport(accountIds: $accountIds, queryString: $queryString) {
      job {
        id
      }
    }
  }
}
    `;
export type CommunicationSettingsExportMutationFn = Apollo.MutationFunction<GraphqlTypes.CommunicationSettingsExportMutation, GraphqlTypes.CommunicationSettingsExportMutationVariables>;

/**
 * __useCommunicationSettingsExportMutation__
 *
 * To run a mutation, you first call `useCommunicationSettingsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommunicationSettingsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [communicationSettingsExportMutation, { data, loading, error }] = useCommunicationSettingsExportMutation({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *      queryString: // value for 'queryString'
 *   },
 * });
 */
export function useCommunicationSettingsExportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CommunicationSettingsExportMutation, GraphqlTypes.CommunicationSettingsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CommunicationSettingsExportMutation, GraphqlTypes.CommunicationSettingsExportMutationVariables>(CommunicationSettingsExportDocument, options);
      }
export type CommunicationSettingsExportMutationHookResult = ReturnType<typeof useCommunicationSettingsExportMutation>;
export type CommunicationSettingsExportMutationResult = Apollo.MutationResult<GraphqlTypes.CommunicationSettingsExportMutation>;
export type CommunicationSettingsExportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CommunicationSettingsExportMutation, GraphqlTypes.CommunicationSettingsExportMutationVariables>;
export const ManageObjectGroupMembershipBulkDocument = gql`
    mutation ManageObjectGroupMembershipBulk($manageObjectGroupMembershipBulkInput: ManageObjectGroupMembershipBulkInput!) {
  manageObjectGroupMembershipBulk(
    manageObjectGroupMembershipBulkInput: $manageObjectGroupMembershipBulkInput
  ) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type ManageObjectGroupMembershipBulkMutationFn = Apollo.MutationFunction<GraphqlTypes.ManageObjectGroupMembershipBulkMutation, GraphqlTypes.ManageObjectGroupMembershipBulkMutationVariables>;

/**
 * __useManageObjectGroupMembershipBulkMutation__
 *
 * To run a mutation, you first call `useManageObjectGroupMembershipBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageObjectGroupMembershipBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageObjectGroupMembershipBulkMutation, { data, loading, error }] = useManageObjectGroupMembershipBulkMutation({
 *   variables: {
 *      manageObjectGroupMembershipBulkInput: // value for 'manageObjectGroupMembershipBulkInput'
 *   },
 * });
 */
export function useManageObjectGroupMembershipBulkMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ManageObjectGroupMembershipBulkMutation, GraphqlTypes.ManageObjectGroupMembershipBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ManageObjectGroupMembershipBulkMutation, GraphqlTypes.ManageObjectGroupMembershipBulkMutationVariables>(ManageObjectGroupMembershipBulkDocument, options);
      }
export type ManageObjectGroupMembershipBulkMutationHookResult = ReturnType<typeof useManageObjectGroupMembershipBulkMutation>;
export type ManageObjectGroupMembershipBulkMutationResult = Apollo.MutationResult<GraphqlTypes.ManageObjectGroupMembershipBulkMutation>;
export type ManageObjectGroupMembershipBulkMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ManageObjectGroupMembershipBulkMutation, GraphqlTypes.ManageObjectGroupMembershipBulkMutationVariables>;
export const SaveContactsGridViewDocument = gql`
    mutation SaveContactsGridView($saveGridViewInput: SaveGridViewInput!) {
  saveGridView(saveGridViewInput: $saveGridViewInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type SaveContactsGridViewMutationFn = Apollo.MutationFunction<GraphqlTypes.SaveContactsGridViewMutation, GraphqlTypes.SaveContactsGridViewMutationVariables>;

/**
 * __useSaveContactsGridViewMutation__
 *
 * To run a mutation, you first call `useSaveContactsGridViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveContactsGridViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveContactsGridViewMutation, { data, loading, error }] = useSaveContactsGridViewMutation({
 *   variables: {
 *      saveGridViewInput: // value for 'saveGridViewInput'
 *   },
 * });
 */
export function useSaveContactsGridViewMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SaveContactsGridViewMutation, GraphqlTypes.SaveContactsGridViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SaveContactsGridViewMutation, GraphqlTypes.SaveContactsGridViewMutationVariables>(SaveContactsGridViewDocument, options);
      }
export type SaveContactsGridViewMutationHookResult = ReturnType<typeof useSaveContactsGridViewMutation>;
export type SaveContactsGridViewMutationResult = Apollo.MutationResult<GraphqlTypes.SaveContactsGridViewMutation>;
export type SaveContactsGridViewMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SaveContactsGridViewMutation, GraphqlTypes.SaveContactsGridViewMutationVariables>;
export const CreateProspectsDocument = gql`
    mutation CreateProspects($prospectsInput: CreateProspectsInput!) {
  createProspects(prospectsInput: $prospectsInput) {
    __typename
    ... on CreateProspectsObjectType {
      prospect {
        id
      }
      newProspectCount
      skippedMessage
    }
    ... on CreateProspectsAsyncResponse {
      jobId
      asyncMessage: message
    }
    ... on MutationErrorResponse {
      errorMessage: message
    }
  }
}
    `;
export type CreateProspectsMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateProspectsMutation, GraphqlTypes.CreateProspectsMutationVariables>;

/**
 * __useCreateProspectsMutation__
 *
 * To run a mutation, you first call `useCreateProspectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProspectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProspectsMutation, { data, loading, error }] = useCreateProspectsMutation({
 *   variables: {
 *      prospectsInput: // value for 'prospectsInput'
 *   },
 * });
 */
export function useCreateProspectsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateProspectsMutation, GraphqlTypes.CreateProspectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateProspectsMutation, GraphqlTypes.CreateProspectsMutationVariables>(CreateProspectsDocument, options);
      }
export type CreateProspectsMutationHookResult = ReturnType<typeof useCreateProspectsMutation>;
export type CreateProspectsMutationResult = Apollo.MutationResult<GraphqlTypes.CreateProspectsMutation>;
export type CreateProspectsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateProspectsMutation, GraphqlTypes.CreateProspectsMutationVariables>;
export const GetAllNonPersonContactsDocument = gql`
    query GetAllNonPersonContacts($after: String, $term: String) {
  allNonPersonContacts(after: $after, term: $term) {
    edges {
      node {
        id
        lastName
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetAllNonPersonContactsQuery__
 *
 * To run a query within a React component, call `useGetAllNonPersonContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNonPersonContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNonPersonContactsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useGetAllNonPersonContactsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAllNonPersonContactsQuery, GraphqlTypes.GetAllNonPersonContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllNonPersonContactsQuery, GraphqlTypes.GetAllNonPersonContactsQueryVariables>(GetAllNonPersonContactsDocument, options);
      }
export function useGetAllNonPersonContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllNonPersonContactsQuery, GraphqlTypes.GetAllNonPersonContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllNonPersonContactsQuery, GraphqlTypes.GetAllNonPersonContactsQueryVariables>(GetAllNonPersonContactsDocument, options);
        }
// @ts-ignore
export function useGetAllNonPersonContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllNonPersonContactsQuery, GraphqlTypes.GetAllNonPersonContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllNonPersonContactsQuery, GraphqlTypes.GetAllNonPersonContactsQueryVariables>;
export function useGetAllNonPersonContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllNonPersonContactsQuery, GraphqlTypes.GetAllNonPersonContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllNonPersonContactsQuery | undefined, GraphqlTypes.GetAllNonPersonContactsQueryVariables>;
export function useGetAllNonPersonContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllNonPersonContactsQuery, GraphqlTypes.GetAllNonPersonContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllNonPersonContactsQuery, GraphqlTypes.GetAllNonPersonContactsQueryVariables>(GetAllNonPersonContactsDocument, options);
        }
export type GetAllNonPersonContactsQueryHookResult = ReturnType<typeof useGetAllNonPersonContactsQuery>;
export type GetAllNonPersonContactsLazyQueryHookResult = ReturnType<typeof useGetAllNonPersonContactsLazyQuery>;
export type GetAllNonPersonContactsSuspenseQueryHookResult = ReturnType<typeof useGetAllNonPersonContactsSuspenseQuery>;
export type GetAllNonPersonContactsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllNonPersonContactsQuery, GraphqlTypes.GetAllNonPersonContactsQueryVariables>;
export const GetAllNonPersonContactsWithAccountsDocument = gql`
    query GetAllNonPersonContactsWithAccounts($after: String) {
  allNonPersonContacts(after: $after) {
    edges {
      node {
        id
        lastName
        accounts {
          id
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetAllNonPersonContactsWithAccountsQuery__
 *
 * To run a query within a React component, call `useGetAllNonPersonContactsWithAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNonPersonContactsWithAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNonPersonContactsWithAccountsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAllNonPersonContactsWithAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAllNonPersonContactsWithAccountsQuery, GraphqlTypes.GetAllNonPersonContactsWithAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllNonPersonContactsWithAccountsQuery, GraphqlTypes.GetAllNonPersonContactsWithAccountsQueryVariables>(GetAllNonPersonContactsWithAccountsDocument, options);
      }
export function useGetAllNonPersonContactsWithAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllNonPersonContactsWithAccountsQuery, GraphqlTypes.GetAllNonPersonContactsWithAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllNonPersonContactsWithAccountsQuery, GraphqlTypes.GetAllNonPersonContactsWithAccountsQueryVariables>(GetAllNonPersonContactsWithAccountsDocument, options);
        }
// @ts-ignore
export function useGetAllNonPersonContactsWithAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllNonPersonContactsWithAccountsQuery, GraphqlTypes.GetAllNonPersonContactsWithAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllNonPersonContactsWithAccountsQuery, GraphqlTypes.GetAllNonPersonContactsWithAccountsQueryVariables>;
export function useGetAllNonPersonContactsWithAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllNonPersonContactsWithAccountsQuery, GraphqlTypes.GetAllNonPersonContactsWithAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllNonPersonContactsWithAccountsQuery | undefined, GraphqlTypes.GetAllNonPersonContactsWithAccountsQueryVariables>;
export function useGetAllNonPersonContactsWithAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllNonPersonContactsWithAccountsQuery, GraphqlTypes.GetAllNonPersonContactsWithAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllNonPersonContactsWithAccountsQuery, GraphqlTypes.GetAllNonPersonContactsWithAccountsQueryVariables>(GetAllNonPersonContactsWithAccountsDocument, options);
        }
export type GetAllNonPersonContactsWithAccountsQueryHookResult = ReturnType<typeof useGetAllNonPersonContactsWithAccountsQuery>;
export type GetAllNonPersonContactsWithAccountsLazyQueryHookResult = ReturnType<typeof useGetAllNonPersonContactsWithAccountsLazyQuery>;
export type GetAllNonPersonContactsWithAccountsSuspenseQueryHookResult = ReturnType<typeof useGetAllNonPersonContactsWithAccountsSuspenseQuery>;
export type GetAllNonPersonContactsWithAccountsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllNonPersonContactsWithAccountsQuery, GraphqlTypes.GetAllNonPersonContactsWithAccountsQueryVariables>;
export const GetExtensionEnumValuesDocument = gql`
    query GetExtensionEnumValues($enumName: String!) {
  extensionFieldEnumValues(enumName: $enumName) {
    enumName
    enumValueLabel
    id
    resourceId
    enumValueCode
    sortOrder
  }
}
    `;

/**
 * __useGetExtensionEnumValuesQuery__
 *
 * To run a query within a React component, call `useGetExtensionEnumValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtensionEnumValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtensionEnumValuesQuery({
 *   variables: {
 *      enumName: // value for 'enumName'
 *   },
 * });
 */
export function useGetExtensionEnumValuesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetExtensionEnumValuesQuery, GraphqlTypes.GetExtensionEnumValuesQueryVariables> & ({ variables: GraphqlTypes.GetExtensionEnumValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetExtensionEnumValuesQuery, GraphqlTypes.GetExtensionEnumValuesQueryVariables>(GetExtensionEnumValuesDocument, options);
      }
export function useGetExtensionEnumValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetExtensionEnumValuesQuery, GraphqlTypes.GetExtensionEnumValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetExtensionEnumValuesQuery, GraphqlTypes.GetExtensionEnumValuesQueryVariables>(GetExtensionEnumValuesDocument, options);
        }
// @ts-ignore
export function useGetExtensionEnumValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionEnumValuesQuery, GraphqlTypes.GetExtensionEnumValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExtensionEnumValuesQuery, GraphqlTypes.GetExtensionEnumValuesQueryVariables>;
export function useGetExtensionEnumValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionEnumValuesQuery, GraphqlTypes.GetExtensionEnumValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExtensionEnumValuesQuery | undefined, GraphqlTypes.GetExtensionEnumValuesQueryVariables>;
export function useGetExtensionEnumValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionEnumValuesQuery, GraphqlTypes.GetExtensionEnumValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetExtensionEnumValuesQuery, GraphqlTypes.GetExtensionEnumValuesQueryVariables>(GetExtensionEnumValuesDocument, options);
        }
export type GetExtensionEnumValuesQueryHookResult = ReturnType<typeof useGetExtensionEnumValuesQuery>;
export type GetExtensionEnumValuesLazyQueryHookResult = ReturnType<typeof useGetExtensionEnumValuesLazyQuery>;
export type GetExtensionEnumValuesSuspenseQueryHookResult = ReturnType<typeof useGetExtensionEnumValuesSuspenseQuery>;
export type GetExtensionEnumValuesQueryResult = Apollo.QueryResult<GraphqlTypes.GetExtensionEnumValuesQuery, GraphqlTypes.GetExtensionEnumValuesQueryVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($contact: CreateContactInput!) {
  contactOps {
    createContact(contact: $contact) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on ContactObjectType {
        id
      }
    }
  }
}
    `;
export type CreateContactMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateContactMutation, GraphqlTypes.CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateContactMutation, GraphqlTypes.CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateContactMutation, GraphqlTypes.CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<GraphqlTypes.CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateContactMutation, GraphqlTypes.CreateContactMutationVariables>;
export const CreateBulkInvestorReportDocument = gql`
    mutation CreateBulkInvestorReport($createBulkInvestorReportInput: CreateBulkInvestorReportInput!) {
  publicationOps {
    createBulkInvestorReport(
      createBulkInvestorReportInput: $createBulkInvestorReportInput
    ) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on PublicationObjectType {
        id
      }
    }
  }
}
    `;
export type CreateBulkInvestorReportMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateBulkInvestorReportMutation, GraphqlTypes.CreateBulkInvestorReportMutationVariables>;

/**
 * __useCreateBulkInvestorReportMutation__
 *
 * To run a mutation, you first call `useCreateBulkInvestorReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkInvestorReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkInvestorReportMutation, { data, loading, error }] = useCreateBulkInvestorReportMutation({
 *   variables: {
 *      createBulkInvestorReportInput: // value for 'createBulkInvestorReportInput'
 *   },
 * });
 */
export function useCreateBulkInvestorReportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateBulkInvestorReportMutation, GraphqlTypes.CreateBulkInvestorReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateBulkInvestorReportMutation, GraphqlTypes.CreateBulkInvestorReportMutationVariables>(CreateBulkInvestorReportDocument, options);
      }
export type CreateBulkInvestorReportMutationHookResult = ReturnType<typeof useCreateBulkInvestorReportMutation>;
export type CreateBulkInvestorReportMutationResult = Apollo.MutationResult<GraphqlTypes.CreateBulkInvestorReportMutation>;
export type CreateBulkInvestorReportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateBulkInvestorReportMutation, GraphqlTypes.CreateBulkInvestorReportMutationVariables>;
export const DeleteContactsConfirmationDocument = gql`
    mutation DeleteContactsConfirmation($deleteContactsInput: DeleteContactsInput!) {
  contactOps {
    deleteContactsConfirmation(deleteContactsInput: $deleteContactsInput) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on ContactDeleteConfirmationObjectType {
        ids
        prospectCount
        accountCount
        portalAccountCount
        duplicateCount
        duplicates
      }
    }
  }
}
    `;
export type DeleteContactsConfirmationMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteContactsConfirmationMutation, GraphqlTypes.DeleteContactsConfirmationMutationVariables>;

/**
 * __useDeleteContactsConfirmationMutation__
 *
 * To run a mutation, you first call `useDeleteContactsConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactsConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactsConfirmationMutation, { data, loading, error }] = useDeleteContactsConfirmationMutation({
 *   variables: {
 *      deleteContactsInput: // value for 'deleteContactsInput'
 *   },
 * });
 */
export function useDeleteContactsConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteContactsConfirmationMutation, GraphqlTypes.DeleteContactsConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteContactsConfirmationMutation, GraphqlTypes.DeleteContactsConfirmationMutationVariables>(DeleteContactsConfirmationDocument, options);
      }
export type DeleteContactsConfirmationMutationHookResult = ReturnType<typeof useDeleteContactsConfirmationMutation>;
export type DeleteContactsConfirmationMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteContactsConfirmationMutation>;
export type DeleteContactsConfirmationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteContactsConfirmationMutation, GraphqlTypes.DeleteContactsConfirmationMutationVariables>;
export const DeleteContactsDocument = gql`
    mutation DeleteContacts($deleteContactsInput: DeleteContactsInput!) {
  contactOps {
    deleteContacts(deleteContactsInput: $deleteContactsInput) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on ContactDeletedCountObjectType {
        deletedCount
        deletedIds
      }
    }
  }
}
    `;
export type DeleteContactsMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteContactsMutation, GraphqlTypes.DeleteContactsMutationVariables>;

/**
 * __useDeleteContactsMutation__
 *
 * To run a mutation, you first call `useDeleteContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactsMutation, { data, loading, error }] = useDeleteContactsMutation({
 *   variables: {
 *      deleteContactsInput: // value for 'deleteContactsInput'
 *   },
 * });
 */
export function useDeleteContactsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteContactsMutation, GraphqlTypes.DeleteContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteContactsMutation, GraphqlTypes.DeleteContactsMutationVariables>(DeleteContactsDocument, options);
      }
export type DeleteContactsMutationHookResult = ReturnType<typeof useDeleteContactsMutation>;
export type DeleteContactsMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteContactsMutation>;
export type DeleteContactsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteContactsMutation, GraphqlTypes.DeleteContactsMutationVariables>;
export const BulkUpdateExtensionFieldsDocument = gql`
    mutation BulkUpdateExtensionFields($bulkUpdateExtensionFieldsInput: BulkUpdateExtensionFieldsInput!) {
  bulkUpdateExtensionFieldsForObjectType(
    bulkUpdateExtensionFieldsInput: $bulkUpdateExtensionFieldsInput
  ) {
    result {
      ... on MutationErrorResponse {
        errorCode
        message
      }
    }
  }
}
    `;
export type BulkUpdateExtensionFieldsMutationFn = Apollo.MutationFunction<GraphqlTypes.BulkUpdateExtensionFieldsMutation, GraphqlTypes.BulkUpdateExtensionFieldsMutationVariables>;

/**
 * __useBulkUpdateExtensionFieldsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateExtensionFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateExtensionFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateExtensionFieldsMutation, { data, loading, error }] = useBulkUpdateExtensionFieldsMutation({
 *   variables: {
 *      bulkUpdateExtensionFieldsInput: // value for 'bulkUpdateExtensionFieldsInput'
 *   },
 * });
 */
export function useBulkUpdateExtensionFieldsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.BulkUpdateExtensionFieldsMutation, GraphqlTypes.BulkUpdateExtensionFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.BulkUpdateExtensionFieldsMutation, GraphqlTypes.BulkUpdateExtensionFieldsMutationVariables>(BulkUpdateExtensionFieldsDocument, options);
      }
export type BulkUpdateExtensionFieldsMutationHookResult = ReturnType<typeof useBulkUpdateExtensionFieldsMutation>;
export type BulkUpdateExtensionFieldsMutationResult = Apollo.MutationResult<GraphqlTypes.BulkUpdateExtensionFieldsMutation>;
export type BulkUpdateExtensionFieldsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.BulkUpdateExtensionFieldsMutation, GraphqlTypes.BulkUpdateExtensionFieldsMutationVariables>;
export const AddAssigneesDocument = gql`
    mutation AddAssignees($addAssigneesInput: AddAssigneesInput!) {
  contactOps {
    addAssignees(addAssigneesInput: $addAssigneesInput) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
    }
  }
}
    `;
export type AddAssigneesMutationFn = Apollo.MutationFunction<GraphqlTypes.AddAssigneesMutation, GraphqlTypes.AddAssigneesMutationVariables>;

/**
 * __useAddAssigneesMutation__
 *
 * To run a mutation, you first call `useAddAssigneesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAssigneesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAssigneesMutation, { data, loading, error }] = useAddAssigneesMutation({
 *   variables: {
 *      addAssigneesInput: // value for 'addAssigneesInput'
 *   },
 * });
 */
export function useAddAssigneesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddAssigneesMutation, GraphqlTypes.AddAssigneesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddAssigneesMutation, GraphqlTypes.AddAssigneesMutationVariables>(AddAssigneesDocument, options);
      }
export type AddAssigneesMutationHookResult = ReturnType<typeof useAddAssigneesMutation>;
export type AddAssigneesMutationResult = Apollo.MutationResult<GraphqlTypes.AddAssigneesMutation>;
export type AddAssigneesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddAssigneesMutation, GraphqlTypes.AddAssigneesMutationVariables>;
export const GetContactsExtensionFieldsDocument = gql`
    query GetContactsExtensionFields($contactIds: [Int!]) {
  contactsExtensionFieldsForBulkEdit(contactIds: $contactIds) {
    extensionFields {
      extensionField {
        id
        name
        extensionFieldTypeId
        enumName
        isMultivalued
        enumValues {
          id
          enumName
          enumValueCode
          enumValueLabel
        }
        activeEnumValues {
          id
          enumName
          enumValueCode
          enumValueLabel
        }
      }
      values {
        ...ExtensionFieldValue
      }
    }
  }
}
    ${ExtensionFieldValueFragmentDoc}`;

/**
 * __useGetContactsExtensionFieldsQuery__
 *
 * To run a query within a React component, call `useGetContactsExtensionFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsExtensionFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsExtensionFieldsQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useGetContactsExtensionFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetContactsExtensionFieldsQuery, GraphqlTypes.GetContactsExtensionFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactsExtensionFieldsQuery, GraphqlTypes.GetContactsExtensionFieldsQueryVariables>(GetContactsExtensionFieldsDocument, options);
      }
export function useGetContactsExtensionFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactsExtensionFieldsQuery, GraphqlTypes.GetContactsExtensionFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactsExtensionFieldsQuery, GraphqlTypes.GetContactsExtensionFieldsQueryVariables>(GetContactsExtensionFieldsDocument, options);
        }
// @ts-ignore
export function useGetContactsExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsExtensionFieldsQuery, GraphqlTypes.GetContactsExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsExtensionFieldsQuery, GraphqlTypes.GetContactsExtensionFieldsQueryVariables>;
export function useGetContactsExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsExtensionFieldsQuery, GraphqlTypes.GetContactsExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsExtensionFieldsQuery | undefined, GraphqlTypes.GetContactsExtensionFieldsQueryVariables>;
export function useGetContactsExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsExtensionFieldsQuery, GraphqlTypes.GetContactsExtensionFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactsExtensionFieldsQuery, GraphqlTypes.GetContactsExtensionFieldsQueryVariables>(GetContactsExtensionFieldsDocument, options);
        }
export type GetContactsExtensionFieldsQueryHookResult = ReturnType<typeof useGetContactsExtensionFieldsQuery>;
export type GetContactsExtensionFieldsLazyQueryHookResult = ReturnType<typeof useGetContactsExtensionFieldsLazyQuery>;
export type GetContactsExtensionFieldsSuspenseQueryHookResult = ReturnType<typeof useGetContactsExtensionFieldsSuspenseQuery>;
export type GetContactsExtensionFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactsExtensionFieldsQuery, GraphqlTypes.GetContactsExtensionFieldsQueryVariables>;
export const GetContactAssigneeMapDocument = gql`
    query GetContactAssigneeMap($contactIds: [Int!]) {
  contactAssigneeMap(contactIds: $contactIds) {
    contactId
    assignee {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetContactAssigneeMapQuery__
 *
 * To run a query within a React component, call `useGetContactAssigneeMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactAssigneeMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactAssigneeMapQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useGetContactAssigneeMapQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetContactAssigneeMapQuery, GraphqlTypes.GetContactAssigneeMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactAssigneeMapQuery, GraphqlTypes.GetContactAssigneeMapQueryVariables>(GetContactAssigneeMapDocument, options);
      }
export function useGetContactAssigneeMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactAssigneeMapQuery, GraphqlTypes.GetContactAssigneeMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactAssigneeMapQuery, GraphqlTypes.GetContactAssigneeMapQueryVariables>(GetContactAssigneeMapDocument, options);
        }
// @ts-ignore
export function useGetContactAssigneeMapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactAssigneeMapQuery, GraphqlTypes.GetContactAssigneeMapQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactAssigneeMapQuery, GraphqlTypes.GetContactAssigneeMapQueryVariables>;
export function useGetContactAssigneeMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactAssigneeMapQuery, GraphqlTypes.GetContactAssigneeMapQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactAssigneeMapQuery | undefined, GraphqlTypes.GetContactAssigneeMapQueryVariables>;
export function useGetContactAssigneeMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactAssigneeMapQuery, GraphqlTypes.GetContactAssigneeMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactAssigneeMapQuery, GraphqlTypes.GetContactAssigneeMapQueryVariables>(GetContactAssigneeMapDocument, options);
        }
export type GetContactAssigneeMapQueryHookResult = ReturnType<typeof useGetContactAssigneeMapQuery>;
export type GetContactAssigneeMapLazyQueryHookResult = ReturnType<typeof useGetContactAssigneeMapLazyQuery>;
export type GetContactAssigneeMapSuspenseQueryHookResult = ReturnType<typeof useGetContactAssigneeMapSuspenseQuery>;
export type GetContactAssigneeMapQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactAssigneeMapQuery, GraphqlTypes.GetContactAssigneeMapQueryVariables>;
export const GetAllAssigneeUsersDocument = gql`
    query GetAllAssigneeUsers {
  staffUsers {
    id
    fullName
  }
}
    `;

/**
 * __useGetAllAssigneeUsersQuery__
 *
 * To run a query within a React component, call `useGetAllAssigneeUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAssigneeUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAssigneeUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllAssigneeUsersQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAllAssigneeUsersQuery, GraphqlTypes.GetAllAssigneeUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllAssigneeUsersQuery, GraphqlTypes.GetAllAssigneeUsersQueryVariables>(GetAllAssigneeUsersDocument, options);
      }
export function useGetAllAssigneeUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllAssigneeUsersQuery, GraphqlTypes.GetAllAssigneeUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllAssigneeUsersQuery, GraphqlTypes.GetAllAssigneeUsersQueryVariables>(GetAllAssigneeUsersDocument, options);
        }
// @ts-ignore
export function useGetAllAssigneeUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllAssigneeUsersQuery, GraphqlTypes.GetAllAssigneeUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllAssigneeUsersQuery, GraphqlTypes.GetAllAssigneeUsersQueryVariables>;
export function useGetAllAssigneeUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllAssigneeUsersQuery, GraphqlTypes.GetAllAssigneeUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllAssigneeUsersQuery | undefined, GraphqlTypes.GetAllAssigneeUsersQueryVariables>;
export function useGetAllAssigneeUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllAssigneeUsersQuery, GraphqlTypes.GetAllAssigneeUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllAssigneeUsersQuery, GraphqlTypes.GetAllAssigneeUsersQueryVariables>(GetAllAssigneeUsersDocument, options);
        }
export type GetAllAssigneeUsersQueryHookResult = ReturnType<typeof useGetAllAssigneeUsersQuery>;
export type GetAllAssigneeUsersLazyQueryHookResult = ReturnType<typeof useGetAllAssigneeUsersLazyQuery>;
export type GetAllAssigneeUsersSuspenseQueryHookResult = ReturnType<typeof useGetAllAssigneeUsersSuspenseQuery>;
export type GetAllAssigneeUsersQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllAssigneeUsersQuery, GraphqlTypes.GetAllAssigneeUsersQueryVariables>;
export const ImportContactsDocument = gql`
    mutation ImportContacts($importContactsInput: ImportContactsInput!) {
  contactOps {
    importContacts(importContactsInput: $importContactsInput) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on ImportContactsObject {
        job {
          id
          status
          data
          jobType
        }
      }
    }
  }
}
    `;
export type ImportContactsMutationFn = Apollo.MutationFunction<GraphqlTypes.ImportContactsMutation, GraphqlTypes.ImportContactsMutationVariables>;

/**
 * __useImportContactsMutation__
 *
 * To run a mutation, you first call `useImportContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importContactsMutation, { data, loading, error }] = useImportContactsMutation({
 *   variables: {
 *      importContactsInput: // value for 'importContactsInput'
 *   },
 * });
 */
export function useImportContactsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ImportContactsMutation, GraphqlTypes.ImportContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ImportContactsMutation, GraphqlTypes.ImportContactsMutationVariables>(ImportContactsDocument, options);
      }
export type ImportContactsMutationHookResult = ReturnType<typeof useImportContactsMutation>;
export type ImportContactsMutationResult = Apollo.MutationResult<GraphqlTypes.ImportContactsMutation>;
export type ImportContactsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ImportContactsMutation, GraphqlTypes.ImportContactsMutationVariables>;
export const CreateEmailBatchDocument = gql`
    mutation createEmailBatch($emailBatchInput: CreateEmailBatchInput!) {
  emailOps {
    createEmailBatch(emailBatchInput: $emailBatchInput) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on EmailBatchObjectType {
        id
      }
    }
  }
}
    `;
export type CreateEmailBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateEmailBatchMutation, GraphqlTypes.CreateEmailBatchMutationVariables>;

/**
 * __useCreateEmailBatchMutation__
 *
 * To run a mutation, you first call `useCreateEmailBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailBatchMutation, { data, loading, error }] = useCreateEmailBatchMutation({
 *   variables: {
 *      emailBatchInput: // value for 'emailBatchInput'
 *   },
 * });
 */
export function useCreateEmailBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateEmailBatchMutation, GraphqlTypes.CreateEmailBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateEmailBatchMutation, GraphqlTypes.CreateEmailBatchMutationVariables>(CreateEmailBatchDocument, options);
      }
export type CreateEmailBatchMutationHookResult = ReturnType<typeof useCreateEmailBatchMutation>;
export type CreateEmailBatchMutationResult = Apollo.MutationResult<GraphqlTypes.CreateEmailBatchMutation>;
export type CreateEmailBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateEmailBatchMutation, GraphqlTypes.CreateEmailBatchMutationVariables>;
export const GetEnableReactifiedEmailPreviewFeatureFlagDocument = gql`
    query GetEnableReactifiedEmailPreviewFeatureFlag {
  devFeatures {
    enableReactifiedEmailPreview
  }
}
    `;

/**
 * __useGetEnableReactifiedEmailPreviewFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetEnableReactifiedEmailPreviewFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnableReactifiedEmailPreviewFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnableReactifiedEmailPreviewFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEnableReactifiedEmailPreviewFeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>(GetEnableReactifiedEmailPreviewFeatureFlagDocument, options);
      }
export function useGetEnableReactifiedEmailPreviewFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>(GetEnableReactifiedEmailPreviewFeatureFlagDocument, options);
        }
// @ts-ignore
export function useGetEnableReactifiedEmailPreviewFeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>;
export function useGetEnableReactifiedEmailPreviewFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQuery | undefined, GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>;
export function useGetEnableReactifiedEmailPreviewFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>(GetEnableReactifiedEmailPreviewFeatureFlagDocument, options);
        }
export type GetEnableReactifiedEmailPreviewFeatureFlagQueryHookResult = ReturnType<typeof useGetEnableReactifiedEmailPreviewFeatureFlagQuery>;
export type GetEnableReactifiedEmailPreviewFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetEnableReactifiedEmailPreviewFeatureFlagLazyQuery>;
export type GetEnableReactifiedEmailPreviewFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetEnableReactifiedEmailPreviewFeatureFlagSuspenseQuery>;
export type GetEnableReactifiedEmailPreviewFeatureFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>;
export const ExportContactsDocument = gql`
    mutation ExportContacts($exportContactsInput: ExportContactsInput!) {
  contactOps {
    exportContacts(exportContactsInput: $exportContactsInput) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on ExportContactsObject {
        job {
          id
          status
          data
          jobType
        }
      }
    }
  }
}
    `;
export type ExportContactsMutationFn = Apollo.MutationFunction<GraphqlTypes.ExportContactsMutation, GraphqlTypes.ExportContactsMutationVariables>;

/**
 * __useExportContactsMutation__
 *
 * To run a mutation, you first call `useExportContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportContactsMutation, { data, loading, error }] = useExportContactsMutation({
 *   variables: {
 *      exportContactsInput: // value for 'exportContactsInput'
 *   },
 * });
 */
export function useExportContactsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExportContactsMutation, GraphqlTypes.ExportContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExportContactsMutation, GraphqlTypes.ExportContactsMutationVariables>(ExportContactsDocument, options);
      }
export type ExportContactsMutationHookResult = ReturnType<typeof useExportContactsMutation>;
export type ExportContactsMutationResult = Apollo.MutationResult<GraphqlTypes.ExportContactsMutation>;
export type ExportContactsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExportContactsMutation, GraphqlTypes.ExportContactsMutationVariables>;
export const AddContactTagDocument = gql`
    mutation AddContactTag($jsqObjectType: JSQObjectType!, $objectIds: [ID], $objectInput: AddTagInput!) {
  tagOps {
    addTag(
      jsqObjectType: $jsqObjectType
      objectIds: $objectIds
      objectInput: $objectInput
    ) {
      tag {
        id
        tagText
      }
      updatedObjects {
        ... on PermissionCheckedNode {
          id
        }
      }
    }
  }
}
    `;
export type AddContactTagMutationFn = Apollo.MutationFunction<GraphqlTypes.AddContactTagMutation, GraphqlTypes.AddContactTagMutationVariables>;

/**
 * __useAddContactTagMutation__
 *
 * To run a mutation, you first call `useAddContactTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactTagMutation, { data, loading, error }] = useAddContactTagMutation({
 *   variables: {
 *      jsqObjectType: // value for 'jsqObjectType'
 *      objectIds: // value for 'objectIds'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useAddContactTagMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddContactTagMutation, GraphqlTypes.AddContactTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddContactTagMutation, GraphqlTypes.AddContactTagMutationVariables>(AddContactTagDocument, options);
      }
export type AddContactTagMutationHookResult = ReturnType<typeof useAddContactTagMutation>;
export type AddContactTagMutationResult = Apollo.MutationResult<GraphqlTypes.AddContactTagMutation>;
export type AddContactTagMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddContactTagMutation, GraphqlTypes.AddContactTagMutationVariables>;
export const RemoveContactTagDocument = gql`
    mutation RemoveContactTag($jsqObjectType: JSQObjectType!, $objectIds: [ID], $tagId: ID!) {
  tagOps {
    __typename
    removeTag(jsqObjectType: $jsqObjectType, objectIds: $objectIds, tagId: $tagId) {
      __typename
      tag {
        id
        tagText
      }
      updatedObjects {
        ... on PermissionCheckedNode {
          id
        }
      }
    }
  }
}
    `;
export type RemoveContactTagMutationFn = Apollo.MutationFunction<GraphqlTypes.RemoveContactTagMutation, GraphqlTypes.RemoveContactTagMutationVariables>;

/**
 * __useRemoveContactTagMutation__
 *
 * To run a mutation, you first call `useRemoveContactTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContactTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContactTagMutation, { data, loading, error }] = useRemoveContactTagMutation({
 *   variables: {
 *      jsqObjectType: // value for 'jsqObjectType'
 *      objectIds: // value for 'objectIds'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useRemoveContactTagMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RemoveContactTagMutation, GraphqlTypes.RemoveContactTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RemoveContactTagMutation, GraphqlTypes.RemoveContactTagMutationVariables>(RemoveContactTagDocument, options);
      }
export type RemoveContactTagMutationHookResult = ReturnType<typeof useRemoveContactTagMutation>;
export type RemoveContactTagMutationResult = Apollo.MutationResult<GraphqlTypes.RemoveContactTagMutation>;
export type RemoveContactTagMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RemoveContactTagMutation, GraphqlTypes.RemoveContactTagMutationVariables>;
export const GetContactsIdsDocument = gql`
    query GetContactsIds($offset: Int, $limit: Int, $sort: [String!], $setFilters: [SetFilterInput!], $numberFilters: [NumberFilterInput!], $nameFilter: NameFilterInput, $locationFilter: LocationFilterInput, $extensionFieldFilters: ExtensionFieldFiltersInput) {
  contactsPageGrid(
    offset: $offset
    limit: $limit
    sort: $sort
    setFilters: $setFilters
    numberFilters: $numberFilters
    nameFilter: $nameFilter
    locationFilter: $locationFilter
    extensionFieldFilters: $extensionFieldFilters
  ) {
    rows {
      id
    }
  }
}
    `;

/**
 * __useGetContactsIdsQuery__
 *
 * To run a query within a React component, call `useGetContactsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsIdsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      setFilters: // value for 'setFilters'
 *      numberFilters: // value for 'numberFilters'
 *      nameFilter: // value for 'nameFilter'
 *      locationFilter: // value for 'locationFilter'
 *      extensionFieldFilters: // value for 'extensionFieldFilters'
 *   },
 * });
 */
export function useGetContactsIdsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetContactsIdsQuery, GraphqlTypes.GetContactsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactsIdsQuery, GraphqlTypes.GetContactsIdsQueryVariables>(GetContactsIdsDocument, options);
      }
export function useGetContactsIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactsIdsQuery, GraphqlTypes.GetContactsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactsIdsQuery, GraphqlTypes.GetContactsIdsQueryVariables>(GetContactsIdsDocument, options);
        }
// @ts-ignore
export function useGetContactsIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsIdsQuery, GraphqlTypes.GetContactsIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsIdsQuery, GraphqlTypes.GetContactsIdsQueryVariables>;
export function useGetContactsIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsIdsQuery, GraphqlTypes.GetContactsIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsIdsQuery | undefined, GraphqlTypes.GetContactsIdsQueryVariables>;
export function useGetContactsIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsIdsQuery, GraphqlTypes.GetContactsIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactsIdsQuery, GraphqlTypes.GetContactsIdsQueryVariables>(GetContactsIdsDocument, options);
        }
export type GetContactsIdsQueryHookResult = ReturnType<typeof useGetContactsIdsQuery>;
export type GetContactsIdsLazyQueryHookResult = ReturnType<typeof useGetContactsIdsLazyQuery>;
export type GetContactsIdsSuspenseQueryHookResult = ReturnType<typeof useGetContactsIdsSuspenseQuery>;
export type GetContactsIdsQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactsIdsQuery, GraphqlTypes.GetContactsIdsQueryVariables>;
export const GetContactIdsAndNamesDocument = gql`
    query GetContactIdsAndNames($offset: Int, $limit: Int, $sort: [String!], $setFilters: [SetFilterInput!], $numberFilters: [NumberFilterInput!], $nameFilter: NameFilterInput, $locationFilter: LocationFilterInput, $extensionFieldFilters: ExtensionFieldFiltersInput) {
  contactsPageGrid(
    offset: $offset
    limit: $limit
    sort: $sort
    setFilters: $setFilters
    numberFilters: $numberFilters
    nameFilter: $nameFilter
    locationFilter: $locationFilter
    extensionFieldFilters: $extensionFieldFilters
  ) {
    rows {
      id
      name
    }
  }
}
    `;

/**
 * __useGetContactIdsAndNamesQuery__
 *
 * To run a query within a React component, call `useGetContactIdsAndNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactIdsAndNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactIdsAndNamesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      setFilters: // value for 'setFilters'
 *      numberFilters: // value for 'numberFilters'
 *      nameFilter: // value for 'nameFilter'
 *      locationFilter: // value for 'locationFilter'
 *      extensionFieldFilters: // value for 'extensionFieldFilters'
 *   },
 * });
 */
export function useGetContactIdsAndNamesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetContactIdsAndNamesQuery, GraphqlTypes.GetContactIdsAndNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactIdsAndNamesQuery, GraphqlTypes.GetContactIdsAndNamesQueryVariables>(GetContactIdsAndNamesDocument, options);
      }
export function useGetContactIdsAndNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactIdsAndNamesQuery, GraphqlTypes.GetContactIdsAndNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactIdsAndNamesQuery, GraphqlTypes.GetContactIdsAndNamesQueryVariables>(GetContactIdsAndNamesDocument, options);
        }
// @ts-ignore
export function useGetContactIdsAndNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactIdsAndNamesQuery, GraphqlTypes.GetContactIdsAndNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactIdsAndNamesQuery, GraphqlTypes.GetContactIdsAndNamesQueryVariables>;
export function useGetContactIdsAndNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactIdsAndNamesQuery, GraphqlTypes.GetContactIdsAndNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactIdsAndNamesQuery | undefined, GraphqlTypes.GetContactIdsAndNamesQueryVariables>;
export function useGetContactIdsAndNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactIdsAndNamesQuery, GraphqlTypes.GetContactIdsAndNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactIdsAndNamesQuery, GraphqlTypes.GetContactIdsAndNamesQueryVariables>(GetContactIdsAndNamesDocument, options);
        }
export type GetContactIdsAndNamesQueryHookResult = ReturnType<typeof useGetContactIdsAndNamesQuery>;
export type GetContactIdsAndNamesLazyQueryHookResult = ReturnType<typeof useGetContactIdsAndNamesLazyQuery>;
export type GetContactIdsAndNamesSuspenseQueryHookResult = ReturnType<typeof useGetContactIdsAndNamesSuspenseQuery>;
export type GetContactIdsAndNamesQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactIdsAndNamesQuery, GraphqlTypes.GetContactIdsAndNamesQueryVariables>;
export const GetContactTagsDocument = gql`
    query GetContactTags($offset: Int, $limit: Int, $sort: [String!], $setFilters: [SetFilterInput!], $numberFilters: [NumberFilterInput!], $nameFilter: NameFilterInput, $locationFilter: LocationFilterInput, $extensionFieldFilters: ExtensionFieldFiltersInput) {
  contactsPageGrid(
    offset: $offset
    limit: $limit
    sort: $sort
    setFilters: $setFilters
    numberFilters: $numberFilters
    nameFilter: $nameFilter
    locationFilter: $locationFilter
    extensionFieldFilters: $extensionFieldFilters
  ) {
    rows {
      id
      tags {
        id
        text
      }
    }
  }
}
    `;

/**
 * __useGetContactTagsQuery__
 *
 * To run a query within a React component, call `useGetContactTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactTagsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      setFilters: // value for 'setFilters'
 *      numberFilters: // value for 'numberFilters'
 *      nameFilter: // value for 'nameFilter'
 *      locationFilter: // value for 'locationFilter'
 *      extensionFieldFilters: // value for 'extensionFieldFilters'
 *   },
 * });
 */
export function useGetContactTagsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetContactTagsQuery, GraphqlTypes.GetContactTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactTagsQuery, GraphqlTypes.GetContactTagsQueryVariables>(GetContactTagsDocument, options);
      }
export function useGetContactTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactTagsQuery, GraphqlTypes.GetContactTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactTagsQuery, GraphqlTypes.GetContactTagsQueryVariables>(GetContactTagsDocument, options);
        }
// @ts-ignore
export function useGetContactTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactTagsQuery, GraphqlTypes.GetContactTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactTagsQuery, GraphqlTypes.GetContactTagsQueryVariables>;
export function useGetContactTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactTagsQuery, GraphqlTypes.GetContactTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactTagsQuery | undefined, GraphqlTypes.GetContactTagsQueryVariables>;
export function useGetContactTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactTagsQuery, GraphqlTypes.GetContactTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactTagsQuery, GraphqlTypes.GetContactTagsQueryVariables>(GetContactTagsDocument, options);
        }
export type GetContactTagsQueryHookResult = ReturnType<typeof useGetContactTagsQuery>;
export type GetContactTagsLazyQueryHookResult = ReturnType<typeof useGetContactTagsLazyQuery>;
export type GetContactTagsSuspenseQueryHookResult = ReturnType<typeof useGetContactTagsSuspenseQuery>;
export type GetContactTagsQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactTagsQuery, GraphqlTypes.GetContactTagsQueryVariables>;
export const GetContactsForGridDocument = gql`
    query GetContactsForGrid($offset: Int, $limit: Int, $sort: [String!], $setFilters: [SetFilterInput!], $numberFilters: [NumberFilterInput!], $nameFilter: NameFilterInput, $locationFilter: LocationFilterInput, $extensionFieldFilters: ExtensionFieldFiltersInput) {
  contactsPageGrid(
    offset: $offset
    limit: $limit
    sort: $sort
    setFilters: $setFilters
    numberFilters: $numberFilters
    nameFilter: $nameFilter
    locationFilter: $locationFilter
    extensionFieldFilters: $extensionFieldFilters
  ) {
    rows {
      id
      name
      company
      email
      committedAmount
      positionCount
      tags {
        id
        text
      }
      isOrg
      notes
      websiteUrl
      linkedinUrl
      locationFilterResult {
        addressType
        milesFromLocation
      }
    }
    filteredCount
    totalCount
  }
}
    `;

/**
 * __useGetContactsForGridQuery__
 *
 * To run a query within a React component, call `useGetContactsForGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsForGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsForGridQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      setFilters: // value for 'setFilters'
 *      numberFilters: // value for 'numberFilters'
 *      nameFilter: // value for 'nameFilter'
 *      locationFilter: // value for 'locationFilter'
 *      extensionFieldFilters: // value for 'extensionFieldFilters'
 *   },
 * });
 */
export function useGetContactsForGridQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetContactsForGridQuery, GraphqlTypes.GetContactsForGridQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactsForGridQuery, GraphqlTypes.GetContactsForGridQueryVariables>(GetContactsForGridDocument, options);
      }
export function useGetContactsForGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactsForGridQuery, GraphqlTypes.GetContactsForGridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactsForGridQuery, GraphqlTypes.GetContactsForGridQueryVariables>(GetContactsForGridDocument, options);
        }
// @ts-ignore
export function useGetContactsForGridSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsForGridQuery, GraphqlTypes.GetContactsForGridQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsForGridQuery, GraphqlTypes.GetContactsForGridQueryVariables>;
export function useGetContactsForGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsForGridQuery, GraphqlTypes.GetContactsForGridQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsForGridQuery | undefined, GraphqlTypes.GetContactsForGridQueryVariables>;
export function useGetContactsForGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsForGridQuery, GraphqlTypes.GetContactsForGridQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactsForGridQuery, GraphqlTypes.GetContactsForGridQueryVariables>(GetContactsForGridDocument, options);
        }
export type GetContactsForGridQueryHookResult = ReturnType<typeof useGetContactsForGridQuery>;
export type GetContactsForGridLazyQueryHookResult = ReturnType<typeof useGetContactsForGridLazyQuery>;
export type GetContactsForGridSuspenseQueryHookResult = ReturnType<typeof useGetContactsForGridSuspenseQuery>;
export type GetContactsForGridQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactsForGridQuery, GraphqlTypes.GetContactsForGridQueryVariables>;
export const GetTagsDocument = gql`
    query GetTags($jsqObjectType: JSQObjectType!) {
  tags(jsqObjectType: $jsqObjectType) {
    edges {
      node {
        id
        tagText
      }
    }
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *      jsqObjectType: // value for 'jsqObjectType'
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTagsQuery, GraphqlTypes.GetTagsQueryVariables> & ({ variables: GraphqlTypes.GetTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTagsQuery, GraphqlTypes.GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTagsQuery, GraphqlTypes.GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTagsQuery, GraphqlTypes.GetTagsQueryVariables>(GetTagsDocument, options);
        }
// @ts-ignore
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTagsQuery, GraphqlTypes.GetTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTagsQuery, GraphqlTypes.GetTagsQueryVariables>;
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTagsQuery, GraphqlTypes.GetTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTagsQuery | undefined, GraphqlTypes.GetTagsQueryVariables>;
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTagsQuery, GraphqlTypes.GetTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTagsQuery, GraphqlTypes.GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<typeof useGetTagsSuspenseQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GraphqlTypes.GetTagsQuery, GraphqlTypes.GetTagsQueryVariables>;
export const GetAssigneesDocument = gql`
    query GetAssignees {
  contactAssigneeUsers {
    id
    fullName
  }
}
    `;

/**
 * __useGetAssigneesQuery__
 *
 * To run a query within a React component, call `useGetAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssigneesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssigneesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAssigneesQuery, GraphqlTypes.GetAssigneesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssigneesQuery, GraphqlTypes.GetAssigneesQueryVariables>(GetAssigneesDocument, options);
      }
export function useGetAssigneesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssigneesQuery, GraphqlTypes.GetAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssigneesQuery, GraphqlTypes.GetAssigneesQueryVariables>(GetAssigneesDocument, options);
        }
// @ts-ignore
export function useGetAssigneesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssigneesQuery, GraphqlTypes.GetAssigneesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssigneesQuery, GraphqlTypes.GetAssigneesQueryVariables>;
export function useGetAssigneesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssigneesQuery, GraphqlTypes.GetAssigneesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssigneesQuery | undefined, GraphqlTypes.GetAssigneesQueryVariables>;
export function useGetAssigneesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssigneesQuery, GraphqlTypes.GetAssigneesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssigneesQuery, GraphqlTypes.GetAssigneesQueryVariables>(GetAssigneesDocument, options);
        }
export type GetAssigneesQueryHookResult = ReturnType<typeof useGetAssigneesQuery>;
export type GetAssigneesLazyQueryHookResult = ReturnType<typeof useGetAssigneesLazyQuery>;
export type GetAssigneesSuspenseQueryHookResult = ReturnType<typeof useGetAssigneesSuspenseQuery>;
export type GetAssigneesQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssigneesQuery, GraphqlTypes.GetAssigneesQueryVariables>;
export const GetLeadSourcesDocument = gql`
    query GetLeadSources {
  leadSources {
    id
    name
  }
}
    `;

/**
 * __useGetLeadSourcesQuery__
 *
 * To run a query within a React component, call `useGetLeadSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLeadSourcesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetLeadSourcesQuery, GraphqlTypes.GetLeadSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLeadSourcesQuery, GraphqlTypes.GetLeadSourcesQueryVariables>(GetLeadSourcesDocument, options);
      }
export function useGetLeadSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLeadSourcesQuery, GraphqlTypes.GetLeadSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLeadSourcesQuery, GraphqlTypes.GetLeadSourcesQueryVariables>(GetLeadSourcesDocument, options);
        }
// @ts-ignore
export function useGetLeadSourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLeadSourcesQuery, GraphqlTypes.GetLeadSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLeadSourcesQuery, GraphqlTypes.GetLeadSourcesQueryVariables>;
export function useGetLeadSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLeadSourcesQuery, GraphqlTypes.GetLeadSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLeadSourcesQuery | undefined, GraphqlTypes.GetLeadSourcesQueryVariables>;
export function useGetLeadSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLeadSourcesQuery, GraphqlTypes.GetLeadSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLeadSourcesQuery, GraphqlTypes.GetLeadSourcesQueryVariables>(GetLeadSourcesDocument, options);
        }
export type GetLeadSourcesQueryHookResult = ReturnType<typeof useGetLeadSourcesQuery>;
export type GetLeadSourcesLazyQueryHookResult = ReturnType<typeof useGetLeadSourcesLazyQuery>;
export type GetLeadSourcesSuspenseQueryHookResult = ReturnType<typeof useGetLeadSourcesSuspenseQuery>;
export type GetLeadSourcesQueryResult = Apollo.QueryResult<GraphqlTypes.GetLeadSourcesQuery, GraphqlTypes.GetLeadSourcesQueryVariables>;
export const GetStaffOfferingsDocument = gql`
    query GetStaffOfferings {
  offerings {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetStaffOfferingsQuery__
 *
 * To run a query within a React component, call `useGetStaffOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffOfferingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStaffOfferingsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetStaffOfferingsQuery, GraphqlTypes.GetStaffOfferingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetStaffOfferingsQuery, GraphqlTypes.GetStaffOfferingsQueryVariables>(GetStaffOfferingsDocument, options);
      }
export function useGetStaffOfferingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetStaffOfferingsQuery, GraphqlTypes.GetStaffOfferingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetStaffOfferingsQuery, GraphqlTypes.GetStaffOfferingsQueryVariables>(GetStaffOfferingsDocument, options);
        }
// @ts-ignore
export function useGetStaffOfferingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffOfferingsQuery, GraphqlTypes.GetStaffOfferingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStaffOfferingsQuery, GraphqlTypes.GetStaffOfferingsQueryVariables>;
export function useGetStaffOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffOfferingsQuery, GraphqlTypes.GetStaffOfferingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStaffOfferingsQuery | undefined, GraphqlTypes.GetStaffOfferingsQueryVariables>;
export function useGetStaffOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffOfferingsQuery, GraphqlTypes.GetStaffOfferingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetStaffOfferingsQuery, GraphqlTypes.GetStaffOfferingsQueryVariables>(GetStaffOfferingsDocument, options);
        }
export type GetStaffOfferingsQueryHookResult = ReturnType<typeof useGetStaffOfferingsQuery>;
export type GetStaffOfferingsLazyQueryHookResult = ReturnType<typeof useGetStaffOfferingsLazyQuery>;
export type GetStaffOfferingsSuspenseQueryHookResult = ReturnType<typeof useGetStaffOfferingsSuspenseQuery>;
export type GetStaffOfferingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetStaffOfferingsQuery, GraphqlTypes.GetStaffOfferingsQueryVariables>;
export const GetReferrersDocument = gql`
    query GetReferrers {
  referrers {
    id
    fullName
  }
}
    `;

/**
 * __useGetReferrersQuery__
 *
 * To run a query within a React component, call `useGetReferrersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferrersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferrersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferrersQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetReferrersQuery, GraphqlTypes.GetReferrersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReferrersQuery, GraphqlTypes.GetReferrersQueryVariables>(GetReferrersDocument, options);
      }
export function useGetReferrersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReferrersQuery, GraphqlTypes.GetReferrersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReferrersQuery, GraphqlTypes.GetReferrersQueryVariables>(GetReferrersDocument, options);
        }
// @ts-ignore
export function useGetReferrersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReferrersQuery, GraphqlTypes.GetReferrersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReferrersQuery, GraphqlTypes.GetReferrersQueryVariables>;
export function useGetReferrersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReferrersQuery, GraphqlTypes.GetReferrersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReferrersQuery | undefined, GraphqlTypes.GetReferrersQueryVariables>;
export function useGetReferrersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReferrersQuery, GraphqlTypes.GetReferrersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReferrersQuery, GraphqlTypes.GetReferrersQueryVariables>(GetReferrersDocument, options);
        }
export type GetReferrersQueryHookResult = ReturnType<typeof useGetReferrersQuery>;
export type GetReferrersLazyQueryHookResult = ReturnType<typeof useGetReferrersLazyQuery>;
export type GetReferrersSuspenseQueryHookResult = ReturnType<typeof useGetReferrersSuspenseQuery>;
export type GetReferrersQueryResult = Apollo.QueryResult<GraphqlTypes.GetReferrersQuery, GraphqlTypes.GetReferrersQueryVariables>;
export const GetInvestmentEntitiesOwningPositionsDocument = gql`
    query GetInvestmentEntitiesOwningPositions {
  investmentEntitiesUnsorted(investorOwnedOnly: true) {
    edges {
      node {
        id
        status
        name
      }
    }
  }
}
    `;

/**
 * __useGetInvestmentEntitiesOwningPositionsQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntitiesOwningPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntitiesOwningPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntitiesOwningPositionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvestmentEntitiesOwningPositionsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntitiesOwningPositionsQuery, GraphqlTypes.GetInvestmentEntitiesOwningPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntitiesOwningPositionsQuery, GraphqlTypes.GetInvestmentEntitiesOwningPositionsQueryVariables>(GetInvestmentEntitiesOwningPositionsDocument, options);
      }
export function useGetInvestmentEntitiesOwningPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesOwningPositionsQuery, GraphqlTypes.GetInvestmentEntitiesOwningPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntitiesOwningPositionsQuery, GraphqlTypes.GetInvestmentEntitiesOwningPositionsQueryVariables>(GetInvestmentEntitiesOwningPositionsDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntitiesOwningPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesOwningPositionsQuery, GraphqlTypes.GetInvestmentEntitiesOwningPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesOwningPositionsQuery, GraphqlTypes.GetInvestmentEntitiesOwningPositionsQueryVariables>;
export function useGetInvestmentEntitiesOwningPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesOwningPositionsQuery, GraphqlTypes.GetInvestmentEntitiesOwningPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesOwningPositionsQuery | undefined, GraphqlTypes.GetInvestmentEntitiesOwningPositionsQueryVariables>;
export function useGetInvestmentEntitiesOwningPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesOwningPositionsQuery, GraphqlTypes.GetInvestmentEntitiesOwningPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntitiesOwningPositionsQuery, GraphqlTypes.GetInvestmentEntitiesOwningPositionsQueryVariables>(GetInvestmentEntitiesOwningPositionsDocument, options);
        }
export type GetInvestmentEntitiesOwningPositionsQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesOwningPositionsQuery>;
export type GetInvestmentEntitiesOwningPositionsLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesOwningPositionsLazyQuery>;
export type GetInvestmentEntitiesOwningPositionsSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesOwningPositionsSuspenseQuery>;
export type GetInvestmentEntitiesOwningPositionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntitiesOwningPositionsQuery, GraphqlTypes.GetInvestmentEntitiesOwningPositionsQueryVariables>;
export const GetContactExtensionFieldEnumValuesDocument = gql`
    query GetContactExtensionFieldEnumValues($enumName: String!) {
  extensionFieldEnumValues(enumName: $enumName) {
    enumValueCode
    enumValueLabel
  }
}
    `;

/**
 * __useGetContactExtensionFieldEnumValuesQuery__
 *
 * To run a query within a React component, call `useGetContactExtensionFieldEnumValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactExtensionFieldEnumValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactExtensionFieldEnumValuesQuery({
 *   variables: {
 *      enumName: // value for 'enumName'
 *   },
 * });
 */
export function useGetContactExtensionFieldEnumValuesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactExtensionFieldEnumValuesQuery, GraphqlTypes.GetContactExtensionFieldEnumValuesQueryVariables> & ({ variables: GraphqlTypes.GetContactExtensionFieldEnumValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactExtensionFieldEnumValuesQuery, GraphqlTypes.GetContactExtensionFieldEnumValuesQueryVariables>(GetContactExtensionFieldEnumValuesDocument, options);
      }
export function useGetContactExtensionFieldEnumValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactExtensionFieldEnumValuesQuery, GraphqlTypes.GetContactExtensionFieldEnumValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactExtensionFieldEnumValuesQuery, GraphqlTypes.GetContactExtensionFieldEnumValuesQueryVariables>(GetContactExtensionFieldEnumValuesDocument, options);
        }
// @ts-ignore
export function useGetContactExtensionFieldEnumValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactExtensionFieldEnumValuesQuery, GraphqlTypes.GetContactExtensionFieldEnumValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactExtensionFieldEnumValuesQuery, GraphqlTypes.GetContactExtensionFieldEnumValuesQueryVariables>;
export function useGetContactExtensionFieldEnumValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactExtensionFieldEnumValuesQuery, GraphqlTypes.GetContactExtensionFieldEnumValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactExtensionFieldEnumValuesQuery | undefined, GraphqlTypes.GetContactExtensionFieldEnumValuesQueryVariables>;
export function useGetContactExtensionFieldEnumValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactExtensionFieldEnumValuesQuery, GraphqlTypes.GetContactExtensionFieldEnumValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactExtensionFieldEnumValuesQuery, GraphqlTypes.GetContactExtensionFieldEnumValuesQueryVariables>(GetContactExtensionFieldEnumValuesDocument, options);
        }
export type GetContactExtensionFieldEnumValuesQueryHookResult = ReturnType<typeof useGetContactExtensionFieldEnumValuesQuery>;
export type GetContactExtensionFieldEnumValuesLazyQueryHookResult = ReturnType<typeof useGetContactExtensionFieldEnumValuesLazyQuery>;
export type GetContactExtensionFieldEnumValuesSuspenseQueryHookResult = ReturnType<typeof useGetContactExtensionFieldEnumValuesSuspenseQuery>;
export type GetContactExtensionFieldEnumValuesQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactExtensionFieldEnumValuesQuery, GraphqlTypes.GetContactExtensionFieldEnumValuesQueryVariables>;
export const ContactExtensionFieldsDocument = gql`
    query ContactExtensionFields($contactIds: [Int!]) {
  contactsExtensionFields(contactIds: $contactIds) {
    extensionFields {
      extensionField {
        id
        name
        enumName
        extensionFieldTypeId
        isMultivalued
      }
      values {
        id
        objectId
        enumValue {
          enumValueLabel
        }
        intValue
        stringValue
        floatValue
        dateValue
      }
    }
  }
}
    `;

/**
 * __useContactExtensionFieldsQuery__
 *
 * To run a query within a React component, call `useContactExtensionFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactExtensionFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactExtensionFieldsQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useContactExtensionFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.ContactExtensionFieldsQuery, GraphqlTypes.ContactExtensionFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ContactExtensionFieldsQuery, GraphqlTypes.ContactExtensionFieldsQueryVariables>(ContactExtensionFieldsDocument, options);
      }
export function useContactExtensionFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ContactExtensionFieldsQuery, GraphqlTypes.ContactExtensionFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ContactExtensionFieldsQuery, GraphqlTypes.ContactExtensionFieldsQueryVariables>(ContactExtensionFieldsDocument, options);
        }
// @ts-ignore
export function useContactExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactExtensionFieldsQuery, GraphqlTypes.ContactExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactExtensionFieldsQuery, GraphqlTypes.ContactExtensionFieldsQueryVariables>;
export function useContactExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactExtensionFieldsQuery, GraphqlTypes.ContactExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactExtensionFieldsQuery | undefined, GraphqlTypes.ContactExtensionFieldsQueryVariables>;
export function useContactExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactExtensionFieldsQuery, GraphqlTypes.ContactExtensionFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ContactExtensionFieldsQuery, GraphqlTypes.ContactExtensionFieldsQueryVariables>(ContactExtensionFieldsDocument, options);
        }
export type ContactExtensionFieldsQueryHookResult = ReturnType<typeof useContactExtensionFieldsQuery>;
export type ContactExtensionFieldsLazyQueryHookResult = ReturnType<typeof useContactExtensionFieldsLazyQuery>;
export type ContactExtensionFieldsSuspenseQueryHookResult = ReturnType<typeof useContactExtensionFieldsSuspenseQuery>;
export type ContactExtensionFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.ContactExtensionFieldsQuery, GraphqlTypes.ContactExtensionFieldsQueryVariables>;
export const ContactExtensionFieldsWithFiltersDocument = gql`
    query ContactExtensionFieldsWithFilters($contactIds: [Int!], $extensionFieldIds: [ID!], $includeExtensionFieldsWithoutValues: Boolean, $sort: Boolean) {
  contactsExtensionFields(
    contactIds: $contactIds
    extensionFieldIds: $extensionFieldIds
    includeExtensionFieldsWithoutValues: $includeExtensionFieldsWithoutValues
    sort: $sort
  ) {
    extensionFields {
      extensionField {
        id
        name
        enumName
        extensionFieldTypeId
        isMultivalued
      }
      values {
        id
        objectId
        enumValue {
          enumValueLabel
        }
        intValue
        stringValue
        floatValue
        dateValue
      }
    }
  }
}
    `;

/**
 * __useContactExtensionFieldsWithFiltersQuery__
 *
 * To run a query within a React component, call `useContactExtensionFieldsWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactExtensionFieldsWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactExtensionFieldsWithFiltersQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *      extensionFieldIds: // value for 'extensionFieldIds'
 *      includeExtensionFieldsWithoutValues: // value for 'includeExtensionFieldsWithoutValues'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useContactExtensionFieldsWithFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.ContactExtensionFieldsWithFiltersQuery, GraphqlTypes.ContactExtensionFieldsWithFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ContactExtensionFieldsWithFiltersQuery, GraphqlTypes.ContactExtensionFieldsWithFiltersQueryVariables>(ContactExtensionFieldsWithFiltersDocument, options);
      }
export function useContactExtensionFieldsWithFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ContactExtensionFieldsWithFiltersQuery, GraphqlTypes.ContactExtensionFieldsWithFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ContactExtensionFieldsWithFiltersQuery, GraphqlTypes.ContactExtensionFieldsWithFiltersQueryVariables>(ContactExtensionFieldsWithFiltersDocument, options);
        }
// @ts-ignore
export function useContactExtensionFieldsWithFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactExtensionFieldsWithFiltersQuery, GraphqlTypes.ContactExtensionFieldsWithFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactExtensionFieldsWithFiltersQuery, GraphqlTypes.ContactExtensionFieldsWithFiltersQueryVariables>;
export function useContactExtensionFieldsWithFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactExtensionFieldsWithFiltersQuery, GraphqlTypes.ContactExtensionFieldsWithFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactExtensionFieldsWithFiltersQuery | undefined, GraphqlTypes.ContactExtensionFieldsWithFiltersQueryVariables>;
export function useContactExtensionFieldsWithFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactExtensionFieldsWithFiltersQuery, GraphqlTypes.ContactExtensionFieldsWithFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ContactExtensionFieldsWithFiltersQuery, GraphqlTypes.ContactExtensionFieldsWithFiltersQueryVariables>(ContactExtensionFieldsWithFiltersDocument, options);
        }
export type ContactExtensionFieldsWithFiltersQueryHookResult = ReturnType<typeof useContactExtensionFieldsWithFiltersQuery>;
export type ContactExtensionFieldsWithFiltersLazyQueryHookResult = ReturnType<typeof useContactExtensionFieldsWithFiltersLazyQuery>;
export type ContactExtensionFieldsWithFiltersSuspenseQueryHookResult = ReturnType<typeof useContactExtensionFieldsWithFiltersSuspenseQuery>;
export type ContactExtensionFieldsWithFiltersQueryResult = Apollo.QueryResult<GraphqlTypes.ContactExtensionFieldsWithFiltersQuery, GraphqlTypes.ContactExtensionFieldsWithFiltersQueryVariables>;
export const ContactsBasicInfoExtendedDocument = gql`
    query ContactsBasicInfoExtended($contactIds: [Int!]) {
  contactsBasicInfoExtended(contactIds: $contactIds) {
    id
    contactType
    assignee
    referrer
    preqinUrl
    emails {
      id
      emailAddress
      emailType
    }
    hubspotSyncEnabled
    hubspotDuplicateEmail
    starredContactNames
  }
}
    `;

/**
 * __useContactsBasicInfoExtendedQuery__
 *
 * To run a query within a React component, call `useContactsBasicInfoExtendedQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsBasicInfoExtendedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsBasicInfoExtendedQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useContactsBasicInfoExtendedQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.ContactsBasicInfoExtendedQuery, GraphqlTypes.ContactsBasicInfoExtendedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ContactsBasicInfoExtendedQuery, GraphqlTypes.ContactsBasicInfoExtendedQueryVariables>(ContactsBasicInfoExtendedDocument, options);
      }
export function useContactsBasicInfoExtendedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ContactsBasicInfoExtendedQuery, GraphqlTypes.ContactsBasicInfoExtendedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ContactsBasicInfoExtendedQuery, GraphqlTypes.ContactsBasicInfoExtendedQueryVariables>(ContactsBasicInfoExtendedDocument, options);
        }
// @ts-ignore
export function useContactsBasicInfoExtendedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsBasicInfoExtendedQuery, GraphqlTypes.ContactsBasicInfoExtendedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactsBasicInfoExtendedQuery, GraphqlTypes.ContactsBasicInfoExtendedQueryVariables>;
export function useContactsBasicInfoExtendedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsBasicInfoExtendedQuery, GraphqlTypes.ContactsBasicInfoExtendedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactsBasicInfoExtendedQuery | undefined, GraphqlTypes.ContactsBasicInfoExtendedQueryVariables>;
export function useContactsBasicInfoExtendedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsBasicInfoExtendedQuery, GraphqlTypes.ContactsBasicInfoExtendedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ContactsBasicInfoExtendedQuery, GraphqlTypes.ContactsBasicInfoExtendedQueryVariables>(ContactsBasicInfoExtendedDocument, options);
        }
export type ContactsBasicInfoExtendedQueryHookResult = ReturnType<typeof useContactsBasicInfoExtendedQuery>;
export type ContactsBasicInfoExtendedLazyQueryHookResult = ReturnType<typeof useContactsBasicInfoExtendedLazyQuery>;
export type ContactsBasicInfoExtendedSuspenseQueryHookResult = ReturnType<typeof useContactsBasicInfoExtendedSuspenseQuery>;
export type ContactsBasicInfoExtendedQueryResult = Apollo.QueryResult<GraphqlTypes.ContactsBasicInfoExtendedQuery, GraphqlTypes.ContactsBasicInfoExtendedQueryVariables>;
export const AssigneesByContactDocument = gql`
    query AssigneesByContact($contactIds: [Int!]) {
  contactsBasicInfoExtended(contactIds: $contactIds) {
    id
    assignee
  }
}
    `;

/**
 * __useAssigneesByContactQuery__
 *
 * To run a query within a React component, call `useAssigneesByContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssigneesByContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssigneesByContactQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useAssigneesByContactQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.AssigneesByContactQuery, GraphqlTypes.AssigneesByContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AssigneesByContactQuery, GraphqlTypes.AssigneesByContactQueryVariables>(AssigneesByContactDocument, options);
      }
export function useAssigneesByContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AssigneesByContactQuery, GraphqlTypes.AssigneesByContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AssigneesByContactQuery, GraphqlTypes.AssigneesByContactQueryVariables>(AssigneesByContactDocument, options);
        }
// @ts-ignore
export function useAssigneesByContactSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AssigneesByContactQuery, GraphqlTypes.AssigneesByContactQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AssigneesByContactQuery, GraphqlTypes.AssigneesByContactQueryVariables>;
export function useAssigneesByContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AssigneesByContactQuery, GraphqlTypes.AssigneesByContactQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AssigneesByContactQuery | undefined, GraphqlTypes.AssigneesByContactQueryVariables>;
export function useAssigneesByContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AssigneesByContactQuery, GraphqlTypes.AssigneesByContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AssigneesByContactQuery, GraphqlTypes.AssigneesByContactQueryVariables>(AssigneesByContactDocument, options);
        }
export type AssigneesByContactQueryHookResult = ReturnType<typeof useAssigneesByContactQuery>;
export type AssigneesByContactLazyQueryHookResult = ReturnType<typeof useAssigneesByContactLazyQuery>;
export type AssigneesByContactSuspenseQueryHookResult = ReturnType<typeof useAssigneesByContactSuspenseQuery>;
export type AssigneesByContactQueryResult = Apollo.QueryResult<GraphqlTypes.AssigneesByContactQuery, GraphqlTypes.AssigneesByContactQueryVariables>;
export const ContactsEnrichedInfoExtendedDocument = gql`
    query ContactsEnrichedInfoExtended($contactIds: [Int!]) {
  contactsEnrichedInfoExtended(contactIds: $contactIds) {
    id
    lastUpdated
  }
}
    `;

/**
 * __useContactsEnrichedInfoExtendedQuery__
 *
 * To run a query within a React component, call `useContactsEnrichedInfoExtendedQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsEnrichedInfoExtendedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsEnrichedInfoExtendedQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useContactsEnrichedInfoExtendedQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.ContactsEnrichedInfoExtendedQuery, GraphqlTypes.ContactsEnrichedInfoExtendedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ContactsEnrichedInfoExtendedQuery, GraphqlTypes.ContactsEnrichedInfoExtendedQueryVariables>(ContactsEnrichedInfoExtendedDocument, options);
      }
export function useContactsEnrichedInfoExtendedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ContactsEnrichedInfoExtendedQuery, GraphqlTypes.ContactsEnrichedInfoExtendedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ContactsEnrichedInfoExtendedQuery, GraphqlTypes.ContactsEnrichedInfoExtendedQueryVariables>(ContactsEnrichedInfoExtendedDocument, options);
        }
// @ts-ignore
export function useContactsEnrichedInfoExtendedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsEnrichedInfoExtendedQuery, GraphqlTypes.ContactsEnrichedInfoExtendedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactsEnrichedInfoExtendedQuery, GraphqlTypes.ContactsEnrichedInfoExtendedQueryVariables>;
export function useContactsEnrichedInfoExtendedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsEnrichedInfoExtendedQuery, GraphqlTypes.ContactsEnrichedInfoExtendedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactsEnrichedInfoExtendedQuery | undefined, GraphqlTypes.ContactsEnrichedInfoExtendedQueryVariables>;
export function useContactsEnrichedInfoExtendedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsEnrichedInfoExtendedQuery, GraphqlTypes.ContactsEnrichedInfoExtendedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ContactsEnrichedInfoExtendedQuery, GraphqlTypes.ContactsEnrichedInfoExtendedQueryVariables>(ContactsEnrichedInfoExtendedDocument, options);
        }
export type ContactsEnrichedInfoExtendedQueryHookResult = ReturnType<typeof useContactsEnrichedInfoExtendedQuery>;
export type ContactsEnrichedInfoExtendedLazyQueryHookResult = ReturnType<typeof useContactsEnrichedInfoExtendedLazyQuery>;
export type ContactsEnrichedInfoExtendedSuspenseQueryHookResult = ReturnType<typeof useContactsEnrichedInfoExtendedSuspenseQuery>;
export type ContactsEnrichedInfoExtendedQueryResult = Apollo.QueryResult<GraphqlTypes.ContactsEnrichedInfoExtendedQuery, GraphqlTypes.ContactsEnrichedInfoExtendedQueryVariables>;
export const GetViewAndEditContactAccessGroupsDocument = gql`
    query GetViewAndEditContactAccessGroups {
  objectGroups(authorizedClass: contact, includeReadonlyObjectGroups: true) {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetViewAndEditContactAccessGroupsQuery__
 *
 * To run a query within a React component, call `useGetViewAndEditContactAccessGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewAndEditContactAccessGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewAndEditContactAccessGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewAndEditContactAccessGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetViewAndEditContactAccessGroupsQuery, GraphqlTypes.GetViewAndEditContactAccessGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetViewAndEditContactAccessGroupsQuery, GraphqlTypes.GetViewAndEditContactAccessGroupsQueryVariables>(GetViewAndEditContactAccessGroupsDocument, options);
      }
export function useGetViewAndEditContactAccessGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetViewAndEditContactAccessGroupsQuery, GraphqlTypes.GetViewAndEditContactAccessGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetViewAndEditContactAccessGroupsQuery, GraphqlTypes.GetViewAndEditContactAccessGroupsQueryVariables>(GetViewAndEditContactAccessGroupsDocument, options);
        }
// @ts-ignore
export function useGetViewAndEditContactAccessGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetViewAndEditContactAccessGroupsQuery, GraphqlTypes.GetViewAndEditContactAccessGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetViewAndEditContactAccessGroupsQuery, GraphqlTypes.GetViewAndEditContactAccessGroupsQueryVariables>;
export function useGetViewAndEditContactAccessGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetViewAndEditContactAccessGroupsQuery, GraphqlTypes.GetViewAndEditContactAccessGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetViewAndEditContactAccessGroupsQuery | undefined, GraphqlTypes.GetViewAndEditContactAccessGroupsQueryVariables>;
export function useGetViewAndEditContactAccessGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetViewAndEditContactAccessGroupsQuery, GraphqlTypes.GetViewAndEditContactAccessGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetViewAndEditContactAccessGroupsQuery, GraphqlTypes.GetViewAndEditContactAccessGroupsQueryVariables>(GetViewAndEditContactAccessGroupsDocument, options);
        }
export type GetViewAndEditContactAccessGroupsQueryHookResult = ReturnType<typeof useGetViewAndEditContactAccessGroupsQuery>;
export type GetViewAndEditContactAccessGroupsLazyQueryHookResult = ReturnType<typeof useGetViewAndEditContactAccessGroupsLazyQuery>;
export type GetViewAndEditContactAccessGroupsSuspenseQueryHookResult = ReturnType<typeof useGetViewAndEditContactAccessGroupsSuspenseQuery>;
export type GetViewAndEditContactAccessGroupsQueryResult = Apollo.QueryResult<GraphqlTypes.GetViewAndEditContactAccessGroupsQuery, GraphqlTypes.GetViewAndEditContactAccessGroupsQueryVariables>;
export const GetEditableContactAccessGroupsDocument = gql`
    query GetEditableContactAccessGroups {
  objectGroups(authorizedClass: contact, includeReadonlyObjectGroups: false) {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetEditableContactAccessGroupsQuery__
 *
 * To run a query within a React component, call `useGetEditableContactAccessGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditableContactAccessGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditableContactAccessGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEditableContactAccessGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEditableContactAccessGroupsQuery, GraphqlTypes.GetEditableContactAccessGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEditableContactAccessGroupsQuery, GraphqlTypes.GetEditableContactAccessGroupsQueryVariables>(GetEditableContactAccessGroupsDocument, options);
      }
export function useGetEditableContactAccessGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEditableContactAccessGroupsQuery, GraphqlTypes.GetEditableContactAccessGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEditableContactAccessGroupsQuery, GraphqlTypes.GetEditableContactAccessGroupsQueryVariables>(GetEditableContactAccessGroupsDocument, options);
        }
// @ts-ignore
export function useGetEditableContactAccessGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditableContactAccessGroupsQuery, GraphqlTypes.GetEditableContactAccessGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEditableContactAccessGroupsQuery, GraphqlTypes.GetEditableContactAccessGroupsQueryVariables>;
export function useGetEditableContactAccessGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditableContactAccessGroupsQuery, GraphqlTypes.GetEditableContactAccessGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEditableContactAccessGroupsQuery | undefined, GraphqlTypes.GetEditableContactAccessGroupsQueryVariables>;
export function useGetEditableContactAccessGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditableContactAccessGroupsQuery, GraphqlTypes.GetEditableContactAccessGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEditableContactAccessGroupsQuery, GraphqlTypes.GetEditableContactAccessGroupsQueryVariables>(GetEditableContactAccessGroupsDocument, options);
        }
export type GetEditableContactAccessGroupsQueryHookResult = ReturnType<typeof useGetEditableContactAccessGroupsQuery>;
export type GetEditableContactAccessGroupsLazyQueryHookResult = ReturnType<typeof useGetEditableContactAccessGroupsLazyQuery>;
export type GetEditableContactAccessGroupsSuspenseQueryHookResult = ReturnType<typeof useGetEditableContactAccessGroupsSuspenseQuery>;
export type GetEditableContactAccessGroupsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEditableContactAccessGroupsQuery, GraphqlTypes.GetEditableContactAccessGroupsQueryVariables>;
export const GetContactAccessGroupMembersDocument = gql`
    query GetContactAccessGroupMembers($contactIds: [ID!]!) {
  objectGroupObjects(authorizedClass: contact, objectIds: $contactIds) {
    memberObjectId
    group {
      id
    }
  }
}
    `;

/**
 * __useGetContactAccessGroupMembersQuery__
 *
 * To run a query within a React component, call `useGetContactAccessGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactAccessGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactAccessGroupMembersQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useGetContactAccessGroupMembersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactAccessGroupMembersQuery, GraphqlTypes.GetContactAccessGroupMembersQueryVariables> & ({ variables: GraphqlTypes.GetContactAccessGroupMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactAccessGroupMembersQuery, GraphqlTypes.GetContactAccessGroupMembersQueryVariables>(GetContactAccessGroupMembersDocument, options);
      }
export function useGetContactAccessGroupMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactAccessGroupMembersQuery, GraphqlTypes.GetContactAccessGroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactAccessGroupMembersQuery, GraphqlTypes.GetContactAccessGroupMembersQueryVariables>(GetContactAccessGroupMembersDocument, options);
        }
// @ts-ignore
export function useGetContactAccessGroupMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactAccessGroupMembersQuery, GraphqlTypes.GetContactAccessGroupMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactAccessGroupMembersQuery, GraphqlTypes.GetContactAccessGroupMembersQueryVariables>;
export function useGetContactAccessGroupMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactAccessGroupMembersQuery, GraphqlTypes.GetContactAccessGroupMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactAccessGroupMembersQuery | undefined, GraphqlTypes.GetContactAccessGroupMembersQueryVariables>;
export function useGetContactAccessGroupMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactAccessGroupMembersQuery, GraphqlTypes.GetContactAccessGroupMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactAccessGroupMembersQuery, GraphqlTypes.GetContactAccessGroupMembersQueryVariables>(GetContactAccessGroupMembersDocument, options);
        }
export type GetContactAccessGroupMembersQueryHookResult = ReturnType<typeof useGetContactAccessGroupMembersQuery>;
export type GetContactAccessGroupMembersLazyQueryHookResult = ReturnType<typeof useGetContactAccessGroupMembersLazyQuery>;
export type GetContactAccessGroupMembersSuspenseQueryHookResult = ReturnType<typeof useGetContactAccessGroupMembersSuspenseQuery>;
export type GetContactAccessGroupMembersQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactAccessGroupMembersQuery, GraphqlTypes.GetContactAccessGroupMembersQueryVariables>;
export const GetContactsAccessibilityDocument = gql`
    query GetContactsAccessibility($contactIds: [Int!]!) {
  contactsAccessibility(contactIds: $contactIds) {
    editableContacts
  }
}
    `;

/**
 * __useGetContactsAccessibilityQuery__
 *
 * To run a query within a React component, call `useGetContactsAccessibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsAccessibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsAccessibilityQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useGetContactsAccessibilityQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactsAccessibilityQuery, GraphqlTypes.GetContactsAccessibilityQueryVariables> & ({ variables: GraphqlTypes.GetContactsAccessibilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactsAccessibilityQuery, GraphqlTypes.GetContactsAccessibilityQueryVariables>(GetContactsAccessibilityDocument, options);
      }
export function useGetContactsAccessibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactsAccessibilityQuery, GraphqlTypes.GetContactsAccessibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactsAccessibilityQuery, GraphqlTypes.GetContactsAccessibilityQueryVariables>(GetContactsAccessibilityDocument, options);
        }
// @ts-ignore
export function useGetContactsAccessibilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsAccessibilityQuery, GraphqlTypes.GetContactsAccessibilityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsAccessibilityQuery, GraphqlTypes.GetContactsAccessibilityQueryVariables>;
export function useGetContactsAccessibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsAccessibilityQuery, GraphqlTypes.GetContactsAccessibilityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsAccessibilityQuery | undefined, GraphqlTypes.GetContactsAccessibilityQueryVariables>;
export function useGetContactsAccessibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsAccessibilityQuery, GraphqlTypes.GetContactsAccessibilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactsAccessibilityQuery, GraphqlTypes.GetContactsAccessibilityQueryVariables>(GetContactsAccessibilityDocument, options);
        }
export type GetContactsAccessibilityQueryHookResult = ReturnType<typeof useGetContactsAccessibilityQuery>;
export type GetContactsAccessibilityLazyQueryHookResult = ReturnType<typeof useGetContactsAccessibilityLazyQuery>;
export type GetContactsAccessibilitySuspenseQueryHookResult = ReturnType<typeof useGetContactsAccessibilitySuspenseQuery>;
export type GetContactsAccessibilityQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactsAccessibilityQuery, GraphqlTypes.GetContactsAccessibilityQueryVariables>;
export const GetUserContactsViewDocument = gql`
    query GetUserContactsView {
  userGridView(tableType: Contacts) {
    columnOrder {
      orderedColIds
    }
    columnVisibility {
      hiddenColIds
    }
    columnSizing {
      colId
      flex
      width
    }
    columnPinning {
      leftColIds
      rightColIds
    }
    setFilters {
      field
      selected
      quantifier
    }
    numberFilters {
      field
      filter
      filterTo
      numberFilterType
    }
    locationFilters {
      field
      coordinates {
        latitude
        longitude
        radius
      }
      stateName
      countryName
    }
    extensionFieldFilters {
      textFilters {
        extensionFieldId
        text
        textFilterType
      }
      intFilters {
        extensionFieldId
        numberFilterType
        filter
        filterTo
      }
      floatFilters {
        extensionFieldId
        numberFilterType
        filter
        filterTo
      }
      dateFilters {
        extensionFieldId
        dateFilterType
        filter
        filterTo
      }
    }
  }
}
    `;

/**
 * __useGetUserContactsViewQuery__
 *
 * To run a query within a React component, call `useGetUserContactsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserContactsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserContactsViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserContactsViewQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetUserContactsViewQuery, GraphqlTypes.GetUserContactsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUserContactsViewQuery, GraphqlTypes.GetUserContactsViewQueryVariables>(GetUserContactsViewDocument, options);
      }
export function useGetUserContactsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUserContactsViewQuery, GraphqlTypes.GetUserContactsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUserContactsViewQuery, GraphqlTypes.GetUserContactsViewQueryVariables>(GetUserContactsViewDocument, options);
        }
// @ts-ignore
export function useGetUserContactsViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserContactsViewQuery, GraphqlTypes.GetUserContactsViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserContactsViewQuery, GraphqlTypes.GetUserContactsViewQueryVariables>;
export function useGetUserContactsViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserContactsViewQuery, GraphqlTypes.GetUserContactsViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserContactsViewQuery | undefined, GraphqlTypes.GetUserContactsViewQueryVariables>;
export function useGetUserContactsViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserContactsViewQuery, GraphqlTypes.GetUserContactsViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUserContactsViewQuery, GraphqlTypes.GetUserContactsViewQueryVariables>(GetUserContactsViewDocument, options);
        }
export type GetUserContactsViewQueryHookResult = ReturnType<typeof useGetUserContactsViewQuery>;
export type GetUserContactsViewLazyQueryHookResult = ReturnType<typeof useGetUserContactsViewLazyQuery>;
export type GetUserContactsViewSuspenseQueryHookResult = ReturnType<typeof useGetUserContactsViewSuspenseQuery>;
export type GetUserContactsViewQueryResult = Apollo.QueryResult<GraphqlTypes.GetUserContactsViewQuery, GraphqlTypes.GetUserContactsViewQueryVariables>;
export const PreqinLocationAboutBatchDocument = gql`
    query PreqinLocationAboutBatch($contactIds: [Int!]!) {
  preqinLocationAboutBatch(contactIds: $contactIds) {
    contactId
    location
    about
  }
}
    `;

/**
 * __usePreqinLocationAboutBatchQuery__
 *
 * To run a query within a React component, call `usePreqinLocationAboutBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreqinLocationAboutBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreqinLocationAboutBatchQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function usePreqinLocationAboutBatchQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.PreqinLocationAboutBatchQuery, GraphqlTypes.PreqinLocationAboutBatchQueryVariables> & ({ variables: GraphqlTypes.PreqinLocationAboutBatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.PreqinLocationAboutBatchQuery, GraphqlTypes.PreqinLocationAboutBatchQueryVariables>(PreqinLocationAboutBatchDocument, options);
      }
export function usePreqinLocationAboutBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.PreqinLocationAboutBatchQuery, GraphqlTypes.PreqinLocationAboutBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.PreqinLocationAboutBatchQuery, GraphqlTypes.PreqinLocationAboutBatchQueryVariables>(PreqinLocationAboutBatchDocument, options);
        }
// @ts-ignore
export function usePreqinLocationAboutBatchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.PreqinLocationAboutBatchQuery, GraphqlTypes.PreqinLocationAboutBatchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PreqinLocationAboutBatchQuery, GraphqlTypes.PreqinLocationAboutBatchQueryVariables>;
export function usePreqinLocationAboutBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PreqinLocationAboutBatchQuery, GraphqlTypes.PreqinLocationAboutBatchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PreqinLocationAboutBatchQuery | undefined, GraphqlTypes.PreqinLocationAboutBatchQueryVariables>;
export function usePreqinLocationAboutBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PreqinLocationAboutBatchQuery, GraphqlTypes.PreqinLocationAboutBatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.PreqinLocationAboutBatchQuery, GraphqlTypes.PreqinLocationAboutBatchQueryVariables>(PreqinLocationAboutBatchDocument, options);
        }
export type PreqinLocationAboutBatchQueryHookResult = ReturnType<typeof usePreqinLocationAboutBatchQuery>;
export type PreqinLocationAboutBatchLazyQueryHookResult = ReturnType<typeof usePreqinLocationAboutBatchLazyQuery>;
export type PreqinLocationAboutBatchSuspenseQueryHookResult = ReturnType<typeof usePreqinLocationAboutBatchSuspenseQuery>;
export type PreqinLocationAboutBatchQueryResult = Apollo.QueryResult<GraphqlTypes.PreqinLocationAboutBatchQuery, GraphqlTypes.PreqinLocationAboutBatchQueryVariables>;
export const SearchContactsAndAccountForTicketDocument = gql`
    query SearchContactsAndAccountForTicket($term: String!) {
  contacts: contactsPageGrid(
    nameFilter: {filter: $term}
    setFilters: [{field: "portal_access", selected: ["1"], quantifier: any}]
    limit: 5
  ) {
    rows {
      id
      name
      __typename
    }
  }
  accounts: searchAccounts(term: $term, first: 5, objectFilter: is_not_entity) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSearchContactsAndAccountForTicketQuery__
 *
 * To run a query within a React component, call `useSearchContactsAndAccountForTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactsAndAccountForTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactsAndAccountForTicketQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchContactsAndAccountForTicketQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchContactsAndAccountForTicketQuery, GraphqlTypes.SearchContactsAndAccountForTicketQueryVariables> & ({ variables: GraphqlTypes.SearchContactsAndAccountForTicketQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchContactsAndAccountForTicketQuery, GraphqlTypes.SearchContactsAndAccountForTicketQueryVariables>(SearchContactsAndAccountForTicketDocument, options);
      }
export function useSearchContactsAndAccountForTicketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchContactsAndAccountForTicketQuery, GraphqlTypes.SearchContactsAndAccountForTicketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchContactsAndAccountForTicketQuery, GraphqlTypes.SearchContactsAndAccountForTicketQueryVariables>(SearchContactsAndAccountForTicketDocument, options);
        }
// @ts-ignore
export function useSearchContactsAndAccountForTicketSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchContactsAndAccountForTicketQuery, GraphqlTypes.SearchContactsAndAccountForTicketQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchContactsAndAccountForTicketQuery, GraphqlTypes.SearchContactsAndAccountForTicketQueryVariables>;
export function useSearchContactsAndAccountForTicketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchContactsAndAccountForTicketQuery, GraphqlTypes.SearchContactsAndAccountForTicketQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchContactsAndAccountForTicketQuery | undefined, GraphqlTypes.SearchContactsAndAccountForTicketQueryVariables>;
export function useSearchContactsAndAccountForTicketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchContactsAndAccountForTicketQuery, GraphqlTypes.SearchContactsAndAccountForTicketQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchContactsAndAccountForTicketQuery, GraphqlTypes.SearchContactsAndAccountForTicketQueryVariables>(SearchContactsAndAccountForTicketDocument, options);
        }
export type SearchContactsAndAccountForTicketQueryHookResult = ReturnType<typeof useSearchContactsAndAccountForTicketQuery>;
export type SearchContactsAndAccountForTicketLazyQueryHookResult = ReturnType<typeof useSearchContactsAndAccountForTicketLazyQuery>;
export type SearchContactsAndAccountForTicketSuspenseQueryHookResult = ReturnType<typeof useSearchContactsAndAccountForTicketSuspenseQuery>;
export type SearchContactsAndAccountForTicketQueryResult = Apollo.QueryResult<GraphqlTypes.SearchContactsAndAccountForTicketQuery, GraphqlTypes.SearchContactsAndAccountForTicketQueryVariables>;
export const SearchEntitiesForTicketDocument = gql`
    query SearchEntitiesForTicket($term: String!) {
  searchAccounts(term: $term, first: 20, objectFilter: is_entity) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSearchEntitiesForTicketQuery__
 *
 * To run a query within a React component, call `useSearchEntitiesForTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEntitiesForTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEntitiesForTicketQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchEntitiesForTicketQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchEntitiesForTicketQuery, GraphqlTypes.SearchEntitiesForTicketQueryVariables> & ({ variables: GraphqlTypes.SearchEntitiesForTicketQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchEntitiesForTicketQuery, GraphqlTypes.SearchEntitiesForTicketQueryVariables>(SearchEntitiesForTicketDocument, options);
      }
export function useSearchEntitiesForTicketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchEntitiesForTicketQuery, GraphqlTypes.SearchEntitiesForTicketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchEntitiesForTicketQuery, GraphqlTypes.SearchEntitiesForTicketQueryVariables>(SearchEntitiesForTicketDocument, options);
        }
// @ts-ignore
export function useSearchEntitiesForTicketSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchEntitiesForTicketQuery, GraphqlTypes.SearchEntitiesForTicketQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchEntitiesForTicketQuery, GraphqlTypes.SearchEntitiesForTicketQueryVariables>;
export function useSearchEntitiesForTicketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchEntitiesForTicketQuery, GraphqlTypes.SearchEntitiesForTicketQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchEntitiesForTicketQuery | undefined, GraphqlTypes.SearchEntitiesForTicketQueryVariables>;
export function useSearchEntitiesForTicketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchEntitiesForTicketQuery, GraphqlTypes.SearchEntitiesForTicketQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchEntitiesForTicketQuery, GraphqlTypes.SearchEntitiesForTicketQueryVariables>(SearchEntitiesForTicketDocument, options);
        }
export type SearchEntitiesForTicketQueryHookResult = ReturnType<typeof useSearchEntitiesForTicketQuery>;
export type SearchEntitiesForTicketLazyQueryHookResult = ReturnType<typeof useSearchEntitiesForTicketLazyQuery>;
export type SearchEntitiesForTicketSuspenseQueryHookResult = ReturnType<typeof useSearchEntitiesForTicketSuspenseQuery>;
export type SearchEntitiesForTicketQueryResult = Apollo.QueryResult<GraphqlTypes.SearchEntitiesForTicketQuery, GraphqlTypes.SearchEntitiesForTicketQueryVariables>;
export const SearchOfferingsForTicketDocument = gql`
    query SearchOfferingsForTicket($term: String!) {
  searchOfferings(term: $term) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSearchOfferingsForTicketQuery__
 *
 * To run a query within a React component, call `useSearchOfferingsForTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOfferingsForTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOfferingsForTicketQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchOfferingsForTicketQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchOfferingsForTicketQuery, GraphqlTypes.SearchOfferingsForTicketQueryVariables> & ({ variables: GraphqlTypes.SearchOfferingsForTicketQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchOfferingsForTicketQuery, GraphqlTypes.SearchOfferingsForTicketQueryVariables>(SearchOfferingsForTicketDocument, options);
      }
export function useSearchOfferingsForTicketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchOfferingsForTicketQuery, GraphqlTypes.SearchOfferingsForTicketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchOfferingsForTicketQuery, GraphqlTypes.SearchOfferingsForTicketQueryVariables>(SearchOfferingsForTicketDocument, options);
        }
// @ts-ignore
export function useSearchOfferingsForTicketSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchOfferingsForTicketQuery, GraphqlTypes.SearchOfferingsForTicketQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchOfferingsForTicketQuery, GraphqlTypes.SearchOfferingsForTicketQueryVariables>;
export function useSearchOfferingsForTicketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchOfferingsForTicketQuery, GraphqlTypes.SearchOfferingsForTicketQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchOfferingsForTicketQuery | undefined, GraphqlTypes.SearchOfferingsForTicketQueryVariables>;
export function useSearchOfferingsForTicketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchOfferingsForTicketQuery, GraphqlTypes.SearchOfferingsForTicketQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchOfferingsForTicketQuery, GraphqlTypes.SearchOfferingsForTicketQueryVariables>(SearchOfferingsForTicketDocument, options);
        }
export type SearchOfferingsForTicketQueryHookResult = ReturnType<typeof useSearchOfferingsForTicketQuery>;
export type SearchOfferingsForTicketLazyQueryHookResult = ReturnType<typeof useSearchOfferingsForTicketLazyQuery>;
export type SearchOfferingsForTicketSuspenseQueryHookResult = ReturnType<typeof useSearchOfferingsForTicketSuspenseQuery>;
export type SearchOfferingsForTicketQueryResult = Apollo.QueryResult<GraphqlTypes.SearchOfferingsForTicketQuery, GraphqlTypes.SearchOfferingsForTicketQueryVariables>;
export const SearchOrganizationsForTicketDocument = gql`
    query SearchOrganizationsForTicket($term: String!) {
  searchContacts(term: $term, objectFilter: is_org) {
    edges {
      node {
        id
        fullName
        lastName
      }
    }
  }
}
    `;

/**
 * __useSearchOrganizationsForTicketQuery__
 *
 * To run a query within a React component, call `useSearchOrganizationsForTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOrganizationsForTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOrganizationsForTicketQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchOrganizationsForTicketQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchOrganizationsForTicketQuery, GraphqlTypes.SearchOrganizationsForTicketQueryVariables> & ({ variables: GraphqlTypes.SearchOrganizationsForTicketQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchOrganizationsForTicketQuery, GraphqlTypes.SearchOrganizationsForTicketQueryVariables>(SearchOrganizationsForTicketDocument, options);
      }
export function useSearchOrganizationsForTicketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchOrganizationsForTicketQuery, GraphqlTypes.SearchOrganizationsForTicketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchOrganizationsForTicketQuery, GraphqlTypes.SearchOrganizationsForTicketQueryVariables>(SearchOrganizationsForTicketDocument, options);
        }
// @ts-ignore
export function useSearchOrganizationsForTicketSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchOrganizationsForTicketQuery, GraphqlTypes.SearchOrganizationsForTicketQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchOrganizationsForTicketQuery, GraphqlTypes.SearchOrganizationsForTicketQueryVariables>;
export function useSearchOrganizationsForTicketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchOrganizationsForTicketQuery, GraphqlTypes.SearchOrganizationsForTicketQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchOrganizationsForTicketQuery | undefined, GraphqlTypes.SearchOrganizationsForTicketQueryVariables>;
export function useSearchOrganizationsForTicketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchOrganizationsForTicketQuery, GraphqlTypes.SearchOrganizationsForTicketQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchOrganizationsForTicketQuery, GraphqlTypes.SearchOrganizationsForTicketQueryVariables>(SearchOrganizationsForTicketDocument, options);
        }
export type SearchOrganizationsForTicketQueryHookResult = ReturnType<typeof useSearchOrganizationsForTicketQuery>;
export type SearchOrganizationsForTicketLazyQueryHookResult = ReturnType<typeof useSearchOrganizationsForTicketLazyQuery>;
export type SearchOrganizationsForTicketSuspenseQueryHookResult = ReturnType<typeof useSearchOrganizationsForTicketSuspenseQuery>;
export type SearchOrganizationsForTicketQueryResult = Apollo.QueryResult<GraphqlTypes.SearchOrganizationsForTicketQuery, GraphqlTypes.SearchOrganizationsForTicketQueryVariables>;
export const EditUserLookerViewDocument = gql`
    mutation EditUserLookerView($lookerViews: [UserLookerViewInputObjectType!]!) {
  insightsOps {
    editUserLookerViews(lookerViews: $lookerViews) {
      result {
        ...EditUserLookerViewFields
      }
    }
  }
}
    ${EditUserLookerViewFieldsFragmentDoc}`;
export type EditUserLookerViewMutationFn = Apollo.MutationFunction<GraphqlTypes.EditUserLookerViewMutation, GraphqlTypes.EditUserLookerViewMutationVariables>;

/**
 * __useEditUserLookerViewMutation__
 *
 * To run a mutation, you first call `useEditUserLookerViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserLookerViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserLookerViewMutation, { data, loading, error }] = useEditUserLookerViewMutation({
 *   variables: {
 *      lookerViews: // value for 'lookerViews'
 *   },
 * });
 */
export function useEditUserLookerViewMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditUserLookerViewMutation, GraphqlTypes.EditUserLookerViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditUserLookerViewMutation, GraphqlTypes.EditUserLookerViewMutationVariables>(EditUserLookerViewDocument, options);
      }
export type EditUserLookerViewMutationHookResult = ReturnType<typeof useEditUserLookerViewMutation>;
export type EditUserLookerViewMutationResult = Apollo.MutationResult<GraphqlTypes.EditUserLookerViewMutation>;
export type EditUserLookerViewMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditUserLookerViewMutation, GraphqlTypes.EditUserLookerViewMutationVariables>;
export const GetUserLookerViewsDocument = gql`
    query GetUserLookerViews($includeDisabled: Boolean) {
  dashboards(includeDisabled: $includeDisabled) {
    ...UserLookerDashboard
  }
}
    ${UserLookerDashboardFragmentDoc}`;

/**
 * __useGetUserLookerViewsQuery__
 *
 * To run a query within a React component, call `useGetUserLookerViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLookerViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLookerViewsQuery({
 *   variables: {
 *      includeDisabled: // value for 'includeDisabled'
 *   },
 * });
 */
export function useGetUserLookerViewsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetUserLookerViewsQuery, GraphqlTypes.GetUserLookerViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUserLookerViewsQuery, GraphqlTypes.GetUserLookerViewsQueryVariables>(GetUserLookerViewsDocument, options);
      }
export function useGetUserLookerViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUserLookerViewsQuery, GraphqlTypes.GetUserLookerViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUserLookerViewsQuery, GraphqlTypes.GetUserLookerViewsQueryVariables>(GetUserLookerViewsDocument, options);
        }
// @ts-ignore
export function useGetUserLookerViewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserLookerViewsQuery, GraphqlTypes.GetUserLookerViewsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserLookerViewsQuery, GraphqlTypes.GetUserLookerViewsQueryVariables>;
export function useGetUserLookerViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserLookerViewsQuery, GraphqlTypes.GetUserLookerViewsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserLookerViewsQuery | undefined, GraphqlTypes.GetUserLookerViewsQueryVariables>;
export function useGetUserLookerViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserLookerViewsQuery, GraphqlTypes.GetUserLookerViewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUserLookerViewsQuery, GraphqlTypes.GetUserLookerViewsQueryVariables>(GetUserLookerViewsDocument, options);
        }
export type GetUserLookerViewsQueryHookResult = ReturnType<typeof useGetUserLookerViewsQuery>;
export type GetUserLookerViewsLazyQueryHookResult = ReturnType<typeof useGetUserLookerViewsLazyQuery>;
export type GetUserLookerViewsSuspenseQueryHookResult = ReturnType<typeof useGetUserLookerViewsSuspenseQuery>;
export type GetUserLookerViewsQueryResult = Apollo.QueryResult<GraphqlTypes.GetUserLookerViewsQuery, GraphqlTypes.GetUserLookerViewsQueryVariables>;
export const AddTagDocument = gql`
    mutation AddTag($jsqObjectType: JSQObjectType!, $objectIds: [ID]!, $objectInput: AddTagInput!) {
  tagOps {
    addTag(
      jsqObjectType: $jsqObjectType
      objectIds: $objectIds
      objectInput: $objectInput
    ) {
      tag {
        ...TagFields
      }
      updatedObjects {
        ... on PermissionCheckedNode {
          id
        }
      }
    }
  }
}
    ${TagFieldsFragmentDoc}`;
export type AddTagMutationFn = Apollo.MutationFunction<GraphqlTypes.AddTagMutation, GraphqlTypes.AddTagMutationVariables>;

/**
 * __useAddTagMutation__
 *
 * To run a mutation, you first call `useAddTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagMutation, { data, loading, error }] = useAddTagMutation({
 *   variables: {
 *      jsqObjectType: // value for 'jsqObjectType'
 *      objectIds: // value for 'objectIds'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useAddTagMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddTagMutation, GraphqlTypes.AddTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddTagMutation, GraphqlTypes.AddTagMutationVariables>(AddTagDocument, options);
      }
export type AddTagMutationHookResult = ReturnType<typeof useAddTagMutation>;
export type AddTagMutationResult = Apollo.MutationResult<GraphqlTypes.AddTagMutation>;
export type AddTagMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddTagMutation, GraphqlTypes.AddTagMutationVariables>;
export const BulkUpdateEntitiesDocument = gql`
    mutation BulkUpdateEntities($input: BulkUpdateEntitiesInput!) {
  entityBulkOps {
    update(objectInput: $input) {
      updated
      notUpdated
      entities {
        id
        status
        entityCollection {
          id
          name
        }
        type {
          id
          name
        }
      }
    }
  }
}
    `;
export type BulkUpdateEntitiesMutationFn = Apollo.MutationFunction<GraphqlTypes.BulkUpdateEntitiesMutation, GraphqlTypes.BulkUpdateEntitiesMutationVariables>;

/**
 * __useBulkUpdateEntitiesMutation__
 *
 * To run a mutation, you first call `useBulkUpdateEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateEntitiesMutation, { data, loading, error }] = useBulkUpdateEntitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.BulkUpdateEntitiesMutation, GraphqlTypes.BulkUpdateEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.BulkUpdateEntitiesMutation, GraphqlTypes.BulkUpdateEntitiesMutationVariables>(BulkUpdateEntitiesDocument, options);
      }
export type BulkUpdateEntitiesMutationHookResult = ReturnType<typeof useBulkUpdateEntitiesMutation>;
export type BulkUpdateEntitiesMutationResult = Apollo.MutationResult<GraphqlTypes.BulkUpdateEntitiesMutation>;
export type BulkUpdateEntitiesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.BulkUpdateEntitiesMutation, GraphqlTypes.BulkUpdateEntitiesMutationVariables>;
export const ExportCapitalAccountBalanceDocument = gql`
    mutation ExportCapitalAccountBalance($entityIds: [ID]!, $startDate: Date!, $endDate: Date!, $exportDailyReport: Boolean!) {
  entityOps {
    downloadCapitalAccountBalance(
      gpEntityIdList: $entityIds
      gpStartDate: $startDate
      gpEndDate: $endDate
      exportDailyReport: $exportDailyReport
    ) {
      job {
        id
      }
    }
  }
}
    `;
export type ExportCapitalAccountBalanceMutationFn = Apollo.MutationFunction<GraphqlTypes.ExportCapitalAccountBalanceMutation, GraphqlTypes.ExportCapitalAccountBalanceMutationVariables>;

/**
 * __useExportCapitalAccountBalanceMutation__
 *
 * To run a mutation, you first call `useExportCapitalAccountBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCapitalAccountBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCapitalAccountBalanceMutation, { data, loading, error }] = useExportCapitalAccountBalanceMutation({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      exportDailyReport: // value for 'exportDailyReport'
 *   },
 * });
 */
export function useExportCapitalAccountBalanceMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExportCapitalAccountBalanceMutation, GraphqlTypes.ExportCapitalAccountBalanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExportCapitalAccountBalanceMutation, GraphqlTypes.ExportCapitalAccountBalanceMutationVariables>(ExportCapitalAccountBalanceDocument, options);
      }
export type ExportCapitalAccountBalanceMutationHookResult = ReturnType<typeof useExportCapitalAccountBalanceMutation>;
export type ExportCapitalAccountBalanceMutationResult = Apollo.MutationResult<GraphqlTypes.ExportCapitalAccountBalanceMutation>;
export type ExportCapitalAccountBalanceMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExportCapitalAccountBalanceMutation, GraphqlTypes.ExportCapitalAccountBalanceMutationVariables>;
export const GetCapitalCallAccountBalanceExportDocument = gql`
    query GetCapitalCallAccountBalanceExport($jobId: ID!) {
  capitalAccountBalanceDownloadUrl(asyncJobId: $jobId)
}
    `;

/**
 * __useGetCapitalCallAccountBalanceExportQuery__
 *
 * To run a query within a React component, call `useGetCapitalCallAccountBalanceExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapitalCallAccountBalanceExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapitalCallAccountBalanceExportQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetCapitalCallAccountBalanceExportQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCapitalCallAccountBalanceExportQuery, GraphqlTypes.GetCapitalCallAccountBalanceExportQueryVariables> & ({ variables: GraphqlTypes.GetCapitalCallAccountBalanceExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCapitalCallAccountBalanceExportQuery, GraphqlTypes.GetCapitalCallAccountBalanceExportQueryVariables>(GetCapitalCallAccountBalanceExportDocument, options);
      }
export function useGetCapitalCallAccountBalanceExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCapitalCallAccountBalanceExportQuery, GraphqlTypes.GetCapitalCallAccountBalanceExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCapitalCallAccountBalanceExportQuery, GraphqlTypes.GetCapitalCallAccountBalanceExportQueryVariables>(GetCapitalCallAccountBalanceExportDocument, options);
        }
// @ts-ignore
export function useGetCapitalCallAccountBalanceExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallAccountBalanceExportQuery, GraphqlTypes.GetCapitalCallAccountBalanceExportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalCallAccountBalanceExportQuery, GraphqlTypes.GetCapitalCallAccountBalanceExportQueryVariables>;
export function useGetCapitalCallAccountBalanceExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallAccountBalanceExportQuery, GraphqlTypes.GetCapitalCallAccountBalanceExportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalCallAccountBalanceExportQuery | undefined, GraphqlTypes.GetCapitalCallAccountBalanceExportQueryVariables>;
export function useGetCapitalCallAccountBalanceExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallAccountBalanceExportQuery, GraphqlTypes.GetCapitalCallAccountBalanceExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCapitalCallAccountBalanceExportQuery, GraphqlTypes.GetCapitalCallAccountBalanceExportQueryVariables>(GetCapitalCallAccountBalanceExportDocument, options);
        }
export type GetCapitalCallAccountBalanceExportQueryHookResult = ReturnType<typeof useGetCapitalCallAccountBalanceExportQuery>;
export type GetCapitalCallAccountBalanceExportLazyQueryHookResult = ReturnType<typeof useGetCapitalCallAccountBalanceExportLazyQuery>;
export type GetCapitalCallAccountBalanceExportSuspenseQueryHookResult = ReturnType<typeof useGetCapitalCallAccountBalanceExportSuspenseQuery>;
export type GetCapitalCallAccountBalanceExportQueryResult = Apollo.QueryResult<GraphqlTypes.GetCapitalCallAccountBalanceExportQuery, GraphqlTypes.GetCapitalCallAccountBalanceExportQueryVariables>;
export const RemoveTagDocument = gql`
    mutation RemoveTag($tagId: ID!, $jsqObjectType: JSQObjectType!, $objectIds: [ID]!) {
  tagOps {
    removeTag(tagId: $tagId, jsqObjectType: $jsqObjectType, objectIds: $objectIds) {
      tag {
        ...TagFields
      }
      updatedObjects {
        ... on PermissionCheckedNode {
          id
        }
      }
    }
  }
}
    ${TagFieldsFragmentDoc}`;
export type RemoveTagMutationFn = Apollo.MutationFunction<GraphqlTypes.RemoveTagMutation, GraphqlTypes.RemoveTagMutationVariables>;

/**
 * __useRemoveTagMutation__
 *
 * To run a mutation, you first call `useRemoveTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagMutation, { data, loading, error }] = useRemoveTagMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *      jsqObjectType: // value for 'jsqObjectType'
 *      objectIds: // value for 'objectIds'
 *   },
 * });
 */
export function useRemoveTagMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RemoveTagMutation, GraphqlTypes.RemoveTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RemoveTagMutation, GraphqlTypes.RemoveTagMutationVariables>(RemoveTagDocument, options);
      }
export type RemoveTagMutationHookResult = ReturnType<typeof useRemoveTagMutation>;
export type RemoveTagMutationResult = Apollo.MutationResult<GraphqlTypes.RemoveTagMutation>;
export type RemoveTagMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RemoveTagMutation, GraphqlTypes.RemoveTagMutationVariables>;
export const GetInvestmentEntitiesDocument = gql`
    query GetInvestmentEntities($filters: EntitiesFilters, $first: Int, $after: String) {
  total: investmentEntities {
    count
  }
  filtered: investmentEntities(filters: $filters, first: $first, after: $after) {
    count
    edges {
      node {
        ...EntityFields
        ...ComputedEntityFields
        ...Tags
        portalStatus
        isOperatingCompany
        directlyOwnedEntities {
          ...EntityFields
        }
        entityCollection {
          id
          name
        }
        entityAccessGroups {
          id
          title
        }
        currency {
          code
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${EntityFieldsFragmentDoc}
${ComputedEntityFieldsFragmentDoc}
${TagsFragmentDoc}`;

/**
 * __useGetInvestmentEntitiesQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntitiesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetInvestmentEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>(GetInvestmentEntitiesDocument, options);
      }
export function useGetInvestmentEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>(GetInvestmentEntitiesDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>;
export function useGetInvestmentEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesQuery | undefined, GraphqlTypes.GetInvestmentEntitiesQueryVariables>;
export function useGetInvestmentEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>(GetInvestmentEntitiesDocument, options);
        }
export type GetInvestmentEntitiesQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesQuery>;
export type GetInvestmentEntitiesLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesLazyQuery>;
export type GetInvestmentEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesSuspenseQuery>;
export type GetInvestmentEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>;
export const GetInvestmentEntitiesByArenaDocument = gql`
    query GetInvestmentEntitiesByArena($arenaId: ID, $filterEntitiesWithTransactions: Boolean = true) {
  investmentEntitiesByArena(
    arenaId: $arenaId
    filterEntitiesWithTransactions: $filterEntitiesWithTransactions
  ) {
    edges {
      node {
        ...EntityFields
      }
    }
  }
}
    ${EntityFieldsFragmentDoc}`;

/**
 * __useGetInvestmentEntitiesByArenaQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntitiesByArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntitiesByArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntitiesByArenaQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      filterEntitiesWithTransactions: // value for 'filterEntitiesWithTransactions'
 *   },
 * });
 */
export function useGetInvestmentEntitiesByArenaQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>(GetInvestmentEntitiesByArenaDocument, options);
      }
export function useGetInvestmentEntitiesByArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>(GetInvestmentEntitiesByArenaDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntitiesByArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>;
export function useGetInvestmentEntitiesByArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesByArenaQuery | undefined, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>;
export function useGetInvestmentEntitiesByArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>(GetInvestmentEntitiesByArenaDocument, options);
        }
export type GetInvestmentEntitiesByArenaQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesByArenaQuery>;
export type GetInvestmentEntitiesByArenaLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesByArenaLazyQuery>;
export type GetInvestmentEntitiesByArenaSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesByArenaSuspenseQuery>;
export type GetInvestmentEntitiesByArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>;
export const GetOperatingCompaniesFeatureFlagDocument = gql`
    query GetOperatingCompaniesFeatureFlag {
  devFeatures {
    enableOperatingCompanies
  }
}
    `;

/**
 * __useGetOperatingCompaniesFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetOperatingCompaniesFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperatingCompaniesFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperatingCompaniesFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOperatingCompaniesFeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetOperatingCompaniesFeatureFlagQuery, GraphqlTypes.GetOperatingCompaniesFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOperatingCompaniesFeatureFlagQuery, GraphqlTypes.GetOperatingCompaniesFeatureFlagQueryVariables>(GetOperatingCompaniesFeatureFlagDocument, options);
      }
export function useGetOperatingCompaniesFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOperatingCompaniesFeatureFlagQuery, GraphqlTypes.GetOperatingCompaniesFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOperatingCompaniesFeatureFlagQuery, GraphqlTypes.GetOperatingCompaniesFeatureFlagQueryVariables>(GetOperatingCompaniesFeatureFlagDocument, options);
        }
// @ts-ignore
export function useGetOperatingCompaniesFeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOperatingCompaniesFeatureFlagQuery, GraphqlTypes.GetOperatingCompaniesFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOperatingCompaniesFeatureFlagQuery, GraphqlTypes.GetOperatingCompaniesFeatureFlagQueryVariables>;
export function useGetOperatingCompaniesFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOperatingCompaniesFeatureFlagQuery, GraphqlTypes.GetOperatingCompaniesFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOperatingCompaniesFeatureFlagQuery | undefined, GraphqlTypes.GetOperatingCompaniesFeatureFlagQueryVariables>;
export function useGetOperatingCompaniesFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOperatingCompaniesFeatureFlagQuery, GraphqlTypes.GetOperatingCompaniesFeatureFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOperatingCompaniesFeatureFlagQuery, GraphqlTypes.GetOperatingCompaniesFeatureFlagQueryVariables>(GetOperatingCompaniesFeatureFlagDocument, options);
        }
export type GetOperatingCompaniesFeatureFlagQueryHookResult = ReturnType<typeof useGetOperatingCompaniesFeatureFlagQuery>;
export type GetOperatingCompaniesFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetOperatingCompaniesFeatureFlagLazyQuery>;
export type GetOperatingCompaniesFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetOperatingCompaniesFeatureFlagSuspenseQuery>;
export type GetOperatingCompaniesFeatureFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GetOperatingCompaniesFeatureFlagQuery, GraphqlTypes.GetOperatingCompaniesFeatureFlagQueryVariables>;
export const GetTransactionsInReviewDocument = gql`
    query GetTransactionsInReview($count: Boolean) {
  reviewInfo(countOnly: $count) {
    entityCount
    transactionCount
    transactionBatchData {
      entityId
      entityName
      lastReadyForReviewDate
      capitalCall
      transactionBatch
      distribution
      managementFee
      netIncome
      nav
    }
  }
}
    `;

/**
 * __useGetTransactionsInReviewQuery__
 *
 * To run a query within a React component, call `useGetTransactionsInReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsInReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsInReviewQuery({
 *   variables: {
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetTransactionsInReviewQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetTransactionsInReviewQuery, GraphqlTypes.GetTransactionsInReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTransactionsInReviewQuery, GraphqlTypes.GetTransactionsInReviewQueryVariables>(GetTransactionsInReviewDocument, options);
      }
export function useGetTransactionsInReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTransactionsInReviewQuery, GraphqlTypes.GetTransactionsInReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTransactionsInReviewQuery, GraphqlTypes.GetTransactionsInReviewQueryVariables>(GetTransactionsInReviewDocument, options);
        }
// @ts-ignore
export function useGetTransactionsInReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionsInReviewQuery, GraphqlTypes.GetTransactionsInReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionsInReviewQuery, GraphqlTypes.GetTransactionsInReviewQueryVariables>;
export function useGetTransactionsInReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionsInReviewQuery, GraphqlTypes.GetTransactionsInReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionsInReviewQuery | undefined, GraphqlTypes.GetTransactionsInReviewQueryVariables>;
export function useGetTransactionsInReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionsInReviewQuery, GraphqlTypes.GetTransactionsInReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTransactionsInReviewQuery, GraphqlTypes.GetTransactionsInReviewQueryVariables>(GetTransactionsInReviewDocument, options);
        }
export type GetTransactionsInReviewQueryHookResult = ReturnType<typeof useGetTransactionsInReviewQuery>;
export type GetTransactionsInReviewLazyQueryHookResult = ReturnType<typeof useGetTransactionsInReviewLazyQuery>;
export type GetTransactionsInReviewSuspenseQueryHookResult = ReturnType<typeof useGetTransactionsInReviewSuspenseQuery>;
export type GetTransactionsInReviewQueryResult = Apollo.QueryResult<GraphqlTypes.GetTransactionsInReviewQuery, GraphqlTypes.GetTransactionsInReviewQueryVariables>;
export const PortalOperationEligibilityDocument = gql`
    query PortalOperationEligibility($contactId: ID!, $operationType: String!) {
  portalOperationEligibility(contactId: $contactId, operationType: $operationType) {
    title
    confirmMessage
    saveLabel
    cancelLabel
  }
}
    `;

/**
 * __usePortalOperationEligibilityQuery__
 *
 * To run a query within a React component, call `usePortalOperationEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalOperationEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalOperationEligibilityQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      operationType: // value for 'operationType'
 *   },
 * });
 */
export function usePortalOperationEligibilityQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.PortalOperationEligibilityQuery, GraphqlTypes.PortalOperationEligibilityQueryVariables> & ({ variables: GraphqlTypes.PortalOperationEligibilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.PortalOperationEligibilityQuery, GraphqlTypes.PortalOperationEligibilityQueryVariables>(PortalOperationEligibilityDocument, options);
      }
export function usePortalOperationEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.PortalOperationEligibilityQuery, GraphqlTypes.PortalOperationEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.PortalOperationEligibilityQuery, GraphqlTypes.PortalOperationEligibilityQueryVariables>(PortalOperationEligibilityDocument, options);
        }
// @ts-ignore
export function usePortalOperationEligibilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.PortalOperationEligibilityQuery, GraphqlTypes.PortalOperationEligibilityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PortalOperationEligibilityQuery, GraphqlTypes.PortalOperationEligibilityQueryVariables>;
export function usePortalOperationEligibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PortalOperationEligibilityQuery, GraphqlTypes.PortalOperationEligibilityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PortalOperationEligibilityQuery | undefined, GraphqlTypes.PortalOperationEligibilityQueryVariables>;
export function usePortalOperationEligibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PortalOperationEligibilityQuery, GraphqlTypes.PortalOperationEligibilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.PortalOperationEligibilityQuery, GraphqlTypes.PortalOperationEligibilityQueryVariables>(PortalOperationEligibilityDocument, options);
        }
export type PortalOperationEligibilityQueryHookResult = ReturnType<typeof usePortalOperationEligibilityQuery>;
export type PortalOperationEligibilityLazyQueryHookResult = ReturnType<typeof usePortalOperationEligibilityLazyQuery>;
export type PortalOperationEligibilitySuspenseQueryHookResult = ReturnType<typeof usePortalOperationEligibilitySuspenseQuery>;
export type PortalOperationEligibilityQueryResult = Apollo.QueryResult<GraphqlTypes.PortalOperationEligibilityQuery, GraphqlTypes.PortalOperationEligibilityQueryVariables>;
export const GetContactsWithoutPositionsDocument = gql`
    query GetContactsWithoutPositions($contactIds: [Int!]) {
  contactsWithoutPositions(contactIds: $contactIds) {
    edges {
      node {
        id
        fullName
      }
    }
  }
  nonPersonContacts(contactIds: $contactIds) {
    edges {
      node {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useGetContactsWithoutPositionsQuery__
 *
 * To run a query within a React component, call `useGetContactsWithoutPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsWithoutPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsWithoutPositionsQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useGetContactsWithoutPositionsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetContactsWithoutPositionsQuery, GraphqlTypes.GetContactsWithoutPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactsWithoutPositionsQuery, GraphqlTypes.GetContactsWithoutPositionsQueryVariables>(GetContactsWithoutPositionsDocument, options);
      }
export function useGetContactsWithoutPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactsWithoutPositionsQuery, GraphqlTypes.GetContactsWithoutPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactsWithoutPositionsQuery, GraphqlTypes.GetContactsWithoutPositionsQueryVariables>(GetContactsWithoutPositionsDocument, options);
        }
// @ts-ignore
export function useGetContactsWithoutPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsWithoutPositionsQuery, GraphqlTypes.GetContactsWithoutPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsWithoutPositionsQuery, GraphqlTypes.GetContactsWithoutPositionsQueryVariables>;
export function useGetContactsWithoutPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsWithoutPositionsQuery, GraphqlTypes.GetContactsWithoutPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsWithoutPositionsQuery | undefined, GraphqlTypes.GetContactsWithoutPositionsQueryVariables>;
export function useGetContactsWithoutPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsWithoutPositionsQuery, GraphqlTypes.GetContactsWithoutPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactsWithoutPositionsQuery, GraphqlTypes.GetContactsWithoutPositionsQueryVariables>(GetContactsWithoutPositionsDocument, options);
        }
export type GetContactsWithoutPositionsQueryHookResult = ReturnType<typeof useGetContactsWithoutPositionsQuery>;
export type GetContactsWithoutPositionsLazyQueryHookResult = ReturnType<typeof useGetContactsWithoutPositionsLazyQuery>;
export type GetContactsWithoutPositionsSuspenseQueryHookResult = ReturnType<typeof useGetContactsWithoutPositionsSuspenseQuery>;
export type GetContactsWithoutPositionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactsWithoutPositionsQuery, GraphqlTypes.GetContactsWithoutPositionsQueryVariables>;
export const SubmitKbaChoicesForInviteDocument = gql`
    mutation SubmitKBAChoicesForInvite($kbaAnswerSet: KbaAnswerSetInput!, $code: String!) {
  kycInviteOps {
    acceptOrRejectKbaChoices(kbaAnswerSet: $kbaAnswerSet, code: $code) {
      ...SubmitKBAResponse
    }
  }
}
    ${SubmitKbaResponseFragmentDoc}`;
export type SubmitKbaChoicesForInviteMutationFn = Apollo.MutationFunction<GraphqlTypes.SubmitKbaChoicesForInviteMutation, GraphqlTypes.SubmitKbaChoicesForInviteMutationVariables>;

/**
 * __useSubmitKbaChoicesForInviteMutation__
 *
 * To run a mutation, you first call `useSubmitKbaChoicesForInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitKbaChoicesForInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitKbaChoicesForInviteMutation, { data, loading, error }] = useSubmitKbaChoicesForInviteMutation({
 *   variables: {
 *      kbaAnswerSet: // value for 'kbaAnswerSet'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSubmitKbaChoicesForInviteMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubmitKbaChoicesForInviteMutation, GraphqlTypes.SubmitKbaChoicesForInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubmitKbaChoicesForInviteMutation, GraphqlTypes.SubmitKbaChoicesForInviteMutationVariables>(SubmitKbaChoicesForInviteDocument, options);
      }
export type SubmitKbaChoicesForInviteMutationHookResult = ReturnType<typeof useSubmitKbaChoicesForInviteMutation>;
export type SubmitKbaChoicesForInviteMutationResult = Apollo.MutationResult<GraphqlTypes.SubmitKbaChoicesForInviteMutation>;
export type SubmitKbaChoicesForInviteMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubmitKbaChoicesForInviteMutation, GraphqlTypes.SubmitKbaChoicesForInviteMutationVariables>;
export const GetKeyIndividualDocument = gql`
    query GetKeyIndividual($code: String!) {
  kycInvite(code: $code) {
    ...KycInviteObjectFields
  }
}
    ${KycInviteObjectFieldsFragmentDoc}`;

/**
 * __useGetKeyIndividualQuery__
 *
 * To run a query within a React component, call `useGetKeyIndividualQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeyIndividualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeyIndividualQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetKeyIndividualQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetKeyIndividualQuery, GraphqlTypes.GetKeyIndividualQueryVariables> & ({ variables: GraphqlTypes.GetKeyIndividualQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetKeyIndividualQuery, GraphqlTypes.GetKeyIndividualQueryVariables>(GetKeyIndividualDocument, options);
      }
export function useGetKeyIndividualLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetKeyIndividualQuery, GraphqlTypes.GetKeyIndividualQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetKeyIndividualQuery, GraphqlTypes.GetKeyIndividualQueryVariables>(GetKeyIndividualDocument, options);
        }
// @ts-ignore
export function useGetKeyIndividualSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKeyIndividualQuery, GraphqlTypes.GetKeyIndividualQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetKeyIndividualQuery, GraphqlTypes.GetKeyIndividualQueryVariables>;
export function useGetKeyIndividualSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKeyIndividualQuery, GraphqlTypes.GetKeyIndividualQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetKeyIndividualQuery | undefined, GraphqlTypes.GetKeyIndividualQueryVariables>;
export function useGetKeyIndividualSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKeyIndividualQuery, GraphqlTypes.GetKeyIndividualQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetKeyIndividualQuery, GraphqlTypes.GetKeyIndividualQueryVariables>(GetKeyIndividualDocument, options);
        }
export type GetKeyIndividualQueryHookResult = ReturnType<typeof useGetKeyIndividualQuery>;
export type GetKeyIndividualLazyQueryHookResult = ReturnType<typeof useGetKeyIndividualLazyQuery>;
export type GetKeyIndividualSuspenseQueryHookResult = ReturnType<typeof useGetKeyIndividualSuspenseQuery>;
export type GetKeyIndividualQueryResult = Apollo.QueryResult<GraphqlTypes.GetKeyIndividualQuery, GraphqlTypes.GetKeyIndividualQueryVariables>;
export const GetKbaQuestionsForInviteDocument = gql`
    query GetKbaQuestionsForInvite($code: String!) {
  kycInviteKbaQuestionSet(code: $code) {
    ...KbaQuestionSetFields
  }
}
    ${KbaQuestionSetFieldsFragmentDoc}`;

/**
 * __useGetKbaQuestionsForInviteQuery__
 *
 * To run a query within a React component, call `useGetKbaQuestionsForInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKbaQuestionsForInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKbaQuestionsForInviteQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetKbaQuestionsForInviteQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetKbaQuestionsForInviteQuery, GraphqlTypes.GetKbaQuestionsForInviteQueryVariables> & ({ variables: GraphqlTypes.GetKbaQuestionsForInviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetKbaQuestionsForInviteQuery, GraphqlTypes.GetKbaQuestionsForInviteQueryVariables>(GetKbaQuestionsForInviteDocument, options);
      }
export function useGetKbaQuestionsForInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetKbaQuestionsForInviteQuery, GraphqlTypes.GetKbaQuestionsForInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetKbaQuestionsForInviteQuery, GraphqlTypes.GetKbaQuestionsForInviteQueryVariables>(GetKbaQuestionsForInviteDocument, options);
        }
// @ts-ignore
export function useGetKbaQuestionsForInviteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKbaQuestionsForInviteQuery, GraphqlTypes.GetKbaQuestionsForInviteQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetKbaQuestionsForInviteQuery, GraphqlTypes.GetKbaQuestionsForInviteQueryVariables>;
export function useGetKbaQuestionsForInviteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKbaQuestionsForInviteQuery, GraphqlTypes.GetKbaQuestionsForInviteQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetKbaQuestionsForInviteQuery | undefined, GraphqlTypes.GetKbaQuestionsForInviteQueryVariables>;
export function useGetKbaQuestionsForInviteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKbaQuestionsForInviteQuery, GraphqlTypes.GetKbaQuestionsForInviteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetKbaQuestionsForInviteQuery, GraphqlTypes.GetKbaQuestionsForInviteQueryVariables>(GetKbaQuestionsForInviteDocument, options);
        }
export type GetKbaQuestionsForInviteQueryHookResult = ReturnType<typeof useGetKbaQuestionsForInviteQuery>;
export type GetKbaQuestionsForInviteLazyQueryHookResult = ReturnType<typeof useGetKbaQuestionsForInviteLazyQuery>;
export type GetKbaQuestionsForInviteSuspenseQueryHookResult = ReturnType<typeof useGetKbaQuestionsForInviteSuspenseQuery>;
export type GetKbaQuestionsForInviteQueryResult = Apollo.QueryResult<GraphqlTypes.GetKbaQuestionsForInviteQuery, GraphqlTypes.GetKbaQuestionsForInviteQueryVariables>;
export const DownloadErrorReportDocument = gql`
    mutation DownloadErrorReport($jobId: ID!) {
  asyncJobOps {
    downloadAsyncJobErrorReport(jobId: $jobId) {
      job {
        id
      }
    }
  }
}
    `;
export type DownloadErrorReportMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadErrorReportMutation, GraphqlTypes.DownloadErrorReportMutationVariables>;

/**
 * __useDownloadErrorReportMutation__
 *
 * To run a mutation, you first call `useDownloadErrorReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadErrorReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadErrorReportMutation, { data, loading, error }] = useDownloadErrorReportMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDownloadErrorReportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadErrorReportMutation, GraphqlTypes.DownloadErrorReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadErrorReportMutation, GraphqlTypes.DownloadErrorReportMutationVariables>(DownloadErrorReportDocument, options);
      }
export type DownloadErrorReportMutationHookResult = ReturnType<typeof useDownloadErrorReportMutation>;
export type DownloadErrorReportMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadErrorReportMutation>;
export type DownloadErrorReportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadErrorReportMutation, GraphqlTypes.DownloadErrorReportMutationVariables>;
export const GetRecentJobsDocument = gql`
    query GetRecentJobs($lookbackSeconds: Int!, $sort: [PortalInvitationJobObjectTypeSortEnum] = []) {
  recentPortalInvitationAsyncJobs(lookbackSeconds: $lookbackSeconds, sort: $sort) {
    edges {
      node {
        id
        endTime
        errorCount
        invitesSent
        jobType
        status
        totalInvites
      }
    }
  }
}
    `;

/**
 * __useGetRecentJobsQuery__
 *
 * To run a query within a React component, call `useGetRecentJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentJobsQuery({
 *   variables: {
 *      lookbackSeconds: // value for 'lookbackSeconds'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetRecentJobsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetRecentJobsQuery, GraphqlTypes.GetRecentJobsQueryVariables> & ({ variables: GraphqlTypes.GetRecentJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRecentJobsQuery, GraphqlTypes.GetRecentJobsQueryVariables>(GetRecentJobsDocument, options);
      }
export function useGetRecentJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRecentJobsQuery, GraphqlTypes.GetRecentJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRecentJobsQuery, GraphqlTypes.GetRecentJobsQueryVariables>(GetRecentJobsDocument, options);
        }
// @ts-ignore
export function useGetRecentJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecentJobsQuery, GraphqlTypes.GetRecentJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRecentJobsQuery, GraphqlTypes.GetRecentJobsQueryVariables>;
export function useGetRecentJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecentJobsQuery, GraphqlTypes.GetRecentJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRecentJobsQuery | undefined, GraphqlTypes.GetRecentJobsQueryVariables>;
export function useGetRecentJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecentJobsQuery, GraphqlTypes.GetRecentJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRecentJobsQuery, GraphqlTypes.GetRecentJobsQueryVariables>(GetRecentJobsDocument, options);
        }
export type GetRecentJobsQueryHookResult = ReturnType<typeof useGetRecentJobsQuery>;
export type GetRecentJobsLazyQueryHookResult = ReturnType<typeof useGetRecentJobsLazyQuery>;
export type GetRecentJobsSuspenseQueryHookResult = ReturnType<typeof useGetRecentJobsSuspenseQuery>;
export type GetRecentJobsQueryResult = Apollo.QueryResult<GraphqlTypes.GetRecentJobsQuery, GraphqlTypes.GetRecentJobsQueryVariables>;
export const GetAllOfferingsDocument = gql`
    query getAllOfferings {
  offerings {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAllOfferingsQuery__
 *
 * To run a query within a React component, call `useGetAllOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOfferingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllOfferingsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAllOfferingsQuery, GraphqlTypes.GetAllOfferingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllOfferingsQuery, GraphqlTypes.GetAllOfferingsQueryVariables>(GetAllOfferingsDocument, options);
      }
export function useGetAllOfferingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllOfferingsQuery, GraphqlTypes.GetAllOfferingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllOfferingsQuery, GraphqlTypes.GetAllOfferingsQueryVariables>(GetAllOfferingsDocument, options);
        }
// @ts-ignore
export function useGetAllOfferingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllOfferingsQuery, GraphqlTypes.GetAllOfferingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllOfferingsQuery, GraphqlTypes.GetAllOfferingsQueryVariables>;
export function useGetAllOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllOfferingsQuery, GraphqlTypes.GetAllOfferingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllOfferingsQuery | undefined, GraphqlTypes.GetAllOfferingsQueryVariables>;
export function useGetAllOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllOfferingsQuery, GraphqlTypes.GetAllOfferingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllOfferingsQuery, GraphqlTypes.GetAllOfferingsQueryVariables>(GetAllOfferingsDocument, options);
        }
export type GetAllOfferingsQueryHookResult = ReturnType<typeof useGetAllOfferingsQuery>;
export type GetAllOfferingsLazyQueryHookResult = ReturnType<typeof useGetAllOfferingsLazyQuery>;
export type GetAllOfferingsSuspenseQueryHookResult = ReturnType<typeof useGetAllOfferingsSuspenseQuery>;
export type GetAllOfferingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllOfferingsQuery, GraphqlTypes.GetAllOfferingsQueryVariables>;
export const GetFundAdminServicesDocument = gql`
    query GetFundAdminServices($serviceIds: [String!], $filters: FundAdminServiceFilters, $sort: [FundAdminServiceObjectTypeSortEnum], $first: Int, $last: Int, $before: String, $after: String) {
  fundAdminServices(
    serviceIds: $serviceIds
    filters: $filters
    sort: $sort
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    count
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        externalTicketIdentifier
        details
        status
        isPublished
        createdAt
        modifiedAt
        requestType
        activities {
          authorName
          id
          createdAt
          message
          isUserComment
        }
        documents {
          id
          documentVersionId
          documentVersion {
            name
            downloadUrl
            id
          }
          documentType
        }
        objects {
          objectValue {
            ... on UserObjectType {
              id
              fullName
              emailAddress
            }
            ... on AccountObjectType {
              id
              name
            }
            ... on EntityCollectionObjectType {
              id
              name
              entities(fundAdministeredOnly: true) {
                count
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
          objectDetails
        }
      }
    }
  }
}
    `;

/**
 * __useGetFundAdminServicesQuery__
 *
 * To run a query within a React component, call `useGetFundAdminServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundAdminServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundAdminServicesQuery({
 *   variables: {
 *      serviceIds: // value for 'serviceIds'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetFundAdminServicesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>(GetFundAdminServicesDocument, options);
      }
export function useGetFundAdminServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>(GetFundAdminServicesDocument, options);
        }
// @ts-ignore
export function useGetFundAdminServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>;
export function useGetFundAdminServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundAdminServicesQuery | undefined, GraphqlTypes.GetFundAdminServicesQueryVariables>;
export function useGetFundAdminServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>(GetFundAdminServicesDocument, options);
        }
export type GetFundAdminServicesQueryHookResult = ReturnType<typeof useGetFundAdminServicesQuery>;
export type GetFundAdminServicesLazyQueryHookResult = ReturnType<typeof useGetFundAdminServicesLazyQuery>;
export type GetFundAdminServicesSuspenseQueryHookResult = ReturnType<typeof useGetFundAdminServicesSuspenseQuery>;
export type GetFundAdminServicesQueryResult = Apollo.QueryResult<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>;
export const UpsertArenaStyleSettingsDocument = gql`
    mutation upsertArenaStyleSettings($arenaStyleSettingsInput: ArenaStyleSettingsMutationInput!) {
  arenaStyleSettings(objectInput: $arenaStyleSettingsInput) {
    __typename
    ... on ArenaStyleSettingsMutationResponse {
      success
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UpsertArenaStyleSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertArenaStyleSettingsMutation, GraphqlTypes.UpsertArenaStyleSettingsMutationVariables>;

/**
 * __useUpsertArenaStyleSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertArenaStyleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertArenaStyleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertArenaStyleSettingsMutation, { data, loading, error }] = useUpsertArenaStyleSettingsMutation({
 *   variables: {
 *      arenaStyleSettingsInput: // value for 'arenaStyleSettingsInput'
 *   },
 * });
 */
export function useUpsertArenaStyleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertArenaStyleSettingsMutation, GraphqlTypes.UpsertArenaStyleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertArenaStyleSettingsMutation, GraphqlTypes.UpsertArenaStyleSettingsMutationVariables>(UpsertArenaStyleSettingsDocument, options);
      }
export type UpsertArenaStyleSettingsMutationHookResult = ReturnType<typeof useUpsertArenaStyleSettingsMutation>;
export type UpsertArenaStyleSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertArenaStyleSettingsMutation>;
export type UpsertArenaStyleSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertArenaStyleSettingsMutation, GraphqlTypes.UpsertArenaStyleSettingsMutationVariables>;
export const DeleteArenaStyleSettingsDocument = gql`
    mutation deleteArenaStyleSettings($arenaStyleSettingsDeleteInput: ArenaStyleSettingsImageDeleteInput!) {
  arenaStyleSettingsImageDelete(objectInput: $arenaStyleSettingsDeleteInput) {
    __typename
    ... on ArenaStyleSettingsMutationResponse {
      success
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type DeleteArenaStyleSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteArenaStyleSettingsMutation, GraphqlTypes.DeleteArenaStyleSettingsMutationVariables>;

/**
 * __useDeleteArenaStyleSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteArenaStyleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArenaStyleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArenaStyleSettingsMutation, { data, loading, error }] = useDeleteArenaStyleSettingsMutation({
 *   variables: {
 *      arenaStyleSettingsDeleteInput: // value for 'arenaStyleSettingsDeleteInput'
 *   },
 * });
 */
export function useDeleteArenaStyleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteArenaStyleSettingsMutation, GraphqlTypes.DeleteArenaStyleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteArenaStyleSettingsMutation, GraphqlTypes.DeleteArenaStyleSettingsMutationVariables>(DeleteArenaStyleSettingsDocument, options);
      }
export type DeleteArenaStyleSettingsMutationHookResult = ReturnType<typeof useDeleteArenaStyleSettingsMutation>;
export type DeleteArenaStyleSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteArenaStyleSettingsMutation>;
export type DeleteArenaStyleSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteArenaStyleSettingsMutation, GraphqlTypes.DeleteArenaStyleSettingsMutationVariables>;
export const PortalStyleSettingsDocument = gql`
    query portalStyleSettings {
  currentArena {
    signInAccessMessage
    headerLogoUrl
    logoWideUrl
    signInButtonTextColor
    signInButtonBackgroundColor
    originalLogoUrl
    signInPhotoUrl
    logoBackgroundColor
    accentBackgroundColor
    useBgColorForPortalIcons
    useBgColorForWebIcons
    useBgColorForIosIcons
    useBgColorForAndroidIcons
    shrinkIosIconCorners
    id
    name
    domain
    secondLevelDomain
    contactEmail
    contactPhone
    websiteUrl
  }
}
    `;

/**
 * __usePortalStyleSettingsQuery__
 *
 * To run a query within a React component, call `usePortalStyleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalStyleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalStyleSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortalStyleSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.PortalStyleSettingsQuery, GraphqlTypes.PortalStyleSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.PortalStyleSettingsQuery, GraphqlTypes.PortalStyleSettingsQueryVariables>(PortalStyleSettingsDocument, options);
      }
export function usePortalStyleSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.PortalStyleSettingsQuery, GraphqlTypes.PortalStyleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.PortalStyleSettingsQuery, GraphqlTypes.PortalStyleSettingsQueryVariables>(PortalStyleSettingsDocument, options);
        }
// @ts-ignore
export function usePortalStyleSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.PortalStyleSettingsQuery, GraphqlTypes.PortalStyleSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PortalStyleSettingsQuery, GraphqlTypes.PortalStyleSettingsQueryVariables>;
export function usePortalStyleSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PortalStyleSettingsQuery, GraphqlTypes.PortalStyleSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PortalStyleSettingsQuery | undefined, GraphqlTypes.PortalStyleSettingsQueryVariables>;
export function usePortalStyleSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PortalStyleSettingsQuery, GraphqlTypes.PortalStyleSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.PortalStyleSettingsQuery, GraphqlTypes.PortalStyleSettingsQueryVariables>(PortalStyleSettingsDocument, options);
        }
export type PortalStyleSettingsQueryHookResult = ReturnType<typeof usePortalStyleSettingsQuery>;
export type PortalStyleSettingsLazyQueryHookResult = ReturnType<typeof usePortalStyleSettingsLazyQuery>;
export type PortalStyleSettingsSuspenseQueryHookResult = ReturnType<typeof usePortalStyleSettingsSuspenseQuery>;
export type PortalStyleSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.PortalStyleSettingsQuery, GraphqlTypes.PortalStyleSettingsQueryVariables>;
export const GetEditMappingPermissionsDocument = gql`
    query getEditMappingPermissions {
  currentUser {
    userPermissions {
      canManageDataMaps
      canAccessAdminConfigurations
    }
  }
}
    `;

/**
 * __useGetEditMappingPermissionsQuery__
 *
 * To run a query within a React component, call `useGetEditMappingPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditMappingPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditMappingPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEditMappingPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEditMappingPermissionsQuery, GraphqlTypes.GetEditMappingPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEditMappingPermissionsQuery, GraphqlTypes.GetEditMappingPermissionsQueryVariables>(GetEditMappingPermissionsDocument, options);
      }
export function useGetEditMappingPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEditMappingPermissionsQuery, GraphqlTypes.GetEditMappingPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEditMappingPermissionsQuery, GraphqlTypes.GetEditMappingPermissionsQueryVariables>(GetEditMappingPermissionsDocument, options);
        }
// @ts-ignore
export function useGetEditMappingPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditMappingPermissionsQuery, GraphqlTypes.GetEditMappingPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEditMappingPermissionsQuery, GraphqlTypes.GetEditMappingPermissionsQueryVariables>;
export function useGetEditMappingPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditMappingPermissionsQuery, GraphqlTypes.GetEditMappingPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEditMappingPermissionsQuery | undefined, GraphqlTypes.GetEditMappingPermissionsQueryVariables>;
export function useGetEditMappingPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditMappingPermissionsQuery, GraphqlTypes.GetEditMappingPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEditMappingPermissionsQuery, GraphqlTypes.GetEditMappingPermissionsQueryVariables>(GetEditMappingPermissionsDocument, options);
        }
export type GetEditMappingPermissionsQueryHookResult = ReturnType<typeof useGetEditMappingPermissionsQuery>;
export type GetEditMappingPermissionsLazyQueryHookResult = ReturnType<typeof useGetEditMappingPermissionsLazyQuery>;
export type GetEditMappingPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetEditMappingPermissionsSuspenseQuery>;
export type GetEditMappingPermissionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEditMappingPermissionsQuery, GraphqlTypes.GetEditMappingPermissionsQueryVariables>;
export const GetHasEntityViewPlusAccessDocument = gql`
    query getHasEntityViewPlusAccess {
  currentUser {
    userPermissions {
      canViewEntity
    }
  }
}
    `;

/**
 * __useGetHasEntityViewPlusAccessQuery__
 *
 * To run a query within a React component, call `useGetHasEntityViewPlusAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHasEntityViewPlusAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHasEntityViewPlusAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHasEntityViewPlusAccessQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetHasEntityViewPlusAccessQuery, GraphqlTypes.GetHasEntityViewPlusAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetHasEntityViewPlusAccessQuery, GraphqlTypes.GetHasEntityViewPlusAccessQueryVariables>(GetHasEntityViewPlusAccessDocument, options);
      }
export function useGetHasEntityViewPlusAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetHasEntityViewPlusAccessQuery, GraphqlTypes.GetHasEntityViewPlusAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetHasEntityViewPlusAccessQuery, GraphqlTypes.GetHasEntityViewPlusAccessQueryVariables>(GetHasEntityViewPlusAccessDocument, options);
        }
// @ts-ignore
export function useGetHasEntityViewPlusAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHasEntityViewPlusAccessQuery, GraphqlTypes.GetHasEntityViewPlusAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetHasEntityViewPlusAccessQuery, GraphqlTypes.GetHasEntityViewPlusAccessQueryVariables>;
export function useGetHasEntityViewPlusAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHasEntityViewPlusAccessQuery, GraphqlTypes.GetHasEntityViewPlusAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetHasEntityViewPlusAccessQuery | undefined, GraphqlTypes.GetHasEntityViewPlusAccessQueryVariables>;
export function useGetHasEntityViewPlusAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHasEntityViewPlusAccessQuery, GraphqlTypes.GetHasEntityViewPlusAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetHasEntityViewPlusAccessQuery, GraphqlTypes.GetHasEntityViewPlusAccessQueryVariables>(GetHasEntityViewPlusAccessDocument, options);
        }
export type GetHasEntityViewPlusAccessQueryHookResult = ReturnType<typeof useGetHasEntityViewPlusAccessQuery>;
export type GetHasEntityViewPlusAccessLazyQueryHookResult = ReturnType<typeof useGetHasEntityViewPlusAccessLazyQuery>;
export type GetHasEntityViewPlusAccessSuspenseQueryHookResult = ReturnType<typeof useGetHasEntityViewPlusAccessSuspenseQuery>;
export type GetHasEntityViewPlusAccessQueryResult = Apollo.QueryResult<GraphqlTypes.GetHasEntityViewPlusAccessQuery, GraphqlTypes.GetHasEntityViewPlusAccessQueryVariables>;
export const GetContactNameDocument = gql`
    query getContactName($subscriptionId: ID!) {
  subscription(id: $subscriptionId) {
    prospect {
      id
      prospectContactMaps {
        contact {
          id
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useGetContactNameQuery__
 *
 * To run a query within a React component, call `useGetContactNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactNameQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useGetContactNameQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactNameQuery, GraphqlTypes.GetContactNameQueryVariables> & ({ variables: GraphqlTypes.GetContactNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactNameQuery, GraphqlTypes.GetContactNameQueryVariables>(GetContactNameDocument, options);
      }
export function useGetContactNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactNameQuery, GraphqlTypes.GetContactNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactNameQuery, GraphqlTypes.GetContactNameQueryVariables>(GetContactNameDocument, options);
        }
// @ts-ignore
export function useGetContactNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactNameQuery, GraphqlTypes.GetContactNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactNameQuery, GraphqlTypes.GetContactNameQueryVariables>;
export function useGetContactNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactNameQuery, GraphqlTypes.GetContactNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactNameQuery | undefined, GraphqlTypes.GetContactNameQueryVariables>;
export function useGetContactNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactNameQuery, GraphqlTypes.GetContactNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactNameQuery, GraphqlTypes.GetContactNameQueryVariables>(GetContactNameDocument, options);
        }
export type GetContactNameQueryHookResult = ReturnType<typeof useGetContactNameQuery>;
export type GetContactNameLazyQueryHookResult = ReturnType<typeof useGetContactNameLazyQuery>;
export type GetContactNameSuspenseQueryHookResult = ReturnType<typeof useGetContactNameSuspenseQuery>;
export type GetContactNameQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactNameQuery, GraphqlTypes.GetContactNameQueryVariables>;
export const DownloadSubscriptionDocumentsDocument = gql`
    mutation DownloadSubscriptionDocuments($objectInput: DownloadSubscriptionDocumentsInput!) {
  subscriptionOps {
    downloadSubscriptionDocuments(objectInput: $objectInput) {
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on DownloadSubscriptionDocumentsObject {
        job {
          id
        }
      }
    }
  }
}
    `;
export type DownloadSubscriptionDocumentsMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadSubscriptionDocumentsMutation, GraphqlTypes.DownloadSubscriptionDocumentsMutationVariables>;

/**
 * __useDownloadSubscriptionDocumentsMutation__
 *
 * To run a mutation, you first call `useDownloadSubscriptionDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadSubscriptionDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadSubscriptionDocumentsMutation, { data, loading, error }] = useDownloadSubscriptionDocumentsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useDownloadSubscriptionDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadSubscriptionDocumentsMutation, GraphqlTypes.DownloadSubscriptionDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadSubscriptionDocumentsMutation, GraphqlTypes.DownloadSubscriptionDocumentsMutationVariables>(DownloadSubscriptionDocumentsDocument, options);
      }
export type DownloadSubscriptionDocumentsMutationHookResult = ReturnType<typeof useDownloadSubscriptionDocumentsMutation>;
export type DownloadSubscriptionDocumentsMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadSubscriptionDocumentsMutation>;
export type DownloadSubscriptionDocumentsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadSubscriptionDocumentsMutation, GraphqlTypes.DownloadSubscriptionDocumentsMutationVariables>;
export const UpdateDesignatedSignerDocument = gql`
    mutation UpdateDesignatedSigner($dataRoomKey: String!, $uuid: String!, $mode: String!) {
  subscriptionDocumentOps {
    updateDesignatedSigner(dataRoomKey: $dataRoomKey, uuid: $uuid) {
      subscription {
        ...SubscriptionObjectFields
        investorSignatureRecipients {
          ...InvestorSignatureRecipientFields
        }
        documents(mode: $mode, dataRoomKey: $dataRoomKey) {
          taxFormOptions {
            ...TaxFormOptionFields
          }
          gpSigned {
            ...GpSignedDocumentFields
          }
          nonSignedLpUploaded {
            ...LpNonSignedDocumentFields
          }
        }
      }
    }
  }
}
    ${SubscriptionObjectFieldsFragmentDoc}
${InvestorSignatureRecipientFieldsFragmentDoc}
${TaxFormOptionFieldsFragmentDoc}
${GpSignedDocumentFieldsFragmentDoc}
${LpNonSignedDocumentFieldsFragmentDoc}`;
export type UpdateDesignatedSignerMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateDesignatedSignerMutation, GraphqlTypes.UpdateDesignatedSignerMutationVariables>;

/**
 * __useUpdateDesignatedSignerMutation__
 *
 * To run a mutation, you first call `useUpdateDesignatedSignerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDesignatedSignerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDesignatedSignerMutation, { data, loading, error }] = useUpdateDesignatedSignerMutation({
 *   variables: {
 *      dataRoomKey: // value for 'dataRoomKey'
 *      uuid: // value for 'uuid'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useUpdateDesignatedSignerMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateDesignatedSignerMutation, GraphqlTypes.UpdateDesignatedSignerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateDesignatedSignerMutation, GraphqlTypes.UpdateDesignatedSignerMutationVariables>(UpdateDesignatedSignerDocument, options);
      }
export type UpdateDesignatedSignerMutationHookResult = ReturnType<typeof useUpdateDesignatedSignerMutation>;
export type UpdateDesignatedSignerMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateDesignatedSignerMutation>;
export type UpdateDesignatedSignerMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateDesignatedSignerMutation, GraphqlTypes.UpdateDesignatedSignerMutationVariables>;
export const UpdateTaxFormTypeDocument = gql`
    mutation UpdateTaxFormType($dataRoomKey: String!, $taxFormType: String!, $mode: String!) {
  subscriptionDocumentOps {
    updateTaxForm(dataRoomKey: $dataRoomKey, taxFormType: $taxFormType) {
      subscription {
        ...SubscriptionObjectFields
        investorSignatureRecipients {
          ...InvestorSignatureRecipientFields
        }
        documents(mode: $mode, dataRoomKey: $dataRoomKey) {
          taxFormOptions {
            ...TaxFormOptionFields
          }
          gpSigned {
            ...GpSignedDocumentFields
          }
          nonSignedLpUploaded {
            ...LpNonSignedDocumentFields
          }
        }
      }
    }
  }
}
    ${SubscriptionObjectFieldsFragmentDoc}
${InvestorSignatureRecipientFieldsFragmentDoc}
${TaxFormOptionFieldsFragmentDoc}
${GpSignedDocumentFieldsFragmentDoc}
${LpNonSignedDocumentFieldsFragmentDoc}`;
export type UpdateTaxFormTypeMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateTaxFormTypeMutation, GraphqlTypes.UpdateTaxFormTypeMutationVariables>;

/**
 * __useUpdateTaxFormTypeMutation__
 *
 * To run a mutation, you first call `useUpdateTaxFormTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxFormTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxFormTypeMutation, { data, loading, error }] = useUpdateTaxFormTypeMutation({
 *   variables: {
 *      dataRoomKey: // value for 'dataRoomKey'
 *      taxFormType: // value for 'taxFormType'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useUpdateTaxFormTypeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateTaxFormTypeMutation, GraphqlTypes.UpdateTaxFormTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateTaxFormTypeMutation, GraphqlTypes.UpdateTaxFormTypeMutationVariables>(UpdateTaxFormTypeDocument, options);
      }
export type UpdateTaxFormTypeMutationHookResult = ReturnType<typeof useUpdateTaxFormTypeMutation>;
export type UpdateTaxFormTypeMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateTaxFormTypeMutation>;
export type UpdateTaxFormTypeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateTaxFormTypeMutation, GraphqlTypes.UpdateTaxFormTypeMutationVariables>;
export const UploadDocumentDocument = gql`
    mutation UploadDocument($documentVersionId: ID!, $fileName: String!, $lpDocumentType: String!, $mode: String!, $dataRoomKey: String!, $requestId: ID) {
  subscriptionDocumentOps {
    uploadDocument(
      documentVersionId: $documentVersionId
      fileName: $fileName
      lpDocumentType: $lpDocumentType
      dataRoomKey: $dataRoomKey
      requestId: $requestId
    ) {
      subscription {
        ...SubscriptionObjectFields
        investorSignatureRecipients {
          ...InvestorSignatureRecipientFields
        }
        documents(mode: $mode, dataRoomKey: $dataRoomKey) {
          taxFormOptions {
            ...TaxFormOptionFields
          }
          gpSigned {
            ...GpSignedDocumentFields
          }
          nonSignedLpUploaded {
            ...LpNonSignedDocumentFields
          }
        }
      }
    }
  }
}
    ${SubscriptionObjectFieldsFragmentDoc}
${InvestorSignatureRecipientFieldsFragmentDoc}
${TaxFormOptionFieldsFragmentDoc}
${GpSignedDocumentFieldsFragmentDoc}
${LpNonSignedDocumentFieldsFragmentDoc}`;
export type UploadDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.UploadDocumentMutation, GraphqlTypes.UploadDocumentMutationVariables>;

/**
 * __useUploadDocumentMutation__
 *
 * To run a mutation, you first call `useUploadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentMutation, { data, loading, error }] = useUploadDocumentMutation({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *      fileName: // value for 'fileName'
 *      lpDocumentType: // value for 'lpDocumentType'
 *      mode: // value for 'mode'
 *      dataRoomKey: // value for 'dataRoomKey'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useUploadDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UploadDocumentMutation, GraphqlTypes.UploadDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UploadDocumentMutation, GraphqlTypes.UploadDocumentMutationVariables>(UploadDocumentDocument, options);
      }
export type UploadDocumentMutationHookResult = ReturnType<typeof useUploadDocumentMutation>;
export type UploadDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.UploadDocumentMutation>;
export type UploadDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UploadDocumentMutation, GraphqlTypes.UploadDocumentMutationVariables>;
export const KycInviteUploadDocument = gql`
    mutation KycInviteUpload($documentVersionId: ID!, $fileName: String!, $contactUuid: String!, $code: String!, $requestId: ID) {
  kycInviteOps {
    uploadDocument(
      documentVersionId: $documentVersionId
      fileName: $fileName
      code: $code
      contactUuid: $contactUuid
      requestId: $requestId
    ) {
      kycInvite(code: $code) {
        ...KycInviteObjectFields
      }
    }
  }
}
    ${KycInviteObjectFieldsFragmentDoc}`;
export type KycInviteUploadMutationFn = Apollo.MutationFunction<GraphqlTypes.KycInviteUploadMutation, GraphqlTypes.KycInviteUploadMutationVariables>;

/**
 * __useKycInviteUploadMutation__
 *
 * To run a mutation, you first call `useKycInviteUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKycInviteUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kycInviteUploadMutation, { data, loading, error }] = useKycInviteUploadMutation({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *      fileName: // value for 'fileName'
 *      contactUuid: // value for 'contactUuid'
 *      code: // value for 'code'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useKycInviteUploadMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.KycInviteUploadMutation, GraphqlTypes.KycInviteUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.KycInviteUploadMutation, GraphqlTypes.KycInviteUploadMutationVariables>(KycInviteUploadDocument, options);
      }
export type KycInviteUploadMutationHookResult = ReturnType<typeof useKycInviteUploadMutation>;
export type KycInviteUploadMutationResult = Apollo.MutationResult<GraphqlTypes.KycInviteUploadMutation>;
export type KycInviteUploadMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.KycInviteUploadMutation, GraphqlTypes.KycInviteUploadMutationVariables>;
export const UploadGpDocumentDocument = gql`
    mutation UploadGpDocument($documentVersionId: ID!, $fileName: String!, $mode: String!, $subscriptionDocumentId: Int!, $dataRoomKey: String!) {
  subscriptionDocumentOps {
    uploadGpDocument(
      documentVersionId: $documentVersionId
      fileName: $fileName
      subscriptionDocumentId: $subscriptionDocumentId
      dataRoomKey: $dataRoomKey
    ) {
      subscription {
        ...SubscriptionObjectFields
        investorSignatureRecipients {
          ...InvestorSignatureRecipientFields
        }
        documents(mode: $mode, dataRoomKey: $dataRoomKey) {
          taxFormOptions {
            ...TaxFormOptionFields
          }
          gpSigned {
            ...GpSignedDocumentFields
          }
          nonSignedLpUploaded {
            ...LpNonSignedDocumentFields
          }
        }
      }
    }
  }
}
    ${SubscriptionObjectFieldsFragmentDoc}
${InvestorSignatureRecipientFieldsFragmentDoc}
${TaxFormOptionFieldsFragmentDoc}
${GpSignedDocumentFieldsFragmentDoc}
${LpNonSignedDocumentFieldsFragmentDoc}`;
export type UploadGpDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.UploadGpDocumentMutation, GraphqlTypes.UploadGpDocumentMutationVariables>;

/**
 * __useUploadGpDocumentMutation__
 *
 * To run a mutation, you first call `useUploadGpDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadGpDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadGpDocumentMutation, { data, loading, error }] = useUploadGpDocumentMutation({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *      fileName: // value for 'fileName'
 *      mode: // value for 'mode'
 *      subscriptionDocumentId: // value for 'subscriptionDocumentId'
 *      dataRoomKey: // value for 'dataRoomKey'
 *   },
 * });
 */
export function useUploadGpDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UploadGpDocumentMutation, GraphqlTypes.UploadGpDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UploadGpDocumentMutation, GraphqlTypes.UploadGpDocumentMutationVariables>(UploadGpDocumentDocument, options);
      }
export type UploadGpDocumentMutationHookResult = ReturnType<typeof useUploadGpDocumentMutation>;
export type UploadGpDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.UploadGpDocumentMutation>;
export type UploadGpDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UploadGpDocumentMutation, GraphqlTypes.UploadGpDocumentMutationVariables>;
export const UploadIdentityDocumentDocument = gql`
    mutation UploadIdentityDocument($documentVersionId: ID!, $fileName: String!, $lpDocumentType: String!, $contactUuid: String, $dataRoomKey: String!, $requestId: ID) {
  subscriptionDocumentOps {
    uploadDocument(
      documentVersionId: $documentVersionId
      fileName: $fileName
      contactUuid: $contactUuid
      lpDocumentType: $lpDocumentType
      dataRoomKey: $dataRoomKey
      requestId: $requestId
    ) {
      subscription {
        id
        status
        investorDiligenceKyc {
          keyIndividuals {
            ...KeyIndividualFields
          }
        }
      }
    }
  }
}
    ${KeyIndividualFieldsFragmentDoc}`;
export type UploadIdentityDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.UploadIdentityDocumentMutation, GraphqlTypes.UploadIdentityDocumentMutationVariables>;

/**
 * __useUploadIdentityDocumentMutation__
 *
 * To run a mutation, you first call `useUploadIdentityDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadIdentityDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadIdentityDocumentMutation, { data, loading, error }] = useUploadIdentityDocumentMutation({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *      fileName: // value for 'fileName'
 *      lpDocumentType: // value for 'lpDocumentType'
 *      contactUuid: // value for 'contactUuid'
 *      dataRoomKey: // value for 'dataRoomKey'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useUploadIdentityDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UploadIdentityDocumentMutation, GraphqlTypes.UploadIdentityDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UploadIdentityDocumentMutation, GraphqlTypes.UploadIdentityDocumentMutationVariables>(UploadIdentityDocumentDocument, options);
      }
export type UploadIdentityDocumentMutationHookResult = ReturnType<typeof useUploadIdentityDocumentMutation>;
export type UploadIdentityDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.UploadIdentityDocumentMutation>;
export type UploadIdentityDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UploadIdentityDocumentMutation, GraphqlTypes.UploadIdentityDocumentMutationVariables>;
export const RemoveDocumentDocument = gql`
    mutation RemoveDocument($lpDocumentVersionId: Int!, $mode: String!, $lpDocumentType: String!, $dataRoomKey: String!) {
  subscriptionDocumentOps {
    removeDocument(
      lpDocumentVersionId: $lpDocumentVersionId
      lpDocumentType: $lpDocumentType
      dataRoomKey: $dataRoomKey
    ) {
      subscription {
        ...SubscriptionObjectFields
        investorSignatureRecipients {
          ...InvestorSignatureRecipientFields
        }
        documents(mode: $mode, dataRoomKey: $dataRoomKey) {
          taxFormOptions {
            ...TaxFormOptionFields
          }
          gpSigned {
            ...GpSignedDocumentFields
          }
          nonSignedLpUploaded {
            ...LpNonSignedDocumentFields
          }
        }
      }
    }
  }
}
    ${SubscriptionObjectFieldsFragmentDoc}
${InvestorSignatureRecipientFieldsFragmentDoc}
${TaxFormOptionFieldsFragmentDoc}
${GpSignedDocumentFieldsFragmentDoc}
${LpNonSignedDocumentFieldsFragmentDoc}`;
export type RemoveDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.RemoveDocumentMutation, GraphqlTypes.RemoveDocumentMutationVariables>;

/**
 * __useRemoveDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDocumentMutation, { data, loading, error }] = useRemoveDocumentMutation({
 *   variables: {
 *      lpDocumentVersionId: // value for 'lpDocumentVersionId'
 *      mode: // value for 'mode'
 *      lpDocumentType: // value for 'lpDocumentType'
 *      dataRoomKey: // value for 'dataRoomKey'
 *   },
 * });
 */
export function useRemoveDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RemoveDocumentMutation, GraphqlTypes.RemoveDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RemoveDocumentMutation, GraphqlTypes.RemoveDocumentMutationVariables>(RemoveDocumentDocument, options);
      }
export type RemoveDocumentMutationHookResult = ReturnType<typeof useRemoveDocumentMutation>;
export type RemoveDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.RemoveDocumentMutation>;
export type RemoveDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RemoveDocumentMutation, GraphqlTypes.RemoveDocumentMutationVariables>;
export const ConfigureDocusignDocument = gql`
    mutation ConfigureDocusign($mode: String!, $dataRoomKey: String!) {
  subscriptionDocumentOps {
    configureDocusign(dataRoomKey: $dataRoomKey) {
      title
      subscription {
        ...SubscriptionObjectFields
        investorSignatureRecipients {
          ...InvestorSignatureRecipientFields
        }
        documents(mode: $mode, dataRoomKey: $dataRoomKey) {
          taxFormOptions {
            ...TaxFormOptionFields
          }
          gpSigned {
            ...GpSignedDocumentFields
          }
          nonSignedLpUploaded {
            ...LpNonSignedDocumentFields
          }
        }
      }
    }
  }
}
    ${SubscriptionObjectFieldsFragmentDoc}
${InvestorSignatureRecipientFieldsFragmentDoc}
${TaxFormOptionFieldsFragmentDoc}
${GpSignedDocumentFieldsFragmentDoc}
${LpNonSignedDocumentFieldsFragmentDoc}`;
export type ConfigureDocusignMutationFn = Apollo.MutationFunction<GraphqlTypes.ConfigureDocusignMutation, GraphqlTypes.ConfigureDocusignMutationVariables>;

/**
 * __useConfigureDocusignMutation__
 *
 * To run a mutation, you first call `useConfigureDocusignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureDocusignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureDocusignMutation, { data, loading, error }] = useConfigureDocusignMutation({
 *   variables: {
 *      mode: // value for 'mode'
 *      dataRoomKey: // value for 'dataRoomKey'
 *   },
 * });
 */
export function useConfigureDocusignMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ConfigureDocusignMutation, GraphqlTypes.ConfigureDocusignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ConfigureDocusignMutation, GraphqlTypes.ConfigureDocusignMutationVariables>(ConfigureDocusignDocument, options);
      }
export type ConfigureDocusignMutationHookResult = ReturnType<typeof useConfigureDocusignMutation>;
export type ConfigureDocusignMutationResult = Apollo.MutationResult<GraphqlTypes.ConfigureDocusignMutation>;
export type ConfigureDocusignMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ConfigureDocusignMutation, GraphqlTypes.ConfigureDocusignMutationVariables>;
export const RemoveElectronicSignaturesDocument = gql`
    mutation RemoveElectronicSignatures($mode: String!, $dataRoomKey: String!) {
  subscriptionDocumentOps {
    removeElectronicSignatures(dataRoomKey: $dataRoomKey) {
      subscription {
        ...SubscriptionObjectFields
        investorSignatureRecipients {
          ...InvestorSignatureRecipientFields
        }
        documents(mode: $mode, dataRoomKey: $dataRoomKey) {
          taxFormOptions {
            ...TaxFormOptionFields
          }
          gpSigned {
            ...GpSignedDocumentFields
          }
          nonSignedLpUploaded {
            ...LpNonSignedDocumentFields
          }
        }
      }
    }
  }
}
    ${SubscriptionObjectFieldsFragmentDoc}
${InvestorSignatureRecipientFieldsFragmentDoc}
${TaxFormOptionFieldsFragmentDoc}
${GpSignedDocumentFieldsFragmentDoc}
${LpNonSignedDocumentFieldsFragmentDoc}`;
export type RemoveElectronicSignaturesMutationFn = Apollo.MutationFunction<GraphqlTypes.RemoveElectronicSignaturesMutation, GraphqlTypes.RemoveElectronicSignaturesMutationVariables>;

/**
 * __useRemoveElectronicSignaturesMutation__
 *
 * To run a mutation, you first call `useRemoveElectronicSignaturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveElectronicSignaturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeElectronicSignaturesMutation, { data, loading, error }] = useRemoveElectronicSignaturesMutation({
 *   variables: {
 *      mode: // value for 'mode'
 *      dataRoomKey: // value for 'dataRoomKey'
 *   },
 * });
 */
export function useRemoveElectronicSignaturesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RemoveElectronicSignaturesMutation, GraphqlTypes.RemoveElectronicSignaturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RemoveElectronicSignaturesMutation, GraphqlTypes.RemoveElectronicSignaturesMutationVariables>(RemoveElectronicSignaturesDocument, options);
      }
export type RemoveElectronicSignaturesMutationHookResult = ReturnType<typeof useRemoveElectronicSignaturesMutation>;
export type RemoveElectronicSignaturesMutationResult = Apollo.MutationResult<GraphqlTypes.RemoveElectronicSignaturesMutation>;
export type RemoveElectronicSignaturesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RemoveElectronicSignaturesMutation, GraphqlTypes.RemoveElectronicSignaturesMutationVariables>;
export const SubmitSubscriptionDocument = gql`
    mutation SubmitSubscription($mode: String!, $dataRoomKey: String!) {
  subscriptionDocumentOps {
    submitSubscription(dataRoomKey: $dataRoomKey) {
      subscription {
        ...SubscriptionObjectFields
        investorSignatureRecipients {
          ...InvestorSignatureRecipientFields
        }
        documents(mode: $mode, dataRoomKey: $dataRoomKey) {
          taxFormOptions {
            ...TaxFormOptionFields
          }
          gpSigned {
            ...GpSignedDocumentFields
          }
          nonSignedLpUploaded {
            ...LpNonSignedDocumentFields
          }
        }
      }
    }
  }
}
    ${SubscriptionObjectFieldsFragmentDoc}
${InvestorSignatureRecipientFieldsFragmentDoc}
${TaxFormOptionFieldsFragmentDoc}
${GpSignedDocumentFieldsFragmentDoc}
${LpNonSignedDocumentFieldsFragmentDoc}`;
export type SubmitSubscriptionMutationFn = Apollo.MutationFunction<GraphqlTypes.SubmitSubscriptionMutation, GraphqlTypes.SubmitSubscriptionMutationVariables>;

/**
 * __useSubmitSubscriptionMutation__
 *
 * To run a mutation, you first call `useSubmitSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSubscriptionMutation, { data, loading, error }] = useSubmitSubscriptionMutation({
 *   variables: {
 *      mode: // value for 'mode'
 *      dataRoomKey: // value for 'dataRoomKey'
 *   },
 * });
 */
export function useSubmitSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubmitSubscriptionMutation, GraphqlTypes.SubmitSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubmitSubscriptionMutation, GraphqlTypes.SubmitSubscriptionMutationVariables>(SubmitSubscriptionDocument, options);
      }
export type SubmitSubscriptionMutationHookResult = ReturnType<typeof useSubmitSubscriptionMutation>;
export type SubmitSubscriptionMutationResult = Apollo.MutationResult<GraphqlTypes.SubmitSubscriptionMutation>;
export type SubmitSubscriptionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubmitSubscriptionMutation, GraphqlTypes.SubmitSubscriptionMutationVariables>;
export const EnvelopePollDocument = gql`
    query EnvelopePoll($dataRoomKey: String!) {
  subscriptionByDataRoomKey(dataRoomKey: $dataRoomKey) {
    ...SubscriptionObjectFields
    envelopePoll {
      ...EnvelopePollFields
    }
  }
}
    ${SubscriptionObjectFieldsFragmentDoc}
${EnvelopePollFieldsFragmentDoc}`;

/**
 * __useEnvelopePollQuery__
 *
 * To run a query within a React component, call `useEnvelopePollQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvelopePollQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvelopePollQuery({
 *   variables: {
 *      dataRoomKey: // value for 'dataRoomKey'
 *   },
 * });
 */
export function useEnvelopePollQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.EnvelopePollQuery, GraphqlTypes.EnvelopePollQueryVariables> & ({ variables: GraphqlTypes.EnvelopePollQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.EnvelopePollQuery, GraphqlTypes.EnvelopePollQueryVariables>(EnvelopePollDocument, options);
      }
export function useEnvelopePollLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.EnvelopePollQuery, GraphqlTypes.EnvelopePollQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.EnvelopePollQuery, GraphqlTypes.EnvelopePollQueryVariables>(EnvelopePollDocument, options);
        }
// @ts-ignore
export function useEnvelopePollSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.EnvelopePollQuery, GraphqlTypes.EnvelopePollQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.EnvelopePollQuery, GraphqlTypes.EnvelopePollQueryVariables>;
export function useEnvelopePollSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.EnvelopePollQuery, GraphqlTypes.EnvelopePollQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.EnvelopePollQuery | undefined, GraphqlTypes.EnvelopePollQueryVariables>;
export function useEnvelopePollSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.EnvelopePollQuery, GraphqlTypes.EnvelopePollQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.EnvelopePollQuery, GraphqlTypes.EnvelopePollQueryVariables>(EnvelopePollDocument, options);
        }
export type EnvelopePollQueryHookResult = ReturnType<typeof useEnvelopePollQuery>;
export type EnvelopePollLazyQueryHookResult = ReturnType<typeof useEnvelopePollLazyQuery>;
export type EnvelopePollSuspenseQueryHookResult = ReturnType<typeof useEnvelopePollSuspenseQuery>;
export type EnvelopePollQueryResult = Apollo.QueryResult<GraphqlTypes.EnvelopePollQuery, GraphqlTypes.EnvelopePollQueryVariables>;
export const UpdateElectronicSignaturesInfoDocument = gql`
    mutation UpdateElectronicSignaturesInfo($dataRoomKey: String!) {
  subscriptionDocumentOps {
    updateElectronicSignaturesInfo(dataRoomKey: $dataRoomKey) {
      subscription {
        id
      }
    }
  }
}
    `;
export type UpdateElectronicSignaturesInfoMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateElectronicSignaturesInfoMutation, GraphqlTypes.UpdateElectronicSignaturesInfoMutationVariables>;

/**
 * __useUpdateElectronicSignaturesInfoMutation__
 *
 * To run a mutation, you first call `useUpdateElectronicSignaturesInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateElectronicSignaturesInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateElectronicSignaturesInfoMutation, { data, loading, error }] = useUpdateElectronicSignaturesInfoMutation({
 *   variables: {
 *      dataRoomKey: // value for 'dataRoomKey'
 *   },
 * });
 */
export function useUpdateElectronicSignaturesInfoMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateElectronicSignaturesInfoMutation, GraphqlTypes.UpdateElectronicSignaturesInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateElectronicSignaturesInfoMutation, GraphqlTypes.UpdateElectronicSignaturesInfoMutationVariables>(UpdateElectronicSignaturesInfoDocument, options);
      }
export type UpdateElectronicSignaturesInfoMutationHookResult = ReturnType<typeof useUpdateElectronicSignaturesInfoMutation>;
export type UpdateElectronicSignaturesInfoMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateElectronicSignaturesInfoMutation>;
export type UpdateElectronicSignaturesInfoMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateElectronicSignaturesInfoMutation, GraphqlTypes.UpdateElectronicSignaturesInfoMutationVariables>;
export const GetSubscriptionDocumentsDocument = gql`
    query GetSubscriptionDocuments($dataRoomKey: String!, $mode: String!) {
  subscriptionByDataRoomKey(dataRoomKey: $dataRoomKey) {
    arenaName
    ...SubscriptionObjectFields
    investorSignatureRecipients {
      ...InvestorSignatureRecipientFields
    }
    documents(mode: $mode, dataRoomKey: $dataRoomKey) {
      taxFormOptions {
        ...TaxFormOptionFields
      }
      gpSigned {
        ...GpSignedDocumentFields
      }
      nonSignedLpUploaded {
        ...LpNonSignedDocumentFields
      }
    }
  }
}
    ${SubscriptionObjectFieldsFragmentDoc}
${InvestorSignatureRecipientFieldsFragmentDoc}
${TaxFormOptionFieldsFragmentDoc}
${GpSignedDocumentFieldsFragmentDoc}
${LpNonSignedDocumentFieldsFragmentDoc}`;

/**
 * __useGetSubscriptionDocumentsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionDocumentsQuery({
 *   variables: {
 *      dataRoomKey: // value for 'dataRoomKey'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useGetSubscriptionDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSubscriptionDocumentsQuery, GraphqlTypes.GetSubscriptionDocumentsQueryVariables> & ({ variables: GraphqlTypes.GetSubscriptionDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSubscriptionDocumentsQuery, GraphqlTypes.GetSubscriptionDocumentsQueryVariables>(GetSubscriptionDocumentsDocument, options);
      }
export function useGetSubscriptionDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSubscriptionDocumentsQuery, GraphqlTypes.GetSubscriptionDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSubscriptionDocumentsQuery, GraphqlTypes.GetSubscriptionDocumentsQueryVariables>(GetSubscriptionDocumentsDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionDocumentsQuery, GraphqlTypes.GetSubscriptionDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionDocumentsQuery, GraphqlTypes.GetSubscriptionDocumentsQueryVariables>;
export function useGetSubscriptionDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionDocumentsQuery, GraphqlTypes.GetSubscriptionDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionDocumentsQuery | undefined, GraphqlTypes.GetSubscriptionDocumentsQueryVariables>;
export function useGetSubscriptionDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionDocumentsQuery, GraphqlTypes.GetSubscriptionDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSubscriptionDocumentsQuery, GraphqlTypes.GetSubscriptionDocumentsQueryVariables>(GetSubscriptionDocumentsDocument, options);
        }
export type GetSubscriptionDocumentsQueryHookResult = ReturnType<typeof useGetSubscriptionDocumentsQuery>;
export type GetSubscriptionDocumentsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionDocumentsLazyQuery>;
export type GetSubscriptionDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionDocumentsSuspenseQuery>;
export type GetSubscriptionDocumentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetSubscriptionDocumentsQuery, GraphqlTypes.GetSubscriptionDocumentsQueryVariables>;
export const UpdateSubscriptionReviewDecisionDocument = gql`
    mutation UpdateSubscriptionReviewDecision($objectInput: UpdateSubscriptionReviewDecisionInput!) {
  updateSubscriptionReviewDecision(objectInput: $objectInput) {
    ... on MutationErrorResponse {
      message
    }
    ... on UpdateSubscriptionReviewDecisionObject {
      reviewer {
        id
        decision
        modifiedAt
      }
      isSubscriptionApproved
      newSubscriptionId
    }
  }
}
    `;
export type UpdateSubscriptionReviewDecisionMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateSubscriptionReviewDecisionMutation, GraphqlTypes.UpdateSubscriptionReviewDecisionMutationVariables>;

/**
 * __useUpdateSubscriptionReviewDecisionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionReviewDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionReviewDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionReviewDecisionMutation, { data, loading, error }] = useUpdateSubscriptionReviewDecisionMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateSubscriptionReviewDecisionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateSubscriptionReviewDecisionMutation, GraphqlTypes.UpdateSubscriptionReviewDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateSubscriptionReviewDecisionMutation, GraphqlTypes.UpdateSubscriptionReviewDecisionMutationVariables>(UpdateSubscriptionReviewDecisionDocument, options);
      }
export type UpdateSubscriptionReviewDecisionMutationHookResult = ReturnType<typeof useUpdateSubscriptionReviewDecisionMutation>;
export type UpdateSubscriptionReviewDecisionMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateSubscriptionReviewDecisionMutation>;
export type UpdateSubscriptionReviewDecisionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateSubscriptionReviewDecisionMutation, GraphqlTypes.UpdateSubscriptionReviewDecisionMutationVariables>;
export const ManuallyCompleteSubscriptionStaffReviewDocument = gql`
    mutation ManuallyCompleteSubscriptionStaffReview($subscriptionId: ID!) {
  manuallyCompleteSubscriptionStaffReview(subscriptionId: $subscriptionId) {
    ... on MutationErrorResponse {
      message
    }
    ... on MutationSuccessResponse {
      didSucceed
    }
  }
}
    `;
export type ManuallyCompleteSubscriptionStaffReviewMutationFn = Apollo.MutationFunction<GraphqlTypes.ManuallyCompleteSubscriptionStaffReviewMutation, GraphqlTypes.ManuallyCompleteSubscriptionStaffReviewMutationVariables>;

/**
 * __useManuallyCompleteSubscriptionStaffReviewMutation__
 *
 * To run a mutation, you first call `useManuallyCompleteSubscriptionStaffReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManuallyCompleteSubscriptionStaffReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manuallyCompleteSubscriptionStaffReviewMutation, { data, loading, error }] = useManuallyCompleteSubscriptionStaffReviewMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useManuallyCompleteSubscriptionStaffReviewMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ManuallyCompleteSubscriptionStaffReviewMutation, GraphqlTypes.ManuallyCompleteSubscriptionStaffReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ManuallyCompleteSubscriptionStaffReviewMutation, GraphqlTypes.ManuallyCompleteSubscriptionStaffReviewMutationVariables>(ManuallyCompleteSubscriptionStaffReviewDocument, options);
      }
export type ManuallyCompleteSubscriptionStaffReviewMutationHookResult = ReturnType<typeof useManuallyCompleteSubscriptionStaffReviewMutation>;
export type ManuallyCompleteSubscriptionStaffReviewMutationResult = Apollo.MutationResult<GraphqlTypes.ManuallyCompleteSubscriptionStaffReviewMutation>;
export type ManuallyCompleteSubscriptionStaffReviewMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ManuallyCompleteSubscriptionStaffReviewMutation, GraphqlTypes.ManuallyCompleteSubscriptionStaffReviewMutationVariables>;
export const GetStaffReviewersDocument = gql`
    query GetStaffReviewers($subscriptionId: ID!) {
  subscription(id: $subscriptionId) {
    id
    status
    reviewers {
      id
      staffUser {
        id
        firstName
        lastName
      }
      decision
      modifiedAt
    }
    reviewerSettings {
      id
      staffUser {
        id
        firstName
        lastName
      }
    }
  }
  currentUser {
    id
  }
}
    `;

/**
 * __useGetStaffReviewersQuery__
 *
 * To run a query within a React component, call `useGetStaffReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffReviewersQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useGetStaffReviewersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetStaffReviewersQuery, GraphqlTypes.GetStaffReviewersQueryVariables> & ({ variables: GraphqlTypes.GetStaffReviewersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetStaffReviewersQuery, GraphqlTypes.GetStaffReviewersQueryVariables>(GetStaffReviewersDocument, options);
      }
export function useGetStaffReviewersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetStaffReviewersQuery, GraphqlTypes.GetStaffReviewersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetStaffReviewersQuery, GraphqlTypes.GetStaffReviewersQueryVariables>(GetStaffReviewersDocument, options);
        }
// @ts-ignore
export function useGetStaffReviewersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffReviewersQuery, GraphqlTypes.GetStaffReviewersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStaffReviewersQuery, GraphqlTypes.GetStaffReviewersQueryVariables>;
export function useGetStaffReviewersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffReviewersQuery, GraphqlTypes.GetStaffReviewersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStaffReviewersQuery | undefined, GraphqlTypes.GetStaffReviewersQueryVariables>;
export function useGetStaffReviewersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffReviewersQuery, GraphqlTypes.GetStaffReviewersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetStaffReviewersQuery, GraphqlTypes.GetStaffReviewersQueryVariables>(GetStaffReviewersDocument, options);
        }
export type GetStaffReviewersQueryHookResult = ReturnType<typeof useGetStaffReviewersQuery>;
export type GetStaffReviewersLazyQueryHookResult = ReturnType<typeof useGetStaffReviewersLazyQuery>;
export type GetStaffReviewersSuspenseQueryHookResult = ReturnType<typeof useGetStaffReviewersSuspenseQuery>;
export type GetStaffReviewersQueryResult = Apollo.QueryResult<GraphqlTypes.GetStaffReviewersQuery, GraphqlTypes.GetStaffReviewersQueryVariables>;
export const GetProspectForStaffReviewDocument = gql`
    query GetProspectForStaffReview($subscriptionId: ID!) {
  subscription(id: $subscriptionId) {
    id
    requestedElectronicSignatures
    prospect {
      id
      prospectContactMaps {
        id
        isMainContact
        dataRoomKey
        contact {
          id
          fullName
          primaryEmail {
            id
            emailAddress
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProspectForStaffReviewQuery__
 *
 * To run a query within a React component, call `useGetProspectForStaffReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProspectForStaffReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProspectForStaffReviewQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useGetProspectForStaffReviewQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProspectForStaffReviewQuery, GraphqlTypes.GetProspectForStaffReviewQueryVariables> & ({ variables: GraphqlTypes.GetProspectForStaffReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProspectForStaffReviewQuery, GraphqlTypes.GetProspectForStaffReviewQueryVariables>(GetProspectForStaffReviewDocument, options);
      }
export function useGetProspectForStaffReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProspectForStaffReviewQuery, GraphqlTypes.GetProspectForStaffReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProspectForStaffReviewQuery, GraphqlTypes.GetProspectForStaffReviewQueryVariables>(GetProspectForStaffReviewDocument, options);
        }
// @ts-ignore
export function useGetProspectForStaffReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectForStaffReviewQuery, GraphqlTypes.GetProspectForStaffReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProspectForStaffReviewQuery, GraphqlTypes.GetProspectForStaffReviewQueryVariables>;
export function useGetProspectForStaffReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectForStaffReviewQuery, GraphqlTypes.GetProspectForStaffReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProspectForStaffReviewQuery | undefined, GraphqlTypes.GetProspectForStaffReviewQueryVariables>;
export function useGetProspectForStaffReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectForStaffReviewQuery, GraphqlTypes.GetProspectForStaffReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProspectForStaffReviewQuery, GraphqlTypes.GetProspectForStaffReviewQueryVariables>(GetProspectForStaffReviewDocument, options);
        }
export type GetProspectForStaffReviewQueryHookResult = ReturnType<typeof useGetProspectForStaffReviewQuery>;
export type GetProspectForStaffReviewLazyQueryHookResult = ReturnType<typeof useGetProspectForStaffReviewLazyQuery>;
export type GetProspectForStaffReviewSuspenseQueryHookResult = ReturnType<typeof useGetProspectForStaffReviewSuspenseQuery>;
export type GetProspectForStaffReviewQueryResult = Apollo.QueryResult<GraphqlTypes.GetProspectForStaffReviewQuery, GraphqlTypes.GetProspectForStaffReviewQueryVariables>;
export const GetKeyIndividualsDocument = gql`
    query GetKeyIndividuals($dataRoomKey: String!) {
  subscriptionByDataRoomKey(dataRoomKey: $dataRoomKey) {
    id
    status
    investorDiligenceKyc {
      id
      keyIndividuals {
        ...KeyIndividualFields
      }
      kycDetails {
        edges {
          node {
            id
            kbaStatus
            externalReferenceKey
          }
        }
      }
    }
  }
}
    ${KeyIndividualFieldsFragmentDoc}`;

/**
 * __useGetKeyIndividualsQuery__
 *
 * To run a query within a React component, call `useGetKeyIndividualsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeyIndividualsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeyIndividualsQuery({
 *   variables: {
 *      dataRoomKey: // value for 'dataRoomKey'
 *   },
 * });
 */
export function useGetKeyIndividualsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetKeyIndividualsQuery, GraphqlTypes.GetKeyIndividualsQueryVariables> & ({ variables: GraphqlTypes.GetKeyIndividualsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetKeyIndividualsQuery, GraphqlTypes.GetKeyIndividualsQueryVariables>(GetKeyIndividualsDocument, options);
      }
export function useGetKeyIndividualsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetKeyIndividualsQuery, GraphqlTypes.GetKeyIndividualsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetKeyIndividualsQuery, GraphqlTypes.GetKeyIndividualsQueryVariables>(GetKeyIndividualsDocument, options);
        }
// @ts-ignore
export function useGetKeyIndividualsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKeyIndividualsQuery, GraphqlTypes.GetKeyIndividualsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetKeyIndividualsQuery, GraphqlTypes.GetKeyIndividualsQueryVariables>;
export function useGetKeyIndividualsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKeyIndividualsQuery, GraphqlTypes.GetKeyIndividualsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetKeyIndividualsQuery | undefined, GraphqlTypes.GetKeyIndividualsQueryVariables>;
export function useGetKeyIndividualsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKeyIndividualsQuery, GraphqlTypes.GetKeyIndividualsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetKeyIndividualsQuery, GraphqlTypes.GetKeyIndividualsQueryVariables>(GetKeyIndividualsDocument, options);
        }
export type GetKeyIndividualsQueryHookResult = ReturnType<typeof useGetKeyIndividualsQuery>;
export type GetKeyIndividualsLazyQueryHookResult = ReturnType<typeof useGetKeyIndividualsLazyQuery>;
export type GetKeyIndividualsSuspenseQueryHookResult = ReturnType<typeof useGetKeyIndividualsSuspenseQuery>;
export type GetKeyIndividualsQueryResult = Apollo.QueryResult<GraphqlTypes.GetKeyIndividualsQuery, GraphqlTypes.GetKeyIndividualsQueryVariables>;
export const SendInvestorDiligenceEmailDocument = gql`
    mutation SendInvestorDiligenceEmail($contactUuid: String!, $dataRoomKey: String!) {
  investorDiligenceOps {
    sendKycInviteEmail(contactUuid: $contactUuid, dataRoomKey: $dataRoomKey) {
      investorDiligenceEmail {
        id
      }
    }
  }
}
    `;
export type SendInvestorDiligenceEmailMutationFn = Apollo.MutationFunction<GraphqlTypes.SendInvestorDiligenceEmailMutation, GraphqlTypes.SendInvestorDiligenceEmailMutationVariables>;

/**
 * __useSendInvestorDiligenceEmailMutation__
 *
 * To run a mutation, you first call `useSendInvestorDiligenceEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvestorDiligenceEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvestorDiligenceEmailMutation, { data, loading, error }] = useSendInvestorDiligenceEmailMutation({
 *   variables: {
 *      contactUuid: // value for 'contactUuid'
 *      dataRoomKey: // value for 'dataRoomKey'
 *   },
 * });
 */
export function useSendInvestorDiligenceEmailMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SendInvestorDiligenceEmailMutation, GraphqlTypes.SendInvestorDiligenceEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SendInvestorDiligenceEmailMutation, GraphqlTypes.SendInvestorDiligenceEmailMutationVariables>(SendInvestorDiligenceEmailDocument, options);
      }
export type SendInvestorDiligenceEmailMutationHookResult = ReturnType<typeof useSendInvestorDiligenceEmailMutation>;
export type SendInvestorDiligenceEmailMutationResult = Apollo.MutationResult<GraphqlTypes.SendInvestorDiligenceEmailMutation>;
export type SendInvestorDiligenceEmailMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SendInvestorDiligenceEmailMutation, GraphqlTypes.SendInvestorDiligenceEmailMutationVariables>;
export const SubmitKbaChoicesDocument = gql`
    mutation SubmitKBAChoices($dataRoomKey: String!, $contactUuid: String!, $investorDiligenceId: ID!, $kbaAnswerSet: KbaAnswerSetInput!) {
  kbaQuestionsOps {
    acceptOrRejectKbaChoices(
      dataRoomKey: $dataRoomKey
      contactUuid: $contactUuid
      investorDiligenceId: $investorDiligenceId
      kbaAnswerSet: $kbaAnswerSet
    ) {
      ...SubmitKBAResponse
    }
  }
}
    ${SubmitKbaResponseFragmentDoc}`;
export type SubmitKbaChoicesMutationFn = Apollo.MutationFunction<GraphqlTypes.SubmitKbaChoicesMutation, GraphqlTypes.SubmitKbaChoicesMutationVariables>;

/**
 * __useSubmitKbaChoicesMutation__
 *
 * To run a mutation, you first call `useSubmitKbaChoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitKbaChoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitKbaChoicesMutation, { data, loading, error }] = useSubmitKbaChoicesMutation({
 *   variables: {
 *      dataRoomKey: // value for 'dataRoomKey'
 *      contactUuid: // value for 'contactUuid'
 *      investorDiligenceId: // value for 'investorDiligenceId'
 *      kbaAnswerSet: // value for 'kbaAnswerSet'
 *   },
 * });
 */
export function useSubmitKbaChoicesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubmitKbaChoicesMutation, GraphqlTypes.SubmitKbaChoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubmitKbaChoicesMutation, GraphqlTypes.SubmitKbaChoicesMutationVariables>(SubmitKbaChoicesDocument, options);
      }
export type SubmitKbaChoicesMutationHookResult = ReturnType<typeof useSubmitKbaChoicesMutation>;
export type SubmitKbaChoicesMutationResult = Apollo.MutationResult<GraphqlTypes.SubmitKbaChoicesMutation>;
export type SubmitKbaChoicesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubmitKbaChoicesMutation, GraphqlTypes.SubmitKbaChoicesMutationVariables>;
export const GetKbaQuestionsDocument = gql`
    query GetKBAQuestions($dataRoomKey: String!, $contactUuid: String!) {
  kbaQuestionSet(dataRoomKey: $dataRoomKey, contactUuid: $contactUuid) {
    ...KbaQuestionSetFields
  }
}
    ${KbaQuestionSetFieldsFragmentDoc}`;

/**
 * __useGetKbaQuestionsQuery__
 *
 * To run a query within a React component, call `useGetKbaQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKbaQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKbaQuestionsQuery({
 *   variables: {
 *      dataRoomKey: // value for 'dataRoomKey'
 *      contactUuid: // value for 'contactUuid'
 *   },
 * });
 */
export function useGetKbaQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetKbaQuestionsQuery, GraphqlTypes.GetKbaQuestionsQueryVariables> & ({ variables: GraphqlTypes.GetKbaQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetKbaQuestionsQuery, GraphqlTypes.GetKbaQuestionsQueryVariables>(GetKbaQuestionsDocument, options);
      }
export function useGetKbaQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetKbaQuestionsQuery, GraphqlTypes.GetKbaQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetKbaQuestionsQuery, GraphqlTypes.GetKbaQuestionsQueryVariables>(GetKbaQuestionsDocument, options);
        }
// @ts-ignore
export function useGetKbaQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKbaQuestionsQuery, GraphqlTypes.GetKbaQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetKbaQuestionsQuery, GraphqlTypes.GetKbaQuestionsQueryVariables>;
export function useGetKbaQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKbaQuestionsQuery, GraphqlTypes.GetKbaQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetKbaQuestionsQuery | undefined, GraphqlTypes.GetKbaQuestionsQueryVariables>;
export function useGetKbaQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKbaQuestionsQuery, GraphqlTypes.GetKbaQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetKbaQuestionsQuery, GraphqlTypes.GetKbaQuestionsQueryVariables>(GetKbaQuestionsDocument, options);
        }
export type GetKbaQuestionsQueryHookResult = ReturnType<typeof useGetKbaQuestionsQuery>;
export type GetKbaQuestionsLazyQueryHookResult = ReturnType<typeof useGetKbaQuestionsLazyQuery>;
export type GetKbaQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetKbaQuestionsSuspenseQuery>;
export type GetKbaQuestionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetKbaQuestionsQuery, GraphqlTypes.GetKbaQuestionsQueryVariables>;
export const GetViewAndEditTicketAccessGroupsDocument = gql`
    query GetViewAndEditTicketAccessGroups {
  objectGroups(authorizedClass: ticket, includeReadonlyObjectGroups: true) {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetViewAndEditTicketAccessGroupsQuery__
 *
 * To run a query within a React component, call `useGetViewAndEditTicketAccessGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewAndEditTicketAccessGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewAndEditTicketAccessGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewAndEditTicketAccessGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetViewAndEditTicketAccessGroupsQuery, GraphqlTypes.GetViewAndEditTicketAccessGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetViewAndEditTicketAccessGroupsQuery, GraphqlTypes.GetViewAndEditTicketAccessGroupsQueryVariables>(GetViewAndEditTicketAccessGroupsDocument, options);
      }
export function useGetViewAndEditTicketAccessGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetViewAndEditTicketAccessGroupsQuery, GraphqlTypes.GetViewAndEditTicketAccessGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetViewAndEditTicketAccessGroupsQuery, GraphqlTypes.GetViewAndEditTicketAccessGroupsQueryVariables>(GetViewAndEditTicketAccessGroupsDocument, options);
        }
// @ts-ignore
export function useGetViewAndEditTicketAccessGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetViewAndEditTicketAccessGroupsQuery, GraphqlTypes.GetViewAndEditTicketAccessGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetViewAndEditTicketAccessGroupsQuery, GraphqlTypes.GetViewAndEditTicketAccessGroupsQueryVariables>;
export function useGetViewAndEditTicketAccessGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetViewAndEditTicketAccessGroupsQuery, GraphqlTypes.GetViewAndEditTicketAccessGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetViewAndEditTicketAccessGroupsQuery | undefined, GraphqlTypes.GetViewAndEditTicketAccessGroupsQueryVariables>;
export function useGetViewAndEditTicketAccessGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetViewAndEditTicketAccessGroupsQuery, GraphqlTypes.GetViewAndEditTicketAccessGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetViewAndEditTicketAccessGroupsQuery, GraphqlTypes.GetViewAndEditTicketAccessGroupsQueryVariables>(GetViewAndEditTicketAccessGroupsDocument, options);
        }
export type GetViewAndEditTicketAccessGroupsQueryHookResult = ReturnType<typeof useGetViewAndEditTicketAccessGroupsQuery>;
export type GetViewAndEditTicketAccessGroupsLazyQueryHookResult = ReturnType<typeof useGetViewAndEditTicketAccessGroupsLazyQuery>;
export type GetViewAndEditTicketAccessGroupsSuspenseQueryHookResult = ReturnType<typeof useGetViewAndEditTicketAccessGroupsSuspenseQuery>;
export type GetViewAndEditTicketAccessGroupsQueryResult = Apollo.QueryResult<GraphqlTypes.GetViewAndEditTicketAccessGroupsQuery, GraphqlTypes.GetViewAndEditTicketAccessGroupsQueryVariables>;
export const SendTwoFaCodeDocument = gql`
    mutation SendTwoFaCode($objectInput: SendTwoFaCodeInput!) {
  sendTwoFaCode(objectInput: $objectInput) {
    errorCode
    message
  }
}
    `;
export type SendTwoFaCodeMutationFn = Apollo.MutationFunction<GraphqlTypes.SendTwoFaCodeMutation, GraphqlTypes.SendTwoFaCodeMutationVariables>;

/**
 * __useSendTwoFaCodeMutation__
 *
 * To run a mutation, you first call `useSendTwoFaCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTwoFaCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTwoFaCodeMutation, { data, loading, error }] = useSendTwoFaCodeMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useSendTwoFaCodeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SendTwoFaCodeMutation, GraphqlTypes.SendTwoFaCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SendTwoFaCodeMutation, GraphqlTypes.SendTwoFaCodeMutationVariables>(SendTwoFaCodeDocument, options);
      }
export type SendTwoFaCodeMutationHookResult = ReturnType<typeof useSendTwoFaCodeMutation>;
export type SendTwoFaCodeMutationResult = Apollo.MutationResult<GraphqlTypes.SendTwoFaCodeMutation>;
export type SendTwoFaCodeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SendTwoFaCodeMutation, GraphqlTypes.SendTwoFaCodeMutationVariables>;
export const VerifyTwoFaCodeDocument = gql`
    mutation VerifyTwoFaCode($objectInput: VerifyTwoFaCodeInput!) {
  verifyTwoFaCode(objectInput: $objectInput) {
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on MutationSuccessResponse {
      didSucceed
    }
  }
}
    `;
export type VerifyTwoFaCodeMutationFn = Apollo.MutationFunction<GraphqlTypes.VerifyTwoFaCodeMutation, GraphqlTypes.VerifyTwoFaCodeMutationVariables>;

/**
 * __useVerifyTwoFaCodeMutation__
 *
 * To run a mutation, you first call `useVerifyTwoFaCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTwoFaCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTwoFaCodeMutation, { data, loading, error }] = useVerifyTwoFaCodeMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useVerifyTwoFaCodeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.VerifyTwoFaCodeMutation, GraphqlTypes.VerifyTwoFaCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.VerifyTwoFaCodeMutation, GraphqlTypes.VerifyTwoFaCodeMutationVariables>(VerifyTwoFaCodeDocument, options);
      }
export type VerifyTwoFaCodeMutationHookResult = ReturnType<typeof useVerifyTwoFaCodeMutation>;
export type VerifyTwoFaCodeMutationResult = Apollo.MutationResult<GraphqlTypes.VerifyTwoFaCodeMutation>;
export type VerifyTwoFaCodeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.VerifyTwoFaCodeMutation, GraphqlTypes.VerifyTwoFaCodeMutationVariables>;
export const SetGlobalPortalLoginCookiesDocument = gql`
    mutation SetGlobalPortalLoginCookies($objectInput: SetGlobalPortalLoginCookiesInput!) {
  setGlobalPortalLoginCookies(objectInput: $objectInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on SetGlobalPortalLoginCookiesObject {
      destinationPath
      user {
        id
      }
    }
  }
}
    `;
export type SetGlobalPortalLoginCookiesMutationFn = Apollo.MutationFunction<GraphqlTypes.SetGlobalPortalLoginCookiesMutation, GraphqlTypes.SetGlobalPortalLoginCookiesMutationVariables>;

/**
 * __useSetGlobalPortalLoginCookiesMutation__
 *
 * To run a mutation, you first call `useSetGlobalPortalLoginCookiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGlobalPortalLoginCookiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGlobalPortalLoginCookiesMutation, { data, loading, error }] = useSetGlobalPortalLoginCookiesMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useSetGlobalPortalLoginCookiesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetGlobalPortalLoginCookiesMutation, GraphqlTypes.SetGlobalPortalLoginCookiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetGlobalPortalLoginCookiesMutation, GraphqlTypes.SetGlobalPortalLoginCookiesMutationVariables>(SetGlobalPortalLoginCookiesDocument, options);
      }
export type SetGlobalPortalLoginCookiesMutationHookResult = ReturnType<typeof useSetGlobalPortalLoginCookiesMutation>;
export type SetGlobalPortalLoginCookiesMutationResult = Apollo.MutationResult<GraphqlTypes.SetGlobalPortalLoginCookiesMutation>;
export type SetGlobalPortalLoginCookiesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetGlobalPortalLoginCookiesMutation, GraphqlTypes.SetGlobalPortalLoginCookiesMutationVariables>;
export const UpsertArenaStyleSettingsVisualBrandingDocument = gql`
    mutation upsertArenaStyleSettingsVisualBranding($arenaStyleSettingsInput: ArenaStyleSettingsMutationInput!) {
  arenaStyleSettings(objectInput: $arenaStyleSettingsInput) {
    __typename
    ... on ArenaStyleSettingsMutationResponse {
      success
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UpsertArenaStyleSettingsVisualBrandingMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertArenaStyleSettingsVisualBrandingMutation, GraphqlTypes.UpsertArenaStyleSettingsVisualBrandingMutationVariables>;

/**
 * __useUpsertArenaStyleSettingsVisualBrandingMutation__
 *
 * To run a mutation, you first call `useUpsertArenaStyleSettingsVisualBrandingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertArenaStyleSettingsVisualBrandingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertArenaStyleSettingsVisualBrandingMutation, { data, loading, error }] = useUpsertArenaStyleSettingsVisualBrandingMutation({
 *   variables: {
 *      arenaStyleSettingsInput: // value for 'arenaStyleSettingsInput'
 *   },
 * });
 */
export function useUpsertArenaStyleSettingsVisualBrandingMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertArenaStyleSettingsVisualBrandingMutation, GraphqlTypes.UpsertArenaStyleSettingsVisualBrandingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertArenaStyleSettingsVisualBrandingMutation, GraphqlTypes.UpsertArenaStyleSettingsVisualBrandingMutationVariables>(UpsertArenaStyleSettingsVisualBrandingDocument, options);
      }
export type UpsertArenaStyleSettingsVisualBrandingMutationHookResult = ReturnType<typeof useUpsertArenaStyleSettingsVisualBrandingMutation>;
export type UpsertArenaStyleSettingsVisualBrandingMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertArenaStyleSettingsVisualBrandingMutation>;
export type UpsertArenaStyleSettingsVisualBrandingMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertArenaStyleSettingsVisualBrandingMutation, GraphqlTypes.UpsertArenaStyleSettingsVisualBrandingMutationVariables>;
export const DeleteArenaStyleSettingsVisualBrandingDocument = gql`
    mutation deleteArenaStyleSettingsVisualBranding($arenaStyleSettingsDeleteInput: ArenaStyleSettingsImageDeleteInput!) {
  arenaStyleSettingsImageDelete(objectInput: $arenaStyleSettingsDeleteInput) {
    __typename
    ... on ArenaStyleSettingsMutationResponse {
      success
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type DeleteArenaStyleSettingsVisualBrandingMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteArenaStyleSettingsVisualBrandingMutation, GraphqlTypes.DeleteArenaStyleSettingsVisualBrandingMutationVariables>;

/**
 * __useDeleteArenaStyleSettingsVisualBrandingMutation__
 *
 * To run a mutation, you first call `useDeleteArenaStyleSettingsVisualBrandingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArenaStyleSettingsVisualBrandingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArenaStyleSettingsVisualBrandingMutation, { data, loading, error }] = useDeleteArenaStyleSettingsVisualBrandingMutation({
 *   variables: {
 *      arenaStyleSettingsDeleteInput: // value for 'arenaStyleSettingsDeleteInput'
 *   },
 * });
 */
export function useDeleteArenaStyleSettingsVisualBrandingMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteArenaStyleSettingsVisualBrandingMutation, GraphqlTypes.DeleteArenaStyleSettingsVisualBrandingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteArenaStyleSettingsVisualBrandingMutation, GraphqlTypes.DeleteArenaStyleSettingsVisualBrandingMutationVariables>(DeleteArenaStyleSettingsVisualBrandingDocument, options);
      }
export type DeleteArenaStyleSettingsVisualBrandingMutationHookResult = ReturnType<typeof useDeleteArenaStyleSettingsVisualBrandingMutation>;
export type DeleteArenaStyleSettingsVisualBrandingMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteArenaStyleSettingsVisualBrandingMutation>;
export type DeleteArenaStyleSettingsVisualBrandingMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteArenaStyleSettingsVisualBrandingMutation, GraphqlTypes.DeleteArenaStyleSettingsVisualBrandingMutationVariables>;
export const GetPortalHeroImageDocument = gql`
    query getPortalHeroImage {
  currentArena {
    id
    heroImageUrl
  }
}
    `;

/**
 * __useGetPortalHeroImageQuery__
 *
 * To run a query within a React component, call `useGetPortalHeroImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalHeroImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalHeroImageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPortalHeroImageQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPortalHeroImageQuery, GraphqlTypes.GetPortalHeroImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPortalHeroImageQuery, GraphqlTypes.GetPortalHeroImageQueryVariables>(GetPortalHeroImageDocument, options);
      }
export function useGetPortalHeroImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPortalHeroImageQuery, GraphqlTypes.GetPortalHeroImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPortalHeroImageQuery, GraphqlTypes.GetPortalHeroImageQueryVariables>(GetPortalHeroImageDocument, options);
        }
// @ts-ignore
export function useGetPortalHeroImageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalHeroImageQuery, GraphqlTypes.GetPortalHeroImageQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalHeroImageQuery, GraphqlTypes.GetPortalHeroImageQueryVariables>;
export function useGetPortalHeroImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalHeroImageQuery, GraphqlTypes.GetPortalHeroImageQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalHeroImageQuery | undefined, GraphqlTypes.GetPortalHeroImageQueryVariables>;
export function useGetPortalHeroImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalHeroImageQuery, GraphqlTypes.GetPortalHeroImageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPortalHeroImageQuery, GraphqlTypes.GetPortalHeroImageQueryVariables>(GetPortalHeroImageDocument, options);
        }
export type GetPortalHeroImageQueryHookResult = ReturnType<typeof useGetPortalHeroImageQuery>;
export type GetPortalHeroImageLazyQueryHookResult = ReturnType<typeof useGetPortalHeroImageLazyQuery>;
export type GetPortalHeroImageSuspenseQueryHookResult = ReturnType<typeof useGetPortalHeroImageSuspenseQuery>;
export type GetPortalHeroImageQueryResult = Apollo.QueryResult<GraphqlTypes.GetPortalHeroImageQuery, GraphqlTypes.GetPortalHeroImageQueryVariables>;
export const GetAccountRiskScoresForEntityDocument = gql`
    query GetAccountRiskScoresForEntity($id: ID!) {
  investmentEntity(id: $id) {
    id
    highRiskPositions {
      account {
        id
        name
        investorDiligenceWatchlist {
          riskScore {
            score
            status
            asOfDate
          }
          isHighRiskAcknowledged
          isAcknowledgementAllowed
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountRiskScoresForEntityQuery__
 *
 * To run a query within a React component, call `useGetAccountRiskScoresForEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountRiskScoresForEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountRiskScoresForEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountRiskScoresForEntityQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAccountRiskScoresForEntityQuery, GraphqlTypes.GetAccountRiskScoresForEntityQueryVariables> & ({ variables: GraphqlTypes.GetAccountRiskScoresForEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountRiskScoresForEntityQuery, GraphqlTypes.GetAccountRiskScoresForEntityQueryVariables>(GetAccountRiskScoresForEntityDocument, options);
      }
export function useGetAccountRiskScoresForEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountRiskScoresForEntityQuery, GraphqlTypes.GetAccountRiskScoresForEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountRiskScoresForEntityQuery, GraphqlTypes.GetAccountRiskScoresForEntityQueryVariables>(GetAccountRiskScoresForEntityDocument, options);
        }
// @ts-ignore
export function useGetAccountRiskScoresForEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountRiskScoresForEntityQuery, GraphqlTypes.GetAccountRiskScoresForEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountRiskScoresForEntityQuery, GraphqlTypes.GetAccountRiskScoresForEntityQueryVariables>;
export function useGetAccountRiskScoresForEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountRiskScoresForEntityQuery, GraphqlTypes.GetAccountRiskScoresForEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountRiskScoresForEntityQuery | undefined, GraphqlTypes.GetAccountRiskScoresForEntityQueryVariables>;
export function useGetAccountRiskScoresForEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountRiskScoresForEntityQuery, GraphqlTypes.GetAccountRiskScoresForEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountRiskScoresForEntityQuery, GraphqlTypes.GetAccountRiskScoresForEntityQueryVariables>(GetAccountRiskScoresForEntityDocument, options);
        }
export type GetAccountRiskScoresForEntityQueryHookResult = ReturnType<typeof useGetAccountRiskScoresForEntityQuery>;
export type GetAccountRiskScoresForEntityLazyQueryHookResult = ReturnType<typeof useGetAccountRiskScoresForEntityLazyQuery>;
export type GetAccountRiskScoresForEntitySuspenseQueryHookResult = ReturnType<typeof useGetAccountRiskScoresForEntitySuspenseQuery>;
export type GetAccountRiskScoresForEntityQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountRiskScoresForEntityQuery, GraphqlTypes.GetAccountRiskScoresForEntityQueryVariables>;
export const GridToolPanelsCreateProspectsDocument = gql`
    mutation GridToolPanelsCreateProspects($prospectsInput: CreateProspectsInput!) {
  createProspects(prospectsInput: $prospectsInput) {
    __typename
    ... on CreateProspectsObjectType {
      prospect {
        id
      }
      newProspectCount
      skippedMessage
    }
    ... on CreateProspectsAsyncResponse {
      jobId
      asyncMessage: message
    }
    ... on MutationErrorResponse {
      errorMessage: message
    }
  }
}
    `;
export type GridToolPanelsCreateProspectsMutationFn = Apollo.MutationFunction<GraphqlTypes.GridToolPanelsCreateProspectsMutation, GraphqlTypes.GridToolPanelsCreateProspectsMutationVariables>;

/**
 * __useGridToolPanelsCreateProspectsMutation__
 *
 * To run a mutation, you first call `useGridToolPanelsCreateProspectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGridToolPanelsCreateProspectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gridToolPanelsCreateProspectsMutation, { data, loading, error }] = useGridToolPanelsCreateProspectsMutation({
 *   variables: {
 *      prospectsInput: // value for 'prospectsInput'
 *   },
 * });
 */
export function useGridToolPanelsCreateProspectsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GridToolPanelsCreateProspectsMutation, GraphqlTypes.GridToolPanelsCreateProspectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GridToolPanelsCreateProspectsMutation, GraphqlTypes.GridToolPanelsCreateProspectsMutationVariables>(GridToolPanelsCreateProspectsDocument, options);
      }
export type GridToolPanelsCreateProspectsMutationHookResult = ReturnType<typeof useGridToolPanelsCreateProspectsMutation>;
export type GridToolPanelsCreateProspectsMutationResult = Apollo.MutationResult<GraphqlTypes.GridToolPanelsCreateProspectsMutation>;
export type GridToolPanelsCreateProspectsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GridToolPanelsCreateProspectsMutation, GraphqlTypes.GridToolPanelsCreateProspectsMutationVariables>;
export const GridToolPanelsCreateEmailBatchDocument = gql`
    mutation GridToolPanelsCreateEmailBatch($emailBatchInput: CreateEmailBatchInput!) {
  emailOps {
    createEmailBatch(emailBatchInput: $emailBatchInput) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on EmailBatchObjectType {
        id
      }
    }
  }
}
    `;
export type GridToolPanelsCreateEmailBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.GridToolPanelsCreateEmailBatchMutation, GraphqlTypes.GridToolPanelsCreateEmailBatchMutationVariables>;

/**
 * __useGridToolPanelsCreateEmailBatchMutation__
 *
 * To run a mutation, you first call `useGridToolPanelsCreateEmailBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGridToolPanelsCreateEmailBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gridToolPanelsCreateEmailBatchMutation, { data, loading, error }] = useGridToolPanelsCreateEmailBatchMutation({
 *   variables: {
 *      emailBatchInput: // value for 'emailBatchInput'
 *   },
 * });
 */
export function useGridToolPanelsCreateEmailBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GridToolPanelsCreateEmailBatchMutation, GraphqlTypes.GridToolPanelsCreateEmailBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GridToolPanelsCreateEmailBatchMutation, GraphqlTypes.GridToolPanelsCreateEmailBatchMutationVariables>(GridToolPanelsCreateEmailBatchDocument, options);
      }
export type GridToolPanelsCreateEmailBatchMutationHookResult = ReturnType<typeof useGridToolPanelsCreateEmailBatchMutation>;
export type GridToolPanelsCreateEmailBatchMutationResult = Apollo.MutationResult<GraphqlTypes.GridToolPanelsCreateEmailBatchMutation>;
export type GridToolPanelsCreateEmailBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GridToolPanelsCreateEmailBatchMutation, GraphqlTypes.GridToolPanelsCreateEmailBatchMutationVariables>;
export const GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagDocument = gql`
    query GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlag {
  devFeatures {
    enableReactifiedEmailPreview
  }
}
    `;

/**
 * __useGridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>(GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagDocument, options);
      }
export function useGridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>(GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagDocument, options);
        }
// @ts-ignore
export function useGridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>;
export function useGridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery | undefined, GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>;
export function useGridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>(GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagDocument, options);
        }
export type GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQueryHookResult = ReturnType<typeof useGridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery>;
export type GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagLazyQueryHookResult = ReturnType<typeof useGridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagLazyQuery>;
export type GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagSuspenseQuery>;
export type GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQuery, GraphqlTypes.GridToolPanelsGetEnableReactifiedEmailPreviewFeatureFlagQueryVariables>;
export const GetPositionAndAssetsDocument = gql`
    query GetPositionAndAssets($id: ID!, $thumbnailWidth: Int = 50, $thumbnailHeight: Int = 50, $photoOption: Int = 4) {
  position(id: $id) {
    id
    account {
      id
      name
    }
    investmentEntity {
      id
      name
      published
      showTimeWeightedReturns
      showPerfMetricsOnAsset
      showTwrOnAsset
      overviewAndFinancialsPublished
      overviewAndFinancialsVisible
      description
      ...SubAndOwnedEntities
      arenaId
      isSpv
      canEdit
      canLimitedEdit
      isOperatingCompany
      soiDisplayConfig {
        showSoiInLpPortal
      }
      assetsIndirect {
        edges {
          node {
            id
            name
            isSold
            visible
            published
            entity {
              id
              name
              arenaId
              isSpv
              published
              overviewAndFinancialsVisible
              showTimeWeightedReturns
              showPerfMetricsOnAsset
              showTwrOnAsset
            }
            ...AssetThumbnail
            ...AssetLocations
            ...AssetStateCBSA
          }
        }
        count
      }
      opCosIndirect {
        opcoId
        parentEntityId
        name
        lpDisplayName
        published
        overviewAndFinancialsVisible
      }
    }
  }
}
    ${SubAndOwnedEntitiesFragmentDoc}
${AssetThumbnailFragmentDoc}
${AssetLocationsFragmentDoc}
${AssetStateCbsaFragmentDoc}`;

/**
 * __useGetPositionAndAssetsQuery__
 *
 * To run a query within a React component, call `useGetPositionAndAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionAndAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionAndAssetsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      thumbnailWidth: // value for 'thumbnailWidth'
 *      thumbnailHeight: // value for 'thumbnailHeight'
 *      photoOption: // value for 'photoOption'
 *   },
 * });
 */
export function useGetPositionAndAssetsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionAndAssetsQuery, GraphqlTypes.GetPositionAndAssetsQueryVariables> & ({ variables: GraphqlTypes.GetPositionAndAssetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionAndAssetsQuery, GraphqlTypes.GetPositionAndAssetsQueryVariables>(GetPositionAndAssetsDocument, options);
      }
export function useGetPositionAndAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionAndAssetsQuery, GraphqlTypes.GetPositionAndAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionAndAssetsQuery, GraphqlTypes.GetPositionAndAssetsQueryVariables>(GetPositionAndAssetsDocument, options);
        }
// @ts-ignore
export function useGetPositionAndAssetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionAndAssetsQuery, GraphqlTypes.GetPositionAndAssetsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionAndAssetsQuery, GraphqlTypes.GetPositionAndAssetsQueryVariables>;
export function useGetPositionAndAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionAndAssetsQuery, GraphqlTypes.GetPositionAndAssetsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionAndAssetsQuery | undefined, GraphqlTypes.GetPositionAndAssetsQueryVariables>;
export function useGetPositionAndAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionAndAssetsQuery, GraphqlTypes.GetPositionAndAssetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionAndAssetsQuery, GraphqlTypes.GetPositionAndAssetsQueryVariables>(GetPositionAndAssetsDocument, options);
        }
export type GetPositionAndAssetsQueryHookResult = ReturnType<typeof useGetPositionAndAssetsQuery>;
export type GetPositionAndAssetsLazyQueryHookResult = ReturnType<typeof useGetPositionAndAssetsLazyQuery>;
export type GetPositionAndAssetsSuspenseQueryHookResult = ReturnType<typeof useGetPositionAndAssetsSuspenseQuery>;
export type GetPositionAndAssetsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionAndAssetsQuery, GraphqlTypes.GetPositionAndAssetsQueryVariables>;
export const GetChildEntityAndAssetsDocument = gql`
    query GetChildEntityAndAssets($id: ID!, $thumbnailWidth: Int = 50, $thumbnailHeight: Int = 50, $photoOption: Int = 4) {
  investmentEntity(id: $id) {
    id
    name
    description
    isOperatingCompany
    published
    overviewAndFinancialsPublished
    overviewAndFinancialsVisible
    ...SubAndOwnedEntities
    assetsIndirect {
      edges {
        node {
          id
          name
          isSold
          published
          entity {
            id
            name
          }
          ...AssetThumbnail
          ...AssetLocations
        }
      }
      count
    }
    opCosIndirect {
      opcoId
      parentEntityId
      name
      published
      overviewAndFinancialsVisible
    }
  }
}
    ${SubAndOwnedEntitiesFragmentDoc}
${AssetThumbnailFragmentDoc}
${AssetLocationsFragmentDoc}`;

/**
 * __useGetChildEntityAndAssetsQuery__
 *
 * To run a query within a React component, call `useGetChildEntityAndAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildEntityAndAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildEntityAndAssetsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      thumbnailWidth: // value for 'thumbnailWidth'
 *      thumbnailHeight: // value for 'thumbnailHeight'
 *      photoOption: // value for 'photoOption'
 *   },
 * });
 */
export function useGetChildEntityAndAssetsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetChildEntityAndAssetsQuery, GraphqlTypes.GetChildEntityAndAssetsQueryVariables> & ({ variables: GraphqlTypes.GetChildEntityAndAssetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetChildEntityAndAssetsQuery, GraphqlTypes.GetChildEntityAndAssetsQueryVariables>(GetChildEntityAndAssetsDocument, options);
      }
export function useGetChildEntityAndAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetChildEntityAndAssetsQuery, GraphqlTypes.GetChildEntityAndAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetChildEntityAndAssetsQuery, GraphqlTypes.GetChildEntityAndAssetsQueryVariables>(GetChildEntityAndAssetsDocument, options);
        }
// @ts-ignore
export function useGetChildEntityAndAssetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChildEntityAndAssetsQuery, GraphqlTypes.GetChildEntityAndAssetsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetChildEntityAndAssetsQuery, GraphqlTypes.GetChildEntityAndAssetsQueryVariables>;
export function useGetChildEntityAndAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChildEntityAndAssetsQuery, GraphqlTypes.GetChildEntityAndAssetsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetChildEntityAndAssetsQuery | undefined, GraphqlTypes.GetChildEntityAndAssetsQueryVariables>;
export function useGetChildEntityAndAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChildEntityAndAssetsQuery, GraphqlTypes.GetChildEntityAndAssetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetChildEntityAndAssetsQuery, GraphqlTypes.GetChildEntityAndAssetsQueryVariables>(GetChildEntityAndAssetsDocument, options);
        }
export type GetChildEntityAndAssetsQueryHookResult = ReturnType<typeof useGetChildEntityAndAssetsQuery>;
export type GetChildEntityAndAssetsLazyQueryHookResult = ReturnType<typeof useGetChildEntityAndAssetsLazyQuery>;
export type GetChildEntityAndAssetsSuspenseQueryHookResult = ReturnType<typeof useGetChildEntityAndAssetsSuspenseQuery>;
export type GetChildEntityAndAssetsQueryResult = Apollo.QueryResult<GraphqlTypes.GetChildEntityAndAssetsQuery, GraphqlTypes.GetChildEntityAndAssetsQueryVariables>;
export const SubmitFeedbackDocument = gql`
    mutation SubmitFeedback($feedback: String!, $destination: FeedbackDestinationTypes!) {
  feedbackOps {
    submitFeedback(feedback: $feedback, destination: $destination) {
      success
    }
  }
}
    `;
export type SubmitFeedbackMutationFn = Apollo.MutationFunction<GraphqlTypes.SubmitFeedbackMutation, GraphqlTypes.SubmitFeedbackMutationVariables>;

/**
 * __useSubmitFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFeedbackMutation, { data, loading, error }] = useSubmitFeedbackMutation({
 *   variables: {
 *      feedback: // value for 'feedback'
 *      destination: // value for 'destination'
 *   },
 * });
 */
export function useSubmitFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubmitFeedbackMutation, GraphqlTypes.SubmitFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubmitFeedbackMutation, GraphqlTypes.SubmitFeedbackMutationVariables>(SubmitFeedbackDocument, options);
      }
export type SubmitFeedbackMutationHookResult = ReturnType<typeof useSubmitFeedbackMutation>;
export type SubmitFeedbackMutationResult = Apollo.MutationResult<GraphqlTypes.SubmitFeedbackMutation>;
export type SubmitFeedbackMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubmitFeedbackMutation, GraphqlTypes.SubmitFeedbackMutationVariables>;
export const CreateManagerInvitationDocument = gql`
    mutation CreateManagerInvitation($invitedManagerId: ID!) {
  managerInvitationOps {
    createInvitation(managerId: $invitedManagerId) {
      managerInvitation {
        id
      }
    }
  }
}
    `;
export type CreateManagerInvitationMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateManagerInvitationMutation, GraphqlTypes.CreateManagerInvitationMutationVariables>;

/**
 * __useCreateManagerInvitationMutation__
 *
 * To run a mutation, you first call `useCreateManagerInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManagerInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManagerInvitationMutation, { data, loading, error }] = useCreateManagerInvitationMutation({
 *   variables: {
 *      invitedManagerId: // value for 'invitedManagerId'
 *   },
 * });
 */
export function useCreateManagerInvitationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateManagerInvitationMutation, GraphqlTypes.CreateManagerInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateManagerInvitationMutation, GraphqlTypes.CreateManagerInvitationMutationVariables>(CreateManagerInvitationDocument, options);
      }
export type CreateManagerInvitationMutationHookResult = ReturnType<typeof useCreateManagerInvitationMutation>;
export type CreateManagerInvitationMutationResult = Apollo.MutationResult<GraphqlTypes.CreateManagerInvitationMutation>;
export type CreateManagerInvitationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateManagerInvitationMutation, GraphqlTypes.CreateManagerInvitationMutationVariables>;
export const GetAllInvitableManagersDocument = gql`
    query GetAllInvitableManagers($searchTerm: String!) {
  invitableManagers(searchTerm: $searchTerm) {
    edges {
      node {
        id
        score
        name
        website
        state
        city
      }
    }
  }
}
    `;

/**
 * __useGetAllInvitableManagersQuery__
 *
 * To run a query within a React component, call `useGetAllInvitableManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllInvitableManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllInvitableManagersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetAllInvitableManagersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAllInvitableManagersQuery, GraphqlTypes.GetAllInvitableManagersQueryVariables> & ({ variables: GraphqlTypes.GetAllInvitableManagersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllInvitableManagersQuery, GraphqlTypes.GetAllInvitableManagersQueryVariables>(GetAllInvitableManagersDocument, options);
      }
export function useGetAllInvitableManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllInvitableManagersQuery, GraphqlTypes.GetAllInvitableManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllInvitableManagersQuery, GraphqlTypes.GetAllInvitableManagersQueryVariables>(GetAllInvitableManagersDocument, options);
        }
// @ts-ignore
export function useGetAllInvitableManagersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllInvitableManagersQuery, GraphqlTypes.GetAllInvitableManagersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllInvitableManagersQuery, GraphqlTypes.GetAllInvitableManagersQueryVariables>;
export function useGetAllInvitableManagersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllInvitableManagersQuery, GraphqlTypes.GetAllInvitableManagersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllInvitableManagersQuery | undefined, GraphqlTypes.GetAllInvitableManagersQueryVariables>;
export function useGetAllInvitableManagersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllInvitableManagersQuery, GraphqlTypes.GetAllInvitableManagersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllInvitableManagersQuery, GraphqlTypes.GetAllInvitableManagersQueryVariables>(GetAllInvitableManagersDocument, options);
        }
export type GetAllInvitableManagersQueryHookResult = ReturnType<typeof useGetAllInvitableManagersQuery>;
export type GetAllInvitableManagersLazyQueryHookResult = ReturnType<typeof useGetAllInvitableManagersLazyQuery>;
export type GetAllInvitableManagersSuspenseQueryHookResult = ReturnType<typeof useGetAllInvitableManagersSuspenseQuery>;
export type GetAllInvitableManagersQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllInvitableManagersQuery, GraphqlTypes.GetAllInvitableManagersQueryVariables>;
export const DeleteManagerInvitationDocument = gql`
    mutation DeleteManagerInvitation($invitedManagerId: ID!) {
  managerInvitationOps {
    deleteManagerInvitation(invitedManagerId: $invitedManagerId) {
      deletedInvitedManagerId
    }
  }
}
    `;
export type DeleteManagerInvitationMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteManagerInvitationMutation, GraphqlTypes.DeleteManagerInvitationMutationVariables>;

/**
 * __useDeleteManagerInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteManagerInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManagerInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManagerInvitationMutation, { data, loading, error }] = useDeleteManagerInvitationMutation({
 *   variables: {
 *      invitedManagerId: // value for 'invitedManagerId'
 *   },
 * });
 */
export function useDeleteManagerInvitationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteManagerInvitationMutation, GraphqlTypes.DeleteManagerInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteManagerInvitationMutation, GraphqlTypes.DeleteManagerInvitationMutationVariables>(DeleteManagerInvitationDocument, options);
      }
export type DeleteManagerInvitationMutationHookResult = ReturnType<typeof useDeleteManagerInvitationMutation>;
export type DeleteManagerInvitationMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteManagerInvitationMutation>;
export type DeleteManagerInvitationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteManagerInvitationMutation, GraphqlTypes.DeleteManagerInvitationMutationVariables>;
export const GetInvestmentManagersDocument = gql`
    query GetInvestmentManagers($status: PositionEntityStatus) {
  managerArenas {
    id
    name
    logoUrl
    logoBackgroundColor
    useBgColorForPortalIcons
    secondLevelDomain
    activeOfferings {
      edges {
        node {
          id
        }
      }
    }
    transactionTotals(status: $status) {
      amountCommitted {
        monies
      }
      lifetimeCapitalContributed {
        monies
      }
      lifetimeAmountDistributed {
        monies
      }
      accountValue {
        monies
      }
      positionCount
    }
    settings {
      reportingValueBasis
      hideValuesInLpPortal
    }
  }
  invitedManagers {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetInvestmentManagersQuery__
 *
 * To run a query within a React component, call `useGetInvestmentManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentManagersQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetInvestmentManagersQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentManagersQuery, GraphqlTypes.GetInvestmentManagersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentManagersQuery, GraphqlTypes.GetInvestmentManagersQueryVariables>(GetInvestmentManagersDocument, options);
      }
export function useGetInvestmentManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentManagersQuery, GraphqlTypes.GetInvestmentManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentManagersQuery, GraphqlTypes.GetInvestmentManagersQueryVariables>(GetInvestmentManagersDocument, options);
        }
// @ts-ignore
export function useGetInvestmentManagersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentManagersQuery, GraphqlTypes.GetInvestmentManagersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentManagersQuery, GraphqlTypes.GetInvestmentManagersQueryVariables>;
export function useGetInvestmentManagersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentManagersQuery, GraphqlTypes.GetInvestmentManagersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentManagersQuery | undefined, GraphqlTypes.GetInvestmentManagersQueryVariables>;
export function useGetInvestmentManagersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentManagersQuery, GraphqlTypes.GetInvestmentManagersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentManagersQuery, GraphqlTypes.GetInvestmentManagersQueryVariables>(GetInvestmentManagersDocument, options);
        }
export type GetInvestmentManagersQueryHookResult = ReturnType<typeof useGetInvestmentManagersQuery>;
export type GetInvestmentManagersLazyQueryHookResult = ReturnType<typeof useGetInvestmentManagersLazyQuery>;
export type GetInvestmentManagersSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentManagersSuspenseQuery>;
export type GetInvestmentManagersQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentManagersQuery, GraphqlTypes.GetInvestmentManagersQueryVariables>;
export const GetMultiManagerAssetLocationsDocument = gql`
    query GetMultiManagerAssetLocations($filters: InvestmentFilters) {
  rootPositionInvestments(filters: $filters) {
    id
    positionsWithAssetLocations {
      arenaId
      positions {
        positionId
        currency
        assets {
          assetId
          locations {
            latitude
            longitude
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMultiManagerAssetLocationsQuery__
 *
 * To run a query within a React component, call `useGetMultiManagerAssetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultiManagerAssetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultiManagerAssetLocationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMultiManagerAssetLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetMultiManagerAssetLocationsQuery, GraphqlTypes.GetMultiManagerAssetLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetMultiManagerAssetLocationsQuery, GraphqlTypes.GetMultiManagerAssetLocationsQueryVariables>(GetMultiManagerAssetLocationsDocument, options);
      }
export function useGetMultiManagerAssetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetMultiManagerAssetLocationsQuery, GraphqlTypes.GetMultiManagerAssetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetMultiManagerAssetLocationsQuery, GraphqlTypes.GetMultiManagerAssetLocationsQueryVariables>(GetMultiManagerAssetLocationsDocument, options);
        }
// @ts-ignore
export function useGetMultiManagerAssetLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMultiManagerAssetLocationsQuery, GraphqlTypes.GetMultiManagerAssetLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetMultiManagerAssetLocationsQuery, GraphqlTypes.GetMultiManagerAssetLocationsQueryVariables>;
export function useGetMultiManagerAssetLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMultiManagerAssetLocationsQuery, GraphqlTypes.GetMultiManagerAssetLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetMultiManagerAssetLocationsQuery | undefined, GraphqlTypes.GetMultiManagerAssetLocationsQueryVariables>;
export function useGetMultiManagerAssetLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMultiManagerAssetLocationsQuery, GraphqlTypes.GetMultiManagerAssetLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetMultiManagerAssetLocationsQuery, GraphqlTypes.GetMultiManagerAssetLocationsQueryVariables>(GetMultiManagerAssetLocationsDocument, options);
        }
export type GetMultiManagerAssetLocationsQueryHookResult = ReturnType<typeof useGetMultiManagerAssetLocationsQuery>;
export type GetMultiManagerAssetLocationsLazyQueryHookResult = ReturnType<typeof useGetMultiManagerAssetLocationsLazyQuery>;
export type GetMultiManagerAssetLocationsSuspenseQueryHookResult = ReturnType<typeof useGetMultiManagerAssetLocationsSuspenseQuery>;
export type GetMultiManagerAssetLocationsQueryResult = Apollo.QueryResult<GraphqlTypes.GetMultiManagerAssetLocationsQuery, GraphqlTypes.GetMultiManagerAssetLocationsQueryVariables>;
export const CancelLpConsolidationRequestDocument = gql`
    mutation CancelLpConsolidationRequest($lpConsolidationRequestId: Int!) {
  cancelLpConsolidation(
    objectInput: {lpConsolidationRequestId: $lpConsolidationRequestId}
  ) {
    ... on LpConsolidationRequestObject {
      isSuccess
    }
  }
}
    `;
export type CancelLpConsolidationRequestMutationFn = Apollo.MutationFunction<GraphqlTypes.CancelLpConsolidationRequestMutation, GraphqlTypes.CancelLpConsolidationRequestMutationVariables>;

/**
 * __useCancelLpConsolidationRequestMutation__
 *
 * To run a mutation, you first call `useCancelLpConsolidationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelLpConsolidationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelLpConsolidationRequestMutation, { data, loading, error }] = useCancelLpConsolidationRequestMutation({
 *   variables: {
 *      lpConsolidationRequestId: // value for 'lpConsolidationRequestId'
 *   },
 * });
 */
export function useCancelLpConsolidationRequestMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CancelLpConsolidationRequestMutation, GraphqlTypes.CancelLpConsolidationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CancelLpConsolidationRequestMutation, GraphqlTypes.CancelLpConsolidationRequestMutationVariables>(CancelLpConsolidationRequestDocument, options);
      }
export type CancelLpConsolidationRequestMutationHookResult = ReturnType<typeof useCancelLpConsolidationRequestMutation>;
export type CancelLpConsolidationRequestMutationResult = Apollo.MutationResult<GraphqlTypes.CancelLpConsolidationRequestMutation>;
export type CancelLpConsolidationRequestMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CancelLpConsolidationRequestMutation, GraphqlTypes.CancelLpConsolidationRequestMutationVariables>;
export const CompleteLpConsolidationRequestDocument = gql`
    mutation CompleteLpConsolidationRequest($object_input: CompleteLpConsolidationRequestInput!) {
  completeLpConsolidationRequest(objectInput: $object_input) {
    ... on LpConsolidationRequestObject {
      isSuccess
    }
    ... on MutationErrorResponse {
      message
    }
  }
}
    `;
export type CompleteLpConsolidationRequestMutationFn = Apollo.MutationFunction<GraphqlTypes.CompleteLpConsolidationRequestMutation, GraphqlTypes.CompleteLpConsolidationRequestMutationVariables>;

/**
 * __useCompleteLpConsolidationRequestMutation__
 *
 * To run a mutation, you first call `useCompleteLpConsolidationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteLpConsolidationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeLpConsolidationRequestMutation, { data, loading, error }] = useCompleteLpConsolidationRequestMutation({
 *   variables: {
 *      object_input: // value for 'object_input'
 *   },
 * });
 */
export function useCompleteLpConsolidationRequestMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CompleteLpConsolidationRequestMutation, GraphqlTypes.CompleteLpConsolidationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CompleteLpConsolidationRequestMutation, GraphqlTypes.CompleteLpConsolidationRequestMutationVariables>(CompleteLpConsolidationRequestDocument, options);
      }
export type CompleteLpConsolidationRequestMutationHookResult = ReturnType<typeof useCompleteLpConsolidationRequestMutation>;
export type CompleteLpConsolidationRequestMutationResult = Apollo.MutationResult<GraphqlTypes.CompleteLpConsolidationRequestMutation>;
export type CompleteLpConsolidationRequestMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CompleteLpConsolidationRequestMutation, GraphqlTypes.CompleteLpConsolidationRequestMutationVariables>;
export const GetMultiManagerTotalsDocument = gql`
    query GetMultiManagerTotals($status: PositionEntityStatus) {
  multiManagerContext {
    transactionTotals(status: $status) {
      amountCommitted {
        monies
      }
      lifetimeCapitalContributed {
        monies
      }
      lifetimeAmountDistributed {
        monies
      }
      accountValue {
        monies
      }
      positionCount
    }
  }
}
    `;

/**
 * __useGetMultiManagerTotalsQuery__
 *
 * To run a query within a React component, call `useGetMultiManagerTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultiManagerTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultiManagerTotalsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetMultiManagerTotalsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetMultiManagerTotalsQuery, GraphqlTypes.GetMultiManagerTotalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetMultiManagerTotalsQuery, GraphqlTypes.GetMultiManagerTotalsQueryVariables>(GetMultiManagerTotalsDocument, options);
      }
export function useGetMultiManagerTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetMultiManagerTotalsQuery, GraphqlTypes.GetMultiManagerTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetMultiManagerTotalsQuery, GraphqlTypes.GetMultiManagerTotalsQueryVariables>(GetMultiManagerTotalsDocument, options);
        }
// @ts-ignore
export function useGetMultiManagerTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMultiManagerTotalsQuery, GraphqlTypes.GetMultiManagerTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetMultiManagerTotalsQuery, GraphqlTypes.GetMultiManagerTotalsQueryVariables>;
export function useGetMultiManagerTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMultiManagerTotalsQuery, GraphqlTypes.GetMultiManagerTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetMultiManagerTotalsQuery | undefined, GraphqlTypes.GetMultiManagerTotalsQueryVariables>;
export function useGetMultiManagerTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMultiManagerTotalsQuery, GraphqlTypes.GetMultiManagerTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetMultiManagerTotalsQuery, GraphqlTypes.GetMultiManagerTotalsQueryVariables>(GetMultiManagerTotalsDocument, options);
        }
export type GetMultiManagerTotalsQueryHookResult = ReturnType<typeof useGetMultiManagerTotalsQuery>;
export type GetMultiManagerTotalsLazyQueryHookResult = ReturnType<typeof useGetMultiManagerTotalsLazyQuery>;
export type GetMultiManagerTotalsSuspenseQueryHookResult = ReturnType<typeof useGetMultiManagerTotalsSuspenseQuery>;
export type GetMultiManagerTotalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetMultiManagerTotalsQuery, GraphqlTypes.GetMultiManagerTotalsQueryVariables>;
export const ShowTaxBannerDocument = gql`
    query ShowTaxBanner {
  showTaxBanner
}
    `;

/**
 * __useShowTaxBannerQuery__
 *
 * To run a query within a React component, call `useShowTaxBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowTaxBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowTaxBannerQuery({
 *   variables: {
 *   },
 * });
 */
export function useShowTaxBannerQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.ShowTaxBannerQuery, GraphqlTypes.ShowTaxBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ShowTaxBannerQuery, GraphqlTypes.ShowTaxBannerQueryVariables>(ShowTaxBannerDocument, options);
      }
export function useShowTaxBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ShowTaxBannerQuery, GraphqlTypes.ShowTaxBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ShowTaxBannerQuery, GraphqlTypes.ShowTaxBannerQueryVariables>(ShowTaxBannerDocument, options);
        }
// @ts-ignore
export function useShowTaxBannerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ShowTaxBannerQuery, GraphqlTypes.ShowTaxBannerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ShowTaxBannerQuery, GraphqlTypes.ShowTaxBannerQueryVariables>;
export function useShowTaxBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ShowTaxBannerQuery, GraphqlTypes.ShowTaxBannerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ShowTaxBannerQuery | undefined, GraphqlTypes.ShowTaxBannerQueryVariables>;
export function useShowTaxBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ShowTaxBannerQuery, GraphqlTypes.ShowTaxBannerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ShowTaxBannerQuery, GraphqlTypes.ShowTaxBannerQueryVariables>(ShowTaxBannerDocument, options);
        }
export type ShowTaxBannerQueryHookResult = ReturnType<typeof useShowTaxBannerQuery>;
export type ShowTaxBannerLazyQueryHookResult = ReturnType<typeof useShowTaxBannerLazyQuery>;
export type ShowTaxBannerSuspenseQueryHookResult = ReturnType<typeof useShowTaxBannerSuspenseQuery>;
export type ShowTaxBannerQueryResult = Apollo.QueryResult<GraphqlTypes.ShowTaxBannerQuery, GraphqlTypes.ShowTaxBannerQueryVariables>;
export const GetLpConsolidationRequestInfoDocument = gql`
    query GetLpConsolidationRequestInfo {
  getLpConsolidationRequest {
    id
    destinationGlobalUserId
    sourceGlobalUserId
    status
    sourceGlobalUserEmail
    destinationGlobalUserEmail
  }
}
    `;

/**
 * __useGetLpConsolidationRequestInfoQuery__
 *
 * To run a query within a React component, call `useGetLpConsolidationRequestInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLpConsolidationRequestInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLpConsolidationRequestInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLpConsolidationRequestInfoQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetLpConsolidationRequestInfoQuery, GraphqlTypes.GetLpConsolidationRequestInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLpConsolidationRequestInfoQuery, GraphqlTypes.GetLpConsolidationRequestInfoQueryVariables>(GetLpConsolidationRequestInfoDocument, options);
      }
export function useGetLpConsolidationRequestInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLpConsolidationRequestInfoQuery, GraphqlTypes.GetLpConsolidationRequestInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLpConsolidationRequestInfoQuery, GraphqlTypes.GetLpConsolidationRequestInfoQueryVariables>(GetLpConsolidationRequestInfoDocument, options);
        }
// @ts-ignore
export function useGetLpConsolidationRequestInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpConsolidationRequestInfoQuery, GraphqlTypes.GetLpConsolidationRequestInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLpConsolidationRequestInfoQuery, GraphqlTypes.GetLpConsolidationRequestInfoQueryVariables>;
export function useGetLpConsolidationRequestInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpConsolidationRequestInfoQuery, GraphqlTypes.GetLpConsolidationRequestInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLpConsolidationRequestInfoQuery | undefined, GraphqlTypes.GetLpConsolidationRequestInfoQueryVariables>;
export function useGetLpConsolidationRequestInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpConsolidationRequestInfoQuery, GraphqlTypes.GetLpConsolidationRequestInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLpConsolidationRequestInfoQuery, GraphqlTypes.GetLpConsolidationRequestInfoQueryVariables>(GetLpConsolidationRequestInfoDocument, options);
        }
export type GetLpConsolidationRequestInfoQueryHookResult = ReturnType<typeof useGetLpConsolidationRequestInfoQuery>;
export type GetLpConsolidationRequestInfoLazyQueryHookResult = ReturnType<typeof useGetLpConsolidationRequestInfoLazyQuery>;
export type GetLpConsolidationRequestInfoSuspenseQueryHookResult = ReturnType<typeof useGetLpConsolidationRequestInfoSuspenseQuery>;
export type GetLpConsolidationRequestInfoQueryResult = Apollo.QueryResult<GraphqlTypes.GetLpConsolidationRequestInfoQuery, GraphqlTypes.GetLpConsolidationRequestInfoQueryVariables>;
export const GetAssetsWithLocationsDocument = gql`
    query GetAssetsWithLocations {
  assets {
    edges {
      node {
        ...AssetWithLocation
      }
    }
  }
}
    ${AssetWithLocationFragmentDoc}`;

/**
 * __useGetAssetsWithLocationsQuery__
 *
 * To run a query within a React component, call `useGetAssetsWithLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetsWithLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetsWithLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssetsWithLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAssetsWithLocationsQuery, GraphqlTypes.GetAssetsWithLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetsWithLocationsQuery, GraphqlTypes.GetAssetsWithLocationsQueryVariables>(GetAssetsWithLocationsDocument, options);
      }
export function useGetAssetsWithLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetsWithLocationsQuery, GraphqlTypes.GetAssetsWithLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetsWithLocationsQuery, GraphqlTypes.GetAssetsWithLocationsQueryVariables>(GetAssetsWithLocationsDocument, options);
        }
// @ts-ignore
export function useGetAssetsWithLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetsWithLocationsQuery, GraphqlTypes.GetAssetsWithLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetsWithLocationsQuery, GraphqlTypes.GetAssetsWithLocationsQueryVariables>;
export function useGetAssetsWithLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetsWithLocationsQuery, GraphqlTypes.GetAssetsWithLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetsWithLocationsQuery | undefined, GraphqlTypes.GetAssetsWithLocationsQueryVariables>;
export function useGetAssetsWithLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetsWithLocationsQuery, GraphqlTypes.GetAssetsWithLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetsWithLocationsQuery, GraphqlTypes.GetAssetsWithLocationsQueryVariables>(GetAssetsWithLocationsDocument, options);
        }
export type GetAssetsWithLocationsQueryHookResult = ReturnType<typeof useGetAssetsWithLocationsQuery>;
export type GetAssetsWithLocationsLazyQueryHookResult = ReturnType<typeof useGetAssetsWithLocationsLazyQuery>;
export type GetAssetsWithLocationsSuspenseQueryHookResult = ReturnType<typeof useGetAssetsWithLocationsSuspenseQuery>;
export type GetAssetsWithLocationsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetsWithLocationsQuery, GraphqlTypes.GetAssetsWithLocationsQueryVariables>;
export const GetPortalExportDownloadFileUrlDocument = gql`
    query GetPortalExportDownloadFileUrl($asyncJobId: ID!, $arenaId: ID) {
  portalExportDownloadFileUrl(asyncJobId: $asyncJobId, managerArenaId: $arenaId)
}
    `;

/**
 * __useGetPortalExportDownloadFileUrlQuery__
 *
 * To run a query within a React component, call `useGetPortalExportDownloadFileUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalExportDownloadFileUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalExportDownloadFileUrlQuery({
 *   variables: {
 *      asyncJobId: // value for 'asyncJobId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetPortalExportDownloadFileUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPortalExportDownloadFileUrlQuery, GraphqlTypes.GetPortalExportDownloadFileUrlQueryVariables> & ({ variables: GraphqlTypes.GetPortalExportDownloadFileUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPortalExportDownloadFileUrlQuery, GraphqlTypes.GetPortalExportDownloadFileUrlQueryVariables>(GetPortalExportDownloadFileUrlDocument, options);
      }
export function useGetPortalExportDownloadFileUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPortalExportDownloadFileUrlQuery, GraphqlTypes.GetPortalExportDownloadFileUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPortalExportDownloadFileUrlQuery, GraphqlTypes.GetPortalExportDownloadFileUrlQueryVariables>(GetPortalExportDownloadFileUrlDocument, options);
        }
// @ts-ignore
export function useGetPortalExportDownloadFileUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalExportDownloadFileUrlQuery, GraphqlTypes.GetPortalExportDownloadFileUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalExportDownloadFileUrlQuery, GraphqlTypes.GetPortalExportDownloadFileUrlQueryVariables>;
export function useGetPortalExportDownloadFileUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalExportDownloadFileUrlQuery, GraphqlTypes.GetPortalExportDownloadFileUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalExportDownloadFileUrlQuery | undefined, GraphqlTypes.GetPortalExportDownloadFileUrlQueryVariables>;
export function useGetPortalExportDownloadFileUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalExportDownloadFileUrlQuery, GraphqlTypes.GetPortalExportDownloadFileUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPortalExportDownloadFileUrlQuery, GraphqlTypes.GetPortalExportDownloadFileUrlQueryVariables>(GetPortalExportDownloadFileUrlDocument, options);
        }
export type GetPortalExportDownloadFileUrlQueryHookResult = ReturnType<typeof useGetPortalExportDownloadFileUrlQuery>;
export type GetPortalExportDownloadFileUrlLazyQueryHookResult = ReturnType<typeof useGetPortalExportDownloadFileUrlLazyQuery>;
export type GetPortalExportDownloadFileUrlSuspenseQueryHookResult = ReturnType<typeof useGetPortalExportDownloadFileUrlSuspenseQuery>;
export type GetPortalExportDownloadFileUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetPortalExportDownloadFileUrlQuery, GraphqlTypes.GetPortalExportDownloadFileUrlQueryVariables>;
export const CurrencySelectorGetCurrenciesDocument = gql`
    query CurrencySelectorGetCurrencies {
  currentGlobalUser {
    currencies {
      id
      symbol
      fullName
      code
      flagUnicode
    }
  }
}
    `;

/**
 * __useCurrencySelectorGetCurrenciesQuery__
 *
 * To run a query within a React component, call `useCurrencySelectorGetCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrencySelectorGetCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrencySelectorGetCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrencySelectorGetCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.CurrencySelectorGetCurrenciesQuery, GraphqlTypes.CurrencySelectorGetCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CurrencySelectorGetCurrenciesQuery, GraphqlTypes.CurrencySelectorGetCurrenciesQueryVariables>(CurrencySelectorGetCurrenciesDocument, options);
      }
export function useCurrencySelectorGetCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CurrencySelectorGetCurrenciesQuery, GraphqlTypes.CurrencySelectorGetCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CurrencySelectorGetCurrenciesQuery, GraphqlTypes.CurrencySelectorGetCurrenciesQueryVariables>(CurrencySelectorGetCurrenciesDocument, options);
        }
// @ts-ignore
export function useCurrencySelectorGetCurrenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrencySelectorGetCurrenciesQuery, GraphqlTypes.CurrencySelectorGetCurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CurrencySelectorGetCurrenciesQuery, GraphqlTypes.CurrencySelectorGetCurrenciesQueryVariables>;
export function useCurrencySelectorGetCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrencySelectorGetCurrenciesQuery, GraphqlTypes.CurrencySelectorGetCurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CurrencySelectorGetCurrenciesQuery | undefined, GraphqlTypes.CurrencySelectorGetCurrenciesQueryVariables>;
export function useCurrencySelectorGetCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrencySelectorGetCurrenciesQuery, GraphqlTypes.CurrencySelectorGetCurrenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CurrencySelectorGetCurrenciesQuery, GraphqlTypes.CurrencySelectorGetCurrenciesQueryVariables>(CurrencySelectorGetCurrenciesDocument, options);
        }
export type CurrencySelectorGetCurrenciesQueryHookResult = ReturnType<typeof useCurrencySelectorGetCurrenciesQuery>;
export type CurrencySelectorGetCurrenciesLazyQueryHookResult = ReturnType<typeof useCurrencySelectorGetCurrenciesLazyQuery>;
export type CurrencySelectorGetCurrenciesSuspenseQueryHookResult = ReturnType<typeof useCurrencySelectorGetCurrenciesSuspenseQuery>;
export type CurrencySelectorGetCurrenciesQueryResult = Apollo.QueryResult<GraphqlTypes.CurrencySelectorGetCurrenciesQuery, GraphqlTypes.CurrencySelectorGetCurrenciesQueryVariables>;
export const CurrencySelectorGetIsCurrencyEnabledDocument = gql`
    query CurrencySelectorGetIsCurrencyEnabled($arenaId: ID!) {
  managerArena(id: $arenaId) {
    settings {
      isMulticurrencyPortalEnabled
    }
  }
}
    `;

/**
 * __useCurrencySelectorGetIsCurrencyEnabledQuery__
 *
 * To run a query within a React component, call `useCurrencySelectorGetIsCurrencyEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrencySelectorGetIsCurrencyEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrencySelectorGetIsCurrencyEnabledQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useCurrencySelectorGetIsCurrencyEnabledQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQuery, GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQueryVariables> & ({ variables: GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQuery, GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQueryVariables>(CurrencySelectorGetIsCurrencyEnabledDocument, options);
      }
export function useCurrencySelectorGetIsCurrencyEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQuery, GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQuery, GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQueryVariables>(CurrencySelectorGetIsCurrencyEnabledDocument, options);
        }
// @ts-ignore
export function useCurrencySelectorGetIsCurrencyEnabledSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQuery, GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQuery, GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQueryVariables>;
export function useCurrencySelectorGetIsCurrencyEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQuery, GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQuery | undefined, GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQueryVariables>;
export function useCurrencySelectorGetIsCurrencyEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQuery, GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQuery, GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQueryVariables>(CurrencySelectorGetIsCurrencyEnabledDocument, options);
        }
export type CurrencySelectorGetIsCurrencyEnabledQueryHookResult = ReturnType<typeof useCurrencySelectorGetIsCurrencyEnabledQuery>;
export type CurrencySelectorGetIsCurrencyEnabledLazyQueryHookResult = ReturnType<typeof useCurrencySelectorGetIsCurrencyEnabledLazyQuery>;
export type CurrencySelectorGetIsCurrencyEnabledSuspenseQueryHookResult = ReturnType<typeof useCurrencySelectorGetIsCurrencyEnabledSuspenseQuery>;
export type CurrencySelectorGetIsCurrencyEnabledQueryResult = Apollo.QueryResult<GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQuery, GraphqlTypes.CurrencySelectorGetIsCurrencyEnabledQueryVariables>;
export const DownloadDataRoomContentsDocument = gql`
    mutation DownloadDataRoomContents($objectInput: DownloadFolderContentsInput!) {
  downloadFolderContents(objectInput: $objectInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on DownloaderFolderContentObjectType {
      job {
        id
        data
        status
      }
    }
    ... on SingleDocumentDownloadResponse {
      downloadUrl
    }
    ... on DocumentLoginOrNDASignatureRequiredResponse {
      requiresLogin
      globalInviteToken
      documentsWithNda {
        id
        nda {
          id
          resourceId
          name
          customerName
          signedByCurrentUser
          agreementText
        }
      }
    }
  }
}
    `;
export type DownloadDataRoomContentsMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadDataRoomContentsMutation, GraphqlTypes.DownloadDataRoomContentsMutationVariables>;

/**
 * __useDownloadDataRoomContentsMutation__
 *
 * To run a mutation, you first call `useDownloadDataRoomContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadDataRoomContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadDataRoomContentsMutation, { data, loading, error }] = useDownloadDataRoomContentsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useDownloadDataRoomContentsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadDataRoomContentsMutation, GraphqlTypes.DownloadDataRoomContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadDataRoomContentsMutation, GraphqlTypes.DownloadDataRoomContentsMutationVariables>(DownloadDataRoomContentsDocument, options);
      }
export type DownloadDataRoomContentsMutationHookResult = ReturnType<typeof useDownloadDataRoomContentsMutation>;
export type DownloadDataRoomContentsMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadDataRoomContentsMutation>;
export type DownloadDataRoomContentsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadDataRoomContentsMutation, GraphqlTypes.DownloadDataRoomContentsMutationVariables>;
export const GetDocumentFolderByDataRoomKeyDocument = gql`
    query GetDocumentFolderByDataRoomKey($arenaDomain: String!, $dataRoomKey: String, $offeringId: ID, $relativeRootFolderId: Int, $isStaffPreview: Boolean) {
  dataRoomByDataRoomKey(
    arenaDomain: $arenaDomain
    dataRoomKey: $dataRoomKey
    offeringId: $offeringId
    isStaffPreview: $isStaffPreview
  ) {
    ...DateRoomDocumentFolderDetails
  }
}
    ${DateRoomDocumentFolderDetailsFragmentDoc}`;

/**
 * __useGetDocumentFolderByDataRoomKeyQuery__
 *
 * To run a query within a React component, call `useGetDocumentFolderByDataRoomKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentFolderByDataRoomKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentFolderByDataRoomKeyQuery({
 *   variables: {
 *      arenaDomain: // value for 'arenaDomain'
 *      dataRoomKey: // value for 'dataRoomKey'
 *      offeringId: // value for 'offeringId'
 *      relativeRootFolderId: // value for 'relativeRootFolderId'
 *      isStaffPreview: // value for 'isStaffPreview'
 *   },
 * });
 */
export function useGetDocumentFolderByDataRoomKeyQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentFolderByDataRoomKeyQuery, GraphqlTypes.GetDocumentFolderByDataRoomKeyQueryVariables> & ({ variables: GraphqlTypes.GetDocumentFolderByDataRoomKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentFolderByDataRoomKeyQuery, GraphqlTypes.GetDocumentFolderByDataRoomKeyQueryVariables>(GetDocumentFolderByDataRoomKeyDocument, options);
      }
export function useGetDocumentFolderByDataRoomKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentFolderByDataRoomKeyQuery, GraphqlTypes.GetDocumentFolderByDataRoomKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentFolderByDataRoomKeyQuery, GraphqlTypes.GetDocumentFolderByDataRoomKeyQueryVariables>(GetDocumentFolderByDataRoomKeyDocument, options);
        }
// @ts-ignore
export function useGetDocumentFolderByDataRoomKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentFolderByDataRoomKeyQuery, GraphqlTypes.GetDocumentFolderByDataRoomKeyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentFolderByDataRoomKeyQuery, GraphqlTypes.GetDocumentFolderByDataRoomKeyQueryVariables>;
export function useGetDocumentFolderByDataRoomKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentFolderByDataRoomKeyQuery, GraphqlTypes.GetDocumentFolderByDataRoomKeyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentFolderByDataRoomKeyQuery | undefined, GraphqlTypes.GetDocumentFolderByDataRoomKeyQueryVariables>;
export function useGetDocumentFolderByDataRoomKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentFolderByDataRoomKeyQuery, GraphqlTypes.GetDocumentFolderByDataRoomKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentFolderByDataRoomKeyQuery, GraphqlTypes.GetDocumentFolderByDataRoomKeyQueryVariables>(GetDocumentFolderByDataRoomKeyDocument, options);
        }
export type GetDocumentFolderByDataRoomKeyQueryHookResult = ReturnType<typeof useGetDocumentFolderByDataRoomKeyQuery>;
export type GetDocumentFolderByDataRoomKeyLazyQueryHookResult = ReturnType<typeof useGetDocumentFolderByDataRoomKeyLazyQuery>;
export type GetDocumentFolderByDataRoomKeySuspenseQueryHookResult = ReturnType<typeof useGetDocumentFolderByDataRoomKeySuspenseQuery>;
export type GetDocumentFolderByDataRoomKeyQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentFolderByDataRoomKeyQuery, GraphqlTypes.GetDocumentFolderByDataRoomKeyQueryVariables>;
export const GetDataRoomByDataRoomKeyDocument = gql`
    query GetDataRoomByDataRoomKey($arenaDomain: String!, $dataRoomKey: String, $offeringId: ID, $isStaffPreview: Boolean) {
  dataRoomByDataRoomKey(
    arenaDomain: $arenaDomain
    dataRoomKey: $dataRoomKey
    offeringId: $offeringId
    isStaffPreview: $isStaffPreview
  ) {
    ...DataRoomDetails
    ...DataRoomAccreditationRequired
    ...DataRoomNoAccess
    ...DataRoomRedirect
    ...DataRoomAccessNdaRequired
  }
}
    ${DataRoomDetailsFragmentDoc}
${DataRoomAccreditationRequiredFragmentDoc}
${DataRoomNoAccessFragmentDoc}
${DataRoomRedirectFragmentDoc}
${DataRoomAccessNdaRequiredFragmentDoc}`;

/**
 * __useGetDataRoomByDataRoomKeyQuery__
 *
 * To run a query within a React component, call `useGetDataRoomByDataRoomKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataRoomByDataRoomKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataRoomByDataRoomKeyQuery({
 *   variables: {
 *      arenaDomain: // value for 'arenaDomain'
 *      dataRoomKey: // value for 'dataRoomKey'
 *      offeringId: // value for 'offeringId'
 *      isStaffPreview: // value for 'isStaffPreview'
 *   },
 * });
 */
export function useGetDataRoomByDataRoomKeyQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDataRoomByDataRoomKeyQuery, GraphqlTypes.GetDataRoomByDataRoomKeyQueryVariables> & ({ variables: GraphqlTypes.GetDataRoomByDataRoomKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDataRoomByDataRoomKeyQuery, GraphqlTypes.GetDataRoomByDataRoomKeyQueryVariables>(GetDataRoomByDataRoomKeyDocument, options);
      }
export function useGetDataRoomByDataRoomKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDataRoomByDataRoomKeyQuery, GraphqlTypes.GetDataRoomByDataRoomKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDataRoomByDataRoomKeyQuery, GraphqlTypes.GetDataRoomByDataRoomKeyQueryVariables>(GetDataRoomByDataRoomKeyDocument, options);
        }
// @ts-ignore
export function useGetDataRoomByDataRoomKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataRoomByDataRoomKeyQuery, GraphqlTypes.GetDataRoomByDataRoomKeyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataRoomByDataRoomKeyQuery, GraphqlTypes.GetDataRoomByDataRoomKeyQueryVariables>;
export function useGetDataRoomByDataRoomKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataRoomByDataRoomKeyQuery, GraphqlTypes.GetDataRoomByDataRoomKeyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataRoomByDataRoomKeyQuery | undefined, GraphqlTypes.GetDataRoomByDataRoomKeyQueryVariables>;
export function useGetDataRoomByDataRoomKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataRoomByDataRoomKeyQuery, GraphqlTypes.GetDataRoomByDataRoomKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDataRoomByDataRoomKeyQuery, GraphqlTypes.GetDataRoomByDataRoomKeyQueryVariables>(GetDataRoomByDataRoomKeyDocument, options);
        }
export type GetDataRoomByDataRoomKeyQueryHookResult = ReturnType<typeof useGetDataRoomByDataRoomKeyQuery>;
export type GetDataRoomByDataRoomKeyLazyQueryHookResult = ReturnType<typeof useGetDataRoomByDataRoomKeyLazyQuery>;
export type GetDataRoomByDataRoomKeySuspenseQueryHookResult = ReturnType<typeof useGetDataRoomByDataRoomKeySuspenseQuery>;
export type GetDataRoomByDataRoomKeyQueryResult = Apollo.QueryResult<GraphqlTypes.GetDataRoomByDataRoomKeyQuery, GraphqlTypes.GetDataRoomByDataRoomKeyQueryVariables>;
export const GetSubscriptionDocument = gql`
    query GetSubscription($arenaDomain: String!, $dataRoomKey: String!) {
  subscriptionV2(arenaDomain: $arenaDomain, dataRoomKey: $dataRoomKey) {
    id
    welcomeMessage
  }
}
    `;

/**
 * __useGetSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionQuery({
 *   variables: {
 *      arenaDomain: // value for 'arenaDomain'
 *      dataRoomKey: // value for 'dataRoomKey'
 *   },
 * });
 */
export function useGetSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSubscriptionQuery, GraphqlTypes.GetSubscriptionQueryVariables> & ({ variables: GraphqlTypes.GetSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSubscriptionQuery, GraphqlTypes.GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSubscriptionQuery, GraphqlTypes.GetSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSubscriptionQuery, GraphqlTypes.GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionQuery, GraphqlTypes.GetSubscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionQuery, GraphqlTypes.GetSubscriptionQueryVariables>;
export function useGetSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionQuery, GraphqlTypes.GetSubscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionQuery | undefined, GraphqlTypes.GetSubscriptionQueryVariables>;
export function useGetSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionQuery, GraphqlTypes.GetSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSubscriptionQuery, GraphqlTypes.GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export type GetSubscriptionQueryHookResult = ReturnType<typeof useGetSubscriptionQuery>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionSuspenseQuery>;
export type GetSubscriptionQueryResult = Apollo.QueryResult<GraphqlTypes.GetSubscriptionQuery, GraphqlTypes.GetSubscriptionQueryVariables>;
export const SaveQuestionnaireResponseDocument = gql`
    mutation SaveQuestionnaireResponse($objectInput: DisregardedEntityQuestionnaireInput!) {
  saveDisregardedEntityQuestionnaire(objectInput: $objectInput) {
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on MutationSuccessResponse {
      didSucceed
    }
  }
}
    `;
export type SaveQuestionnaireResponseMutationFn = Apollo.MutationFunction<GraphqlTypes.SaveQuestionnaireResponseMutation, GraphqlTypes.SaveQuestionnaireResponseMutationVariables>;

/**
 * __useSaveQuestionnaireResponseMutation__
 *
 * To run a mutation, you first call `useSaveQuestionnaireResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuestionnaireResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuestionnaireResponseMutation, { data, loading, error }] = useSaveQuestionnaireResponseMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useSaveQuestionnaireResponseMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SaveQuestionnaireResponseMutation, GraphqlTypes.SaveQuestionnaireResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SaveQuestionnaireResponseMutation, GraphqlTypes.SaveQuestionnaireResponseMutationVariables>(SaveQuestionnaireResponseDocument, options);
      }
export type SaveQuestionnaireResponseMutationHookResult = ReturnType<typeof useSaveQuestionnaireResponseMutation>;
export type SaveQuestionnaireResponseMutationResult = Apollo.MutationResult<GraphqlTypes.SaveQuestionnaireResponseMutation>;
export type SaveQuestionnaireResponseMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SaveQuestionnaireResponseMutation, GraphqlTypes.SaveQuestionnaireResponseMutationVariables>;
export const GetDisregardedEntityQuestionnaireInfoDocument = gql`
    query GetDisregardedEntityQuestionnaireInfo {
  unifiedPortalAccounts(
    filters: {withAdmin: true, disregardedEntityMissingQuestionnaire: true}
  ) {
    edges {
      node {
        ...DEQAccountInfo
      }
    }
  }
}
    ${DeqAccountInfoFragmentDoc}`;

/**
 * __useGetDisregardedEntityQuestionnaireInfoQuery__
 *
 * To run a query within a React component, call `useGetDisregardedEntityQuestionnaireInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisregardedEntityQuestionnaireInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisregardedEntityQuestionnaireInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDisregardedEntityQuestionnaireInfoQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQuery, GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQuery, GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQueryVariables>(GetDisregardedEntityQuestionnaireInfoDocument, options);
      }
export function useGetDisregardedEntityQuestionnaireInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQuery, GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQuery, GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQueryVariables>(GetDisregardedEntityQuestionnaireInfoDocument, options);
        }
// @ts-ignore
export function useGetDisregardedEntityQuestionnaireInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQuery, GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQuery, GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQueryVariables>;
export function useGetDisregardedEntityQuestionnaireInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQuery, GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQuery | undefined, GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQueryVariables>;
export function useGetDisregardedEntityQuestionnaireInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQuery, GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQuery, GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQueryVariables>(GetDisregardedEntityQuestionnaireInfoDocument, options);
        }
export type GetDisregardedEntityQuestionnaireInfoQueryHookResult = ReturnType<typeof useGetDisregardedEntityQuestionnaireInfoQuery>;
export type GetDisregardedEntityQuestionnaireInfoLazyQueryHookResult = ReturnType<typeof useGetDisregardedEntityQuestionnaireInfoLazyQuery>;
export type GetDisregardedEntityQuestionnaireInfoSuspenseQueryHookResult = ReturnType<typeof useGetDisregardedEntityQuestionnaireInfoSuspenseQuery>;
export type GetDisregardedEntityQuestionnaireInfoQueryResult = Apollo.QueryResult<GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQuery, GraphqlTypes.GetDisregardedEntityQuestionnaireInfoQueryVariables>;
export const GetESignatureLpSignerGlobalDocument = gql`
    query GetESignatureLpSignerGlobal($id: ID!) {
  eSignatureLpSigner(id: $id) {
    id
    recipientView {
      url
    }
  }
}
    `;

/**
 * __useGetESignatureLpSignerGlobalQuery__
 *
 * To run a query within a React component, call `useGetESignatureLpSignerGlobalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetESignatureLpSignerGlobalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetESignatureLpSignerGlobalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetESignatureLpSignerGlobalQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetESignatureLpSignerGlobalQuery, GraphqlTypes.GetESignatureLpSignerGlobalQueryVariables> & ({ variables: GraphqlTypes.GetESignatureLpSignerGlobalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetESignatureLpSignerGlobalQuery, GraphqlTypes.GetESignatureLpSignerGlobalQueryVariables>(GetESignatureLpSignerGlobalDocument, options);
      }
export function useGetESignatureLpSignerGlobalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetESignatureLpSignerGlobalQuery, GraphqlTypes.GetESignatureLpSignerGlobalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetESignatureLpSignerGlobalQuery, GraphqlTypes.GetESignatureLpSignerGlobalQueryVariables>(GetESignatureLpSignerGlobalDocument, options);
        }
// @ts-ignore
export function useGetESignatureLpSignerGlobalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureLpSignerGlobalQuery, GraphqlTypes.GetESignatureLpSignerGlobalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureLpSignerGlobalQuery, GraphqlTypes.GetESignatureLpSignerGlobalQueryVariables>;
export function useGetESignatureLpSignerGlobalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureLpSignerGlobalQuery, GraphqlTypes.GetESignatureLpSignerGlobalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureLpSignerGlobalQuery | undefined, GraphqlTypes.GetESignatureLpSignerGlobalQueryVariables>;
export function useGetESignatureLpSignerGlobalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureLpSignerGlobalQuery, GraphqlTypes.GetESignatureLpSignerGlobalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetESignatureLpSignerGlobalQuery, GraphqlTypes.GetESignatureLpSignerGlobalQueryVariables>(GetESignatureLpSignerGlobalDocument, options);
        }
export type GetESignatureLpSignerGlobalQueryHookResult = ReturnType<typeof useGetESignatureLpSignerGlobalQuery>;
export type GetESignatureLpSignerGlobalLazyQueryHookResult = ReturnType<typeof useGetESignatureLpSignerGlobalLazyQuery>;
export type GetESignatureLpSignerGlobalSuspenseQueryHookResult = ReturnType<typeof useGetESignatureLpSignerGlobalSuspenseQuery>;
export type GetESignatureLpSignerGlobalQueryResult = Apollo.QueryResult<GraphqlTypes.GetESignatureLpSignerGlobalQuery, GraphqlTypes.GetESignatureLpSignerGlobalQueryVariables>;
export const GetESignatureLpSignerRequestDetailsGlobalDocument = gql`
    query GetESignatureLpSignerRequestDetailsGlobal($id: ID!) {
  eSignatureLpSigner(id: $id) {
    id
    eSignatureRequest {
      id
      soboUserId
    }
    docusignArenaId {
      docusignUserId
    }
  }
}
    `;

/**
 * __useGetESignatureLpSignerRequestDetailsGlobalQuery__
 *
 * To run a query within a React component, call `useGetESignatureLpSignerRequestDetailsGlobalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetESignatureLpSignerRequestDetailsGlobalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetESignatureLpSignerRequestDetailsGlobalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetESignatureLpSignerRequestDetailsGlobalQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQueryVariables> & ({ variables: GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQueryVariables>(GetESignatureLpSignerRequestDetailsGlobalDocument, options);
      }
export function useGetESignatureLpSignerRequestDetailsGlobalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQueryVariables>(GetESignatureLpSignerRequestDetailsGlobalDocument, options);
        }
// @ts-ignore
export function useGetESignatureLpSignerRequestDetailsGlobalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQueryVariables>;
export function useGetESignatureLpSignerRequestDetailsGlobalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQuery | undefined, GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQueryVariables>;
export function useGetESignatureLpSignerRequestDetailsGlobalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQueryVariables>(GetESignatureLpSignerRequestDetailsGlobalDocument, options);
        }
export type GetESignatureLpSignerRequestDetailsGlobalQueryHookResult = ReturnType<typeof useGetESignatureLpSignerRequestDetailsGlobalQuery>;
export type GetESignatureLpSignerRequestDetailsGlobalLazyQueryHookResult = ReturnType<typeof useGetESignatureLpSignerRequestDetailsGlobalLazyQuery>;
export type GetESignatureLpSignerRequestDetailsGlobalSuspenseQueryHookResult = ReturnType<typeof useGetESignatureLpSignerRequestDetailsGlobalSuspenseQuery>;
export type GetESignatureLpSignerRequestDetailsGlobalQueryResult = Apollo.QueryResult<GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQuery, GraphqlTypes.GetESignatureLpSignerRequestDetailsGlobalQueryVariables>;
export const PortfolioCardGetTotalsByCurrencyDocument = gql`
    query PortfolioCardGetTotalsByCurrency($arenaId: ID!, $status: PositionEntityStatus!, $normalizeTo: CurrencyCode) {
  managerArena(id: $arenaId) {
    hideCashFlowBarChartInPortal
    transactionTotalsByCurrency(status: $status, normalizeTo: $normalizeTo) {
      currency {
        code
        fullName
      }
      transactionTotals {
        positionCount
        accountValue {
          monies
        }
        amountCommitted {
          monies
        }
        lifetimeAmountDistributed {
          monies
        }
        lifetimeCapitalContributed {
          monies
        }
      }
    }
  }
}
    `;

/**
 * __usePortfolioCardGetTotalsByCurrencyQuery__
 *
 * To run a query within a React component, call `usePortfolioCardGetTotalsByCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfolioCardGetTotalsByCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfolioCardGetTotalsByCurrencyQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      status: // value for 'status'
 *      normalizeTo: // value for 'normalizeTo'
 *   },
 * });
 */
export function usePortfolioCardGetTotalsByCurrencyQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.PortfolioCardGetTotalsByCurrencyQuery, GraphqlTypes.PortfolioCardGetTotalsByCurrencyQueryVariables> & ({ variables: GraphqlTypes.PortfolioCardGetTotalsByCurrencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.PortfolioCardGetTotalsByCurrencyQuery, GraphqlTypes.PortfolioCardGetTotalsByCurrencyQueryVariables>(PortfolioCardGetTotalsByCurrencyDocument, options);
      }
export function usePortfolioCardGetTotalsByCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.PortfolioCardGetTotalsByCurrencyQuery, GraphqlTypes.PortfolioCardGetTotalsByCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.PortfolioCardGetTotalsByCurrencyQuery, GraphqlTypes.PortfolioCardGetTotalsByCurrencyQueryVariables>(PortfolioCardGetTotalsByCurrencyDocument, options);
        }
// @ts-ignore
export function usePortfolioCardGetTotalsByCurrencySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.PortfolioCardGetTotalsByCurrencyQuery, GraphqlTypes.PortfolioCardGetTotalsByCurrencyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PortfolioCardGetTotalsByCurrencyQuery, GraphqlTypes.PortfolioCardGetTotalsByCurrencyQueryVariables>;
export function usePortfolioCardGetTotalsByCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PortfolioCardGetTotalsByCurrencyQuery, GraphqlTypes.PortfolioCardGetTotalsByCurrencyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PortfolioCardGetTotalsByCurrencyQuery | undefined, GraphqlTypes.PortfolioCardGetTotalsByCurrencyQueryVariables>;
export function usePortfolioCardGetTotalsByCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PortfolioCardGetTotalsByCurrencyQuery, GraphqlTypes.PortfolioCardGetTotalsByCurrencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.PortfolioCardGetTotalsByCurrencyQuery, GraphqlTypes.PortfolioCardGetTotalsByCurrencyQueryVariables>(PortfolioCardGetTotalsByCurrencyDocument, options);
        }
export type PortfolioCardGetTotalsByCurrencyQueryHookResult = ReturnType<typeof usePortfolioCardGetTotalsByCurrencyQuery>;
export type PortfolioCardGetTotalsByCurrencyLazyQueryHookResult = ReturnType<typeof usePortfolioCardGetTotalsByCurrencyLazyQuery>;
export type PortfolioCardGetTotalsByCurrencySuspenseQueryHookResult = ReturnType<typeof usePortfolioCardGetTotalsByCurrencySuspenseQuery>;
export type PortfolioCardGetTotalsByCurrencyQueryResult = Apollo.QueryResult<GraphqlTypes.PortfolioCardGetTotalsByCurrencyQuery, GraphqlTypes.PortfolioCardGetTotalsByCurrencyQueryVariables>;
export const CurrencySelectorGetArenaFlagDocument = gql`
    query CurrencySelectorGetArenaFlag($arenaDomain: String) {
  arenaFeatures(arenaDomain: $arenaDomain) {
    hasCurrencyConversion
  }
}
    `;

/**
 * __useCurrencySelectorGetArenaFlagQuery__
 *
 * To run a query within a React component, call `useCurrencySelectorGetArenaFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrencySelectorGetArenaFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrencySelectorGetArenaFlagQuery({
 *   variables: {
 *      arenaDomain: // value for 'arenaDomain'
 *   },
 * });
 */
export function useCurrencySelectorGetArenaFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.CurrencySelectorGetArenaFlagQuery, GraphqlTypes.CurrencySelectorGetArenaFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CurrencySelectorGetArenaFlagQuery, GraphqlTypes.CurrencySelectorGetArenaFlagQueryVariables>(CurrencySelectorGetArenaFlagDocument, options);
      }
export function useCurrencySelectorGetArenaFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CurrencySelectorGetArenaFlagQuery, GraphqlTypes.CurrencySelectorGetArenaFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CurrencySelectorGetArenaFlagQuery, GraphqlTypes.CurrencySelectorGetArenaFlagQueryVariables>(CurrencySelectorGetArenaFlagDocument, options);
        }
// @ts-ignore
export function useCurrencySelectorGetArenaFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrencySelectorGetArenaFlagQuery, GraphqlTypes.CurrencySelectorGetArenaFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CurrencySelectorGetArenaFlagQuery, GraphqlTypes.CurrencySelectorGetArenaFlagQueryVariables>;
export function useCurrencySelectorGetArenaFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrencySelectorGetArenaFlagQuery, GraphqlTypes.CurrencySelectorGetArenaFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CurrencySelectorGetArenaFlagQuery | undefined, GraphqlTypes.CurrencySelectorGetArenaFlagQueryVariables>;
export function useCurrencySelectorGetArenaFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrencySelectorGetArenaFlagQuery, GraphqlTypes.CurrencySelectorGetArenaFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CurrencySelectorGetArenaFlagQuery, GraphqlTypes.CurrencySelectorGetArenaFlagQueryVariables>(CurrencySelectorGetArenaFlagDocument, options);
        }
export type CurrencySelectorGetArenaFlagQueryHookResult = ReturnType<typeof useCurrencySelectorGetArenaFlagQuery>;
export type CurrencySelectorGetArenaFlagLazyQueryHookResult = ReturnType<typeof useCurrencySelectorGetArenaFlagLazyQuery>;
export type CurrencySelectorGetArenaFlagSuspenseQueryHookResult = ReturnType<typeof useCurrencySelectorGetArenaFlagSuspenseQuery>;
export type CurrencySelectorGetArenaFlagQueryResult = Apollo.QueryResult<GraphqlTypes.CurrencySelectorGetArenaFlagQuery, GraphqlTypes.CurrencySelectorGetArenaFlagQueryVariables>;
export const GetManagerArenaPortalHeroMetricsTitleDocument = gql`
    query GetManagerArenaPortalHeroMetricsTitle($arenaId: ID!) {
  managerArena(id: $arenaId) {
    portalHeroMetricsConfig {
      title
      isTitleVisible
      filterVisibility
      canFilterVisibility
    }
  }
}
    `;

/**
 * __useGetManagerArenaPortalHeroMetricsTitleQuery__
 *
 * To run a query within a React component, call `useGetManagerArenaPortalHeroMetricsTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerArenaPortalHeroMetricsTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerArenaPortalHeroMetricsTitleQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetManagerArenaPortalHeroMetricsTitleQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQueryVariables> & ({ variables: GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQueryVariables>(GetManagerArenaPortalHeroMetricsTitleDocument, options);
      }
export function useGetManagerArenaPortalHeroMetricsTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQueryVariables>(GetManagerArenaPortalHeroMetricsTitleDocument, options);
        }
// @ts-ignore
export function useGetManagerArenaPortalHeroMetricsTitleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQueryVariables>;
export function useGetManagerArenaPortalHeroMetricsTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQuery | undefined, GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQueryVariables>;
export function useGetManagerArenaPortalHeroMetricsTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQueryVariables>(GetManagerArenaPortalHeroMetricsTitleDocument, options);
        }
export type GetManagerArenaPortalHeroMetricsTitleQueryHookResult = ReturnType<typeof useGetManagerArenaPortalHeroMetricsTitleQuery>;
export type GetManagerArenaPortalHeroMetricsTitleLazyQueryHookResult = ReturnType<typeof useGetManagerArenaPortalHeroMetricsTitleLazyQuery>;
export type GetManagerArenaPortalHeroMetricsTitleSuspenseQueryHookResult = ReturnType<typeof useGetManagerArenaPortalHeroMetricsTitleSuspenseQuery>;
export type GetManagerArenaPortalHeroMetricsTitleQueryResult = Apollo.QueryResult<GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsTitleQueryVariables>;
export const GetManagerArenaPortalHeroMetricsDocument = gql`
    query GetManagerArenaPortalHeroMetrics($currency: CurrencyCode, $targetCurrency: CurrencyCode, $investmentFilter: InvestmentFilter, $arenaId: ID!) {
  managerArena(id: $arenaId) {
    portalHeroMetricsConfig {
      title
      isTitleVisible
      filterVisibility
      canFilterVisibility
      portalHeroMetricsFields {
        id
        fieldName
        fieldType
        metricValue(
          currency: $currency
          investmentFilter: $investmentFilter
          targetCurrency: $targetCurrency
        )
        extensionField {
          extensionFieldTypeId
        }
        contactInvestmentsFieldName
      }
    }
  }
}
    `;

/**
 * __useGetManagerArenaPortalHeroMetricsQuery__
 *
 * To run a query within a React component, call `useGetManagerArenaPortalHeroMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerArenaPortalHeroMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerArenaPortalHeroMetricsQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *      targetCurrency: // value for 'targetCurrency'
 *      investmentFilter: // value for 'investmentFilter'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetManagerArenaPortalHeroMetricsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetManagerArenaPortalHeroMetricsQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsQueryVariables> & ({ variables: GraphqlTypes.GetManagerArenaPortalHeroMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetManagerArenaPortalHeroMetricsQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsQueryVariables>(GetManagerArenaPortalHeroMetricsDocument, options);
      }
export function useGetManagerArenaPortalHeroMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetManagerArenaPortalHeroMetricsQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetManagerArenaPortalHeroMetricsQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsQueryVariables>(GetManagerArenaPortalHeroMetricsDocument, options);
        }
// @ts-ignore
export function useGetManagerArenaPortalHeroMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerArenaPortalHeroMetricsQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManagerArenaPortalHeroMetricsQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsQueryVariables>;
export function useGetManagerArenaPortalHeroMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerArenaPortalHeroMetricsQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManagerArenaPortalHeroMetricsQuery | undefined, GraphqlTypes.GetManagerArenaPortalHeroMetricsQueryVariables>;
export function useGetManagerArenaPortalHeroMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerArenaPortalHeroMetricsQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetManagerArenaPortalHeroMetricsQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsQueryVariables>(GetManagerArenaPortalHeroMetricsDocument, options);
        }
export type GetManagerArenaPortalHeroMetricsQueryHookResult = ReturnType<typeof useGetManagerArenaPortalHeroMetricsQuery>;
export type GetManagerArenaPortalHeroMetricsLazyQueryHookResult = ReturnType<typeof useGetManagerArenaPortalHeroMetricsLazyQuery>;
export type GetManagerArenaPortalHeroMetricsSuspenseQueryHookResult = ReturnType<typeof useGetManagerArenaPortalHeroMetricsSuspenseQuery>;
export type GetManagerArenaPortalHeroMetricsQueryResult = Apollo.QueryResult<GraphqlTypes.GetManagerArenaPortalHeroMetricsQuery, GraphqlTypes.GetManagerArenaPortalHeroMetricsQueryVariables>;
export const GetSingleManagerTotalsDocument = gql`
    query GetSingleManagerTotals($arenaId: ID!, $status: PositionEntityStatus) {
  managerArena(id: $arenaId) {
    id
    hideCashFlowBarChartInPortal
    transactionTotals(status: $status) {
      amountCommitted {
        monies
      }
      lifetimeCapitalContributed {
        monies
      }
      lifetimeAmountDistributed {
        monies
      }
      accountValue {
        monies
      }
      positionCount
    }
  }
}
    `;

/**
 * __useGetSingleManagerTotalsQuery__
 *
 * To run a query within a React component, call `useGetSingleManagerTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleManagerTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleManagerTotalsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetSingleManagerTotalsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSingleManagerTotalsQuery, GraphqlTypes.GetSingleManagerTotalsQueryVariables> & ({ variables: GraphqlTypes.GetSingleManagerTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSingleManagerTotalsQuery, GraphqlTypes.GetSingleManagerTotalsQueryVariables>(GetSingleManagerTotalsDocument, options);
      }
export function useGetSingleManagerTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSingleManagerTotalsQuery, GraphqlTypes.GetSingleManagerTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSingleManagerTotalsQuery, GraphqlTypes.GetSingleManagerTotalsQueryVariables>(GetSingleManagerTotalsDocument, options);
        }
// @ts-ignore
export function useGetSingleManagerTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerTotalsQuery, GraphqlTypes.GetSingleManagerTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleManagerTotalsQuery, GraphqlTypes.GetSingleManagerTotalsQueryVariables>;
export function useGetSingleManagerTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerTotalsQuery, GraphqlTypes.GetSingleManagerTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleManagerTotalsQuery | undefined, GraphqlTypes.GetSingleManagerTotalsQueryVariables>;
export function useGetSingleManagerTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerTotalsQuery, GraphqlTypes.GetSingleManagerTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSingleManagerTotalsQuery, GraphqlTypes.GetSingleManagerTotalsQueryVariables>(GetSingleManagerTotalsDocument, options);
        }
export type GetSingleManagerTotalsQueryHookResult = ReturnType<typeof useGetSingleManagerTotalsQuery>;
export type GetSingleManagerTotalsLazyQueryHookResult = ReturnType<typeof useGetSingleManagerTotalsLazyQuery>;
export type GetSingleManagerTotalsSuspenseQueryHookResult = ReturnType<typeof useGetSingleManagerTotalsSuspenseQuery>;
export type GetSingleManagerTotalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetSingleManagerTotalsQuery, GraphqlTypes.GetSingleManagerTotalsQueryVariables>;
export const GetSingleManagerPositionsDocument = gql`
    query GetSingleManagerPositions($arenaId: ID!, $limit: Int, $activeOnly: Boolean = true, $width: Int, $height: Int, $options: Int, $currency: CurrencyCode, $calculateSummaryTransactions: Boolean = true, $restrictMetricsBalancesToAsOfDate: Boolean = true, $status: PositionEntityStatus, $includePositionCustomFields: Boolean = false, $includeAccountCustomFields: Boolean = false, $includeEntityCustomFields: Boolean = false, $needUnfundedCommitment: Boolean = false, $needLifetimeCapitalOut: Boolean = false, $needInvestedEquityBalance: Boolean = false, $needLifetimeAmountCalled: Boolean = false, $needLifetimeAmountCalledAgainstCommitment: Boolean = false, $needTotalOutstandingCapitalCalled: Boolean = false, $needLifetimeCapitalContributedAgainstCommitment: Boolean = false, $needLifetimeAmountRecalled: Boolean = false, $needContributionsExcessCommitment: Boolean = false, $needNavBalance: Boolean = false, $needAmountRecallable: Boolean = false, $needRemainingRecallable: Boolean = false, $needLifetimeAmountReturned: Boolean = false, $needLifetimeAmountPassedThrough: Boolean = false, $needCapitalAccountBalance: Boolean = false, $needLifetimeWithheld: Boolean = false, $needUnitCount: Boolean = false, $needDpi: Boolean = false, $needRvpi: Boolean = false, $needTvpi: Boolean = false) {
  managerArena(id: $arenaId) {
    id
    logoBackgroundColor
    useBgColorForPortalIcons
    positions(
      first: $limit
      activeOnly: $activeOnly
      status: $status
      calculateSummaryTransactions: $calculateSummaryTransactions
    ) {
      edges {
        node {
          id
          isCompleted
          percentOwnership
          unitCountOwnership
          account {
            id
            name
            extensionFields @include(if: $includeAccountCustomFields) {
              ...InvestmentExtensionFields
            }
          }
          ownershipUnit {
            precisionPortal
            calculationValueMetric {
              id
            }
          }
          performanceMetrics {
            irr
            irr1yr
            irr3yr
            irr5yr
            irr10yr
            irrEstimated
            cocYield
            dpi @include(if: $needDpi)
            rvpi @include(if: $needRvpi)
            tvpi @include(if: $needTvpi)
          }
          transactionTotals(
            restrictMetricsBalancesToAsOfDate: $restrictMetricsBalancesToAsOfDate
            currency: $currency
          ) {
            ...HomePageInvestmentPositionTotals
          }
          pendingCapitalCalls {
            id
            batch {
              effectiveDate
              entity {
                name
              }
            }
          }
          investmentEntity {
            id
            name
            isOperatingCompany
            extensionFields @include(if: $includeEntityCustomFields) {
              ...InvestmentExtensionFields
            }
            thumbnail {
              photoUrl(width: $width, height: $height, option: $options)
            }
          }
          investorGroup {
            id
            name
            latestUnitValues {
              id
              unitValueMetric {
                id
              }
              calculatedPricePerUnit {
                monies
              }
            }
          }
          ...PositionExtensionFields @include(if: $includePositionCustomFields)
        }
      }
    }
    settings {
      reportingValueBasis
      hideValuesInLpPortal
    }
  }
}
    ${InvestmentExtensionFieldsFragmentDoc}
${HomePageInvestmentPositionTotalsFragmentDoc}
${PositionExtensionFieldsFragmentDoc}`;

/**
 * __useGetSingleManagerPositionsQuery__
 *
 * To run a query within a React component, call `useGetSingleManagerPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleManagerPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleManagerPositionsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      limit: // value for 'limit'
 *      activeOnly: // value for 'activeOnly'
 *      width: // value for 'width'
 *      height: // value for 'height'
 *      options: // value for 'options'
 *      currency: // value for 'currency'
 *      calculateSummaryTransactions: // value for 'calculateSummaryTransactions'
 *      restrictMetricsBalancesToAsOfDate: // value for 'restrictMetricsBalancesToAsOfDate'
 *      status: // value for 'status'
 *      includePositionCustomFields: // value for 'includePositionCustomFields'
 *      includeAccountCustomFields: // value for 'includeAccountCustomFields'
 *      includeEntityCustomFields: // value for 'includeEntityCustomFields'
 *      needUnfundedCommitment: // value for 'needUnfundedCommitment'
 *      needLifetimeCapitalOut: // value for 'needLifetimeCapitalOut'
 *      needInvestedEquityBalance: // value for 'needInvestedEquityBalance'
 *      needLifetimeAmountCalled: // value for 'needLifetimeAmountCalled'
 *      needLifetimeAmountCalledAgainstCommitment: // value for 'needLifetimeAmountCalledAgainstCommitment'
 *      needTotalOutstandingCapitalCalled: // value for 'needTotalOutstandingCapitalCalled'
 *      needLifetimeCapitalContributedAgainstCommitment: // value for 'needLifetimeCapitalContributedAgainstCommitment'
 *      needLifetimeAmountRecalled: // value for 'needLifetimeAmountRecalled'
 *      needContributionsExcessCommitment: // value for 'needContributionsExcessCommitment'
 *      needNavBalance: // value for 'needNavBalance'
 *      needAmountRecallable: // value for 'needAmountRecallable'
 *      needRemainingRecallable: // value for 'needRemainingRecallable'
 *      needLifetimeAmountReturned: // value for 'needLifetimeAmountReturned'
 *      needLifetimeAmountPassedThrough: // value for 'needLifetimeAmountPassedThrough'
 *      needCapitalAccountBalance: // value for 'needCapitalAccountBalance'
 *      needLifetimeWithheld: // value for 'needLifetimeWithheld'
 *      needUnitCount: // value for 'needUnitCount'
 *      needDpi: // value for 'needDpi'
 *      needRvpi: // value for 'needRvpi'
 *      needTvpi: // value for 'needTvpi'
 *   },
 * });
 */
export function useGetSingleManagerPositionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSingleManagerPositionsQuery, GraphqlTypes.GetSingleManagerPositionsQueryVariables> & ({ variables: GraphqlTypes.GetSingleManagerPositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSingleManagerPositionsQuery, GraphqlTypes.GetSingleManagerPositionsQueryVariables>(GetSingleManagerPositionsDocument, options);
      }
export function useGetSingleManagerPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSingleManagerPositionsQuery, GraphqlTypes.GetSingleManagerPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSingleManagerPositionsQuery, GraphqlTypes.GetSingleManagerPositionsQueryVariables>(GetSingleManagerPositionsDocument, options);
        }
// @ts-ignore
export function useGetSingleManagerPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerPositionsQuery, GraphqlTypes.GetSingleManagerPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleManagerPositionsQuery, GraphqlTypes.GetSingleManagerPositionsQueryVariables>;
export function useGetSingleManagerPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerPositionsQuery, GraphqlTypes.GetSingleManagerPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleManagerPositionsQuery | undefined, GraphqlTypes.GetSingleManagerPositionsQueryVariables>;
export function useGetSingleManagerPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerPositionsQuery, GraphqlTypes.GetSingleManagerPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSingleManagerPositionsQuery, GraphqlTypes.GetSingleManagerPositionsQueryVariables>(GetSingleManagerPositionsDocument, options);
        }
export type GetSingleManagerPositionsQueryHookResult = ReturnType<typeof useGetSingleManagerPositionsQuery>;
export type GetSingleManagerPositionsLazyQueryHookResult = ReturnType<typeof useGetSingleManagerPositionsLazyQuery>;
export type GetSingleManagerPositionsSuspenseQueryHookResult = ReturnType<typeof useGetSingleManagerPositionsSuspenseQuery>;
export type GetSingleManagerPositionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetSingleManagerPositionsQuery, GraphqlTypes.GetSingleManagerPositionsQueryVariables>;
export const GetManagerDetailsDocument = gql`
    query GetManagerDetails($arenaId: ID!) {
  managerArena(id: $arenaId) {
    id
    aboutText
    combinedContactDetails {
      phoneNumbers {
        value
        label
        id
      }
      emailAddresses {
        value
        label
        id
      }
      addresses {
        value
        label
        id
      }
      websiteUrls {
        value
        label
        id
      }
      customMetrics {
        value
        label
        id
      }
    }
    contactAddress
    contactEmail
    contactPhone
    websiteUrl
    settings {
      portfolioOverviewDisclosureText
      reportingValueBasis
    }
    accentBackgroundColor
    logoWideUrl
  }
}
    `;

/**
 * __useGetManagerDetailsQuery__
 *
 * To run a query within a React component, call `useGetManagerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerDetailsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetManagerDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetManagerDetailsQuery, GraphqlTypes.GetManagerDetailsQueryVariables> & ({ variables: GraphqlTypes.GetManagerDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetManagerDetailsQuery, GraphqlTypes.GetManagerDetailsQueryVariables>(GetManagerDetailsDocument, options);
      }
export function useGetManagerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetManagerDetailsQuery, GraphqlTypes.GetManagerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetManagerDetailsQuery, GraphqlTypes.GetManagerDetailsQueryVariables>(GetManagerDetailsDocument, options);
        }
// @ts-ignore
export function useGetManagerDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerDetailsQuery, GraphqlTypes.GetManagerDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManagerDetailsQuery, GraphqlTypes.GetManagerDetailsQueryVariables>;
export function useGetManagerDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerDetailsQuery, GraphqlTypes.GetManagerDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManagerDetailsQuery | undefined, GraphqlTypes.GetManagerDetailsQueryVariables>;
export function useGetManagerDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerDetailsQuery, GraphqlTypes.GetManagerDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetManagerDetailsQuery, GraphqlTypes.GetManagerDetailsQueryVariables>(GetManagerDetailsDocument, options);
        }
export type GetManagerDetailsQueryHookResult = ReturnType<typeof useGetManagerDetailsQuery>;
export type GetManagerDetailsLazyQueryHookResult = ReturnType<typeof useGetManagerDetailsLazyQuery>;
export type GetManagerDetailsSuspenseQueryHookResult = ReturnType<typeof useGetManagerDetailsSuspenseQuery>;
export type GetManagerDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetManagerDetailsQuery, GraphqlTypes.GetManagerDetailsQueryVariables>;
export const NeedsDisregardedEntityBannerDocument = gql`
    query NeedsDisregardedEntityBanner($arenaId: ID!) {
  needsDisregardedEntityBanner(arenaId: $arenaId)
}
    `;

/**
 * __useNeedsDisregardedEntityBannerQuery__
 *
 * To run a query within a React component, call `useNeedsDisregardedEntityBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useNeedsDisregardedEntityBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNeedsDisregardedEntityBannerQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useNeedsDisregardedEntityBannerQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.NeedsDisregardedEntityBannerQuery, GraphqlTypes.NeedsDisregardedEntityBannerQueryVariables> & ({ variables: GraphqlTypes.NeedsDisregardedEntityBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.NeedsDisregardedEntityBannerQuery, GraphqlTypes.NeedsDisregardedEntityBannerQueryVariables>(NeedsDisregardedEntityBannerDocument, options);
      }
export function useNeedsDisregardedEntityBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.NeedsDisregardedEntityBannerQuery, GraphqlTypes.NeedsDisregardedEntityBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.NeedsDisregardedEntityBannerQuery, GraphqlTypes.NeedsDisregardedEntityBannerQueryVariables>(NeedsDisregardedEntityBannerDocument, options);
        }
// @ts-ignore
export function useNeedsDisregardedEntityBannerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.NeedsDisregardedEntityBannerQuery, GraphqlTypes.NeedsDisregardedEntityBannerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.NeedsDisregardedEntityBannerQuery, GraphqlTypes.NeedsDisregardedEntityBannerQueryVariables>;
export function useNeedsDisregardedEntityBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.NeedsDisregardedEntityBannerQuery, GraphqlTypes.NeedsDisregardedEntityBannerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.NeedsDisregardedEntityBannerQuery | undefined, GraphqlTypes.NeedsDisregardedEntityBannerQueryVariables>;
export function useNeedsDisregardedEntityBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.NeedsDisregardedEntityBannerQuery, GraphqlTypes.NeedsDisregardedEntityBannerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.NeedsDisregardedEntityBannerQuery, GraphqlTypes.NeedsDisregardedEntityBannerQueryVariables>(NeedsDisregardedEntityBannerDocument, options);
        }
export type NeedsDisregardedEntityBannerQueryHookResult = ReturnType<typeof useNeedsDisregardedEntityBannerQuery>;
export type NeedsDisregardedEntityBannerLazyQueryHookResult = ReturnType<typeof useNeedsDisregardedEntityBannerLazyQuery>;
export type NeedsDisregardedEntityBannerSuspenseQueryHookResult = ReturnType<typeof useNeedsDisregardedEntityBannerSuspenseQuery>;
export type NeedsDisregardedEntityBannerQueryResult = Apollo.QueryResult<GraphqlTypes.NeedsDisregardedEntityBannerQuery, GraphqlTypes.NeedsDisregardedEntityBannerQueryVariables>;
export const GetSingleManagerHeroImageDocument = gql`
    query GetSingleManagerHeroImage($arenaId: ID!) {
  managerArena(id: $arenaId) {
    id
    heroImageUrl
  }
}
    `;

/**
 * __useGetSingleManagerHeroImageQuery__
 *
 * To run a query within a React component, call `useGetSingleManagerHeroImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleManagerHeroImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleManagerHeroImageQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetSingleManagerHeroImageQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSingleManagerHeroImageQuery, GraphqlTypes.GetSingleManagerHeroImageQueryVariables> & ({ variables: GraphqlTypes.GetSingleManagerHeroImageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSingleManagerHeroImageQuery, GraphqlTypes.GetSingleManagerHeroImageQueryVariables>(GetSingleManagerHeroImageDocument, options);
      }
export function useGetSingleManagerHeroImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSingleManagerHeroImageQuery, GraphqlTypes.GetSingleManagerHeroImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSingleManagerHeroImageQuery, GraphqlTypes.GetSingleManagerHeroImageQueryVariables>(GetSingleManagerHeroImageDocument, options);
        }
// @ts-ignore
export function useGetSingleManagerHeroImageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerHeroImageQuery, GraphqlTypes.GetSingleManagerHeroImageQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleManagerHeroImageQuery, GraphqlTypes.GetSingleManagerHeroImageQueryVariables>;
export function useGetSingleManagerHeroImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerHeroImageQuery, GraphqlTypes.GetSingleManagerHeroImageQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleManagerHeroImageQuery | undefined, GraphqlTypes.GetSingleManagerHeroImageQueryVariables>;
export function useGetSingleManagerHeroImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerHeroImageQuery, GraphqlTypes.GetSingleManagerHeroImageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSingleManagerHeroImageQuery, GraphqlTypes.GetSingleManagerHeroImageQueryVariables>(GetSingleManagerHeroImageDocument, options);
        }
export type GetSingleManagerHeroImageQueryHookResult = ReturnType<typeof useGetSingleManagerHeroImageQuery>;
export type GetSingleManagerHeroImageLazyQueryHookResult = ReturnType<typeof useGetSingleManagerHeroImageLazyQuery>;
export type GetSingleManagerHeroImageSuspenseQueryHookResult = ReturnType<typeof useGetSingleManagerHeroImageSuspenseQuery>;
export type GetSingleManagerHeroImageQueryResult = Apollo.QueryResult<GraphqlTypes.GetSingleManagerHeroImageQuery, GraphqlTypes.GetSingleManagerHeroImageQueryVariables>;
export const GetRecentPostsDocument = gql`
    query GetRecentPosts($arenaId: ID!, $limit: Int) {
  posts(arenaId: $arenaId, limit: $limit) {
    id
    title
    topic
    publishingDate
    featuredImageUrl
  }
}
    `;

/**
 * __useGetRecentPostsQuery__
 *
 * To run a query within a React component, call `useGetRecentPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentPostsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRecentPostsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetRecentPostsQuery, GraphqlTypes.GetRecentPostsQueryVariables> & ({ variables: GraphqlTypes.GetRecentPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRecentPostsQuery, GraphqlTypes.GetRecentPostsQueryVariables>(GetRecentPostsDocument, options);
      }
export function useGetRecentPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRecentPostsQuery, GraphqlTypes.GetRecentPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRecentPostsQuery, GraphqlTypes.GetRecentPostsQueryVariables>(GetRecentPostsDocument, options);
        }
// @ts-ignore
export function useGetRecentPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecentPostsQuery, GraphqlTypes.GetRecentPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRecentPostsQuery, GraphqlTypes.GetRecentPostsQueryVariables>;
export function useGetRecentPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecentPostsQuery, GraphqlTypes.GetRecentPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRecentPostsQuery | undefined, GraphqlTypes.GetRecentPostsQueryVariables>;
export function useGetRecentPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecentPostsQuery, GraphqlTypes.GetRecentPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRecentPostsQuery, GraphqlTypes.GetRecentPostsQueryVariables>(GetRecentPostsDocument, options);
        }
export type GetRecentPostsQueryHookResult = ReturnType<typeof useGetRecentPostsQuery>;
export type GetRecentPostsLazyQueryHookResult = ReturnType<typeof useGetRecentPostsLazyQuery>;
export type GetRecentPostsSuspenseQueryHookResult = ReturnType<typeof useGetRecentPostsSuspenseQuery>;
export type GetRecentPostsQueryResult = Apollo.QueryResult<GraphqlTypes.GetRecentPostsQuery, GraphqlTypes.GetRecentPostsQueryVariables>;
export const GetDetailsForAssetsDocument = gql`
    query GetDetailsForAssets($assetIds: [ID]!, $timeSeriesTypeNames: [FieldName!]!) {
  assets(ids: $assetIds) {
    edges {
      node {
        id
        name
        isSold
        yearBuilt
        dateAcquired
        latestTimeSeries(timeSeriesTypeNames: $timeSeriesTypeNames) {
          asOfDate
          values {
            __typename
            label
            ...RiskProfileValue
            ...PercentLeasedValue
            ...NavValue
          }
        }
        productTypes {
          edges {
            node {
              id
              productType
              productSubtype
            }
          }
        }
        thumbnail {
          photoUrl(width: 96, height: 112, option: 4)
        }
        entity {
          id
          name
        }
      }
    }
  }
}
    ${RiskProfileValueFragmentDoc}
${PercentLeasedValueFragmentDoc}
${NavValueFragmentDoc}`;

/**
 * __useGetDetailsForAssetsQuery__
 *
 * To run a query within a React component, call `useGetDetailsForAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailsForAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailsForAssetsQuery({
 *   variables: {
 *      assetIds: // value for 'assetIds'
 *      timeSeriesTypeNames: // value for 'timeSeriesTypeNames'
 *   },
 * });
 */
export function useGetDetailsForAssetsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDetailsForAssetsQuery, GraphqlTypes.GetDetailsForAssetsQueryVariables> & ({ variables: GraphqlTypes.GetDetailsForAssetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDetailsForAssetsQuery, GraphqlTypes.GetDetailsForAssetsQueryVariables>(GetDetailsForAssetsDocument, options);
      }
export function useGetDetailsForAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDetailsForAssetsQuery, GraphqlTypes.GetDetailsForAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDetailsForAssetsQuery, GraphqlTypes.GetDetailsForAssetsQueryVariables>(GetDetailsForAssetsDocument, options);
        }
// @ts-ignore
export function useGetDetailsForAssetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDetailsForAssetsQuery, GraphqlTypes.GetDetailsForAssetsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDetailsForAssetsQuery, GraphqlTypes.GetDetailsForAssetsQueryVariables>;
export function useGetDetailsForAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDetailsForAssetsQuery, GraphqlTypes.GetDetailsForAssetsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDetailsForAssetsQuery | undefined, GraphqlTypes.GetDetailsForAssetsQueryVariables>;
export function useGetDetailsForAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDetailsForAssetsQuery, GraphqlTypes.GetDetailsForAssetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDetailsForAssetsQuery, GraphqlTypes.GetDetailsForAssetsQueryVariables>(GetDetailsForAssetsDocument, options);
        }
export type GetDetailsForAssetsQueryHookResult = ReturnType<typeof useGetDetailsForAssetsQuery>;
export type GetDetailsForAssetsLazyQueryHookResult = ReturnType<typeof useGetDetailsForAssetsLazyQuery>;
export type GetDetailsForAssetsSuspenseQueryHookResult = ReturnType<typeof useGetDetailsForAssetsSuspenseQuery>;
export type GetDetailsForAssetsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDetailsForAssetsQuery, GraphqlTypes.GetDetailsForAssetsQueryVariables>;
export const GetAllocationChartDataNewDocument = gql`
    query GetAllocationChartDataNew($filters: InvestmentFilters, $arenaId: ID!) {
  rootPositionInvestments(filters: $filters, arenaId: $arenaId) {
    id
    allocationChartData {
      productTypeChartData {
        label
        value
      }
      geoChartData {
        label
        value
      }
    }
  }
}
    `;

/**
 * __useGetAllocationChartDataNewQuery__
 *
 * To run a query within a React component, call `useGetAllocationChartDataNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllocationChartDataNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllocationChartDataNewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetAllocationChartDataNewQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAllocationChartDataNewQuery, GraphqlTypes.GetAllocationChartDataNewQueryVariables> & ({ variables: GraphqlTypes.GetAllocationChartDataNewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllocationChartDataNewQuery, GraphqlTypes.GetAllocationChartDataNewQueryVariables>(GetAllocationChartDataNewDocument, options);
      }
export function useGetAllocationChartDataNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllocationChartDataNewQuery, GraphqlTypes.GetAllocationChartDataNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllocationChartDataNewQuery, GraphqlTypes.GetAllocationChartDataNewQueryVariables>(GetAllocationChartDataNewDocument, options);
        }
// @ts-ignore
export function useGetAllocationChartDataNewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllocationChartDataNewQuery, GraphqlTypes.GetAllocationChartDataNewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllocationChartDataNewQuery, GraphqlTypes.GetAllocationChartDataNewQueryVariables>;
export function useGetAllocationChartDataNewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllocationChartDataNewQuery, GraphqlTypes.GetAllocationChartDataNewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllocationChartDataNewQuery | undefined, GraphqlTypes.GetAllocationChartDataNewQueryVariables>;
export function useGetAllocationChartDataNewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllocationChartDataNewQuery, GraphqlTypes.GetAllocationChartDataNewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllocationChartDataNewQuery, GraphqlTypes.GetAllocationChartDataNewQueryVariables>(GetAllocationChartDataNewDocument, options);
        }
export type GetAllocationChartDataNewQueryHookResult = ReturnType<typeof useGetAllocationChartDataNewQuery>;
export type GetAllocationChartDataNewLazyQueryHookResult = ReturnType<typeof useGetAllocationChartDataNewLazyQuery>;
export type GetAllocationChartDataNewSuspenseQueryHookResult = ReturnType<typeof useGetAllocationChartDataNewSuspenseQuery>;
export type GetAllocationChartDataNewQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllocationChartDataNewQuery, GraphqlTypes.GetAllocationChartDataNewQueryVariables>;
export const GetCashflowHistoryDataNewDocument = gql`
    query GetCashflowHistoryDataNew($filters: InvestmentFilters, $arenaId: ID!, $currency: CurrencyCode) {
  rootPositionInvestments(filters: $filters, arenaId: $arenaId) {
    id
    cashflowHistoryData(currency: $currency) {
      currency {
        ...CurrencyFields
      }
      ...CashFlowHistoryData
    }
  }
}
    ${CurrencyFieldsFragmentDoc}
${CashFlowHistoryDataFragmentDoc}`;

/**
 * __useGetCashflowHistoryDataNewQuery__
 *
 * To run a query within a React component, call `useGetCashflowHistoryDataNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashflowHistoryDataNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashflowHistoryDataNewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      arenaId: // value for 'arenaId'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetCashflowHistoryDataNewQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCashflowHistoryDataNewQuery, GraphqlTypes.GetCashflowHistoryDataNewQueryVariables> & ({ variables: GraphqlTypes.GetCashflowHistoryDataNewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCashflowHistoryDataNewQuery, GraphqlTypes.GetCashflowHistoryDataNewQueryVariables>(GetCashflowHistoryDataNewDocument, options);
      }
export function useGetCashflowHistoryDataNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCashflowHistoryDataNewQuery, GraphqlTypes.GetCashflowHistoryDataNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCashflowHistoryDataNewQuery, GraphqlTypes.GetCashflowHistoryDataNewQueryVariables>(GetCashflowHistoryDataNewDocument, options);
        }
// @ts-ignore
export function useGetCashflowHistoryDataNewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCashflowHistoryDataNewQuery, GraphqlTypes.GetCashflowHistoryDataNewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCashflowHistoryDataNewQuery, GraphqlTypes.GetCashflowHistoryDataNewQueryVariables>;
export function useGetCashflowHistoryDataNewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCashflowHistoryDataNewQuery, GraphqlTypes.GetCashflowHistoryDataNewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCashflowHistoryDataNewQuery | undefined, GraphqlTypes.GetCashflowHistoryDataNewQueryVariables>;
export function useGetCashflowHistoryDataNewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCashflowHistoryDataNewQuery, GraphqlTypes.GetCashflowHistoryDataNewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCashflowHistoryDataNewQuery, GraphqlTypes.GetCashflowHistoryDataNewQueryVariables>(GetCashflowHistoryDataNewDocument, options);
        }
export type GetCashflowHistoryDataNewQueryHookResult = ReturnType<typeof useGetCashflowHistoryDataNewQuery>;
export type GetCashflowHistoryDataNewLazyQueryHookResult = ReturnType<typeof useGetCashflowHistoryDataNewLazyQuery>;
export type GetCashflowHistoryDataNewSuspenseQueryHookResult = ReturnType<typeof useGetCashflowHistoryDataNewSuspenseQuery>;
export type GetCashflowHistoryDataNewQueryResult = Apollo.QueryResult<GraphqlTypes.GetCashflowHistoryDataNewQuery, GraphqlTypes.GetCashflowHistoryDataNewQueryVariables>;
export const DownloadTransactionsPortalDocument = gql`
    mutation DownloadTransactionsPortal($includeEntityTotals: Boolean!, $isConsolidated: Boolean, $isXlsx: Boolean, $startDate: Date, $endDate: Date, $headers: [String!]!, $filters: InvestmentFilters, $arenaId: ID) {
  portalTransactionsOps {
    downloadTransactionsPortal(
      includeEntityTotals: $includeEntityTotals
      isConsolidated: $isConsolidated
      isXlsx: $isXlsx
      startDate: $startDate
      endDate: $endDate
      headers: $headers
      filters: $filters
      managerArenaId: $arenaId
    ) {
      job {
        id
      }
    }
  }
}
    `;
export type DownloadTransactionsPortalMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadTransactionsPortalMutation, GraphqlTypes.DownloadTransactionsPortalMutationVariables>;

/**
 * __useDownloadTransactionsPortalMutation__
 *
 * To run a mutation, you first call `useDownloadTransactionsPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadTransactionsPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadTransactionsPortalMutation, { data, loading, error }] = useDownloadTransactionsPortalMutation({
 *   variables: {
 *      includeEntityTotals: // value for 'includeEntityTotals'
 *      isConsolidated: // value for 'isConsolidated'
 *      isXlsx: // value for 'isXlsx'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      headers: // value for 'headers'
 *      filters: // value for 'filters'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useDownloadTransactionsPortalMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadTransactionsPortalMutation, GraphqlTypes.DownloadTransactionsPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadTransactionsPortalMutation, GraphqlTypes.DownloadTransactionsPortalMutationVariables>(DownloadTransactionsPortalDocument, options);
      }
export type DownloadTransactionsPortalMutationHookResult = ReturnType<typeof useDownloadTransactionsPortalMutation>;
export type DownloadTransactionsPortalMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadTransactionsPortalMutation>;
export type DownloadTransactionsPortalMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadTransactionsPortalMutation, GraphqlTypes.DownloadTransactionsPortalMutationVariables>;
export const DownloadInvestmentsPortalDocument = gql`
    mutation DownloadInvestmentsPortal($headers: [String!]!, $filters: InvestmentFilters, $arenaId: ID) {
  portalInvestmentsOps {
    downloadInvestmentsPortal(
      headers: $headers
      filters: $filters
      managerArenaId: $arenaId
    ) {
      job {
        id
      }
    }
  }
}
    `;
export type DownloadInvestmentsPortalMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadInvestmentsPortalMutation, GraphqlTypes.DownloadInvestmentsPortalMutationVariables>;

/**
 * __useDownloadInvestmentsPortalMutation__
 *
 * To run a mutation, you first call `useDownloadInvestmentsPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadInvestmentsPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadInvestmentsPortalMutation, { data, loading, error }] = useDownloadInvestmentsPortalMutation({
 *   variables: {
 *      headers: // value for 'headers'
 *      filters: // value for 'filters'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useDownloadInvestmentsPortalMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadInvestmentsPortalMutation, GraphqlTypes.DownloadInvestmentsPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadInvestmentsPortalMutation, GraphqlTypes.DownloadInvestmentsPortalMutationVariables>(DownloadInvestmentsPortalDocument, options);
      }
export type DownloadInvestmentsPortalMutationHookResult = ReturnType<typeof useDownloadInvestmentsPortalMutation>;
export type DownloadInvestmentsPortalMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadInvestmentsPortalMutation>;
export type DownloadInvestmentsPortalMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadInvestmentsPortalMutation, GraphqlTypes.DownloadInvestmentsPortalMutationVariables>;
export const GetSingleManagerInvestmentFiltersDocument = gql`
    query GetSingleManagerInvestmentFilters($arenaId: ID!, $filters: InvestmentFilters) {
  rootPositionInvestments(arenaId: $arenaId, filters: $filters) {
    id
    filterOptions {
      accountNames
      statuses
    }
  }
}
    `;

/**
 * __useGetSingleManagerInvestmentFiltersQuery__
 *
 * To run a query within a React component, call `useGetSingleManagerInvestmentFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleManagerInvestmentFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleManagerInvestmentFiltersQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSingleManagerInvestmentFiltersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSingleManagerInvestmentFiltersQuery, GraphqlTypes.GetSingleManagerInvestmentFiltersQueryVariables> & ({ variables: GraphqlTypes.GetSingleManagerInvestmentFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSingleManagerInvestmentFiltersQuery, GraphqlTypes.GetSingleManagerInvestmentFiltersQueryVariables>(GetSingleManagerInvestmentFiltersDocument, options);
      }
export function useGetSingleManagerInvestmentFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSingleManagerInvestmentFiltersQuery, GraphqlTypes.GetSingleManagerInvestmentFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSingleManagerInvestmentFiltersQuery, GraphqlTypes.GetSingleManagerInvestmentFiltersQueryVariables>(GetSingleManagerInvestmentFiltersDocument, options);
        }
// @ts-ignore
export function useGetSingleManagerInvestmentFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerInvestmentFiltersQuery, GraphqlTypes.GetSingleManagerInvestmentFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleManagerInvestmentFiltersQuery, GraphqlTypes.GetSingleManagerInvestmentFiltersQueryVariables>;
export function useGetSingleManagerInvestmentFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerInvestmentFiltersQuery, GraphqlTypes.GetSingleManagerInvestmentFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleManagerInvestmentFiltersQuery | undefined, GraphqlTypes.GetSingleManagerInvestmentFiltersQueryVariables>;
export function useGetSingleManagerInvestmentFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerInvestmentFiltersQuery, GraphqlTypes.GetSingleManagerInvestmentFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSingleManagerInvestmentFiltersQuery, GraphqlTypes.GetSingleManagerInvestmentFiltersQueryVariables>(GetSingleManagerInvestmentFiltersDocument, options);
        }
export type GetSingleManagerInvestmentFiltersQueryHookResult = ReturnType<typeof useGetSingleManagerInvestmentFiltersQuery>;
export type GetSingleManagerInvestmentFiltersLazyQueryHookResult = ReturnType<typeof useGetSingleManagerInvestmentFiltersLazyQuery>;
export type GetSingleManagerInvestmentFiltersSuspenseQueryHookResult = ReturnType<typeof useGetSingleManagerInvestmentFiltersSuspenseQuery>;
export type GetSingleManagerInvestmentFiltersQueryResult = Apollo.QueryResult<GraphqlTypes.GetSingleManagerInvestmentFiltersQuery, GraphqlTypes.GetSingleManagerInvestmentFiltersQueryVariables>;
export const GetSingleManagerInvestmentsDocument = gql`
    query GetSingleManagerInvestments($filters: InvestmentFilters, $offset: Int, $limit: Int, $arenaId: ID, $orderBy: InvestmentOrder, $currency: CurrencyCode, $thumbnailWidth: Int = 100, $thumbnailHeight: Int = 100, $thumbnailOptions: Int = 4, $includePositionCustomFields: Boolean! = false, $includeEntityCustomFields: Boolean! = false, $includeAccountCustomFields: Boolean! = false, $includePositionTransactionTotals: Boolean! = false, $needAmountCommitted: Boolean! = false, $needLifetimeAmountCalled: Boolean! = false, $needLifetimeAmountCalledAgainstCommitment: Boolean! = false, $needTotalOutstandingCapitalCalled: Boolean! = false, $needLifetimeAmountDistributed: Boolean! = false, $needLifetimeCapitalContributed: Boolean! = false, $needLifetimeCapitalContributedAgainstCommitment: Boolean! = false, $needLifetimeAmountRecalled: Boolean! = false, $needContributionsExcessCommitment: Boolean! = false, $needLifetimeCapitalOut: Boolean! = false, $needNavBalance: Boolean! = false, $needLifetimeAmountReturned: Boolean! = false, $needLifetimeAmountPassedThrough: Boolean! = false, $needLifetimeWithheld: Boolean! = false, $needAmountRecallable: Boolean! = false, $needRemainingRecallable: Boolean! = false, $needAccountValue: Boolean! = false, $needCapitalAccountBalance: Boolean! = false, $needUnitCount: Boolean! = false) {
  investments(
    filters: $filters
    offset: $offset
    limit: $limit
    arenaId: $arenaId
    orderBy: $orderBy
    currency: $currency
  ) {
    hasMappableAssets
    totals {
      ...SingleManagerInvestmentCommonFields
      ...SingleManagerInvestmentTreeNodeFields
    }
    investments {
      ...SingleManagerInvestmentCommonFields
      ...SingleManagerInvestmentTreeNodeFields
      dealBreakdowns {
        dealName
        contributions {
          ...WalletFields
        }
        distributions {
          ...WalletFields
        }
        redemptions {
          ...WalletFields
        }
        value {
          ...WalletFields
        }
        customFields {
          fieldId
          name
          value
        }
        showStandardFields
        showCustomFields
      }
    }
    filteredPositionIds
    hasMore
    offset
    droppedColumns
  }
}
    ${SingleManagerInvestmentCommonFieldsFragmentDoc}
${SingleManagerInvestmentTreeNodeFieldsFragmentDoc}
${WalletFieldsFragmentDoc}`;

/**
 * __useGetSingleManagerInvestmentsQuery__
 *
 * To run a query within a React component, call `useGetSingleManagerInvestmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleManagerInvestmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleManagerInvestmentsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      arenaId: // value for 'arenaId'
 *      orderBy: // value for 'orderBy'
 *      currency: // value for 'currency'
 *      thumbnailWidth: // value for 'thumbnailWidth'
 *      thumbnailHeight: // value for 'thumbnailHeight'
 *      thumbnailOptions: // value for 'thumbnailOptions'
 *      includePositionCustomFields: // value for 'includePositionCustomFields'
 *      includeEntityCustomFields: // value for 'includeEntityCustomFields'
 *      includeAccountCustomFields: // value for 'includeAccountCustomFields'
 *      includePositionTransactionTotals: // value for 'includePositionTransactionTotals'
 *      needAmountCommitted: // value for 'needAmountCommitted'
 *      needLifetimeAmountCalled: // value for 'needLifetimeAmountCalled'
 *      needLifetimeAmountCalledAgainstCommitment: // value for 'needLifetimeAmountCalledAgainstCommitment'
 *      needTotalOutstandingCapitalCalled: // value for 'needTotalOutstandingCapitalCalled'
 *      needLifetimeAmountDistributed: // value for 'needLifetimeAmountDistributed'
 *      needLifetimeCapitalContributed: // value for 'needLifetimeCapitalContributed'
 *      needLifetimeCapitalContributedAgainstCommitment: // value for 'needLifetimeCapitalContributedAgainstCommitment'
 *      needLifetimeAmountRecalled: // value for 'needLifetimeAmountRecalled'
 *      needContributionsExcessCommitment: // value for 'needContributionsExcessCommitment'
 *      needLifetimeCapitalOut: // value for 'needLifetimeCapitalOut'
 *      needNavBalance: // value for 'needNavBalance'
 *      needLifetimeAmountReturned: // value for 'needLifetimeAmountReturned'
 *      needLifetimeAmountPassedThrough: // value for 'needLifetimeAmountPassedThrough'
 *      needLifetimeWithheld: // value for 'needLifetimeWithheld'
 *      needAmountRecallable: // value for 'needAmountRecallable'
 *      needRemainingRecallable: // value for 'needRemainingRecallable'
 *      needAccountValue: // value for 'needAccountValue'
 *      needCapitalAccountBalance: // value for 'needCapitalAccountBalance'
 *      needUnitCount: // value for 'needUnitCount'
 *   },
 * });
 */
export function useGetSingleManagerInvestmentsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetSingleManagerInvestmentsQuery, GraphqlTypes.GetSingleManagerInvestmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSingleManagerInvestmentsQuery, GraphqlTypes.GetSingleManagerInvestmentsQueryVariables>(GetSingleManagerInvestmentsDocument, options);
      }
export function useGetSingleManagerInvestmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSingleManagerInvestmentsQuery, GraphqlTypes.GetSingleManagerInvestmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSingleManagerInvestmentsQuery, GraphqlTypes.GetSingleManagerInvestmentsQueryVariables>(GetSingleManagerInvestmentsDocument, options);
        }
// @ts-ignore
export function useGetSingleManagerInvestmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerInvestmentsQuery, GraphqlTypes.GetSingleManagerInvestmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleManagerInvestmentsQuery, GraphqlTypes.GetSingleManagerInvestmentsQueryVariables>;
export function useGetSingleManagerInvestmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerInvestmentsQuery, GraphqlTypes.GetSingleManagerInvestmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleManagerInvestmentsQuery | undefined, GraphqlTypes.GetSingleManagerInvestmentsQueryVariables>;
export function useGetSingleManagerInvestmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerInvestmentsQuery, GraphqlTypes.GetSingleManagerInvestmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSingleManagerInvestmentsQuery, GraphqlTypes.GetSingleManagerInvestmentsQueryVariables>(GetSingleManagerInvestmentsDocument, options);
        }
export type GetSingleManagerInvestmentsQueryHookResult = ReturnType<typeof useGetSingleManagerInvestmentsQuery>;
export type GetSingleManagerInvestmentsLazyQueryHookResult = ReturnType<typeof useGetSingleManagerInvestmentsLazyQuery>;
export type GetSingleManagerInvestmentsSuspenseQueryHookResult = ReturnType<typeof useGetSingleManagerInvestmentsSuspenseQuery>;
export type GetSingleManagerInvestmentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetSingleManagerInvestmentsQuery, GraphqlTypes.GetSingleManagerInvestmentsQueryVariables>;
export const GetHideCashFlowBarChartInPortalDocument = gql`
    query GetHideCashFlowBarChartInPortal($arenaId: ID!) {
  managerArena(id: $arenaId) {
    hideCashFlowBarChartInPortal
  }
}
    `;

/**
 * __useGetHideCashFlowBarChartInPortalQuery__
 *
 * To run a query within a React component, call `useGetHideCashFlowBarChartInPortalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHideCashFlowBarChartInPortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHideCashFlowBarChartInPortalQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetHideCashFlowBarChartInPortalQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetHideCashFlowBarChartInPortalQuery, GraphqlTypes.GetHideCashFlowBarChartInPortalQueryVariables> & ({ variables: GraphqlTypes.GetHideCashFlowBarChartInPortalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetHideCashFlowBarChartInPortalQuery, GraphqlTypes.GetHideCashFlowBarChartInPortalQueryVariables>(GetHideCashFlowBarChartInPortalDocument, options);
      }
export function useGetHideCashFlowBarChartInPortalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetHideCashFlowBarChartInPortalQuery, GraphqlTypes.GetHideCashFlowBarChartInPortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetHideCashFlowBarChartInPortalQuery, GraphqlTypes.GetHideCashFlowBarChartInPortalQueryVariables>(GetHideCashFlowBarChartInPortalDocument, options);
        }
// @ts-ignore
export function useGetHideCashFlowBarChartInPortalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHideCashFlowBarChartInPortalQuery, GraphqlTypes.GetHideCashFlowBarChartInPortalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetHideCashFlowBarChartInPortalQuery, GraphqlTypes.GetHideCashFlowBarChartInPortalQueryVariables>;
export function useGetHideCashFlowBarChartInPortalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHideCashFlowBarChartInPortalQuery, GraphqlTypes.GetHideCashFlowBarChartInPortalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetHideCashFlowBarChartInPortalQuery | undefined, GraphqlTypes.GetHideCashFlowBarChartInPortalQueryVariables>;
export function useGetHideCashFlowBarChartInPortalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHideCashFlowBarChartInPortalQuery, GraphqlTypes.GetHideCashFlowBarChartInPortalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetHideCashFlowBarChartInPortalQuery, GraphqlTypes.GetHideCashFlowBarChartInPortalQueryVariables>(GetHideCashFlowBarChartInPortalDocument, options);
        }
export type GetHideCashFlowBarChartInPortalQueryHookResult = ReturnType<typeof useGetHideCashFlowBarChartInPortalQuery>;
export type GetHideCashFlowBarChartInPortalLazyQueryHookResult = ReturnType<typeof useGetHideCashFlowBarChartInPortalLazyQuery>;
export type GetHideCashFlowBarChartInPortalSuspenseQueryHookResult = ReturnType<typeof useGetHideCashFlowBarChartInPortalSuspenseQuery>;
export type GetHideCashFlowBarChartInPortalQueryResult = Apollo.QueryResult<GraphqlTypes.GetHideCashFlowBarChartInPortalQuery, GraphqlTypes.GetHideCashFlowBarChartInPortalQueryVariables>;
export const GetArenaSettingsDocument = gql`
    query GetArenaSettings($arenaId: ID!) {
  managerArena(id: $arenaId) {
    settings {
      reportingValueBasis
      hideValuesInLpPortal
    }
  }
}
    `;

/**
 * __useGetArenaSettingsQuery__
 *
 * To run a query within a React component, call `useGetArenaSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaSettingsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetArenaSettingsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetArenaSettingsQuery, GraphqlTypes.GetArenaSettingsQueryVariables> & ({ variables: GraphqlTypes.GetArenaSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaSettingsQuery, GraphqlTypes.GetArenaSettingsQueryVariables>(GetArenaSettingsDocument, options);
      }
export function useGetArenaSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaSettingsQuery, GraphqlTypes.GetArenaSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaSettingsQuery, GraphqlTypes.GetArenaSettingsQueryVariables>(GetArenaSettingsDocument, options);
        }
// @ts-ignore
export function useGetArenaSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaSettingsQuery, GraphqlTypes.GetArenaSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaSettingsQuery, GraphqlTypes.GetArenaSettingsQueryVariables>;
export function useGetArenaSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaSettingsQuery, GraphqlTypes.GetArenaSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaSettingsQuery | undefined, GraphqlTypes.GetArenaSettingsQueryVariables>;
export function useGetArenaSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaSettingsQuery, GraphqlTypes.GetArenaSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaSettingsQuery, GraphqlTypes.GetArenaSettingsQueryVariables>(GetArenaSettingsDocument, options);
        }
export type GetArenaSettingsQueryHookResult = ReturnType<typeof useGetArenaSettingsQuery>;
export type GetArenaSettingsLazyQueryHookResult = ReturnType<typeof useGetArenaSettingsLazyQuery>;
export type GetArenaSettingsSuspenseQueryHookResult = ReturnType<typeof useGetArenaSettingsSuspenseQuery>;
export type GetArenaSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaSettingsQuery, GraphqlTypes.GetArenaSettingsQueryVariables>;
export const UpdateOnboardingAnswersDocument = gql`
    mutation UpdateOnboardingAnswers($answersToOnboardingQuestions: [LpProfileAnswersInput!]!) {
  lpProfileMutationOps {
    submitLpProfileAnswers(lpProfileAnswers: $answersToOnboardingQuestions) {
      submittedQuestionResponses {
        globalUserId
        questionId
        answerOptionId
      }
      responseHistoryLogs {
        globalUserId
        questionId
        answerOptionId
      }
    }
  }
}
    `;
export type UpdateOnboardingAnswersMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateOnboardingAnswersMutation, GraphqlTypes.UpdateOnboardingAnswersMutationVariables>;

/**
 * __useUpdateOnboardingAnswersMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingAnswersMutation, { data, loading, error }] = useUpdateOnboardingAnswersMutation({
 *   variables: {
 *      answersToOnboardingQuestions: // value for 'answersToOnboardingQuestions'
 *   },
 * });
 */
export function useUpdateOnboardingAnswersMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateOnboardingAnswersMutation, GraphqlTypes.UpdateOnboardingAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateOnboardingAnswersMutation, GraphqlTypes.UpdateOnboardingAnswersMutationVariables>(UpdateOnboardingAnswersDocument, options);
      }
export type UpdateOnboardingAnswersMutationHookResult = ReturnType<typeof useUpdateOnboardingAnswersMutation>;
export type UpdateOnboardingAnswersMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateOnboardingAnswersMutation>;
export type UpdateOnboardingAnswersMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateOnboardingAnswersMutation, GraphqlTypes.UpdateOnboardingAnswersMutationVariables>;
export const GetOnboardingSurveyDocument = gql`
    query GetOnboardingSurvey($slugs: [String!]) {
  questionBlocks(slugs: $slugs) {
    edges {
      node {
        id
        slug
        label
        summary
        order
        modalTitle
        modalContent
        questions {
          id
          slug
          title
          label
          order
          questionType
          required
          answerOptions {
            id
            label
            order
            slug
            subtext
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOnboardingSurveyQuery__
 *
 * To run a query within a React component, call `useGetOnboardingSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingSurveyQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useGetOnboardingSurveyQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetOnboardingSurveyQuery, GraphqlTypes.GetOnboardingSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOnboardingSurveyQuery, GraphqlTypes.GetOnboardingSurveyQueryVariables>(GetOnboardingSurveyDocument, options);
      }
export function useGetOnboardingSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOnboardingSurveyQuery, GraphqlTypes.GetOnboardingSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOnboardingSurveyQuery, GraphqlTypes.GetOnboardingSurveyQueryVariables>(GetOnboardingSurveyDocument, options);
        }
// @ts-ignore
export function useGetOnboardingSurveySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOnboardingSurveyQuery, GraphqlTypes.GetOnboardingSurveyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOnboardingSurveyQuery, GraphqlTypes.GetOnboardingSurveyQueryVariables>;
export function useGetOnboardingSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOnboardingSurveyQuery, GraphqlTypes.GetOnboardingSurveyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOnboardingSurveyQuery | undefined, GraphqlTypes.GetOnboardingSurveyQueryVariables>;
export function useGetOnboardingSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOnboardingSurveyQuery, GraphqlTypes.GetOnboardingSurveyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOnboardingSurveyQuery, GraphqlTypes.GetOnboardingSurveyQueryVariables>(GetOnboardingSurveyDocument, options);
        }
export type GetOnboardingSurveyQueryHookResult = ReturnType<typeof useGetOnboardingSurveyQuery>;
export type GetOnboardingSurveyLazyQueryHookResult = ReturnType<typeof useGetOnboardingSurveyLazyQuery>;
export type GetOnboardingSurveySuspenseQueryHookResult = ReturnType<typeof useGetOnboardingSurveySuspenseQuery>;
export type GetOnboardingSurveyQueryResult = Apollo.QueryResult<GraphqlTypes.GetOnboardingSurveyQuery, GraphqlTypes.GetOnboardingSurveyQueryVariables>;
export const GetEarliestPostDocument = gql`
    query GetEarliestPost($arenaId: ID!, $filters: PostFilterInput) {
  earliestPublishingDate(arenaId: $arenaId, filters: $filters)
}
    `;

/**
 * __useGetEarliestPostQuery__
 *
 * To run a query within a React component, call `useGetEarliestPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEarliestPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEarliestPostQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetEarliestPostQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEarliestPostQuery, GraphqlTypes.GetEarliestPostQueryVariables> & ({ variables: GraphqlTypes.GetEarliestPostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEarliestPostQuery, GraphqlTypes.GetEarliestPostQueryVariables>(GetEarliestPostDocument, options);
      }
export function useGetEarliestPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEarliestPostQuery, GraphqlTypes.GetEarliestPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEarliestPostQuery, GraphqlTypes.GetEarliestPostQueryVariables>(GetEarliestPostDocument, options);
        }
// @ts-ignore
export function useGetEarliestPostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEarliestPostQuery, GraphqlTypes.GetEarliestPostQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEarliestPostQuery, GraphqlTypes.GetEarliestPostQueryVariables>;
export function useGetEarliestPostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEarliestPostQuery, GraphqlTypes.GetEarliestPostQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEarliestPostQuery | undefined, GraphqlTypes.GetEarliestPostQueryVariables>;
export function useGetEarliestPostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEarliestPostQuery, GraphqlTypes.GetEarliestPostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEarliestPostQuery, GraphqlTypes.GetEarliestPostQueryVariables>(GetEarliestPostDocument, options);
        }
export type GetEarliestPostQueryHookResult = ReturnType<typeof useGetEarliestPostQuery>;
export type GetEarliestPostLazyQueryHookResult = ReturnType<typeof useGetEarliestPostLazyQuery>;
export type GetEarliestPostSuspenseQueryHookResult = ReturnType<typeof useGetEarliestPostSuspenseQuery>;
export type GetEarliestPostQueryResult = Apollo.QueryResult<GraphqlTypes.GetEarliestPostQuery, GraphqlTypes.GetEarliestPostQueryVariables>;
export const GetAllPostsDocument = gql`
    query GetAllPosts($arenaId: ID!, $limit: Int, $offset: Int, $filters: PostFilterInput) {
  posts(arenaId: $arenaId, limit: $limit, offset: $offset, filters: $filters) {
    id
    title
    subtitle
    topic
    publishingDate
    featuredImageUrl
  }
}
    `;

/**
 * __useGetAllPostsQuery__
 *
 * To run a query within a React component, call `useGetAllPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPostsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAllPostsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAllPostsQuery, GraphqlTypes.GetAllPostsQueryVariables> & ({ variables: GraphqlTypes.GetAllPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllPostsQuery, GraphqlTypes.GetAllPostsQueryVariables>(GetAllPostsDocument, options);
      }
export function useGetAllPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllPostsQuery, GraphqlTypes.GetAllPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllPostsQuery, GraphqlTypes.GetAllPostsQueryVariables>(GetAllPostsDocument, options);
        }
// @ts-ignore
export function useGetAllPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllPostsQuery, GraphqlTypes.GetAllPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllPostsQuery, GraphqlTypes.GetAllPostsQueryVariables>;
export function useGetAllPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllPostsQuery, GraphqlTypes.GetAllPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllPostsQuery | undefined, GraphqlTypes.GetAllPostsQueryVariables>;
export function useGetAllPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllPostsQuery, GraphqlTypes.GetAllPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllPostsQuery, GraphqlTypes.GetAllPostsQueryVariables>(GetAllPostsDocument, options);
        }
export type GetAllPostsQueryHookResult = ReturnType<typeof useGetAllPostsQuery>;
export type GetAllPostsLazyQueryHookResult = ReturnType<typeof useGetAllPostsLazyQuery>;
export type GetAllPostsSuspenseQueryHookResult = ReturnType<typeof useGetAllPostsSuspenseQuery>;
export type GetAllPostsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllPostsQuery, GraphqlTypes.GetAllPostsQueryVariables>;
export const GetPostByIdDocument = gql`
    query GetPostById($arenaId: ID!, $postId: ID!) {
  post(arenaId: $arenaId, postId: $postId) {
    id
    title
    subtitle
    topic
    publishingDate
    status
    contentText
    contentHtml
    featuredImageUrl
    headerImageUrl
    primaryMediaUrl
    headerBgColorHexCode
    titleFontHexCode
    createdAt
    modifiedAt
    author
    totalViews
    uniqueViews
    sharedEntities {
      edges {
        node {
          id
          name
        }
      }
    }
    sharedPeople {
      edges {
        node {
          id
          firstName
          lastName
        }
      }
    }
    sharedOrganizations {
      edges {
        node {
          id
          fullName
        }
      }
    }
    sharingSettings {
      permsAllPositions
      permsAllPosActiveOnly
      permsAllPosDirectOnly
      permsAllPosStartDate
      permsAllPosEndDate
    }
  }
}
    `;

/**
 * __useGetPostByIdQuery__
 *
 * To run a query within a React component, call `useGetPostByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByIdQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostByIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables> & ({ variables: GraphqlTypes.GetPostByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>(GetPostByIdDocument, options);
      }
export function useGetPostByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>(GetPostByIdDocument, options);
        }
// @ts-ignore
export function useGetPostByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>;
export function useGetPostByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostByIdQuery | undefined, GraphqlTypes.GetPostByIdQueryVariables>;
export function useGetPostByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>(GetPostByIdDocument, options);
        }
export type GetPostByIdQueryHookResult = ReturnType<typeof useGetPostByIdQuery>;
export type GetPostByIdLazyQueryHookResult = ReturnType<typeof useGetPostByIdLazyQuery>;
export type GetPostByIdSuspenseQueryHookResult = ReturnType<typeof useGetPostByIdSuspenseQuery>;
export type GetPostByIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>;
export const GetPostsByTopicDocument = gql`
    query GetPostsByTopic($arenaId: ID!, $topic: String!, $limit: Int) {
  posts(
    arenaId: $arenaId
    limit: $limit
    filters: {topicFilter: {selected: [$topic]}}
  ) {
    id
    title
    topic
    publishingDate
    featuredImageUrl
  }
}
    `;

/**
 * __useGetPostsByTopicQuery__
 *
 * To run a query within a React component, call `useGetPostsByTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsByTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsByTopicQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      topic: // value for 'topic'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPostsByTopicQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPostsByTopicQuery, GraphqlTypes.GetPostsByTopicQueryVariables> & ({ variables: GraphqlTypes.GetPostsByTopicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPostsByTopicQuery, GraphqlTypes.GetPostsByTopicQueryVariables>(GetPostsByTopicDocument, options);
      }
export function useGetPostsByTopicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPostsByTopicQuery, GraphqlTypes.GetPostsByTopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPostsByTopicQuery, GraphqlTypes.GetPostsByTopicQueryVariables>(GetPostsByTopicDocument, options);
        }
// @ts-ignore
export function useGetPostsByTopicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostsByTopicQuery, GraphqlTypes.GetPostsByTopicQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostsByTopicQuery, GraphqlTypes.GetPostsByTopicQueryVariables>;
export function useGetPostsByTopicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostsByTopicQuery, GraphqlTypes.GetPostsByTopicQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostsByTopicQuery | undefined, GraphqlTypes.GetPostsByTopicQueryVariables>;
export function useGetPostsByTopicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostsByTopicQuery, GraphqlTypes.GetPostsByTopicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPostsByTopicQuery, GraphqlTypes.GetPostsByTopicQueryVariables>(GetPostsByTopicDocument, options);
        }
export type GetPostsByTopicQueryHookResult = ReturnType<typeof useGetPostsByTopicQuery>;
export type GetPostsByTopicLazyQueryHookResult = ReturnType<typeof useGetPostsByTopicLazyQuery>;
export type GetPostsByTopicSuspenseQueryHookResult = ReturnType<typeof useGetPostsByTopicSuspenseQuery>;
export type GetPostsByTopicQueryResult = Apollo.QueryResult<GraphqlTypes.GetPostsByTopicQuery, GraphqlTypes.GetPostsByTopicQueryVariables>;
export const GetPostTopicsDocument = gql`
    query GetPostTopics($arenaId: ID!) {
  postTopics(arenaId: $arenaId)
}
    `;

/**
 * __useGetPostTopicsQuery__
 *
 * To run a query within a React component, call `useGetPostTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostTopicsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetPostTopicsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables> & ({ variables: GraphqlTypes.GetPostTopicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>(GetPostTopicsDocument, options);
      }
export function useGetPostTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>(GetPostTopicsDocument, options);
        }
// @ts-ignore
export function useGetPostTopicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>;
export function useGetPostTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostTopicsQuery | undefined, GraphqlTypes.GetPostTopicsQueryVariables>;
export function useGetPostTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>(GetPostTopicsDocument, options);
        }
export type GetPostTopicsQueryHookResult = ReturnType<typeof useGetPostTopicsQuery>;
export type GetPostTopicsLazyQueryHookResult = ReturnType<typeof useGetPostTopicsLazyQuery>;
export type GetPostTopicsSuspenseQueryHookResult = ReturnType<typeof useGetPostTopicsSuspenseQuery>;
export type GetPostTopicsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>;
export const GetPostEntitiesDocument = gql`
    query GetPostEntities($arenaId: ID!) {
  postEntities(arenaId: $arenaId) {
    id
    name
  }
}
    `;

/**
 * __useGetPostEntitiesQuery__
 *
 * To run a query within a React component, call `useGetPostEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostEntitiesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetPostEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables> & ({ variables: GraphqlTypes.GetPostEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>(GetPostEntitiesDocument, options);
      }
export function useGetPostEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>(GetPostEntitiesDocument, options);
        }
// @ts-ignore
export function useGetPostEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>;
export function useGetPostEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostEntitiesQuery | undefined, GraphqlTypes.GetPostEntitiesQueryVariables>;
export function useGetPostEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>(GetPostEntitiesDocument, options);
        }
export type GetPostEntitiesQueryHookResult = ReturnType<typeof useGetPostEntitiesQuery>;
export type GetPostEntitiesLazyQueryHookResult = ReturnType<typeof useGetPostEntitiesLazyQuery>;
export type GetPostEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetPostEntitiesSuspenseQuery>;
export type GetPostEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>;
export const UpdateTaxDocDeliveryPrefsDocument = gql`
    mutation updateTaxDocDeliveryPrefs($objectInput: UpdateTaxDocDeliveryPrefInput!) {
  unauthenticatedTaxDocDeliveryPref(objectInput: $objectInput) {
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on MutationSuccessResponse {
      didSucceed
    }
  }
}
    `;
export type UpdateTaxDocDeliveryPrefsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateTaxDocDeliveryPrefsMutation, GraphqlTypes.UpdateTaxDocDeliveryPrefsMutationVariables>;

/**
 * __useUpdateTaxDocDeliveryPrefsMutation__
 *
 * To run a mutation, you first call `useUpdateTaxDocDeliveryPrefsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxDocDeliveryPrefsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxDocDeliveryPrefsMutation, { data, loading, error }] = useUpdateTaxDocDeliveryPrefsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateTaxDocDeliveryPrefsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateTaxDocDeliveryPrefsMutation, GraphqlTypes.UpdateTaxDocDeliveryPrefsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateTaxDocDeliveryPrefsMutation, GraphqlTypes.UpdateTaxDocDeliveryPrefsMutationVariables>(UpdateTaxDocDeliveryPrefsDocument, options);
      }
export type UpdateTaxDocDeliveryPrefsMutationHookResult = ReturnType<typeof useUpdateTaxDocDeliveryPrefsMutation>;
export type UpdateTaxDocDeliveryPrefsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateTaxDocDeliveryPrefsMutation>;
export type UpdateTaxDocDeliveryPrefsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateTaxDocDeliveryPrefsMutation, GraphqlTypes.UpdateTaxDocDeliveryPrefsMutationVariables>;
export const GetUnauthenticatedAccountDocument = gql`
    query getUnauthenticatedAccount($consentToken: String!, $arenaDomain: String!) {
  unauthenticatedAccount(consentToken: $consentToken, arenaDomain: $arenaDomain) {
    __typename
    id
    name
    positions {
      edges {
        node {
          id
          investmentEntity {
            id
            name
          }
          taxDocDeliveryPref {
            id
            deliveryPref
          }
        }
      }
    }
    arena {
      electronicDeliveryConsentUrl
    }
  }
}
    `;

/**
 * __useGetUnauthenticatedAccountQuery__
 *
 * To run a query within a React component, call `useGetUnauthenticatedAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnauthenticatedAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnauthenticatedAccountQuery({
 *   variables: {
 *      consentToken: // value for 'consentToken'
 *      arenaDomain: // value for 'arenaDomain'
 *   },
 * });
 */
export function useGetUnauthenticatedAccountQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUnauthenticatedAccountQuery, GraphqlTypes.GetUnauthenticatedAccountQueryVariables> & ({ variables: GraphqlTypes.GetUnauthenticatedAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUnauthenticatedAccountQuery, GraphqlTypes.GetUnauthenticatedAccountQueryVariables>(GetUnauthenticatedAccountDocument, options);
      }
export function useGetUnauthenticatedAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUnauthenticatedAccountQuery, GraphqlTypes.GetUnauthenticatedAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUnauthenticatedAccountQuery, GraphqlTypes.GetUnauthenticatedAccountQueryVariables>(GetUnauthenticatedAccountDocument, options);
        }
// @ts-ignore
export function useGetUnauthenticatedAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnauthenticatedAccountQuery, GraphqlTypes.GetUnauthenticatedAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnauthenticatedAccountQuery, GraphqlTypes.GetUnauthenticatedAccountQueryVariables>;
export function useGetUnauthenticatedAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnauthenticatedAccountQuery, GraphqlTypes.GetUnauthenticatedAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnauthenticatedAccountQuery | undefined, GraphqlTypes.GetUnauthenticatedAccountQueryVariables>;
export function useGetUnauthenticatedAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnauthenticatedAccountQuery, GraphqlTypes.GetUnauthenticatedAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUnauthenticatedAccountQuery, GraphqlTypes.GetUnauthenticatedAccountQueryVariables>(GetUnauthenticatedAccountDocument, options);
        }
export type GetUnauthenticatedAccountQueryHookResult = ReturnType<typeof useGetUnauthenticatedAccountQuery>;
export type GetUnauthenticatedAccountLazyQueryHookResult = ReturnType<typeof useGetUnauthenticatedAccountLazyQuery>;
export type GetUnauthenticatedAccountSuspenseQueryHookResult = ReturnType<typeof useGetUnauthenticatedAccountSuspenseQuery>;
export type GetUnauthenticatedAccountQueryResult = Apollo.QueryResult<GraphqlTypes.GetUnauthenticatedAccountQuery, GraphqlTypes.GetUnauthenticatedAccountQueryVariables>;
export const UpdateUserHasSeenSingleManagerWelcomeMessageDocument = gql`
    mutation UpdateUserHasSeenSingleManagerWelcomeMessage($promptName: PromptNameEnum!, $arenaId: ID!) {
  userPromptsOps {
    updateUserPromptViewed(promptName: $promptName, forArenaId: $arenaId) {
      userPromptViewed {
        id
      }
    }
  }
}
    `;
export type UpdateUserHasSeenSingleManagerWelcomeMessageMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateUserHasSeenSingleManagerWelcomeMessageMutation, GraphqlTypes.UpdateUserHasSeenSingleManagerWelcomeMessageMutationVariables>;

/**
 * __useUpdateUserHasSeenSingleManagerWelcomeMessageMutation__
 *
 * To run a mutation, you first call `useUpdateUserHasSeenSingleManagerWelcomeMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserHasSeenSingleManagerWelcomeMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserHasSeenSingleManagerWelcomeMessageMutation, { data, loading, error }] = useUpdateUserHasSeenSingleManagerWelcomeMessageMutation({
 *   variables: {
 *      promptName: // value for 'promptName'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useUpdateUserHasSeenSingleManagerWelcomeMessageMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateUserHasSeenSingleManagerWelcomeMessageMutation, GraphqlTypes.UpdateUserHasSeenSingleManagerWelcomeMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateUserHasSeenSingleManagerWelcomeMessageMutation, GraphqlTypes.UpdateUserHasSeenSingleManagerWelcomeMessageMutationVariables>(UpdateUserHasSeenSingleManagerWelcomeMessageDocument, options);
      }
export type UpdateUserHasSeenSingleManagerWelcomeMessageMutationHookResult = ReturnType<typeof useUpdateUserHasSeenSingleManagerWelcomeMessageMutation>;
export type UpdateUserHasSeenSingleManagerWelcomeMessageMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateUserHasSeenSingleManagerWelcomeMessageMutation>;
export type UpdateUserHasSeenSingleManagerWelcomeMessageMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateUserHasSeenSingleManagerWelcomeMessageMutation, GraphqlTypes.UpdateUserHasSeenSingleManagerWelcomeMessageMutationVariables>;
export const GetHasSeenSingleManagerWelcomePromptDocument = gql`
    query GetHasSeenSingleManagerWelcomePrompt($arenaId: ID!) {
  hasSeenArenaWelcomePrompt(arenaId: $arenaId)
  managerArena(id: $arenaId) {
    id
    welcomeMessage
  }
}
    `;

/**
 * __useGetHasSeenSingleManagerWelcomePromptQuery__
 *
 * To run a query within a React component, call `useGetHasSeenSingleManagerWelcomePromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHasSeenSingleManagerWelcomePromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHasSeenSingleManagerWelcomePromptQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetHasSeenSingleManagerWelcomePromptQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQuery, GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQueryVariables> & ({ variables: GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQuery, GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQueryVariables>(GetHasSeenSingleManagerWelcomePromptDocument, options);
      }
export function useGetHasSeenSingleManagerWelcomePromptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQuery, GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQuery, GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQueryVariables>(GetHasSeenSingleManagerWelcomePromptDocument, options);
        }
// @ts-ignore
export function useGetHasSeenSingleManagerWelcomePromptSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQuery, GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQuery, GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQueryVariables>;
export function useGetHasSeenSingleManagerWelcomePromptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQuery, GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQuery | undefined, GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQueryVariables>;
export function useGetHasSeenSingleManagerWelcomePromptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQuery, GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQuery, GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQueryVariables>(GetHasSeenSingleManagerWelcomePromptDocument, options);
        }
export type GetHasSeenSingleManagerWelcomePromptQueryHookResult = ReturnType<typeof useGetHasSeenSingleManagerWelcomePromptQuery>;
export type GetHasSeenSingleManagerWelcomePromptLazyQueryHookResult = ReturnType<typeof useGetHasSeenSingleManagerWelcomePromptLazyQuery>;
export type GetHasSeenSingleManagerWelcomePromptSuspenseQueryHookResult = ReturnType<typeof useGetHasSeenSingleManagerWelcomePromptSuspenseQuery>;
export type GetHasSeenSingleManagerWelcomePromptQueryResult = Apollo.QueryResult<GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQuery, GraphqlTypes.GetHasSeenSingleManagerWelcomePromptQueryVariables>;
export const GetSingleManagerAssetLocationsDocument = gql`
    query GetSingleManagerAssetLocations($filters: InvestmentFilters, $arenaId: ID!) {
  rootPositionInvestments(filters: $filters, arenaId: $arenaId) {
    id
    positionsWithAssetLocations {
      arenaId
      positions {
        positionId
        currency
        assets {
          assetId
          locations {
            latitude
            longitude
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSingleManagerAssetLocationsQuery__
 *
 * To run a query within a React component, call `useGetSingleManagerAssetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleManagerAssetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleManagerAssetLocationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetSingleManagerAssetLocationsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSingleManagerAssetLocationsQuery, GraphqlTypes.GetSingleManagerAssetLocationsQueryVariables> & ({ variables: GraphqlTypes.GetSingleManagerAssetLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSingleManagerAssetLocationsQuery, GraphqlTypes.GetSingleManagerAssetLocationsQueryVariables>(GetSingleManagerAssetLocationsDocument, options);
      }
export function useGetSingleManagerAssetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSingleManagerAssetLocationsQuery, GraphqlTypes.GetSingleManagerAssetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSingleManagerAssetLocationsQuery, GraphqlTypes.GetSingleManagerAssetLocationsQueryVariables>(GetSingleManagerAssetLocationsDocument, options);
        }
// @ts-ignore
export function useGetSingleManagerAssetLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerAssetLocationsQuery, GraphqlTypes.GetSingleManagerAssetLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleManagerAssetLocationsQuery, GraphqlTypes.GetSingleManagerAssetLocationsQueryVariables>;
export function useGetSingleManagerAssetLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerAssetLocationsQuery, GraphqlTypes.GetSingleManagerAssetLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleManagerAssetLocationsQuery | undefined, GraphqlTypes.GetSingleManagerAssetLocationsQueryVariables>;
export function useGetSingleManagerAssetLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerAssetLocationsQuery, GraphqlTypes.GetSingleManagerAssetLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSingleManagerAssetLocationsQuery, GraphqlTypes.GetSingleManagerAssetLocationsQueryVariables>(GetSingleManagerAssetLocationsDocument, options);
        }
export type GetSingleManagerAssetLocationsQueryHookResult = ReturnType<typeof useGetSingleManagerAssetLocationsQuery>;
export type GetSingleManagerAssetLocationsLazyQueryHookResult = ReturnType<typeof useGetSingleManagerAssetLocationsLazyQuery>;
export type GetSingleManagerAssetLocationsSuspenseQueryHookResult = ReturnType<typeof useGetSingleManagerAssetLocationsSuspenseQuery>;
export type GetSingleManagerAssetLocationsQueryResult = Apollo.QueryResult<GraphqlTypes.GetSingleManagerAssetLocationsQuery, GraphqlTypes.GetSingleManagerAssetLocationsQueryVariables>;
export const GetSubscriptionHasSubsV3UiDocument = gql`
    query GetSubscriptionHasSubsV3Ui($arenaDomain: String!, $dataRoomKey: String!) {
  subscriptionV2(arenaDomain: $arenaDomain, dataRoomKey: $dataRoomKey) {
    id
    hasSubsV3Ui
  }
}
    `;

/**
 * __useGetSubscriptionHasSubsV3UiQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionHasSubsV3UiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionHasSubsV3UiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionHasSubsV3UiQuery({
 *   variables: {
 *      arenaDomain: // value for 'arenaDomain'
 *      dataRoomKey: // value for 'dataRoomKey'
 *   },
 * });
 */
export function useGetSubscriptionHasSubsV3UiQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSubscriptionHasSubsV3UiQuery, GraphqlTypes.GetSubscriptionHasSubsV3UiQueryVariables> & ({ variables: GraphqlTypes.GetSubscriptionHasSubsV3UiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSubscriptionHasSubsV3UiQuery, GraphqlTypes.GetSubscriptionHasSubsV3UiQueryVariables>(GetSubscriptionHasSubsV3UiDocument, options);
      }
export function useGetSubscriptionHasSubsV3UiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSubscriptionHasSubsV3UiQuery, GraphqlTypes.GetSubscriptionHasSubsV3UiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSubscriptionHasSubsV3UiQuery, GraphqlTypes.GetSubscriptionHasSubsV3UiQueryVariables>(GetSubscriptionHasSubsV3UiDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionHasSubsV3UiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionHasSubsV3UiQuery, GraphqlTypes.GetSubscriptionHasSubsV3UiQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionHasSubsV3UiQuery, GraphqlTypes.GetSubscriptionHasSubsV3UiQueryVariables>;
export function useGetSubscriptionHasSubsV3UiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionHasSubsV3UiQuery, GraphqlTypes.GetSubscriptionHasSubsV3UiQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionHasSubsV3UiQuery | undefined, GraphqlTypes.GetSubscriptionHasSubsV3UiQueryVariables>;
export function useGetSubscriptionHasSubsV3UiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionHasSubsV3UiQuery, GraphqlTypes.GetSubscriptionHasSubsV3UiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSubscriptionHasSubsV3UiQuery, GraphqlTypes.GetSubscriptionHasSubsV3UiQueryVariables>(GetSubscriptionHasSubsV3UiDocument, options);
        }
export type GetSubscriptionHasSubsV3UiQueryHookResult = ReturnType<typeof useGetSubscriptionHasSubsV3UiQuery>;
export type GetSubscriptionHasSubsV3UiLazyQueryHookResult = ReturnType<typeof useGetSubscriptionHasSubsV3UiLazyQuery>;
export type GetSubscriptionHasSubsV3UiSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionHasSubsV3UiSuspenseQuery>;
export type GetSubscriptionHasSubsV3UiQueryResult = Apollo.QueryResult<GraphqlTypes.GetSubscriptionHasSubsV3UiQuery, GraphqlTypes.GetSubscriptionHasSubsV3UiQueryVariables>;
export const GetSubscriptionCanUsePhoneSmsDocument = gql`
    query GetSubscriptionCanUsePhoneSms($arenaDomain: String!, $dataRoomKey: String!) {
  subscriptionV2(arenaDomain: $arenaDomain, dataRoomKey: $dataRoomKey) {
    id
    canUsePhoneSms
  }
}
    `;

/**
 * __useGetSubscriptionCanUsePhoneSmsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionCanUsePhoneSmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionCanUsePhoneSmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionCanUsePhoneSmsQuery({
 *   variables: {
 *      arenaDomain: // value for 'arenaDomain'
 *      dataRoomKey: // value for 'dataRoomKey'
 *   },
 * });
 */
export function useGetSubscriptionCanUsePhoneSmsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSubscriptionCanUsePhoneSmsQuery, GraphqlTypes.GetSubscriptionCanUsePhoneSmsQueryVariables> & ({ variables: GraphqlTypes.GetSubscriptionCanUsePhoneSmsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSubscriptionCanUsePhoneSmsQuery, GraphqlTypes.GetSubscriptionCanUsePhoneSmsQueryVariables>(GetSubscriptionCanUsePhoneSmsDocument, options);
      }
export function useGetSubscriptionCanUsePhoneSmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSubscriptionCanUsePhoneSmsQuery, GraphqlTypes.GetSubscriptionCanUsePhoneSmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSubscriptionCanUsePhoneSmsQuery, GraphqlTypes.GetSubscriptionCanUsePhoneSmsQueryVariables>(GetSubscriptionCanUsePhoneSmsDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionCanUsePhoneSmsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionCanUsePhoneSmsQuery, GraphqlTypes.GetSubscriptionCanUsePhoneSmsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionCanUsePhoneSmsQuery, GraphqlTypes.GetSubscriptionCanUsePhoneSmsQueryVariables>;
export function useGetSubscriptionCanUsePhoneSmsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionCanUsePhoneSmsQuery, GraphqlTypes.GetSubscriptionCanUsePhoneSmsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionCanUsePhoneSmsQuery | undefined, GraphqlTypes.GetSubscriptionCanUsePhoneSmsQueryVariables>;
export function useGetSubscriptionCanUsePhoneSmsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionCanUsePhoneSmsQuery, GraphqlTypes.GetSubscriptionCanUsePhoneSmsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSubscriptionCanUsePhoneSmsQuery, GraphqlTypes.GetSubscriptionCanUsePhoneSmsQueryVariables>(GetSubscriptionCanUsePhoneSmsDocument, options);
        }
export type GetSubscriptionCanUsePhoneSmsQueryHookResult = ReturnType<typeof useGetSubscriptionCanUsePhoneSmsQuery>;
export type GetSubscriptionCanUsePhoneSmsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionCanUsePhoneSmsLazyQuery>;
export type GetSubscriptionCanUsePhoneSmsSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionCanUsePhoneSmsSuspenseQuery>;
export type GetSubscriptionCanUsePhoneSmsQueryResult = Apollo.QueryResult<GraphqlTypes.GetSubscriptionCanUsePhoneSmsQuery, GraphqlTypes.GetSubscriptionCanUsePhoneSmsQueryVariables>;
export const GetTwoFaGpArenaDetailsDocument = gql`
    query GetTwoFaGpArenaDetails {
  twoFaNumberArenaDetails {
    twoFaNumber
    arenas {
      id
      name
    }
  }
  currentGlobalUser {
    id
    currentTwoFaMethods
    twoFaPhoneNumber
    requiresTwoFaUpgrade
  }
}
    `;

/**
 * __useGetTwoFaGpArenaDetailsQuery__
 *
 * To run a query within a React component, call `useGetTwoFaGpArenaDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwoFaGpArenaDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwoFaGpArenaDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTwoFaGpArenaDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetTwoFaGpArenaDetailsQuery, GraphqlTypes.GetTwoFaGpArenaDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTwoFaGpArenaDetailsQuery, GraphqlTypes.GetTwoFaGpArenaDetailsQueryVariables>(GetTwoFaGpArenaDetailsDocument, options);
      }
export function useGetTwoFaGpArenaDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTwoFaGpArenaDetailsQuery, GraphqlTypes.GetTwoFaGpArenaDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTwoFaGpArenaDetailsQuery, GraphqlTypes.GetTwoFaGpArenaDetailsQueryVariables>(GetTwoFaGpArenaDetailsDocument, options);
        }
// @ts-ignore
export function useGetTwoFaGpArenaDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTwoFaGpArenaDetailsQuery, GraphqlTypes.GetTwoFaGpArenaDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTwoFaGpArenaDetailsQuery, GraphqlTypes.GetTwoFaGpArenaDetailsQueryVariables>;
export function useGetTwoFaGpArenaDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTwoFaGpArenaDetailsQuery, GraphqlTypes.GetTwoFaGpArenaDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTwoFaGpArenaDetailsQuery | undefined, GraphqlTypes.GetTwoFaGpArenaDetailsQueryVariables>;
export function useGetTwoFaGpArenaDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTwoFaGpArenaDetailsQuery, GraphqlTypes.GetTwoFaGpArenaDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTwoFaGpArenaDetailsQuery, GraphqlTypes.GetTwoFaGpArenaDetailsQueryVariables>(GetTwoFaGpArenaDetailsDocument, options);
        }
export type GetTwoFaGpArenaDetailsQueryHookResult = ReturnType<typeof useGetTwoFaGpArenaDetailsQuery>;
export type GetTwoFaGpArenaDetailsLazyQueryHookResult = ReturnType<typeof useGetTwoFaGpArenaDetailsLazyQuery>;
export type GetTwoFaGpArenaDetailsSuspenseQueryHookResult = ReturnType<typeof useGetTwoFaGpArenaDetailsSuspenseQuery>;
export type GetTwoFaGpArenaDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetTwoFaGpArenaDetailsQuery, GraphqlTypes.GetTwoFaGpArenaDetailsQueryVariables>;
export const ClearNewLinkedArenaRecordsDocument = gql`
    mutation ClearNewLinkedArenaRecords($objectInput: ClearPortalUserNewLinkedArenasInput!) {
  clearPortalUserNewLinkedArenas(objectInput: $objectInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on ClearPortalUserNewLinkedArenasObject {
      user {
        id
        newLinkedArenaIds
      }
    }
  }
}
    `;
export type ClearNewLinkedArenaRecordsMutationFn = Apollo.MutationFunction<GraphqlTypes.ClearNewLinkedArenaRecordsMutation, GraphqlTypes.ClearNewLinkedArenaRecordsMutationVariables>;

/**
 * __useClearNewLinkedArenaRecordsMutation__
 *
 * To run a mutation, you first call `useClearNewLinkedArenaRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearNewLinkedArenaRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearNewLinkedArenaRecordsMutation, { data, loading, error }] = useClearNewLinkedArenaRecordsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useClearNewLinkedArenaRecordsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ClearNewLinkedArenaRecordsMutation, GraphqlTypes.ClearNewLinkedArenaRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ClearNewLinkedArenaRecordsMutation, GraphqlTypes.ClearNewLinkedArenaRecordsMutationVariables>(ClearNewLinkedArenaRecordsDocument, options);
      }
export type ClearNewLinkedArenaRecordsMutationHookResult = ReturnType<typeof useClearNewLinkedArenaRecordsMutation>;
export type ClearNewLinkedArenaRecordsMutationResult = Apollo.MutationResult<GraphqlTypes.ClearNewLinkedArenaRecordsMutation>;
export type ClearNewLinkedArenaRecordsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ClearNewLinkedArenaRecordsMutation, GraphqlTypes.ClearNewLinkedArenaRecordsMutationVariables>;
export const GetLinkedManagerDetailsDocument = gql`
    query GetLinkedManagerDetails {
  currentGlobalUser {
    id
    linkedArenas {
      id
      name
      domain
      secondLevelDomain
      logoUrl
      clientTos
      clientPrivacyPolicy
    }
    newLinkedArenaIds
  }
}
    `;

/**
 * __useGetLinkedManagerDetailsQuery__
 *
 * To run a query within a React component, call `useGetLinkedManagerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedManagerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedManagerDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLinkedManagerDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetLinkedManagerDetailsQuery, GraphqlTypes.GetLinkedManagerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLinkedManagerDetailsQuery, GraphqlTypes.GetLinkedManagerDetailsQueryVariables>(GetLinkedManagerDetailsDocument, options);
      }
export function useGetLinkedManagerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLinkedManagerDetailsQuery, GraphqlTypes.GetLinkedManagerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLinkedManagerDetailsQuery, GraphqlTypes.GetLinkedManagerDetailsQueryVariables>(GetLinkedManagerDetailsDocument, options);
        }
// @ts-ignore
export function useGetLinkedManagerDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedManagerDetailsQuery, GraphqlTypes.GetLinkedManagerDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLinkedManagerDetailsQuery, GraphqlTypes.GetLinkedManagerDetailsQueryVariables>;
export function useGetLinkedManagerDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedManagerDetailsQuery, GraphqlTypes.GetLinkedManagerDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLinkedManagerDetailsQuery | undefined, GraphqlTypes.GetLinkedManagerDetailsQueryVariables>;
export function useGetLinkedManagerDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedManagerDetailsQuery, GraphqlTypes.GetLinkedManagerDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLinkedManagerDetailsQuery, GraphqlTypes.GetLinkedManagerDetailsQueryVariables>(GetLinkedManagerDetailsDocument, options);
        }
export type GetLinkedManagerDetailsQueryHookResult = ReturnType<typeof useGetLinkedManagerDetailsQuery>;
export type GetLinkedManagerDetailsLazyQueryHookResult = ReturnType<typeof useGetLinkedManagerDetailsLazyQuery>;
export type GetLinkedManagerDetailsSuspenseQueryHookResult = ReturnType<typeof useGetLinkedManagerDetailsSuspenseQuery>;
export type GetLinkedManagerDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetLinkedManagerDetailsQuery, GraphqlTypes.GetLinkedManagerDetailsQueryVariables>;
export const GenerateTotpQrCodeDocument = gql`
    mutation GenerateTotpQrCode($objectInput: GenerateTotpQrCodeInput) {
  generateTotpQrCode(objectInput: $objectInput) {
    __typename
    ... on MutationErrorResponse {
      message
      errorCode
    }
    ... on GenerateTotpQrCodeOutput {
      totpKey
      qrCode
    }
  }
}
    `;
export type GenerateTotpQrCodeMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateTotpQrCodeMutation, GraphqlTypes.GenerateTotpQrCodeMutationVariables>;

/**
 * __useGenerateTotpQrCodeMutation__
 *
 * To run a mutation, you first call `useGenerateTotpQrCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTotpQrCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTotpQrCodeMutation, { data, loading, error }] = useGenerateTotpQrCodeMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useGenerateTotpQrCodeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateTotpQrCodeMutation, GraphqlTypes.GenerateTotpQrCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateTotpQrCodeMutation, GraphqlTypes.GenerateTotpQrCodeMutationVariables>(GenerateTotpQrCodeDocument, options);
      }
export type GenerateTotpQrCodeMutationHookResult = ReturnType<typeof useGenerateTotpQrCodeMutation>;
export type GenerateTotpQrCodeMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateTotpQrCodeMutation>;
export type GenerateTotpQrCodeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateTotpQrCodeMutation, GraphqlTypes.GenerateTotpQrCodeMutationVariables>;
export const ActivationActivateGlobalUserDocument = gql`
    mutation ActivationActivateGlobalUser {
  activateGlobalUser {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on ActivateGlobalUserObject {
      user {
        id
        globalActivated
        hasUnlinkedLocalUsers
        twoFaRecoveryCodeInfo {
          activeTwoFaRecoveryCodes
          twoFaRecoveryCodesDownloadPath
        }
      }
    }
  }
}
    `;
export type ActivationActivateGlobalUserMutationFn = Apollo.MutationFunction<GraphqlTypes.ActivationActivateGlobalUserMutation, GraphqlTypes.ActivationActivateGlobalUserMutationVariables>;

/**
 * __useActivationActivateGlobalUserMutation__
 *
 * To run a mutation, you first call `useActivationActivateGlobalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivationActivateGlobalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activationActivateGlobalUserMutation, { data, loading, error }] = useActivationActivateGlobalUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useActivationActivateGlobalUserMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ActivationActivateGlobalUserMutation, GraphqlTypes.ActivationActivateGlobalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ActivationActivateGlobalUserMutation, GraphqlTypes.ActivationActivateGlobalUserMutationVariables>(ActivationActivateGlobalUserDocument, options);
      }
export type ActivationActivateGlobalUserMutationHookResult = ReturnType<typeof useActivationActivateGlobalUserMutation>;
export type ActivationActivateGlobalUserMutationResult = Apollo.MutationResult<GraphqlTypes.ActivationActivateGlobalUserMutation>;
export type ActivationActivateGlobalUserMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ActivationActivateGlobalUserMutation, GraphqlTypes.ActivationActivateGlobalUserMutationVariables>;
export const TwoStepAuthSendTokenToSmsForConfigurationDocument = gql`
    mutation TwoStepAuthSendTokenToSmsForConfiguration($objectInput: TwoStepAuthSendTokenToSmsForConfigurationInput!) {
  twoStepAuthSendTokenToSmsForConfiguration(objectInput: $objectInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on MutationSuccessResponse {
      didSucceed
    }
  }
}
    `;
export type TwoStepAuthSendTokenToSmsForConfigurationMutationFn = Apollo.MutationFunction<GraphqlTypes.TwoStepAuthSendTokenToSmsForConfigurationMutation, GraphqlTypes.TwoStepAuthSendTokenToSmsForConfigurationMutationVariables>;

/**
 * __useTwoStepAuthSendTokenToSmsForConfigurationMutation__
 *
 * To run a mutation, you first call `useTwoStepAuthSendTokenToSmsForConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTwoStepAuthSendTokenToSmsForConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [twoStepAuthSendTokenToSmsForConfigurationMutation, { data, loading, error }] = useTwoStepAuthSendTokenToSmsForConfigurationMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useTwoStepAuthSendTokenToSmsForConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.TwoStepAuthSendTokenToSmsForConfigurationMutation, GraphqlTypes.TwoStepAuthSendTokenToSmsForConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.TwoStepAuthSendTokenToSmsForConfigurationMutation, GraphqlTypes.TwoStepAuthSendTokenToSmsForConfigurationMutationVariables>(TwoStepAuthSendTokenToSmsForConfigurationDocument, options);
      }
export type TwoStepAuthSendTokenToSmsForConfigurationMutationHookResult = ReturnType<typeof useTwoStepAuthSendTokenToSmsForConfigurationMutation>;
export type TwoStepAuthSendTokenToSmsForConfigurationMutationResult = Apollo.MutationResult<GraphqlTypes.TwoStepAuthSendTokenToSmsForConfigurationMutation>;
export type TwoStepAuthSendTokenToSmsForConfigurationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.TwoStepAuthSendTokenToSmsForConfigurationMutation, GraphqlTypes.TwoStepAuthSendTokenToSmsForConfigurationMutationVariables>;
export const TwoStepAuthSendTokenToEmailForConfigurationDocument = gql`
    mutation TwoStepAuthSendTokenToEmailForConfiguration($objectInput: TwoStepAuthSendTokenToEmailForConfigurationInput!) {
  twoStepAuthSendTokenToEmailForConfiguration(objectInput: $objectInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on MutationSuccessResponse {
      didSucceed
    }
  }
}
    `;
export type TwoStepAuthSendTokenToEmailForConfigurationMutationFn = Apollo.MutationFunction<GraphqlTypes.TwoStepAuthSendTokenToEmailForConfigurationMutation, GraphqlTypes.TwoStepAuthSendTokenToEmailForConfigurationMutationVariables>;

/**
 * __useTwoStepAuthSendTokenToEmailForConfigurationMutation__
 *
 * To run a mutation, you first call `useTwoStepAuthSendTokenToEmailForConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTwoStepAuthSendTokenToEmailForConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [twoStepAuthSendTokenToEmailForConfigurationMutation, { data, loading, error }] = useTwoStepAuthSendTokenToEmailForConfigurationMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useTwoStepAuthSendTokenToEmailForConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.TwoStepAuthSendTokenToEmailForConfigurationMutation, GraphqlTypes.TwoStepAuthSendTokenToEmailForConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.TwoStepAuthSendTokenToEmailForConfigurationMutation, GraphqlTypes.TwoStepAuthSendTokenToEmailForConfigurationMutationVariables>(TwoStepAuthSendTokenToEmailForConfigurationDocument, options);
      }
export type TwoStepAuthSendTokenToEmailForConfigurationMutationHookResult = ReturnType<typeof useTwoStepAuthSendTokenToEmailForConfigurationMutation>;
export type TwoStepAuthSendTokenToEmailForConfigurationMutationResult = Apollo.MutationResult<GraphqlTypes.TwoStepAuthSendTokenToEmailForConfigurationMutation>;
export type TwoStepAuthSendTokenToEmailForConfigurationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.TwoStepAuthSendTokenToEmailForConfigurationMutation, GraphqlTypes.TwoStepAuthSendTokenToEmailForConfigurationMutationVariables>;
export const SendGlobalPortalActivationEmailDocument = gql`
    mutation SendGlobalPortalActivationEmail($objectInput: SendGlobalPortalActivationEmailInput!) {
  sendGlobalPortalActivationEmail(objectInput: $objectInput) {
    errorCode
    message
  }
}
    `;
export type SendGlobalPortalActivationEmailMutationFn = Apollo.MutationFunction<GraphqlTypes.SendGlobalPortalActivationEmailMutation, GraphqlTypes.SendGlobalPortalActivationEmailMutationVariables>;

/**
 * __useSendGlobalPortalActivationEmailMutation__
 *
 * To run a mutation, you first call `useSendGlobalPortalActivationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGlobalPortalActivationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGlobalPortalActivationEmailMutation, { data, loading, error }] = useSendGlobalPortalActivationEmailMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useSendGlobalPortalActivationEmailMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SendGlobalPortalActivationEmailMutation, GraphqlTypes.SendGlobalPortalActivationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SendGlobalPortalActivationEmailMutation, GraphqlTypes.SendGlobalPortalActivationEmailMutationVariables>(SendGlobalPortalActivationEmailDocument, options);
      }
export type SendGlobalPortalActivationEmailMutationHookResult = ReturnType<typeof useSendGlobalPortalActivationEmailMutation>;
export type SendGlobalPortalActivationEmailMutationResult = Apollo.MutationResult<GraphqlTypes.SendGlobalPortalActivationEmailMutation>;
export type SendGlobalPortalActivationEmailMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SendGlobalPortalActivationEmailMutation, GraphqlTypes.SendGlobalPortalActivationEmailMutationVariables>;
export const GetUnifiedPortalDocumentActivationDetailsDocument = gql`
    query GetUnifiedPortalDocumentActivationDetails($code: String!, $arenaId: Int!) {
  unifiedPortalDocumentActivationDetails(code: $code, arenaId: $arenaId) {
    ...UnifiedPortalActivationErrorFragment
    ...UnifiedPortalDocumentActivationRedirectObjectFragment
    ...UnifiedPortalDocumentActivationDetailsObjectFragment
  }
}
    ${UnifiedPortalActivationErrorFragmentFragmentDoc}
${UnifiedPortalDocumentActivationRedirectObjectFragmentFragmentDoc}
${UnifiedPortalDocumentActivationDetailsObjectFragmentFragmentDoc}`;

/**
 * __useGetUnifiedPortalDocumentActivationDetailsQuery__
 *
 * To run a query within a React component, call `useGetUnifiedPortalDocumentActivationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnifiedPortalDocumentActivationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnifiedPortalDocumentActivationDetailsQuery({
 *   variables: {
 *      code: // value for 'code'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetUnifiedPortalDocumentActivationDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQueryVariables> & ({ variables: GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQueryVariables>(GetUnifiedPortalDocumentActivationDetailsDocument, options);
      }
export function useGetUnifiedPortalDocumentActivationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQueryVariables>(GetUnifiedPortalDocumentActivationDetailsDocument, options);
        }
// @ts-ignore
export function useGetUnifiedPortalDocumentActivationDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQueryVariables>;
export function useGetUnifiedPortalDocumentActivationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQuery | undefined, GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQueryVariables>;
export function useGetUnifiedPortalDocumentActivationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQueryVariables>(GetUnifiedPortalDocumentActivationDetailsDocument, options);
        }
export type GetUnifiedPortalDocumentActivationDetailsQueryHookResult = ReturnType<typeof useGetUnifiedPortalDocumentActivationDetailsQuery>;
export type GetUnifiedPortalDocumentActivationDetailsLazyQueryHookResult = ReturnType<typeof useGetUnifiedPortalDocumentActivationDetailsLazyQuery>;
export type GetUnifiedPortalDocumentActivationDetailsSuspenseQueryHookResult = ReturnType<typeof useGetUnifiedPortalDocumentActivationDetailsSuspenseQuery>;
export type GetUnifiedPortalDocumentActivationDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalDocumentActivationDetailsQueryVariables>;
export const UpdateGlobalUserDocument = gql`
    mutation UpdateGlobalUser($objectInput: UpdateGlobalUserInput!) {
  updateGlobalUser(objectInput: $objectInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on UpdateGlobalUserObject {
      user {
        id
      }
    }
  }
}
    `;
export type UpdateGlobalUserMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateGlobalUserMutation, GraphqlTypes.UpdateGlobalUserMutationVariables>;

/**
 * __useUpdateGlobalUserMutation__
 *
 * To run a mutation, you first call `useUpdateGlobalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlobalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlobalUserMutation, { data, loading, error }] = useUpdateGlobalUserMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateGlobalUserMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateGlobalUserMutation, GraphqlTypes.UpdateGlobalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateGlobalUserMutation, GraphqlTypes.UpdateGlobalUserMutationVariables>(UpdateGlobalUserDocument, options);
      }
export type UpdateGlobalUserMutationHookResult = ReturnType<typeof useUpdateGlobalUserMutation>;
export type UpdateGlobalUserMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateGlobalUserMutation>;
export type UpdateGlobalUserMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateGlobalUserMutation, GraphqlTypes.UpdateGlobalUserMutationVariables>;
export const DeclinePortalInvitationDocument = gql`
    mutation DeclinePortalInvitation($objectInput: DeclinePortalInvitationInput!) {
  declinePortalInvitation(objectInput: $objectInput) {
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on MutationSuccessResponse {
      didSucceed
    }
  }
}
    `;
export type DeclinePortalInvitationMutationFn = Apollo.MutationFunction<GraphqlTypes.DeclinePortalInvitationMutation, GraphqlTypes.DeclinePortalInvitationMutationVariables>;

/**
 * __useDeclinePortalInvitationMutation__
 *
 * To run a mutation, you first call `useDeclinePortalInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclinePortalInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declinePortalInvitationMutation, { data, loading, error }] = useDeclinePortalInvitationMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useDeclinePortalInvitationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeclinePortalInvitationMutation, GraphqlTypes.DeclinePortalInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeclinePortalInvitationMutation, GraphqlTypes.DeclinePortalInvitationMutationVariables>(DeclinePortalInvitationDocument, options);
      }
export type DeclinePortalInvitationMutationHookResult = ReturnType<typeof useDeclinePortalInvitationMutation>;
export type DeclinePortalInvitationMutationResult = Apollo.MutationResult<GraphqlTypes.DeclinePortalInvitationMutation>;
export type DeclinePortalInvitationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeclinePortalInvitationMutation, GraphqlTypes.DeclinePortalInvitationMutationVariables>;
export const GetUnifiedPortalActivationDetailsDocument = gql`
    query GetUnifiedPortalActivationDetails($code: String!) {
  unifiedPortalActivationDetails(code: $code) {
    ...UnifiedPortalActivationDetailsFragment
    ...UnifiedPortalActivationErrorFragment
  }
}
    ${UnifiedPortalActivationDetailsFragmentFragmentDoc}
${UnifiedPortalActivationErrorFragmentFragmentDoc}`;

/**
 * __useGetUnifiedPortalActivationDetailsQuery__
 *
 * To run a query within a React component, call `useGetUnifiedPortalActivationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnifiedPortalActivationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnifiedPortalActivationDetailsQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetUnifiedPortalActivationDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUnifiedPortalActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalActivationDetailsQueryVariables> & ({ variables: GraphqlTypes.GetUnifiedPortalActivationDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUnifiedPortalActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalActivationDetailsQueryVariables>(GetUnifiedPortalActivationDetailsDocument, options);
      }
export function useGetUnifiedPortalActivationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUnifiedPortalActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalActivationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUnifiedPortalActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalActivationDetailsQueryVariables>(GetUnifiedPortalActivationDetailsDocument, options);
        }
// @ts-ignore
export function useGetUnifiedPortalActivationDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnifiedPortalActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalActivationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnifiedPortalActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalActivationDetailsQueryVariables>;
export function useGetUnifiedPortalActivationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnifiedPortalActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalActivationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnifiedPortalActivationDetailsQuery | undefined, GraphqlTypes.GetUnifiedPortalActivationDetailsQueryVariables>;
export function useGetUnifiedPortalActivationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnifiedPortalActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalActivationDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUnifiedPortalActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalActivationDetailsQueryVariables>(GetUnifiedPortalActivationDetailsDocument, options);
        }
export type GetUnifiedPortalActivationDetailsQueryHookResult = ReturnType<typeof useGetUnifiedPortalActivationDetailsQuery>;
export type GetUnifiedPortalActivationDetailsLazyQueryHookResult = ReturnType<typeof useGetUnifiedPortalActivationDetailsLazyQuery>;
export type GetUnifiedPortalActivationDetailsSuspenseQueryHookResult = ReturnType<typeof useGetUnifiedPortalActivationDetailsSuspenseQuery>;
export type GetUnifiedPortalActivationDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetUnifiedPortalActivationDetailsQuery, GraphqlTypes.GetUnifiedPortalActivationDetailsQueryVariables>;
export const GetGlobalUserStatusDetailsDocument = gql`
    query GetGlobalUserStatusDetails {
  currentGlobalUser {
    id
    globalActivated
    hasUnlinkedLocalUsers
    newLinkedArenaIds
    requiresTwoFaUpgrade
  }
}
    `;

/**
 * __useGetGlobalUserStatusDetailsQuery__
 *
 * To run a query within a React component, call `useGetGlobalUserStatusDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalUserStatusDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalUserStatusDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGlobalUserStatusDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetGlobalUserStatusDetailsQuery, GraphqlTypes.GetGlobalUserStatusDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGlobalUserStatusDetailsQuery, GraphqlTypes.GetGlobalUserStatusDetailsQueryVariables>(GetGlobalUserStatusDetailsDocument, options);
      }
export function useGetGlobalUserStatusDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGlobalUserStatusDetailsQuery, GraphqlTypes.GetGlobalUserStatusDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGlobalUserStatusDetailsQuery, GraphqlTypes.GetGlobalUserStatusDetailsQueryVariables>(GetGlobalUserStatusDetailsDocument, options);
        }
// @ts-ignore
export function useGetGlobalUserStatusDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGlobalUserStatusDetailsQuery, GraphqlTypes.GetGlobalUserStatusDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGlobalUserStatusDetailsQuery, GraphqlTypes.GetGlobalUserStatusDetailsQueryVariables>;
export function useGetGlobalUserStatusDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGlobalUserStatusDetailsQuery, GraphqlTypes.GetGlobalUserStatusDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGlobalUserStatusDetailsQuery | undefined, GraphqlTypes.GetGlobalUserStatusDetailsQueryVariables>;
export function useGetGlobalUserStatusDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGlobalUserStatusDetailsQuery, GraphqlTypes.GetGlobalUserStatusDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGlobalUserStatusDetailsQuery, GraphqlTypes.GetGlobalUserStatusDetailsQueryVariables>(GetGlobalUserStatusDetailsDocument, options);
        }
export type GetGlobalUserStatusDetailsQueryHookResult = ReturnType<typeof useGetGlobalUserStatusDetailsQuery>;
export type GetGlobalUserStatusDetailsLazyQueryHookResult = ReturnType<typeof useGetGlobalUserStatusDetailsLazyQuery>;
export type GetGlobalUserStatusDetailsSuspenseQueryHookResult = ReturnType<typeof useGetGlobalUserStatusDetailsSuspenseQuery>;
export type GetGlobalUserStatusDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetGlobalUserStatusDetailsQuery, GraphqlTypes.GetGlobalUserStatusDetailsQueryVariables>;
export const GetNetworkActivityFeedDocument = gql`
    query GetNetworkActivityFeed($startTimestamp: String, $quantity: Int) {
  networkActivityFeedWrapper(startTimestamp: $startTimestamp, quantity: $quantity) {
    newStartTimestamp
    items {
      arena {
        id
        name
        secondLevelDomain
      }
      activityType
      activityObject {
        ...InvestorTransactionsFeedObjectFields
        __typename
      }
      emailId
      effectiveDate
      arenaAdjustedDate
      regarding
      timestamp
      recipientsLabel
      __typename
    }
    __typename
  }
}
    ${InvestorTransactionsFeedObjectFieldsFragmentDoc}`;

/**
 * __useGetNetworkActivityFeedQuery__
 *
 * To run a query within a React component, call `useGetNetworkActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetworkActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetworkActivityFeedQuery({
 *   variables: {
 *      startTimestamp: // value for 'startTimestamp'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useGetNetworkActivityFeedQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetNetworkActivityFeedQuery, GraphqlTypes.GetNetworkActivityFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNetworkActivityFeedQuery, GraphqlTypes.GetNetworkActivityFeedQueryVariables>(GetNetworkActivityFeedDocument, options);
      }
export function useGetNetworkActivityFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNetworkActivityFeedQuery, GraphqlTypes.GetNetworkActivityFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNetworkActivityFeedQuery, GraphqlTypes.GetNetworkActivityFeedQueryVariables>(GetNetworkActivityFeedDocument, options);
        }
// @ts-ignore
export function useGetNetworkActivityFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNetworkActivityFeedQuery, GraphqlTypes.GetNetworkActivityFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNetworkActivityFeedQuery, GraphqlTypes.GetNetworkActivityFeedQueryVariables>;
export function useGetNetworkActivityFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNetworkActivityFeedQuery, GraphqlTypes.GetNetworkActivityFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNetworkActivityFeedQuery | undefined, GraphqlTypes.GetNetworkActivityFeedQueryVariables>;
export function useGetNetworkActivityFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNetworkActivityFeedQuery, GraphqlTypes.GetNetworkActivityFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNetworkActivityFeedQuery, GraphqlTypes.GetNetworkActivityFeedQueryVariables>(GetNetworkActivityFeedDocument, options);
        }
export type GetNetworkActivityFeedQueryHookResult = ReturnType<typeof useGetNetworkActivityFeedQuery>;
export type GetNetworkActivityFeedLazyQueryHookResult = ReturnType<typeof useGetNetworkActivityFeedLazyQuery>;
export type GetNetworkActivityFeedSuspenseQueryHookResult = ReturnType<typeof useGetNetworkActivityFeedSuspenseQuery>;
export type GetNetworkActivityFeedQueryResult = Apollo.QueryResult<GraphqlTypes.GetNetworkActivityFeedQuery, GraphqlTypes.GetNetworkActivityFeedQueryVariables>;
export const GetSingleManagerActivityFeedDocument = gql`
    query GetSingleManagerActivityFeed($startTimestamp: String, $quantity: Int, $arenaId: ID!) {
  managerArena(id: $arenaId) {
    id
    networkActivityFeedWrapper(startTimestamp: $startTimestamp, quantity: $quantity) {
      newStartTimestamp
      items {
        arena {
          id
          name
          secondLevelDomain
        }
        activityType
        activityObject {
          ...InvestorTransactionsFeedObjectFields
          __typename
        }
        emailId
        effectiveDate
        arenaAdjustedDate
        regarding
        timestamp
        recipientsLabel
        __typename
      }
      __typename
    }
  }
}
    ${InvestorTransactionsFeedObjectFieldsFragmentDoc}`;

/**
 * __useGetSingleManagerActivityFeedQuery__
 *
 * To run a query within a React component, call `useGetSingleManagerActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleManagerActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleManagerActivityFeedQuery({
 *   variables: {
 *      startTimestamp: // value for 'startTimestamp'
 *      quantity: // value for 'quantity'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetSingleManagerActivityFeedQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSingleManagerActivityFeedQuery, GraphqlTypes.GetSingleManagerActivityFeedQueryVariables> & ({ variables: GraphqlTypes.GetSingleManagerActivityFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSingleManagerActivityFeedQuery, GraphqlTypes.GetSingleManagerActivityFeedQueryVariables>(GetSingleManagerActivityFeedDocument, options);
      }
export function useGetSingleManagerActivityFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSingleManagerActivityFeedQuery, GraphqlTypes.GetSingleManagerActivityFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSingleManagerActivityFeedQuery, GraphqlTypes.GetSingleManagerActivityFeedQueryVariables>(GetSingleManagerActivityFeedDocument, options);
        }
// @ts-ignore
export function useGetSingleManagerActivityFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerActivityFeedQuery, GraphqlTypes.GetSingleManagerActivityFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleManagerActivityFeedQuery, GraphqlTypes.GetSingleManagerActivityFeedQueryVariables>;
export function useGetSingleManagerActivityFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerActivityFeedQuery, GraphqlTypes.GetSingleManagerActivityFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleManagerActivityFeedQuery | undefined, GraphqlTypes.GetSingleManagerActivityFeedQueryVariables>;
export function useGetSingleManagerActivityFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleManagerActivityFeedQuery, GraphqlTypes.GetSingleManagerActivityFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSingleManagerActivityFeedQuery, GraphqlTypes.GetSingleManagerActivityFeedQueryVariables>(GetSingleManagerActivityFeedDocument, options);
        }
export type GetSingleManagerActivityFeedQueryHookResult = ReturnType<typeof useGetSingleManagerActivityFeedQuery>;
export type GetSingleManagerActivityFeedLazyQueryHookResult = ReturnType<typeof useGetSingleManagerActivityFeedLazyQuery>;
export type GetSingleManagerActivityFeedSuspenseQueryHookResult = ReturnType<typeof useGetSingleManagerActivityFeedSuspenseQuery>;
export type GetSingleManagerActivityFeedQueryResult = Apollo.QueryResult<GraphqlTypes.GetSingleManagerActivityFeedQuery, GraphqlTypes.GetSingleManagerActivityFeedQueryVariables>;
export const CapitalCallBannerDocument = gql`
    query CapitalCallBanner($id: ID!) {
  managerArena(id: $id) {
    positions {
      edges {
        node {
          id
          investmentEntity {
            name
          }
          pendingCapitalCalls {
            id
            batch {
              effectiveDate
              batchCategory
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCapitalCallBannerQuery__
 *
 * To run a query within a React component, call `useCapitalCallBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapitalCallBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapitalCallBannerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCapitalCallBannerQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.CapitalCallBannerQuery, GraphqlTypes.CapitalCallBannerQueryVariables> & ({ variables: GraphqlTypes.CapitalCallBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CapitalCallBannerQuery, GraphqlTypes.CapitalCallBannerQueryVariables>(CapitalCallBannerDocument, options);
      }
export function useCapitalCallBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CapitalCallBannerQuery, GraphqlTypes.CapitalCallBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CapitalCallBannerQuery, GraphqlTypes.CapitalCallBannerQueryVariables>(CapitalCallBannerDocument, options);
        }
// @ts-ignore
export function useCapitalCallBannerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CapitalCallBannerQuery, GraphqlTypes.CapitalCallBannerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CapitalCallBannerQuery, GraphqlTypes.CapitalCallBannerQueryVariables>;
export function useCapitalCallBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CapitalCallBannerQuery, GraphqlTypes.CapitalCallBannerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CapitalCallBannerQuery | undefined, GraphqlTypes.CapitalCallBannerQueryVariables>;
export function useCapitalCallBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CapitalCallBannerQuery, GraphqlTypes.CapitalCallBannerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CapitalCallBannerQuery, GraphqlTypes.CapitalCallBannerQueryVariables>(CapitalCallBannerDocument, options);
        }
export type CapitalCallBannerQueryHookResult = ReturnType<typeof useCapitalCallBannerQuery>;
export type CapitalCallBannerLazyQueryHookResult = ReturnType<typeof useCapitalCallBannerLazyQuery>;
export type CapitalCallBannerSuspenseQueryHookResult = ReturnType<typeof useCapitalCallBannerSuspenseQuery>;
export type CapitalCallBannerQueryResult = Apollo.QueryResult<GraphqlTypes.CapitalCallBannerQuery, GraphqlTypes.CapitalCallBannerQueryVariables>;
export const GetTotalDocument = gql`
    query GetTotal($positionId: ID, $filters: DocumentFilters) {
  total: documents(positionId: $positionId, filters: $filters) {
    count
  }
}
    `;

/**
 * __useGetTotalQuery__
 *
 * To run a query within a React component, call `useGetTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetTotalQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetTotalQuery, GraphqlTypes.GetTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTotalQuery, GraphqlTypes.GetTotalQueryVariables>(GetTotalDocument, options);
      }
export function useGetTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTotalQuery, GraphqlTypes.GetTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTotalQuery, GraphqlTypes.GetTotalQueryVariables>(GetTotalDocument, options);
        }
// @ts-ignore
export function useGetTotalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTotalQuery, GraphqlTypes.GetTotalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTotalQuery, GraphqlTypes.GetTotalQueryVariables>;
export function useGetTotalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTotalQuery, GraphqlTypes.GetTotalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTotalQuery | undefined, GraphqlTypes.GetTotalQueryVariables>;
export function useGetTotalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTotalQuery, GraphqlTypes.GetTotalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTotalQuery, GraphqlTypes.GetTotalQueryVariables>(GetTotalDocument, options);
        }
export type GetTotalQueryHookResult = ReturnType<typeof useGetTotalQuery>;
export type GetTotalLazyQueryHookResult = ReturnType<typeof useGetTotalLazyQuery>;
export type GetTotalSuspenseQueryHookResult = ReturnType<typeof useGetTotalSuspenseQuery>;
export type GetTotalQueryResult = Apollo.QueryResult<GraphqlTypes.GetTotalQuery, GraphqlTypes.GetTotalQueryVariables>;
export const GetDocumentsDocument = gql`
    query GetDocuments($first: Int, $after: String, $filters: DocumentFilters, $sort: [GlobalDocumentQuerySortEnum], $ids: [ID], $dataRoomKey: String, $isDownloadNdaEnabled: Boolean!) {
  filtered: documents(
    first: $first
    after: $after
    filters: $filters
    sort: $sort
    ids: $ids
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    count
    earliestDocumentDate
    documents: edges {
      document: node {
        ...PortalDocument
      }
    }
  }
}
    ${PortalDocumentFragmentDoc}`;

/**
 * __useGetDocumentsQuery__
 *
 * To run a query within a React component, call `useGetDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      ids: // value for 'ids'
 *      dataRoomKey: // value for 'dataRoomKey'
 *      isDownloadNdaEnabled: // value for 'isDownloadNdaEnabled'
 *   },
 * });
 */
export function useGetDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentsQuery, GraphqlTypes.GetDocumentsQueryVariables> & ({ variables: GraphqlTypes.GetDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentsQuery, GraphqlTypes.GetDocumentsQueryVariables>(GetDocumentsDocument, options);
      }
export function useGetDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentsQuery, GraphqlTypes.GetDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentsQuery, GraphqlTypes.GetDocumentsQueryVariables>(GetDocumentsDocument, options);
        }
// @ts-ignore
export function useGetDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentsQuery, GraphqlTypes.GetDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentsQuery, GraphqlTypes.GetDocumentsQueryVariables>;
export function useGetDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentsQuery, GraphqlTypes.GetDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentsQuery | undefined, GraphqlTypes.GetDocumentsQueryVariables>;
export function useGetDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentsQuery, GraphqlTypes.GetDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentsQuery, GraphqlTypes.GetDocumentsQueryVariables>(GetDocumentsDocument, options);
        }
export type GetDocumentsQueryHookResult = ReturnType<typeof useGetDocumentsQuery>;
export type GetDocumentsLazyQueryHookResult = ReturnType<typeof useGetDocumentsLazyQuery>;
export type GetDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentsSuspenseQuery>;
export type GetDocumentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentsQuery, GraphqlTypes.GetDocumentsQueryVariables>;
export const GetPortalFiltersDocument = gql`
    query GetPortalFilters($categoryFilters: DocumentFilters, $entityFilters: PortalEntityFilters, $accountFilters: PortalAccountFilters) {
  documents: documents(filters: $categoryFilters) {
    availableDocumentCategories {
      id
      arenaId
      name
    }
  }
  managerArenas {
    id
    name
  }
  unifiedPortalEntities(filters: $entityFilters) {
    edges {
      node {
        id
        arenaId
        name
      }
    }
  }
  unifiedPortalAccounts(filters: $accountFilters) {
    edges {
      node {
        id
        arenaId
        name
      }
    }
  }
}
    `;

/**
 * __useGetPortalFiltersQuery__
 *
 * To run a query within a React component, call `useGetPortalFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalFiltersQuery({
 *   variables: {
 *      categoryFilters: // value for 'categoryFilters'
 *      entityFilters: // value for 'entityFilters'
 *      accountFilters: // value for 'accountFilters'
 *   },
 * });
 */
export function useGetPortalFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPortalFiltersQuery, GraphqlTypes.GetPortalFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPortalFiltersQuery, GraphqlTypes.GetPortalFiltersQueryVariables>(GetPortalFiltersDocument, options);
      }
export function useGetPortalFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPortalFiltersQuery, GraphqlTypes.GetPortalFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPortalFiltersQuery, GraphqlTypes.GetPortalFiltersQueryVariables>(GetPortalFiltersDocument, options);
        }
// @ts-ignore
export function useGetPortalFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalFiltersQuery, GraphqlTypes.GetPortalFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalFiltersQuery, GraphqlTypes.GetPortalFiltersQueryVariables>;
export function useGetPortalFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalFiltersQuery, GraphqlTypes.GetPortalFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalFiltersQuery | undefined, GraphqlTypes.GetPortalFiltersQueryVariables>;
export function useGetPortalFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalFiltersQuery, GraphqlTypes.GetPortalFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPortalFiltersQuery, GraphqlTypes.GetPortalFiltersQueryVariables>(GetPortalFiltersDocument, options);
        }
export type GetPortalFiltersQueryHookResult = ReturnType<typeof useGetPortalFiltersQuery>;
export type GetPortalFiltersLazyQueryHookResult = ReturnType<typeof useGetPortalFiltersLazyQuery>;
export type GetPortalFiltersSuspenseQueryHookResult = ReturnType<typeof useGetPortalFiltersSuspenseQuery>;
export type GetPortalFiltersQueryResult = Apollo.QueryResult<GraphqlTypes.GetPortalFiltersQuery, GraphqlTypes.GetPortalFiltersQueryVariables>;
export const DownloadAllDocumentsDocument = gql`
    mutation DownloadAllDocuments($input: DownloadAllDocumentsInput!) {
  documentOps {
    downloadAllDocuments(objectInput: $input) {
      job {
        id
      }
    }
  }
}
    `;
export type DownloadAllDocumentsMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadAllDocumentsMutation, GraphqlTypes.DownloadAllDocumentsMutationVariables>;

/**
 * __useDownloadAllDocumentsMutation__
 *
 * To run a mutation, you first call `useDownloadAllDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAllDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAllDocumentsMutation, { data, loading, error }] = useDownloadAllDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadAllDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadAllDocumentsMutation, GraphqlTypes.DownloadAllDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadAllDocumentsMutation, GraphqlTypes.DownloadAllDocumentsMutationVariables>(DownloadAllDocumentsDocument, options);
      }
export type DownloadAllDocumentsMutationHookResult = ReturnType<typeof useDownloadAllDocumentsMutation>;
export type DownloadAllDocumentsMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadAllDocumentsMutation>;
export type DownloadAllDocumentsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadAllDocumentsMutation, GraphqlTypes.DownloadAllDocumentsMutationVariables>;
export const GetNdaDocument = gql`
    query GetNda($id: ID!) {
  nda(id: $id) {
    id
    name
    customerName
    agreementText
  }
}
    `;

/**
 * __useGetNdaQuery__
 *
 * To run a query within a React component, call `useGetNdaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNdaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNdaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNdaQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetNdaQuery, GraphqlTypes.GetNdaQueryVariables> & ({ variables: GraphqlTypes.GetNdaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNdaQuery, GraphqlTypes.GetNdaQueryVariables>(GetNdaDocument, options);
      }
export function useGetNdaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNdaQuery, GraphqlTypes.GetNdaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNdaQuery, GraphqlTypes.GetNdaQueryVariables>(GetNdaDocument, options);
        }
// @ts-ignore
export function useGetNdaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNdaQuery, GraphqlTypes.GetNdaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNdaQuery, GraphqlTypes.GetNdaQueryVariables>;
export function useGetNdaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNdaQuery, GraphqlTypes.GetNdaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNdaQuery | undefined, GraphqlTypes.GetNdaQueryVariables>;
export function useGetNdaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNdaQuery, GraphqlTypes.GetNdaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNdaQuery, GraphqlTypes.GetNdaQueryVariables>(GetNdaDocument, options);
        }
export type GetNdaQueryHookResult = ReturnType<typeof useGetNdaQuery>;
export type GetNdaLazyQueryHookResult = ReturnType<typeof useGetNdaLazyQuery>;
export type GetNdaSuspenseQueryHookResult = ReturnType<typeof useGetNdaSuspenseQuery>;
export type GetNdaQueryResult = Apollo.QueryResult<GraphqlTypes.GetNdaQuery, GraphqlTypes.GetNdaQueryVariables>;
export const AcceptNdaDocument = gql`
    mutation AcceptNda($input: AcceptNdaInput!) {
  documentOps {
    acceptNda(objectInput: $input) {
      nda {
        id
        signedByCurrentUser
      }
    }
  }
}
    `;
export type AcceptNdaMutationFn = Apollo.MutationFunction<GraphqlTypes.AcceptNdaMutation, GraphqlTypes.AcceptNdaMutationVariables>;

/**
 * __useAcceptNdaMutation__
 *
 * To run a mutation, you first call `useAcceptNdaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptNdaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptNdaMutation, { data, loading, error }] = useAcceptNdaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptNdaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AcceptNdaMutation, GraphqlTypes.AcceptNdaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AcceptNdaMutation, GraphqlTypes.AcceptNdaMutationVariables>(AcceptNdaDocument, options);
      }
export type AcceptNdaMutationHookResult = ReturnType<typeof useAcceptNdaMutation>;
export type AcceptNdaMutationResult = Apollo.MutationResult<GraphqlTypes.AcceptNdaMutation>;
export type AcceptNdaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AcceptNdaMutation, GraphqlTypes.AcceptNdaMutationVariables>;
export const GetUnauthenticatedDocumentDocument = gql`
    query GetUnauthenticatedDocument($id: ID!, $downloadKey: String!, $dataRoomKey: String, $viewToken: String) {
  document(
    id: $id
    downloadKey: $downloadKey
    dataRoomKey: $dataRoomKey
    viewToken: $viewToken
  ) {
    ...UnauthenticatedDocument
    ...DocumentNdaRequiredResponse
    ...DocumentActivationRequiredResponse
  }
}
    ${UnauthenticatedDocumentFragmentDoc}
${DocumentNdaRequiredResponseFragmentDoc}
${DocumentActivationRequiredResponseFragmentDoc}`;

/**
 * __useGetUnauthenticatedDocumentQuery__
 *
 * To run a query within a React component, call `useGetUnauthenticatedDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnauthenticatedDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnauthenticatedDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      downloadKey: // value for 'downloadKey'
 *      dataRoomKey: // value for 'dataRoomKey'
 *      viewToken: // value for 'viewToken'
 *   },
 * });
 */
export function useGetUnauthenticatedDocumentQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUnauthenticatedDocumentQuery, GraphqlTypes.GetUnauthenticatedDocumentQueryVariables> & ({ variables: GraphqlTypes.GetUnauthenticatedDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUnauthenticatedDocumentQuery, GraphqlTypes.GetUnauthenticatedDocumentQueryVariables>(GetUnauthenticatedDocumentDocument, options);
      }
export function useGetUnauthenticatedDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUnauthenticatedDocumentQuery, GraphqlTypes.GetUnauthenticatedDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUnauthenticatedDocumentQuery, GraphqlTypes.GetUnauthenticatedDocumentQueryVariables>(GetUnauthenticatedDocumentDocument, options);
        }
// @ts-ignore
export function useGetUnauthenticatedDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnauthenticatedDocumentQuery, GraphqlTypes.GetUnauthenticatedDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnauthenticatedDocumentQuery, GraphqlTypes.GetUnauthenticatedDocumentQueryVariables>;
export function useGetUnauthenticatedDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnauthenticatedDocumentQuery, GraphqlTypes.GetUnauthenticatedDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnauthenticatedDocumentQuery | undefined, GraphqlTypes.GetUnauthenticatedDocumentQueryVariables>;
export function useGetUnauthenticatedDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnauthenticatedDocumentQuery, GraphqlTypes.GetUnauthenticatedDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUnauthenticatedDocumentQuery, GraphqlTypes.GetUnauthenticatedDocumentQueryVariables>(GetUnauthenticatedDocumentDocument, options);
        }
export type GetUnauthenticatedDocumentQueryHookResult = ReturnType<typeof useGetUnauthenticatedDocumentQuery>;
export type GetUnauthenticatedDocumentLazyQueryHookResult = ReturnType<typeof useGetUnauthenticatedDocumentLazyQuery>;
export type GetUnauthenticatedDocumentSuspenseQueryHookResult = ReturnType<typeof useGetUnauthenticatedDocumentSuspenseQuery>;
export type GetUnauthenticatedDocumentQueryResult = Apollo.QueryResult<GraphqlTypes.GetUnauthenticatedDocumentQuery, GraphqlTypes.GetUnauthenticatedDocumentQueryVariables>;
export const AcceptUnauthenticatedNdaDocument = gql`
    mutation AcceptUnauthenticatedNda($input: UnauthenticatedAcceptNdaInput!) {
  unauthenticatedAcceptNda(objectInput: $input) {
    __typename
    ...UnauthenticatedNda
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    ${UnauthenticatedNdaFragmentDoc}`;
export type AcceptUnauthenticatedNdaMutationFn = Apollo.MutationFunction<GraphqlTypes.AcceptUnauthenticatedNdaMutation, GraphqlTypes.AcceptUnauthenticatedNdaMutationVariables>;

/**
 * __useAcceptUnauthenticatedNdaMutation__
 *
 * To run a mutation, you first call `useAcceptUnauthenticatedNdaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptUnauthenticatedNdaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptUnauthenticatedNdaMutation, { data, loading, error }] = useAcceptUnauthenticatedNdaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptUnauthenticatedNdaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AcceptUnauthenticatedNdaMutation, GraphqlTypes.AcceptUnauthenticatedNdaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AcceptUnauthenticatedNdaMutation, GraphqlTypes.AcceptUnauthenticatedNdaMutationVariables>(AcceptUnauthenticatedNdaDocument, options);
      }
export type AcceptUnauthenticatedNdaMutationHookResult = ReturnType<typeof useAcceptUnauthenticatedNdaMutation>;
export type AcceptUnauthenticatedNdaMutationResult = Apollo.MutationResult<GraphqlTypes.AcceptUnauthenticatedNdaMutation>;
export type AcceptUnauthenticatedNdaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AcceptUnauthenticatedNdaMutation, GraphqlTypes.AcceptUnauthenticatedNdaMutationVariables>;
export const GetPortalESignatureRequestsDocument = gql`
    query GetPortalESignatureRequests($arenaId: ID!, $objectType: Int, $objectId: Int) {
  portalESignatureRequests(
    arenaId: $arenaId
    objectType: $objectType
    objectId: $objectId
  ) {
    id
    requestName
    entityOrOfferingName
    objectType
    objectId
  }
}
    `;

/**
 * __useGetPortalESignatureRequestsQuery__
 *
 * To run a query within a React component, call `useGetPortalESignatureRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalESignatureRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalESignatureRequestsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetPortalESignatureRequestsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPortalESignatureRequestsQuery, GraphqlTypes.GetPortalESignatureRequestsQueryVariables> & ({ variables: GraphqlTypes.GetPortalESignatureRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPortalESignatureRequestsQuery, GraphqlTypes.GetPortalESignatureRequestsQueryVariables>(GetPortalESignatureRequestsDocument, options);
      }
export function useGetPortalESignatureRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPortalESignatureRequestsQuery, GraphqlTypes.GetPortalESignatureRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPortalESignatureRequestsQuery, GraphqlTypes.GetPortalESignatureRequestsQueryVariables>(GetPortalESignatureRequestsDocument, options);
        }
// @ts-ignore
export function useGetPortalESignatureRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalESignatureRequestsQuery, GraphqlTypes.GetPortalESignatureRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalESignatureRequestsQuery, GraphqlTypes.GetPortalESignatureRequestsQueryVariables>;
export function useGetPortalESignatureRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalESignatureRequestsQuery, GraphqlTypes.GetPortalESignatureRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalESignatureRequestsQuery | undefined, GraphqlTypes.GetPortalESignatureRequestsQueryVariables>;
export function useGetPortalESignatureRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalESignatureRequestsQuery, GraphqlTypes.GetPortalESignatureRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPortalESignatureRequestsQuery, GraphqlTypes.GetPortalESignatureRequestsQueryVariables>(GetPortalESignatureRequestsDocument, options);
        }
export type GetPortalESignatureRequestsQueryHookResult = ReturnType<typeof useGetPortalESignatureRequestsQuery>;
export type GetPortalESignatureRequestsLazyQueryHookResult = ReturnType<typeof useGetPortalESignatureRequestsLazyQuery>;
export type GetPortalESignatureRequestsSuspenseQueryHookResult = ReturnType<typeof useGetPortalESignatureRequestsSuspenseQuery>;
export type GetPortalESignatureRequestsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPortalESignatureRequestsQuery, GraphqlTypes.GetPortalESignatureRequestsQueryVariables>;
export const GetManagerArenasDocument = gql`
    query GetManagerArenas {
  managerArenas {
    id
    name
  }
}
    `;

/**
 * __useGetManagerArenasQuery__
 *
 * To run a query within a React component, call `useGetManagerArenasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerArenasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerArenasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagerArenasQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetManagerArenasQuery, GraphqlTypes.GetManagerArenasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetManagerArenasQuery, GraphqlTypes.GetManagerArenasQueryVariables>(GetManagerArenasDocument, options);
      }
export function useGetManagerArenasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetManagerArenasQuery, GraphqlTypes.GetManagerArenasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetManagerArenasQuery, GraphqlTypes.GetManagerArenasQueryVariables>(GetManagerArenasDocument, options);
        }
// @ts-ignore
export function useGetManagerArenasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerArenasQuery, GraphqlTypes.GetManagerArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManagerArenasQuery, GraphqlTypes.GetManagerArenasQueryVariables>;
export function useGetManagerArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerArenasQuery, GraphqlTypes.GetManagerArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManagerArenasQuery | undefined, GraphqlTypes.GetManagerArenasQueryVariables>;
export function useGetManagerArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerArenasQuery, GraphqlTypes.GetManagerArenasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetManagerArenasQuery, GraphqlTypes.GetManagerArenasQueryVariables>(GetManagerArenasDocument, options);
        }
export type GetManagerArenasQueryHookResult = ReturnType<typeof useGetManagerArenasQuery>;
export type GetManagerArenasLazyQueryHookResult = ReturnType<typeof useGetManagerArenasLazyQuery>;
export type GetManagerArenasSuspenseQueryHookResult = ReturnType<typeof useGetManagerArenasSuspenseQuery>;
export type GetManagerArenasQueryResult = Apollo.QueryResult<GraphqlTypes.GetManagerArenasQuery, GraphqlTypes.GetManagerArenasQueryVariables>;
export const GetEarliestEmailDocument = gql`
    query GetEarliestEmail($filters: EmailFilters) {
  emails(filters: $filters) {
    earliestSent
  }
}
    `;

/**
 * __useGetEarliestEmailQuery__
 *
 * To run a query within a React component, call `useGetEarliestEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEarliestEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEarliestEmailQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetEarliestEmailQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEarliestEmailQuery, GraphqlTypes.GetEarliestEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEarliestEmailQuery, GraphqlTypes.GetEarliestEmailQueryVariables>(GetEarliestEmailDocument, options);
      }
export function useGetEarliestEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEarliestEmailQuery, GraphqlTypes.GetEarliestEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEarliestEmailQuery, GraphqlTypes.GetEarliestEmailQueryVariables>(GetEarliestEmailDocument, options);
        }
// @ts-ignore
export function useGetEarliestEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEarliestEmailQuery, GraphqlTypes.GetEarliestEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEarliestEmailQuery, GraphqlTypes.GetEarliestEmailQueryVariables>;
export function useGetEarliestEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEarliestEmailQuery, GraphqlTypes.GetEarliestEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEarliestEmailQuery | undefined, GraphqlTypes.GetEarliestEmailQueryVariables>;
export function useGetEarliestEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEarliestEmailQuery, GraphqlTypes.GetEarliestEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEarliestEmailQuery, GraphqlTypes.GetEarliestEmailQueryVariables>(GetEarliestEmailDocument, options);
        }
export type GetEarliestEmailQueryHookResult = ReturnType<typeof useGetEarliestEmailQuery>;
export type GetEarliestEmailLazyQueryHookResult = ReturnType<typeof useGetEarliestEmailLazyQuery>;
export type GetEarliestEmailSuspenseQueryHookResult = ReturnType<typeof useGetEarliestEmailSuspenseQuery>;
export type GetEarliestEmailQueryResult = Apollo.QueryResult<GraphqlTypes.GetEarliestEmailQuery, GraphqlTypes.GetEarliestEmailQueryVariables>;
export const GetAllAvailableEntitiesDocument = gql`
    query GetAllAvailableEntities($filters: PortalEntityFilters) {
  unifiedPortalEntities(filters: $filters) {
    edges {
      node {
        id
        name
        arena {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllAvailableEntitiesQuery__
 *
 * To run a query within a React component, call `useGetAllAvailableEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAvailableEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAvailableEntitiesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAllAvailableEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAllAvailableEntitiesQuery, GraphqlTypes.GetAllAvailableEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllAvailableEntitiesQuery, GraphqlTypes.GetAllAvailableEntitiesQueryVariables>(GetAllAvailableEntitiesDocument, options);
      }
export function useGetAllAvailableEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllAvailableEntitiesQuery, GraphqlTypes.GetAllAvailableEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllAvailableEntitiesQuery, GraphqlTypes.GetAllAvailableEntitiesQueryVariables>(GetAllAvailableEntitiesDocument, options);
        }
// @ts-ignore
export function useGetAllAvailableEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllAvailableEntitiesQuery, GraphqlTypes.GetAllAvailableEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllAvailableEntitiesQuery, GraphqlTypes.GetAllAvailableEntitiesQueryVariables>;
export function useGetAllAvailableEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllAvailableEntitiesQuery, GraphqlTypes.GetAllAvailableEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllAvailableEntitiesQuery | undefined, GraphqlTypes.GetAllAvailableEntitiesQueryVariables>;
export function useGetAllAvailableEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllAvailableEntitiesQuery, GraphqlTypes.GetAllAvailableEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllAvailableEntitiesQuery, GraphqlTypes.GetAllAvailableEntitiesQueryVariables>(GetAllAvailableEntitiesDocument, options);
        }
export type GetAllAvailableEntitiesQueryHookResult = ReturnType<typeof useGetAllAvailableEntitiesQuery>;
export type GetAllAvailableEntitiesLazyQueryHookResult = ReturnType<typeof useGetAllAvailableEntitiesLazyQuery>;
export type GetAllAvailableEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetAllAvailableEntitiesSuspenseQuery>;
export type GetAllAvailableEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllAvailableEntitiesQuery, GraphqlTypes.GetAllAvailableEntitiesQueryVariables>;
export const GetOfferingsDocument = gql`
    query GetOfferings($filters: OfferingFilters) {
  offerings(filters: $filters) {
    edges {
      node {
        id
        name
        arena {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetOfferingsQuery__
 *
 * To run a query within a React component, call `useGetOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferingsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOfferingsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetOfferingsQuery, GraphqlTypes.GetOfferingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOfferingsQuery, GraphqlTypes.GetOfferingsQueryVariables>(GetOfferingsDocument, options);
      }
export function useGetOfferingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOfferingsQuery, GraphqlTypes.GetOfferingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOfferingsQuery, GraphqlTypes.GetOfferingsQueryVariables>(GetOfferingsDocument, options);
        }
// @ts-ignore
export function useGetOfferingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingsQuery, GraphqlTypes.GetOfferingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOfferingsQuery, GraphqlTypes.GetOfferingsQueryVariables>;
export function useGetOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingsQuery, GraphqlTypes.GetOfferingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOfferingsQuery | undefined, GraphqlTypes.GetOfferingsQueryVariables>;
export function useGetOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingsQuery, GraphqlTypes.GetOfferingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOfferingsQuery, GraphqlTypes.GetOfferingsQueryVariables>(GetOfferingsDocument, options);
        }
export type GetOfferingsQueryHookResult = ReturnType<typeof useGetOfferingsQuery>;
export type GetOfferingsLazyQueryHookResult = ReturnType<typeof useGetOfferingsLazyQuery>;
export type GetOfferingsSuspenseQueryHookResult = ReturnType<typeof useGetOfferingsSuspenseQuery>;
export type GetOfferingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetOfferingsQuery, GraphqlTypes.GetOfferingsQueryVariables>;
export const GetEmailDocument = gql`
    query GetEmail($id: ID!) {
  email(id: $id) {
    id
    subject
    dateSent
    bodyHtml
    investmentName
    senderName
    senderEmailAddress
    recipients {
      edges {
        node {
          id
          name
          emailAddress
          recipientType
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmailQuery__
 *
 * To run a query within a React component, call `useGetEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmailQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEmailQuery, GraphqlTypes.GetEmailQueryVariables> & ({ variables: GraphqlTypes.GetEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEmailQuery, GraphqlTypes.GetEmailQueryVariables>(GetEmailDocument, options);
      }
export function useGetEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEmailQuery, GraphqlTypes.GetEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEmailQuery, GraphqlTypes.GetEmailQueryVariables>(GetEmailDocument, options);
        }
// @ts-ignore
export function useGetEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailQuery, GraphqlTypes.GetEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailQuery, GraphqlTypes.GetEmailQueryVariables>;
export function useGetEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailQuery, GraphqlTypes.GetEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailQuery | undefined, GraphqlTypes.GetEmailQueryVariables>;
export function useGetEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailQuery, GraphqlTypes.GetEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEmailQuery, GraphqlTypes.GetEmailQueryVariables>(GetEmailDocument, options);
        }
export type GetEmailQueryHookResult = ReturnType<typeof useGetEmailQuery>;
export type GetEmailLazyQueryHookResult = ReturnType<typeof useGetEmailLazyQuery>;
export type GetEmailSuspenseQueryHookResult = ReturnType<typeof useGetEmailSuspenseQuery>;
export type GetEmailQueryResult = Apollo.QueryResult<GraphqlTypes.GetEmailQuery, GraphqlTypes.GetEmailQueryVariables>;
export const GetEmailsDocument = gql`
    query GetEmails($filters: EmailFilters, $after: String, $sort: [GlobalEmailQuerySortEnum]) {
  emails(filters: $filters, first: 50, after: $after, sort: $sort) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        investmentName
        arena {
          id
          name
        }
        subject
        dateSent
      }
    }
    count
  }
}
    `;

/**
 * __useGetEmailsQuery__
 *
 * To run a query within a React component, call `useGetEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEmailsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEmailsQuery, GraphqlTypes.GetEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEmailsQuery, GraphqlTypes.GetEmailsQueryVariables>(GetEmailsDocument, options);
      }
export function useGetEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEmailsQuery, GraphqlTypes.GetEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEmailsQuery, GraphqlTypes.GetEmailsQueryVariables>(GetEmailsDocument, options);
        }
// @ts-ignore
export function useGetEmailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailsQuery, GraphqlTypes.GetEmailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailsQuery, GraphqlTypes.GetEmailsQueryVariables>;
export function useGetEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailsQuery, GraphqlTypes.GetEmailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailsQuery | undefined, GraphqlTypes.GetEmailsQueryVariables>;
export function useGetEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailsQuery, GraphqlTypes.GetEmailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEmailsQuery, GraphqlTypes.GetEmailsQueryVariables>(GetEmailsDocument, options);
        }
export type GetEmailsQueryHookResult = ReturnType<typeof useGetEmailsQuery>;
export type GetEmailsLazyQueryHookResult = ReturnType<typeof useGetEmailsLazyQuery>;
export type GetEmailsSuspenseQueryHookResult = ReturnType<typeof useGetEmailsSuspenseQuery>;
export type GetEmailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEmailsQuery, GraphqlTypes.GetEmailsQueryVariables>;
export const DownloadAllAssetsPortalDocument = gql`
    mutation DownloadAllAssetsPortal($headers: [String], $filters: InvestmentFilters, $period: String, $year: Int, $showOutOfDate: Boolean) {
  assetOps {
    downloadAllAssetsPortal(
      headers: $headers
      filters: $filters
      period: $period
      year: $year
      showOutOfDate: $showOutOfDate
    ) {
      job {
        id
      }
    }
  }
}
    `;
export type DownloadAllAssetsPortalMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadAllAssetsPortalMutation, GraphqlTypes.DownloadAllAssetsPortalMutationVariables>;

/**
 * __useDownloadAllAssetsPortalMutation__
 *
 * To run a mutation, you first call `useDownloadAllAssetsPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAllAssetsPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAllAssetsPortalMutation, { data, loading, error }] = useDownloadAllAssetsPortalMutation({
 *   variables: {
 *      headers: // value for 'headers'
 *      filters: // value for 'filters'
 *      period: // value for 'period'
 *      year: // value for 'year'
 *      showOutOfDate: // value for 'showOutOfDate'
 *   },
 * });
 */
export function useDownloadAllAssetsPortalMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadAllAssetsPortalMutation, GraphqlTypes.DownloadAllAssetsPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadAllAssetsPortalMutation, GraphqlTypes.DownloadAllAssetsPortalMutationVariables>(DownloadAllAssetsPortalDocument, options);
      }
export type DownloadAllAssetsPortalMutationHookResult = ReturnType<typeof useDownloadAllAssetsPortalMutation>;
export type DownloadAllAssetsPortalMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadAllAssetsPortalMutation>;
export type DownloadAllAssetsPortalMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadAllAssetsPortalMutation, GraphqlTypes.DownloadAllAssetsPortalMutationVariables>;
export const DownloadInvestorReportPortalDocument = gql`
    mutation DownloadInvestorReportPortal($arenaId: ID!) {
  portalInvestorReportOps {
    downloadInvestorReportPortal(managerArenaId: $arenaId) {
      job {
        id
      }
    }
  }
}
    `;
export type DownloadInvestorReportPortalMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadInvestorReportPortalMutation, GraphqlTypes.DownloadInvestorReportPortalMutationVariables>;

/**
 * __useDownloadInvestorReportPortalMutation__
 *
 * To run a mutation, you first call `useDownloadInvestorReportPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadInvestorReportPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadInvestorReportPortalMutation, { data, loading, error }] = useDownloadInvestorReportPortalMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useDownloadInvestorReportPortalMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadInvestorReportPortalMutation, GraphqlTypes.DownloadInvestorReportPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadInvestorReportPortalMutation, GraphqlTypes.DownloadInvestorReportPortalMutationVariables>(DownloadInvestorReportPortalDocument, options);
      }
export type DownloadInvestorReportPortalMutationHookResult = ReturnType<typeof useDownloadInvestorReportPortalMutation>;
export type DownloadInvestorReportPortalMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadInvestorReportPortalMutation>;
export type DownloadInvestorReportPortalMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadInvestorReportPortalMutation, GraphqlTypes.DownloadInvestorReportPortalMutationVariables>;
export const GetInvestmentsLocationsDocument = gql`
    query GetInvestmentsLocations($filters: InvestmentFilters, $arenaId: ID!) {
  rootPositionInvestments(filters: $filters, arenaId: $arenaId) {
    id
    positionsWithAssetLocations {
      arenaId
      positions {
        positionId
        currency
        assets {
          assetId
          locations {
            latitude
            longitude
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetInvestmentsLocationsQuery__
 *
 * To run a query within a React component, call `useGetInvestmentsLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentsLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentsLocationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetInvestmentsLocationsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentsLocationsQuery, GraphqlTypes.GetInvestmentsLocationsQueryVariables> & ({ variables: GraphqlTypes.GetInvestmentsLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentsLocationsQuery, GraphqlTypes.GetInvestmentsLocationsQueryVariables>(GetInvestmentsLocationsDocument, options);
      }
export function useGetInvestmentsLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentsLocationsQuery, GraphqlTypes.GetInvestmentsLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentsLocationsQuery, GraphqlTypes.GetInvestmentsLocationsQueryVariables>(GetInvestmentsLocationsDocument, options);
        }
// @ts-ignore
export function useGetInvestmentsLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentsLocationsQuery, GraphqlTypes.GetInvestmentsLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentsLocationsQuery, GraphqlTypes.GetInvestmentsLocationsQueryVariables>;
export function useGetInvestmentsLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentsLocationsQuery, GraphqlTypes.GetInvestmentsLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentsLocationsQuery | undefined, GraphqlTypes.GetInvestmentsLocationsQueryVariables>;
export function useGetInvestmentsLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentsLocationsQuery, GraphqlTypes.GetInvestmentsLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentsLocationsQuery, GraphqlTypes.GetInvestmentsLocationsQueryVariables>(GetInvestmentsLocationsDocument, options);
        }
export type GetInvestmentsLocationsQueryHookResult = ReturnType<typeof useGetInvestmentsLocationsQuery>;
export type GetInvestmentsLocationsLazyQueryHookResult = ReturnType<typeof useGetInvestmentsLocationsLazyQuery>;
export type GetInvestmentsLocationsSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentsLocationsSuspenseQuery>;
export type GetInvestmentsLocationsQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentsLocationsQuery, GraphqlTypes.GetInvestmentsLocationsQueryVariables>;
export const GetFeatureFlagDocument = gql`
    query getFeatureFlag {
  devFeatures {
    lpZendeskFeatureFlag
  }
}
    `;

/**
 * __useGetFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetFeatureFlagQuery, GraphqlTypes.GetFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFeatureFlagQuery, GraphqlTypes.GetFeatureFlagQueryVariables>(GetFeatureFlagDocument, options);
      }
export function useGetFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFeatureFlagQuery, GraphqlTypes.GetFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFeatureFlagQuery, GraphqlTypes.GetFeatureFlagQueryVariables>(GetFeatureFlagDocument, options);
        }
// @ts-ignore
export function useGetFeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFeatureFlagQuery, GraphqlTypes.GetFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFeatureFlagQuery, GraphqlTypes.GetFeatureFlagQueryVariables>;
export function useGetFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFeatureFlagQuery, GraphqlTypes.GetFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFeatureFlagQuery | undefined, GraphqlTypes.GetFeatureFlagQueryVariables>;
export function useGetFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFeatureFlagQuery, GraphqlTypes.GetFeatureFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFeatureFlagQuery, GraphqlTypes.GetFeatureFlagQueryVariables>(GetFeatureFlagDocument, options);
        }
export type GetFeatureFlagQueryHookResult = ReturnType<typeof useGetFeatureFlagQuery>;
export type GetFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagLazyQuery>;
export type GetFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetFeatureFlagSuspenseQuery>;
export type GetFeatureFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GetFeatureFlagQuery, GraphqlTypes.GetFeatureFlagQueryVariables>;
export const GetOfferingsForPortalUserDocument = gql`
    query GetOfferingsForPortalUser($filters: OfferingFilters, $limit: Int) {
  offerings(first: $limit, filters: $filters) {
    count
    edges {
      node {
        id
        lpDisplayName
        name
        currency {
          id
          code
          fullName
          symbol
        }
        arena {
          id
          name
          secondLevelDomain
          jsqHostname
        }
        prospects {
          edges {
            node {
              id
              prospectContactNameConcatenation
              subscription {
                id
                isEditable
                status
              }
              prospectContactMaps {
                id
                dataRoomKey
                isLpInvited
              }
            }
          }
        }
        dataRoom {
          id
          summary
          published
          size
          closingDate
          irrMin
          irrMax
          equityMultipleMin
          equityMultipleMax
          locations {
            id
            city
            state {
              id
              code
            }
            latitude
            longitude
          }
          extensionFields {
            extensionField {
              id
              name
            }
            values {
              enumValue {
                id
                enumValueLabel
              }
            }
          }
          photos {
            id
            title
            photoUrl(width: 200, height: 200, option: 4)
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOfferingsForPortalUserQuery__
 *
 * To run a query within a React component, call `useGetOfferingsForPortalUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferingsForPortalUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferingsForPortalUserQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetOfferingsForPortalUserQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetOfferingsForPortalUserQuery, GraphqlTypes.GetOfferingsForPortalUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOfferingsForPortalUserQuery, GraphqlTypes.GetOfferingsForPortalUserQueryVariables>(GetOfferingsForPortalUserDocument, options);
      }
export function useGetOfferingsForPortalUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOfferingsForPortalUserQuery, GraphqlTypes.GetOfferingsForPortalUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOfferingsForPortalUserQuery, GraphqlTypes.GetOfferingsForPortalUserQueryVariables>(GetOfferingsForPortalUserDocument, options);
        }
// @ts-ignore
export function useGetOfferingsForPortalUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingsForPortalUserQuery, GraphqlTypes.GetOfferingsForPortalUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOfferingsForPortalUserQuery, GraphqlTypes.GetOfferingsForPortalUserQueryVariables>;
export function useGetOfferingsForPortalUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingsForPortalUserQuery, GraphqlTypes.GetOfferingsForPortalUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOfferingsForPortalUserQuery | undefined, GraphqlTypes.GetOfferingsForPortalUserQueryVariables>;
export function useGetOfferingsForPortalUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingsForPortalUserQuery, GraphqlTypes.GetOfferingsForPortalUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOfferingsForPortalUserQuery, GraphqlTypes.GetOfferingsForPortalUserQueryVariables>(GetOfferingsForPortalUserDocument, options);
        }
export type GetOfferingsForPortalUserQueryHookResult = ReturnType<typeof useGetOfferingsForPortalUserQuery>;
export type GetOfferingsForPortalUserLazyQueryHookResult = ReturnType<typeof useGetOfferingsForPortalUserLazyQuery>;
export type GetOfferingsForPortalUserSuspenseQueryHookResult = ReturnType<typeof useGetOfferingsForPortalUserSuspenseQuery>;
export type GetOfferingsForPortalUserQueryResult = Apollo.QueryResult<GraphqlTypes.GetOfferingsForPortalUserQuery, GraphqlTypes.GetOfferingsForPortalUserQueryVariables>;
export const GetIsOnboardingRequiredForArenaDocument = gql`
    query GetIsOnboardingRequiredForArena($arenaDomain: String!) {
  currentGlobalUser {
    id
    isOnboardingRequired(arenaDomain: $arenaDomain)
  }
}
    `;

/**
 * __useGetIsOnboardingRequiredForArenaQuery__
 *
 * To run a query within a React component, call `useGetIsOnboardingRequiredForArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsOnboardingRequiredForArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsOnboardingRequiredForArenaQuery({
 *   variables: {
 *      arenaDomain: // value for 'arenaDomain'
 *   },
 * });
 */
export function useGetIsOnboardingRequiredForArenaQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetIsOnboardingRequiredForArenaQuery, GraphqlTypes.GetIsOnboardingRequiredForArenaQueryVariables> & ({ variables: GraphqlTypes.GetIsOnboardingRequiredForArenaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetIsOnboardingRequiredForArenaQuery, GraphqlTypes.GetIsOnboardingRequiredForArenaQueryVariables>(GetIsOnboardingRequiredForArenaDocument, options);
      }
export function useGetIsOnboardingRequiredForArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetIsOnboardingRequiredForArenaQuery, GraphqlTypes.GetIsOnboardingRequiredForArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetIsOnboardingRequiredForArenaQuery, GraphqlTypes.GetIsOnboardingRequiredForArenaQueryVariables>(GetIsOnboardingRequiredForArenaDocument, options);
        }
// @ts-ignore
export function useGetIsOnboardingRequiredForArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIsOnboardingRequiredForArenaQuery, GraphqlTypes.GetIsOnboardingRequiredForArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIsOnboardingRequiredForArenaQuery, GraphqlTypes.GetIsOnboardingRequiredForArenaQueryVariables>;
export function useGetIsOnboardingRequiredForArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIsOnboardingRequiredForArenaQuery, GraphqlTypes.GetIsOnboardingRequiredForArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIsOnboardingRequiredForArenaQuery | undefined, GraphqlTypes.GetIsOnboardingRequiredForArenaQueryVariables>;
export function useGetIsOnboardingRequiredForArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIsOnboardingRequiredForArenaQuery, GraphqlTypes.GetIsOnboardingRequiredForArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetIsOnboardingRequiredForArenaQuery, GraphqlTypes.GetIsOnboardingRequiredForArenaQueryVariables>(GetIsOnboardingRequiredForArenaDocument, options);
        }
export type GetIsOnboardingRequiredForArenaQueryHookResult = ReturnType<typeof useGetIsOnboardingRequiredForArenaQuery>;
export type GetIsOnboardingRequiredForArenaLazyQueryHookResult = ReturnType<typeof useGetIsOnboardingRequiredForArenaLazyQuery>;
export type GetIsOnboardingRequiredForArenaSuspenseQueryHookResult = ReturnType<typeof useGetIsOnboardingRequiredForArenaSuspenseQuery>;
export type GetIsOnboardingRequiredForArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetIsOnboardingRequiredForArenaQuery, GraphqlTypes.GetIsOnboardingRequiredForArenaQueryVariables>;
export const GetEntitySoiSettingsDocument = gql`
    query GetEntitySoiSettings($id: ID!) {
  investmentEntity(id: $id) {
    id
    soiDisplayConfig {
      showSoiInLpPortal
      hideDateColumn
      hideUnitsColumn
      hideCostPerUnitColumn
      hideValuePerUnitColumn
      hideCostColumn
      hideFairValueColumn
      hideUnrealizedValueColumn
    }
  }
}
    `;

/**
 * __useGetEntitySoiSettingsQuery__
 *
 * To run a query within a React component, call `useGetEntitySoiSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitySoiSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitySoiSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEntitySoiSettingsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntitySoiSettingsQuery, GraphqlTypes.GetEntitySoiSettingsQueryVariables> & ({ variables: GraphqlTypes.GetEntitySoiSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntitySoiSettingsQuery, GraphqlTypes.GetEntitySoiSettingsQueryVariables>(GetEntitySoiSettingsDocument, options);
      }
export function useGetEntitySoiSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntitySoiSettingsQuery, GraphqlTypes.GetEntitySoiSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntitySoiSettingsQuery, GraphqlTypes.GetEntitySoiSettingsQueryVariables>(GetEntitySoiSettingsDocument, options);
        }
// @ts-ignore
export function useGetEntitySoiSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitySoiSettingsQuery, GraphqlTypes.GetEntitySoiSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitySoiSettingsQuery, GraphqlTypes.GetEntitySoiSettingsQueryVariables>;
export function useGetEntitySoiSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitySoiSettingsQuery, GraphqlTypes.GetEntitySoiSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitySoiSettingsQuery | undefined, GraphqlTypes.GetEntitySoiSettingsQueryVariables>;
export function useGetEntitySoiSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitySoiSettingsQuery, GraphqlTypes.GetEntitySoiSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntitySoiSettingsQuery, GraphqlTypes.GetEntitySoiSettingsQueryVariables>(GetEntitySoiSettingsDocument, options);
        }
export type GetEntitySoiSettingsQueryHookResult = ReturnType<typeof useGetEntitySoiSettingsQuery>;
export type GetEntitySoiSettingsLazyQueryHookResult = ReturnType<typeof useGetEntitySoiSettingsLazyQuery>;
export type GetEntitySoiSettingsSuspenseQueryHookResult = ReturnType<typeof useGetEntitySoiSettingsSuspenseQuery>;
export type GetEntitySoiSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntitySoiSettingsQuery, GraphqlTypes.GetEntitySoiSettingsQueryVariables>;
export const GetPositionArenaDocument = gql`
    query GetPositionArena {
  managerArenas {
    secondLevelDomain
    features {
      hasGlDataForSoi
    }
  }
}
    `;

/**
 * __useGetPositionArenaQuery__
 *
 * To run a query within a React component, call `useGetPositionArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionArenaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPositionArenaQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPositionArenaQuery, GraphqlTypes.GetPositionArenaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionArenaQuery, GraphqlTypes.GetPositionArenaQueryVariables>(GetPositionArenaDocument, options);
      }
export function useGetPositionArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionArenaQuery, GraphqlTypes.GetPositionArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionArenaQuery, GraphqlTypes.GetPositionArenaQueryVariables>(GetPositionArenaDocument, options);
        }
// @ts-ignore
export function useGetPositionArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionArenaQuery, GraphqlTypes.GetPositionArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionArenaQuery, GraphqlTypes.GetPositionArenaQueryVariables>;
export function useGetPositionArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionArenaQuery, GraphqlTypes.GetPositionArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionArenaQuery | undefined, GraphqlTypes.GetPositionArenaQueryVariables>;
export function useGetPositionArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionArenaQuery, GraphqlTypes.GetPositionArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionArenaQuery, GraphqlTypes.GetPositionArenaQueryVariables>(GetPositionArenaDocument, options);
        }
export type GetPositionArenaQueryHookResult = ReturnType<typeof useGetPositionArenaQuery>;
export type GetPositionArenaLazyQueryHookResult = ReturnType<typeof useGetPositionArenaLazyQuery>;
export type GetPositionArenaSuspenseQueryHookResult = ReturnType<typeof useGetPositionArenaSuspenseQuery>;
export type GetPositionArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionArenaQuery, GraphqlTypes.GetPositionArenaQueryVariables>;
export const GetPositionOverviewForSummaryDocument = gql`
    query getPositionOverviewForSummary($id: ID!) {
  position(id: $id) {
    id
    investmentEntity {
      id
      publishedAssetsIndirect {
        edges {
          node {
            id
            name
            isSold
            saleDate
            ...AssetLocations
          }
        }
        count
      }
      opCosIndirect {
        opcoId
        parentEntityId
        name
        lpDisplayName
        published
        overviewAndFinancialsVisible
        sector
        logo {
          id
          photoUrl
        }
      }
    }
  }
}
    ${AssetLocationsFragmentDoc}`;

/**
 * __useGetPositionOverviewForSummaryQuery__
 *
 * To run a query within a React component, call `useGetPositionOverviewForSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionOverviewForSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionOverviewForSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPositionOverviewForSummaryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionOverviewForSummaryQuery, GraphqlTypes.GetPositionOverviewForSummaryQueryVariables> & ({ variables: GraphqlTypes.GetPositionOverviewForSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionOverviewForSummaryQuery, GraphqlTypes.GetPositionOverviewForSummaryQueryVariables>(GetPositionOverviewForSummaryDocument, options);
      }
export function useGetPositionOverviewForSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionOverviewForSummaryQuery, GraphqlTypes.GetPositionOverviewForSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionOverviewForSummaryQuery, GraphqlTypes.GetPositionOverviewForSummaryQueryVariables>(GetPositionOverviewForSummaryDocument, options);
        }
// @ts-ignore
export function useGetPositionOverviewForSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionOverviewForSummaryQuery, GraphqlTypes.GetPositionOverviewForSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionOverviewForSummaryQuery, GraphqlTypes.GetPositionOverviewForSummaryQueryVariables>;
export function useGetPositionOverviewForSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionOverviewForSummaryQuery, GraphqlTypes.GetPositionOverviewForSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionOverviewForSummaryQuery | undefined, GraphqlTypes.GetPositionOverviewForSummaryQueryVariables>;
export function useGetPositionOverviewForSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionOverviewForSummaryQuery, GraphqlTypes.GetPositionOverviewForSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionOverviewForSummaryQuery, GraphqlTypes.GetPositionOverviewForSummaryQueryVariables>(GetPositionOverviewForSummaryDocument, options);
        }
export type GetPositionOverviewForSummaryQueryHookResult = ReturnType<typeof useGetPositionOverviewForSummaryQuery>;
export type GetPositionOverviewForSummaryLazyQueryHookResult = ReturnType<typeof useGetPositionOverviewForSummaryLazyQuery>;
export type GetPositionOverviewForSummarySuspenseQueryHookResult = ReturnType<typeof useGetPositionOverviewForSummarySuspenseQuery>;
export type GetPositionOverviewForSummaryQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionOverviewForSummaryQuery, GraphqlTypes.GetPositionOverviewForSummaryQueryVariables>;
export const GetPositionActivityFeedDocument = gql`
    query getPositionActivityFeed($positionId: ID!, $startTimestamp: String, $quantity: Int) {
  activityFeedWrapper(
    positionId: $positionId
    startTimestamp: $startTimestamp
    quantity: $quantity
  ) {
    newStartTimestamp
    items {
      attachments {
        documentName
        url
      }
      activityType
      activityObject {
        ...ActivityFeedObjectFields
      }
      emailId
      effectiveDate
      arenaAdjustedDate
      regarding
      timestamp
      recipientsLabel
    }
  }
}
    ${ActivityFeedObjectFieldsFragmentDoc}`;

/**
 * __useGetPositionActivityFeedQuery__
 *
 * To run a query within a React component, call `useGetPositionActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionActivityFeedQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      startTimestamp: // value for 'startTimestamp'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useGetPositionActivityFeedQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionActivityFeedQuery, GraphqlTypes.GetPositionActivityFeedQueryVariables> & ({ variables: GraphqlTypes.GetPositionActivityFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionActivityFeedQuery, GraphqlTypes.GetPositionActivityFeedQueryVariables>(GetPositionActivityFeedDocument, options);
      }
export function useGetPositionActivityFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionActivityFeedQuery, GraphqlTypes.GetPositionActivityFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionActivityFeedQuery, GraphqlTypes.GetPositionActivityFeedQueryVariables>(GetPositionActivityFeedDocument, options);
        }
// @ts-ignore
export function useGetPositionActivityFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionActivityFeedQuery, GraphqlTypes.GetPositionActivityFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionActivityFeedQuery, GraphqlTypes.GetPositionActivityFeedQueryVariables>;
export function useGetPositionActivityFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionActivityFeedQuery, GraphqlTypes.GetPositionActivityFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionActivityFeedQuery | undefined, GraphqlTypes.GetPositionActivityFeedQueryVariables>;
export function useGetPositionActivityFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionActivityFeedQuery, GraphqlTypes.GetPositionActivityFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionActivityFeedQuery, GraphqlTypes.GetPositionActivityFeedQueryVariables>(GetPositionActivityFeedDocument, options);
        }
export type GetPositionActivityFeedQueryHookResult = ReturnType<typeof useGetPositionActivityFeedQuery>;
export type GetPositionActivityFeedLazyQueryHookResult = ReturnType<typeof useGetPositionActivityFeedLazyQuery>;
export type GetPositionActivityFeedSuspenseQueryHookResult = ReturnType<typeof useGetPositionActivityFeedSuspenseQuery>;
export type GetPositionActivityFeedQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionActivityFeedQuery, GraphqlTypes.GetPositionActivityFeedQueryVariables>;
export const GetEntityTransactionTotalsDocument = gql`
    query GetEntityTransactionTotals($entityId: ID!) {
  investmentEntity(id: $entityId) {
    id
    showCapitalAccountBalance
    showNavBalance
    showInvestedEquityBalance
    currency {
      id
      code
    }
    contributionTypeTotals {
      transactionTypeName
      amount {
        monies
      }
    }
    redemptionTypeTotals {
      transactionTypeName
      amount {
        monies
      }
    }
    entityTransactionTotals {
      lifetimeCapitalOut {
        monies
      }
      lifetimeCapitalContributed {
        monies
      }
      lifetimeAmountDistributed {
        monies
      }
      lifetimeAmountReturned {
        monies
      }
      lifetimeAmountPassedThrough {
        monies
      }
      capitalAccountBalance {
        monies
      }
      investedEquityBalance {
        monies
      }
      navBalance {
        monies
      }
    }
  }
}
    `;

/**
 * __useGetEntityTransactionTotalsQuery__
 *
 * To run a query within a React component, call `useGetEntityTransactionTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityTransactionTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityTransactionTotalsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityTransactionTotalsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityTransactionTotalsQuery, GraphqlTypes.GetEntityTransactionTotalsQueryVariables> & ({ variables: GraphqlTypes.GetEntityTransactionTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityTransactionTotalsQuery, GraphqlTypes.GetEntityTransactionTotalsQueryVariables>(GetEntityTransactionTotalsDocument, options);
      }
export function useGetEntityTransactionTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityTransactionTotalsQuery, GraphqlTypes.GetEntityTransactionTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityTransactionTotalsQuery, GraphqlTypes.GetEntityTransactionTotalsQueryVariables>(GetEntityTransactionTotalsDocument, options);
        }
// @ts-ignore
export function useGetEntityTransactionTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityTransactionTotalsQuery, GraphqlTypes.GetEntityTransactionTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityTransactionTotalsQuery, GraphqlTypes.GetEntityTransactionTotalsQueryVariables>;
export function useGetEntityTransactionTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityTransactionTotalsQuery, GraphqlTypes.GetEntityTransactionTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityTransactionTotalsQuery | undefined, GraphqlTypes.GetEntityTransactionTotalsQueryVariables>;
export function useGetEntityTransactionTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityTransactionTotalsQuery, GraphqlTypes.GetEntityTransactionTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityTransactionTotalsQuery, GraphqlTypes.GetEntityTransactionTotalsQueryVariables>(GetEntityTransactionTotalsDocument, options);
        }
export type GetEntityTransactionTotalsQueryHookResult = ReturnType<typeof useGetEntityTransactionTotalsQuery>;
export type GetEntityTransactionTotalsLazyQueryHookResult = ReturnType<typeof useGetEntityTransactionTotalsLazyQuery>;
export type GetEntityTransactionTotalsSuspenseQueryHookResult = ReturnType<typeof useGetEntityTransactionTotalsSuspenseQuery>;
export type GetEntityTransactionTotalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityTransactionTotalsQuery, GraphqlTypes.GetEntityTransactionTotalsQueryVariables>;
export const GetCapitalActivityDetailsByIdDocument = gql`
    query getCapitalActivityDetailsById($id: ID!) {
  transaction(id: $id) {
    id
    paymentDate
    paymentMethod
    description
    rebalancingTransactions {
      id
      position {
        entityCurrency
      }
      details {
        edges {
          node {
            id
            amount {
              monies
            }
            transactionType {
              id
              name
              isSubType
            }
          }
        }
      }
      allAmounts {
        monies
      }
      batch {
        id
        batchCategory
        rebalancedCapitalCallBatch {
          id
          effectiveDate
          description
        }
      }
    }
    batch {
      id
      description
      effectiveDate
      batchCategory
      containsRebalancing
      transactionType {
        id
        name
        isPositive
        isNegative
      }
    }
    details {
      edges {
        node {
          id
          amount {
            monies
          }
          transactionType {
            id
            name
            isSubType
          }
        }
      }
    }
    redemptionDetails {
      redemptionDetailList {
        lotDate
        unitsAvailable
        redeemedAmount {
          monies
        }
        amountAvailable {
          monies
        }
      }
      unitValue {
        id
      }
      positionBalance {
        monies
      }
    }
    pricePerUnit {
      monies
    }
    position {
      id
      entityCurrency
      account {
        id
        lpDisplayName
      }
      ownershipUnit {
        id
        shortName
        precisionMetrics
        precisionPortal
        isMethodUnit
        isMethodContribution
      }
      showOwnershipAsCommitment
    }
    positionDelta {
      id
      deltaUnitCount
    }
    capitalCall {
      id
      batch {
        id
        description
        effectiveDate
      }
    }
  }
}
    `;

/**
 * __useGetCapitalActivityDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetCapitalActivityDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapitalActivityDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapitalActivityDetailsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCapitalActivityDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCapitalActivityDetailsByIdQuery, GraphqlTypes.GetCapitalActivityDetailsByIdQueryVariables> & ({ variables: GraphqlTypes.GetCapitalActivityDetailsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCapitalActivityDetailsByIdQuery, GraphqlTypes.GetCapitalActivityDetailsByIdQueryVariables>(GetCapitalActivityDetailsByIdDocument, options);
      }
export function useGetCapitalActivityDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCapitalActivityDetailsByIdQuery, GraphqlTypes.GetCapitalActivityDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCapitalActivityDetailsByIdQuery, GraphqlTypes.GetCapitalActivityDetailsByIdQueryVariables>(GetCapitalActivityDetailsByIdDocument, options);
        }
// @ts-ignore
export function useGetCapitalActivityDetailsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalActivityDetailsByIdQuery, GraphqlTypes.GetCapitalActivityDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalActivityDetailsByIdQuery, GraphqlTypes.GetCapitalActivityDetailsByIdQueryVariables>;
export function useGetCapitalActivityDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalActivityDetailsByIdQuery, GraphqlTypes.GetCapitalActivityDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalActivityDetailsByIdQuery | undefined, GraphqlTypes.GetCapitalActivityDetailsByIdQueryVariables>;
export function useGetCapitalActivityDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalActivityDetailsByIdQuery, GraphqlTypes.GetCapitalActivityDetailsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCapitalActivityDetailsByIdQuery, GraphqlTypes.GetCapitalActivityDetailsByIdQueryVariables>(GetCapitalActivityDetailsByIdDocument, options);
        }
export type GetCapitalActivityDetailsByIdQueryHookResult = ReturnType<typeof useGetCapitalActivityDetailsByIdQuery>;
export type GetCapitalActivityDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetCapitalActivityDetailsByIdLazyQuery>;
export type GetCapitalActivityDetailsByIdSuspenseQueryHookResult = ReturnType<typeof useGetCapitalActivityDetailsByIdSuspenseQuery>;
export type GetCapitalActivityDetailsByIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetCapitalActivityDetailsByIdQuery, GraphqlTypes.GetCapitalActivityDetailsByIdQueryVariables>;
export const GetCapitalActivityBatchTotalDetailsDocument = gql`
    query GetCapitalActivityBatchTotalDetails($id: ID!) {
  transaction(id: $id) {
    id
    position {
      entityCurrency
    }
    rebalancingTransactions {
      id
      position {
        entityCurrency
      }
      batch {
        id
        batchTotalDetails {
          transactionType {
            id
            name
            isSubType
          }
          amount {
            monies
          }
        }
      }
    }
    batch {
      id
      batchTotalDetails {
        transactionType {
          id
          name
          isSubType
        }
        amount {
          monies
        }
      }
    }
  }
}
    `;

/**
 * __useGetCapitalActivityBatchTotalDetailsQuery__
 *
 * To run a query within a React component, call `useGetCapitalActivityBatchTotalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapitalActivityBatchTotalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapitalActivityBatchTotalDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCapitalActivityBatchTotalDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCapitalActivityBatchTotalDetailsQuery, GraphqlTypes.GetCapitalActivityBatchTotalDetailsQueryVariables> & ({ variables: GraphqlTypes.GetCapitalActivityBatchTotalDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCapitalActivityBatchTotalDetailsQuery, GraphqlTypes.GetCapitalActivityBatchTotalDetailsQueryVariables>(GetCapitalActivityBatchTotalDetailsDocument, options);
      }
export function useGetCapitalActivityBatchTotalDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCapitalActivityBatchTotalDetailsQuery, GraphqlTypes.GetCapitalActivityBatchTotalDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCapitalActivityBatchTotalDetailsQuery, GraphqlTypes.GetCapitalActivityBatchTotalDetailsQueryVariables>(GetCapitalActivityBatchTotalDetailsDocument, options);
        }
// @ts-ignore
export function useGetCapitalActivityBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalActivityBatchTotalDetailsQuery, GraphqlTypes.GetCapitalActivityBatchTotalDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalActivityBatchTotalDetailsQuery, GraphqlTypes.GetCapitalActivityBatchTotalDetailsQueryVariables>;
export function useGetCapitalActivityBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalActivityBatchTotalDetailsQuery, GraphqlTypes.GetCapitalActivityBatchTotalDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalActivityBatchTotalDetailsQuery | undefined, GraphqlTypes.GetCapitalActivityBatchTotalDetailsQueryVariables>;
export function useGetCapitalActivityBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalActivityBatchTotalDetailsQuery, GraphqlTypes.GetCapitalActivityBatchTotalDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCapitalActivityBatchTotalDetailsQuery, GraphqlTypes.GetCapitalActivityBatchTotalDetailsQueryVariables>(GetCapitalActivityBatchTotalDetailsDocument, options);
        }
export type GetCapitalActivityBatchTotalDetailsQueryHookResult = ReturnType<typeof useGetCapitalActivityBatchTotalDetailsQuery>;
export type GetCapitalActivityBatchTotalDetailsLazyQueryHookResult = ReturnType<typeof useGetCapitalActivityBatchTotalDetailsLazyQuery>;
export type GetCapitalActivityBatchTotalDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCapitalActivityBatchTotalDetailsSuspenseQuery>;
export type GetCapitalActivityBatchTotalDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetCapitalActivityBatchTotalDetailsQuery, GraphqlTypes.GetCapitalActivityBatchTotalDetailsQueryVariables>;
export const GetCapitalActivityByPositionIdDocument = gql`
    query getCapitalActivityByPositionId($id: ID!, $after: String) {
  position(id: $id) {
    id
    entityCurrency
    arena {
      id
      isAdjustMetricsProvisioned
    }
    showOwnershipAsCommitment
    ownershipUnit {
      id
      name
      precisionMetrics
      precisionPortal
      isMethodUnit
    }
    transactionTotals {
      lifetimeAmountReceived {
        monies
      }
      lifetimeTotalCapitalOut {
        monies
      }
    }
    investmentEntity {
      id
      name
      showEntityTotalsOnNp
      manualUnitSettingsEnabled
    }
  }
  transactions(
    positionId: $id
    sort: [EFFECTIVE_DATE_DESC, ID_DESC]
    first: 50
    after: $after
  ) {
    count
    totalCapitalIn {
      monies
    }
    totalCapitalOut {
      monies
    }
    edges {
      node {
        id
        paymentDate
        rebalancingTransactions {
          id
          allAmounts {
            monies
          }
        }
        positionDelta {
          id
          deltaUnitCount
        }
        batch {
          id
          effectiveDate
          rowDescription
          containsRebalancing
          batchCategory
          transactionType {
            id
            name
            isPositive
          }
        }
        allAmounts {
          monies
        }
        pricePerUnit {
          monies
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetCapitalActivityByPositionIdQuery__
 *
 * To run a query within a React component, call `useGetCapitalActivityByPositionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapitalActivityByPositionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapitalActivityByPositionIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCapitalActivityByPositionIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCapitalActivityByPositionIdQuery, GraphqlTypes.GetCapitalActivityByPositionIdQueryVariables> & ({ variables: GraphqlTypes.GetCapitalActivityByPositionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCapitalActivityByPositionIdQuery, GraphqlTypes.GetCapitalActivityByPositionIdQueryVariables>(GetCapitalActivityByPositionIdDocument, options);
      }
export function useGetCapitalActivityByPositionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCapitalActivityByPositionIdQuery, GraphqlTypes.GetCapitalActivityByPositionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCapitalActivityByPositionIdQuery, GraphqlTypes.GetCapitalActivityByPositionIdQueryVariables>(GetCapitalActivityByPositionIdDocument, options);
        }
// @ts-ignore
export function useGetCapitalActivityByPositionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalActivityByPositionIdQuery, GraphqlTypes.GetCapitalActivityByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalActivityByPositionIdQuery, GraphqlTypes.GetCapitalActivityByPositionIdQueryVariables>;
export function useGetCapitalActivityByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalActivityByPositionIdQuery, GraphqlTypes.GetCapitalActivityByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalActivityByPositionIdQuery | undefined, GraphqlTypes.GetCapitalActivityByPositionIdQueryVariables>;
export function useGetCapitalActivityByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalActivityByPositionIdQuery, GraphqlTypes.GetCapitalActivityByPositionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCapitalActivityByPositionIdQuery, GraphqlTypes.GetCapitalActivityByPositionIdQueryVariables>(GetCapitalActivityByPositionIdDocument, options);
        }
export type GetCapitalActivityByPositionIdQueryHookResult = ReturnType<typeof useGetCapitalActivityByPositionIdQuery>;
export type GetCapitalActivityByPositionIdLazyQueryHookResult = ReturnType<typeof useGetCapitalActivityByPositionIdLazyQuery>;
export type GetCapitalActivityByPositionIdSuspenseQueryHookResult = ReturnType<typeof useGetCapitalActivityByPositionIdSuspenseQuery>;
export type GetCapitalActivityByPositionIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetCapitalActivityByPositionIdQuery, GraphqlTypes.GetCapitalActivityByPositionIdQueryVariables>;
export const GetCapitalCallsByPositionIdDocument = gql`
    query getCapitalCallsByPositionId($id: ID!, $after: String) {
  position(id: $id) {
    id
    entityCurrency
    arena {
      id
      isAdjustMetricsProvisioned
    }
    investmentEntity {
      id
      name
      currency {
        fullName
      }
      showEntityTotalsOnNp
    }
    transactionTotals {
      lifetimeTotalAmountCalled {
        monies
      }
      lifetimeAmountReceived {
        monies
      }
      lifetimeUncalledContributions {
        monies
      }
    }
  }
  capitalCalls(
    positionId: $id
    sort: [DATE_DUE_DESC, ID_DESC]
    after: $after
    first: 50
  ) {
    count
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCalled {
      monies
    }
    totalReceived {
      monies
    }
    edges {
      node {
        id
        amount {
          monies
        }
        amountReceived {
          monies
        }
        email {
          id
          dateSent
        }
        batch {
          id
          description
          effectiveDate
          batchCategory
        }
        capitalCalled {
          monies
        }
        capitalCalledTotal {
          monies
        }
        contributions {
          count
          edges {
            node {
              id
              paymentDate
            }
          }
        }
        hasDefaulted
        hideCommitment
        hideUnfundedCommitment
        uploadedAccountName
      }
    }
  }
}
    `;

/**
 * __useGetCapitalCallsByPositionIdQuery__
 *
 * To run a query within a React component, call `useGetCapitalCallsByPositionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapitalCallsByPositionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapitalCallsByPositionIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCapitalCallsByPositionIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCapitalCallsByPositionIdQuery, GraphqlTypes.GetCapitalCallsByPositionIdQueryVariables> & ({ variables: GraphqlTypes.GetCapitalCallsByPositionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCapitalCallsByPositionIdQuery, GraphqlTypes.GetCapitalCallsByPositionIdQueryVariables>(GetCapitalCallsByPositionIdDocument, options);
      }
export function useGetCapitalCallsByPositionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCapitalCallsByPositionIdQuery, GraphqlTypes.GetCapitalCallsByPositionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCapitalCallsByPositionIdQuery, GraphqlTypes.GetCapitalCallsByPositionIdQueryVariables>(GetCapitalCallsByPositionIdDocument, options);
        }
// @ts-ignore
export function useGetCapitalCallsByPositionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallsByPositionIdQuery, GraphqlTypes.GetCapitalCallsByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalCallsByPositionIdQuery, GraphqlTypes.GetCapitalCallsByPositionIdQueryVariables>;
export function useGetCapitalCallsByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallsByPositionIdQuery, GraphqlTypes.GetCapitalCallsByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalCallsByPositionIdQuery | undefined, GraphqlTypes.GetCapitalCallsByPositionIdQueryVariables>;
export function useGetCapitalCallsByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallsByPositionIdQuery, GraphqlTypes.GetCapitalCallsByPositionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCapitalCallsByPositionIdQuery, GraphqlTypes.GetCapitalCallsByPositionIdQueryVariables>(GetCapitalCallsByPositionIdDocument, options);
        }
export type GetCapitalCallsByPositionIdQueryHookResult = ReturnType<typeof useGetCapitalCallsByPositionIdQuery>;
export type GetCapitalCallsByPositionIdLazyQueryHookResult = ReturnType<typeof useGetCapitalCallsByPositionIdLazyQuery>;
export type GetCapitalCallsByPositionIdSuspenseQueryHookResult = ReturnType<typeof useGetCapitalCallsByPositionIdSuspenseQuery>;
export type GetCapitalCallsByPositionIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetCapitalCallsByPositionIdQuery, GraphqlTypes.GetCapitalCallsByPositionIdQueryVariables>;
export const GetCapitalCallDetailsByIdDocument = gql`
    query getCapitalCallDetailsById($id: ID!) {
  capitalCall(id: $id) {
    id
    amount {
      monies
    }
    batch {
      id
      effectiveDate
      description
      batchCategory
      entity {
        id
        hideCapitalCallDetails
      }
    }
    capitalCalled {
      monies
    }
    capitalRebalancedIncludedInMetrics {
      monies
    }
    capitalRebalancedExcludedFromMetrics {
      monies
    }
    balance {
      monies
    }
    metrics {
      lifetimeCapitalContributed {
        monies
      }
      positionUnfundedCommitment {
        monies
      }
      positionRemainingRecallable {
        monies
      }
      totalOutstandingCapitalCalled {
        monies
      }
    }
    adjustedMetrics {
      lifetimeCapitalContributed {
        monies
      }
      positionUnfundedCommitment {
        monies
      }
      positionRemainingRecallable {
        monies
      }
      totalOutstandingCapitalCalled {
        monies
      }
    }
    contributions {
      count
      edges {
        node {
          id
          allAmounts {
            monies
          }
          amountReceived {
            monies
          }
          paymentDate
          paymentMethod
          notes
          description
        }
      }
    }
    details {
      count
      edges {
        node {
          id
          hasRebalancedCapitalCallBatch
          amount {
            monies
          }
          transactionType {
            id
            name
            excludeFromMetrics
          }
        }
      }
    }
    hasDefaulted
    hideCommitment
    hideUnfundedCommitment
    uploadedAccountName
    position {
      id
      entityCurrency
      amountCommitted {
        monies
      }
      hideCommitment
      initialAmountCommitted {
        monies
      }
    }
  }
}
    `;

/**
 * __useGetCapitalCallDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetCapitalCallDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapitalCallDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapitalCallDetailsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCapitalCallDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCapitalCallDetailsByIdQuery, GraphqlTypes.GetCapitalCallDetailsByIdQueryVariables> & ({ variables: GraphqlTypes.GetCapitalCallDetailsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCapitalCallDetailsByIdQuery, GraphqlTypes.GetCapitalCallDetailsByIdQueryVariables>(GetCapitalCallDetailsByIdDocument, options);
      }
export function useGetCapitalCallDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCapitalCallDetailsByIdQuery, GraphqlTypes.GetCapitalCallDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCapitalCallDetailsByIdQuery, GraphqlTypes.GetCapitalCallDetailsByIdQueryVariables>(GetCapitalCallDetailsByIdDocument, options);
        }
// @ts-ignore
export function useGetCapitalCallDetailsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallDetailsByIdQuery, GraphqlTypes.GetCapitalCallDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalCallDetailsByIdQuery, GraphqlTypes.GetCapitalCallDetailsByIdQueryVariables>;
export function useGetCapitalCallDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallDetailsByIdQuery, GraphqlTypes.GetCapitalCallDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalCallDetailsByIdQuery | undefined, GraphqlTypes.GetCapitalCallDetailsByIdQueryVariables>;
export function useGetCapitalCallDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallDetailsByIdQuery, GraphqlTypes.GetCapitalCallDetailsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCapitalCallDetailsByIdQuery, GraphqlTypes.GetCapitalCallDetailsByIdQueryVariables>(GetCapitalCallDetailsByIdDocument, options);
        }
export type GetCapitalCallDetailsByIdQueryHookResult = ReturnType<typeof useGetCapitalCallDetailsByIdQuery>;
export type GetCapitalCallDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetCapitalCallDetailsByIdLazyQuery>;
export type GetCapitalCallDetailsByIdSuspenseQueryHookResult = ReturnType<typeof useGetCapitalCallDetailsByIdSuspenseQuery>;
export type GetCapitalCallDetailsByIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetCapitalCallDetailsByIdQuery, GraphqlTypes.GetCapitalCallDetailsByIdQueryVariables>;
export const GetCapitalCallBatchTotalDetailsDocument = gql`
    query GetCapitalCallBatchTotalDetails($id: ID!, $batchId: ID!) {
  capitalCall(id: $id) {
    id
    batch {
      id
      entity {
        id
        contributed(maxCapitalCallBatchId: $batchId) {
          monies
        }
      }
      batchTotalDetails {
        batchTotalsByType {
          transactionType {
            id
            name
            excludeFromMetrics
          }
          amount {
            monies
          }
        }
        totalAmount {
          monies
        }
        totalCapitalCalled {
          monies
        }
      }
    }
  }
}
    `;

/**
 * __useGetCapitalCallBatchTotalDetailsQuery__
 *
 * To run a query within a React component, call `useGetCapitalCallBatchTotalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapitalCallBatchTotalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapitalCallBatchTotalDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useGetCapitalCallBatchTotalDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCapitalCallBatchTotalDetailsQuery, GraphqlTypes.GetCapitalCallBatchTotalDetailsQueryVariables> & ({ variables: GraphqlTypes.GetCapitalCallBatchTotalDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCapitalCallBatchTotalDetailsQuery, GraphqlTypes.GetCapitalCallBatchTotalDetailsQueryVariables>(GetCapitalCallBatchTotalDetailsDocument, options);
      }
export function useGetCapitalCallBatchTotalDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCapitalCallBatchTotalDetailsQuery, GraphqlTypes.GetCapitalCallBatchTotalDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCapitalCallBatchTotalDetailsQuery, GraphqlTypes.GetCapitalCallBatchTotalDetailsQueryVariables>(GetCapitalCallBatchTotalDetailsDocument, options);
        }
// @ts-ignore
export function useGetCapitalCallBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallBatchTotalDetailsQuery, GraphqlTypes.GetCapitalCallBatchTotalDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalCallBatchTotalDetailsQuery, GraphqlTypes.GetCapitalCallBatchTotalDetailsQueryVariables>;
export function useGetCapitalCallBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallBatchTotalDetailsQuery, GraphqlTypes.GetCapitalCallBatchTotalDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalCallBatchTotalDetailsQuery | undefined, GraphqlTypes.GetCapitalCallBatchTotalDetailsQueryVariables>;
export function useGetCapitalCallBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallBatchTotalDetailsQuery, GraphqlTypes.GetCapitalCallBatchTotalDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCapitalCallBatchTotalDetailsQuery, GraphqlTypes.GetCapitalCallBatchTotalDetailsQueryVariables>(GetCapitalCallBatchTotalDetailsDocument, options);
        }
export type GetCapitalCallBatchTotalDetailsQueryHookResult = ReturnType<typeof useGetCapitalCallBatchTotalDetailsQuery>;
export type GetCapitalCallBatchTotalDetailsLazyQueryHookResult = ReturnType<typeof useGetCapitalCallBatchTotalDetailsLazyQuery>;
export type GetCapitalCallBatchTotalDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCapitalCallBatchTotalDetailsSuspenseQuery>;
export type GetCapitalCallBatchTotalDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetCapitalCallBatchTotalDetailsQuery, GraphqlTypes.GetCapitalCallBatchTotalDetailsQueryVariables>;
export const GetTransactionDistributionsByPositionIdDocument = gql`
    query getTransactionDistributionsByPositionId($positionId: ID!, $after: String) {
  position(id: $positionId) {
    id
    entityCurrency
    arena {
      id
      isAdjustMetricsProvisioned
    }
    ownershipUnit {
      id
      name
      precisionMetrics
      precisionPortal
      isMethodUnit
    }
    transactionTotals {
      lifetimeAmountDistributed {
        monies
      }
    }
    investmentEntity {
      id
      name
      showEntityTotalsOnNp
      manualUnitSettingsEnabled
    }
  }
  distributions(
    positionId: $positionId
    after: $after
    sort: [DATE_DISTRIBUTED_DESC, ID_DESC]
    first: 50
  ) {
    count
    pageInfo {
      endCursor
      hasNextPage
    }
    totalDistributed {
      monies
    }
    edges {
      node {
        id
        amountDistributed {
          monies
        }
        batch {
          id
          effectiveDate
          description
          batchCategory
        }
        email {
          id
          dateSent
        }
        hideCommitment
        positionDelta {
          id
          deltaUnitCount
        }
        pricePerUnit {
          monies
        }
      }
    }
  }
}
    `;

/**
 * __useGetTransactionDistributionsByPositionIdQuery__
 *
 * To run a query within a React component, call `useGetTransactionDistributionsByPositionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionDistributionsByPositionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionDistributionsByPositionIdQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetTransactionDistributionsByPositionIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTransactionDistributionsByPositionIdQuery, GraphqlTypes.GetTransactionDistributionsByPositionIdQueryVariables> & ({ variables: GraphqlTypes.GetTransactionDistributionsByPositionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTransactionDistributionsByPositionIdQuery, GraphqlTypes.GetTransactionDistributionsByPositionIdQueryVariables>(GetTransactionDistributionsByPositionIdDocument, options);
      }
export function useGetTransactionDistributionsByPositionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTransactionDistributionsByPositionIdQuery, GraphqlTypes.GetTransactionDistributionsByPositionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTransactionDistributionsByPositionIdQuery, GraphqlTypes.GetTransactionDistributionsByPositionIdQueryVariables>(GetTransactionDistributionsByPositionIdDocument, options);
        }
// @ts-ignore
export function useGetTransactionDistributionsByPositionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionDistributionsByPositionIdQuery, GraphqlTypes.GetTransactionDistributionsByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionDistributionsByPositionIdQuery, GraphqlTypes.GetTransactionDistributionsByPositionIdQueryVariables>;
export function useGetTransactionDistributionsByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionDistributionsByPositionIdQuery, GraphqlTypes.GetTransactionDistributionsByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionDistributionsByPositionIdQuery | undefined, GraphqlTypes.GetTransactionDistributionsByPositionIdQueryVariables>;
export function useGetTransactionDistributionsByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionDistributionsByPositionIdQuery, GraphqlTypes.GetTransactionDistributionsByPositionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTransactionDistributionsByPositionIdQuery, GraphqlTypes.GetTransactionDistributionsByPositionIdQueryVariables>(GetTransactionDistributionsByPositionIdDocument, options);
        }
export type GetTransactionDistributionsByPositionIdQueryHookResult = ReturnType<typeof useGetTransactionDistributionsByPositionIdQuery>;
export type GetTransactionDistributionsByPositionIdLazyQueryHookResult = ReturnType<typeof useGetTransactionDistributionsByPositionIdLazyQuery>;
export type GetTransactionDistributionsByPositionIdSuspenseQueryHookResult = ReturnType<typeof useGetTransactionDistributionsByPositionIdSuspenseQuery>;
export type GetTransactionDistributionsByPositionIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetTransactionDistributionsByPositionIdQuery, GraphqlTypes.GetTransactionDistributionsByPositionIdQueryVariables>;
export const GetDistributionBatchTotalDetailsDocument = gql`
    query GetDistributionBatchTotalDetails($id: ID!, $batchId: ID!) {
  distribution(id: $id) {
    id
    batch {
      id
      batchTotalDetails {
        batchTotalsByType {
          transactionType {
            id
            name
            isWithholding
          }
          amount {
            monies
          }
          amountRecallable {
            monies
          }
        }
        amountDistributed {
          monies
        }
        netAmount {
          monies
        }
      }
      entity {
        id
        distributed(maxDistributionBatchId: $batchId) {
          monies
        }
      }
    }
  }
}
    `;

/**
 * __useGetDistributionBatchTotalDetailsQuery__
 *
 * To run a query within a React component, call `useGetDistributionBatchTotalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionBatchTotalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionBatchTotalDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useGetDistributionBatchTotalDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDistributionBatchTotalDetailsQuery, GraphqlTypes.GetDistributionBatchTotalDetailsQueryVariables> & ({ variables: GraphqlTypes.GetDistributionBatchTotalDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDistributionBatchTotalDetailsQuery, GraphqlTypes.GetDistributionBatchTotalDetailsQueryVariables>(GetDistributionBatchTotalDetailsDocument, options);
      }
export function useGetDistributionBatchTotalDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDistributionBatchTotalDetailsQuery, GraphqlTypes.GetDistributionBatchTotalDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDistributionBatchTotalDetailsQuery, GraphqlTypes.GetDistributionBatchTotalDetailsQueryVariables>(GetDistributionBatchTotalDetailsDocument, options);
        }
// @ts-ignore
export function useGetDistributionBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchTotalDetailsQuery, GraphqlTypes.GetDistributionBatchTotalDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionBatchTotalDetailsQuery, GraphqlTypes.GetDistributionBatchTotalDetailsQueryVariables>;
export function useGetDistributionBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchTotalDetailsQuery, GraphqlTypes.GetDistributionBatchTotalDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionBatchTotalDetailsQuery | undefined, GraphqlTypes.GetDistributionBatchTotalDetailsQueryVariables>;
export function useGetDistributionBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchTotalDetailsQuery, GraphqlTypes.GetDistributionBatchTotalDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDistributionBatchTotalDetailsQuery, GraphqlTypes.GetDistributionBatchTotalDetailsQueryVariables>(GetDistributionBatchTotalDetailsDocument, options);
        }
export type GetDistributionBatchTotalDetailsQueryHookResult = ReturnType<typeof useGetDistributionBatchTotalDetailsQuery>;
export type GetDistributionBatchTotalDetailsLazyQueryHookResult = ReturnType<typeof useGetDistributionBatchTotalDetailsLazyQuery>;
export type GetDistributionBatchTotalDetailsSuspenseQueryHookResult = ReturnType<typeof useGetDistributionBatchTotalDetailsSuspenseQuery>;
export type GetDistributionBatchTotalDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDistributionBatchTotalDetailsQuery, GraphqlTypes.GetDistributionBatchTotalDetailsQueryVariables>;
export const GetManagementFeesByPositionIdDocument = gql`
    query getManagementFeesByPositionId($id: ID!, $after: String) {
  position(id: $id) {
    id
    entityCurrency
    arena {
      id
      isAdjustMetricsProvisioned
    }
    account {
      id
      name
    }
    totalManagementFeeAdjusted {
      monies
    }
    investmentEntity {
      id
      name
    }
  }
  managementFees(
    positionId: $id
    after: $after
    sort: [DATE_DUE_DESC, ID_DESC]
    first: 50
  ) {
    count
    pageInfo {
      endCursor
      hasNextPage
    }
    totalManagementFee {
      monies
    }
    edges {
      node {
        id
        batch {
          id
          dateDue
          description
        }
        amount {
          monies
        }
      }
    }
  }
}
    `;

/**
 * __useGetManagementFeesByPositionIdQuery__
 *
 * To run a query within a React component, call `useGetManagementFeesByPositionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagementFeesByPositionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagementFeesByPositionIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetManagementFeesByPositionIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetManagementFeesByPositionIdQuery, GraphqlTypes.GetManagementFeesByPositionIdQueryVariables> & ({ variables: GraphqlTypes.GetManagementFeesByPositionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetManagementFeesByPositionIdQuery, GraphqlTypes.GetManagementFeesByPositionIdQueryVariables>(GetManagementFeesByPositionIdDocument, options);
      }
export function useGetManagementFeesByPositionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetManagementFeesByPositionIdQuery, GraphqlTypes.GetManagementFeesByPositionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetManagementFeesByPositionIdQuery, GraphqlTypes.GetManagementFeesByPositionIdQueryVariables>(GetManagementFeesByPositionIdDocument, options);
        }
// @ts-ignore
export function useGetManagementFeesByPositionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagementFeesByPositionIdQuery, GraphqlTypes.GetManagementFeesByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManagementFeesByPositionIdQuery, GraphqlTypes.GetManagementFeesByPositionIdQueryVariables>;
export function useGetManagementFeesByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagementFeesByPositionIdQuery, GraphqlTypes.GetManagementFeesByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManagementFeesByPositionIdQuery | undefined, GraphqlTypes.GetManagementFeesByPositionIdQueryVariables>;
export function useGetManagementFeesByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagementFeesByPositionIdQuery, GraphqlTypes.GetManagementFeesByPositionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetManagementFeesByPositionIdQuery, GraphqlTypes.GetManagementFeesByPositionIdQueryVariables>(GetManagementFeesByPositionIdDocument, options);
        }
export type GetManagementFeesByPositionIdQueryHookResult = ReturnType<typeof useGetManagementFeesByPositionIdQuery>;
export type GetManagementFeesByPositionIdLazyQueryHookResult = ReturnType<typeof useGetManagementFeesByPositionIdLazyQuery>;
export type GetManagementFeesByPositionIdSuspenseQueryHookResult = ReturnType<typeof useGetManagementFeesByPositionIdSuspenseQuery>;
export type GetManagementFeesByPositionIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetManagementFeesByPositionIdQuery, GraphqlTypes.GetManagementFeesByPositionIdQueryVariables>;
export const GetManagementFeeDetailsByIdDocument = gql`
    query getManagementFeeDetailsById($id: ID!) {
  managementFee(id: $id) {
    batch {
      entity {
        currency {
          ...CurrencyFields
        }
      }
    }
    amount {
      monies
    }
    details {
      edges {
        node {
          id
          amount {
            monies
          }
          transactionType {
            id
            name
            group {
              id
              name
              sortOrder
            }
          }
          sortOrder
        }
      }
    }
  }
}
    ${CurrencyFieldsFragmentDoc}`;

/**
 * __useGetManagementFeeDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetManagementFeeDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagementFeeDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagementFeeDetailsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetManagementFeeDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetManagementFeeDetailsByIdQuery, GraphqlTypes.GetManagementFeeDetailsByIdQueryVariables> & ({ variables: GraphqlTypes.GetManagementFeeDetailsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetManagementFeeDetailsByIdQuery, GraphqlTypes.GetManagementFeeDetailsByIdQueryVariables>(GetManagementFeeDetailsByIdDocument, options);
      }
export function useGetManagementFeeDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetManagementFeeDetailsByIdQuery, GraphqlTypes.GetManagementFeeDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetManagementFeeDetailsByIdQuery, GraphqlTypes.GetManagementFeeDetailsByIdQueryVariables>(GetManagementFeeDetailsByIdDocument, options);
        }
// @ts-ignore
export function useGetManagementFeeDetailsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagementFeeDetailsByIdQuery, GraphqlTypes.GetManagementFeeDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManagementFeeDetailsByIdQuery, GraphqlTypes.GetManagementFeeDetailsByIdQueryVariables>;
export function useGetManagementFeeDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagementFeeDetailsByIdQuery, GraphqlTypes.GetManagementFeeDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManagementFeeDetailsByIdQuery | undefined, GraphqlTypes.GetManagementFeeDetailsByIdQueryVariables>;
export function useGetManagementFeeDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagementFeeDetailsByIdQuery, GraphqlTypes.GetManagementFeeDetailsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetManagementFeeDetailsByIdQuery, GraphqlTypes.GetManagementFeeDetailsByIdQueryVariables>(GetManagementFeeDetailsByIdDocument, options);
        }
export type GetManagementFeeDetailsByIdQueryHookResult = ReturnType<typeof useGetManagementFeeDetailsByIdQuery>;
export type GetManagementFeeDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetManagementFeeDetailsByIdLazyQuery>;
export type GetManagementFeeDetailsByIdSuspenseQueryHookResult = ReturnType<typeof useGetManagementFeeDetailsByIdSuspenseQuery>;
export type GetManagementFeeDetailsByIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetManagementFeeDetailsByIdQuery, GraphqlTypes.GetManagementFeeDetailsByIdQueryVariables>;
export const GetNavsDocument = gql`
    query GetNavs($positionId: ID!, $after: String) {
  navs(
    positionId: $positionId
    after: $after
    sort: [EFFECTIVE_DATE_DESC, ID_DESC]
    first: 50
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    count
    edges {
      node {
        id
        amount {
          monies
        }
        batch {
          description
          effectiveDate
        }
      }
    }
  }
}
    `;

/**
 * __useGetNavsQuery__
 *
 * To run a query within a React component, call `useGetNavsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavsQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetNavsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetNavsQuery, GraphqlTypes.GetNavsQueryVariables> & ({ variables: GraphqlTypes.GetNavsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNavsQuery, GraphqlTypes.GetNavsQueryVariables>(GetNavsDocument, options);
      }
export function useGetNavsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNavsQuery, GraphqlTypes.GetNavsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNavsQuery, GraphqlTypes.GetNavsQueryVariables>(GetNavsDocument, options);
        }
// @ts-ignore
export function useGetNavsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavsQuery, GraphqlTypes.GetNavsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNavsQuery, GraphqlTypes.GetNavsQueryVariables>;
export function useGetNavsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavsQuery, GraphqlTypes.GetNavsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNavsQuery | undefined, GraphqlTypes.GetNavsQueryVariables>;
export function useGetNavsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavsQuery, GraphqlTypes.GetNavsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNavsQuery, GraphqlTypes.GetNavsQueryVariables>(GetNavsDocument, options);
        }
export type GetNavsQueryHookResult = ReturnType<typeof useGetNavsQuery>;
export type GetNavsLazyQueryHookResult = ReturnType<typeof useGetNavsLazyQuery>;
export type GetNavsSuspenseQueryHookResult = ReturnType<typeof useGetNavsSuspenseQuery>;
export type GetNavsQueryResult = Apollo.QueryResult<GraphqlTypes.GetNavsQuery, GraphqlTypes.GetNavsQueryVariables>;
export const GetInvestmentEntityByPositionIdDocument = gql`
    query GetInvestmentEntityByPositionId($positionId: ID!) {
  position(id: $positionId) {
    id
    entityCurrency
    investmentEntity {
      id
      name
      showEntityTotalsOnNp
    }
  }
}
    `;

/**
 * __useGetInvestmentEntityByPositionIdQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntityByPositionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntityByPositionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntityByPositionIdQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useGetInvestmentEntityByPositionIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntityByPositionIdQuery, GraphqlTypes.GetInvestmentEntityByPositionIdQueryVariables> & ({ variables: GraphqlTypes.GetInvestmentEntityByPositionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntityByPositionIdQuery, GraphqlTypes.GetInvestmentEntityByPositionIdQueryVariables>(GetInvestmentEntityByPositionIdDocument, options);
      }
export function useGetInvestmentEntityByPositionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntityByPositionIdQuery, GraphqlTypes.GetInvestmentEntityByPositionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntityByPositionIdQuery, GraphqlTypes.GetInvestmentEntityByPositionIdQueryVariables>(GetInvestmentEntityByPositionIdDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntityByPositionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityByPositionIdQuery, GraphqlTypes.GetInvestmentEntityByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityByPositionIdQuery, GraphqlTypes.GetInvestmentEntityByPositionIdQueryVariables>;
export function useGetInvestmentEntityByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityByPositionIdQuery, GraphqlTypes.GetInvestmentEntityByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityByPositionIdQuery | undefined, GraphqlTypes.GetInvestmentEntityByPositionIdQueryVariables>;
export function useGetInvestmentEntityByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityByPositionIdQuery, GraphqlTypes.GetInvestmentEntityByPositionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntityByPositionIdQuery, GraphqlTypes.GetInvestmentEntityByPositionIdQueryVariables>(GetInvestmentEntityByPositionIdDocument, options);
        }
export type GetInvestmentEntityByPositionIdQueryHookResult = ReturnType<typeof useGetInvestmentEntityByPositionIdQuery>;
export type GetInvestmentEntityByPositionIdLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntityByPositionIdLazyQuery>;
export type GetInvestmentEntityByPositionIdSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntityByPositionIdSuspenseQuery>;
export type GetInvestmentEntityByPositionIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntityByPositionIdQuery, GraphqlTypes.GetInvestmentEntityByPositionIdQueryVariables>;
export const GetNavDetailsDocument = gql`
    query GetNavDetails($id: ID!) {
  nav(id: $id) {
    id
    amount {
      monies
    }
    batch {
      id
      effectiveDate
      description
      hasWaterfall
    }
    waterfallStats {
      errorReason
      items {
        grossDistributionAmount {
          monies
        }
        tiers {
          label
          amount {
            monies
          }
        }
      }
    }
    details {
      edges {
        node {
          id
          amount {
            monies
          }
          transactionType {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetNavDetailsQuery__
 *
 * To run a query within a React component, call `useGetNavDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNavDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetNavDetailsQuery, GraphqlTypes.GetNavDetailsQueryVariables> & ({ variables: GraphqlTypes.GetNavDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNavDetailsQuery, GraphqlTypes.GetNavDetailsQueryVariables>(GetNavDetailsDocument, options);
      }
export function useGetNavDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNavDetailsQuery, GraphqlTypes.GetNavDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNavDetailsQuery, GraphqlTypes.GetNavDetailsQueryVariables>(GetNavDetailsDocument, options);
        }
// @ts-ignore
export function useGetNavDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavDetailsQuery, GraphqlTypes.GetNavDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNavDetailsQuery, GraphqlTypes.GetNavDetailsQueryVariables>;
export function useGetNavDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavDetailsQuery, GraphqlTypes.GetNavDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNavDetailsQuery | undefined, GraphqlTypes.GetNavDetailsQueryVariables>;
export function useGetNavDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavDetailsQuery, GraphqlTypes.GetNavDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNavDetailsQuery, GraphqlTypes.GetNavDetailsQueryVariables>(GetNavDetailsDocument, options);
        }
export type GetNavDetailsQueryHookResult = ReturnType<typeof useGetNavDetailsQuery>;
export type GetNavDetailsLazyQueryHookResult = ReturnType<typeof useGetNavDetailsLazyQuery>;
export type GetNavDetailsSuspenseQueryHookResult = ReturnType<typeof useGetNavDetailsSuspenseQuery>;
export type GetNavDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetNavDetailsQuery, GraphqlTypes.GetNavDetailsQueryVariables>;
export const GetNavBatchTotalDetailsDocument = gql`
    query GetNavBatchTotalDetails($id: ID!) {
  nav(id: $id) {
    id
    batch {
      id
      batchTotalDetails {
        batchTotalsByType {
          transactionType {
            id
            name
          }
          amount {
            monies
          }
        }
        totalAmount {
          monies
        }
      }
    }
  }
}
    `;

/**
 * __useGetNavBatchTotalDetailsQuery__
 *
 * To run a query within a React component, call `useGetNavBatchTotalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavBatchTotalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavBatchTotalDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNavBatchTotalDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetNavBatchTotalDetailsQuery, GraphqlTypes.GetNavBatchTotalDetailsQueryVariables> & ({ variables: GraphqlTypes.GetNavBatchTotalDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNavBatchTotalDetailsQuery, GraphqlTypes.GetNavBatchTotalDetailsQueryVariables>(GetNavBatchTotalDetailsDocument, options);
      }
export function useGetNavBatchTotalDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNavBatchTotalDetailsQuery, GraphqlTypes.GetNavBatchTotalDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNavBatchTotalDetailsQuery, GraphqlTypes.GetNavBatchTotalDetailsQueryVariables>(GetNavBatchTotalDetailsDocument, options);
        }
// @ts-ignore
export function useGetNavBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavBatchTotalDetailsQuery, GraphqlTypes.GetNavBatchTotalDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNavBatchTotalDetailsQuery, GraphqlTypes.GetNavBatchTotalDetailsQueryVariables>;
export function useGetNavBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavBatchTotalDetailsQuery, GraphqlTypes.GetNavBatchTotalDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNavBatchTotalDetailsQuery | undefined, GraphqlTypes.GetNavBatchTotalDetailsQueryVariables>;
export function useGetNavBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavBatchTotalDetailsQuery, GraphqlTypes.GetNavBatchTotalDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNavBatchTotalDetailsQuery, GraphqlTypes.GetNavBatchTotalDetailsQueryVariables>(GetNavBatchTotalDetailsDocument, options);
        }
export type GetNavBatchTotalDetailsQueryHookResult = ReturnType<typeof useGetNavBatchTotalDetailsQuery>;
export type GetNavBatchTotalDetailsLazyQueryHookResult = ReturnType<typeof useGetNavBatchTotalDetailsLazyQuery>;
export type GetNavBatchTotalDetailsSuspenseQueryHookResult = ReturnType<typeof useGetNavBatchTotalDetailsSuspenseQuery>;
export type GetNavBatchTotalDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetNavBatchTotalDetailsQuery, GraphqlTypes.GetNavBatchTotalDetailsQueryVariables>;
export const GetNetIncomesDocument = gql`
    query GetNetIncomes($positionId: ID!, $after: String) {
  position(id: $positionId) {
    id
    entityCurrency
    arena {
      id
      isAdjustMetricsProvisioned
    }
    transactionTotals {
      lifetimeTotalAmountPassedThrough {
        monies
      }
    }
    ownershipUnit {
      id
      name
      precisionMetrics
      precisionPortal
      isMethodUnit
    }
    account {
      id
      name
    }
    investmentEntity {
      id
      name
      showEntityTotalsOnNp
      manualUnitSettingsEnabled
    }
  }
  netIncomes(
    positionId: $positionId
    sort: [DATE_PASSED_THROUGH_DESC, ID_DESC]
    first: 50
    after: $after
  ) {
    totalNetIncome {
      monies
    }
    count
    edges {
      node {
        id
        amount {
          monies
        }
        datePassedThrough
        basisName
        batchDescription
        email {
          id
          dateSent
        }
        batch {
          id
          batchCategory
        }
        positionDelta {
          id
          deltaUnitCount
        }
        pricePerUnit {
          monies
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetNetIncomesQuery__
 *
 * To run a query within a React component, call `useGetNetIncomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetIncomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetIncomesQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetNetIncomesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetNetIncomesQuery, GraphqlTypes.GetNetIncomesQueryVariables> & ({ variables: GraphqlTypes.GetNetIncomesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNetIncomesQuery, GraphqlTypes.GetNetIncomesQueryVariables>(GetNetIncomesDocument, options);
      }
export function useGetNetIncomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNetIncomesQuery, GraphqlTypes.GetNetIncomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNetIncomesQuery, GraphqlTypes.GetNetIncomesQueryVariables>(GetNetIncomesDocument, options);
        }
// @ts-ignore
export function useGetNetIncomesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNetIncomesQuery, GraphqlTypes.GetNetIncomesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNetIncomesQuery, GraphqlTypes.GetNetIncomesQueryVariables>;
export function useGetNetIncomesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNetIncomesQuery, GraphqlTypes.GetNetIncomesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNetIncomesQuery | undefined, GraphqlTypes.GetNetIncomesQueryVariables>;
export function useGetNetIncomesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNetIncomesQuery, GraphqlTypes.GetNetIncomesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNetIncomesQuery, GraphqlTypes.GetNetIncomesQueryVariables>(GetNetIncomesDocument, options);
        }
export type GetNetIncomesQueryHookResult = ReturnType<typeof useGetNetIncomesQuery>;
export type GetNetIncomesLazyQueryHookResult = ReturnType<typeof useGetNetIncomesLazyQuery>;
export type GetNetIncomesSuspenseQueryHookResult = ReturnType<typeof useGetNetIncomesSuspenseQuery>;
export type GetNetIncomesQueryResult = Apollo.QueryResult<GraphqlTypes.GetNetIncomesQuery, GraphqlTypes.GetNetIncomesQueryVariables>;
export const GetNetIncomeDetailDocument = gql`
    query GetNetIncomeDetail($id: ID!) {
  netIncome(id: $id) {
    id
    amount {
      monies
    }
    datePassedThrough
    batchDescription
    amountTaxable {
      monies
    }
    amountTaxExempt {
      monies
    }
    batch {
      batchCategory
    }
    details {
      edges {
        node {
          id
          amount {
            monies
          }
          typeDescription
          transactionType {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetNetIncomeDetailQuery__
 *
 * To run a query within a React component, call `useGetNetIncomeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetIncomeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetIncomeDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNetIncomeDetailQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetNetIncomeDetailQuery, GraphqlTypes.GetNetIncomeDetailQueryVariables> & ({ variables: GraphqlTypes.GetNetIncomeDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNetIncomeDetailQuery, GraphqlTypes.GetNetIncomeDetailQueryVariables>(GetNetIncomeDetailDocument, options);
      }
export function useGetNetIncomeDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNetIncomeDetailQuery, GraphqlTypes.GetNetIncomeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNetIncomeDetailQuery, GraphqlTypes.GetNetIncomeDetailQueryVariables>(GetNetIncomeDetailDocument, options);
        }
// @ts-ignore
export function useGetNetIncomeDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNetIncomeDetailQuery, GraphqlTypes.GetNetIncomeDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNetIncomeDetailQuery, GraphqlTypes.GetNetIncomeDetailQueryVariables>;
export function useGetNetIncomeDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNetIncomeDetailQuery, GraphqlTypes.GetNetIncomeDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNetIncomeDetailQuery | undefined, GraphqlTypes.GetNetIncomeDetailQueryVariables>;
export function useGetNetIncomeDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNetIncomeDetailQuery, GraphqlTypes.GetNetIncomeDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNetIncomeDetailQuery, GraphqlTypes.GetNetIncomeDetailQueryVariables>(GetNetIncomeDetailDocument, options);
        }
export type GetNetIncomeDetailQueryHookResult = ReturnType<typeof useGetNetIncomeDetailQuery>;
export type GetNetIncomeDetailLazyQueryHookResult = ReturnType<typeof useGetNetIncomeDetailLazyQuery>;
export type GetNetIncomeDetailSuspenseQueryHookResult = ReturnType<typeof useGetNetIncomeDetailSuspenseQuery>;
export type GetNetIncomeDetailQueryResult = Apollo.QueryResult<GraphqlTypes.GetNetIncomeDetailQuery, GraphqlTypes.GetNetIncomeDetailQueryVariables>;
export const GetNetIncomeBatchTotalDetailsDocument = gql`
    query GetNetIncomeBatchTotalDetails($id: ID!) {
  netIncome(id: $id) {
    id
    batch {
      id
      batchTotalDetails {
        batchTotalsByType {
          amount {
            monies
          }
          typeDescription
          transactionType {
            id
            name
          }
        }
        totalAmount {
          monies
        }
        totalAmountTaxable {
          monies
        }
        totalAmountTaxExempt {
          monies
        }
      }
    }
  }
}
    `;

/**
 * __useGetNetIncomeBatchTotalDetailsQuery__
 *
 * To run a query within a React component, call `useGetNetIncomeBatchTotalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetIncomeBatchTotalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetIncomeBatchTotalDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNetIncomeBatchTotalDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetNetIncomeBatchTotalDetailsQuery, GraphqlTypes.GetNetIncomeBatchTotalDetailsQueryVariables> & ({ variables: GraphqlTypes.GetNetIncomeBatchTotalDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNetIncomeBatchTotalDetailsQuery, GraphqlTypes.GetNetIncomeBatchTotalDetailsQueryVariables>(GetNetIncomeBatchTotalDetailsDocument, options);
      }
export function useGetNetIncomeBatchTotalDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNetIncomeBatchTotalDetailsQuery, GraphqlTypes.GetNetIncomeBatchTotalDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNetIncomeBatchTotalDetailsQuery, GraphqlTypes.GetNetIncomeBatchTotalDetailsQueryVariables>(GetNetIncomeBatchTotalDetailsDocument, options);
        }
// @ts-ignore
export function useGetNetIncomeBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNetIncomeBatchTotalDetailsQuery, GraphqlTypes.GetNetIncomeBatchTotalDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNetIncomeBatchTotalDetailsQuery, GraphqlTypes.GetNetIncomeBatchTotalDetailsQueryVariables>;
export function useGetNetIncomeBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNetIncomeBatchTotalDetailsQuery, GraphqlTypes.GetNetIncomeBatchTotalDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNetIncomeBatchTotalDetailsQuery | undefined, GraphqlTypes.GetNetIncomeBatchTotalDetailsQueryVariables>;
export function useGetNetIncomeBatchTotalDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNetIncomeBatchTotalDetailsQuery, GraphqlTypes.GetNetIncomeBatchTotalDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNetIncomeBatchTotalDetailsQuery, GraphqlTypes.GetNetIncomeBatchTotalDetailsQueryVariables>(GetNetIncomeBatchTotalDetailsDocument, options);
        }
export type GetNetIncomeBatchTotalDetailsQueryHookResult = ReturnType<typeof useGetNetIncomeBatchTotalDetailsQuery>;
export type GetNetIncomeBatchTotalDetailsLazyQueryHookResult = ReturnType<typeof useGetNetIncomeBatchTotalDetailsLazyQuery>;
export type GetNetIncomeBatchTotalDetailsSuspenseQueryHookResult = ReturnType<typeof useGetNetIncomeBatchTotalDetailsSuspenseQuery>;
export type GetNetIncomeBatchTotalDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetNetIncomeBatchTotalDetailsQuery, GraphqlTypes.GetNetIncomeBatchTotalDetailsQueryVariables>;
export const GetCashflowChartDocument = gql`
    query GetCashflowChart($positionId: ID!) {
  position(id: $positionId) {
    id
    entityCurrency
    isCompleted
    showCashFlowHistoryChart
    cashflowHistoryData {
      ...CashFlowHistoryData
    }
  }
}
    ${CashFlowHistoryDataFragmentDoc}`;

/**
 * __useGetCashflowChartQuery__
 *
 * To run a query within a React component, call `useGetCashflowChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashflowChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashflowChartQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useGetCashflowChartQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCashflowChartQuery, GraphqlTypes.GetCashflowChartQueryVariables> & ({ variables: GraphqlTypes.GetCashflowChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCashflowChartQuery, GraphqlTypes.GetCashflowChartQueryVariables>(GetCashflowChartDocument, options);
      }
export function useGetCashflowChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCashflowChartQuery, GraphqlTypes.GetCashflowChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCashflowChartQuery, GraphqlTypes.GetCashflowChartQueryVariables>(GetCashflowChartDocument, options);
        }
// @ts-ignore
export function useGetCashflowChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCashflowChartQuery, GraphqlTypes.GetCashflowChartQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCashflowChartQuery, GraphqlTypes.GetCashflowChartQueryVariables>;
export function useGetCashflowChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCashflowChartQuery, GraphqlTypes.GetCashflowChartQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCashflowChartQuery | undefined, GraphqlTypes.GetCashflowChartQueryVariables>;
export function useGetCashflowChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCashflowChartQuery, GraphqlTypes.GetCashflowChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCashflowChartQuery, GraphqlTypes.GetCashflowChartQueryVariables>(GetCashflowChartDocument, options);
        }
export type GetCashflowChartQueryHookResult = ReturnType<typeof useGetCashflowChartQuery>;
export type GetCashflowChartLazyQueryHookResult = ReturnType<typeof useGetCashflowChartLazyQuery>;
export type GetCashflowChartSuspenseQueryHookResult = ReturnType<typeof useGetCashflowChartSuspenseQuery>;
export type GetCashflowChartQueryResult = Apollo.QueryResult<GraphqlTypes.GetCashflowChartQuery, GraphqlTypes.GetCashflowChartQueryVariables>;
export const GetNpPositionTwrMetricsDocument = gql`
    query GetNpPositionTwrMetrics($positionId: ID!) {
  position(id: $positionId) {
    id
    twrEndDate
    twrPeriodMetrics {
      ...PortalTwrPeriodHeaderAndMetrics
    }
    twrSummaryMetrics {
      ...PortalTwrSummaryHeaderAndMetrics
    }
  }
}
    ${PortalTwrPeriodHeaderAndMetricsFragmentDoc}
${PortalTwrSummaryHeaderAndMetricsFragmentDoc}`;

/**
 * __useGetNpPositionTwrMetricsQuery__
 *
 * To run a query within a React component, call `useGetNpPositionTwrMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNpPositionTwrMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNpPositionTwrMetricsQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useGetNpPositionTwrMetricsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetNpPositionTwrMetricsQuery, GraphqlTypes.GetNpPositionTwrMetricsQueryVariables> & ({ variables: GraphqlTypes.GetNpPositionTwrMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNpPositionTwrMetricsQuery, GraphqlTypes.GetNpPositionTwrMetricsQueryVariables>(GetNpPositionTwrMetricsDocument, options);
      }
export function useGetNpPositionTwrMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNpPositionTwrMetricsQuery, GraphqlTypes.GetNpPositionTwrMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNpPositionTwrMetricsQuery, GraphqlTypes.GetNpPositionTwrMetricsQueryVariables>(GetNpPositionTwrMetricsDocument, options);
        }
// @ts-ignore
export function useGetNpPositionTwrMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNpPositionTwrMetricsQuery, GraphqlTypes.GetNpPositionTwrMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNpPositionTwrMetricsQuery, GraphqlTypes.GetNpPositionTwrMetricsQueryVariables>;
export function useGetNpPositionTwrMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNpPositionTwrMetricsQuery, GraphqlTypes.GetNpPositionTwrMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNpPositionTwrMetricsQuery | undefined, GraphqlTypes.GetNpPositionTwrMetricsQueryVariables>;
export function useGetNpPositionTwrMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNpPositionTwrMetricsQuery, GraphqlTypes.GetNpPositionTwrMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNpPositionTwrMetricsQuery, GraphqlTypes.GetNpPositionTwrMetricsQueryVariables>(GetNpPositionTwrMetricsDocument, options);
        }
export type GetNpPositionTwrMetricsQueryHookResult = ReturnType<typeof useGetNpPositionTwrMetricsQuery>;
export type GetNpPositionTwrMetricsLazyQueryHookResult = ReturnType<typeof useGetNpPositionTwrMetricsLazyQuery>;
export type GetNpPositionTwrMetricsSuspenseQueryHookResult = ReturnType<typeof useGetNpPositionTwrMetricsSuspenseQuery>;
export type GetNpPositionTwrMetricsQueryResult = Apollo.QueryResult<GraphqlTypes.GetNpPositionTwrMetricsQuery, GraphqlTypes.GetNpPositionTwrMetricsQueryVariables>;
export const GetOwnershipHistoryDocument = gql`
    query GetOwnershipHistory($positionId: ID!) {
  position(id: $positionId) {
    id
    arena {
      ownershipDisplayPrecision
    }
    entityCurrency
    percentOwnership
    ownershipSnapshots {
      ...SnapshotFields
      isFirstDelta
      delta {
        id
        deltaAmountCommitted {
          monies
        }
        deltaPercentOwnershipManual
        deltaUnitCount
        date
        fromAccountName
        toAccountName
        transaction {
          id
          totalRedeemAmount {
            monies
          }
          batch {
            id
            transactionType {
              id
              name
            }
          }
        }
        distribution {
          batch {
            description
          }
        }
        netIncome {
          batch {
            description
          }
        }
        capitalCall {
          batch {
            description
          }
        }
      }
    }
    commitmentSnapshots {
      ...SnapshotFields
      isFirstDelta
      delta {
        id
        closeRound
        deltaAmountCommitted {
          monies
        }
        deltaPercentOwnershipManual
        date
        fromAccountName
        toAccountName
      }
    }
    ownershipUnit {
      id
      calculationMethod
      precisionPortal
    }
    investorGroup {
      id
      name
    }
  }
}
    ${SnapshotFieldsFragmentDoc}`;

/**
 * __useGetOwnershipHistoryQuery__
 *
 * To run a query within a React component, call `useGetOwnershipHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnershipHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnershipHistoryQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useGetOwnershipHistoryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOwnershipHistoryQuery, GraphqlTypes.GetOwnershipHistoryQueryVariables> & ({ variables: GraphqlTypes.GetOwnershipHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOwnershipHistoryQuery, GraphqlTypes.GetOwnershipHistoryQueryVariables>(GetOwnershipHistoryDocument, options);
      }
export function useGetOwnershipHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOwnershipHistoryQuery, GraphqlTypes.GetOwnershipHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOwnershipHistoryQuery, GraphqlTypes.GetOwnershipHistoryQueryVariables>(GetOwnershipHistoryDocument, options);
        }
// @ts-ignore
export function useGetOwnershipHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOwnershipHistoryQuery, GraphqlTypes.GetOwnershipHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOwnershipHistoryQuery, GraphqlTypes.GetOwnershipHistoryQueryVariables>;
export function useGetOwnershipHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOwnershipHistoryQuery, GraphqlTypes.GetOwnershipHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOwnershipHistoryQuery | undefined, GraphqlTypes.GetOwnershipHistoryQueryVariables>;
export function useGetOwnershipHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOwnershipHistoryQuery, GraphqlTypes.GetOwnershipHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOwnershipHistoryQuery, GraphqlTypes.GetOwnershipHistoryQueryVariables>(GetOwnershipHistoryDocument, options);
        }
export type GetOwnershipHistoryQueryHookResult = ReturnType<typeof useGetOwnershipHistoryQuery>;
export type GetOwnershipHistoryLazyQueryHookResult = ReturnType<typeof useGetOwnershipHistoryLazyQuery>;
export type GetOwnershipHistorySuspenseQueryHookResult = ReturnType<typeof useGetOwnershipHistorySuspenseQuery>;
export type GetOwnershipHistoryQueryResult = Apollo.QueryResult<GraphqlTypes.GetOwnershipHistoryQuery, GraphqlTypes.GetOwnershipHistoryQueryVariables>;
export const GetUnitValuesByPositionIdDocument = gql`
    query getUnitValuesByPositionId($id: ID!) {
  position(id: $id) {
    id
    entityCurrency
    investmentEntity {
      id
      name
    }
    unitValues {
      id
      calculatedPricePerUnit {
        monies
      }
      totalValue {
        monies
      }
      unitValueBatch {
        id
        effectiveDate
        description
      }
      unitValueMetric {
        id
        name
        ownershipUnit {
          id
          shortName
          precisionMetrics
        }
      }
    }
  }
}
    `;

/**
 * __useGetUnitValuesByPositionIdQuery__
 *
 * To run a query within a React component, call `useGetUnitValuesByPositionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitValuesByPositionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitValuesByPositionIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUnitValuesByPositionIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUnitValuesByPositionIdQuery, GraphqlTypes.GetUnitValuesByPositionIdQueryVariables> & ({ variables: GraphqlTypes.GetUnitValuesByPositionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUnitValuesByPositionIdQuery, GraphqlTypes.GetUnitValuesByPositionIdQueryVariables>(GetUnitValuesByPositionIdDocument, options);
      }
export function useGetUnitValuesByPositionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUnitValuesByPositionIdQuery, GraphqlTypes.GetUnitValuesByPositionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUnitValuesByPositionIdQuery, GraphqlTypes.GetUnitValuesByPositionIdQueryVariables>(GetUnitValuesByPositionIdDocument, options);
        }
// @ts-ignore
export function useGetUnitValuesByPositionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnitValuesByPositionIdQuery, GraphqlTypes.GetUnitValuesByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnitValuesByPositionIdQuery, GraphqlTypes.GetUnitValuesByPositionIdQueryVariables>;
export function useGetUnitValuesByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnitValuesByPositionIdQuery, GraphqlTypes.GetUnitValuesByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnitValuesByPositionIdQuery | undefined, GraphqlTypes.GetUnitValuesByPositionIdQueryVariables>;
export function useGetUnitValuesByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnitValuesByPositionIdQuery, GraphqlTypes.GetUnitValuesByPositionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUnitValuesByPositionIdQuery, GraphqlTypes.GetUnitValuesByPositionIdQueryVariables>(GetUnitValuesByPositionIdDocument, options);
        }
export type GetUnitValuesByPositionIdQueryHookResult = ReturnType<typeof useGetUnitValuesByPositionIdQuery>;
export type GetUnitValuesByPositionIdLazyQueryHookResult = ReturnType<typeof useGetUnitValuesByPositionIdLazyQuery>;
export type GetUnitValuesByPositionIdSuspenseQueryHookResult = ReturnType<typeof useGetUnitValuesByPositionIdSuspenseQuery>;
export type GetUnitValuesByPositionIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetUnitValuesByPositionIdQuery, GraphqlTypes.GetUnitValuesByPositionIdQueryVariables>;
export const GetPositionWithTransactionsDocument = gql`
    query getPositionWithTransactions($id: ID!) {
  position(id: $id) {
    id
    investmentEntity {
      id
      hideOwnershipPct
      hideCommitment
      showNavBalance
    }
    twrPeriodMetrics {
      ...PortalTwrPeriodHeaderAndMetrics
    }
    ownershipUnit {
      id
      isMethodUnit
      isMethodCommitment
      isMethodPercentage
      isMethodContribution
      isMethodCommitmentOrPercentage
      isMethodContributionOrUnit
    }
    amountCommitted {
      monies
    }
    hideCommitment
    showOwnershipAsCommitment
    capitalCalls {
      count
    }
    distributions {
      count
    }
    transactions {
      count
    }
    netIncomes {
      count
    }
    managementFees {
      count
    }
    navs {
      count
    }
    portalTransactionPermissions {
      capitalCalls
      distributions
      transactions
      netIncome
      managementFees
      nav
      unitValues
    }
    showTimeWeightedReturns
    transactionTotals {
      lifetimeAmountDistributed {
        monies
      }
      lifetimeTotalAmountCalled {
        monies
      }
      lifetimeAmountReceived {
        monies
      }
      lifetimeTotalAmountPassedThrough {
        monies
      }
      lifetimeCapitalContributed {
        monies
      }
      lifetimeCapitalOut {
        monies
      }
    }
    totalManagementFeeAdjusted {
      monies
    }
  }
}
    ${PortalTwrPeriodHeaderAndMetricsFragmentDoc}`;

/**
 * __useGetPositionWithTransactionsQuery__
 *
 * To run a query within a React component, call `useGetPositionWithTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionWithTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionWithTransactionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPositionWithTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionWithTransactionsQuery, GraphqlTypes.GetPositionWithTransactionsQueryVariables> & ({ variables: GraphqlTypes.GetPositionWithTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionWithTransactionsQuery, GraphqlTypes.GetPositionWithTransactionsQueryVariables>(GetPositionWithTransactionsDocument, options);
      }
export function useGetPositionWithTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionWithTransactionsQuery, GraphqlTypes.GetPositionWithTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionWithTransactionsQuery, GraphqlTypes.GetPositionWithTransactionsQueryVariables>(GetPositionWithTransactionsDocument, options);
        }
// @ts-ignore
export function useGetPositionWithTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionWithTransactionsQuery, GraphqlTypes.GetPositionWithTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionWithTransactionsQuery, GraphqlTypes.GetPositionWithTransactionsQueryVariables>;
export function useGetPositionWithTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionWithTransactionsQuery, GraphqlTypes.GetPositionWithTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionWithTransactionsQuery | undefined, GraphqlTypes.GetPositionWithTransactionsQueryVariables>;
export function useGetPositionWithTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionWithTransactionsQuery, GraphqlTypes.GetPositionWithTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionWithTransactionsQuery, GraphqlTypes.GetPositionWithTransactionsQueryVariables>(GetPositionWithTransactionsDocument, options);
        }
export type GetPositionWithTransactionsQueryHookResult = ReturnType<typeof useGetPositionWithTransactionsQuery>;
export type GetPositionWithTransactionsLazyQueryHookResult = ReturnType<typeof useGetPositionWithTransactionsLazyQuery>;
export type GetPositionWithTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetPositionWithTransactionsSuspenseQuery>;
export type GetPositionWithTransactionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionWithTransactionsQuery, GraphqlTypes.GetPositionWithTransactionsQueryVariables>;
export const GetPositionDocument = gql`
    query getPosition($id: ID!, $entityTimeSeriesTypeNames: [FieldName]!) {
  position(id: $id) {
    id
    account {
      id
      name
    }
    entityCurrency
    dripPercentage
    capitalCalls {
      count
    }
    distributions {
      count
    }
    transactions {
      count
    }
    netIncomes {
      count
    }
    managementFees {
      count
    }
    navs {
      count
    }
    twrPeriodMetrics {
      ...PortalTwrPeriodHeaderAndMetrics
    }
    transactionTotals {
      amountCommitted {
        monies
      }
      lifetimeCapitalContributed {
        monies
      }
      lifetimeCapitalOut {
        monies
      }
      lifetimeAmountDistributed {
        monies
      }
      lifetimeAmountReturned {
        monies
      }
      lifetimeAmountPassedThrough {
        monies
      }
      lifetimeAmountReceived {
        monies
      }
      lifetimeTotalAmountPassedThrough {
        monies
      }
      capitalAccountBalance {
        monies
      }
      navBalance {
        monies
      }
      accountValue {
        monies
      }
      totalOutstandingCapitalCalled {
        monies
      }
      unfundedCommitment {
        monies
      }
      investedEquityBalance {
        monies
      }
      dpi
      rvpi
      tvpi
      remainingRecallable {
        monies
      }
    }
    netIncomeAllocationTotals {
      remainingTotal {
        monies
      }
      independentTotals {
        name
        lifetimeTotal {
          monies
        }
      }
    }
    contributionsByType: totalsByTransactionType(signEffect: positive) {
      new {
        monies
      }
      rollover {
        monies
      }
      transactionTypeName
    }
    redemptionsByType: totalsByTransactionType(signEffect: negative) {
      new {
        monies
      }
      rollover {
        monies
      }
      transactionTypeName
    }
    percentOwnership
    unitCountOwnership
    showOwnershipAsCommitment
    status
    investorGroup {
      id
      name
      latestUnitValues {
        id
        unitValueMetric {
          id
          name
        }
        calculatedPricePerUnit {
          monies
        }
      }
    }
    ownershipUnit {
      id
      calculationMethod
      precisionPortal
      shortName
      name
      isMethodUnit
      calculationValueMetric {
        id
        name
      }
    }
    portalTransactionPermissions {
      capitalCalls
      distributions
      transactions
      netIncome
      nav
    }
    investmentEntity {
      id
      name
      showCapitalAccountBalance
      showNavBalance
      showAccountValueBalance
      showInvestedEquityBalance
      showIrr
      showDpi
      showRvpi
      showYield
      showEntityTotalsOnNp
      overviewAndFinancialsPublished
      targetIrr {
        minVal
        maxVal
      }
      targetStrategy
      inceptionDate
      endOfInvestingPeriod
      endOfInvestmentLife
      endOfExtensionPeriods
      description
      isCompleted
      isOperatingCompany
      hideOwnershipPct
      hideCommitment
      overviewAndFinancialsVisible
      perfMetricsAsOfDate
      published
      showTwrOnAsset
      soiDisplayConfig {
        showSoiInLpPortal
        hideDateColumn
        hideUnitsColumn
        hideCostPerUnitColumn
        hideValuePerUnitColumn
        hideCostColumn
        hideFairValueColumn
        hideUnrealizedValueColumn
      }
      publishedAssetsIndirect {
        edges {
          asset: node {
            id
          }
        }
      }
      ...EntityLatestTimeSeriesProjections
    }
    lpTransactionDownloadUrl
    isCompleted
    showTimeWeightedReturns
    showCashFlowHistoryChart
    arena {
      id
      name
      perfMetricsAsOfDate
      ownershipDisplayPrecision
    }
    performanceMetrics {
      id
      irr
      irr1yr
      irr3yr
      irr5yr
      irr10yr
      cocYield
      effectiveDate
    }
    pendingCapitalCalls {
      id
      batch {
        effectiveDate
      }
    }
    contacts {
      edges {
        contact: node {
          id
          fullName
        }
      }
    }
    waterfallReturnData {
      accounts {
        label
        value
      }
      asOfDate
    }
    ...PositionExtensionFields
  }
}
    ${PortalTwrPeriodHeaderAndMetricsFragmentDoc}
${EntityLatestTimeSeriesProjectionsFragmentDoc}
${PositionExtensionFieldsFragmentDoc}`;

/**
 * __useGetPositionQuery__
 *
 * To run a query within a React component, call `useGetPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetPositionQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionQuery, GraphqlTypes.GetPositionQueryVariables> & ({ variables: GraphqlTypes.GetPositionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionQuery, GraphqlTypes.GetPositionQueryVariables>(GetPositionDocument, options);
      }
export function useGetPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionQuery, GraphqlTypes.GetPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionQuery, GraphqlTypes.GetPositionQueryVariables>(GetPositionDocument, options);
        }
// @ts-ignore
export function useGetPositionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionQuery, GraphqlTypes.GetPositionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionQuery, GraphqlTypes.GetPositionQueryVariables>;
export function useGetPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionQuery, GraphqlTypes.GetPositionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionQuery | undefined, GraphqlTypes.GetPositionQueryVariables>;
export function useGetPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionQuery, GraphqlTypes.GetPositionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionQuery, GraphqlTypes.GetPositionQueryVariables>(GetPositionDocument, options);
        }
export type GetPositionQueryHookResult = ReturnType<typeof useGetPositionQuery>;
export type GetPositionLazyQueryHookResult = ReturnType<typeof useGetPositionLazyQuery>;
export type GetPositionSuspenseQueryHookResult = ReturnType<typeof useGetPositionSuspenseQuery>;
export type GetPositionQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionQuery, GraphqlTypes.GetPositionQueryVariables>;
export const GetChildEntityDocument = gql`
    query GetChildEntity($id: ID!) {
  investmentEntity(id: $id) {
    id
    description
    published
    overviewAndFinancialsVisible
    overviewAndFinancialsPublished
  }
}
    `;

/**
 * __useGetChildEntityQuery__
 *
 * To run a query within a React component, call `useGetChildEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChildEntityQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetChildEntityQuery, GraphqlTypes.GetChildEntityQueryVariables> & ({ variables: GraphqlTypes.GetChildEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetChildEntityQuery, GraphqlTypes.GetChildEntityQueryVariables>(GetChildEntityDocument, options);
      }
export function useGetChildEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetChildEntityQuery, GraphqlTypes.GetChildEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetChildEntityQuery, GraphqlTypes.GetChildEntityQueryVariables>(GetChildEntityDocument, options);
        }
// @ts-ignore
export function useGetChildEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChildEntityQuery, GraphqlTypes.GetChildEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetChildEntityQuery, GraphqlTypes.GetChildEntityQueryVariables>;
export function useGetChildEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChildEntityQuery, GraphqlTypes.GetChildEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetChildEntityQuery | undefined, GraphqlTypes.GetChildEntityQueryVariables>;
export function useGetChildEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChildEntityQuery, GraphqlTypes.GetChildEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetChildEntityQuery, GraphqlTypes.GetChildEntityQueryVariables>(GetChildEntityDocument, options);
        }
export type GetChildEntityQueryHookResult = ReturnType<typeof useGetChildEntityQuery>;
export type GetChildEntityLazyQueryHookResult = ReturnType<typeof useGetChildEntityLazyQuery>;
export type GetChildEntitySuspenseQueryHookResult = ReturnType<typeof useGetChildEntitySuspenseQuery>;
export type GetChildEntityQueryResult = Apollo.QueryResult<GraphqlTypes.GetChildEntityQuery, GraphqlTypes.GetChildEntityQueryVariables>;
export const VerifyPasswordDocument = gql`
    mutation VerifyPassword($objectInput: VerifyPasswordInput!) {
  verifyPassword(objectInput: $objectInput) {
    __typename
    ... on MutationSuccessResponse {
      didSucceed
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type VerifyPasswordMutationFn = Apollo.MutationFunction<GraphqlTypes.VerifyPasswordMutation, GraphqlTypes.VerifyPasswordMutationVariables>;

/**
 * __useVerifyPasswordMutation__
 *
 * To run a mutation, you first call `useVerifyPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPasswordMutation, { data, loading, error }] = useVerifyPasswordMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useVerifyPasswordMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.VerifyPasswordMutation, GraphqlTypes.VerifyPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.VerifyPasswordMutation, GraphqlTypes.VerifyPasswordMutationVariables>(VerifyPasswordDocument, options);
      }
export type VerifyPasswordMutationHookResult = ReturnType<typeof useVerifyPasswordMutation>;
export type VerifyPasswordMutationResult = Apollo.MutationResult<GraphqlTypes.VerifyPasswordMutation>;
export type VerifyPasswordMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.VerifyPasswordMutation, GraphqlTypes.VerifyPasswordMutationVariables>;
export const ContactManagersDocument = gql`
    mutation ContactManagers($contactManagerInput: SettingsAddTaskInput!) {
  settingsAddTask(objectInput: $contactManagerInput) {
    __typename
    ... on SettingsAddTaskResponse {
      success
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type ContactManagersMutationFn = Apollo.MutationFunction<GraphqlTypes.ContactManagersMutation, GraphqlTypes.ContactManagersMutationVariables>;

/**
 * __useContactManagersMutation__
 *
 * To run a mutation, you first call `useContactManagersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactManagersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactManagersMutation, { data, loading, error }] = useContactManagersMutation({
 *   variables: {
 *      contactManagerInput: // value for 'contactManagerInput'
 *   },
 * });
 */
export function useContactManagersMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ContactManagersMutation, GraphqlTypes.ContactManagersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ContactManagersMutation, GraphqlTypes.ContactManagersMutationVariables>(ContactManagersDocument, options);
      }
export type ContactManagersMutationHookResult = ReturnType<typeof useContactManagersMutation>;
export type ContactManagersMutationResult = Apollo.MutationResult<GraphqlTypes.ContactManagersMutation>;
export type ContactManagersMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ContactManagersMutation, GraphqlTypes.ContactManagersMutationVariables>;
export const UpdateInvestorProfileDocument = gql`
    mutation UpdateInvestorProfile($answersToOnboardingQuestions: [LpProfileAnswersInput!]!) {
  lpProfileMutationOps {
    submitLpProfileAnswers(lpProfileAnswers: $answersToOnboardingQuestions) {
      submittedQuestionResponses {
        globalUserId
        questionId
        answerOptionId
      }
      responseHistoryLogs {
        globalUserId
        questionId
        answerOptionId
      }
    }
  }
}
    `;
export type UpdateInvestorProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateInvestorProfileMutation, GraphqlTypes.UpdateInvestorProfileMutationVariables>;

/**
 * __useUpdateInvestorProfileMutation__
 *
 * To run a mutation, you first call `useUpdateInvestorProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvestorProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvestorProfileMutation, { data, loading, error }] = useUpdateInvestorProfileMutation({
 *   variables: {
 *      answersToOnboardingQuestions: // value for 'answersToOnboardingQuestions'
 *   },
 * });
 */
export function useUpdateInvestorProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateInvestorProfileMutation, GraphqlTypes.UpdateInvestorProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateInvestorProfileMutation, GraphqlTypes.UpdateInvestorProfileMutationVariables>(UpdateInvestorProfileDocument, options);
      }
export type UpdateInvestorProfileMutationHookResult = ReturnType<typeof useUpdateInvestorProfileMutation>;
export type UpdateInvestorProfileMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateInvestorProfileMutation>;
export type UpdateInvestorProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateInvestorProfileMutation, GraphqlTypes.UpdateInvestorProfileMutationVariables>;
export const GetInvestorProfileQuestionBlocksDocument = gql`
    query GetInvestorProfileQuestionBlocks {
  questionBlocks(slugs: ["accreditation_status", "investment_preferences"]) {
    edges {
      node {
        id
        slug
        label
        summary
        modalTitle
        modalContent
        questions {
          id
          slug
          label
          title
          order
          required
          questionType
          answerOptions {
            label
            slug
            id
            isSelected
            order
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetInvestorProfileQuestionBlocksQuery__
 *
 * To run a query within a React component, call `useGetInvestorProfileQuestionBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestorProfileQuestionBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestorProfileQuestionBlocksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvestorProfileQuestionBlocksQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetInvestorProfileQuestionBlocksQuery, GraphqlTypes.GetInvestorProfileQuestionBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestorProfileQuestionBlocksQuery, GraphqlTypes.GetInvestorProfileQuestionBlocksQueryVariables>(GetInvestorProfileQuestionBlocksDocument, options);
      }
export function useGetInvestorProfileQuestionBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestorProfileQuestionBlocksQuery, GraphqlTypes.GetInvestorProfileQuestionBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestorProfileQuestionBlocksQuery, GraphqlTypes.GetInvestorProfileQuestionBlocksQueryVariables>(GetInvestorProfileQuestionBlocksDocument, options);
        }
// @ts-ignore
export function useGetInvestorProfileQuestionBlocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorProfileQuestionBlocksQuery, GraphqlTypes.GetInvestorProfileQuestionBlocksQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestorProfileQuestionBlocksQuery, GraphqlTypes.GetInvestorProfileQuestionBlocksQueryVariables>;
export function useGetInvestorProfileQuestionBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorProfileQuestionBlocksQuery, GraphqlTypes.GetInvestorProfileQuestionBlocksQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestorProfileQuestionBlocksQuery | undefined, GraphqlTypes.GetInvestorProfileQuestionBlocksQueryVariables>;
export function useGetInvestorProfileQuestionBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorProfileQuestionBlocksQuery, GraphqlTypes.GetInvestorProfileQuestionBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestorProfileQuestionBlocksQuery, GraphqlTypes.GetInvestorProfileQuestionBlocksQueryVariables>(GetInvestorProfileQuestionBlocksDocument, options);
        }
export type GetInvestorProfileQuestionBlocksQueryHookResult = ReturnType<typeof useGetInvestorProfileQuestionBlocksQuery>;
export type GetInvestorProfileQuestionBlocksLazyQueryHookResult = ReturnType<typeof useGetInvestorProfileQuestionBlocksLazyQuery>;
export type GetInvestorProfileQuestionBlocksSuspenseQueryHookResult = ReturnType<typeof useGetInvestorProfileQuestionBlocksSuspenseQuery>;
export type GetInvestorProfileQuestionBlocksQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestorProfileQuestionBlocksQuery, GraphqlTypes.GetInvestorProfileQuestionBlocksQueryVariables>;
export const CurrencyModalGetCurrenciesDocument = gql`
    query CurrencyModalGetCurrencies {
  currentGlobalUser {
    currencies {
      id
      symbol
      fullName
      code
      flagUnicode
    }
  }
}
    `;

/**
 * __useCurrencyModalGetCurrenciesQuery__
 *
 * To run a query within a React component, call `useCurrencyModalGetCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrencyModalGetCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrencyModalGetCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrencyModalGetCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.CurrencyModalGetCurrenciesQuery, GraphqlTypes.CurrencyModalGetCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CurrencyModalGetCurrenciesQuery, GraphqlTypes.CurrencyModalGetCurrenciesQueryVariables>(CurrencyModalGetCurrenciesDocument, options);
      }
export function useCurrencyModalGetCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CurrencyModalGetCurrenciesQuery, GraphqlTypes.CurrencyModalGetCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CurrencyModalGetCurrenciesQuery, GraphqlTypes.CurrencyModalGetCurrenciesQueryVariables>(CurrencyModalGetCurrenciesDocument, options);
        }
// @ts-ignore
export function useCurrencyModalGetCurrenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrencyModalGetCurrenciesQuery, GraphqlTypes.CurrencyModalGetCurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CurrencyModalGetCurrenciesQuery, GraphqlTypes.CurrencyModalGetCurrenciesQueryVariables>;
export function useCurrencyModalGetCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrencyModalGetCurrenciesQuery, GraphqlTypes.CurrencyModalGetCurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CurrencyModalGetCurrenciesQuery | undefined, GraphqlTypes.CurrencyModalGetCurrenciesQueryVariables>;
export function useCurrencyModalGetCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrencyModalGetCurrenciesQuery, GraphqlTypes.CurrencyModalGetCurrenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CurrencyModalGetCurrenciesQuery, GraphqlTypes.CurrencyModalGetCurrenciesQueryVariables>(CurrencyModalGetCurrenciesDocument, options);
        }
export type CurrencyModalGetCurrenciesQueryHookResult = ReturnType<typeof useCurrencyModalGetCurrenciesQuery>;
export type CurrencyModalGetCurrenciesLazyQueryHookResult = ReturnType<typeof useCurrencyModalGetCurrenciesLazyQuery>;
export type CurrencyModalGetCurrenciesSuspenseQueryHookResult = ReturnType<typeof useCurrencyModalGetCurrenciesSuspenseQuery>;
export type CurrencyModalGetCurrenciesQueryResult = Apollo.QueryResult<GraphqlTypes.CurrencyModalGetCurrenciesQuery, GraphqlTypes.CurrencyModalGetCurrenciesQueryVariables>;
export const UpdateUserPreferencesDatetimeFormatDocument = gql`
    mutation UpdateUserPreferencesDatetimeFormat($input: DatetimeFormatPreferencesInput!) {
  updateDatetimeFormatPreferences(objectInput: $input) {
    ... on UpdateDatetimeFormatPreferencesObject {
      user {
        id
        dateFormat
        timeFormat
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type UpdateUserPreferencesDatetimeFormatMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateUserPreferencesDatetimeFormatMutation, GraphqlTypes.UpdateUserPreferencesDatetimeFormatMutationVariables>;

/**
 * __useUpdateUserPreferencesDatetimeFormatMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferencesDatetimeFormatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferencesDatetimeFormatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferencesDatetimeFormatMutation, { data, loading, error }] = useUpdateUserPreferencesDatetimeFormatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPreferencesDatetimeFormatMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateUserPreferencesDatetimeFormatMutation, GraphqlTypes.UpdateUserPreferencesDatetimeFormatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateUserPreferencesDatetimeFormatMutation, GraphqlTypes.UpdateUserPreferencesDatetimeFormatMutationVariables>(UpdateUserPreferencesDatetimeFormatDocument, options);
      }
export type UpdateUserPreferencesDatetimeFormatMutationHookResult = ReturnType<typeof useUpdateUserPreferencesDatetimeFormatMutation>;
export type UpdateUserPreferencesDatetimeFormatMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateUserPreferencesDatetimeFormatMutation>;
export type UpdateUserPreferencesDatetimeFormatMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateUserPreferencesDatetimeFormatMutation, GraphqlTypes.UpdateUserPreferencesDatetimeFormatMutationVariables>;
export const CreateLpConsolidationRequestDocument = gql`
    mutation CreateLpConsolidationRequest($input: CreateLpConsolidationRequestInput!) {
  createLpConsolidationRequest(objectInput: $input) {
    ... on LpConsolidationRequestObject {
      isSuccess
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type CreateLpConsolidationRequestMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateLpConsolidationRequestMutation, GraphqlTypes.CreateLpConsolidationRequestMutationVariables>;

/**
 * __useCreateLpConsolidationRequestMutation__
 *
 * To run a mutation, you first call `useCreateLpConsolidationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLpConsolidationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLpConsolidationRequestMutation, { data, loading, error }] = useCreateLpConsolidationRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLpConsolidationRequestMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateLpConsolidationRequestMutation, GraphqlTypes.CreateLpConsolidationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateLpConsolidationRequestMutation, GraphqlTypes.CreateLpConsolidationRequestMutationVariables>(CreateLpConsolidationRequestDocument, options);
      }
export type CreateLpConsolidationRequestMutationHookResult = ReturnType<typeof useCreateLpConsolidationRequestMutation>;
export type CreateLpConsolidationRequestMutationResult = Apollo.MutationResult<GraphqlTypes.CreateLpConsolidationRequestMutation>;
export type CreateLpConsolidationRequestMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateLpConsolidationRequestMutation, GraphqlTypes.CreateLpConsolidationRequestMutationVariables>;
export const GetRecoveryCodesForProfileSettingDocument = gql`
    query GetRecoveryCodesForProfileSetting($password: String!) {
  currentGlobalUser {
    id
    twoFaRecoveryCodeInfo(password: $password) {
      activeTwoFaRecoveryCodes
      twoFaRecoveryCodesDownloadPath
    }
  }
}
    `;

/**
 * __useGetRecoveryCodesForProfileSettingQuery__
 *
 * To run a query within a React component, call `useGetRecoveryCodesForProfileSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecoveryCodesForProfileSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecoveryCodesForProfileSettingQuery({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGetRecoveryCodesForProfileSettingQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetRecoveryCodesForProfileSettingQuery, GraphqlTypes.GetRecoveryCodesForProfileSettingQueryVariables> & ({ variables: GraphqlTypes.GetRecoveryCodesForProfileSettingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRecoveryCodesForProfileSettingQuery, GraphqlTypes.GetRecoveryCodesForProfileSettingQueryVariables>(GetRecoveryCodesForProfileSettingDocument, options);
      }
export function useGetRecoveryCodesForProfileSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRecoveryCodesForProfileSettingQuery, GraphqlTypes.GetRecoveryCodesForProfileSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRecoveryCodesForProfileSettingQuery, GraphqlTypes.GetRecoveryCodesForProfileSettingQueryVariables>(GetRecoveryCodesForProfileSettingDocument, options);
        }
// @ts-ignore
export function useGetRecoveryCodesForProfileSettingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecoveryCodesForProfileSettingQuery, GraphqlTypes.GetRecoveryCodesForProfileSettingQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRecoveryCodesForProfileSettingQuery, GraphqlTypes.GetRecoveryCodesForProfileSettingQueryVariables>;
export function useGetRecoveryCodesForProfileSettingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecoveryCodesForProfileSettingQuery, GraphqlTypes.GetRecoveryCodesForProfileSettingQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRecoveryCodesForProfileSettingQuery | undefined, GraphqlTypes.GetRecoveryCodesForProfileSettingQueryVariables>;
export function useGetRecoveryCodesForProfileSettingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecoveryCodesForProfileSettingQuery, GraphqlTypes.GetRecoveryCodesForProfileSettingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRecoveryCodesForProfileSettingQuery, GraphqlTypes.GetRecoveryCodesForProfileSettingQueryVariables>(GetRecoveryCodesForProfileSettingDocument, options);
        }
export type GetRecoveryCodesForProfileSettingQueryHookResult = ReturnType<typeof useGetRecoveryCodesForProfileSettingQuery>;
export type GetRecoveryCodesForProfileSettingLazyQueryHookResult = ReturnType<typeof useGetRecoveryCodesForProfileSettingLazyQuery>;
export type GetRecoveryCodesForProfileSettingSuspenseQueryHookResult = ReturnType<typeof useGetRecoveryCodesForProfileSettingSuspenseQuery>;
export type GetRecoveryCodesForProfileSettingQueryResult = Apollo.QueryResult<GraphqlTypes.GetRecoveryCodesForProfileSettingQuery, GraphqlTypes.GetRecoveryCodesForProfileSettingQueryVariables>;
export const GetDatetimeInternationalizationFeatureFlagDocument = gql`
    query GetDatetimeInternationalizationFeatureFlag {
  devFeatures {
    portalDatetimeInternationalization
  }
}
    `;

/**
 * __useGetDatetimeInternationalizationFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetDatetimeInternationalizationFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatetimeInternationalizationFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatetimeInternationalizationFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDatetimeInternationalizationFeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQuery, GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQuery, GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQueryVariables>(GetDatetimeInternationalizationFeatureFlagDocument, options);
      }
export function useGetDatetimeInternationalizationFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQuery, GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQuery, GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQueryVariables>(GetDatetimeInternationalizationFeatureFlagDocument, options);
        }
// @ts-ignore
export function useGetDatetimeInternationalizationFeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQuery, GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQuery, GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQueryVariables>;
export function useGetDatetimeInternationalizationFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQuery, GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQuery | undefined, GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQueryVariables>;
export function useGetDatetimeInternationalizationFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQuery, GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQuery, GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQueryVariables>(GetDatetimeInternationalizationFeatureFlagDocument, options);
        }
export type GetDatetimeInternationalizationFeatureFlagQueryHookResult = ReturnType<typeof useGetDatetimeInternationalizationFeatureFlagQuery>;
export type GetDatetimeInternationalizationFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetDatetimeInternationalizationFeatureFlagLazyQuery>;
export type GetDatetimeInternationalizationFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetDatetimeInternationalizationFeatureFlagSuspenseQuery>;
export type GetDatetimeInternationalizationFeatureFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQuery, GraphqlTypes.GetDatetimeInternationalizationFeatureFlagQueryVariables>;
export const GetCurrencyConversionFeatureFlagDocument = gql`
    query GetCurrencyConversionFeatureFlag {
  managerArenas {
    hasCurrencyConversion
  }
}
    `;

/**
 * __useGetCurrencyConversionFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetCurrencyConversionFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyConversionFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyConversionFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrencyConversionFeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrencyConversionFeatureFlagQuery, GraphqlTypes.GetCurrencyConversionFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrencyConversionFeatureFlagQuery, GraphqlTypes.GetCurrencyConversionFeatureFlagQueryVariables>(GetCurrencyConversionFeatureFlagDocument, options);
      }
export function useGetCurrencyConversionFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrencyConversionFeatureFlagQuery, GraphqlTypes.GetCurrencyConversionFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrencyConversionFeatureFlagQuery, GraphqlTypes.GetCurrencyConversionFeatureFlagQueryVariables>(GetCurrencyConversionFeatureFlagDocument, options);
        }
// @ts-ignore
export function useGetCurrencyConversionFeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrencyConversionFeatureFlagQuery, GraphqlTypes.GetCurrencyConversionFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrencyConversionFeatureFlagQuery, GraphqlTypes.GetCurrencyConversionFeatureFlagQueryVariables>;
export function useGetCurrencyConversionFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrencyConversionFeatureFlagQuery, GraphqlTypes.GetCurrencyConversionFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrencyConversionFeatureFlagQuery | undefined, GraphqlTypes.GetCurrencyConversionFeatureFlagQueryVariables>;
export function useGetCurrencyConversionFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrencyConversionFeatureFlagQuery, GraphqlTypes.GetCurrencyConversionFeatureFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrencyConversionFeatureFlagQuery, GraphqlTypes.GetCurrencyConversionFeatureFlagQueryVariables>(GetCurrencyConversionFeatureFlagDocument, options);
        }
export type GetCurrencyConversionFeatureFlagQueryHookResult = ReturnType<typeof useGetCurrencyConversionFeatureFlagQuery>;
export type GetCurrencyConversionFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetCurrencyConversionFeatureFlagLazyQuery>;
export type GetCurrencyConversionFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetCurrencyConversionFeatureFlagSuspenseQuery>;
export type GetCurrencyConversionFeatureFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrencyConversionFeatureFlagQuery, GraphqlTypes.GetCurrencyConversionFeatureFlagQueryVariables>;
export const UpdateAccountsDocument = gql`
    mutation UpdateAccounts($bulkUpdateAccountInput: BulkUpdateAccountInput!) {
  accountBulkUpdate(bulkUpdateAccountInput: $bulkUpdateAccountInput) {
    ... on BulkUpdateAccountResponse {
      accounts {
        id
        name
        canViewAccountDetails
        canEditAccountDetails
        isInvestmentEntity
        gpDisplayName
        arenaId
        arena {
          name
          logoUrl
          headerLogoUrl
          features {
            hasEditableLpPaymentPreferences
          }
        }
        contacts {
          count
          edges {
            node {
              id
              firstName
              lastName
            }
          }
        }
        mailingAddress {
          street
          street2
          street3
          city
          region
          addressType
          country {
            objectId
            objectName
          }
          state {
            objectId
            objectName
          }
          postalCode
        }
        paymentPrefs {
          id
          paymentMethod
          bankInfoRedacted
          checkAddrCity
          checkAddrStreet
          checkAddrStreet2
          checkAddrStreet3
          checkAddrRegion
          checkAddrState {
            name
          }
          checkAddrCountry {
            name
          }
          checkAddrPostalCode
        }
        positions {
          edges {
            node {
              id
              investmentEntity {
                name
              }
            }
          }
        }
      }
      updatedAccountsCount
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UpdateAccountsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateAccountsMutation, GraphqlTypes.UpdateAccountsMutationVariables>;

/**
 * __useUpdateAccountsMutation__
 *
 * To run a mutation, you first call `useUpdateAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountsMutation, { data, loading, error }] = useUpdateAccountsMutation({
 *   variables: {
 *      bulkUpdateAccountInput: // value for 'bulkUpdateAccountInput'
 *   },
 * });
 */
export function useUpdateAccountsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateAccountsMutation, GraphqlTypes.UpdateAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateAccountsMutation, GraphqlTypes.UpdateAccountsMutationVariables>(UpdateAccountsDocument, options);
      }
export type UpdateAccountsMutationHookResult = ReturnType<typeof useUpdateAccountsMutation>;
export type UpdateAccountsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateAccountsMutation>;
export type UpdateAccountsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateAccountsMutation, GraphqlTypes.UpdateAccountsMutationVariables>;
export const UpdatePaymentPrefDocument = gql`
    mutation UpdatePaymentPref($objectInput: AccountBulkUpdatePaymentPrefsInput!) {
  accountBulkUpdatePaymentPrefs(objectInput: $objectInput) {
    ... on AccountBulkUpdatePaymentPrefsResponse {
      accounts {
        id
        name
        paymentPrefs {
          paymentMethod
          bankInfoRedacted
          checkAddrState {
            id
            name
          }
          checkAddrRegion
        }
      }
      changedPositions {
        id
        account {
          id
        }
        investmentEntity {
          name
        }
      }
      unchangedPositions {
        id
        account {
          id
        }
        investmentEntity {
          name
        }
      }
      updatedAccountsCount
      changedPositionsCount
      unchangedPositionsCount
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
    ... on AccountBulkUpdatePaymentPrefsValidationErrors {
      errors {
        message
        path
      }
    }
  }
}
    `;
export type UpdatePaymentPrefMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePaymentPrefMutation, GraphqlTypes.UpdatePaymentPrefMutationVariables>;

/**
 * __useUpdatePaymentPrefMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentPrefMutation, { data, loading, error }] = useUpdatePaymentPrefMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdatePaymentPrefMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePaymentPrefMutation, GraphqlTypes.UpdatePaymentPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePaymentPrefMutation, GraphqlTypes.UpdatePaymentPrefMutationVariables>(UpdatePaymentPrefDocument, options);
      }
export type UpdatePaymentPrefMutationHookResult = ReturnType<typeof useUpdatePaymentPrefMutation>;
export type UpdatePaymentPrefMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePaymentPrefMutation>;
export type UpdatePaymentPrefMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePaymentPrefMutation, GraphqlTypes.UpdatePaymentPrefMutationVariables>;
export const GetSubscriptionInfoForSelectorModalDocument = gql`
    query GetSubscriptionInfoForSelectorModal($offeringId: ID!, $validPortalOfferingsOnly: Boolean) {
  offering(id: $offeringId, validPortalOfferingsOnly: $validPortalOfferingsOnly) {
    id
    arenaId
    prospects {
      edges {
        node {
          id
          prospectContactMaps {
            id
            dataRoomKey
            contactId
          }
          prospectContactNameConcatenation
          subscription {
            id
            accountName
            entityId
            entityName
            status
            isEditable
            amountRequested
            subscriptionInfo {
              subscriptionInfoHash
              primaryContactNames
              secondaryContactNames
              formattedInvestmentAmount
              dataRoomKey
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSubscriptionInfoForSelectorModalQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionInfoForSelectorModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionInfoForSelectorModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionInfoForSelectorModalQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *      validPortalOfferingsOnly: // value for 'validPortalOfferingsOnly'
 *   },
 * });
 */
export function useGetSubscriptionInfoForSelectorModalQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSubscriptionInfoForSelectorModalQuery, GraphqlTypes.GetSubscriptionInfoForSelectorModalQueryVariables> & ({ variables: GraphqlTypes.GetSubscriptionInfoForSelectorModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSubscriptionInfoForSelectorModalQuery, GraphqlTypes.GetSubscriptionInfoForSelectorModalQueryVariables>(GetSubscriptionInfoForSelectorModalDocument, options);
      }
export function useGetSubscriptionInfoForSelectorModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSubscriptionInfoForSelectorModalQuery, GraphqlTypes.GetSubscriptionInfoForSelectorModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSubscriptionInfoForSelectorModalQuery, GraphqlTypes.GetSubscriptionInfoForSelectorModalQueryVariables>(GetSubscriptionInfoForSelectorModalDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionInfoForSelectorModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionInfoForSelectorModalQuery, GraphqlTypes.GetSubscriptionInfoForSelectorModalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionInfoForSelectorModalQuery, GraphqlTypes.GetSubscriptionInfoForSelectorModalQueryVariables>;
export function useGetSubscriptionInfoForSelectorModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionInfoForSelectorModalQuery, GraphqlTypes.GetSubscriptionInfoForSelectorModalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionInfoForSelectorModalQuery | undefined, GraphqlTypes.GetSubscriptionInfoForSelectorModalQueryVariables>;
export function useGetSubscriptionInfoForSelectorModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionInfoForSelectorModalQuery, GraphqlTypes.GetSubscriptionInfoForSelectorModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSubscriptionInfoForSelectorModalQuery, GraphqlTypes.GetSubscriptionInfoForSelectorModalQueryVariables>(GetSubscriptionInfoForSelectorModalDocument, options);
        }
export type GetSubscriptionInfoForSelectorModalQueryHookResult = ReturnType<typeof useGetSubscriptionInfoForSelectorModalQuery>;
export type GetSubscriptionInfoForSelectorModalLazyQueryHookResult = ReturnType<typeof useGetSubscriptionInfoForSelectorModalLazyQuery>;
export type GetSubscriptionInfoForSelectorModalSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionInfoForSelectorModalSuspenseQuery>;
export type GetSubscriptionInfoForSelectorModalQueryResult = Apollo.QueryResult<GraphqlTypes.GetSubscriptionInfoForSelectorModalQuery, GraphqlTypes.GetSubscriptionInfoForSelectorModalQueryVariables>;
export const DownloadArenasTouAndPpDocument = gql`
    mutation DownloadArenasTouAndPP($arenaIds: [ID!]!, $includeNetworkTou: Boolean!) {
  downloadArenasTermsOfUseAndPrivacyPolicies(
    arenaIds: $arenaIds
    includeNetworkTou: $includeNetworkTou
  ) {
    job {
      id
    }
  }
}
    `;
export type DownloadArenasTouAndPpMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadArenasTouAndPpMutation, GraphqlTypes.DownloadArenasTouAndPpMutationVariables>;

/**
 * __useDownloadArenasTouAndPpMutation__
 *
 * To run a mutation, you first call `useDownloadArenasTouAndPpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadArenasTouAndPpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadArenasTouAndPpMutation, { data, loading, error }] = useDownloadArenasTouAndPpMutation({
 *   variables: {
 *      arenaIds: // value for 'arenaIds'
 *      includeNetworkTou: // value for 'includeNetworkTou'
 *   },
 * });
 */
export function useDownloadArenasTouAndPpMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadArenasTouAndPpMutation, GraphqlTypes.DownloadArenasTouAndPpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadArenasTouAndPpMutation, GraphqlTypes.DownloadArenasTouAndPpMutationVariables>(DownloadArenasTouAndPpDocument, options);
      }
export type DownloadArenasTouAndPpMutationHookResult = ReturnType<typeof useDownloadArenasTouAndPpMutation>;
export type DownloadArenasTouAndPpMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadArenasTouAndPpMutation>;
export type DownloadArenasTouAndPpMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadArenasTouAndPpMutation, GraphqlTypes.DownloadArenasTouAndPpMutationVariables>;
export const GetUnifiedPortalFeatureFlagDocument = gql`
    query getUnifiedPortalFeatureFlag {
  devFeatures {
    unifiedPortal
  }
}
    `;

/**
 * __useGetUnifiedPortalFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetUnifiedPortalFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnifiedPortalFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnifiedPortalFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnifiedPortalFeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>(GetUnifiedPortalFeatureFlagDocument, options);
      }
export function useGetUnifiedPortalFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>(GetUnifiedPortalFeatureFlagDocument, options);
        }
// @ts-ignore
export function useGetUnifiedPortalFeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>;
export function useGetUnifiedPortalFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery | undefined, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>;
export function useGetUnifiedPortalFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>(GetUnifiedPortalFeatureFlagDocument, options);
        }
export type GetUnifiedPortalFeatureFlagQueryHookResult = ReturnType<typeof useGetUnifiedPortalFeatureFlagQuery>;
export type GetUnifiedPortalFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetUnifiedPortalFeatureFlagLazyQuery>;
export type GetUnifiedPortalFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetUnifiedPortalFeatureFlagSuspenseQuery>;
export type GetUnifiedPortalFeatureFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>;
export const GetActivationFlowTermsAndPpDocument = gql`
    query GetActivationFlowTermsAndPP($code: String!) {
  unifiedPortalUnauthTermsAndPolicy(code: $code) {
    ...UnifiedPortalUnauthTermsAndPolicyObjectFragment
    ...UnifiedPortalUnauthTermsAndPolicyErrorFragment
  }
}
    ${UnifiedPortalUnauthTermsAndPolicyObjectFragmentFragmentDoc}
${UnifiedPortalUnauthTermsAndPolicyErrorFragmentFragmentDoc}`;

/**
 * __useGetActivationFlowTermsAndPpQuery__
 *
 * To run a query within a React component, call `useGetActivationFlowTermsAndPpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivationFlowTermsAndPpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivationFlowTermsAndPpQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetActivationFlowTermsAndPpQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetActivationFlowTermsAndPpQuery, GraphqlTypes.GetActivationFlowTermsAndPpQueryVariables> & ({ variables: GraphqlTypes.GetActivationFlowTermsAndPpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActivationFlowTermsAndPpQuery, GraphqlTypes.GetActivationFlowTermsAndPpQueryVariables>(GetActivationFlowTermsAndPpDocument, options);
      }
export function useGetActivationFlowTermsAndPpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActivationFlowTermsAndPpQuery, GraphqlTypes.GetActivationFlowTermsAndPpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActivationFlowTermsAndPpQuery, GraphqlTypes.GetActivationFlowTermsAndPpQueryVariables>(GetActivationFlowTermsAndPpDocument, options);
        }
// @ts-ignore
export function useGetActivationFlowTermsAndPpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivationFlowTermsAndPpQuery, GraphqlTypes.GetActivationFlowTermsAndPpQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivationFlowTermsAndPpQuery, GraphqlTypes.GetActivationFlowTermsAndPpQueryVariables>;
export function useGetActivationFlowTermsAndPpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivationFlowTermsAndPpQuery, GraphqlTypes.GetActivationFlowTermsAndPpQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivationFlowTermsAndPpQuery | undefined, GraphqlTypes.GetActivationFlowTermsAndPpQueryVariables>;
export function useGetActivationFlowTermsAndPpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivationFlowTermsAndPpQuery, GraphqlTypes.GetActivationFlowTermsAndPpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActivationFlowTermsAndPpQuery, GraphqlTypes.GetActivationFlowTermsAndPpQueryVariables>(GetActivationFlowTermsAndPpDocument, options);
        }
export type GetActivationFlowTermsAndPpQueryHookResult = ReturnType<typeof useGetActivationFlowTermsAndPpQuery>;
export type GetActivationFlowTermsAndPpLazyQueryHookResult = ReturnType<typeof useGetActivationFlowTermsAndPpLazyQuery>;
export type GetActivationFlowTermsAndPpSuspenseQueryHookResult = ReturnType<typeof useGetActivationFlowTermsAndPpSuspenseQuery>;
export type GetActivationFlowTermsAndPpQueryResult = Apollo.QueryResult<GraphqlTypes.GetActivationFlowTermsAndPpQuery, GraphqlTypes.GetActivationFlowTermsAndPpQueryVariables>;
export const GetTermsAndPpDocument = gql`
    query GetTermsAndPP($arenaIds: [ID!]!) {
  managerArenas(arenaIds: $arenaIds) {
    id
    name
    domain
    clientTos
    clientPrivacyPolicy
  }
}
    `;

/**
 * __useGetTermsAndPpQuery__
 *
 * To run a query within a React component, call `useGetTermsAndPpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsAndPpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsAndPpQuery({
 *   variables: {
 *      arenaIds: // value for 'arenaIds'
 *   },
 * });
 */
export function useGetTermsAndPpQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTermsAndPpQuery, GraphqlTypes.GetTermsAndPpQueryVariables> & ({ variables: GraphqlTypes.GetTermsAndPpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTermsAndPpQuery, GraphqlTypes.GetTermsAndPpQueryVariables>(GetTermsAndPpDocument, options);
      }
export function useGetTermsAndPpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTermsAndPpQuery, GraphqlTypes.GetTermsAndPpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTermsAndPpQuery, GraphqlTypes.GetTermsAndPpQueryVariables>(GetTermsAndPpDocument, options);
        }
// @ts-ignore
export function useGetTermsAndPpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTermsAndPpQuery, GraphqlTypes.GetTermsAndPpQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTermsAndPpQuery, GraphqlTypes.GetTermsAndPpQueryVariables>;
export function useGetTermsAndPpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTermsAndPpQuery, GraphqlTypes.GetTermsAndPpQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTermsAndPpQuery | undefined, GraphqlTypes.GetTermsAndPpQueryVariables>;
export function useGetTermsAndPpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTermsAndPpQuery, GraphqlTypes.GetTermsAndPpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTermsAndPpQuery, GraphqlTypes.GetTermsAndPpQueryVariables>(GetTermsAndPpDocument, options);
        }
export type GetTermsAndPpQueryHookResult = ReturnType<typeof useGetTermsAndPpQuery>;
export type GetTermsAndPpLazyQueryHookResult = ReturnType<typeof useGetTermsAndPpLazyQuery>;
export type GetTermsAndPpSuspenseQueryHookResult = ReturnType<typeof useGetTermsAndPpSuspenseQuery>;
export type GetTermsAndPpQueryResult = Apollo.QueryResult<GraphqlTypes.GetTermsAndPpQuery, GraphqlTypes.GetTermsAndPpQueryVariables>;
export const UpdateEmailTwoStepAuthSettingsDocument = gql`
    mutation UpdateEmailTwoStepAuthSettings($objectInput: UpdateEmailTwoStepAuthSettingsInput!) {
  globalUserOps {
    updateEmailTwoStepAuthSettings(objectInput: $objectInput) {
      __typename
      user {
        id
        currentTwoFaMethods
      }
    }
  }
}
    `;
export type UpdateEmailTwoStepAuthSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateEmailTwoStepAuthSettingsMutation, GraphqlTypes.UpdateEmailTwoStepAuthSettingsMutationVariables>;

/**
 * __useUpdateEmailTwoStepAuthSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEmailTwoStepAuthSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailTwoStepAuthSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailTwoStepAuthSettingsMutation, { data, loading, error }] = useUpdateEmailTwoStepAuthSettingsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateEmailTwoStepAuthSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateEmailTwoStepAuthSettingsMutation, GraphqlTypes.UpdateEmailTwoStepAuthSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateEmailTwoStepAuthSettingsMutation, GraphqlTypes.UpdateEmailTwoStepAuthSettingsMutationVariables>(UpdateEmailTwoStepAuthSettingsDocument, options);
      }
export type UpdateEmailTwoStepAuthSettingsMutationHookResult = ReturnType<typeof useUpdateEmailTwoStepAuthSettingsMutation>;
export type UpdateEmailTwoStepAuthSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateEmailTwoStepAuthSettingsMutation>;
export type UpdateEmailTwoStepAuthSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateEmailTwoStepAuthSettingsMutation, GraphqlTypes.UpdateEmailTwoStepAuthSettingsMutationVariables>;
export const UpdateTotpTwoStepAuthSettingsDocument = gql`
    mutation UpdateTotpTwoStepAuthSettings($objectInput: UpdateTotpTwoStepAuthSettingsInput!) {
  globalUserOps {
    updateTotpTwoStepAuthSettings(objectInput: $objectInput) {
      user {
        id
        hasUnlinkedLocalUsers
      }
    }
  }
}
    `;
export type UpdateTotpTwoStepAuthSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateTotpTwoStepAuthSettingsMutation, GraphqlTypes.UpdateTotpTwoStepAuthSettingsMutationVariables>;

/**
 * __useUpdateTotpTwoStepAuthSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTotpTwoStepAuthSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTotpTwoStepAuthSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTotpTwoStepAuthSettingsMutation, { data, loading, error }] = useUpdateTotpTwoStepAuthSettingsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateTotpTwoStepAuthSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateTotpTwoStepAuthSettingsMutation, GraphqlTypes.UpdateTotpTwoStepAuthSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateTotpTwoStepAuthSettingsMutation, GraphqlTypes.UpdateTotpTwoStepAuthSettingsMutationVariables>(UpdateTotpTwoStepAuthSettingsDocument, options);
      }
export type UpdateTotpTwoStepAuthSettingsMutationHookResult = ReturnType<typeof useUpdateTotpTwoStepAuthSettingsMutation>;
export type UpdateTotpTwoStepAuthSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateTotpTwoStepAuthSettingsMutation>;
export type UpdateTotpTwoStepAuthSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateTotpTwoStepAuthSettingsMutation, GraphqlTypes.UpdateTotpTwoStepAuthSettingsMutationVariables>;
export const GetViewableArenasDocument = gql`
    query GetViewableArenas {
  viewableArenas {
    edges {
      node {
        id
        name
        domain
      }
    }
  }
}
    `;

/**
 * __useGetViewableArenasQuery__
 *
 * To run a query within a React component, call `useGetViewableArenasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewableArenasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewableArenasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewableArenasQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetViewableArenasQuery, GraphqlTypes.GetViewableArenasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetViewableArenasQuery, GraphqlTypes.GetViewableArenasQueryVariables>(GetViewableArenasDocument, options);
      }
export function useGetViewableArenasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetViewableArenasQuery, GraphqlTypes.GetViewableArenasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetViewableArenasQuery, GraphqlTypes.GetViewableArenasQueryVariables>(GetViewableArenasDocument, options);
        }
// @ts-ignore
export function useGetViewableArenasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetViewableArenasQuery, GraphqlTypes.GetViewableArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetViewableArenasQuery, GraphqlTypes.GetViewableArenasQueryVariables>;
export function useGetViewableArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetViewableArenasQuery, GraphqlTypes.GetViewableArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetViewableArenasQuery | undefined, GraphqlTypes.GetViewableArenasQueryVariables>;
export function useGetViewableArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetViewableArenasQuery, GraphqlTypes.GetViewableArenasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetViewableArenasQuery, GraphqlTypes.GetViewableArenasQueryVariables>(GetViewableArenasDocument, options);
        }
export type GetViewableArenasQueryHookResult = ReturnType<typeof useGetViewableArenasQuery>;
export type GetViewableArenasLazyQueryHookResult = ReturnType<typeof useGetViewableArenasLazyQuery>;
export type GetViewableArenasSuspenseQueryHookResult = ReturnType<typeof useGetViewableArenasSuspenseQuery>;
export type GetViewableArenasQueryResult = Apollo.QueryResult<GraphqlTypes.GetViewableArenasQuery, GraphqlTypes.GetViewableArenasQueryVariables>;
export const GetGpArenaTwoFaNumbersDocument = gql`
    query GetGpArenaTwoFaNumbers {
  gpArenaTwoFaNumbers {
    arenaIds
    twoFaNumber
  }
}
    `;

/**
 * __useGetGpArenaTwoFaNumbersQuery__
 *
 * To run a query within a React component, call `useGetGpArenaTwoFaNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpArenaTwoFaNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpArenaTwoFaNumbersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGpArenaTwoFaNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetGpArenaTwoFaNumbersQuery, GraphqlTypes.GetGpArenaTwoFaNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGpArenaTwoFaNumbersQuery, GraphqlTypes.GetGpArenaTwoFaNumbersQueryVariables>(GetGpArenaTwoFaNumbersDocument, options);
      }
export function useGetGpArenaTwoFaNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGpArenaTwoFaNumbersQuery, GraphqlTypes.GetGpArenaTwoFaNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGpArenaTwoFaNumbersQuery, GraphqlTypes.GetGpArenaTwoFaNumbersQueryVariables>(GetGpArenaTwoFaNumbersDocument, options);
        }
// @ts-ignore
export function useGetGpArenaTwoFaNumbersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpArenaTwoFaNumbersQuery, GraphqlTypes.GetGpArenaTwoFaNumbersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpArenaTwoFaNumbersQuery, GraphqlTypes.GetGpArenaTwoFaNumbersQueryVariables>;
export function useGetGpArenaTwoFaNumbersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpArenaTwoFaNumbersQuery, GraphqlTypes.GetGpArenaTwoFaNumbersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpArenaTwoFaNumbersQuery | undefined, GraphqlTypes.GetGpArenaTwoFaNumbersQueryVariables>;
export function useGetGpArenaTwoFaNumbersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpArenaTwoFaNumbersQuery, GraphqlTypes.GetGpArenaTwoFaNumbersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGpArenaTwoFaNumbersQuery, GraphqlTypes.GetGpArenaTwoFaNumbersQueryVariables>(GetGpArenaTwoFaNumbersDocument, options);
        }
export type GetGpArenaTwoFaNumbersQueryHookResult = ReturnType<typeof useGetGpArenaTwoFaNumbersQuery>;
export type GetGpArenaTwoFaNumbersLazyQueryHookResult = ReturnType<typeof useGetGpArenaTwoFaNumbersLazyQuery>;
export type GetGpArenaTwoFaNumbersSuspenseQueryHookResult = ReturnType<typeof useGetGpArenaTwoFaNumbersSuspenseQuery>;
export type GetGpArenaTwoFaNumbersQueryResult = Apollo.QueryResult<GraphqlTypes.GetGpArenaTwoFaNumbersQuery, GraphqlTypes.GetGpArenaTwoFaNumbersQueryVariables>;
export const GetCurrentGlobalUserDocument = gql`
    query GetCurrentGlobalUser {
  currentGlobalUser {
    id
    globalActivated
  }
}
    `;

/**
 * __useGetCurrentGlobalUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentGlobalUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentGlobalUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentGlobalUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentGlobalUserQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrentGlobalUserQuery, GraphqlTypes.GetCurrentGlobalUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrentGlobalUserQuery, GraphqlTypes.GetCurrentGlobalUserQueryVariables>(GetCurrentGlobalUserDocument, options);
      }
export function useGetCurrentGlobalUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrentGlobalUserQuery, GraphqlTypes.GetCurrentGlobalUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrentGlobalUserQuery, GraphqlTypes.GetCurrentGlobalUserQueryVariables>(GetCurrentGlobalUserDocument, options);
        }
// @ts-ignore
export function useGetCurrentGlobalUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentGlobalUserQuery, GraphqlTypes.GetCurrentGlobalUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentGlobalUserQuery, GraphqlTypes.GetCurrentGlobalUserQueryVariables>;
export function useGetCurrentGlobalUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentGlobalUserQuery, GraphqlTypes.GetCurrentGlobalUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentGlobalUserQuery | undefined, GraphqlTypes.GetCurrentGlobalUserQueryVariables>;
export function useGetCurrentGlobalUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentGlobalUserQuery, GraphqlTypes.GetCurrentGlobalUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrentGlobalUserQuery, GraphqlTypes.GetCurrentGlobalUserQueryVariables>(GetCurrentGlobalUserDocument, options);
        }
export type GetCurrentGlobalUserQueryHookResult = ReturnType<typeof useGetCurrentGlobalUserQuery>;
export type GetCurrentGlobalUserLazyQueryHookResult = ReturnType<typeof useGetCurrentGlobalUserLazyQuery>;
export type GetCurrentGlobalUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentGlobalUserSuspenseQuery>;
export type GetCurrentGlobalUserQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrentGlobalUserQuery, GraphqlTypes.GetCurrentGlobalUserQueryVariables>;
export const GetSessionStatusDocument = gql`
    query GetSessionStatus {
  session {
    arenaId
    spoofed
    originalUserId
    userId
    returnUrl
  }
}
    `;

/**
 * __useGetSessionStatusQuery__
 *
 * To run a query within a React component, call `useGetSessionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionStatusQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetSessionStatusQuery, GraphqlTypes.GetSessionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSessionStatusQuery, GraphqlTypes.GetSessionStatusQueryVariables>(GetSessionStatusDocument, options);
      }
export function useGetSessionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSessionStatusQuery, GraphqlTypes.GetSessionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSessionStatusQuery, GraphqlTypes.GetSessionStatusQueryVariables>(GetSessionStatusDocument, options);
        }
// @ts-ignore
export function useGetSessionStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSessionStatusQuery, GraphqlTypes.GetSessionStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSessionStatusQuery, GraphqlTypes.GetSessionStatusQueryVariables>;
export function useGetSessionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSessionStatusQuery, GraphqlTypes.GetSessionStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSessionStatusQuery | undefined, GraphqlTypes.GetSessionStatusQueryVariables>;
export function useGetSessionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSessionStatusQuery, GraphqlTypes.GetSessionStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSessionStatusQuery, GraphqlTypes.GetSessionStatusQueryVariables>(GetSessionStatusDocument, options);
        }
export type GetSessionStatusQueryHookResult = ReturnType<typeof useGetSessionStatusQuery>;
export type GetSessionStatusLazyQueryHookResult = ReturnType<typeof useGetSessionStatusLazyQuery>;
export type GetSessionStatusSuspenseQueryHookResult = ReturnType<typeof useGetSessionStatusSuspenseQuery>;
export type GetSessionStatusQueryResult = Apollo.QueryResult<GraphqlTypes.GetSessionStatusQuery, GraphqlTypes.GetSessionStatusQueryVariables>;
export const GetUnauthenticatedArenaDocument = gql`
    query GetUnauthenticatedArena($arenaDomain: String!) {
  unauthenticatedArena(arenaDomain: $arenaDomain) {
    id
    name
    domain
    contactEmail
    contactPhone
    websiteUrl
    logoUrl
    logoWideUrl
    headerLogoUrl
    headerLogoUrl2x
    signinButtonTextColor
    signinButtonBackgroundColor
    signInButtonTextColor
    signInButtonBackgroundColor
    signInPhotoUrl
    signInAccessMessage
    loginMessage
    secondLevelDomain
    faviconUrl16px
    faviconUrl32px
    hideCopyrightText
  }
}
    `;

/**
 * __useGetUnauthenticatedArenaQuery__
 *
 * To run a query within a React component, call `useGetUnauthenticatedArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnauthenticatedArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnauthenticatedArenaQuery({
 *   variables: {
 *      arenaDomain: // value for 'arenaDomain'
 *   },
 * });
 */
export function useGetUnauthenticatedArenaQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUnauthenticatedArenaQuery, GraphqlTypes.GetUnauthenticatedArenaQueryVariables> & ({ variables: GraphqlTypes.GetUnauthenticatedArenaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUnauthenticatedArenaQuery, GraphqlTypes.GetUnauthenticatedArenaQueryVariables>(GetUnauthenticatedArenaDocument, options);
      }
export function useGetUnauthenticatedArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUnauthenticatedArenaQuery, GraphqlTypes.GetUnauthenticatedArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUnauthenticatedArenaQuery, GraphqlTypes.GetUnauthenticatedArenaQueryVariables>(GetUnauthenticatedArenaDocument, options);
        }
// @ts-ignore
export function useGetUnauthenticatedArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnauthenticatedArenaQuery, GraphqlTypes.GetUnauthenticatedArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnauthenticatedArenaQuery, GraphqlTypes.GetUnauthenticatedArenaQueryVariables>;
export function useGetUnauthenticatedArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnauthenticatedArenaQuery, GraphqlTypes.GetUnauthenticatedArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnauthenticatedArenaQuery | undefined, GraphqlTypes.GetUnauthenticatedArenaQueryVariables>;
export function useGetUnauthenticatedArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnauthenticatedArenaQuery, GraphqlTypes.GetUnauthenticatedArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUnauthenticatedArenaQuery, GraphqlTypes.GetUnauthenticatedArenaQueryVariables>(GetUnauthenticatedArenaDocument, options);
        }
export type GetUnauthenticatedArenaQueryHookResult = ReturnType<typeof useGetUnauthenticatedArenaQuery>;
export type GetUnauthenticatedArenaLazyQueryHookResult = ReturnType<typeof useGetUnauthenticatedArenaLazyQuery>;
export type GetUnauthenticatedArenaSuspenseQueryHookResult = ReturnType<typeof useGetUnauthenticatedArenaSuspenseQuery>;
export type GetUnauthenticatedArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetUnauthenticatedArenaQuery, GraphqlTypes.GetUnauthenticatedArenaQueryVariables>;
export const GetAvailableTwoStepAuthMethodsDocument = gql`
    query GetAvailableTwoStepAuthMethods {
  currentGlobalUser {
    id
    globalActivated
    availableTwoStepAuthMethods
    requiresTwoFaUpgrade
  }
}
    `;

/**
 * __useGetAvailableTwoStepAuthMethodsQuery__
 *
 * To run a query within a React component, call `useGetAvailableTwoStepAuthMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableTwoStepAuthMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableTwoStepAuthMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableTwoStepAuthMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAvailableTwoStepAuthMethodsQuery, GraphqlTypes.GetAvailableTwoStepAuthMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAvailableTwoStepAuthMethodsQuery, GraphqlTypes.GetAvailableTwoStepAuthMethodsQueryVariables>(GetAvailableTwoStepAuthMethodsDocument, options);
      }
export function useGetAvailableTwoStepAuthMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAvailableTwoStepAuthMethodsQuery, GraphqlTypes.GetAvailableTwoStepAuthMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAvailableTwoStepAuthMethodsQuery, GraphqlTypes.GetAvailableTwoStepAuthMethodsQueryVariables>(GetAvailableTwoStepAuthMethodsDocument, options);
        }
// @ts-ignore
export function useGetAvailableTwoStepAuthMethodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAvailableTwoStepAuthMethodsQuery, GraphqlTypes.GetAvailableTwoStepAuthMethodsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAvailableTwoStepAuthMethodsQuery, GraphqlTypes.GetAvailableTwoStepAuthMethodsQueryVariables>;
export function useGetAvailableTwoStepAuthMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAvailableTwoStepAuthMethodsQuery, GraphqlTypes.GetAvailableTwoStepAuthMethodsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAvailableTwoStepAuthMethodsQuery | undefined, GraphqlTypes.GetAvailableTwoStepAuthMethodsQueryVariables>;
export function useGetAvailableTwoStepAuthMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAvailableTwoStepAuthMethodsQuery, GraphqlTypes.GetAvailableTwoStepAuthMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAvailableTwoStepAuthMethodsQuery, GraphqlTypes.GetAvailableTwoStepAuthMethodsQueryVariables>(GetAvailableTwoStepAuthMethodsDocument, options);
        }
export type GetAvailableTwoStepAuthMethodsQueryHookResult = ReturnType<typeof useGetAvailableTwoStepAuthMethodsQuery>;
export type GetAvailableTwoStepAuthMethodsLazyQueryHookResult = ReturnType<typeof useGetAvailableTwoStepAuthMethodsLazyQuery>;
export type GetAvailableTwoStepAuthMethodsSuspenseQueryHookResult = ReturnType<typeof useGetAvailableTwoStepAuthMethodsSuspenseQuery>;
export type GetAvailableTwoStepAuthMethodsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAvailableTwoStepAuthMethodsQuery, GraphqlTypes.GetAvailableTwoStepAuthMethodsQueryVariables>;
export const GetArenaTermsAndPpDetailsDocument = gql`
    query GetArenaTermsAndPPDetails($code: String!) {
  unifiedPortalActivationDetails(code: $code) {
    ...ArenaTermsAndPPDetailsFragment
  }
}
    ${ArenaTermsAndPpDetailsFragmentFragmentDoc}`;

/**
 * __useGetArenaTermsAndPpDetailsQuery__
 *
 * To run a query within a React component, call `useGetArenaTermsAndPpDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaTermsAndPpDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaTermsAndPpDetailsQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetArenaTermsAndPpDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetArenaTermsAndPpDetailsQuery, GraphqlTypes.GetArenaTermsAndPpDetailsQueryVariables> & ({ variables: GraphqlTypes.GetArenaTermsAndPpDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaTermsAndPpDetailsQuery, GraphqlTypes.GetArenaTermsAndPpDetailsQueryVariables>(GetArenaTermsAndPpDetailsDocument, options);
      }
export function useGetArenaTermsAndPpDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaTermsAndPpDetailsQuery, GraphqlTypes.GetArenaTermsAndPpDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaTermsAndPpDetailsQuery, GraphqlTypes.GetArenaTermsAndPpDetailsQueryVariables>(GetArenaTermsAndPpDetailsDocument, options);
        }
// @ts-ignore
export function useGetArenaTermsAndPpDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaTermsAndPpDetailsQuery, GraphqlTypes.GetArenaTermsAndPpDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaTermsAndPpDetailsQuery, GraphqlTypes.GetArenaTermsAndPpDetailsQueryVariables>;
export function useGetArenaTermsAndPpDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaTermsAndPpDetailsQuery, GraphqlTypes.GetArenaTermsAndPpDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaTermsAndPpDetailsQuery | undefined, GraphqlTypes.GetArenaTermsAndPpDetailsQueryVariables>;
export function useGetArenaTermsAndPpDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaTermsAndPpDetailsQuery, GraphqlTypes.GetArenaTermsAndPpDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaTermsAndPpDetailsQuery, GraphqlTypes.GetArenaTermsAndPpDetailsQueryVariables>(GetArenaTermsAndPpDetailsDocument, options);
        }
export type GetArenaTermsAndPpDetailsQueryHookResult = ReturnType<typeof useGetArenaTermsAndPpDetailsQuery>;
export type GetArenaTermsAndPpDetailsLazyQueryHookResult = ReturnType<typeof useGetArenaTermsAndPpDetailsLazyQuery>;
export type GetArenaTermsAndPpDetailsSuspenseQueryHookResult = ReturnType<typeof useGetArenaTermsAndPpDetailsSuspenseQuery>;
export type GetArenaTermsAndPpDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaTermsAndPpDetailsQuery, GraphqlTypes.GetArenaTermsAndPpDetailsQueryVariables>;
export const GetSubscriptionRedirectUrlDocument = gql`
    query GetSubscriptionRedirectUrl($arenaDomain: String!, $dataRoomKey: String!, $stagePath: String) {
  subscriptionRedirectUrl(
    arenaDomain: $arenaDomain
    dataRoomKey: $dataRoomKey
    stagePath: $stagePath
  ) {
    ...SubscriptionRedirectError
    ...SubscriptionRedirectUrl
  }
}
    ${SubscriptionRedirectErrorFragmentDoc}
${SubscriptionRedirectUrlFragmentDoc}`;

/**
 * __useGetSubscriptionRedirectUrlQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionRedirectUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionRedirectUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionRedirectUrlQuery({
 *   variables: {
 *      arenaDomain: // value for 'arenaDomain'
 *      dataRoomKey: // value for 'dataRoomKey'
 *      stagePath: // value for 'stagePath'
 *   },
 * });
 */
export function useGetSubscriptionRedirectUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSubscriptionRedirectUrlQuery, GraphqlTypes.GetSubscriptionRedirectUrlQueryVariables> & ({ variables: GraphqlTypes.GetSubscriptionRedirectUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSubscriptionRedirectUrlQuery, GraphqlTypes.GetSubscriptionRedirectUrlQueryVariables>(GetSubscriptionRedirectUrlDocument, options);
      }
export function useGetSubscriptionRedirectUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSubscriptionRedirectUrlQuery, GraphqlTypes.GetSubscriptionRedirectUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSubscriptionRedirectUrlQuery, GraphqlTypes.GetSubscriptionRedirectUrlQueryVariables>(GetSubscriptionRedirectUrlDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionRedirectUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionRedirectUrlQuery, GraphqlTypes.GetSubscriptionRedirectUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionRedirectUrlQuery, GraphqlTypes.GetSubscriptionRedirectUrlQueryVariables>;
export function useGetSubscriptionRedirectUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionRedirectUrlQuery, GraphqlTypes.GetSubscriptionRedirectUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionRedirectUrlQuery | undefined, GraphqlTypes.GetSubscriptionRedirectUrlQueryVariables>;
export function useGetSubscriptionRedirectUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionRedirectUrlQuery, GraphqlTypes.GetSubscriptionRedirectUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSubscriptionRedirectUrlQuery, GraphqlTypes.GetSubscriptionRedirectUrlQueryVariables>(GetSubscriptionRedirectUrlDocument, options);
        }
export type GetSubscriptionRedirectUrlQueryHookResult = ReturnType<typeof useGetSubscriptionRedirectUrlQuery>;
export type GetSubscriptionRedirectUrlLazyQueryHookResult = ReturnType<typeof useGetSubscriptionRedirectUrlLazyQuery>;
export type GetSubscriptionRedirectUrlSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionRedirectUrlSuspenseQuery>;
export type GetSubscriptionRedirectUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetSubscriptionRedirectUrlQuery, GraphqlTypes.GetSubscriptionRedirectUrlQueryVariables>;
export const DownloadTransactionsPortalDeprecatedDocument = gql`
    mutation DownloadTransactionsPortalDeprecated($positionIds: [Int]!, $includeEntityTotals: Boolean!, $isConsolidated: Boolean, $isXlsx: Boolean, $startDate: Date, $endDate: Date, $appliedFilters: [String]) {
  portalTransactionsOpsDeprecated {
    downloadTransactionsPortal(
      positionIds: $positionIds
      includeEntityTotals: $includeEntityTotals
      isConsolidated: $isConsolidated
      isXlsx: $isXlsx
      startDate: $startDate
      endDate: $endDate
      appliedFilters: $appliedFilters
    ) {
      job {
        id
      }
    }
  }
}
    `;
export type DownloadTransactionsPortalDeprecatedMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadTransactionsPortalDeprecatedMutation, GraphqlTypes.DownloadTransactionsPortalDeprecatedMutationVariables>;

/**
 * __useDownloadTransactionsPortalDeprecatedMutation__
 *
 * To run a mutation, you first call `useDownloadTransactionsPortalDeprecatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadTransactionsPortalDeprecatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadTransactionsPortalDeprecatedMutation, { data, loading, error }] = useDownloadTransactionsPortalDeprecatedMutation({
 *   variables: {
 *      positionIds: // value for 'positionIds'
 *      includeEntityTotals: // value for 'includeEntityTotals'
 *      isConsolidated: // value for 'isConsolidated'
 *      isXlsx: // value for 'isXlsx'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      appliedFilters: // value for 'appliedFilters'
 *   },
 * });
 */
export function useDownloadTransactionsPortalDeprecatedMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadTransactionsPortalDeprecatedMutation, GraphqlTypes.DownloadTransactionsPortalDeprecatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadTransactionsPortalDeprecatedMutation, GraphqlTypes.DownloadTransactionsPortalDeprecatedMutationVariables>(DownloadTransactionsPortalDeprecatedDocument, options);
      }
export type DownloadTransactionsPortalDeprecatedMutationHookResult = ReturnType<typeof useDownloadTransactionsPortalDeprecatedMutation>;
export type DownloadTransactionsPortalDeprecatedMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadTransactionsPortalDeprecatedMutation>;
export type DownloadTransactionsPortalDeprecatedMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadTransactionsPortalDeprecatedMutation, GraphqlTypes.DownloadTransactionsPortalDeprecatedMutationVariables>;
export const GetPortalAppContextDocument = gql`
    query GetPortalAppContext {
  currentGlobalUser {
    id
    globalActivated
    fullName
    emailAddress
    dateFormat
    timeFormat
    hasActiveSecurityTriggers
  }
  managerArenas {
    id
    name
    secondLevelDomain
    logoUrl
    logoBackgroundColor
    useBgColorForPortalIcons
    hasUnifiedPortalPreview
    supportEmail
    perfMetricsAsOfDate
    ownershipDisplayPrecision
    allowPortalInvestorReport
    showDisregardedEntityQuestionnaire
    paymentPermission {
      requirePositionPaymentPrefStaffApprovals
      requirePositionPaymentPrefInvestorApprovals
      requiredApprovalCount
      requireDifferentApprover
      requireNoteOnStaffPaymentInstructionChange
      arenaId
    }
    labelDisplaySettings {
      id
      fieldName
      singular
      plural
      variants {
        id
        variantName
        investmentEntities {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetPortalAppContextQuery__
 *
 * To run a query within a React component, call `useGetPortalAppContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalAppContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalAppContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPortalAppContextQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPortalAppContextQuery, GraphqlTypes.GetPortalAppContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPortalAppContextQuery, GraphqlTypes.GetPortalAppContextQueryVariables>(GetPortalAppContextDocument, options);
      }
export function useGetPortalAppContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPortalAppContextQuery, GraphqlTypes.GetPortalAppContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPortalAppContextQuery, GraphqlTypes.GetPortalAppContextQueryVariables>(GetPortalAppContextDocument, options);
        }
// @ts-ignore
export function useGetPortalAppContextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalAppContextQuery, GraphqlTypes.GetPortalAppContextQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalAppContextQuery, GraphqlTypes.GetPortalAppContextQueryVariables>;
export function useGetPortalAppContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalAppContextQuery, GraphqlTypes.GetPortalAppContextQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalAppContextQuery | undefined, GraphqlTypes.GetPortalAppContextQueryVariables>;
export function useGetPortalAppContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalAppContextQuery, GraphqlTypes.GetPortalAppContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPortalAppContextQuery, GraphqlTypes.GetPortalAppContextQueryVariables>(GetPortalAppContextDocument, options);
        }
export type GetPortalAppContextQueryHookResult = ReturnType<typeof useGetPortalAppContextQuery>;
export type GetPortalAppContextLazyQueryHookResult = ReturnType<typeof useGetPortalAppContextLazyQuery>;
export type GetPortalAppContextSuspenseQueryHookResult = ReturnType<typeof useGetPortalAppContextSuspenseQuery>;
export type GetPortalAppContextQueryResult = Apollo.QueryResult<GraphqlTypes.GetPortalAppContextQuery, GraphqlTypes.GetPortalAppContextQueryVariables>;
export const GetArenaContentDocument = gql`
    query GetArenaContent($arenaDomain: String!) {
  unauthenticatedArena(arenaDomain: $arenaDomain) {
    id
    name
    headerLogoUrl
    headerLogoUrl2x
    contactEmail
    contactPhone
    faviconUrl16px
    faviconUrl32px
  }
}
    `;

/**
 * __useGetArenaContentQuery__
 *
 * To run a query within a React component, call `useGetArenaContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaContentQuery({
 *   variables: {
 *      arenaDomain: // value for 'arenaDomain'
 *   },
 * });
 */
export function useGetArenaContentQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetArenaContentQuery, GraphqlTypes.GetArenaContentQueryVariables> & ({ variables: GraphqlTypes.GetArenaContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaContentQuery, GraphqlTypes.GetArenaContentQueryVariables>(GetArenaContentDocument, options);
      }
export function useGetArenaContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaContentQuery, GraphqlTypes.GetArenaContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaContentQuery, GraphqlTypes.GetArenaContentQueryVariables>(GetArenaContentDocument, options);
        }
// @ts-ignore
export function useGetArenaContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaContentQuery, GraphqlTypes.GetArenaContentQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaContentQuery, GraphqlTypes.GetArenaContentQueryVariables>;
export function useGetArenaContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaContentQuery, GraphqlTypes.GetArenaContentQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaContentQuery | undefined, GraphqlTypes.GetArenaContentQueryVariables>;
export function useGetArenaContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaContentQuery, GraphqlTypes.GetArenaContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaContentQuery, GraphqlTypes.GetArenaContentQueryVariables>(GetArenaContentDocument, options);
        }
export type GetArenaContentQueryHookResult = ReturnType<typeof useGetArenaContentQuery>;
export type GetArenaContentLazyQueryHookResult = ReturnType<typeof useGetArenaContentLazyQuery>;
export type GetArenaContentSuspenseQueryHookResult = ReturnType<typeof useGetArenaContentSuspenseQuery>;
export type GetArenaContentQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaContentQuery, GraphqlTypes.GetArenaContentQueryVariables>;
export const GetPortalFeatureFlagsDocument = gql`
    query GetPortalFeatureFlags {
  devFeatures {
    unifiedPortal
    taxDocDeliveryPreferences
    lpZendeskFeatureFlag
    disregardedEntityQuestionnaire
    hasKycInUnifiedPortal
    dataRoomRestrictDownloads
    lpRequestManagementM1
    lpRequestManagementM2
    investorPortalUserProfile
    deprecateLegacyCustomSections
    enableCoBrowseFeature
    subscriptionSubquestions
    enableLpcmCommPrefsSubscription
  }
}
    `;

/**
 * __useGetPortalFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetPortalFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPortalFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPortalFeatureFlagsQuery, GraphqlTypes.GetPortalFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPortalFeatureFlagsQuery, GraphqlTypes.GetPortalFeatureFlagsQueryVariables>(GetPortalFeatureFlagsDocument, options);
      }
export function useGetPortalFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPortalFeatureFlagsQuery, GraphqlTypes.GetPortalFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPortalFeatureFlagsQuery, GraphqlTypes.GetPortalFeatureFlagsQueryVariables>(GetPortalFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useGetPortalFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalFeatureFlagsQuery, GraphqlTypes.GetPortalFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalFeatureFlagsQuery, GraphqlTypes.GetPortalFeatureFlagsQueryVariables>;
export function useGetPortalFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalFeatureFlagsQuery, GraphqlTypes.GetPortalFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalFeatureFlagsQuery | undefined, GraphqlTypes.GetPortalFeatureFlagsQueryVariables>;
export function useGetPortalFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalFeatureFlagsQuery, GraphqlTypes.GetPortalFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPortalFeatureFlagsQuery, GraphqlTypes.GetPortalFeatureFlagsQueryVariables>(GetPortalFeatureFlagsDocument, options);
        }
export type GetPortalFeatureFlagsQueryHookResult = ReturnType<typeof useGetPortalFeatureFlagsQuery>;
export type GetPortalFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetPortalFeatureFlagsLazyQuery>;
export type GetPortalFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useGetPortalFeatureFlagsSuspenseQuery>;
export type GetPortalFeatureFlagsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPortalFeatureFlagsQuery, GraphqlTypes.GetPortalFeatureFlagsQueryVariables>;
export const GetArenaFeatureFlagsDocument = gql`
    query GetArenaFeatureFlags($arenaDomain: String!) {
  arenaFeatures(arenaDomain: $arenaDomain) {
    hasDynamicSubscriptions
    hasDynamicSubscriptionsCustomSections
    hasLpcmAutomaticUpdateAndRemoval
    showOwnershipTabWithNewLogic
    hasInsightsAi
    useDocusignOauthFor2fa
  }
}
    `;

/**
 * __useGetArenaFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetArenaFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaFeatureFlagsQuery({
 *   variables: {
 *      arenaDomain: // value for 'arenaDomain'
 *   },
 * });
 */
export function useGetArenaFeatureFlagsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetArenaFeatureFlagsQuery, GraphqlTypes.GetArenaFeatureFlagsQueryVariables> & ({ variables: GraphqlTypes.GetArenaFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaFeatureFlagsQuery, GraphqlTypes.GetArenaFeatureFlagsQueryVariables>(GetArenaFeatureFlagsDocument, options);
      }
export function useGetArenaFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaFeatureFlagsQuery, GraphqlTypes.GetArenaFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaFeatureFlagsQuery, GraphqlTypes.GetArenaFeatureFlagsQueryVariables>(GetArenaFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useGetArenaFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaFeatureFlagsQuery, GraphqlTypes.GetArenaFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaFeatureFlagsQuery, GraphqlTypes.GetArenaFeatureFlagsQueryVariables>;
export function useGetArenaFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaFeatureFlagsQuery, GraphqlTypes.GetArenaFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaFeatureFlagsQuery | undefined, GraphqlTypes.GetArenaFeatureFlagsQueryVariables>;
export function useGetArenaFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaFeatureFlagsQuery, GraphqlTypes.GetArenaFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaFeatureFlagsQuery, GraphqlTypes.GetArenaFeatureFlagsQueryVariables>(GetArenaFeatureFlagsDocument, options);
        }
export type GetArenaFeatureFlagsQueryHookResult = ReturnType<typeof useGetArenaFeatureFlagsQuery>;
export type GetArenaFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetArenaFeatureFlagsLazyQuery>;
export type GetArenaFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useGetArenaFeatureFlagsSuspenseQuery>;
export type GetArenaFeatureFlagsQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaFeatureFlagsQuery, GraphqlTypes.GetArenaFeatureFlagsQueryVariables>;
export const GetUpdateEmailDataDocument = gql`
    query GetUpdateEmailData($code: String!) {
  updateEmailData(code: $code) {
    globalUser {
      id
      emailAddress
      linkedArenas {
        id
        name
        domain
      }
    }
    newEmailAddress
  }
}
    `;

/**
 * __useGetUpdateEmailDataQuery__
 *
 * To run a query within a React component, call `useGetUpdateEmailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdateEmailDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdateEmailDataQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetUpdateEmailDataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUpdateEmailDataQuery, GraphqlTypes.GetUpdateEmailDataQueryVariables> & ({ variables: GraphqlTypes.GetUpdateEmailDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUpdateEmailDataQuery, GraphqlTypes.GetUpdateEmailDataQueryVariables>(GetUpdateEmailDataDocument, options);
      }
export function useGetUpdateEmailDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUpdateEmailDataQuery, GraphqlTypes.GetUpdateEmailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUpdateEmailDataQuery, GraphqlTypes.GetUpdateEmailDataQueryVariables>(GetUpdateEmailDataDocument, options);
        }
// @ts-ignore
export function useGetUpdateEmailDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUpdateEmailDataQuery, GraphqlTypes.GetUpdateEmailDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUpdateEmailDataQuery, GraphqlTypes.GetUpdateEmailDataQueryVariables>;
export function useGetUpdateEmailDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUpdateEmailDataQuery, GraphqlTypes.GetUpdateEmailDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUpdateEmailDataQuery | undefined, GraphqlTypes.GetUpdateEmailDataQueryVariables>;
export function useGetUpdateEmailDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUpdateEmailDataQuery, GraphqlTypes.GetUpdateEmailDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUpdateEmailDataQuery, GraphqlTypes.GetUpdateEmailDataQueryVariables>(GetUpdateEmailDataDocument, options);
        }
export type GetUpdateEmailDataQueryHookResult = ReturnType<typeof useGetUpdateEmailDataQuery>;
export type GetUpdateEmailDataLazyQueryHookResult = ReturnType<typeof useGetUpdateEmailDataLazyQuery>;
export type GetUpdateEmailDataSuspenseQueryHookResult = ReturnType<typeof useGetUpdateEmailDataSuspenseQuery>;
export type GetUpdateEmailDataQueryResult = Apollo.QueryResult<GraphqlTypes.GetUpdateEmailDataQuery, GraphqlTypes.GetUpdateEmailDataQueryVariables>;
export const GetGlobalUserSettingsDocument = gql`
    query GetGlobalUserSettings {
  currentGlobalUser {
    id
    title
    emailAddress
    firstName
    middleName
    lastName
    salutationName
    jobTitle
    companyName
    twoFaPhoneNumber
    phones {
      id
      phoneType
      phoneNumber
    }
    addresses {
      id
      addressType
      street
      street2
      street3
      city
      state {
        objectName
        objectId
      }
      region
      postalCode
      country {
        objectName
        objectId
      }
    }
    defaultCurrency
    currentTwoFaMethods
    dateFormat
    timeFormat
    linkedArenas {
      id
      name
      domain
    }
    notificationCampaignFrequencies {
      id
      notificationCampaign {
        id
        name
      }
      frequency
    }
    hasLpAccreditationAndPreferencesRequiredArenas
    currencies {
      id
      code
      fullName
      symbol
      flagUnicode
    }
  }
}
    `;

/**
 * __useGetGlobalUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetGlobalUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalUserSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGlobalUserSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetGlobalUserSettingsQuery, GraphqlTypes.GetGlobalUserSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGlobalUserSettingsQuery, GraphqlTypes.GetGlobalUserSettingsQueryVariables>(GetGlobalUserSettingsDocument, options);
      }
export function useGetGlobalUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGlobalUserSettingsQuery, GraphqlTypes.GetGlobalUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGlobalUserSettingsQuery, GraphqlTypes.GetGlobalUserSettingsQueryVariables>(GetGlobalUserSettingsDocument, options);
        }
// @ts-ignore
export function useGetGlobalUserSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGlobalUserSettingsQuery, GraphqlTypes.GetGlobalUserSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGlobalUserSettingsQuery, GraphqlTypes.GetGlobalUserSettingsQueryVariables>;
export function useGetGlobalUserSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGlobalUserSettingsQuery, GraphqlTypes.GetGlobalUserSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGlobalUserSettingsQuery | undefined, GraphqlTypes.GetGlobalUserSettingsQueryVariables>;
export function useGetGlobalUserSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGlobalUserSettingsQuery, GraphqlTypes.GetGlobalUserSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGlobalUserSettingsQuery, GraphqlTypes.GetGlobalUserSettingsQueryVariables>(GetGlobalUserSettingsDocument, options);
        }
export type GetGlobalUserSettingsQueryHookResult = ReturnType<typeof useGetGlobalUserSettingsQuery>;
export type GetGlobalUserSettingsLazyQueryHookResult = ReturnType<typeof useGetGlobalUserSettingsLazyQuery>;
export type GetGlobalUserSettingsSuspenseQueryHookResult = ReturnType<typeof useGetGlobalUserSettingsSuspenseQuery>;
export type GetGlobalUserSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetGlobalUserSettingsQuery, GraphqlTypes.GetGlobalUserSettingsQueryVariables>;
export const GetExistingPaymentPrefsDocument = gql`
    query GetExistingPaymentPrefs {
  dedupedPaymentPrefs {
    id
    paymentMethod
    bankInfoRedacted
    checkAddrCity
    checkAddrCountry {
      id
      name
    }
    checkAddrPostalCode
    checkAddrRegion
    checkAddrState {
      id
      name
    }
    checkAddrStreet
    checkAddrStreet2
    checkAddrStreet3
  }
}
    `;

/**
 * __useGetExistingPaymentPrefsQuery__
 *
 * To run a query within a React component, call `useGetExistingPaymentPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingPaymentPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingPaymentPrefsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExistingPaymentPrefsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetExistingPaymentPrefsQuery, GraphqlTypes.GetExistingPaymentPrefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetExistingPaymentPrefsQuery, GraphqlTypes.GetExistingPaymentPrefsQueryVariables>(GetExistingPaymentPrefsDocument, options);
      }
export function useGetExistingPaymentPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetExistingPaymentPrefsQuery, GraphqlTypes.GetExistingPaymentPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetExistingPaymentPrefsQuery, GraphqlTypes.GetExistingPaymentPrefsQueryVariables>(GetExistingPaymentPrefsDocument, options);
        }
// @ts-ignore
export function useGetExistingPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExistingPaymentPrefsQuery, GraphqlTypes.GetExistingPaymentPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExistingPaymentPrefsQuery, GraphqlTypes.GetExistingPaymentPrefsQueryVariables>;
export function useGetExistingPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExistingPaymentPrefsQuery, GraphqlTypes.GetExistingPaymentPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExistingPaymentPrefsQuery | undefined, GraphqlTypes.GetExistingPaymentPrefsQueryVariables>;
export function useGetExistingPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExistingPaymentPrefsQuery, GraphqlTypes.GetExistingPaymentPrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetExistingPaymentPrefsQuery, GraphqlTypes.GetExistingPaymentPrefsQueryVariables>(GetExistingPaymentPrefsDocument, options);
        }
export type GetExistingPaymentPrefsQueryHookResult = ReturnType<typeof useGetExistingPaymentPrefsQuery>;
export type GetExistingPaymentPrefsLazyQueryHookResult = ReturnType<typeof useGetExistingPaymentPrefsLazyQuery>;
export type GetExistingPaymentPrefsSuspenseQueryHookResult = ReturnType<typeof useGetExistingPaymentPrefsSuspenseQuery>;
export type GetExistingPaymentPrefsQueryResult = Apollo.QueryResult<GraphqlTypes.GetExistingPaymentPrefsQuery, GraphqlTypes.GetExistingPaymentPrefsQueryVariables>;
export const GetAccountsCountDocument = gql`
    query GetAccountsCount($filters: PortalAccountFilters) {
  unifiedPortalAccounts(filters: $filters) {
    count
  }
}
    `;

/**
 * __useGetAccountsCountQuery__
 *
 * To run a query within a React component, call `useGetAccountsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAccountsCountQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAccountsCountQuery, GraphqlTypes.GetAccountsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountsCountQuery, GraphqlTypes.GetAccountsCountQueryVariables>(GetAccountsCountDocument, options);
      }
export function useGetAccountsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountsCountQuery, GraphqlTypes.GetAccountsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountsCountQuery, GraphqlTypes.GetAccountsCountQueryVariables>(GetAccountsCountDocument, options);
        }
// @ts-ignore
export function useGetAccountsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountsCountQuery, GraphqlTypes.GetAccountsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountsCountQuery, GraphqlTypes.GetAccountsCountQueryVariables>;
export function useGetAccountsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountsCountQuery, GraphqlTypes.GetAccountsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountsCountQuery | undefined, GraphqlTypes.GetAccountsCountQueryVariables>;
export function useGetAccountsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountsCountQuery, GraphqlTypes.GetAccountsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountsCountQuery, GraphqlTypes.GetAccountsCountQueryVariables>(GetAccountsCountDocument, options);
        }
export type GetAccountsCountQueryHookResult = ReturnType<typeof useGetAccountsCountQuery>;
export type GetAccountsCountLazyQueryHookResult = ReturnType<typeof useGetAccountsCountLazyQuery>;
export type GetAccountsCountSuspenseQueryHookResult = ReturnType<typeof useGetAccountsCountSuspenseQuery>;
export type GetAccountsCountQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountsCountQuery, GraphqlTypes.GetAccountsCountQueryVariables>;
export const GetAccountDetailsDocument = gql`
    query GetAccountDetails($filters: PortalAccountFilters) {
  unifiedPortalAccounts(filters: $filters) {
    edges {
      node {
        id
        name
        arenaId
        arena {
          name
        }
        canLpcmManageContacts
        canEditAccountDetails
        canAccessLpcm
        mailingAddress {
          street
          street2
          street3
          city
          region
          addressType
          country {
            objectId
            objectName
          }
          state {
            objectId
            objectName
          }
          postalCode
        }
        paymentPrefs {
          id
          paymentMethod
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountDetailsQuery__
 *
 * To run a query within a React component, call `useGetAccountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountDetailsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAccountDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAccountDetailsQuery, GraphqlTypes.GetAccountDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountDetailsQuery, GraphqlTypes.GetAccountDetailsQueryVariables>(GetAccountDetailsDocument, options);
      }
export function useGetAccountDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountDetailsQuery, GraphqlTypes.GetAccountDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountDetailsQuery, GraphqlTypes.GetAccountDetailsQueryVariables>(GetAccountDetailsDocument, options);
        }
// @ts-ignore
export function useGetAccountDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountDetailsQuery, GraphqlTypes.GetAccountDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountDetailsQuery, GraphqlTypes.GetAccountDetailsQueryVariables>;
export function useGetAccountDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountDetailsQuery, GraphqlTypes.GetAccountDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountDetailsQuery | undefined, GraphqlTypes.GetAccountDetailsQueryVariables>;
export function useGetAccountDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountDetailsQuery, GraphqlTypes.GetAccountDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountDetailsQuery, GraphqlTypes.GetAccountDetailsQueryVariables>(GetAccountDetailsDocument, options);
        }
export type GetAccountDetailsQueryHookResult = ReturnType<typeof useGetAccountDetailsQuery>;
export type GetAccountDetailsLazyQueryHookResult = ReturnType<typeof useGetAccountDetailsLazyQuery>;
export type GetAccountDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAccountDetailsSuspenseQuery>;
export type GetAccountDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountDetailsQuery, GraphqlTypes.GetAccountDetailsQueryVariables>;
export const GetAccountDetailsForAllEnabledDocument = gql`
    query GetAccountDetailsForAllEnabled($filters: PortalAccountFilters) {
  unifiedPortalAccounts(filters: $filters) {
    edges {
      node {
        id
        name
        arenaId
        canEditAccountDetails
        canLpcmManageContacts
      }
    }
  }
}
    `;

/**
 * __useGetAccountDetailsForAllEnabledQuery__
 *
 * To run a query within a React component, call `useGetAccountDetailsForAllEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountDetailsForAllEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountDetailsForAllEnabledQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAccountDetailsForAllEnabledQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAccountDetailsForAllEnabledQuery, GraphqlTypes.GetAccountDetailsForAllEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountDetailsForAllEnabledQuery, GraphqlTypes.GetAccountDetailsForAllEnabledQueryVariables>(GetAccountDetailsForAllEnabledDocument, options);
      }
export function useGetAccountDetailsForAllEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountDetailsForAllEnabledQuery, GraphqlTypes.GetAccountDetailsForAllEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountDetailsForAllEnabledQuery, GraphqlTypes.GetAccountDetailsForAllEnabledQueryVariables>(GetAccountDetailsForAllEnabledDocument, options);
        }
// @ts-ignore
export function useGetAccountDetailsForAllEnabledSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountDetailsForAllEnabledQuery, GraphqlTypes.GetAccountDetailsForAllEnabledQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountDetailsForAllEnabledQuery, GraphqlTypes.GetAccountDetailsForAllEnabledQueryVariables>;
export function useGetAccountDetailsForAllEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountDetailsForAllEnabledQuery, GraphqlTypes.GetAccountDetailsForAllEnabledQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountDetailsForAllEnabledQuery | undefined, GraphqlTypes.GetAccountDetailsForAllEnabledQueryVariables>;
export function useGetAccountDetailsForAllEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountDetailsForAllEnabledQuery, GraphqlTypes.GetAccountDetailsForAllEnabledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountDetailsForAllEnabledQuery, GraphqlTypes.GetAccountDetailsForAllEnabledQueryVariables>(GetAccountDetailsForAllEnabledDocument, options);
        }
export type GetAccountDetailsForAllEnabledQueryHookResult = ReturnType<typeof useGetAccountDetailsForAllEnabledQuery>;
export type GetAccountDetailsForAllEnabledLazyQueryHookResult = ReturnType<typeof useGetAccountDetailsForAllEnabledLazyQuery>;
export type GetAccountDetailsForAllEnabledSuspenseQueryHookResult = ReturnType<typeof useGetAccountDetailsForAllEnabledSuspenseQuery>;
export type GetAccountDetailsForAllEnabledQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountDetailsForAllEnabledQuery, GraphqlTypes.GetAccountDetailsForAllEnabledQueryVariables>;
export const GetAccountIdsDocument = gql`
    query GetAccountIds($filters: PortalAccountFilters) {
  unifiedPortalAccounts(filters: $filters) {
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useGetAccountIdsQuery__
 *
 * To run a query within a React component, call `useGetAccountIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAccountIdsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAccountIdsQuery, GraphqlTypes.GetAccountIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountIdsQuery, GraphqlTypes.GetAccountIdsQueryVariables>(GetAccountIdsDocument, options);
      }
export function useGetAccountIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountIdsQuery, GraphqlTypes.GetAccountIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountIdsQuery, GraphqlTypes.GetAccountIdsQueryVariables>(GetAccountIdsDocument, options);
        }
// @ts-ignore
export function useGetAccountIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountIdsQuery, GraphqlTypes.GetAccountIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountIdsQuery, GraphqlTypes.GetAccountIdsQueryVariables>;
export function useGetAccountIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountIdsQuery, GraphqlTypes.GetAccountIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountIdsQuery | undefined, GraphqlTypes.GetAccountIdsQueryVariables>;
export function useGetAccountIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountIdsQuery, GraphqlTypes.GetAccountIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountIdsQuery, GraphqlTypes.GetAccountIdsQueryVariables>(GetAccountIdsDocument, options);
        }
export type GetAccountIdsQueryHookResult = ReturnType<typeof useGetAccountIdsQuery>;
export type GetAccountIdsLazyQueryHookResult = ReturnType<typeof useGetAccountIdsLazyQuery>;
export type GetAccountIdsSuspenseQueryHookResult = ReturnType<typeof useGetAccountIdsSuspenseQuery>;
export type GetAccountIdsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountIdsQuery, GraphqlTypes.GetAccountIdsQueryVariables>;
export const GetGlobalUserDefaultCurrencyDocument = gql`
    query GetGlobalUserDefaultCurrency {
  currentGlobalUser {
    id
    defaultCurrency
  }
}
    `;

/**
 * __useGetGlobalUserDefaultCurrencyQuery__
 *
 * To run a query within a React component, call `useGetGlobalUserDefaultCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalUserDefaultCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalUserDefaultCurrencyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGlobalUserDefaultCurrencyQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetGlobalUserDefaultCurrencyQuery, GraphqlTypes.GetGlobalUserDefaultCurrencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGlobalUserDefaultCurrencyQuery, GraphqlTypes.GetGlobalUserDefaultCurrencyQueryVariables>(GetGlobalUserDefaultCurrencyDocument, options);
      }
export function useGetGlobalUserDefaultCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGlobalUserDefaultCurrencyQuery, GraphqlTypes.GetGlobalUserDefaultCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGlobalUserDefaultCurrencyQuery, GraphqlTypes.GetGlobalUserDefaultCurrencyQueryVariables>(GetGlobalUserDefaultCurrencyDocument, options);
        }
// @ts-ignore
export function useGetGlobalUserDefaultCurrencySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGlobalUserDefaultCurrencyQuery, GraphqlTypes.GetGlobalUserDefaultCurrencyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGlobalUserDefaultCurrencyQuery, GraphqlTypes.GetGlobalUserDefaultCurrencyQueryVariables>;
export function useGetGlobalUserDefaultCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGlobalUserDefaultCurrencyQuery, GraphqlTypes.GetGlobalUserDefaultCurrencyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGlobalUserDefaultCurrencyQuery | undefined, GraphqlTypes.GetGlobalUserDefaultCurrencyQueryVariables>;
export function useGetGlobalUserDefaultCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGlobalUserDefaultCurrencyQuery, GraphqlTypes.GetGlobalUserDefaultCurrencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGlobalUserDefaultCurrencyQuery, GraphqlTypes.GetGlobalUserDefaultCurrencyQueryVariables>(GetGlobalUserDefaultCurrencyDocument, options);
        }
export type GetGlobalUserDefaultCurrencyQueryHookResult = ReturnType<typeof useGetGlobalUserDefaultCurrencyQuery>;
export type GetGlobalUserDefaultCurrencyLazyQueryHookResult = ReturnType<typeof useGetGlobalUserDefaultCurrencyLazyQuery>;
export type GetGlobalUserDefaultCurrencySuspenseQueryHookResult = ReturnType<typeof useGetGlobalUserDefaultCurrencySuspenseQuery>;
export type GetGlobalUserDefaultCurrencyQueryResult = Apollo.QueryResult<GraphqlTypes.GetGlobalUserDefaultCurrencyQuery, GraphqlTypes.GetGlobalUserDefaultCurrencyQueryVariables>;
export const UploadFileDocument = gql`
    mutation UploadFile($fileContents: String!, $fileName: String!, $managerCode: String!, $emailAddress: String!, $fullName: String!, $tosAcceptTime: DateTime!) {
  quarterlyDataUploadOps {
    uploadFile(
      fileContents: $fileContents
      fileName: $fileName
      managerCode: $managerCode
      emailAddress: $emailAddress
      fullName: $fullName
      tosAcceptTime: $tosAcceptTime
    ) {
      success
    }
  }
}
    `;
export type UploadFileMutationFn = Apollo.MutationFunction<GraphqlTypes.UploadFileMutation, GraphqlTypes.UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      fileContents: // value for 'fileContents'
 *      fileName: // value for 'fileName'
 *      managerCode: // value for 'managerCode'
 *      emailAddress: // value for 'emailAddress'
 *      fullName: // value for 'fullName'
 *      tosAcceptTime: // value for 'tosAcceptTime'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UploadFileMutation, GraphqlTypes.UploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UploadFileMutation, GraphqlTypes.UploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<GraphqlTypes.UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UploadFileMutation, GraphqlTypes.UploadFileMutationVariables>;
export const GetManagerInfoDocument = gql`
    query GetManagerInfo($code: String) {
  managerInfo(code: $code) {
    managerName
    contactEmail
    hasAcceptedTos
  }
}
    `;

/**
 * __useGetManagerInfoQuery__
 *
 * To run a query within a React component, call `useGetManagerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerInfoQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetManagerInfoQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetManagerInfoQuery, GraphqlTypes.GetManagerInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetManagerInfoQuery, GraphqlTypes.GetManagerInfoQueryVariables>(GetManagerInfoDocument, options);
      }
export function useGetManagerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetManagerInfoQuery, GraphqlTypes.GetManagerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetManagerInfoQuery, GraphqlTypes.GetManagerInfoQueryVariables>(GetManagerInfoDocument, options);
        }
// @ts-ignore
export function useGetManagerInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerInfoQuery, GraphqlTypes.GetManagerInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManagerInfoQuery, GraphqlTypes.GetManagerInfoQueryVariables>;
export function useGetManagerInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerInfoQuery, GraphqlTypes.GetManagerInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManagerInfoQuery | undefined, GraphqlTypes.GetManagerInfoQueryVariables>;
export function useGetManagerInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManagerInfoQuery, GraphqlTypes.GetManagerInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetManagerInfoQuery, GraphqlTypes.GetManagerInfoQueryVariables>(GetManagerInfoDocument, options);
        }
export type GetManagerInfoQueryHookResult = ReturnType<typeof useGetManagerInfoQuery>;
export type GetManagerInfoLazyQueryHookResult = ReturnType<typeof useGetManagerInfoLazyQuery>;
export type GetManagerInfoSuspenseQueryHookResult = ReturnType<typeof useGetManagerInfoSuspenseQuery>;
export type GetManagerInfoQueryResult = Apollo.QueryResult<GraphqlTypes.GetManagerInfoQuery, GraphqlTypes.GetManagerInfoQueryVariables>;
export const GeneratePrivateEdgeTemplateDocument = gql`
    mutation GeneratePrivateEdgeTemplate($positionId: String!, $period: Period!) {
  generatePrivateEdgeTemplateOps {
    generatePrivateEdgeTemplate(positionId: $positionId, period: $period) {
      job {
        id
      }
    }
  }
}
    `;
export type GeneratePrivateEdgeTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.GeneratePrivateEdgeTemplateMutation, GraphqlTypes.GeneratePrivateEdgeTemplateMutationVariables>;

/**
 * __useGeneratePrivateEdgeTemplateMutation__
 *
 * To run a mutation, you first call `useGeneratePrivateEdgeTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePrivateEdgeTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePrivateEdgeTemplateMutation, { data, loading, error }] = useGeneratePrivateEdgeTemplateMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGeneratePrivateEdgeTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GeneratePrivateEdgeTemplateMutation, GraphqlTypes.GeneratePrivateEdgeTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GeneratePrivateEdgeTemplateMutation, GraphqlTypes.GeneratePrivateEdgeTemplateMutationVariables>(GeneratePrivateEdgeTemplateDocument, options);
      }
export type GeneratePrivateEdgeTemplateMutationHookResult = ReturnType<typeof useGeneratePrivateEdgeTemplateMutation>;
export type GeneratePrivateEdgeTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.GeneratePrivateEdgeTemplateMutation>;
export type GeneratePrivateEdgeTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GeneratePrivateEdgeTemplateMutation, GraphqlTypes.GeneratePrivateEdgeTemplateMutationVariables>;
export const SaveActivityGridViewDocument = gql`
    mutation SaveActivityGridView($saveGridViewInput: SaveGridViewInput!) {
  saveGridView(saveGridViewInput: $saveGridViewInput) {
    __typename
    ... on MutationErrorResponse {
      message
      errorCode
    }
    ... on GridViewObjectType {
      columnOrder {
        orderedColIds
      }
      columnVisibility {
        hiddenColIds
      }
      columnSizing {
        colId
        flex
        width
      }
      columnPinning {
        leftColIds
        rightColIds
      }
    }
  }
}
    `;
export type SaveActivityGridViewMutationFn = Apollo.MutationFunction<GraphqlTypes.SaveActivityGridViewMutation, GraphqlTypes.SaveActivityGridViewMutationVariables>;

/**
 * __useSaveActivityGridViewMutation__
 *
 * To run a mutation, you first call `useSaveActivityGridViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveActivityGridViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveActivityGridViewMutation, { data, loading, error }] = useSaveActivityGridViewMutation({
 *   variables: {
 *      saveGridViewInput: // value for 'saveGridViewInput'
 *   },
 * });
 */
export function useSaveActivityGridViewMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SaveActivityGridViewMutation, GraphqlTypes.SaveActivityGridViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SaveActivityGridViewMutation, GraphqlTypes.SaveActivityGridViewMutationVariables>(SaveActivityGridViewDocument, options);
      }
export type SaveActivityGridViewMutationHookResult = ReturnType<typeof useSaveActivityGridViewMutation>;
export type SaveActivityGridViewMutationResult = Apollo.MutationResult<GraphqlTypes.SaveActivityGridViewMutation>;
export type SaveActivityGridViewMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SaveActivityGridViewMutation, GraphqlTypes.SaveActivityGridViewMutationVariables>;
export const GetActivityGridViewDocument = gql`
    query GetActivityGridView {
  userGridView(tableType: ActivityFeed) {
    columnOrder {
      orderedColIds
    }
    columnVisibility {
      hiddenColIds
    }
    columnSizing {
      colId
      flex
      width
    }
    columnPinning {
      leftColIds
      rightColIds
    }
    columnSort {
      colId
      isAscending
    }
    setFilters {
      field
      selected
      quantifier
    }
    numberFilters {
      field
      filter
      filterTo
      numberFilterType
    }
    locationFilters {
      field
      coordinates {
        latitude
        longitude
        radius
      }
      stateName
      countryName
    }
    extensionFieldFilters {
      textFilters {
        extensionFieldId
        text
        textFilterType
      }
      intFilters {
        extensionFieldId
        numberFilterType
        filter
        filterTo
      }
      floatFilters {
        extensionFieldId
        numberFilterType
        filter
        filterTo
      }
      dateFilters {
        extensionFieldId
        dateFilterType
        filter
        filterTo
      }
    }
  }
}
    `;

/**
 * __useGetActivityGridViewQuery__
 *
 * To run a query within a React component, call `useGetActivityGridViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityGridViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityGridViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActivityGridViewQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetActivityGridViewQuery, GraphqlTypes.GetActivityGridViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActivityGridViewQuery, GraphqlTypes.GetActivityGridViewQueryVariables>(GetActivityGridViewDocument, options);
      }
export function useGetActivityGridViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActivityGridViewQuery, GraphqlTypes.GetActivityGridViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActivityGridViewQuery, GraphqlTypes.GetActivityGridViewQueryVariables>(GetActivityGridViewDocument, options);
        }
// @ts-ignore
export function useGetActivityGridViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityGridViewQuery, GraphqlTypes.GetActivityGridViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityGridViewQuery, GraphqlTypes.GetActivityGridViewQueryVariables>;
export function useGetActivityGridViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityGridViewQuery, GraphqlTypes.GetActivityGridViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityGridViewQuery | undefined, GraphqlTypes.GetActivityGridViewQueryVariables>;
export function useGetActivityGridViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityGridViewQuery, GraphqlTypes.GetActivityGridViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActivityGridViewQuery, GraphqlTypes.GetActivityGridViewQueryVariables>(GetActivityGridViewDocument, options);
        }
export type GetActivityGridViewQueryHookResult = ReturnType<typeof useGetActivityGridViewQuery>;
export type GetActivityGridViewLazyQueryHookResult = ReturnType<typeof useGetActivityGridViewLazyQuery>;
export type GetActivityGridViewSuspenseQueryHookResult = ReturnType<typeof useGetActivityGridViewSuspenseQuery>;
export type GetActivityGridViewQueryResult = Apollo.QueryResult<GraphqlTypes.GetActivityGridViewQuery, GraphqlTypes.GetActivityGridViewQueryVariables>;
export const DeleteStoredEmailDocument = gql`
    mutation DeleteStoredEmail($objectInput: DeleteStoredEmailInput!) {
  storedEmailOps {
    deleteStoredEmail(objectInput: $objectInput) {
      storedEmail {
        id
      }
    }
  }
}
    `;
export type DeleteStoredEmailMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteStoredEmailMutation, GraphqlTypes.DeleteStoredEmailMutationVariables>;

/**
 * __useDeleteStoredEmailMutation__
 *
 * To run a mutation, you first call `useDeleteStoredEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStoredEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStoredEmailMutation, { data, loading, error }] = useDeleteStoredEmailMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useDeleteStoredEmailMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteStoredEmailMutation, GraphqlTypes.DeleteStoredEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteStoredEmailMutation, GraphqlTypes.DeleteStoredEmailMutationVariables>(DeleteStoredEmailDocument, options);
      }
export type DeleteStoredEmailMutationHookResult = ReturnType<typeof useDeleteStoredEmailMutation>;
export type DeleteStoredEmailMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteStoredEmailMutation>;
export type DeleteStoredEmailMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteStoredEmailMutation, GraphqlTypes.DeleteStoredEmailMutationVariables>;
export const GetActivityExtensionFieldsDocument = gql`
    query GetActivityExtensionFields($objectType: JSQObjectType!) {
  extensionFields(objectType: $objectType, includeApiEditOnly: false) {
    name
    id
  }
}
    `;

/**
 * __useGetActivityExtensionFieldsQuery__
 *
 * To run a query within a React component, call `useGetActivityExtensionFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityExtensionFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityExtensionFieldsQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useGetActivityExtensionFieldsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetActivityExtensionFieldsQuery, GraphqlTypes.GetActivityExtensionFieldsQueryVariables> & ({ variables: GraphqlTypes.GetActivityExtensionFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActivityExtensionFieldsQuery, GraphqlTypes.GetActivityExtensionFieldsQueryVariables>(GetActivityExtensionFieldsDocument, options);
      }
export function useGetActivityExtensionFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActivityExtensionFieldsQuery, GraphqlTypes.GetActivityExtensionFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActivityExtensionFieldsQuery, GraphqlTypes.GetActivityExtensionFieldsQueryVariables>(GetActivityExtensionFieldsDocument, options);
        }
// @ts-ignore
export function useGetActivityExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityExtensionFieldsQuery, GraphqlTypes.GetActivityExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityExtensionFieldsQuery, GraphqlTypes.GetActivityExtensionFieldsQueryVariables>;
export function useGetActivityExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityExtensionFieldsQuery, GraphqlTypes.GetActivityExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityExtensionFieldsQuery | undefined, GraphqlTypes.GetActivityExtensionFieldsQueryVariables>;
export function useGetActivityExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityExtensionFieldsQuery, GraphqlTypes.GetActivityExtensionFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActivityExtensionFieldsQuery, GraphqlTypes.GetActivityExtensionFieldsQueryVariables>(GetActivityExtensionFieldsDocument, options);
        }
export type GetActivityExtensionFieldsQueryHookResult = ReturnType<typeof useGetActivityExtensionFieldsQuery>;
export type GetActivityExtensionFieldsLazyQueryHookResult = ReturnType<typeof useGetActivityExtensionFieldsLazyQuery>;
export type GetActivityExtensionFieldsSuspenseQueryHookResult = ReturnType<typeof useGetActivityExtensionFieldsSuspenseQuery>;
export type GetActivityExtensionFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetActivityExtensionFieldsQuery, GraphqlTypes.GetActivityExtensionFieldsQueryVariables>;
export const GetAllStaffUsersDocument = gql`
    query GetAllStaffUsers {
  staffUsers {
    id
    fullName
  }
}
    `;

/**
 * __useGetAllStaffUsersQuery__
 *
 * To run a query within a React component, call `useGetAllStaffUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStaffUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStaffUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStaffUsersQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAllStaffUsersQuery, GraphqlTypes.GetAllStaffUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllStaffUsersQuery, GraphqlTypes.GetAllStaffUsersQueryVariables>(GetAllStaffUsersDocument, options);
      }
export function useGetAllStaffUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllStaffUsersQuery, GraphqlTypes.GetAllStaffUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllStaffUsersQuery, GraphqlTypes.GetAllStaffUsersQueryVariables>(GetAllStaffUsersDocument, options);
        }
// @ts-ignore
export function useGetAllStaffUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllStaffUsersQuery, GraphqlTypes.GetAllStaffUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllStaffUsersQuery, GraphqlTypes.GetAllStaffUsersQueryVariables>;
export function useGetAllStaffUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllStaffUsersQuery, GraphqlTypes.GetAllStaffUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllStaffUsersQuery | undefined, GraphqlTypes.GetAllStaffUsersQueryVariables>;
export function useGetAllStaffUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllStaffUsersQuery, GraphqlTypes.GetAllStaffUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllStaffUsersQuery, GraphqlTypes.GetAllStaffUsersQueryVariables>(GetAllStaffUsersDocument, options);
        }
export type GetAllStaffUsersQueryHookResult = ReturnType<typeof useGetAllStaffUsersQuery>;
export type GetAllStaffUsersLazyQueryHookResult = ReturnType<typeof useGetAllStaffUsersLazyQuery>;
export type GetAllStaffUsersSuspenseQueryHookResult = ReturnType<typeof useGetAllStaffUsersSuspenseQuery>;
export type GetAllStaffUsersQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllStaffUsersQuery, GraphqlTypes.GetAllStaffUsersQueryVariables>;
export const CreateDocumentVersionForActivityDocument = gql`
    mutation CreateDocumentVersionForActivity($objectInput: CreateDocumentVersionInput!) {
  createDocumentVersion(objectInput: $objectInput) {
    ... on DocumentVersionObjectType {
      id
      name
      downloadUrl
      embedUrl
      directDownloadUrl
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type CreateDocumentVersionForActivityMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateDocumentVersionForActivityMutation, GraphqlTypes.CreateDocumentVersionForActivityMutationVariables>;

/**
 * __useCreateDocumentVersionForActivityMutation__
 *
 * To run a mutation, you first call `useCreateDocumentVersionForActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentVersionForActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentVersionForActivityMutation, { data, loading, error }] = useCreateDocumentVersionForActivityMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useCreateDocumentVersionForActivityMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateDocumentVersionForActivityMutation, GraphqlTypes.CreateDocumentVersionForActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateDocumentVersionForActivityMutation, GraphqlTypes.CreateDocumentVersionForActivityMutationVariables>(CreateDocumentVersionForActivityDocument, options);
      }
export type CreateDocumentVersionForActivityMutationHookResult = ReturnType<typeof useCreateDocumentVersionForActivityMutation>;
export type CreateDocumentVersionForActivityMutationResult = Apollo.MutationResult<GraphqlTypes.CreateDocumentVersionForActivityMutation>;
export type CreateDocumentVersionForActivityMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateDocumentVersionForActivityMutation, GraphqlTypes.CreateDocumentVersionForActivityMutationVariables>;
export const GetContactForAutoPopulateDocument = gql`
    query GetContactForAutoPopulate($id: ID!) {
  contact(id: $id) {
    id
    fullName
    contactType
    company {
      id
      fullName
    }
    staff {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetContactForAutoPopulateQuery__
 *
 * To run a query within a React component, call `useGetContactForAutoPopulateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactForAutoPopulateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactForAutoPopulateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContactForAutoPopulateQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactForAutoPopulateQuery, GraphqlTypes.GetContactForAutoPopulateQueryVariables> & ({ variables: GraphqlTypes.GetContactForAutoPopulateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactForAutoPopulateQuery, GraphqlTypes.GetContactForAutoPopulateQueryVariables>(GetContactForAutoPopulateDocument, options);
      }
export function useGetContactForAutoPopulateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactForAutoPopulateQuery, GraphqlTypes.GetContactForAutoPopulateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactForAutoPopulateQuery, GraphqlTypes.GetContactForAutoPopulateQueryVariables>(GetContactForAutoPopulateDocument, options);
        }
// @ts-ignore
export function useGetContactForAutoPopulateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactForAutoPopulateQuery, GraphqlTypes.GetContactForAutoPopulateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactForAutoPopulateQuery, GraphqlTypes.GetContactForAutoPopulateQueryVariables>;
export function useGetContactForAutoPopulateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactForAutoPopulateQuery, GraphqlTypes.GetContactForAutoPopulateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactForAutoPopulateQuery | undefined, GraphqlTypes.GetContactForAutoPopulateQueryVariables>;
export function useGetContactForAutoPopulateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactForAutoPopulateQuery, GraphqlTypes.GetContactForAutoPopulateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactForAutoPopulateQuery, GraphqlTypes.GetContactForAutoPopulateQueryVariables>(GetContactForAutoPopulateDocument, options);
        }
export type GetContactForAutoPopulateQueryHookResult = ReturnType<typeof useGetContactForAutoPopulateQuery>;
export type GetContactForAutoPopulateLazyQueryHookResult = ReturnType<typeof useGetContactForAutoPopulateLazyQuery>;
export type GetContactForAutoPopulateSuspenseQueryHookResult = ReturnType<typeof useGetContactForAutoPopulateSuspenseQuery>;
export type GetContactForAutoPopulateQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactForAutoPopulateQuery, GraphqlTypes.GetContactForAutoPopulateQueryVariables>;
export const GetProspectForAutoPopulateDocument = gql`
    query GetProspectForAutoPopulate($id: ID!) {
  prospect(id: $id) {
    id
    title
    offeringName
    offeringId
    contacts {
      edges {
        node {
          id
          fullName
          contactType
        }
      }
    }
  }
}
    `;

/**
 * __useGetProspectForAutoPopulateQuery__
 *
 * To run a query within a React component, call `useGetProspectForAutoPopulateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProspectForAutoPopulateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProspectForAutoPopulateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProspectForAutoPopulateQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProspectForAutoPopulateQuery, GraphqlTypes.GetProspectForAutoPopulateQueryVariables> & ({ variables: GraphqlTypes.GetProspectForAutoPopulateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProspectForAutoPopulateQuery, GraphqlTypes.GetProspectForAutoPopulateQueryVariables>(GetProspectForAutoPopulateDocument, options);
      }
export function useGetProspectForAutoPopulateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProspectForAutoPopulateQuery, GraphqlTypes.GetProspectForAutoPopulateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProspectForAutoPopulateQuery, GraphqlTypes.GetProspectForAutoPopulateQueryVariables>(GetProspectForAutoPopulateDocument, options);
        }
// @ts-ignore
export function useGetProspectForAutoPopulateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectForAutoPopulateQuery, GraphqlTypes.GetProspectForAutoPopulateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProspectForAutoPopulateQuery, GraphqlTypes.GetProspectForAutoPopulateQueryVariables>;
export function useGetProspectForAutoPopulateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectForAutoPopulateQuery, GraphqlTypes.GetProspectForAutoPopulateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProspectForAutoPopulateQuery | undefined, GraphqlTypes.GetProspectForAutoPopulateQueryVariables>;
export function useGetProspectForAutoPopulateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectForAutoPopulateQuery, GraphqlTypes.GetProspectForAutoPopulateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProspectForAutoPopulateQuery, GraphqlTypes.GetProspectForAutoPopulateQueryVariables>(GetProspectForAutoPopulateDocument, options);
        }
export type GetProspectForAutoPopulateQueryHookResult = ReturnType<typeof useGetProspectForAutoPopulateQuery>;
export type GetProspectForAutoPopulateLazyQueryHookResult = ReturnType<typeof useGetProspectForAutoPopulateLazyQuery>;
export type GetProspectForAutoPopulateSuspenseQueryHookResult = ReturnType<typeof useGetProspectForAutoPopulateSuspenseQuery>;
export type GetProspectForAutoPopulateQueryResult = Apollo.QueryResult<GraphqlTypes.GetProspectForAutoPopulateQuery, GraphqlTypes.GetProspectForAutoPopulateQueryVariables>;
export const GetPositionForAutoPopulateDocument = gql`
    query GetPositionForAutoPopulate($id: ID!) {
  position(id: $id) {
    id
    account {
      id
      name
      contacts {
        edges {
          node {
            id
            fullName
            contactType
          }
        }
      }
    }
    investmentEntity {
      id
      name
    }
  }
}
    `;

/**
 * __useGetPositionForAutoPopulateQuery__
 *
 * To run a query within a React component, call `useGetPositionForAutoPopulateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionForAutoPopulateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionForAutoPopulateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPositionForAutoPopulateQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionForAutoPopulateQuery, GraphqlTypes.GetPositionForAutoPopulateQueryVariables> & ({ variables: GraphqlTypes.GetPositionForAutoPopulateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionForAutoPopulateQuery, GraphqlTypes.GetPositionForAutoPopulateQueryVariables>(GetPositionForAutoPopulateDocument, options);
      }
export function useGetPositionForAutoPopulateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionForAutoPopulateQuery, GraphqlTypes.GetPositionForAutoPopulateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionForAutoPopulateQuery, GraphqlTypes.GetPositionForAutoPopulateQueryVariables>(GetPositionForAutoPopulateDocument, options);
        }
// @ts-ignore
export function useGetPositionForAutoPopulateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionForAutoPopulateQuery, GraphqlTypes.GetPositionForAutoPopulateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionForAutoPopulateQuery, GraphqlTypes.GetPositionForAutoPopulateQueryVariables>;
export function useGetPositionForAutoPopulateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionForAutoPopulateQuery, GraphqlTypes.GetPositionForAutoPopulateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionForAutoPopulateQuery | undefined, GraphqlTypes.GetPositionForAutoPopulateQueryVariables>;
export function useGetPositionForAutoPopulateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionForAutoPopulateQuery, GraphqlTypes.GetPositionForAutoPopulateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionForAutoPopulateQuery, GraphqlTypes.GetPositionForAutoPopulateQueryVariables>(GetPositionForAutoPopulateDocument, options);
        }
export type GetPositionForAutoPopulateQueryHookResult = ReturnType<typeof useGetPositionForAutoPopulateQuery>;
export type GetPositionForAutoPopulateLazyQueryHookResult = ReturnType<typeof useGetPositionForAutoPopulateLazyQuery>;
export type GetPositionForAutoPopulateSuspenseQueryHookResult = ReturnType<typeof useGetPositionForAutoPopulateSuspenseQuery>;
export type GetPositionForAutoPopulateQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionForAutoPopulateQuery, GraphqlTypes.GetPositionForAutoPopulateQueryVariables>;
export const GetEmailDetailsDocument = gql`
    query GetEmailDetails($id: ID!) {
  email(id: $id) {
    id
    bodyText
    bodyHtml
    subject
    dateSent
    sendFailed
    recipients {
      edges {
        node {
          recipientType
          emailAddress
          contactId
          deliverStatusCode
          deliverStatusMessage
          dateSent
          firstOpened
          id
          name
        }
      }
    }
    attachments {
      documentId
      documentName
    }
    emailType
    senderName
    lastError
    senderEmailAddress
  }
}
    `;

/**
 * __useGetEmailDetailsQuery__
 *
 * To run a query within a React component, call `useGetEmailDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmailDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEmailDetailsQuery, GraphqlTypes.GetEmailDetailsQueryVariables> & ({ variables: GraphqlTypes.GetEmailDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEmailDetailsQuery, GraphqlTypes.GetEmailDetailsQueryVariables>(GetEmailDetailsDocument, options);
      }
export function useGetEmailDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEmailDetailsQuery, GraphqlTypes.GetEmailDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEmailDetailsQuery, GraphqlTypes.GetEmailDetailsQueryVariables>(GetEmailDetailsDocument, options);
        }
// @ts-ignore
export function useGetEmailDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailDetailsQuery, GraphqlTypes.GetEmailDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailDetailsQuery, GraphqlTypes.GetEmailDetailsQueryVariables>;
export function useGetEmailDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailDetailsQuery, GraphqlTypes.GetEmailDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailDetailsQuery | undefined, GraphqlTypes.GetEmailDetailsQueryVariables>;
export function useGetEmailDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailDetailsQuery, GraphqlTypes.GetEmailDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEmailDetailsQuery, GraphqlTypes.GetEmailDetailsQueryVariables>(GetEmailDetailsDocument, options);
        }
export type GetEmailDetailsQueryHookResult = ReturnType<typeof useGetEmailDetailsQuery>;
export type GetEmailDetailsLazyQueryHookResult = ReturnType<typeof useGetEmailDetailsLazyQuery>;
export type GetEmailDetailsSuspenseQueryHookResult = ReturnType<typeof useGetEmailDetailsSuspenseQuery>;
export type GetEmailDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEmailDetailsQuery, GraphqlTypes.GetEmailDetailsQueryVariables>;
export const GetStoredEmailDetailsDocument = gql`
    query GetStoredEmailDetails($id: ID!, $thumbnailWidth: Int = 64, $thumbnailHeight: Int = 64) {
  storedEmail(id: $id) {
    id
    subject
    bodyHtml
    bodyText
    sender
    dateTime
    conversationId
    conversationPosition
    integrationId
    createdBy
    people {
      edges {
        node {
          id
          fullName
          contactType
          company {
            id
            fullName
          }
          thumbnail {
            photoUrl(width: $thumbnailWidth, height: $thumbnailHeight)
          }
        }
      }
    }
    organizations {
      edges {
        node {
          id
          fullName
          contactType
          thumbnail {
            photoUrl(width: $thumbnailWidth, height: $thumbnailHeight)
          }
        }
      }
    }
    staff {
      edges {
        node {
          id
          fullName
        }
      }
    }
    offerings {
      id
      name
    }
    entities {
      id
      name
    }
    toRecipients {
      name
      address
    }
    ccRecipients {
      name
      address
    }
    bccRecipients {
      name
      address
    }
    attachments {
      documentId
      documentName
      documentVersion {
        id
        name
        size
        contentType
        extension
        downloadUrl
      }
    }
    activityFeedOwnerName
  }
}
    `;

/**
 * __useGetStoredEmailDetailsQuery__
 *
 * To run a query within a React component, call `useGetStoredEmailDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoredEmailDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoredEmailDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      thumbnailWidth: // value for 'thumbnailWidth'
 *      thumbnailHeight: // value for 'thumbnailHeight'
 *   },
 * });
 */
export function useGetStoredEmailDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetStoredEmailDetailsQuery, GraphqlTypes.GetStoredEmailDetailsQueryVariables> & ({ variables: GraphqlTypes.GetStoredEmailDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetStoredEmailDetailsQuery, GraphqlTypes.GetStoredEmailDetailsQueryVariables>(GetStoredEmailDetailsDocument, options);
      }
export function useGetStoredEmailDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetStoredEmailDetailsQuery, GraphqlTypes.GetStoredEmailDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetStoredEmailDetailsQuery, GraphqlTypes.GetStoredEmailDetailsQueryVariables>(GetStoredEmailDetailsDocument, options);
        }
// @ts-ignore
export function useGetStoredEmailDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStoredEmailDetailsQuery, GraphqlTypes.GetStoredEmailDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStoredEmailDetailsQuery, GraphqlTypes.GetStoredEmailDetailsQueryVariables>;
export function useGetStoredEmailDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStoredEmailDetailsQuery, GraphqlTypes.GetStoredEmailDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStoredEmailDetailsQuery | undefined, GraphqlTypes.GetStoredEmailDetailsQueryVariables>;
export function useGetStoredEmailDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStoredEmailDetailsQuery, GraphqlTypes.GetStoredEmailDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetStoredEmailDetailsQuery, GraphqlTypes.GetStoredEmailDetailsQueryVariables>(GetStoredEmailDetailsDocument, options);
        }
export type GetStoredEmailDetailsQueryHookResult = ReturnType<typeof useGetStoredEmailDetailsQuery>;
export type GetStoredEmailDetailsLazyQueryHookResult = ReturnType<typeof useGetStoredEmailDetailsLazyQuery>;
export type GetStoredEmailDetailsSuspenseQueryHookResult = ReturnType<typeof useGetStoredEmailDetailsSuspenseQuery>;
export type GetStoredEmailDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetStoredEmailDetailsQuery, GraphqlTypes.GetStoredEmailDetailsQueryVariables>;
export const GetStoredEmailsByConversationDocument = gql`
    query GetStoredEmailsByConversation($conversationId: String!) {
  storedEmailsByConversation(conversationId: $conversationId) {
    id
    subject
    bodyHtml
    bodyText
    sender
    dateTime
    conversationId
    conversationPosition
    integrationId
    people {
      edges {
        node {
          id
          fullName
          contactType
          company {
            id
            fullName
          }
        }
      }
    }
    organizations {
      edges {
        node {
          id
          fullName
          contactType
        }
      }
    }
    staff {
      edges {
        node {
          id
          fullName
        }
      }
    }
    offerings {
      id
      name
    }
    entities {
      id
      name
    }
    toRecipients {
      name
      address
    }
    ccRecipients {
      name
      address
    }
    bccRecipients {
      name
      address
    }
    attachments {
      documentId
      documentName
      documentVersion {
        id
        name
        size
        contentType
        extension
        downloadUrl
      }
    }
    activityFeedOwnerName
  }
}
    `;

/**
 * __useGetStoredEmailsByConversationQuery__
 *
 * To run a query within a React component, call `useGetStoredEmailsByConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoredEmailsByConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoredEmailsByConversationQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useGetStoredEmailsByConversationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetStoredEmailsByConversationQuery, GraphqlTypes.GetStoredEmailsByConversationQueryVariables> & ({ variables: GraphqlTypes.GetStoredEmailsByConversationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetStoredEmailsByConversationQuery, GraphqlTypes.GetStoredEmailsByConversationQueryVariables>(GetStoredEmailsByConversationDocument, options);
      }
export function useGetStoredEmailsByConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetStoredEmailsByConversationQuery, GraphqlTypes.GetStoredEmailsByConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetStoredEmailsByConversationQuery, GraphqlTypes.GetStoredEmailsByConversationQueryVariables>(GetStoredEmailsByConversationDocument, options);
        }
// @ts-ignore
export function useGetStoredEmailsByConversationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStoredEmailsByConversationQuery, GraphqlTypes.GetStoredEmailsByConversationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStoredEmailsByConversationQuery, GraphqlTypes.GetStoredEmailsByConversationQueryVariables>;
export function useGetStoredEmailsByConversationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStoredEmailsByConversationQuery, GraphqlTypes.GetStoredEmailsByConversationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStoredEmailsByConversationQuery | undefined, GraphqlTypes.GetStoredEmailsByConversationQueryVariables>;
export function useGetStoredEmailsByConversationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStoredEmailsByConversationQuery, GraphqlTypes.GetStoredEmailsByConversationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetStoredEmailsByConversationQuery, GraphqlTypes.GetStoredEmailsByConversationQueryVariables>(GetStoredEmailsByConversationDocument, options);
        }
export type GetStoredEmailsByConversationQueryHookResult = ReturnType<typeof useGetStoredEmailsByConversationQuery>;
export type GetStoredEmailsByConversationLazyQueryHookResult = ReturnType<typeof useGetStoredEmailsByConversationLazyQuery>;
export type GetStoredEmailsByConversationSuspenseQueryHookResult = ReturnType<typeof useGetStoredEmailsByConversationSuspenseQuery>;
export type GetStoredEmailsByConversationQueryResult = Apollo.QueryResult<GraphqlTypes.GetStoredEmailsByConversationQuery, GraphqlTypes.GetStoredEmailsByConversationQueryVariables>;
export const GetAiEnabledDocument = gql`
    query GetAiEnabled {
  currentArena {
    aiEnabled
  }
}
    `;

/**
 * __useGetAiEnabledQuery__
 *
 * To run a query within a React component, call `useGetAiEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiEnabledQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAiEnabledQuery, GraphqlTypes.GetAiEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAiEnabledQuery, GraphqlTypes.GetAiEnabledQueryVariables>(GetAiEnabledDocument, options);
      }
export function useGetAiEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAiEnabledQuery, GraphqlTypes.GetAiEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAiEnabledQuery, GraphqlTypes.GetAiEnabledQueryVariables>(GetAiEnabledDocument, options);
        }
// @ts-ignore
export function useGetAiEnabledSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAiEnabledQuery, GraphqlTypes.GetAiEnabledQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAiEnabledQuery, GraphqlTypes.GetAiEnabledQueryVariables>;
export function useGetAiEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAiEnabledQuery, GraphqlTypes.GetAiEnabledQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAiEnabledQuery | undefined, GraphqlTypes.GetAiEnabledQueryVariables>;
export function useGetAiEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAiEnabledQuery, GraphqlTypes.GetAiEnabledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAiEnabledQuery, GraphqlTypes.GetAiEnabledQueryVariables>(GetAiEnabledDocument, options);
        }
export type GetAiEnabledQueryHookResult = ReturnType<typeof useGetAiEnabledQuery>;
export type GetAiEnabledLazyQueryHookResult = ReturnType<typeof useGetAiEnabledLazyQuery>;
export type GetAiEnabledSuspenseQueryHookResult = ReturnType<typeof useGetAiEnabledSuspenseQuery>;
export type GetAiEnabledQueryResult = Apollo.QueryResult<GraphqlTypes.GetAiEnabledQuery, GraphqlTypes.GetAiEnabledQueryVariables>;
export const ToggleAiEnabledDocument = gql`
    mutation ToggleAiEnabled($enabled: Boolean!) {
  arenaOps {
    toggleAiEnabled(enabled: $enabled) {
      result {
        ... on MutationErrorResponse {
          errorCode
          message
        }
        ... on MutationSuccessResponse {
          didSucceed
        }
      }
    }
  }
}
    `;
export type ToggleAiEnabledMutationFn = Apollo.MutationFunction<GraphqlTypes.ToggleAiEnabledMutation, GraphqlTypes.ToggleAiEnabledMutationVariables>;

/**
 * __useToggleAiEnabledMutation__
 *
 * To run a mutation, you first call `useToggleAiEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAiEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAiEnabledMutation, { data, loading, error }] = useToggleAiEnabledMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useToggleAiEnabledMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ToggleAiEnabledMutation, GraphqlTypes.ToggleAiEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ToggleAiEnabledMutation, GraphqlTypes.ToggleAiEnabledMutationVariables>(ToggleAiEnabledDocument, options);
      }
export type ToggleAiEnabledMutationHookResult = ReturnType<typeof useToggleAiEnabledMutation>;
export type ToggleAiEnabledMutationResult = Apollo.MutationResult<GraphqlTypes.ToggleAiEnabledMutation>;
export type ToggleAiEnabledMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ToggleAiEnabledMutation, GraphqlTypes.ToggleAiEnabledMutationVariables>;
export const UpdateSsoConfigDocument = gql`
    mutation UpdateSsoConfig($updateSsoConfigInput: UpdateSsoConfigInput!) {
  ssoOps {
    updateSsoConfig(updateSsoConfigInput: $updateSsoConfigInput) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on MutationSuccessResponse {
        didSucceed
      }
    }
  }
}
    `;
export type UpdateSsoConfigMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateSsoConfigMutation, GraphqlTypes.UpdateSsoConfigMutationVariables>;

/**
 * __useUpdateSsoConfigMutation__
 *
 * To run a mutation, you first call `useUpdateSsoConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSsoConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSsoConfigMutation, { data, loading, error }] = useUpdateSsoConfigMutation({
 *   variables: {
 *      updateSsoConfigInput: // value for 'updateSsoConfigInput'
 *   },
 * });
 */
export function useUpdateSsoConfigMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateSsoConfigMutation, GraphqlTypes.UpdateSsoConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateSsoConfigMutation, GraphqlTypes.UpdateSsoConfigMutationVariables>(UpdateSsoConfigDocument, options);
      }
export type UpdateSsoConfigMutationHookResult = ReturnType<typeof useUpdateSsoConfigMutation>;
export type UpdateSsoConfigMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateSsoConfigMutation>;
export type UpdateSsoConfigMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateSsoConfigMutation, GraphqlTypes.UpdateSsoConfigMutationVariables>;
export const UpdateSsoStatusDocument = gql`
    mutation UpdateSsoStatus($updateSsoStatusInput: UpdateSsoStatusInput!) {
  ssoOps {
    updateSsoStatus(updateSsoStatusInput: $updateSsoStatusInput) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on MutationSuccessResponse {
        didSucceed
      }
    }
  }
}
    `;
export type UpdateSsoStatusMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateSsoStatusMutation, GraphqlTypes.UpdateSsoStatusMutationVariables>;

/**
 * __useUpdateSsoStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSsoStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSsoStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSsoStatusMutation, { data, loading, error }] = useUpdateSsoStatusMutation({
 *   variables: {
 *      updateSsoStatusInput: // value for 'updateSsoStatusInput'
 *   },
 * });
 */
export function useUpdateSsoStatusMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateSsoStatusMutation, GraphqlTypes.UpdateSsoStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateSsoStatusMutation, GraphqlTypes.UpdateSsoStatusMutationVariables>(UpdateSsoStatusDocument, options);
      }
export type UpdateSsoStatusMutationHookResult = ReturnType<typeof useUpdateSsoStatusMutation>;
export type UpdateSsoStatusMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateSsoStatusMutation>;
export type UpdateSsoStatusMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateSsoStatusMutation, GraphqlTypes.UpdateSsoStatusMutationVariables>;
export const GetSsoConfigDocument = gql`
    query GetSsoConfig {
  ssoSettings {
    name
    providerType
    identityProviderEntityId
    singleSignOnUrl
    x509SigningCerts
    x509EncryptionCert
    status
  }
}
    `;

/**
 * __useGetSsoConfigQuery__
 *
 * To run a query within a React component, call `useGetSsoConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSsoConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSsoConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSsoConfigQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetSsoConfigQuery, GraphqlTypes.GetSsoConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSsoConfigQuery, GraphqlTypes.GetSsoConfigQueryVariables>(GetSsoConfigDocument, options);
      }
export function useGetSsoConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSsoConfigQuery, GraphqlTypes.GetSsoConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSsoConfigQuery, GraphqlTypes.GetSsoConfigQueryVariables>(GetSsoConfigDocument, options);
        }
// @ts-ignore
export function useGetSsoConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoConfigQuery, GraphqlTypes.GetSsoConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSsoConfigQuery, GraphqlTypes.GetSsoConfigQueryVariables>;
export function useGetSsoConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoConfigQuery, GraphqlTypes.GetSsoConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSsoConfigQuery | undefined, GraphqlTypes.GetSsoConfigQueryVariables>;
export function useGetSsoConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoConfigQuery, GraphqlTypes.GetSsoConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSsoConfigQuery, GraphqlTypes.GetSsoConfigQueryVariables>(GetSsoConfigDocument, options);
        }
export type GetSsoConfigQueryHookResult = ReturnType<typeof useGetSsoConfigQuery>;
export type GetSsoConfigLazyQueryHookResult = ReturnType<typeof useGetSsoConfigLazyQuery>;
export type GetSsoConfigSuspenseQueryHookResult = ReturnType<typeof useGetSsoConfigSuspenseQuery>;
export type GetSsoConfigQueryResult = Apollo.QueryResult<GraphqlTypes.GetSsoConfigQuery, GraphqlTypes.GetSsoConfigQueryVariables>;
export const GetAuthenticationSettingsFeatureFlagsDocument = gql`
    query GetAuthenticationSettingsFeatureFlags {
  devFeatures {
    externalAuthentication
  }
}
    `;

/**
 * __useGetAuthenticationSettingsFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetAuthenticationSettingsFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthenticationSettingsFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthenticationSettingsFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuthenticationSettingsFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQuery, GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQuery, GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQueryVariables>(GetAuthenticationSettingsFeatureFlagsDocument, options);
      }
export function useGetAuthenticationSettingsFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQuery, GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQuery, GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQueryVariables>(GetAuthenticationSettingsFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useGetAuthenticationSettingsFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQuery, GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQuery, GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQueryVariables>;
export function useGetAuthenticationSettingsFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQuery, GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQuery | undefined, GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQueryVariables>;
export function useGetAuthenticationSettingsFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQuery, GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQuery, GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQueryVariables>(GetAuthenticationSettingsFeatureFlagsDocument, options);
        }
export type GetAuthenticationSettingsFeatureFlagsQueryHookResult = ReturnType<typeof useGetAuthenticationSettingsFeatureFlagsQuery>;
export type GetAuthenticationSettingsFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetAuthenticationSettingsFeatureFlagsLazyQuery>;
export type GetAuthenticationSettingsFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useGetAuthenticationSettingsFeatureFlagsSuspenseQuery>;
export type GetAuthenticationSettingsFeatureFlagsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQuery, GraphqlTypes.GetAuthenticationSettingsFeatureFlagsQueryVariables>;
export const GetTwoFaRequiredDocument = gql`
    query GetTwoFaRequired {
  currentArena {
    twoFaRequiredStaff
  }
}
    `;

/**
 * __useGetTwoFaRequiredQuery__
 *
 * To run a query within a React component, call `useGetTwoFaRequiredQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwoFaRequiredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwoFaRequiredQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTwoFaRequiredQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetTwoFaRequiredQuery, GraphqlTypes.GetTwoFaRequiredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTwoFaRequiredQuery, GraphqlTypes.GetTwoFaRequiredQueryVariables>(GetTwoFaRequiredDocument, options);
      }
export function useGetTwoFaRequiredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTwoFaRequiredQuery, GraphqlTypes.GetTwoFaRequiredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTwoFaRequiredQuery, GraphqlTypes.GetTwoFaRequiredQueryVariables>(GetTwoFaRequiredDocument, options);
        }
// @ts-ignore
export function useGetTwoFaRequiredSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTwoFaRequiredQuery, GraphqlTypes.GetTwoFaRequiredQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTwoFaRequiredQuery, GraphqlTypes.GetTwoFaRequiredQueryVariables>;
export function useGetTwoFaRequiredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTwoFaRequiredQuery, GraphqlTypes.GetTwoFaRequiredQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTwoFaRequiredQuery | undefined, GraphqlTypes.GetTwoFaRequiredQueryVariables>;
export function useGetTwoFaRequiredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTwoFaRequiredQuery, GraphqlTypes.GetTwoFaRequiredQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTwoFaRequiredQuery, GraphqlTypes.GetTwoFaRequiredQueryVariables>(GetTwoFaRequiredDocument, options);
        }
export type GetTwoFaRequiredQueryHookResult = ReturnType<typeof useGetTwoFaRequiredQuery>;
export type GetTwoFaRequiredLazyQueryHookResult = ReturnType<typeof useGetTwoFaRequiredLazyQuery>;
export type GetTwoFaRequiredSuspenseQueryHookResult = ReturnType<typeof useGetTwoFaRequiredSuspenseQuery>;
export type GetTwoFaRequiredQueryResult = Apollo.QueryResult<GraphqlTypes.GetTwoFaRequiredQuery, GraphqlTypes.GetTwoFaRequiredQueryVariables>;
export const GetSsoStatusDocument = gql`
    query GetSsoStatus {
  ssoSettings {
    name
    status
  }
}
    `;

/**
 * __useGetSsoStatusQuery__
 *
 * To run a query within a React component, call `useGetSsoStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSsoStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSsoStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSsoStatusQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetSsoStatusQuery, GraphqlTypes.GetSsoStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSsoStatusQuery, GraphqlTypes.GetSsoStatusQueryVariables>(GetSsoStatusDocument, options);
      }
export function useGetSsoStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSsoStatusQuery, GraphqlTypes.GetSsoStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSsoStatusQuery, GraphqlTypes.GetSsoStatusQueryVariables>(GetSsoStatusDocument, options);
        }
// @ts-ignore
export function useGetSsoStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoStatusQuery, GraphqlTypes.GetSsoStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSsoStatusQuery, GraphqlTypes.GetSsoStatusQueryVariables>;
export function useGetSsoStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoStatusQuery, GraphqlTypes.GetSsoStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSsoStatusQuery | undefined, GraphqlTypes.GetSsoStatusQueryVariables>;
export function useGetSsoStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoStatusQuery, GraphqlTypes.GetSsoStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSsoStatusQuery, GraphqlTypes.GetSsoStatusQueryVariables>(GetSsoStatusDocument, options);
        }
export type GetSsoStatusQueryHookResult = ReturnType<typeof useGetSsoStatusQuery>;
export type GetSsoStatusLazyQueryHookResult = ReturnType<typeof useGetSsoStatusLazyQuery>;
export type GetSsoStatusSuspenseQueryHookResult = ReturnType<typeof useGetSsoStatusSuspenseQuery>;
export type GetSsoStatusQueryResult = Apollo.QueryResult<GraphqlTypes.GetSsoStatusQuery, GraphqlTypes.GetSsoStatusQueryVariables>;
export const ToggleTwoFaDocument = gql`
    mutation ToggleTwoFa($toggleInput: ToggleTwoFaRequiredInput!) {
  twoFaOps {
    toggleTwoFa(toggleInput: $toggleInput) {
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on MutationSuccessResponse {
        didSucceed
      }
    }
  }
}
    `;
export type ToggleTwoFaMutationFn = Apollo.MutationFunction<GraphqlTypes.ToggleTwoFaMutation, GraphqlTypes.ToggleTwoFaMutationVariables>;

/**
 * __useToggleTwoFaMutation__
 *
 * To run a mutation, you first call `useToggleTwoFaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleTwoFaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleTwoFaMutation, { data, loading, error }] = useToggleTwoFaMutation({
 *   variables: {
 *      toggleInput: // value for 'toggleInput'
 *   },
 * });
 */
export function useToggleTwoFaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ToggleTwoFaMutation, GraphqlTypes.ToggleTwoFaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ToggleTwoFaMutation, GraphqlTypes.ToggleTwoFaMutationVariables>(ToggleTwoFaDocument, options);
      }
export type ToggleTwoFaMutationHookResult = ReturnType<typeof useToggleTwoFaMutation>;
export type ToggleTwoFaMutationResult = Apollo.MutationResult<GraphqlTypes.ToggleTwoFaMutation>;
export type ToggleTwoFaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ToggleTwoFaMutation, GraphqlTypes.ToggleTwoFaMutationVariables>;
export const DeleteSsoConfigDocument = gql`
    mutation DeleteSsoConfig {
  ssoOps {
    deleteSsoConfig {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on MutationSuccessResponse {
        didSucceed
      }
    }
  }
}
    `;
export type DeleteSsoConfigMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteSsoConfigMutation, GraphqlTypes.DeleteSsoConfigMutationVariables>;

/**
 * __useDeleteSsoConfigMutation__
 *
 * To run a mutation, you first call `useDeleteSsoConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSsoConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSsoConfigMutation, { data, loading, error }] = useDeleteSsoConfigMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteSsoConfigMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteSsoConfigMutation, GraphqlTypes.DeleteSsoConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteSsoConfigMutation, GraphqlTypes.DeleteSsoConfigMutationVariables>(DeleteSsoConfigDocument, options);
      }
export type DeleteSsoConfigMutationHookResult = ReturnType<typeof useDeleteSsoConfigMutation>;
export type DeleteSsoConfigMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteSsoConfigMutation>;
export type DeleteSsoConfigMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteSsoConfigMutation, GraphqlTypes.DeleteSsoConfigMutationVariables>;
export const SetDocusignSoboEmailAddressDocument = gql`
    mutation SetDocusignSoboEmailAddress($objectInput: DocusignSoboEmailEditInput!) {
  setDocusignSoboEmailAddress(objectInput: $objectInput) {
    success
  }
}
    `;
export type SetDocusignSoboEmailAddressMutationFn = Apollo.MutationFunction<GraphqlTypes.SetDocusignSoboEmailAddressMutation, GraphqlTypes.SetDocusignSoboEmailAddressMutationVariables>;

/**
 * __useSetDocusignSoboEmailAddressMutation__
 *
 * To run a mutation, you first call `useSetDocusignSoboEmailAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocusignSoboEmailAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocusignSoboEmailAddressMutation, { data, loading, error }] = useSetDocusignSoboEmailAddressMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useSetDocusignSoboEmailAddressMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetDocusignSoboEmailAddressMutation, GraphqlTypes.SetDocusignSoboEmailAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetDocusignSoboEmailAddressMutation, GraphqlTypes.SetDocusignSoboEmailAddressMutationVariables>(SetDocusignSoboEmailAddressDocument, options);
      }
export type SetDocusignSoboEmailAddressMutationHookResult = ReturnType<typeof useSetDocusignSoboEmailAddressMutation>;
export type SetDocusignSoboEmailAddressMutationResult = Apollo.MutationResult<GraphqlTypes.SetDocusignSoboEmailAddressMutation>;
export type SetDocusignSoboEmailAddressMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetDocusignSoboEmailAddressMutation, GraphqlTypes.SetDocusignSoboEmailAddressMutationVariables>;
export const GetActiveDocusignEnvelopesDocument = gql`
    query GetActiveDocusignEnvelopes {
  currentArena {
    id
    activeEmbeddedDocusignEnvelopes {
      accessibleEnvelopeDetails {
        ...SubscriptionEmbeddedEnvelopeDetailsFragment
        ...ESignatureEntityEnvelopeDetailsFragment
        ...ESignatureOfferingEnvelopeDetailsFragment
      }
      allEnvelopesCount
      nonAccessibleEnvelopesCount
    }
  }
}
    ${SubscriptionEmbeddedEnvelopeDetailsFragmentFragmentDoc}
${ESignatureEntityEnvelopeDetailsFragmentFragmentDoc}
${ESignatureOfferingEnvelopeDetailsFragmentFragmentDoc}`;

/**
 * __useGetActiveDocusignEnvelopesQuery__
 *
 * To run a query within a React component, call `useGetActiveDocusignEnvelopesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveDocusignEnvelopesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveDocusignEnvelopesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveDocusignEnvelopesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetActiveDocusignEnvelopesQuery, GraphqlTypes.GetActiveDocusignEnvelopesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActiveDocusignEnvelopesQuery, GraphqlTypes.GetActiveDocusignEnvelopesQueryVariables>(GetActiveDocusignEnvelopesDocument, options);
      }
export function useGetActiveDocusignEnvelopesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActiveDocusignEnvelopesQuery, GraphqlTypes.GetActiveDocusignEnvelopesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActiveDocusignEnvelopesQuery, GraphqlTypes.GetActiveDocusignEnvelopesQueryVariables>(GetActiveDocusignEnvelopesDocument, options);
        }
// @ts-ignore
export function useGetActiveDocusignEnvelopesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActiveDocusignEnvelopesQuery, GraphqlTypes.GetActiveDocusignEnvelopesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActiveDocusignEnvelopesQuery, GraphqlTypes.GetActiveDocusignEnvelopesQueryVariables>;
export function useGetActiveDocusignEnvelopesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActiveDocusignEnvelopesQuery, GraphqlTypes.GetActiveDocusignEnvelopesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActiveDocusignEnvelopesQuery | undefined, GraphqlTypes.GetActiveDocusignEnvelopesQueryVariables>;
export function useGetActiveDocusignEnvelopesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActiveDocusignEnvelopesQuery, GraphqlTypes.GetActiveDocusignEnvelopesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActiveDocusignEnvelopesQuery, GraphqlTypes.GetActiveDocusignEnvelopesQueryVariables>(GetActiveDocusignEnvelopesDocument, options);
        }
export type GetActiveDocusignEnvelopesQueryHookResult = ReturnType<typeof useGetActiveDocusignEnvelopesQuery>;
export type GetActiveDocusignEnvelopesLazyQueryHookResult = ReturnType<typeof useGetActiveDocusignEnvelopesLazyQuery>;
export type GetActiveDocusignEnvelopesSuspenseQueryHookResult = ReturnType<typeof useGetActiveDocusignEnvelopesSuspenseQuery>;
export type GetActiveDocusignEnvelopesQueryResult = Apollo.QueryResult<GraphqlTypes.GetActiveDocusignEnvelopesQuery, GraphqlTypes.GetActiveDocusignEnvelopesQueryVariables>;
export const GetDocusignSoboDetailsDocument = gql`
    query GetDocusignSoboDetails {
  currentArena {
    id
    docusignSoboEmailAddress
    docusignSoboUserStatus
    docusignSoboUserConsentUrl
    archivedSoboEmailAddresses
  }
}
    `;

/**
 * __useGetDocusignSoboDetailsQuery__
 *
 * To run a query within a React component, call `useGetDocusignSoboDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocusignSoboDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocusignSoboDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDocusignSoboDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDocusignSoboDetailsQuery, GraphqlTypes.GetDocusignSoboDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocusignSoboDetailsQuery, GraphqlTypes.GetDocusignSoboDetailsQueryVariables>(GetDocusignSoboDetailsDocument, options);
      }
export function useGetDocusignSoboDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocusignSoboDetailsQuery, GraphqlTypes.GetDocusignSoboDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocusignSoboDetailsQuery, GraphqlTypes.GetDocusignSoboDetailsQueryVariables>(GetDocusignSoboDetailsDocument, options);
        }
// @ts-ignore
export function useGetDocusignSoboDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocusignSoboDetailsQuery, GraphqlTypes.GetDocusignSoboDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocusignSoboDetailsQuery, GraphqlTypes.GetDocusignSoboDetailsQueryVariables>;
export function useGetDocusignSoboDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocusignSoboDetailsQuery, GraphqlTypes.GetDocusignSoboDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocusignSoboDetailsQuery | undefined, GraphqlTypes.GetDocusignSoboDetailsQueryVariables>;
export function useGetDocusignSoboDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocusignSoboDetailsQuery, GraphqlTypes.GetDocusignSoboDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocusignSoboDetailsQuery, GraphqlTypes.GetDocusignSoboDetailsQueryVariables>(GetDocusignSoboDetailsDocument, options);
        }
export type GetDocusignSoboDetailsQueryHookResult = ReturnType<typeof useGetDocusignSoboDetailsQuery>;
export type GetDocusignSoboDetailsLazyQueryHookResult = ReturnType<typeof useGetDocusignSoboDetailsLazyQuery>;
export type GetDocusignSoboDetailsSuspenseQueryHookResult = ReturnType<typeof useGetDocusignSoboDetailsSuspenseQuery>;
export type GetDocusignSoboDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocusignSoboDetailsQuery, GraphqlTypes.GetDocusignSoboDetailsQueryVariables>;
export const GetCurrentArenaForBusinessInformationDocument = gql`
    query GetCurrentArenaForBusinessInformation {
  currentArena {
    id
    twoFaRequiredStaff
  }
}
    `;

/**
 * __useGetCurrentArenaForBusinessInformationQuery__
 *
 * To run a query within a React component, call `useGetCurrentArenaForBusinessInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentArenaForBusinessInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentArenaForBusinessInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentArenaForBusinessInformationQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrentArenaForBusinessInformationQuery, GraphqlTypes.GetCurrentArenaForBusinessInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrentArenaForBusinessInformationQuery, GraphqlTypes.GetCurrentArenaForBusinessInformationQueryVariables>(GetCurrentArenaForBusinessInformationDocument, options);
      }
export function useGetCurrentArenaForBusinessInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrentArenaForBusinessInformationQuery, GraphqlTypes.GetCurrentArenaForBusinessInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrentArenaForBusinessInformationQuery, GraphqlTypes.GetCurrentArenaForBusinessInformationQueryVariables>(GetCurrentArenaForBusinessInformationDocument, options);
        }
// @ts-ignore
export function useGetCurrentArenaForBusinessInformationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaForBusinessInformationQuery, GraphqlTypes.GetCurrentArenaForBusinessInformationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentArenaForBusinessInformationQuery, GraphqlTypes.GetCurrentArenaForBusinessInformationQueryVariables>;
export function useGetCurrentArenaForBusinessInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaForBusinessInformationQuery, GraphqlTypes.GetCurrentArenaForBusinessInformationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentArenaForBusinessInformationQuery | undefined, GraphqlTypes.GetCurrentArenaForBusinessInformationQueryVariables>;
export function useGetCurrentArenaForBusinessInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaForBusinessInformationQuery, GraphqlTypes.GetCurrentArenaForBusinessInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrentArenaForBusinessInformationQuery, GraphqlTypes.GetCurrentArenaForBusinessInformationQueryVariables>(GetCurrentArenaForBusinessInformationDocument, options);
        }
export type GetCurrentArenaForBusinessInformationQueryHookResult = ReturnType<typeof useGetCurrentArenaForBusinessInformationQuery>;
export type GetCurrentArenaForBusinessInformationLazyQueryHookResult = ReturnType<typeof useGetCurrentArenaForBusinessInformationLazyQuery>;
export type GetCurrentArenaForBusinessInformationSuspenseQueryHookResult = ReturnType<typeof useGetCurrentArenaForBusinessInformationSuspenseQuery>;
export type GetCurrentArenaForBusinessInformationQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrentArenaForBusinessInformationQuery, GraphqlTypes.GetCurrentArenaForBusinessInformationQueryVariables>;
export const DownloadPortalAccessDataDocument = gql`
    mutation DownloadPortalAccessData($statusFilter: String) {
  portalAccessOps {
    downloadPortalAccessData(statusFilter: $statusFilter) {
      job {
        id
      }
    }
  }
}
    `;
export type DownloadPortalAccessDataMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadPortalAccessDataMutation, GraphqlTypes.DownloadPortalAccessDataMutationVariables>;

/**
 * __useDownloadPortalAccessDataMutation__
 *
 * To run a mutation, you first call `useDownloadPortalAccessDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadPortalAccessDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadPortalAccessDataMutation, { data, loading, error }] = useDownloadPortalAccessDataMutation({
 *   variables: {
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useDownloadPortalAccessDataMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadPortalAccessDataMutation, GraphqlTypes.DownloadPortalAccessDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadPortalAccessDataMutation, GraphqlTypes.DownloadPortalAccessDataMutationVariables>(DownloadPortalAccessDataDocument, options);
      }
export type DownloadPortalAccessDataMutationHookResult = ReturnType<typeof useDownloadPortalAccessDataMutation>;
export type DownloadPortalAccessDataMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadPortalAccessDataMutation>;
export type DownloadPortalAccessDataMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadPortalAccessDataMutation, GraphqlTypes.DownloadPortalAccessDataMutationVariables>;
export const GetArenaInfoForEntitySelectorModalDocument = gql`
    query GetArenaInfoForEntitySelectorModal {
  currentArena {
    id
    name
    isGpLite
    hasPortalInvites
    smtpHost
    supportEmail
    supportPhone
  }
  currentUser {
    isStaffAdminUser
  }
}
    `;

/**
 * __useGetArenaInfoForEntitySelectorModalQuery__
 *
 * To run a query within a React component, call `useGetArenaInfoForEntitySelectorModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaInfoForEntitySelectorModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaInfoForEntitySelectorModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetArenaInfoForEntitySelectorModalQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetArenaInfoForEntitySelectorModalQuery, GraphqlTypes.GetArenaInfoForEntitySelectorModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaInfoForEntitySelectorModalQuery, GraphqlTypes.GetArenaInfoForEntitySelectorModalQueryVariables>(GetArenaInfoForEntitySelectorModalDocument, options);
      }
export function useGetArenaInfoForEntitySelectorModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaInfoForEntitySelectorModalQuery, GraphqlTypes.GetArenaInfoForEntitySelectorModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaInfoForEntitySelectorModalQuery, GraphqlTypes.GetArenaInfoForEntitySelectorModalQueryVariables>(GetArenaInfoForEntitySelectorModalDocument, options);
        }
// @ts-ignore
export function useGetArenaInfoForEntitySelectorModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaInfoForEntitySelectorModalQuery, GraphqlTypes.GetArenaInfoForEntitySelectorModalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaInfoForEntitySelectorModalQuery, GraphqlTypes.GetArenaInfoForEntitySelectorModalQueryVariables>;
export function useGetArenaInfoForEntitySelectorModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaInfoForEntitySelectorModalQuery, GraphqlTypes.GetArenaInfoForEntitySelectorModalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaInfoForEntitySelectorModalQuery | undefined, GraphqlTypes.GetArenaInfoForEntitySelectorModalQueryVariables>;
export function useGetArenaInfoForEntitySelectorModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaInfoForEntitySelectorModalQuery, GraphqlTypes.GetArenaInfoForEntitySelectorModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaInfoForEntitySelectorModalQuery, GraphqlTypes.GetArenaInfoForEntitySelectorModalQueryVariables>(GetArenaInfoForEntitySelectorModalDocument, options);
        }
export type GetArenaInfoForEntitySelectorModalQueryHookResult = ReturnType<typeof useGetArenaInfoForEntitySelectorModalQuery>;
export type GetArenaInfoForEntitySelectorModalLazyQueryHookResult = ReturnType<typeof useGetArenaInfoForEntitySelectorModalLazyQuery>;
export type GetArenaInfoForEntitySelectorModalSuspenseQueryHookResult = ReturnType<typeof useGetArenaInfoForEntitySelectorModalSuspenseQuery>;
export type GetArenaInfoForEntitySelectorModalQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaInfoForEntitySelectorModalQuery, GraphqlTypes.GetArenaInfoForEntitySelectorModalQueryVariables>;
export const InviteContactsToPortalDocument = gql`
    mutation InviteContactsToPortal($entityIds: [Int!], $contactIds: [Int!], $allEntities: Boolean) {
  portalAccessOps {
    inviteContactsToPortal(
      entityIds: $entityIds
      contactIds: $contactIds
      allEntities: $allEntities
    ) {
      job {
        id
      }
      __typename
    }
  }
}
    `;
export type InviteContactsToPortalMutationFn = Apollo.MutationFunction<GraphqlTypes.InviteContactsToPortalMutation, GraphqlTypes.InviteContactsToPortalMutationVariables>;

/**
 * __useInviteContactsToPortalMutation__
 *
 * To run a mutation, you first call `useInviteContactsToPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteContactsToPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteContactsToPortalMutation, { data, loading, error }] = useInviteContactsToPortalMutation({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *      contactIds: // value for 'contactIds'
 *      allEntities: // value for 'allEntities'
 *   },
 * });
 */
export function useInviteContactsToPortalMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.InviteContactsToPortalMutation, GraphqlTypes.InviteContactsToPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.InviteContactsToPortalMutation, GraphqlTypes.InviteContactsToPortalMutationVariables>(InviteContactsToPortalDocument, options);
      }
export type InviteContactsToPortalMutationHookResult = ReturnType<typeof useInviteContactsToPortalMutation>;
export type InviteContactsToPortalMutationResult = Apollo.MutationResult<GraphqlTypes.InviteContactsToPortalMutation>;
export type InviteContactsToPortalMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.InviteContactsToPortalMutation, GraphqlTypes.InviteContactsToPortalMutationVariables>;
export const GetInvitablePortalContactsDocument = gql`
    query GetInvitablePortalContacts($allEntities: Boolean!, $entityIds: [Int!], $contactIds: [Int!], $sort: [ContactObjectTypeSortEnum], $first: Int) {
  contactsInvitableToPortal(
    allEntities: $allEntities
    entityIds: $entityIds
    contactIds: $contactIds
    sort: $sort
    first: $first
  ) {
    count
    edges {
      node {
        id
        fullName
        accounts {
          name
        }
        primaryEmail {
          emailAddress
        }
      }
    }
  }
  contactsExcludedFromBulkPortalInvite(
    allEntities: $allEntities
    entityIds: $entityIds
    contactIds: $contactIds
    sort: $sort
  ) {
    count
    edges {
      node {
        id
        fullName
      }
    }
  }
  contactsNotInvitableToPortalNoEmail(
    allEntities: $allEntities
    entityIds: $entityIds
    contactIds: $contactIds
    sort: $sort
  ) {
    count
    edges {
      node {
        id
        fullName
      }
    }
  }
  contactsWithAccessToPortal(
    allEntities: $allEntities
    entityIds: $entityIds
    contactIds: $contactIds
    sort: $sort
  ) {
    count
    edges {
      node {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useGetInvitablePortalContactsQuery__
 *
 * To run a query within a React component, call `useGetInvitablePortalContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitablePortalContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitablePortalContactsQuery({
 *   variables: {
 *      allEntities: // value for 'allEntities'
 *      entityIds: // value for 'entityIds'
 *      contactIds: // value for 'contactIds'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetInvitablePortalContactsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvitablePortalContactsQuery, GraphqlTypes.GetInvitablePortalContactsQueryVariables> & ({ variables: GraphqlTypes.GetInvitablePortalContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvitablePortalContactsQuery, GraphqlTypes.GetInvitablePortalContactsQueryVariables>(GetInvitablePortalContactsDocument, options);
      }
export function useGetInvitablePortalContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvitablePortalContactsQuery, GraphqlTypes.GetInvitablePortalContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvitablePortalContactsQuery, GraphqlTypes.GetInvitablePortalContactsQueryVariables>(GetInvitablePortalContactsDocument, options);
        }
// @ts-ignore
export function useGetInvitablePortalContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvitablePortalContactsQuery, GraphqlTypes.GetInvitablePortalContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvitablePortalContactsQuery, GraphqlTypes.GetInvitablePortalContactsQueryVariables>;
export function useGetInvitablePortalContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvitablePortalContactsQuery, GraphqlTypes.GetInvitablePortalContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvitablePortalContactsQuery | undefined, GraphqlTypes.GetInvitablePortalContactsQueryVariables>;
export function useGetInvitablePortalContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvitablePortalContactsQuery, GraphqlTypes.GetInvitablePortalContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvitablePortalContactsQuery, GraphqlTypes.GetInvitablePortalContactsQueryVariables>(GetInvitablePortalContactsDocument, options);
        }
export type GetInvitablePortalContactsQueryHookResult = ReturnType<typeof useGetInvitablePortalContactsQuery>;
export type GetInvitablePortalContactsLazyQueryHookResult = ReturnType<typeof useGetInvitablePortalContactsLazyQuery>;
export type GetInvitablePortalContactsSuspenseQueryHookResult = ReturnType<typeof useGetInvitablePortalContactsSuspenseQuery>;
export type GetInvitablePortalContactsQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvitablePortalContactsQuery, GraphqlTypes.GetInvitablePortalContactsQueryVariables>;
export const CreateAssetReportTemplateDocument = gql`
    mutation createAssetReportTemplate($assetIds: [ID!]!, $name: String!, $stationeryId: ID!) {
  assetReportTemplateOps {
    createAssetReportTemplate(
      assetIds: $assetIds
      name: $name
      stationeryId: $stationeryId
    ) {
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on AssetReportTemplateObjectType {
        id
      }
    }
  }
}
    `;
export type CreateAssetReportTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateAssetReportTemplateMutation, GraphqlTypes.CreateAssetReportTemplateMutationVariables>;

/**
 * __useCreateAssetReportTemplateMutation__
 *
 * To run a mutation, you first call `useCreateAssetReportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetReportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetReportTemplateMutation, { data, loading, error }] = useCreateAssetReportTemplateMutation({
 *   variables: {
 *      assetIds: // value for 'assetIds'
 *      name: // value for 'name'
 *      stationeryId: // value for 'stationeryId'
 *   },
 * });
 */
export function useCreateAssetReportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateAssetReportTemplateMutation, GraphqlTypes.CreateAssetReportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateAssetReportTemplateMutation, GraphqlTypes.CreateAssetReportTemplateMutationVariables>(CreateAssetReportTemplateDocument, options);
      }
export type CreateAssetReportTemplateMutationHookResult = ReturnType<typeof useCreateAssetReportTemplateMutation>;
export type CreateAssetReportTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.CreateAssetReportTemplateMutation>;
export type CreateAssetReportTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateAssetReportTemplateMutation, GraphqlTypes.CreateAssetReportTemplateMutationVariables>;
export const AssignAssetsToTemplateDocument = gql`
    mutation AssignAssetsToTemplate($templateId: ID!, $assetsToAssign: [ID!]!) {
  assetOps {
    assignAssetsToTemplate(templateId: $templateId, assetsToAssign: $assetsToAssign) {
      errorCode
      message
    }
  }
}
    `;
export type AssignAssetsToTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.AssignAssetsToTemplateMutation, GraphqlTypes.AssignAssetsToTemplateMutationVariables>;

/**
 * __useAssignAssetsToTemplateMutation__
 *
 * To run a mutation, you first call `useAssignAssetsToTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAssetsToTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAssetsToTemplateMutation, { data, loading, error }] = useAssignAssetsToTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      assetsToAssign: // value for 'assetsToAssign'
 *   },
 * });
 */
export function useAssignAssetsToTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AssignAssetsToTemplateMutation, GraphqlTypes.AssignAssetsToTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AssignAssetsToTemplateMutation, GraphqlTypes.AssignAssetsToTemplateMutationVariables>(AssignAssetsToTemplateDocument, options);
      }
export type AssignAssetsToTemplateMutationHookResult = ReturnType<typeof useAssignAssetsToTemplateMutation>;
export type AssignAssetsToTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.AssignAssetsToTemplateMutation>;
export type AssignAssetsToTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AssignAssetsToTemplateMutation, GraphqlTypes.AssignAssetsToTemplateMutationVariables>;
export const GetAssetsForSelectorDocument = gql`
    query GetAssetsForSelector {
  assets {
    edges {
      node {
        ...AssetSelectorAsset
      }
    }
  }
}
    ${AssetSelectorAssetFragmentDoc}`;

/**
 * __useGetAssetsForSelectorQuery__
 *
 * To run a query within a React component, call `useGetAssetsForSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetsForSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetsForSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssetsForSelectorQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAssetsForSelectorQuery, GraphqlTypes.GetAssetsForSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetsForSelectorQuery, GraphqlTypes.GetAssetsForSelectorQueryVariables>(GetAssetsForSelectorDocument, options);
      }
export function useGetAssetsForSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetsForSelectorQuery, GraphqlTypes.GetAssetsForSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetsForSelectorQuery, GraphqlTypes.GetAssetsForSelectorQueryVariables>(GetAssetsForSelectorDocument, options);
        }
// @ts-ignore
export function useGetAssetsForSelectorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetsForSelectorQuery, GraphqlTypes.GetAssetsForSelectorQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetsForSelectorQuery, GraphqlTypes.GetAssetsForSelectorQueryVariables>;
export function useGetAssetsForSelectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetsForSelectorQuery, GraphqlTypes.GetAssetsForSelectorQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetsForSelectorQuery | undefined, GraphqlTypes.GetAssetsForSelectorQueryVariables>;
export function useGetAssetsForSelectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetsForSelectorQuery, GraphqlTypes.GetAssetsForSelectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetsForSelectorQuery, GraphqlTypes.GetAssetsForSelectorQueryVariables>(GetAssetsForSelectorDocument, options);
        }
export type GetAssetsForSelectorQueryHookResult = ReturnType<typeof useGetAssetsForSelectorQuery>;
export type GetAssetsForSelectorLazyQueryHookResult = ReturnType<typeof useGetAssetsForSelectorLazyQuery>;
export type GetAssetsForSelectorSuspenseQueryHookResult = ReturnType<typeof useGetAssetsForSelectorSuspenseQuery>;
export type GetAssetsForSelectorQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetsForSelectorQuery, GraphqlTypes.GetAssetsForSelectorQueryVariables>;
export const EditAssetReportTemplateDocument = gql`
    mutation EditAssetReportTemplate($assetReportTemplateId: ID!, $name: String, $stationeryId: ID) {
  assetReportTemplateOps {
    editAssetReportTemplate(
      assetReportTemplateId: $assetReportTemplateId
      name: $name
      stationeryId: $stationeryId
    ) {
      __typename
      ...EditAssetReportTemplateResponseFields
    }
  }
}
    ${EditAssetReportTemplateResponseFieldsFragmentDoc}`;
export type EditAssetReportTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.EditAssetReportTemplateMutation, GraphqlTypes.EditAssetReportTemplateMutationVariables>;

/**
 * __useEditAssetReportTemplateMutation__
 *
 * To run a mutation, you first call `useEditAssetReportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAssetReportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAssetReportTemplateMutation, { data, loading, error }] = useEditAssetReportTemplateMutation({
 *   variables: {
 *      assetReportTemplateId: // value for 'assetReportTemplateId'
 *      name: // value for 'name'
 *      stationeryId: // value for 'stationeryId'
 *   },
 * });
 */
export function useEditAssetReportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditAssetReportTemplateMutation, GraphqlTypes.EditAssetReportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditAssetReportTemplateMutation, GraphqlTypes.EditAssetReportTemplateMutationVariables>(EditAssetReportTemplateDocument, options);
      }
export type EditAssetReportTemplateMutationHookResult = ReturnType<typeof useEditAssetReportTemplateMutation>;
export type EditAssetReportTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.EditAssetReportTemplateMutation>;
export type EditAssetReportTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditAssetReportTemplateMutation, GraphqlTypes.EditAssetReportTemplateMutationVariables>;
export const DeleteAssetReportTemplateDocument = gql`
    mutation DeleteAssetReportTemplate($assetReportTemplateId: ID!) {
  assetReportTemplateOps {
    deleteAssetReportTemplate(assetReportTemplateId: $assetReportTemplateId) {
      __typename
      ...DeleteAssetReportTemplateResponseFields
    }
  }
}
    ${DeleteAssetReportTemplateResponseFieldsFragmentDoc}`;
export type DeleteAssetReportTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteAssetReportTemplateMutation, GraphqlTypes.DeleteAssetReportTemplateMutationVariables>;

/**
 * __useDeleteAssetReportTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteAssetReportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetReportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetReportTemplateMutation, { data, loading, error }] = useDeleteAssetReportTemplateMutation({
 *   variables: {
 *      assetReportTemplateId: // value for 'assetReportTemplateId'
 *   },
 * });
 */
export function useDeleteAssetReportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteAssetReportTemplateMutation, GraphqlTypes.DeleteAssetReportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteAssetReportTemplateMutation, GraphqlTypes.DeleteAssetReportTemplateMutationVariables>(DeleteAssetReportTemplateDocument, options);
      }
export type DeleteAssetReportTemplateMutationHookResult = ReturnType<typeof useDeleteAssetReportTemplateMutation>;
export type DeleteAssetReportTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteAssetReportTemplateMutation>;
export type DeleteAssetReportTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteAssetReportTemplateMutation, GraphqlTypes.DeleteAssetReportTemplateMutationVariables>;
export const OrderAssetReportTemplateModuleFieldsDocument = gql`
    mutation OrderAssetReportTemplateModuleFields($assetReportTemplateModuleId: ID!, $fields: [ID!]!) {
  assetReportTemplateOps {
    orderAssetReportTemplateModuleFields(
      assetReportTemplateModuleId: $assetReportTemplateModuleId
      fields: $fields
    ) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on AssetReportTemplateModuleFieldResults {
        result {
          ... on AssetReportTemplateModuleFieldObjectType {
            id
            templateField
          }
        }
      }
    }
  }
}
    `;
export type OrderAssetReportTemplateModuleFieldsMutationFn = Apollo.MutationFunction<GraphqlTypes.OrderAssetReportTemplateModuleFieldsMutation, GraphqlTypes.OrderAssetReportTemplateModuleFieldsMutationVariables>;

/**
 * __useOrderAssetReportTemplateModuleFieldsMutation__
 *
 * To run a mutation, you first call `useOrderAssetReportTemplateModuleFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderAssetReportTemplateModuleFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderAssetReportTemplateModuleFieldsMutation, { data, loading, error }] = useOrderAssetReportTemplateModuleFieldsMutation({
 *   variables: {
 *      assetReportTemplateModuleId: // value for 'assetReportTemplateModuleId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useOrderAssetReportTemplateModuleFieldsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.OrderAssetReportTemplateModuleFieldsMutation, GraphqlTypes.OrderAssetReportTemplateModuleFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.OrderAssetReportTemplateModuleFieldsMutation, GraphqlTypes.OrderAssetReportTemplateModuleFieldsMutationVariables>(OrderAssetReportTemplateModuleFieldsDocument, options);
      }
export type OrderAssetReportTemplateModuleFieldsMutationHookResult = ReturnType<typeof useOrderAssetReportTemplateModuleFieldsMutation>;
export type OrderAssetReportTemplateModuleFieldsMutationResult = Apollo.MutationResult<GraphqlTypes.OrderAssetReportTemplateModuleFieldsMutation>;
export type OrderAssetReportTemplateModuleFieldsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.OrderAssetReportTemplateModuleFieldsMutation, GraphqlTypes.OrderAssetReportTemplateModuleFieldsMutationVariables>;
export const EditAssetReportTemplateModuleDocument = gql`
    mutation EditAssetReportTemplateModule($moduleInput: EditAssetReportTemplateModuleInput!) {
  assetReportTemplateOps {
    editAssetReportTemplateModule(moduleInput: $moduleInput) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on AssetReportTemplateModuleObjectType {
        ...moduleFragment
      }
    }
  }
}
    ${ModuleFragmentFragmentDoc}`;
export type EditAssetReportTemplateModuleMutationFn = Apollo.MutationFunction<GraphqlTypes.EditAssetReportTemplateModuleMutation, GraphqlTypes.EditAssetReportTemplateModuleMutationVariables>;

/**
 * __useEditAssetReportTemplateModuleMutation__
 *
 * To run a mutation, you first call `useEditAssetReportTemplateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAssetReportTemplateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAssetReportTemplateModuleMutation, { data, loading, error }] = useEditAssetReportTemplateModuleMutation({
 *   variables: {
 *      moduleInput: // value for 'moduleInput'
 *   },
 * });
 */
export function useEditAssetReportTemplateModuleMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditAssetReportTemplateModuleMutation, GraphqlTypes.EditAssetReportTemplateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditAssetReportTemplateModuleMutation, GraphqlTypes.EditAssetReportTemplateModuleMutationVariables>(EditAssetReportTemplateModuleDocument, options);
      }
export type EditAssetReportTemplateModuleMutationHookResult = ReturnType<typeof useEditAssetReportTemplateModuleMutation>;
export type EditAssetReportTemplateModuleMutationResult = Apollo.MutationResult<GraphqlTypes.EditAssetReportTemplateModuleMutation>;
export type EditAssetReportTemplateModuleMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditAssetReportTemplateModuleMutation, GraphqlTypes.EditAssetReportTemplateModuleMutationVariables>;
export const CreateOrEditAssetReportTemplateModuleFieldDocument = gql`
    mutation CreateOrEditAssetReportTemplateModuleField($assetReportTemplateModuleId: ID!, $assetReportTemplateModuleFieldId: ID, $templateField: AssetReportFieldName!, $relativePeriod: RelativePeriod, $assetExtensionFieldId: ID) {
  assetReportTemplateOps {
    createOrEditAssetReportTemplateModuleField(
      assetReportTemplateModuleId: $assetReportTemplateModuleId
      assetReportTemplateModuleFieldId: $assetReportTemplateModuleFieldId
      templateField: $templateField
      relativePeriod: $relativePeriod
      assetExtensionFieldId: $assetExtensionFieldId
    ) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on AssetReportTemplateModuleFieldObjectType {
        id
        resourceId
        templateField
        relativePeriod
        assetExtensionFieldId
      }
    }
  }
}
    `;
export type CreateOrEditAssetReportTemplateModuleFieldMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateOrEditAssetReportTemplateModuleFieldMutation, GraphqlTypes.CreateOrEditAssetReportTemplateModuleFieldMutationVariables>;

/**
 * __useCreateOrEditAssetReportTemplateModuleFieldMutation__
 *
 * To run a mutation, you first call `useCreateOrEditAssetReportTemplateModuleFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrEditAssetReportTemplateModuleFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrEditAssetReportTemplateModuleFieldMutation, { data, loading, error }] = useCreateOrEditAssetReportTemplateModuleFieldMutation({
 *   variables: {
 *      assetReportTemplateModuleId: // value for 'assetReportTemplateModuleId'
 *      assetReportTemplateModuleFieldId: // value for 'assetReportTemplateModuleFieldId'
 *      templateField: // value for 'templateField'
 *      relativePeriod: // value for 'relativePeriod'
 *      assetExtensionFieldId: // value for 'assetExtensionFieldId'
 *   },
 * });
 */
export function useCreateOrEditAssetReportTemplateModuleFieldMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateOrEditAssetReportTemplateModuleFieldMutation, GraphqlTypes.CreateOrEditAssetReportTemplateModuleFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateOrEditAssetReportTemplateModuleFieldMutation, GraphqlTypes.CreateOrEditAssetReportTemplateModuleFieldMutationVariables>(CreateOrEditAssetReportTemplateModuleFieldDocument, options);
      }
export type CreateOrEditAssetReportTemplateModuleFieldMutationHookResult = ReturnType<typeof useCreateOrEditAssetReportTemplateModuleFieldMutation>;
export type CreateOrEditAssetReportTemplateModuleFieldMutationResult = Apollo.MutationResult<GraphqlTypes.CreateOrEditAssetReportTemplateModuleFieldMutation>;
export type CreateOrEditAssetReportTemplateModuleFieldMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateOrEditAssetReportTemplateModuleFieldMutation, GraphqlTypes.CreateOrEditAssetReportTemplateModuleFieldMutationVariables>;
export const DeleteAssetReportTemplateModuleFieldDocument = gql`
    mutation DeleteAssetReportTemplateModuleField($assetReportTemplateModuleFieldId: ID!) {
  assetReportTemplateOps {
    deleteAssetReportTemplateModuleField(
      assetReportTemplateModuleFieldId: $assetReportTemplateModuleFieldId
    ) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on AssetReportTemplateModuleFieldObjectType {
        id
        templateField
      }
    }
  }
}
    `;
export type DeleteAssetReportTemplateModuleFieldMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteAssetReportTemplateModuleFieldMutation, GraphqlTypes.DeleteAssetReportTemplateModuleFieldMutationVariables>;

/**
 * __useDeleteAssetReportTemplateModuleFieldMutation__
 *
 * To run a mutation, you first call `useDeleteAssetReportTemplateModuleFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetReportTemplateModuleFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetReportTemplateModuleFieldMutation, { data, loading, error }] = useDeleteAssetReportTemplateModuleFieldMutation({
 *   variables: {
 *      assetReportTemplateModuleFieldId: // value for 'assetReportTemplateModuleFieldId'
 *   },
 * });
 */
export function useDeleteAssetReportTemplateModuleFieldMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteAssetReportTemplateModuleFieldMutation, GraphqlTypes.DeleteAssetReportTemplateModuleFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteAssetReportTemplateModuleFieldMutation, GraphqlTypes.DeleteAssetReportTemplateModuleFieldMutationVariables>(DeleteAssetReportTemplateModuleFieldDocument, options);
      }
export type DeleteAssetReportTemplateModuleFieldMutationHookResult = ReturnType<typeof useDeleteAssetReportTemplateModuleFieldMutation>;
export type DeleteAssetReportTemplateModuleFieldMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteAssetReportTemplateModuleFieldMutation>;
export type DeleteAssetReportTemplateModuleFieldMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteAssetReportTemplateModuleFieldMutation, GraphqlTypes.DeleteAssetReportTemplateModuleFieldMutationVariables>;
export const StartPdfPreviewGenerationDocument = gql`
    mutation StartPdfPreviewGeneration($assetId: ID!, $templateId: ID!, $period: Period!) {
  assetReportTemplateOps {
    startPdfPreviewGeneration(
      assetId: $assetId
      templateId: $templateId
      period: $period
    ) {
      job {
        id
      }
    }
  }
}
    `;
export type StartPdfPreviewGenerationMutationFn = Apollo.MutationFunction<GraphqlTypes.StartPdfPreviewGenerationMutation, GraphqlTypes.StartPdfPreviewGenerationMutationVariables>;

/**
 * __useStartPdfPreviewGenerationMutation__
 *
 * To run a mutation, you first call `useStartPdfPreviewGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPdfPreviewGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPdfPreviewGenerationMutation, { data, loading, error }] = useStartPdfPreviewGenerationMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      templateId: // value for 'templateId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useStartPdfPreviewGenerationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.StartPdfPreviewGenerationMutation, GraphqlTypes.StartPdfPreviewGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.StartPdfPreviewGenerationMutation, GraphqlTypes.StartPdfPreviewGenerationMutationVariables>(StartPdfPreviewGenerationDocument, options);
      }
export type StartPdfPreviewGenerationMutationHookResult = ReturnType<typeof useStartPdfPreviewGenerationMutation>;
export type StartPdfPreviewGenerationMutationResult = Apollo.MutationResult<GraphqlTypes.StartPdfPreviewGenerationMutation>;
export type StartPdfPreviewGenerationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.StartPdfPreviewGenerationMutation, GraphqlTypes.StartPdfPreviewGenerationMutationVariables>;
export const PublishAssetReportDocument = gql`
    mutation publishAssetReport($publishInput: GenerateAssetReportInput!) {
  assetReportTemplateOps {
    publishAssetReport(publishInput: $publishInput) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on AsyncJobObjectType {
        id
      }
    }
  }
}
    `;
export type PublishAssetReportMutationFn = Apollo.MutationFunction<GraphqlTypes.PublishAssetReportMutation, GraphqlTypes.PublishAssetReportMutationVariables>;

/**
 * __usePublishAssetReportMutation__
 *
 * To run a mutation, you first call `usePublishAssetReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishAssetReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishAssetReportMutation, { data, loading, error }] = usePublishAssetReportMutation({
 *   variables: {
 *      publishInput: // value for 'publishInput'
 *   },
 * });
 */
export function usePublishAssetReportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PublishAssetReportMutation, GraphqlTypes.PublishAssetReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PublishAssetReportMutation, GraphqlTypes.PublishAssetReportMutationVariables>(PublishAssetReportDocument, options);
      }
export type PublishAssetReportMutationHookResult = ReturnType<typeof usePublishAssetReportMutation>;
export type PublishAssetReportMutationResult = Apollo.MutationResult<GraphqlTypes.PublishAssetReportMutation>;
export type PublishAssetReportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PublishAssetReportMutation, GraphqlTypes.PublishAssetReportMutationVariables>;
export const DownloadAssetReportDocument = gql`
    mutation downloadAssetReport($downloadInput: DownloadAssetReportInput!) {
  assetReportTemplateOps {
    downloadAssetReport(downloadInput: $downloadInput) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on AsyncJobObjectType {
        id
      }
    }
  }
}
    `;
export type DownloadAssetReportMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadAssetReportMutation, GraphqlTypes.DownloadAssetReportMutationVariables>;

/**
 * __useDownloadAssetReportMutation__
 *
 * To run a mutation, you first call `useDownloadAssetReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAssetReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAssetReportMutation, { data, loading, error }] = useDownloadAssetReportMutation({
 *   variables: {
 *      downloadInput: // value for 'downloadInput'
 *   },
 * });
 */
export function useDownloadAssetReportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadAssetReportMutation, GraphqlTypes.DownloadAssetReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadAssetReportMutation, GraphqlTypes.DownloadAssetReportMutationVariables>(DownloadAssetReportDocument, options);
      }
export type DownloadAssetReportMutationHookResult = ReturnType<typeof useDownloadAssetReportMutation>;
export type DownloadAssetReportMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadAssetReportMutation>;
export type DownloadAssetReportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadAssetReportMutation, GraphqlTypes.DownloadAssetReportMutationVariables>;
export const GetAssetExtensionFieldsDocument = gql`
    query GetAssetExtensionFields {
  extensionFields(objectType: asset) {
    id
    name
  }
}
    `;

/**
 * __useGetAssetExtensionFieldsQuery__
 *
 * To run a query within a React component, call `useGetAssetExtensionFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetExtensionFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetExtensionFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssetExtensionFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAssetExtensionFieldsQuery, GraphqlTypes.GetAssetExtensionFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetExtensionFieldsQuery, GraphqlTypes.GetAssetExtensionFieldsQueryVariables>(GetAssetExtensionFieldsDocument, options);
      }
export function useGetAssetExtensionFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetExtensionFieldsQuery, GraphqlTypes.GetAssetExtensionFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetExtensionFieldsQuery, GraphqlTypes.GetAssetExtensionFieldsQueryVariables>(GetAssetExtensionFieldsDocument, options);
        }
// @ts-ignore
export function useGetAssetExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetExtensionFieldsQuery, GraphqlTypes.GetAssetExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetExtensionFieldsQuery, GraphqlTypes.GetAssetExtensionFieldsQueryVariables>;
export function useGetAssetExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetExtensionFieldsQuery, GraphqlTypes.GetAssetExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetExtensionFieldsQuery | undefined, GraphqlTypes.GetAssetExtensionFieldsQueryVariables>;
export function useGetAssetExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetExtensionFieldsQuery, GraphqlTypes.GetAssetExtensionFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetExtensionFieldsQuery, GraphqlTypes.GetAssetExtensionFieldsQueryVariables>(GetAssetExtensionFieldsDocument, options);
        }
export type GetAssetExtensionFieldsQueryHookResult = ReturnType<typeof useGetAssetExtensionFieldsQuery>;
export type GetAssetExtensionFieldsLazyQueryHookResult = ReturnType<typeof useGetAssetExtensionFieldsLazyQuery>;
export type GetAssetExtensionFieldsSuspenseQueryHookResult = ReturnType<typeof useGetAssetExtensionFieldsSuspenseQuery>;
export type GetAssetExtensionFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetExtensionFieldsQuery, GraphqlTypes.GetAssetExtensionFieldsQueryVariables>;
export const GetStationeryDocument = gql`
    query GetStationery {
  stationery {
    edges {
      node {
        id
        name
        documentVersionUrl
        isDefault
        marginTop
        marginBottom
        color
      }
    }
  }
}
    `;

/**
 * __useGetStationeryQuery__
 *
 * To run a query within a React component, call `useGetStationeryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStationeryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStationeryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStationeryQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetStationeryQuery, GraphqlTypes.GetStationeryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetStationeryQuery, GraphqlTypes.GetStationeryQueryVariables>(GetStationeryDocument, options);
      }
export function useGetStationeryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetStationeryQuery, GraphqlTypes.GetStationeryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetStationeryQuery, GraphqlTypes.GetStationeryQueryVariables>(GetStationeryDocument, options);
        }
// @ts-ignore
export function useGetStationerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStationeryQuery, GraphqlTypes.GetStationeryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStationeryQuery, GraphqlTypes.GetStationeryQueryVariables>;
export function useGetStationerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStationeryQuery, GraphqlTypes.GetStationeryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStationeryQuery | undefined, GraphqlTypes.GetStationeryQueryVariables>;
export function useGetStationerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStationeryQuery, GraphqlTypes.GetStationeryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetStationeryQuery, GraphqlTypes.GetStationeryQueryVariables>(GetStationeryDocument, options);
        }
export type GetStationeryQueryHookResult = ReturnType<typeof useGetStationeryQuery>;
export type GetStationeryLazyQueryHookResult = ReturnType<typeof useGetStationeryLazyQuery>;
export type GetStationerySuspenseQueryHookResult = ReturnType<typeof useGetStationerySuspenseQuery>;
export type GetStationeryQueryResult = Apollo.QueryResult<GraphqlTypes.GetStationeryQuery, GraphqlTypes.GetStationeryQueryVariables>;
export const GetAssetReportTemplatesDocument = gql`
    query GetAssetReportTemplates($assetReportTemplateParams: AssetReportTemplateParams) {
  assetReportTemplates(assetReportTemplateParams: $assetReportTemplateParams) {
    edges {
      node {
        id
        name
        hasUpdatePermission
        hasUpdateOwnPermission
        stationery {
          id
          marginTop
          marginBottom
          documentVersionUrl
          documentVersion {
            id
          }
        }
        assets {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
  userPermissions {
    canCreateAssetReport
  }
}
    `;

/**
 * __useGetAssetReportTemplatesQuery__
 *
 * To run a query within a React component, call `useGetAssetReportTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetReportTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetReportTemplatesQuery({
 *   variables: {
 *      assetReportTemplateParams: // value for 'assetReportTemplateParams'
 *   },
 * });
 */
export function useGetAssetReportTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAssetReportTemplatesQuery, GraphqlTypes.GetAssetReportTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetReportTemplatesQuery, GraphqlTypes.GetAssetReportTemplatesQueryVariables>(GetAssetReportTemplatesDocument, options);
      }
export function useGetAssetReportTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetReportTemplatesQuery, GraphqlTypes.GetAssetReportTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetReportTemplatesQuery, GraphqlTypes.GetAssetReportTemplatesQueryVariables>(GetAssetReportTemplatesDocument, options);
        }
// @ts-ignore
export function useGetAssetReportTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetReportTemplatesQuery, GraphqlTypes.GetAssetReportTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetReportTemplatesQuery, GraphqlTypes.GetAssetReportTemplatesQueryVariables>;
export function useGetAssetReportTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetReportTemplatesQuery, GraphqlTypes.GetAssetReportTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetReportTemplatesQuery | undefined, GraphqlTypes.GetAssetReportTemplatesQueryVariables>;
export function useGetAssetReportTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetReportTemplatesQuery, GraphqlTypes.GetAssetReportTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetReportTemplatesQuery, GraphqlTypes.GetAssetReportTemplatesQueryVariables>(GetAssetReportTemplatesDocument, options);
        }
export type GetAssetReportTemplatesQueryHookResult = ReturnType<typeof useGetAssetReportTemplatesQuery>;
export type GetAssetReportTemplatesLazyQueryHookResult = ReturnType<typeof useGetAssetReportTemplatesLazyQuery>;
export type GetAssetReportTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetAssetReportTemplatesSuspenseQuery>;
export type GetAssetReportTemplatesQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetReportTemplatesQuery, GraphqlTypes.GetAssetReportTemplatesQueryVariables>;
export const GetAssetReportTemplateDocument = gql`
    query GetAssetReportTemplate($templateId: ID!) {
  assetReportTemplate(id: $templateId) {
    id
    name
    hasUpdatePermission
    hasUpdateOwnPermission
    stationery {
      id
      name
      color
      marginTop
      marginBottom
      documentVersionUrl
    }
    modules {
      edges {
        node {
          ...moduleFragment
        }
      }
    }
    assets {
      edges {
        node {
          id
          name
          entity {
            id
            name
          }
        }
      }
    }
  }
}
    ${ModuleFragmentFragmentDoc}`;

/**
 * __useGetAssetReportTemplateQuery__
 *
 * To run a query within a React component, call `useGetAssetReportTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetReportTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetReportTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useGetAssetReportTemplateQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAssetReportTemplateQuery, GraphqlTypes.GetAssetReportTemplateQueryVariables> & ({ variables: GraphqlTypes.GetAssetReportTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetReportTemplateQuery, GraphqlTypes.GetAssetReportTemplateQueryVariables>(GetAssetReportTemplateDocument, options);
      }
export function useGetAssetReportTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetReportTemplateQuery, GraphqlTypes.GetAssetReportTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetReportTemplateQuery, GraphqlTypes.GetAssetReportTemplateQueryVariables>(GetAssetReportTemplateDocument, options);
        }
// @ts-ignore
export function useGetAssetReportTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetReportTemplateQuery, GraphqlTypes.GetAssetReportTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetReportTemplateQuery, GraphqlTypes.GetAssetReportTemplateQueryVariables>;
export function useGetAssetReportTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetReportTemplateQuery, GraphqlTypes.GetAssetReportTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetReportTemplateQuery | undefined, GraphqlTypes.GetAssetReportTemplateQueryVariables>;
export function useGetAssetReportTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetReportTemplateQuery, GraphqlTypes.GetAssetReportTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetReportTemplateQuery, GraphqlTypes.GetAssetReportTemplateQueryVariables>(GetAssetReportTemplateDocument, options);
        }
export type GetAssetReportTemplateQueryHookResult = ReturnType<typeof useGetAssetReportTemplateQuery>;
export type GetAssetReportTemplateLazyQueryHookResult = ReturnType<typeof useGetAssetReportTemplateLazyQuery>;
export type GetAssetReportTemplateSuspenseQueryHookResult = ReturnType<typeof useGetAssetReportTemplateSuspenseQuery>;
export type GetAssetReportTemplateQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetReportTemplateQuery, GraphqlTypes.GetAssetReportTemplateQueryVariables>;
export const GetModuleDocument = gql`
    query GetModule($moduleId: ID!) {
  assetReportTemplateModule(id: $moduleId) {
    ...moduleFragment
  }
}
    ${ModuleFragmentFragmentDoc}`;

/**
 * __useGetModuleQuery__
 *
 * To run a query within a React component, call `useGetModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleQuery({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useGetModuleQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetModuleQuery, GraphqlTypes.GetModuleQueryVariables> & ({ variables: GraphqlTypes.GetModuleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetModuleQuery, GraphqlTypes.GetModuleQueryVariables>(GetModuleDocument, options);
      }
export function useGetModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetModuleQuery, GraphqlTypes.GetModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetModuleQuery, GraphqlTypes.GetModuleQueryVariables>(GetModuleDocument, options);
        }
// @ts-ignore
export function useGetModuleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetModuleQuery, GraphqlTypes.GetModuleQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetModuleQuery, GraphqlTypes.GetModuleQueryVariables>;
export function useGetModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetModuleQuery, GraphqlTypes.GetModuleQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetModuleQuery | undefined, GraphqlTypes.GetModuleQueryVariables>;
export function useGetModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetModuleQuery, GraphqlTypes.GetModuleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetModuleQuery, GraphqlTypes.GetModuleQueryVariables>(GetModuleDocument, options);
        }
export type GetModuleQueryHookResult = ReturnType<typeof useGetModuleQuery>;
export type GetModuleLazyQueryHookResult = ReturnType<typeof useGetModuleLazyQuery>;
export type GetModuleSuspenseQueryHookResult = ReturnType<typeof useGetModuleSuspenseQuery>;
export type GetModuleQueryResult = Apollo.QueryResult<GraphqlTypes.GetModuleQuery, GraphqlTypes.GetModuleQueryVariables>;
export const GetAssetReportDataDocument = gql`
    query GetAssetReportData($id: ID!, $period: Period!, $assetTimeSeriesTypeNames: [FieldName!]!, $entityTimeSeriesTypeNames: [FieldName!]!, $plCategories: [FieldName!]!) {
  asset(id: $id) {
    id
    name
    yearBuilt
    classUponEntry
    classUponStabilization
    expectedHoldYears
    businessStrategy
    productTypes {
      edges {
        node {
          id
          productType
          grossSqft
          netSqft
          keyCount
        }
      }
    }
    loans {
      edges {
        node {
          id
          lender
          lenderType
          originationDate
          firstPrincipalPaymentDate
          paymentDueDate
          maturityDate
          loanIndex
          interestRateDescription
          floatingRateFloor
          initialAmount {
            monies
          }
          totalAmount {
            monies
          }
        }
      }
    }
    locations {
      edges {
        node {
          id
          street
          city
          state {
            id
            name
          }
          postalCode
        }
      }
    }
    latestTimeSeriesByPeriod(
      timeSeriesTypeNames: $assetTimeSeriesTypeNames
      period: $period
    ) {
      asOfDate
      values {
        ...TimeSeriesFields
      }
    }
    entity {
      id
      name
      profitLossPeriods(plCategories: $plCategories, period: $period) {
        year
        period
        entries {
          ...ProfitLossEntryFields
        }
      }
      latestTimeSeriesByPeriod(
        timeSeriesTypeNames: $entityTimeSeriesTypeNames
        period: $period
      ) {
        asOfDate
        values {
          ...TimeSeriesFields
        }
      }
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}
${ProfitLossEntryFieldsFragmentDoc}`;

/**
 * __useGetAssetReportDataQuery__
 *
 * To run a query within a React component, call `useGetAssetReportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetReportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetReportDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      period: // value for 'period'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *      plCategories: // value for 'plCategories'
 *   },
 * });
 */
export function useGetAssetReportDataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAssetReportDataQuery, GraphqlTypes.GetAssetReportDataQueryVariables> & ({ variables: GraphqlTypes.GetAssetReportDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetReportDataQuery, GraphqlTypes.GetAssetReportDataQueryVariables>(GetAssetReportDataDocument, options);
      }
export function useGetAssetReportDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetReportDataQuery, GraphqlTypes.GetAssetReportDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetReportDataQuery, GraphqlTypes.GetAssetReportDataQueryVariables>(GetAssetReportDataDocument, options);
        }
// @ts-ignore
export function useGetAssetReportDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetReportDataQuery, GraphqlTypes.GetAssetReportDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetReportDataQuery, GraphqlTypes.GetAssetReportDataQueryVariables>;
export function useGetAssetReportDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetReportDataQuery, GraphqlTypes.GetAssetReportDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetReportDataQuery | undefined, GraphqlTypes.GetAssetReportDataQueryVariables>;
export function useGetAssetReportDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetReportDataQuery, GraphqlTypes.GetAssetReportDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetReportDataQuery, GraphqlTypes.GetAssetReportDataQueryVariables>(GetAssetReportDataDocument, options);
        }
export type GetAssetReportDataQueryHookResult = ReturnType<typeof useGetAssetReportDataQuery>;
export type GetAssetReportDataLazyQueryHookResult = ReturnType<typeof useGetAssetReportDataLazyQuery>;
export type GetAssetReportDataSuspenseQueryHookResult = ReturnType<typeof useGetAssetReportDataSuspenseQuery>;
export type GetAssetReportDataQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetReportDataQuery, GraphqlTypes.GetAssetReportDataQueryVariables>;
export const GetDevAutomatedPaymentsFeatureFlagsDocument = gql`
    query GetDevAutomatedPaymentsFeatureFlags {
  devFeatures {
    automatedPaymentsAchDebit
    hasGpxKycPaymentsOnboarding
    paymentsLpComplianceScreening
    automatedPaymentBatchesSummaryDownload
  }
}
    `;

/**
 * __useGetDevAutomatedPaymentsFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetDevAutomatedPaymentsFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevAutomatedPaymentsFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevAutomatedPaymentsFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDevAutomatedPaymentsFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQuery, GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQuery, GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQueryVariables>(GetDevAutomatedPaymentsFeatureFlagsDocument, options);
      }
export function useGetDevAutomatedPaymentsFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQuery, GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQuery, GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQueryVariables>(GetDevAutomatedPaymentsFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useGetDevAutomatedPaymentsFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQuery, GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQuery, GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQueryVariables>;
export function useGetDevAutomatedPaymentsFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQuery, GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQuery | undefined, GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQueryVariables>;
export function useGetDevAutomatedPaymentsFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQuery, GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQuery, GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQueryVariables>(GetDevAutomatedPaymentsFeatureFlagsDocument, options);
        }
export type GetDevAutomatedPaymentsFeatureFlagsQueryHookResult = ReturnType<typeof useGetDevAutomatedPaymentsFeatureFlagsQuery>;
export type GetDevAutomatedPaymentsFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetDevAutomatedPaymentsFeatureFlagsLazyQuery>;
export type GetDevAutomatedPaymentsFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useGetDevAutomatedPaymentsFeatureFlagsSuspenseQuery>;
export type GetDevAutomatedPaymentsFeatureFlagsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQuery, GraphqlTypes.GetDevAutomatedPaymentsFeatureFlagsQueryVariables>;
export const GetCurrentUserNameDocument = gql`
    query GetCurrentUserName {
  currentUser {
    id
    firstName
    middleName
    lastName
  }
}
    `;

/**
 * __useGetCurrentUserNameQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserNameQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrentUserNameQuery, GraphqlTypes.GetCurrentUserNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrentUserNameQuery, GraphqlTypes.GetCurrentUserNameQueryVariables>(GetCurrentUserNameDocument, options);
      }
export function useGetCurrentUserNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrentUserNameQuery, GraphqlTypes.GetCurrentUserNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrentUserNameQuery, GraphqlTypes.GetCurrentUserNameQueryVariables>(GetCurrentUserNameDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserNameQuery, GraphqlTypes.GetCurrentUserNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentUserNameQuery, GraphqlTypes.GetCurrentUserNameQueryVariables>;
export function useGetCurrentUserNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserNameQuery, GraphqlTypes.GetCurrentUserNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentUserNameQuery | undefined, GraphqlTypes.GetCurrentUserNameQueryVariables>;
export function useGetCurrentUserNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserNameQuery, GraphqlTypes.GetCurrentUserNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrentUserNameQuery, GraphqlTypes.GetCurrentUserNameQueryVariables>(GetCurrentUserNameDocument, options);
        }
export type GetCurrentUserNameQueryHookResult = ReturnType<typeof useGetCurrentUserNameQuery>;
export type GetCurrentUserNameLazyQueryHookResult = ReturnType<typeof useGetCurrentUserNameLazyQuery>;
export type GetCurrentUserNameSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserNameSuspenseQuery>;
export type GetCurrentUserNameQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrentUserNameQuery, GraphqlTypes.GetCurrentUserNameQueryVariables>;
export const ConfigureCustomReportDocument = gql`
    mutation ConfigureCustomReport($input: ConfigureCustomReportInput!) {
  publicationOps {
    configureCustomReport(configureCustomReportInput: $input) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on PublicationObjectType {
        id
      }
    }
  }
}
    `;
export type ConfigureCustomReportMutationFn = Apollo.MutationFunction<GraphqlTypes.ConfigureCustomReportMutation, GraphqlTypes.ConfigureCustomReportMutationVariables>;

/**
 * __useConfigureCustomReportMutation__
 *
 * To run a mutation, you first call `useConfigureCustomReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureCustomReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureCustomReportMutation, { data, loading, error }] = useConfigureCustomReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureCustomReportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ConfigureCustomReportMutation, GraphqlTypes.ConfigureCustomReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ConfigureCustomReportMutation, GraphqlTypes.ConfigureCustomReportMutationVariables>(ConfigureCustomReportDocument, options);
      }
export type ConfigureCustomReportMutationHookResult = ReturnType<typeof useConfigureCustomReportMutation>;
export type ConfigureCustomReportMutationResult = Apollo.MutationResult<GraphqlTypes.ConfigureCustomReportMutation>;
export type ConfigureCustomReportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ConfigureCustomReportMutation, GraphqlTypes.ConfigureCustomReportMutationVariables>;
export const SetCustomReportMessagesDocument = gql`
    mutation SetCustomReportMessages($input: SetCustomReportMessagesInput!) {
  publicationOps {
    setCustomReportMessages(setCustomReportMessagesInput: $input) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on PublicationObjectType {
        id
      }
    }
  }
}
    `;
export type SetCustomReportMessagesMutationFn = Apollo.MutationFunction<GraphqlTypes.SetCustomReportMessagesMutation, GraphqlTypes.SetCustomReportMessagesMutationVariables>;

/**
 * __useSetCustomReportMessagesMutation__
 *
 * To run a mutation, you first call `useSetCustomReportMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomReportMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomReportMessagesMutation, { data, loading, error }] = useSetCustomReportMessagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCustomReportMessagesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetCustomReportMessagesMutation, GraphqlTypes.SetCustomReportMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetCustomReportMessagesMutation, GraphqlTypes.SetCustomReportMessagesMutationVariables>(SetCustomReportMessagesDocument, options);
      }
export type SetCustomReportMessagesMutationHookResult = ReturnType<typeof useSetCustomReportMessagesMutation>;
export type SetCustomReportMessagesMutationResult = Apollo.MutationResult<GraphqlTypes.SetCustomReportMessagesMutation>;
export type SetCustomReportMessagesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetCustomReportMessagesMutation, GraphqlTypes.SetCustomReportMessagesMutationVariables>;
export const UpdateCustomReportDocument = gql`
    mutation UpdateCustomReport($input: UpdateCustomReportInput!) {
  publicationOps {
    updateCustomReport(updateCustomReportInput: $input) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on PublicationObjectType {
        id
      }
    }
  }
}
    `;
export type UpdateCustomReportMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateCustomReportMutation, GraphqlTypes.UpdateCustomReportMutationVariables>;

/**
 * __useUpdateCustomReportMutation__
 *
 * To run a mutation, you first call `useUpdateCustomReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomReportMutation, { data, loading, error }] = useUpdateCustomReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomReportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateCustomReportMutation, GraphqlTypes.UpdateCustomReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateCustomReportMutation, GraphqlTypes.UpdateCustomReportMutationVariables>(UpdateCustomReportDocument, options);
      }
export type UpdateCustomReportMutationHookResult = ReturnType<typeof useUpdateCustomReportMutation>;
export type UpdateCustomReportMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateCustomReportMutation>;
export type UpdateCustomReportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateCustomReportMutation, GraphqlTypes.UpdateCustomReportMutationVariables>;
export const GenerateCustomReportPreviewPdfDocument = gql`
    mutation GenerateCustomReportPreviewPdf($publicationId: ID!, $recipientId: Int!) {
  publicationOps {
    generateCustomReportPreviewPdf(
      publicationId: $publicationId
      recipientId: $recipientId
    ) {
      job {
        id
        status
      }
    }
  }
}
    `;
export type GenerateCustomReportPreviewPdfMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateCustomReportPreviewPdfMutation, GraphqlTypes.GenerateCustomReportPreviewPdfMutationVariables>;

/**
 * __useGenerateCustomReportPreviewPdfMutation__
 *
 * To run a mutation, you first call `useGenerateCustomReportPreviewPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCustomReportPreviewPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCustomReportPreviewPdfMutation, { data, loading, error }] = useGenerateCustomReportPreviewPdfMutation({
 *   variables: {
 *      publicationId: // value for 'publicationId'
 *      recipientId: // value for 'recipientId'
 *   },
 * });
 */
export function useGenerateCustomReportPreviewPdfMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateCustomReportPreviewPdfMutation, GraphqlTypes.GenerateCustomReportPreviewPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateCustomReportPreviewPdfMutation, GraphqlTypes.GenerateCustomReportPreviewPdfMutationVariables>(GenerateCustomReportPreviewPdfDocument, options);
      }
export type GenerateCustomReportPreviewPdfMutationHookResult = ReturnType<typeof useGenerateCustomReportPreviewPdfMutation>;
export type GenerateCustomReportPreviewPdfMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateCustomReportPreviewPdfMutation>;
export type GenerateCustomReportPreviewPdfMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateCustomReportPreviewPdfMutation, GraphqlTypes.GenerateCustomReportPreviewPdfMutationVariables>;
export const DiscardPublicationDocument = gql`
    mutation DiscardPublication($input: DiscardPublicationInput!) {
  publicationOps {
    discardPublication(discardPublicationInput: $input) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on MutationSuccessResponse {
        didSucceed
      }
    }
  }
}
    `;
export type DiscardPublicationMutationFn = Apollo.MutationFunction<GraphqlTypes.DiscardPublicationMutation, GraphqlTypes.DiscardPublicationMutationVariables>;

/**
 * __useDiscardPublicationMutation__
 *
 * To run a mutation, you first call `useDiscardPublicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardPublicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardPublicationMutation, { data, loading, error }] = useDiscardPublicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiscardPublicationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DiscardPublicationMutation, GraphqlTypes.DiscardPublicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DiscardPublicationMutation, GraphqlTypes.DiscardPublicationMutationVariables>(DiscardPublicationDocument, options);
      }
export type DiscardPublicationMutationHookResult = ReturnType<typeof useDiscardPublicationMutation>;
export type DiscardPublicationMutationResult = Apollo.MutationResult<GraphqlTypes.DiscardPublicationMutation>;
export type DiscardPublicationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DiscardPublicationMutation, GraphqlTypes.DiscardPublicationMutationVariables>;
export const GenerateCustomReportDocumentCollectionDocument = gql`
    mutation GenerateCustomReportDocumentCollection($input: GenerateCustomReportDocumentCollectionInput!) {
  publicationOps {
    generateCustomReportDocumentCollection(input: $input) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on MutationSuccessResponse {
        didSucceed
      }
    }
  }
}
    `;
export type GenerateCustomReportDocumentCollectionMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateCustomReportDocumentCollectionMutation, GraphqlTypes.GenerateCustomReportDocumentCollectionMutationVariables>;

/**
 * __useGenerateCustomReportDocumentCollectionMutation__
 *
 * To run a mutation, you first call `useGenerateCustomReportDocumentCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCustomReportDocumentCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCustomReportDocumentCollectionMutation, { data, loading, error }] = useGenerateCustomReportDocumentCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateCustomReportDocumentCollectionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateCustomReportDocumentCollectionMutation, GraphqlTypes.GenerateCustomReportDocumentCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateCustomReportDocumentCollectionMutation, GraphqlTypes.GenerateCustomReportDocumentCollectionMutationVariables>(GenerateCustomReportDocumentCollectionDocument, options);
      }
export type GenerateCustomReportDocumentCollectionMutationHookResult = ReturnType<typeof useGenerateCustomReportDocumentCollectionMutation>;
export type GenerateCustomReportDocumentCollectionMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateCustomReportDocumentCollectionMutation>;
export type GenerateCustomReportDocumentCollectionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateCustomReportDocumentCollectionMutation, GraphqlTypes.GenerateCustomReportDocumentCollectionMutationVariables>;
export const GetEntitiesForCustomReportDocument = gql`
    query GetEntitiesForCustomReport {
  investmentEntitiesUnsorted {
    edges {
      node {
        ...EntityFields
        positionCount
      }
    }
  }
}
    ${EntityFieldsFragmentDoc}`;

/**
 * __useGetEntitiesForCustomReportQuery__
 *
 * To run a query within a React component, call `useGetEntitiesForCustomReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitiesForCustomReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitiesForCustomReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEntitiesForCustomReportQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEntitiesForCustomReportQuery, GraphqlTypes.GetEntitiesForCustomReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntitiesForCustomReportQuery, GraphqlTypes.GetEntitiesForCustomReportQueryVariables>(GetEntitiesForCustomReportDocument, options);
      }
export function useGetEntitiesForCustomReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntitiesForCustomReportQuery, GraphqlTypes.GetEntitiesForCustomReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntitiesForCustomReportQuery, GraphqlTypes.GetEntitiesForCustomReportQueryVariables>(GetEntitiesForCustomReportDocument, options);
        }
// @ts-ignore
export function useGetEntitiesForCustomReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesForCustomReportQuery, GraphqlTypes.GetEntitiesForCustomReportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesForCustomReportQuery, GraphqlTypes.GetEntitiesForCustomReportQueryVariables>;
export function useGetEntitiesForCustomReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesForCustomReportQuery, GraphqlTypes.GetEntitiesForCustomReportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesForCustomReportQuery | undefined, GraphqlTypes.GetEntitiesForCustomReportQueryVariables>;
export function useGetEntitiesForCustomReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesForCustomReportQuery, GraphqlTypes.GetEntitiesForCustomReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntitiesForCustomReportQuery, GraphqlTypes.GetEntitiesForCustomReportQueryVariables>(GetEntitiesForCustomReportDocument, options);
        }
export type GetEntitiesForCustomReportQueryHookResult = ReturnType<typeof useGetEntitiesForCustomReportQuery>;
export type GetEntitiesForCustomReportLazyQueryHookResult = ReturnType<typeof useGetEntitiesForCustomReportLazyQuery>;
export type GetEntitiesForCustomReportSuspenseQueryHookResult = ReturnType<typeof useGetEntitiesForCustomReportSuspenseQuery>;
export type GetEntitiesForCustomReportQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntitiesForCustomReportQuery, GraphqlTypes.GetEntitiesForCustomReportQueryVariables>;
export const GetInvestmentEntityNamesDocument = gql`
    query GetInvestmentEntityNames($ids: [ID!], $first: Int) {
  investmentEntities(first: $first, filters: {ids: $ids}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetInvestmentEntityNamesQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntityNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntityNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntityNamesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetInvestmentEntityNamesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntityNamesQuery, GraphqlTypes.GetInvestmentEntityNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntityNamesQuery, GraphqlTypes.GetInvestmentEntityNamesQueryVariables>(GetInvestmentEntityNamesDocument, options);
      }
export function useGetInvestmentEntityNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntityNamesQuery, GraphqlTypes.GetInvestmentEntityNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntityNamesQuery, GraphqlTypes.GetInvestmentEntityNamesQueryVariables>(GetInvestmentEntityNamesDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntityNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityNamesQuery, GraphqlTypes.GetInvestmentEntityNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityNamesQuery, GraphqlTypes.GetInvestmentEntityNamesQueryVariables>;
export function useGetInvestmentEntityNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityNamesQuery, GraphqlTypes.GetInvestmentEntityNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityNamesQuery | undefined, GraphqlTypes.GetInvestmentEntityNamesQueryVariables>;
export function useGetInvestmentEntityNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityNamesQuery, GraphqlTypes.GetInvestmentEntityNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntityNamesQuery, GraphqlTypes.GetInvestmentEntityNamesQueryVariables>(GetInvestmentEntityNamesDocument, options);
        }
export type GetInvestmentEntityNamesQueryHookResult = ReturnType<typeof useGetInvestmentEntityNamesQuery>;
export type GetInvestmentEntityNamesLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntityNamesLazyQuery>;
export type GetInvestmentEntityNamesSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntityNamesSuspenseQuery>;
export type GetInvestmentEntityNamesQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntityNamesQuery, GraphqlTypes.GetInvestmentEntityNamesQueryVariables>;
export const GetPublicationTypeDefaultDocumentCategoryDocument = gql`
    query GetPublicationTypeDefaultDocumentCategory($publicationType: String!) {
  publicationTypeDefaultDocumentCategory(publicationType: $publicationType) {
    id
    name
  }
}
    `;

/**
 * __useGetPublicationTypeDefaultDocumentCategoryQuery__
 *
 * To run a query within a React component, call `useGetPublicationTypeDefaultDocumentCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicationTypeDefaultDocumentCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicationTypeDefaultDocumentCategoryQuery({
 *   variables: {
 *      publicationType: // value for 'publicationType'
 *   },
 * });
 */
export function useGetPublicationTypeDefaultDocumentCategoryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQuery, GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQueryVariables> & ({ variables: GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQuery, GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQueryVariables>(GetPublicationTypeDefaultDocumentCategoryDocument, options);
      }
export function useGetPublicationTypeDefaultDocumentCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQuery, GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQuery, GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQueryVariables>(GetPublicationTypeDefaultDocumentCategoryDocument, options);
        }
// @ts-ignore
export function useGetPublicationTypeDefaultDocumentCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQuery, GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQuery, GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQueryVariables>;
export function useGetPublicationTypeDefaultDocumentCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQuery, GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQuery | undefined, GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQueryVariables>;
export function useGetPublicationTypeDefaultDocumentCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQuery, GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQuery, GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQueryVariables>(GetPublicationTypeDefaultDocumentCategoryDocument, options);
        }
export type GetPublicationTypeDefaultDocumentCategoryQueryHookResult = ReturnType<typeof useGetPublicationTypeDefaultDocumentCategoryQuery>;
export type GetPublicationTypeDefaultDocumentCategoryLazyQueryHookResult = ReturnType<typeof useGetPublicationTypeDefaultDocumentCategoryLazyQuery>;
export type GetPublicationTypeDefaultDocumentCategorySuspenseQueryHookResult = ReturnType<typeof useGetPublicationTypeDefaultDocumentCategorySuspenseQuery>;
export type GetPublicationTypeDefaultDocumentCategoryQueryResult = Apollo.QueryResult<GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQuery, GraphqlTypes.GetPublicationTypeDefaultDocumentCategoryQueryVariables>;
export const GetCustomReportMessagesDocument = gql`
    query GetCustomReportMessages($publicationId: ID!) {
  customReportMessages(publicationId: $publicationId) {
    isConsolidated
    publications {
      id
      entityId
      entityName
      text
    }
  }
}
    `;

/**
 * __useGetCustomReportMessagesQuery__
 *
 * To run a query within a React component, call `useGetCustomReportMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomReportMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomReportMessagesQuery({
 *   variables: {
 *      publicationId: // value for 'publicationId'
 *   },
 * });
 */
export function useGetCustomReportMessagesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCustomReportMessagesQuery, GraphqlTypes.GetCustomReportMessagesQueryVariables> & ({ variables: GraphqlTypes.GetCustomReportMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCustomReportMessagesQuery, GraphqlTypes.GetCustomReportMessagesQueryVariables>(GetCustomReportMessagesDocument, options);
      }
export function useGetCustomReportMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCustomReportMessagesQuery, GraphqlTypes.GetCustomReportMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCustomReportMessagesQuery, GraphqlTypes.GetCustomReportMessagesQueryVariables>(GetCustomReportMessagesDocument, options);
        }
// @ts-ignore
export function useGetCustomReportMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCustomReportMessagesQuery, GraphqlTypes.GetCustomReportMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCustomReportMessagesQuery, GraphqlTypes.GetCustomReportMessagesQueryVariables>;
export function useGetCustomReportMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCustomReportMessagesQuery, GraphqlTypes.GetCustomReportMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCustomReportMessagesQuery | undefined, GraphqlTypes.GetCustomReportMessagesQueryVariables>;
export function useGetCustomReportMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCustomReportMessagesQuery, GraphqlTypes.GetCustomReportMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCustomReportMessagesQuery, GraphqlTypes.GetCustomReportMessagesQueryVariables>(GetCustomReportMessagesDocument, options);
        }
export type GetCustomReportMessagesQueryHookResult = ReturnType<typeof useGetCustomReportMessagesQuery>;
export type GetCustomReportMessagesLazyQueryHookResult = ReturnType<typeof useGetCustomReportMessagesLazyQuery>;
export type GetCustomReportMessagesSuspenseQueryHookResult = ReturnType<typeof useGetCustomReportMessagesSuspenseQuery>;
export type GetCustomReportMessagesQueryResult = Apollo.QueryResult<GraphqlTypes.GetCustomReportMessagesQuery, GraphqlTypes.GetCustomReportMessagesQueryVariables>;
export const GetPublicationRecipientsDocument = gql`
    query GetPublicationRecipients($publicationId: ID!) {
  publicationRecipients(publicationId: $publicationId) {
    id
    name
  }
}
    `;

/**
 * __useGetPublicationRecipientsQuery__
 *
 * To run a query within a React component, call `useGetPublicationRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicationRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicationRecipientsQuery({
 *   variables: {
 *      publicationId: // value for 'publicationId'
 *   },
 * });
 */
export function useGetPublicationRecipientsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPublicationRecipientsQuery, GraphqlTypes.GetPublicationRecipientsQueryVariables> & ({ variables: GraphqlTypes.GetPublicationRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPublicationRecipientsQuery, GraphqlTypes.GetPublicationRecipientsQueryVariables>(GetPublicationRecipientsDocument, options);
      }
export function useGetPublicationRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPublicationRecipientsQuery, GraphqlTypes.GetPublicationRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPublicationRecipientsQuery, GraphqlTypes.GetPublicationRecipientsQueryVariables>(GetPublicationRecipientsDocument, options);
        }
// @ts-ignore
export function useGetPublicationRecipientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPublicationRecipientsQuery, GraphqlTypes.GetPublicationRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPublicationRecipientsQuery, GraphqlTypes.GetPublicationRecipientsQueryVariables>;
export function useGetPublicationRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPublicationRecipientsQuery, GraphqlTypes.GetPublicationRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPublicationRecipientsQuery | undefined, GraphqlTypes.GetPublicationRecipientsQueryVariables>;
export function useGetPublicationRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPublicationRecipientsQuery, GraphqlTypes.GetPublicationRecipientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPublicationRecipientsQuery, GraphqlTypes.GetPublicationRecipientsQueryVariables>(GetPublicationRecipientsDocument, options);
        }
export type GetPublicationRecipientsQueryHookResult = ReturnType<typeof useGetPublicationRecipientsQuery>;
export type GetPublicationRecipientsLazyQueryHookResult = ReturnType<typeof useGetPublicationRecipientsLazyQuery>;
export type GetPublicationRecipientsSuspenseQueryHookResult = ReturnType<typeof useGetPublicationRecipientsSuspenseQuery>;
export type GetPublicationRecipientsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPublicationRecipientsQuery, GraphqlTypes.GetPublicationRecipientsQueryVariables>;
export const GetCustomReportDraftDocument = gql`
    query GetCustomReportDraft($publicationId: ID!) {
  customReportDraft(publicationId: $publicationId) {
    publicationType
    description
    logicalDate
    documentCategoryId
    customTemplateId
    entities {
      id
      name
    }
    glTransactionIds
    parameters {
      parameterKey
      valueType
      dateValue
      stringValue
      integerValue
      floatValue
    }
  }
}
    `;

/**
 * __useGetCustomReportDraftQuery__
 *
 * To run a query within a React component, call `useGetCustomReportDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomReportDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomReportDraftQuery({
 *   variables: {
 *      publicationId: // value for 'publicationId'
 *   },
 * });
 */
export function useGetCustomReportDraftQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCustomReportDraftQuery, GraphqlTypes.GetCustomReportDraftQueryVariables> & ({ variables: GraphqlTypes.GetCustomReportDraftQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCustomReportDraftQuery, GraphqlTypes.GetCustomReportDraftQueryVariables>(GetCustomReportDraftDocument, options);
      }
export function useGetCustomReportDraftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCustomReportDraftQuery, GraphqlTypes.GetCustomReportDraftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCustomReportDraftQuery, GraphqlTypes.GetCustomReportDraftQueryVariables>(GetCustomReportDraftDocument, options);
        }
// @ts-ignore
export function useGetCustomReportDraftSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCustomReportDraftQuery, GraphqlTypes.GetCustomReportDraftQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCustomReportDraftQuery, GraphqlTypes.GetCustomReportDraftQueryVariables>;
export function useGetCustomReportDraftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCustomReportDraftQuery, GraphqlTypes.GetCustomReportDraftQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCustomReportDraftQuery | undefined, GraphqlTypes.GetCustomReportDraftQueryVariables>;
export function useGetCustomReportDraftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCustomReportDraftQuery, GraphqlTypes.GetCustomReportDraftQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCustomReportDraftQuery, GraphqlTypes.GetCustomReportDraftQueryVariables>(GetCustomReportDraftDocument, options);
        }
export type GetCustomReportDraftQueryHookResult = ReturnType<typeof useGetCustomReportDraftQuery>;
export type GetCustomReportDraftLazyQueryHookResult = ReturnType<typeof useGetCustomReportDraftLazyQuery>;
export type GetCustomReportDraftSuspenseQueryHookResult = ReturnType<typeof useGetCustomReportDraftSuspenseQuery>;
export type GetCustomReportDraftQueryResult = Apollo.QueryResult<GraphqlTypes.GetCustomReportDraftQuery, GraphqlTypes.GetCustomReportDraftQueryVariables>;
export const EditDataRoomConfigurationSettingsDocument = gql`
    mutation EditDataRoomConfigurationSettings($objectInput: EditDataRoomConfigurationSettingsInput!) {
  editDataRoomConfigurationSettings(objectInput: $objectInput) {
    ... on MutationErrorResponse {
      message
    }
    ... on EditDataRoomConfigurationSettingsResponse {
      dataRoom {
        id
        published
        requiresLogin
        restrictDownloadOptions
        nda {
          id
          name
        }
      }
      currentArena {
        id
        ndaSelectList {
          id
          name
        }
        canAddNewNda
      }
    }
  }
}
    `;
export type EditDataRoomConfigurationSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.EditDataRoomConfigurationSettingsMutation, GraphqlTypes.EditDataRoomConfigurationSettingsMutationVariables>;

/**
 * __useEditDataRoomConfigurationSettingsMutation__
 *
 * To run a mutation, you first call `useEditDataRoomConfigurationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDataRoomConfigurationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDataRoomConfigurationSettingsMutation, { data, loading, error }] = useEditDataRoomConfigurationSettingsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useEditDataRoomConfigurationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditDataRoomConfigurationSettingsMutation, GraphqlTypes.EditDataRoomConfigurationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditDataRoomConfigurationSettingsMutation, GraphqlTypes.EditDataRoomConfigurationSettingsMutationVariables>(EditDataRoomConfigurationSettingsDocument, options);
      }
export type EditDataRoomConfigurationSettingsMutationHookResult = ReturnType<typeof useEditDataRoomConfigurationSettingsMutation>;
export type EditDataRoomConfigurationSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.EditDataRoomConfigurationSettingsMutation>;
export type EditDataRoomConfigurationSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditDataRoomConfigurationSettingsMutation, GraphqlTypes.EditDataRoomConfigurationSettingsMutationVariables>;
export const GetDataRoomNdaSelectListDocument = gql`
    query GetDataRoomNdaSelectList {
  currentArena {
    id
    ndaSelectList {
      id
      name
    }
    canAddNewNda
  }
}
    `;

/**
 * __useGetDataRoomNdaSelectListQuery__
 *
 * To run a query within a React component, call `useGetDataRoomNdaSelectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataRoomNdaSelectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataRoomNdaSelectListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDataRoomNdaSelectListQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDataRoomNdaSelectListQuery, GraphqlTypes.GetDataRoomNdaSelectListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDataRoomNdaSelectListQuery, GraphqlTypes.GetDataRoomNdaSelectListQueryVariables>(GetDataRoomNdaSelectListDocument, options);
      }
export function useGetDataRoomNdaSelectListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDataRoomNdaSelectListQuery, GraphqlTypes.GetDataRoomNdaSelectListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDataRoomNdaSelectListQuery, GraphqlTypes.GetDataRoomNdaSelectListQueryVariables>(GetDataRoomNdaSelectListDocument, options);
        }
// @ts-ignore
export function useGetDataRoomNdaSelectListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataRoomNdaSelectListQuery, GraphqlTypes.GetDataRoomNdaSelectListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataRoomNdaSelectListQuery, GraphqlTypes.GetDataRoomNdaSelectListQueryVariables>;
export function useGetDataRoomNdaSelectListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataRoomNdaSelectListQuery, GraphqlTypes.GetDataRoomNdaSelectListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataRoomNdaSelectListQuery | undefined, GraphqlTypes.GetDataRoomNdaSelectListQueryVariables>;
export function useGetDataRoomNdaSelectListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataRoomNdaSelectListQuery, GraphqlTypes.GetDataRoomNdaSelectListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDataRoomNdaSelectListQuery, GraphqlTypes.GetDataRoomNdaSelectListQueryVariables>(GetDataRoomNdaSelectListDocument, options);
        }
export type GetDataRoomNdaSelectListQueryHookResult = ReturnType<typeof useGetDataRoomNdaSelectListQuery>;
export type GetDataRoomNdaSelectListLazyQueryHookResult = ReturnType<typeof useGetDataRoomNdaSelectListLazyQuery>;
export type GetDataRoomNdaSelectListSuspenseQueryHookResult = ReturnType<typeof useGetDataRoomNdaSelectListSuspenseQuery>;
export type GetDataRoomNdaSelectListQueryResult = Apollo.QueryResult<GraphqlTypes.GetDataRoomNdaSelectListQuery, GraphqlTypes.GetDataRoomNdaSelectListQueryVariables>;
export const GetDataRoomConfigurationSettingsDocument = gql`
    query GetDataRoomConfigurationSettings($offeringId: ID!) {
  offering(id: $offeringId) {
    id
    dataRoom {
      id
      published
      invitedProspectCount
      requiresLogin
      restrictDownloadOptions
      nda {
        id
        name
        isArchived
      }
    }
  }
  currentUser {
    id
    roles {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetDataRoomConfigurationSettingsQuery__
 *
 * To run a query within a React component, call `useGetDataRoomConfigurationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataRoomConfigurationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataRoomConfigurationSettingsQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useGetDataRoomConfigurationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDataRoomConfigurationSettingsQuery, GraphqlTypes.GetDataRoomConfigurationSettingsQueryVariables> & ({ variables: GraphqlTypes.GetDataRoomConfigurationSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDataRoomConfigurationSettingsQuery, GraphqlTypes.GetDataRoomConfigurationSettingsQueryVariables>(GetDataRoomConfigurationSettingsDocument, options);
      }
export function useGetDataRoomConfigurationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDataRoomConfigurationSettingsQuery, GraphqlTypes.GetDataRoomConfigurationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDataRoomConfigurationSettingsQuery, GraphqlTypes.GetDataRoomConfigurationSettingsQueryVariables>(GetDataRoomConfigurationSettingsDocument, options);
        }
// @ts-ignore
export function useGetDataRoomConfigurationSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataRoomConfigurationSettingsQuery, GraphqlTypes.GetDataRoomConfigurationSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataRoomConfigurationSettingsQuery, GraphqlTypes.GetDataRoomConfigurationSettingsQueryVariables>;
export function useGetDataRoomConfigurationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataRoomConfigurationSettingsQuery, GraphqlTypes.GetDataRoomConfigurationSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataRoomConfigurationSettingsQuery | undefined, GraphqlTypes.GetDataRoomConfigurationSettingsQueryVariables>;
export function useGetDataRoomConfigurationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataRoomConfigurationSettingsQuery, GraphqlTypes.GetDataRoomConfigurationSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDataRoomConfigurationSettingsQuery, GraphqlTypes.GetDataRoomConfigurationSettingsQueryVariables>(GetDataRoomConfigurationSettingsDocument, options);
        }
export type GetDataRoomConfigurationSettingsQueryHookResult = ReturnType<typeof useGetDataRoomConfigurationSettingsQuery>;
export type GetDataRoomConfigurationSettingsLazyQueryHookResult = ReturnType<typeof useGetDataRoomConfigurationSettingsLazyQuery>;
export type GetDataRoomConfigurationSettingsSuspenseQueryHookResult = ReturnType<typeof useGetDataRoomConfigurationSettingsSuspenseQuery>;
export type GetDataRoomConfigurationSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDataRoomConfigurationSettingsQuery, GraphqlTypes.GetDataRoomConfigurationSettingsQueryVariables>;
export const BulkShareDocumentsDocument = gql`
    mutation BulkShareDocuments($documentIds: [ID!]!, $objectInput: BulkShareOrRevokeDocumentsInput!) {
  documentOps {
    bulkShareDocuments(documentIds: $documentIds, objectInput: $objectInput) {
      error
    }
  }
}
    `;
export type BulkShareDocumentsMutationFn = Apollo.MutationFunction<GraphqlTypes.BulkShareDocumentsMutation, GraphqlTypes.BulkShareDocumentsMutationVariables>;

/**
 * __useBulkShareDocumentsMutation__
 *
 * To run a mutation, you first call `useBulkShareDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkShareDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkShareDocumentsMutation, { data, loading, error }] = useBulkShareDocumentsMutation({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useBulkShareDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.BulkShareDocumentsMutation, GraphqlTypes.BulkShareDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.BulkShareDocumentsMutation, GraphqlTypes.BulkShareDocumentsMutationVariables>(BulkShareDocumentsDocument, options);
      }
export type BulkShareDocumentsMutationHookResult = ReturnType<typeof useBulkShareDocumentsMutation>;
export type BulkShareDocumentsMutationResult = Apollo.MutationResult<GraphqlTypes.BulkShareDocumentsMutation>;
export type BulkShareDocumentsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.BulkShareDocumentsMutation, GraphqlTypes.BulkShareDocumentsMutationVariables>;
export const BulkUnshareDocumentsDocument = gql`
    mutation BulkUnshareDocuments($documentIds: [ID!]!, $objectInput: BulkShareOrRevokeDocumentsInput!) {
  documentOps {
    bulkUnshareDocuments(documentIds: $documentIds, objectInput: $objectInput) {
      error
    }
  }
}
    `;
export type BulkUnshareDocumentsMutationFn = Apollo.MutationFunction<GraphqlTypes.BulkUnshareDocumentsMutation, GraphqlTypes.BulkUnshareDocumentsMutationVariables>;

/**
 * __useBulkUnshareDocumentsMutation__
 *
 * To run a mutation, you first call `useBulkUnshareDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUnshareDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUnshareDocumentsMutation, { data, loading, error }] = useBulkUnshareDocumentsMutation({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useBulkUnshareDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.BulkUnshareDocumentsMutation, GraphqlTypes.BulkUnshareDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.BulkUnshareDocumentsMutation, GraphqlTypes.BulkUnshareDocumentsMutationVariables>(BulkUnshareDocumentsDocument, options);
      }
export type BulkUnshareDocumentsMutationHookResult = ReturnType<typeof useBulkUnshareDocumentsMutation>;
export type BulkUnshareDocumentsMutationResult = Apollo.MutationResult<GraphqlTypes.BulkUnshareDocumentsMutation>;
export type BulkUnshareDocumentsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.BulkUnshareDocumentsMutation, GraphqlTypes.BulkUnshareDocumentsMutationVariables>;
export const MatchAndShareDocumentsDocument = gql`
    mutation MatchAndShareDocuments($documentId: Int!, $objectInput: MatchAndShareInput!) {
  documentOps {
    matchAndShareDocumentCollection(
      documentId: $documentId
      objectInput: $objectInput
    ) {
      ... on MutationErrorResponse {
        message
      }
      ... on AsyncJobObjectType {
        id
      }
    }
  }
}
    `;
export type MatchAndShareDocumentsMutationFn = Apollo.MutationFunction<GraphqlTypes.MatchAndShareDocumentsMutation, GraphqlTypes.MatchAndShareDocumentsMutationVariables>;

/**
 * __useMatchAndShareDocumentsMutation__
 *
 * To run a mutation, you first call `useMatchAndShareDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchAndShareDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchAndShareDocumentsMutation, { data, loading, error }] = useMatchAndShareDocumentsMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useMatchAndShareDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.MatchAndShareDocumentsMutation, GraphqlTypes.MatchAndShareDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.MatchAndShareDocumentsMutation, GraphqlTypes.MatchAndShareDocumentsMutationVariables>(MatchAndShareDocumentsDocument, options);
      }
export type MatchAndShareDocumentsMutationHookResult = ReturnType<typeof useMatchAndShareDocumentsMutation>;
export type MatchAndShareDocumentsMutationResult = Apollo.MutationResult<GraphqlTypes.MatchAndShareDocumentsMutation>;
export type MatchAndShareDocumentsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.MatchAndShareDocumentsMutation, GraphqlTypes.MatchAndShareDocumentsMutationVariables>;
export const GetEntityDocumentsDocument = gql`
    query GetEntityDocuments($id: ID!, $manualShareOnly: Boolean, $sort: [DocumentObjectTypeSortEnum]) {
  investmentEntity(id: $id, manualShareOnly: $manualShareOnly) {
    objectDocuments(manualShareOnly: $manualShareOnly, sort: $sort) {
      edges {
        node {
          id
          name
          sortingDate
          category {
            id
            name
          }
          currentVersion {
            extension
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEntityDocumentsQuery__
 *
 * To run a query within a React component, call `useGetEntityDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      manualShareOnly: // value for 'manualShareOnly'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEntityDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityDocumentsQuery, GraphqlTypes.GetEntityDocumentsQueryVariables> & ({ variables: GraphqlTypes.GetEntityDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityDocumentsQuery, GraphqlTypes.GetEntityDocumentsQueryVariables>(GetEntityDocumentsDocument, options);
      }
export function useGetEntityDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityDocumentsQuery, GraphqlTypes.GetEntityDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityDocumentsQuery, GraphqlTypes.GetEntityDocumentsQueryVariables>(GetEntityDocumentsDocument, options);
        }
// @ts-ignore
export function useGetEntityDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDocumentsQuery, GraphqlTypes.GetEntityDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityDocumentsQuery, GraphqlTypes.GetEntityDocumentsQueryVariables>;
export function useGetEntityDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDocumentsQuery, GraphqlTypes.GetEntityDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityDocumentsQuery | undefined, GraphqlTypes.GetEntityDocumentsQueryVariables>;
export function useGetEntityDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDocumentsQuery, GraphqlTypes.GetEntityDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityDocumentsQuery, GraphqlTypes.GetEntityDocumentsQueryVariables>(GetEntityDocumentsDocument, options);
        }
export type GetEntityDocumentsQueryHookResult = ReturnType<typeof useGetEntityDocumentsQuery>;
export type GetEntityDocumentsLazyQueryHookResult = ReturnType<typeof useGetEntityDocumentsLazyQuery>;
export type GetEntityDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetEntityDocumentsSuspenseQuery>;
export type GetEntityDocumentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityDocumentsQuery, GraphqlTypes.GetEntityDocumentsQueryVariables>;
export const GetOfferingDocumentsDocument = gql`
    query GetOfferingDocuments($id: ID!, $manualShareOnly: Boolean, $sort: [DocumentObjectTypeSortEnum]) {
  offering(id: $id, manualShareOnly: $manualShareOnly) {
    objectDocuments(manualShareOnly: $manualShareOnly, sort: $sort) {
      edges {
        node {
          name
          id
          sortingDate
          category {
            id
            name
          }
          currentVersion {
            extension
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOfferingDocumentsQuery__
 *
 * To run a query within a React component, call `useGetOfferingDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferingDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferingDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      manualShareOnly: // value for 'manualShareOnly'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetOfferingDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOfferingDocumentsQuery, GraphqlTypes.GetOfferingDocumentsQueryVariables> & ({ variables: GraphqlTypes.GetOfferingDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOfferingDocumentsQuery, GraphqlTypes.GetOfferingDocumentsQueryVariables>(GetOfferingDocumentsDocument, options);
      }
export function useGetOfferingDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOfferingDocumentsQuery, GraphqlTypes.GetOfferingDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOfferingDocumentsQuery, GraphqlTypes.GetOfferingDocumentsQueryVariables>(GetOfferingDocumentsDocument, options);
        }
// @ts-ignore
export function useGetOfferingDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingDocumentsQuery, GraphqlTypes.GetOfferingDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOfferingDocumentsQuery, GraphqlTypes.GetOfferingDocumentsQueryVariables>;
export function useGetOfferingDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingDocumentsQuery, GraphqlTypes.GetOfferingDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOfferingDocumentsQuery | undefined, GraphqlTypes.GetOfferingDocumentsQueryVariables>;
export function useGetOfferingDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingDocumentsQuery, GraphqlTypes.GetOfferingDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOfferingDocumentsQuery, GraphqlTypes.GetOfferingDocumentsQueryVariables>(GetOfferingDocumentsDocument, options);
        }
export type GetOfferingDocumentsQueryHookResult = ReturnType<typeof useGetOfferingDocumentsQuery>;
export type GetOfferingDocumentsLazyQueryHookResult = ReturnType<typeof useGetOfferingDocumentsLazyQuery>;
export type GetOfferingDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetOfferingDocumentsSuspenseQuery>;
export type GetOfferingDocumentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetOfferingDocumentsQuery, GraphqlTypes.GetOfferingDocumentsQueryVariables>;
export const GetManuallySharedDocumentsDocument = gql`
    query GetManuallySharedDocuments($objectType: JSQObjectType!, $objectIds: [ID!]!) {
  manuallySharedDocuments(objectType: $objectType, objectIds: $objectIds) {
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useGetManuallySharedDocumentsQuery__
 *
 * To run a query within a React component, call `useGetManuallySharedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManuallySharedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManuallySharedDocumentsQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      objectIds: // value for 'objectIds'
 *   },
 * });
 */
export function useGetManuallySharedDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetManuallySharedDocumentsQuery, GraphqlTypes.GetManuallySharedDocumentsQueryVariables> & ({ variables: GraphqlTypes.GetManuallySharedDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetManuallySharedDocumentsQuery, GraphqlTypes.GetManuallySharedDocumentsQueryVariables>(GetManuallySharedDocumentsDocument, options);
      }
export function useGetManuallySharedDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetManuallySharedDocumentsQuery, GraphqlTypes.GetManuallySharedDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetManuallySharedDocumentsQuery, GraphqlTypes.GetManuallySharedDocumentsQueryVariables>(GetManuallySharedDocumentsDocument, options);
        }
// @ts-ignore
export function useGetManuallySharedDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManuallySharedDocumentsQuery, GraphqlTypes.GetManuallySharedDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManuallySharedDocumentsQuery, GraphqlTypes.GetManuallySharedDocumentsQueryVariables>;
export function useGetManuallySharedDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManuallySharedDocumentsQuery, GraphqlTypes.GetManuallySharedDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetManuallySharedDocumentsQuery | undefined, GraphqlTypes.GetManuallySharedDocumentsQueryVariables>;
export function useGetManuallySharedDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetManuallySharedDocumentsQuery, GraphqlTypes.GetManuallySharedDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetManuallySharedDocumentsQuery, GraphqlTypes.GetManuallySharedDocumentsQueryVariables>(GetManuallySharedDocumentsDocument, options);
        }
export type GetManuallySharedDocumentsQueryHookResult = ReturnType<typeof useGetManuallySharedDocumentsQuery>;
export type GetManuallySharedDocumentsLazyQueryHookResult = ReturnType<typeof useGetManuallySharedDocumentsLazyQuery>;
export type GetManuallySharedDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetManuallySharedDocumentsSuspenseQuery>;
export type GetManuallySharedDocumentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetManuallySharedDocumentsQuery, GraphqlTypes.GetManuallySharedDocumentsQueryVariables>;
export const GetAttachmentDocumentsDocument = gql`
    query GetAttachmentDocuments($objectType: JSQObjectType!, $objectId: ID!, $sort: [DocumentObjectTypeSortEnum]) {
  attachmentDocuments(objectType: $objectType, objectId: $objectId, sort: $sort) {
    edges {
      node {
        ...DocumentFields
      }
      cursor
    }
  }
}
    ${DocumentFieldsFragmentDoc}`;

/**
 * __useGetAttachmentDocumentsQuery__
 *
 * To run a query within a React component, call `useGetAttachmentDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentDocumentsQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAttachmentDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAttachmentDocumentsQuery, GraphqlTypes.GetAttachmentDocumentsQueryVariables> & ({ variables: GraphqlTypes.GetAttachmentDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAttachmentDocumentsQuery, GraphqlTypes.GetAttachmentDocumentsQueryVariables>(GetAttachmentDocumentsDocument, options);
      }
export function useGetAttachmentDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAttachmentDocumentsQuery, GraphqlTypes.GetAttachmentDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAttachmentDocumentsQuery, GraphqlTypes.GetAttachmentDocumentsQueryVariables>(GetAttachmentDocumentsDocument, options);
        }
// @ts-ignore
export function useGetAttachmentDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAttachmentDocumentsQuery, GraphqlTypes.GetAttachmentDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAttachmentDocumentsQuery, GraphqlTypes.GetAttachmentDocumentsQueryVariables>;
export function useGetAttachmentDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAttachmentDocumentsQuery, GraphqlTypes.GetAttachmentDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAttachmentDocumentsQuery | undefined, GraphqlTypes.GetAttachmentDocumentsQueryVariables>;
export function useGetAttachmentDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAttachmentDocumentsQuery, GraphqlTypes.GetAttachmentDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAttachmentDocumentsQuery, GraphqlTypes.GetAttachmentDocumentsQueryVariables>(GetAttachmentDocumentsDocument, options);
        }
export type GetAttachmentDocumentsQueryHookResult = ReturnType<typeof useGetAttachmentDocumentsQuery>;
export type GetAttachmentDocumentsLazyQueryHookResult = ReturnType<typeof useGetAttachmentDocumentsLazyQuery>;
export type GetAttachmentDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetAttachmentDocumentsSuspenseQuery>;
export type GetAttachmentDocumentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAttachmentDocumentsQuery, GraphqlTypes.GetAttachmentDocumentsQueryVariables>;
export const GetPositionExtensionFieldsDocument = gql`
    query GetPositionExtensionFields {
  extensionFields(objectType: position) {
    name
    id
  }
}
    `;

/**
 * __useGetPositionExtensionFieldsQuery__
 *
 * To run a query within a React component, call `useGetPositionExtensionFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionExtensionFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionExtensionFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPositionExtensionFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPositionExtensionFieldsQuery, GraphqlTypes.GetPositionExtensionFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionExtensionFieldsQuery, GraphqlTypes.GetPositionExtensionFieldsQueryVariables>(GetPositionExtensionFieldsDocument, options);
      }
export function useGetPositionExtensionFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionExtensionFieldsQuery, GraphqlTypes.GetPositionExtensionFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionExtensionFieldsQuery, GraphqlTypes.GetPositionExtensionFieldsQueryVariables>(GetPositionExtensionFieldsDocument, options);
        }
// @ts-ignore
export function useGetPositionExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionExtensionFieldsQuery, GraphqlTypes.GetPositionExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionExtensionFieldsQuery, GraphqlTypes.GetPositionExtensionFieldsQueryVariables>;
export function useGetPositionExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionExtensionFieldsQuery, GraphqlTypes.GetPositionExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionExtensionFieldsQuery | undefined, GraphqlTypes.GetPositionExtensionFieldsQueryVariables>;
export function useGetPositionExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionExtensionFieldsQuery, GraphqlTypes.GetPositionExtensionFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionExtensionFieldsQuery, GraphqlTypes.GetPositionExtensionFieldsQueryVariables>(GetPositionExtensionFieldsDocument, options);
        }
export type GetPositionExtensionFieldsQueryHookResult = ReturnType<typeof useGetPositionExtensionFieldsQuery>;
export type GetPositionExtensionFieldsLazyQueryHookResult = ReturnType<typeof useGetPositionExtensionFieldsLazyQuery>;
export type GetPositionExtensionFieldsSuspenseQueryHookResult = ReturnType<typeof useGetPositionExtensionFieldsSuspenseQuery>;
export type GetPositionExtensionFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionExtensionFieldsQuery, GraphqlTypes.GetPositionExtensionFieldsQueryVariables>;
export const GetDocumentsByIdListDocument = gql`
    query GetDocumentsByIdList($documentIds: [Int]!) {
  documentsByIdList(documentIds: $documentIds) {
    edges {
      node {
        ...OfferingDocumentFields
        folder {
          id
          breadcrumb {
            ...BreadcrumbFields
          }
        }
      }
    }
  }
}
    ${OfferingDocumentFieldsFragmentDoc}
${BreadcrumbFieldsFragmentDoc}`;

/**
 * __useGetDocumentsByIdListQuery__
 *
 * To run a query within a React component, call `useGetDocumentsByIdListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsByIdListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsByIdListQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useGetDocumentsByIdListQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentsByIdListQuery, GraphqlTypes.GetDocumentsByIdListQueryVariables> & ({ variables: GraphqlTypes.GetDocumentsByIdListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentsByIdListQuery, GraphqlTypes.GetDocumentsByIdListQueryVariables>(GetDocumentsByIdListDocument, options);
      }
export function useGetDocumentsByIdListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentsByIdListQuery, GraphqlTypes.GetDocumentsByIdListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentsByIdListQuery, GraphqlTypes.GetDocumentsByIdListQueryVariables>(GetDocumentsByIdListDocument, options);
        }
// @ts-ignore
export function useGetDocumentsByIdListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentsByIdListQuery, GraphqlTypes.GetDocumentsByIdListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentsByIdListQuery, GraphqlTypes.GetDocumentsByIdListQueryVariables>;
export function useGetDocumentsByIdListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentsByIdListQuery, GraphqlTypes.GetDocumentsByIdListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentsByIdListQuery | undefined, GraphqlTypes.GetDocumentsByIdListQueryVariables>;
export function useGetDocumentsByIdListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentsByIdListQuery, GraphqlTypes.GetDocumentsByIdListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentsByIdListQuery, GraphqlTypes.GetDocumentsByIdListQueryVariables>(GetDocumentsByIdListDocument, options);
        }
export type GetDocumentsByIdListQueryHookResult = ReturnType<typeof useGetDocumentsByIdListQuery>;
export type GetDocumentsByIdListLazyQueryHookResult = ReturnType<typeof useGetDocumentsByIdListLazyQuery>;
export type GetDocumentsByIdListSuspenseQueryHookResult = ReturnType<typeof useGetDocumentsByIdListSuspenseQuery>;
export type GetDocumentsByIdListQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentsByIdListQuery, GraphqlTypes.GetDocumentsByIdListQueryVariables>;
export const GetUserUploadDocumentPermissionsDocument = gql`
    query GetUserUploadDocumentPermissions {
  userPermissions {
    canUploadDocument
  }
}
    `;

/**
 * __useGetUserUploadDocumentPermissionsQuery__
 *
 * To run a query within a React component, call `useGetUserUploadDocumentPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserUploadDocumentPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserUploadDocumentPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserUploadDocumentPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetUserUploadDocumentPermissionsQuery, GraphqlTypes.GetUserUploadDocumentPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUserUploadDocumentPermissionsQuery, GraphqlTypes.GetUserUploadDocumentPermissionsQueryVariables>(GetUserUploadDocumentPermissionsDocument, options);
      }
export function useGetUserUploadDocumentPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUserUploadDocumentPermissionsQuery, GraphqlTypes.GetUserUploadDocumentPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUserUploadDocumentPermissionsQuery, GraphqlTypes.GetUserUploadDocumentPermissionsQueryVariables>(GetUserUploadDocumentPermissionsDocument, options);
        }
// @ts-ignore
export function useGetUserUploadDocumentPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserUploadDocumentPermissionsQuery, GraphqlTypes.GetUserUploadDocumentPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserUploadDocumentPermissionsQuery, GraphqlTypes.GetUserUploadDocumentPermissionsQueryVariables>;
export function useGetUserUploadDocumentPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserUploadDocumentPermissionsQuery, GraphqlTypes.GetUserUploadDocumentPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserUploadDocumentPermissionsQuery | undefined, GraphqlTypes.GetUserUploadDocumentPermissionsQueryVariables>;
export function useGetUserUploadDocumentPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserUploadDocumentPermissionsQuery, GraphqlTypes.GetUserUploadDocumentPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUserUploadDocumentPermissionsQuery, GraphqlTypes.GetUserUploadDocumentPermissionsQueryVariables>(GetUserUploadDocumentPermissionsDocument, options);
        }
export type GetUserUploadDocumentPermissionsQueryHookResult = ReturnType<typeof useGetUserUploadDocumentPermissionsQuery>;
export type GetUserUploadDocumentPermissionsLazyQueryHookResult = ReturnType<typeof useGetUserUploadDocumentPermissionsLazyQuery>;
export type GetUserUploadDocumentPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetUserUploadDocumentPermissionsSuspenseQuery>;
export type GetUserUploadDocumentPermissionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetUserUploadDocumentPermissionsQuery, GraphqlTypes.GetUserUploadDocumentPermissionsQueryVariables>;
export const SendReminderDocument = gql`
    mutation SendReminder($input: SendReminderInputObjectType!) {
  eSignatureOps {
    sendReminder(objectInput: $input) {
      eSignatureRequest {
        id
        reminderLastSentDate
      }
    }
  }
}
    `;
export type SendReminderMutationFn = Apollo.MutationFunction<GraphqlTypes.SendReminderMutation, GraphqlTypes.SendReminderMutationVariables>;

/**
 * __useSendReminderMutation__
 *
 * To run a mutation, you first call `useSendReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReminderMutation, { data, loading, error }] = useSendReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendReminderMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SendReminderMutation, GraphqlTypes.SendReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SendReminderMutation, GraphqlTypes.SendReminderMutationVariables>(SendReminderDocument, options);
      }
export type SendReminderMutationHookResult = ReturnType<typeof useSendReminderMutation>;
export type SendReminderMutationResult = Apollo.MutationResult<GraphqlTypes.SendReminderMutation>;
export type SendReminderMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SendReminderMutation, GraphqlTypes.SendReminderMutationVariables>;
export const UpdateEsignatureRequestStatusDocument = gql`
    mutation UpdateEsignatureRequestStatus($arenaId: ID!, $eSignatureRequestId: ID!, $event: String!, $token: String!) {
  updateESignatureRequestStatus(
    input: {arenaId: $arenaId, eSignatureRequestId: $eSignatureRequestId, event: $event, token: $token}
  ) {
    success
  }
}
    `;
export type UpdateEsignatureRequestStatusMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateEsignatureRequestStatusMutation, GraphqlTypes.UpdateEsignatureRequestStatusMutationVariables>;

/**
 * __useUpdateEsignatureRequestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEsignatureRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsignatureRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsignatureRequestStatusMutation, { data, loading, error }] = useUpdateEsignatureRequestStatusMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      eSignatureRequestId: // value for 'eSignatureRequestId'
 *      event: // value for 'event'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUpdateEsignatureRequestStatusMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateEsignatureRequestStatusMutation, GraphqlTypes.UpdateEsignatureRequestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateEsignatureRequestStatusMutation, GraphqlTypes.UpdateEsignatureRequestStatusMutationVariables>(UpdateEsignatureRequestStatusDocument, options);
      }
export type UpdateEsignatureRequestStatusMutationHookResult = ReturnType<typeof useUpdateEsignatureRequestStatusMutation>;
export type UpdateEsignatureRequestStatusMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateEsignatureRequestStatusMutation>;
export type UpdateEsignatureRequestStatusMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateEsignatureRequestStatusMutation, GraphqlTypes.UpdateEsignatureRequestStatusMutationVariables>;
export const GetESignatureGpSignerDocument = gql`
    query GetESignatureGpSigner($id: ID!) {
  eSignatureGpSigner(id: $id) {
    id
    recipientView {
      url
    }
  }
}
    `;

/**
 * __useGetESignatureGpSignerQuery__
 *
 * To run a query within a React component, call `useGetESignatureGpSignerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetESignatureGpSignerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetESignatureGpSignerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetESignatureGpSignerQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetESignatureGpSignerQuery, GraphqlTypes.GetESignatureGpSignerQueryVariables> & ({ variables: GraphqlTypes.GetESignatureGpSignerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetESignatureGpSignerQuery, GraphqlTypes.GetESignatureGpSignerQueryVariables>(GetESignatureGpSignerDocument, options);
      }
export function useGetESignatureGpSignerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetESignatureGpSignerQuery, GraphqlTypes.GetESignatureGpSignerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetESignatureGpSignerQuery, GraphqlTypes.GetESignatureGpSignerQueryVariables>(GetESignatureGpSignerDocument, options);
        }
// @ts-ignore
export function useGetESignatureGpSignerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureGpSignerQuery, GraphqlTypes.GetESignatureGpSignerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureGpSignerQuery, GraphqlTypes.GetESignatureGpSignerQueryVariables>;
export function useGetESignatureGpSignerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureGpSignerQuery, GraphqlTypes.GetESignatureGpSignerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureGpSignerQuery | undefined, GraphqlTypes.GetESignatureGpSignerQueryVariables>;
export function useGetESignatureGpSignerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureGpSignerQuery, GraphqlTypes.GetESignatureGpSignerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetESignatureGpSignerQuery, GraphqlTypes.GetESignatureGpSignerQueryVariables>(GetESignatureGpSignerDocument, options);
        }
export type GetESignatureGpSignerQueryHookResult = ReturnType<typeof useGetESignatureGpSignerQuery>;
export type GetESignatureGpSignerLazyQueryHookResult = ReturnType<typeof useGetESignatureGpSignerLazyQuery>;
export type GetESignatureGpSignerSuspenseQueryHookResult = ReturnType<typeof useGetESignatureGpSignerSuspenseQuery>;
export type GetESignatureGpSignerQueryResult = Apollo.QueryResult<GraphqlTypes.GetESignatureGpSignerQuery, GraphqlTypes.GetESignatureGpSignerQueryVariables>;
export const GetESignatureGpSignerRequestDetailsDocument = gql`
    query GetESignatureGpSignerRequestDetails($id: ID!) {
  eSignatureGpSigner(id: $id) {
    id
    eSignatureRequest {
      id
      soboUserId
      soboUserEmailAddress
    }
  }
  currentArena {
    id
    docusignUserId
  }
}
    `;

/**
 * __useGetESignatureGpSignerRequestDetailsQuery__
 *
 * To run a query within a React component, call `useGetESignatureGpSignerRequestDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetESignatureGpSignerRequestDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetESignatureGpSignerRequestDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetESignatureGpSignerRequestDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetESignatureGpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureGpSignerRequestDetailsQueryVariables> & ({ variables: GraphqlTypes.GetESignatureGpSignerRequestDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetESignatureGpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureGpSignerRequestDetailsQueryVariables>(GetESignatureGpSignerRequestDetailsDocument, options);
      }
export function useGetESignatureGpSignerRequestDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetESignatureGpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureGpSignerRequestDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetESignatureGpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureGpSignerRequestDetailsQueryVariables>(GetESignatureGpSignerRequestDetailsDocument, options);
        }
// @ts-ignore
export function useGetESignatureGpSignerRequestDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureGpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureGpSignerRequestDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureGpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureGpSignerRequestDetailsQueryVariables>;
export function useGetESignatureGpSignerRequestDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureGpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureGpSignerRequestDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureGpSignerRequestDetailsQuery | undefined, GraphqlTypes.GetESignatureGpSignerRequestDetailsQueryVariables>;
export function useGetESignatureGpSignerRequestDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureGpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureGpSignerRequestDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetESignatureGpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureGpSignerRequestDetailsQueryVariables>(GetESignatureGpSignerRequestDetailsDocument, options);
        }
export type GetESignatureGpSignerRequestDetailsQueryHookResult = ReturnType<typeof useGetESignatureGpSignerRequestDetailsQuery>;
export type GetESignatureGpSignerRequestDetailsLazyQueryHookResult = ReturnType<typeof useGetESignatureGpSignerRequestDetailsLazyQuery>;
export type GetESignatureGpSignerRequestDetailsSuspenseQueryHookResult = ReturnType<typeof useGetESignatureGpSignerRequestDetailsSuspenseQuery>;
export type GetESignatureGpSignerRequestDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetESignatureGpSignerRequestDetailsQuery, GraphqlTypes.GetESignatureGpSignerRequestDetailsQueryVariables>;
export const VoidRequestDocument = gql`
    mutation VoidRequest($input: VoidRequestInputObjectType!) {
  eSignatureOps {
    voidRequest(objectInput: $input) {
      eSignatureRequest {
        id
        status
      }
    }
  }
}
    `;
export type VoidRequestMutationFn = Apollo.MutationFunction<GraphqlTypes.VoidRequestMutation, GraphqlTypes.VoidRequestMutationVariables>;

/**
 * __useVoidRequestMutation__
 *
 * To run a mutation, you first call `useVoidRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidRequestMutation, { data, loading, error }] = useVoidRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVoidRequestMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.VoidRequestMutation, GraphqlTypes.VoidRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.VoidRequestMutation, GraphqlTypes.VoidRequestMutationVariables>(VoidRequestDocument, options);
      }
export type VoidRequestMutationHookResult = ReturnType<typeof useVoidRequestMutation>;
export type VoidRequestMutationResult = Apollo.MutationResult<GraphqlTypes.VoidRequestMutation>;
export type VoidRequestMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.VoidRequestMutation, GraphqlTypes.VoidRequestMutationVariables>;
export const GetESignatureDashboardDocument = gql`
    query GetESignatureDashboard($id: ID!, $filters: ESignatureRequestTemplateGpSignerFilters!, $searchFilters: ESignatureRequestSearchFilters) {
  eSignatureRequestTemplateGpSigners(filters: $filters) {
    edges {
      node {
        title
        user {
          fullName
          id
        }
      }
    }
  }
  eSignatureRequestTemplate(id: $id) {
    id
    objectId
    objectType
    currentValidatedStep
    title
    eSignatureRequestTemplateErrors {
      id
      message
    }
    eSignatureDocument {
      id
      documentCollectionId
      documentVersion {
        id
        name
        size
        contentType
        createdAt
        extension
        embedUrl
      }
    }
    eSignatureRequests {
      count
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          status
          hasDocumentAccessToWriteAndUpload
          reminderLastSentDate
          lpSignersSentDate
          eSignatureExecutedDocuments {
            edges {
              node {
                executedDocumentVersion {
                  id
                  name
                  size
                  contentType
                  createdAt
                  extension
                  embedUrl
                }
              }
            }
          }
          eSignatureGpSigners {
            edges {
              node {
                id
                status
                signedDate
                isEmbedded
                user {
                  id
                  fullName
                  emailAddress
                  contact {
                    ...SignerContactFields
                  }
                }
              }
            }
          }
          eSignatureRecipients(filters: $searchFilters) {
            edges {
              node {
                id
                objectId
                objectType
                eSignatureRequestRecipientObject {
                  ...ProspectFields
                  ...PositionFields
                  __typename
                }
                eSignatureLpSigners {
                  edges {
                    node {
                      id
                      status
                      isDesignatedFormFiller
                      contact {
                        ...SignerContactFields
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${SignerContactFieldsFragmentDoc}
${ProspectFieldsFragmentDoc}
${PositionFieldsFragmentDoc}`;

/**
 * __useGetESignatureDashboardQuery__
 *
 * To run a query within a React component, call `useGetESignatureDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetESignatureDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetESignatureDashboardQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *      searchFilters: // value for 'searchFilters'
 *   },
 * });
 */
export function useGetESignatureDashboardQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetESignatureDashboardQuery, GraphqlTypes.GetESignatureDashboardQueryVariables> & ({ variables: GraphqlTypes.GetESignatureDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetESignatureDashboardQuery, GraphqlTypes.GetESignatureDashboardQueryVariables>(GetESignatureDashboardDocument, options);
      }
export function useGetESignatureDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetESignatureDashboardQuery, GraphqlTypes.GetESignatureDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetESignatureDashboardQuery, GraphqlTypes.GetESignatureDashboardQueryVariables>(GetESignatureDashboardDocument, options);
        }
// @ts-ignore
export function useGetESignatureDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureDashboardQuery, GraphqlTypes.GetESignatureDashboardQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureDashboardQuery, GraphqlTypes.GetESignatureDashboardQueryVariables>;
export function useGetESignatureDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureDashboardQuery, GraphqlTypes.GetESignatureDashboardQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureDashboardQuery | undefined, GraphqlTypes.GetESignatureDashboardQueryVariables>;
export function useGetESignatureDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureDashboardQuery, GraphqlTypes.GetESignatureDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetESignatureDashboardQuery, GraphqlTypes.GetESignatureDashboardQueryVariables>(GetESignatureDashboardDocument, options);
        }
export type GetESignatureDashboardQueryHookResult = ReturnType<typeof useGetESignatureDashboardQuery>;
export type GetESignatureDashboardLazyQueryHookResult = ReturnType<typeof useGetESignatureDashboardLazyQuery>;
export type GetESignatureDashboardSuspenseQueryHookResult = ReturnType<typeof useGetESignatureDashboardSuspenseQuery>;
export type GetESignatureDashboardQueryResult = Apollo.QueryResult<GraphqlTypes.GetESignatureDashboardQuery, GraphqlTypes.GetESignatureDashboardQueryVariables>;
export const UpdateFieldAccessRolePermissionsDocument = gql`
    mutation UpdateFieldAccessRolePermissions($roleId: Int!, $rolePermissions: [FieldPermissionInputObject!]!) {
  fieldPermissionOps {
    updateFieldAccessRolePermissions(
      roleId: $roleId
      rolePermissions: $rolePermissions
    ) {
      roleId
      restrictionCount
      updatedPermissions {
        fieldAccessFieldId
        isEnabled
      }
    }
  }
}
    `;
export type UpdateFieldAccessRolePermissionsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateFieldAccessRolePermissionsMutation, GraphqlTypes.UpdateFieldAccessRolePermissionsMutationVariables>;

/**
 * __useUpdateFieldAccessRolePermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateFieldAccessRolePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFieldAccessRolePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFieldAccessRolePermissionsMutation, { data, loading, error }] = useUpdateFieldAccessRolePermissionsMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      rolePermissions: // value for 'rolePermissions'
 *   },
 * });
 */
export function useUpdateFieldAccessRolePermissionsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateFieldAccessRolePermissionsMutation, GraphqlTypes.UpdateFieldAccessRolePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateFieldAccessRolePermissionsMutation, GraphqlTypes.UpdateFieldAccessRolePermissionsMutationVariables>(UpdateFieldAccessRolePermissionsDocument, options);
      }
export type UpdateFieldAccessRolePermissionsMutationHookResult = ReturnType<typeof useUpdateFieldAccessRolePermissionsMutation>;
export type UpdateFieldAccessRolePermissionsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateFieldAccessRolePermissionsMutation>;
export type UpdateFieldAccessRolePermissionsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateFieldAccessRolePermissionsMutation, GraphqlTypes.UpdateFieldAccessRolePermissionsMutationVariables>;
export const GetDataAccessRoleDocument = gql`
    query GetDataAccessRole($roleId: Int!) {
  roleName(roleId: $roleId)
  roleUsageCount(roleId: $roleId)
  rolePermissions(roleId: $roleId) {
    fieldPermissions {
      fieldAccessFieldId
      fieldKey
      fieldName
      fieldGroup
      level
      isEnabled
    }
  }
}
    `;

/**
 * __useGetDataAccessRoleQuery__
 *
 * To run a query within a React component, call `useGetDataAccessRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataAccessRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataAccessRoleQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useGetDataAccessRoleQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDataAccessRoleQuery, GraphqlTypes.GetDataAccessRoleQueryVariables> & ({ variables: GraphqlTypes.GetDataAccessRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDataAccessRoleQuery, GraphqlTypes.GetDataAccessRoleQueryVariables>(GetDataAccessRoleDocument, options);
      }
export function useGetDataAccessRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDataAccessRoleQuery, GraphqlTypes.GetDataAccessRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDataAccessRoleQuery, GraphqlTypes.GetDataAccessRoleQueryVariables>(GetDataAccessRoleDocument, options);
        }
// @ts-ignore
export function useGetDataAccessRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataAccessRoleQuery, GraphqlTypes.GetDataAccessRoleQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataAccessRoleQuery, GraphqlTypes.GetDataAccessRoleQueryVariables>;
export function useGetDataAccessRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataAccessRoleQuery, GraphqlTypes.GetDataAccessRoleQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataAccessRoleQuery | undefined, GraphqlTypes.GetDataAccessRoleQueryVariables>;
export function useGetDataAccessRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataAccessRoleQuery, GraphqlTypes.GetDataAccessRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDataAccessRoleQuery, GraphqlTypes.GetDataAccessRoleQueryVariables>(GetDataAccessRoleDocument, options);
        }
export type GetDataAccessRoleQueryHookResult = ReturnType<typeof useGetDataAccessRoleQuery>;
export type GetDataAccessRoleLazyQueryHookResult = ReturnType<typeof useGetDataAccessRoleLazyQuery>;
export type GetDataAccessRoleSuspenseQueryHookResult = ReturnType<typeof useGetDataAccessRoleSuspenseQuery>;
export type GetDataAccessRoleQueryResult = Apollo.QueryResult<GraphqlTypes.GetDataAccessRoleQuery, GraphqlTypes.GetDataAccessRoleQueryVariables>;
export const CreateEditMoveFolderDocument = gql`
    mutation CreateEditMoveFolder($upsertFolderInput: UpsertFolderInput!) {
  upsertFolder(objectInput: $upsertFolderInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on DocumentFolder {
      ...OfferingDocumentFolderFields
      parent {
        id
        name
      }
    }
  }
}
    ${OfferingDocumentFolderFieldsFragmentDoc}`;
export type CreateEditMoveFolderMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateEditMoveFolderMutation, GraphqlTypes.CreateEditMoveFolderMutationVariables>;

/**
 * __useCreateEditMoveFolderMutation__
 *
 * To run a mutation, you first call `useCreateEditMoveFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEditMoveFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEditMoveFolderMutation, { data, loading, error }] = useCreateEditMoveFolderMutation({
 *   variables: {
 *      upsertFolderInput: // value for 'upsertFolderInput'
 *   },
 * });
 */
export function useCreateEditMoveFolderMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateEditMoveFolderMutation, GraphqlTypes.CreateEditMoveFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateEditMoveFolderMutation, GraphqlTypes.CreateEditMoveFolderMutationVariables>(CreateEditMoveFolderDocument, options);
      }
export type CreateEditMoveFolderMutationHookResult = ReturnType<typeof useCreateEditMoveFolderMutation>;
export type CreateEditMoveFolderMutationResult = Apollo.MutationResult<GraphqlTypes.CreateEditMoveFolderMutation>;
export type CreateEditMoveFolderMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateEditMoveFolderMutation, GraphqlTypes.CreateEditMoveFolderMutationVariables>;
export const DeleteFolderDocument = gql`
    mutation DeleteFolder($objectInput: DeleteFolderInput!) {
  deleteFolder(objectInput: $objectInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on DocumentFolder {
      id
      name
      state
    }
  }
}
    `;
export type DeleteFolderMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteFolderMutation, GraphqlTypes.DeleteFolderMutationVariables>;

/**
 * __useDeleteFolderMutation__
 *
 * To run a mutation, you first call `useDeleteFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderMutation, { data, loading, error }] = useDeleteFolderMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useDeleteFolderMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteFolderMutation, GraphqlTypes.DeleteFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteFolderMutation, GraphqlTypes.DeleteFolderMutationVariables>(DeleteFolderDocument, options);
      }
export type DeleteFolderMutationHookResult = ReturnType<typeof useDeleteFolderMutation>;
export type DeleteFolderMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteFolderMutation>;
export type DeleteFolderMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteFolderMutation, GraphqlTypes.DeleteFolderMutationVariables>;
export const UpdateFolderSharingSettingsDocument = gql`
    mutation UpdateFolderSharingSettings($objectInput: UpdateFolderSharingSettingsInput!) {
  updateFolderSharingSettings(objectInput: $objectInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on DocumentFolder {
      id
      name
      breadcrumb {
        id
        name
        sharedWithAllProspects: calculatedSharedWithAllProspects
        sharedWithProspectIds: calculatedSharedWithAllProspects
      }
    }
  }
}
    `;
export type UpdateFolderSharingSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateFolderSharingSettingsMutation, GraphqlTypes.UpdateFolderSharingSettingsMutationVariables>;

/**
 * __useUpdateFolderSharingSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateFolderSharingSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFolderSharingSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFolderSharingSettingsMutation, { data, loading, error }] = useUpdateFolderSharingSettingsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateFolderSharingSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateFolderSharingSettingsMutation, GraphqlTypes.UpdateFolderSharingSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateFolderSharingSettingsMutation, GraphqlTypes.UpdateFolderSharingSettingsMutationVariables>(UpdateFolderSharingSettingsDocument, options);
      }
export type UpdateFolderSharingSettingsMutationHookResult = ReturnType<typeof useUpdateFolderSharingSettingsMutation>;
export type UpdateFolderSharingSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateFolderSharingSettingsMutation>;
export type UpdateFolderSharingSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateFolderSharingSettingsMutation, GraphqlTypes.UpdateFolderSharingSettingsMutationVariables>;
export const MoveFolderDocumentDocument = gql`
    mutation MoveFolderDocument($objectInput: EditFolderDocumentFieldsInput!) {
  editFolderDocument(objectInput: $objectInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on FolderDocument {
      ...OfferingDocumentFields
    }
  }
}
    ${OfferingDocumentFieldsFragmentDoc}`;
export type MoveFolderDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.MoveFolderDocumentMutation, GraphqlTypes.MoveFolderDocumentMutationVariables>;

/**
 * __useMoveFolderDocumentMutation__
 *
 * To run a mutation, you first call `useMoveFolderDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFolderDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFolderDocumentMutation, { data, loading, error }] = useMoveFolderDocumentMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useMoveFolderDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.MoveFolderDocumentMutation, GraphqlTypes.MoveFolderDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.MoveFolderDocumentMutation, GraphqlTypes.MoveFolderDocumentMutationVariables>(MoveFolderDocumentDocument, options);
      }
export type MoveFolderDocumentMutationHookResult = ReturnType<typeof useMoveFolderDocumentMutation>;
export type MoveFolderDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.MoveFolderDocumentMutation>;
export type MoveFolderDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.MoveFolderDocumentMutation, GraphqlTypes.MoveFolderDocumentMutationVariables>;
export const CreateFolderDocumentDocument = gql`
    mutation CreateFolderDocument($objectInput: CreateFolderDocumentFieldsInput!) {
  createFolderDocument(objectInput: $objectInput) {
    ...CreateFolderDocumentFields
  }
}
    ${CreateFolderDocumentFieldsFragmentDoc}`;
export type CreateFolderDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateFolderDocumentMutation, GraphqlTypes.CreateFolderDocumentMutationVariables>;

/**
 * __useCreateFolderDocumentMutation__
 *
 * To run a mutation, you first call `useCreateFolderDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFolderDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFolderDocumentMutation, { data, loading, error }] = useCreateFolderDocumentMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useCreateFolderDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateFolderDocumentMutation, GraphqlTypes.CreateFolderDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateFolderDocumentMutation, GraphqlTypes.CreateFolderDocumentMutationVariables>(CreateFolderDocumentDocument, options);
      }
export type CreateFolderDocumentMutationHookResult = ReturnType<typeof useCreateFolderDocumentMutation>;
export type CreateFolderDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.CreateFolderDocumentMutation>;
export type CreateFolderDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateFolderDocumentMutation, GraphqlTypes.CreateFolderDocumentMutationVariables>;
export const UndeleteFolderDocument = gql`
    mutation UndeleteFolder($objectInput: UndeleteFolderInput!) {
  undeleteFolder(objectInput: $objectInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on DocumentFolder {
      id
      name
      state
    }
  }
}
    `;
export type UndeleteFolderMutationFn = Apollo.MutationFunction<GraphqlTypes.UndeleteFolderMutation, GraphqlTypes.UndeleteFolderMutationVariables>;

/**
 * __useUndeleteFolderMutation__
 *
 * To run a mutation, you first call `useUndeleteFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndeleteFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undeleteFolderMutation, { data, loading, error }] = useUndeleteFolderMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUndeleteFolderMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UndeleteFolderMutation, GraphqlTypes.UndeleteFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UndeleteFolderMutation, GraphqlTypes.UndeleteFolderMutationVariables>(UndeleteFolderDocument, options);
      }
export type UndeleteFolderMutationHookResult = ReturnType<typeof useUndeleteFolderMutation>;
export type UndeleteFolderMutationResult = Apollo.MutationResult<GraphqlTypes.UndeleteFolderMutation>;
export type UndeleteFolderMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UndeleteFolderMutation, GraphqlTypes.UndeleteFolderMutationVariables>;
export const GetProspectsByOfferingDocument = gql`
    query GetProspectsByOffering($offeringId: ID!, $term: String!) {
  searchProspectsByOffering(offeringId: $offeringId, term: $term) {
    count
    edges {
      node {
        __typename
        id
        name: title
        contacts {
          count
          edges {
            node {
              id
              contactType
              fullName
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProspectsByOfferingQuery__
 *
 * To run a query within a React component, call `useGetProspectsByOfferingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProspectsByOfferingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProspectsByOfferingQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useGetProspectsByOfferingQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProspectsByOfferingQuery, GraphqlTypes.GetProspectsByOfferingQueryVariables> & ({ variables: GraphqlTypes.GetProspectsByOfferingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProspectsByOfferingQuery, GraphqlTypes.GetProspectsByOfferingQueryVariables>(GetProspectsByOfferingDocument, options);
      }
export function useGetProspectsByOfferingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProspectsByOfferingQuery, GraphqlTypes.GetProspectsByOfferingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProspectsByOfferingQuery, GraphqlTypes.GetProspectsByOfferingQueryVariables>(GetProspectsByOfferingDocument, options);
        }
// @ts-ignore
export function useGetProspectsByOfferingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectsByOfferingQuery, GraphqlTypes.GetProspectsByOfferingQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProspectsByOfferingQuery, GraphqlTypes.GetProspectsByOfferingQueryVariables>;
export function useGetProspectsByOfferingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectsByOfferingQuery, GraphqlTypes.GetProspectsByOfferingQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProspectsByOfferingQuery | undefined, GraphqlTypes.GetProspectsByOfferingQueryVariables>;
export function useGetProspectsByOfferingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectsByOfferingQuery, GraphqlTypes.GetProspectsByOfferingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProspectsByOfferingQuery, GraphqlTypes.GetProspectsByOfferingQueryVariables>(GetProspectsByOfferingDocument, options);
        }
export type GetProspectsByOfferingQueryHookResult = ReturnType<typeof useGetProspectsByOfferingQuery>;
export type GetProspectsByOfferingLazyQueryHookResult = ReturnType<typeof useGetProspectsByOfferingLazyQuery>;
export type GetProspectsByOfferingSuspenseQueryHookResult = ReturnType<typeof useGetProspectsByOfferingSuspenseQuery>;
export type GetProspectsByOfferingQueryResult = Apollo.QueryResult<GraphqlTypes.GetProspectsByOfferingQuery, GraphqlTypes.GetProspectsByOfferingQueryVariables>;
export const GetOfferingFolderDocumentsDocument = gql`
    query GetOfferingFolderDocuments($id: ID!, $relativeRootFolderId: Int) {
  offering(id: $id) {
    id
    name
    documentFolder(folderId: $relativeRootFolderId, includeDeleted: true) {
      ...OfferingDocumentFolderFields
    }
  }
}
    ${OfferingDocumentFolderFieldsFragmentDoc}`;

/**
 * __useGetOfferingFolderDocumentsQuery__
 *
 * To run a query within a React component, call `useGetOfferingFolderDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferingFolderDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferingFolderDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      relativeRootFolderId: // value for 'relativeRootFolderId'
 *   },
 * });
 */
export function useGetOfferingFolderDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOfferingFolderDocumentsQuery, GraphqlTypes.GetOfferingFolderDocumentsQueryVariables> & ({ variables: GraphqlTypes.GetOfferingFolderDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOfferingFolderDocumentsQuery, GraphqlTypes.GetOfferingFolderDocumentsQueryVariables>(GetOfferingFolderDocumentsDocument, options);
      }
export function useGetOfferingFolderDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOfferingFolderDocumentsQuery, GraphqlTypes.GetOfferingFolderDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOfferingFolderDocumentsQuery, GraphqlTypes.GetOfferingFolderDocumentsQueryVariables>(GetOfferingFolderDocumentsDocument, options);
        }
// @ts-ignore
export function useGetOfferingFolderDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingFolderDocumentsQuery, GraphqlTypes.GetOfferingFolderDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOfferingFolderDocumentsQuery, GraphqlTypes.GetOfferingFolderDocumentsQueryVariables>;
export function useGetOfferingFolderDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingFolderDocumentsQuery, GraphqlTypes.GetOfferingFolderDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOfferingFolderDocumentsQuery | undefined, GraphqlTypes.GetOfferingFolderDocumentsQueryVariables>;
export function useGetOfferingFolderDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingFolderDocumentsQuery, GraphqlTypes.GetOfferingFolderDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOfferingFolderDocumentsQuery, GraphqlTypes.GetOfferingFolderDocumentsQueryVariables>(GetOfferingFolderDocumentsDocument, options);
        }
export type GetOfferingFolderDocumentsQueryHookResult = ReturnType<typeof useGetOfferingFolderDocumentsQuery>;
export type GetOfferingFolderDocumentsLazyQueryHookResult = ReturnType<typeof useGetOfferingFolderDocumentsLazyQuery>;
export type GetOfferingFolderDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetOfferingFolderDocumentsSuspenseQuery>;
export type GetOfferingFolderDocumentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetOfferingFolderDocumentsQuery, GraphqlTypes.GetOfferingFolderDocumentsQueryVariables>;
export const GetDocumentFolderSortingFeatureFlagDocument = gql`
    query GetDocumentFolderSortingFeatureFlag {
  devFeatures {
    documentFolderSorting
  }
}
    `;

/**
 * __useGetDocumentFolderSortingFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetDocumentFolderSortingFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentFolderSortingFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentFolderSortingFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDocumentFolderSortingFeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentFolderSortingFeatureFlagQuery, GraphqlTypes.GetDocumentFolderSortingFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentFolderSortingFeatureFlagQuery, GraphqlTypes.GetDocumentFolderSortingFeatureFlagQueryVariables>(GetDocumentFolderSortingFeatureFlagDocument, options);
      }
export function useGetDocumentFolderSortingFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentFolderSortingFeatureFlagQuery, GraphqlTypes.GetDocumentFolderSortingFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentFolderSortingFeatureFlagQuery, GraphqlTypes.GetDocumentFolderSortingFeatureFlagQueryVariables>(GetDocumentFolderSortingFeatureFlagDocument, options);
        }
// @ts-ignore
export function useGetDocumentFolderSortingFeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentFolderSortingFeatureFlagQuery, GraphqlTypes.GetDocumentFolderSortingFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentFolderSortingFeatureFlagQuery, GraphqlTypes.GetDocumentFolderSortingFeatureFlagQueryVariables>;
export function useGetDocumentFolderSortingFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentFolderSortingFeatureFlagQuery, GraphqlTypes.GetDocumentFolderSortingFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentFolderSortingFeatureFlagQuery | undefined, GraphqlTypes.GetDocumentFolderSortingFeatureFlagQueryVariables>;
export function useGetDocumentFolderSortingFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentFolderSortingFeatureFlagQuery, GraphqlTypes.GetDocumentFolderSortingFeatureFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentFolderSortingFeatureFlagQuery, GraphqlTypes.GetDocumentFolderSortingFeatureFlagQueryVariables>(GetDocumentFolderSortingFeatureFlagDocument, options);
        }
export type GetDocumentFolderSortingFeatureFlagQueryHookResult = ReturnType<typeof useGetDocumentFolderSortingFeatureFlagQuery>;
export type GetDocumentFolderSortingFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetDocumentFolderSortingFeatureFlagLazyQuery>;
export type GetDocumentFolderSortingFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetDocumentFolderSortingFeatureFlagSuspenseQuery>;
export type GetDocumentFolderSortingFeatureFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentFolderSortingFeatureFlagQuery, GraphqlTypes.GetDocumentFolderSortingFeatureFlagQueryVariables>;
export const GetUserManageOfferingsPermissionsDocument = gql`
    query GetUserManageOfferingsPermissions($globalOfferingId: String) {
  userPermissions {
    canManageOffering(globalOfferingId: $globalOfferingId)
  }
}
    `;

/**
 * __useGetUserManageOfferingsPermissionsQuery__
 *
 * To run a query within a React component, call `useGetUserManageOfferingsPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserManageOfferingsPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserManageOfferingsPermissionsQuery({
 *   variables: {
 *      globalOfferingId: // value for 'globalOfferingId'
 *   },
 * });
 */
export function useGetUserManageOfferingsPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetUserManageOfferingsPermissionsQuery, GraphqlTypes.GetUserManageOfferingsPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUserManageOfferingsPermissionsQuery, GraphqlTypes.GetUserManageOfferingsPermissionsQueryVariables>(GetUserManageOfferingsPermissionsDocument, options);
      }
export function useGetUserManageOfferingsPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUserManageOfferingsPermissionsQuery, GraphqlTypes.GetUserManageOfferingsPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUserManageOfferingsPermissionsQuery, GraphqlTypes.GetUserManageOfferingsPermissionsQueryVariables>(GetUserManageOfferingsPermissionsDocument, options);
        }
// @ts-ignore
export function useGetUserManageOfferingsPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserManageOfferingsPermissionsQuery, GraphqlTypes.GetUserManageOfferingsPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserManageOfferingsPermissionsQuery, GraphqlTypes.GetUserManageOfferingsPermissionsQueryVariables>;
export function useGetUserManageOfferingsPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserManageOfferingsPermissionsQuery, GraphqlTypes.GetUserManageOfferingsPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserManageOfferingsPermissionsQuery | undefined, GraphqlTypes.GetUserManageOfferingsPermissionsQueryVariables>;
export function useGetUserManageOfferingsPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserManageOfferingsPermissionsQuery, GraphqlTypes.GetUserManageOfferingsPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUserManageOfferingsPermissionsQuery, GraphqlTypes.GetUserManageOfferingsPermissionsQueryVariables>(GetUserManageOfferingsPermissionsDocument, options);
        }
export type GetUserManageOfferingsPermissionsQueryHookResult = ReturnType<typeof useGetUserManageOfferingsPermissionsQuery>;
export type GetUserManageOfferingsPermissionsLazyQueryHookResult = ReturnType<typeof useGetUserManageOfferingsPermissionsLazyQuery>;
export type GetUserManageOfferingsPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetUserManageOfferingsPermissionsSuspenseQuery>;
export type GetUserManageOfferingsPermissionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetUserManageOfferingsPermissionsQuery, GraphqlTypes.GetUserManageOfferingsPermissionsQueryVariables>;
export const GetGpEmailDocument = gql`
    query GetGpEmail($id: ID!) {
  email(id: $id) {
    id
    subject
    dateSent
    bodyHtml
    senderName
    senderEmailAddress
    sendFailed
    recipients {
      edges {
        node {
          id
          name
          emailAddress
          recipientType
          contactId
          firstOpened
          dateSent
          lastError
          deliverStatusCode
          deliverStatusMessage
        }
      }
    }
  }
}
    `;

/**
 * __useGetGpEmailQuery__
 *
 * To run a query within a React component, call `useGetGpEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpEmailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGpEmailQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetGpEmailQuery, GraphqlTypes.GetGpEmailQueryVariables> & ({ variables: GraphqlTypes.GetGpEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGpEmailQuery, GraphqlTypes.GetGpEmailQueryVariables>(GetGpEmailDocument, options);
      }
export function useGetGpEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGpEmailQuery, GraphqlTypes.GetGpEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGpEmailQuery, GraphqlTypes.GetGpEmailQueryVariables>(GetGpEmailDocument, options);
        }
// @ts-ignore
export function useGetGpEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpEmailQuery, GraphqlTypes.GetGpEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpEmailQuery, GraphqlTypes.GetGpEmailQueryVariables>;
export function useGetGpEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpEmailQuery, GraphqlTypes.GetGpEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpEmailQuery | undefined, GraphqlTypes.GetGpEmailQueryVariables>;
export function useGetGpEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpEmailQuery, GraphqlTypes.GetGpEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGpEmailQuery, GraphqlTypes.GetGpEmailQueryVariables>(GetGpEmailDocument, options);
        }
export type GetGpEmailQueryHookResult = ReturnType<typeof useGetGpEmailQuery>;
export type GetGpEmailLazyQueryHookResult = ReturnType<typeof useGetGpEmailLazyQuery>;
export type GetGpEmailSuspenseQueryHookResult = ReturnType<typeof useGetGpEmailSuspenseQuery>;
export type GetGpEmailQueryResult = Apollo.QueryResult<GraphqlTypes.GetGpEmailQuery, GraphqlTypes.GetGpEmailQueryVariables>;
export const GetProspectFolderDocumentsDocument = gql`
    query GetProspectFolderDocuments($id: ID!, $relativeRootFolderId: Int) {
  prospect(id: $id) {
    id
    documentFolder(folderId: $relativeRootFolderId) {
      ...ProspectDocumentFolderFields
    }
  }
}
    ${ProspectDocumentFolderFieldsFragmentDoc}`;

/**
 * __useGetProspectFolderDocumentsQuery__
 *
 * To run a query within a React component, call `useGetProspectFolderDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProspectFolderDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProspectFolderDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      relativeRootFolderId: // value for 'relativeRootFolderId'
 *   },
 * });
 */
export function useGetProspectFolderDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProspectFolderDocumentsQuery, GraphqlTypes.GetProspectFolderDocumentsQueryVariables> & ({ variables: GraphqlTypes.GetProspectFolderDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProspectFolderDocumentsQuery, GraphqlTypes.GetProspectFolderDocumentsQueryVariables>(GetProspectFolderDocumentsDocument, options);
      }
export function useGetProspectFolderDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProspectFolderDocumentsQuery, GraphqlTypes.GetProspectFolderDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProspectFolderDocumentsQuery, GraphqlTypes.GetProspectFolderDocumentsQueryVariables>(GetProspectFolderDocumentsDocument, options);
        }
// @ts-ignore
export function useGetProspectFolderDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectFolderDocumentsQuery, GraphqlTypes.GetProspectFolderDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProspectFolderDocumentsQuery, GraphqlTypes.GetProspectFolderDocumentsQueryVariables>;
export function useGetProspectFolderDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectFolderDocumentsQuery, GraphqlTypes.GetProspectFolderDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProspectFolderDocumentsQuery | undefined, GraphqlTypes.GetProspectFolderDocumentsQueryVariables>;
export function useGetProspectFolderDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectFolderDocumentsQuery, GraphqlTypes.GetProspectFolderDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProspectFolderDocumentsQuery, GraphqlTypes.GetProspectFolderDocumentsQueryVariables>(GetProspectFolderDocumentsDocument, options);
        }
export type GetProspectFolderDocumentsQueryHookResult = ReturnType<typeof useGetProspectFolderDocumentsQuery>;
export type GetProspectFolderDocumentsLazyQueryHookResult = ReturnType<typeof useGetProspectFolderDocumentsLazyQuery>;
export type GetProspectFolderDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetProspectFolderDocumentsSuspenseQuery>;
export type GetProspectFolderDocumentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetProspectFolderDocumentsQuery, GraphqlTypes.GetProspectFolderDocumentsQueryVariables>;
export const GetContactsByTermDocument = gql`
    query GetContactsByTerm($term: String!, $first: Int, $objectFilter: ObjectFilter) {
  searchContacts(term: $term, first: $first, objectFilter: $objectFilter) {
    edges {
      node {
        id
        firstName
        lastName
        fullName
        salutationName
        portalIsActivated
        emails {
          id
          emailType
          emailAddress
        }
        primaryEmail {
          emailAddress
        }
        phones {
          id
          phoneType
          phoneNumber
        }
        addresses {
          id
          addressType
          street
          street2
          street3
          region
          city
          state {
            objectName
          }
          postalCode
          country {
            objectName
          }
        }
        pastEmployments {
          id
          employer {
            id
            fullName
          }
          employerName
          jobTitle
        }
        companyName
        company {
          id
          fullName
        }
        jobTitle
        accounts {
          id
          accountContactMaps {
            accountId
            contactId
            communicationPrefs {
              emailDistributionList {
                name
                id
              }
            }
            isMainContact
            isAdminContact
            label {
              labelText
              id
            }
          }
        }
      }
    }
    count
  }
}
    `;

/**
 * __useGetContactsByTermQuery__
 *
 * To run a query within a React component, call `useGetContactsByTermQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsByTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsByTermQuery({
 *   variables: {
 *      term: // value for 'term'
 *      first: // value for 'first'
 *      objectFilter: // value for 'objectFilter'
 *   },
 * });
 */
export function useGetContactsByTermQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactsByTermQuery, GraphqlTypes.GetContactsByTermQueryVariables> & ({ variables: GraphqlTypes.GetContactsByTermQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactsByTermQuery, GraphqlTypes.GetContactsByTermQueryVariables>(GetContactsByTermDocument, options);
      }
export function useGetContactsByTermLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactsByTermQuery, GraphqlTypes.GetContactsByTermQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactsByTermQuery, GraphqlTypes.GetContactsByTermQueryVariables>(GetContactsByTermDocument, options);
        }
// @ts-ignore
export function useGetContactsByTermSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsByTermQuery, GraphqlTypes.GetContactsByTermQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsByTermQuery, GraphqlTypes.GetContactsByTermQueryVariables>;
export function useGetContactsByTermSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsByTermQuery, GraphqlTypes.GetContactsByTermQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsByTermQuery | undefined, GraphqlTypes.GetContactsByTermQueryVariables>;
export function useGetContactsByTermSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsByTermQuery, GraphqlTypes.GetContactsByTermQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactsByTermQuery, GraphqlTypes.GetContactsByTermQueryVariables>(GetContactsByTermDocument, options);
        }
export type GetContactsByTermQueryHookResult = ReturnType<typeof useGetContactsByTermQuery>;
export type GetContactsByTermLazyQueryHookResult = ReturnType<typeof useGetContactsByTermLazyQuery>;
export type GetContactsByTermSuspenseQueryHookResult = ReturnType<typeof useGetContactsByTermSuspenseQuery>;
export type GetContactsByTermQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactsByTermQuery, GraphqlTypes.GetContactsByTermQueryVariables>;
export const GetCompanyByTermDocument = gql`
    query GetCompanyByTerm($term: String!, $first: Int, $objectFilter: ObjectFilter) {
  searchContacts(term: $term, first: $first, objectFilter: $objectFilter) {
    edges {
      node {
        id
        fullName
      }
    }
    count
  }
}
    `;

/**
 * __useGetCompanyByTermQuery__
 *
 * To run a query within a React component, call `useGetCompanyByTermQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyByTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyByTermQuery({
 *   variables: {
 *      term: // value for 'term'
 *      first: // value for 'first'
 *      objectFilter: // value for 'objectFilter'
 *   },
 * });
 */
export function useGetCompanyByTermQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCompanyByTermQuery, GraphqlTypes.GetCompanyByTermQueryVariables> & ({ variables: GraphqlTypes.GetCompanyByTermQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCompanyByTermQuery, GraphqlTypes.GetCompanyByTermQueryVariables>(GetCompanyByTermDocument, options);
      }
export function useGetCompanyByTermLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCompanyByTermQuery, GraphqlTypes.GetCompanyByTermQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCompanyByTermQuery, GraphqlTypes.GetCompanyByTermQueryVariables>(GetCompanyByTermDocument, options);
        }
// @ts-ignore
export function useGetCompanyByTermSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCompanyByTermQuery, GraphqlTypes.GetCompanyByTermQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCompanyByTermQuery, GraphqlTypes.GetCompanyByTermQueryVariables>;
export function useGetCompanyByTermSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCompanyByTermQuery, GraphqlTypes.GetCompanyByTermQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCompanyByTermQuery | undefined, GraphqlTypes.GetCompanyByTermQueryVariables>;
export function useGetCompanyByTermSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCompanyByTermQuery, GraphqlTypes.GetCompanyByTermQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCompanyByTermQuery, GraphqlTypes.GetCompanyByTermQueryVariables>(GetCompanyByTermDocument, options);
        }
export type GetCompanyByTermQueryHookResult = ReturnType<typeof useGetCompanyByTermQuery>;
export type GetCompanyByTermLazyQueryHookResult = ReturnType<typeof useGetCompanyByTermLazyQuery>;
export type GetCompanyByTermSuspenseQueryHookResult = ReturnType<typeof useGetCompanyByTermSuspenseQuery>;
export type GetCompanyByTermQueryResult = Apollo.QueryResult<GraphqlTypes.GetCompanyByTermQuery, GraphqlTypes.GetCompanyByTermQueryVariables>;
export const GetUserContactPermissionsDocument = gql`
    query GetUserContactPermissions {
  userPermissions {
    canViewContactGroups
  }
}
    `;

/**
 * __useGetUserContactPermissionsQuery__
 *
 * To run a query within a React component, call `useGetUserContactPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserContactPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserContactPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserContactPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetUserContactPermissionsQuery, GraphqlTypes.GetUserContactPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUserContactPermissionsQuery, GraphqlTypes.GetUserContactPermissionsQueryVariables>(GetUserContactPermissionsDocument, options);
      }
export function useGetUserContactPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUserContactPermissionsQuery, GraphqlTypes.GetUserContactPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUserContactPermissionsQuery, GraphqlTypes.GetUserContactPermissionsQueryVariables>(GetUserContactPermissionsDocument, options);
        }
// @ts-ignore
export function useGetUserContactPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserContactPermissionsQuery, GraphqlTypes.GetUserContactPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserContactPermissionsQuery, GraphqlTypes.GetUserContactPermissionsQueryVariables>;
export function useGetUserContactPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserContactPermissionsQuery, GraphqlTypes.GetUserContactPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserContactPermissionsQuery | undefined, GraphqlTypes.GetUserContactPermissionsQueryVariables>;
export function useGetUserContactPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserContactPermissionsQuery, GraphqlTypes.GetUserContactPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUserContactPermissionsQuery, GraphqlTypes.GetUserContactPermissionsQueryVariables>(GetUserContactPermissionsDocument, options);
        }
export type GetUserContactPermissionsQueryHookResult = ReturnType<typeof useGetUserContactPermissionsQuery>;
export type GetUserContactPermissionsLazyQueryHookResult = ReturnType<typeof useGetUserContactPermissionsLazyQuery>;
export type GetUserContactPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetUserContactPermissionsSuspenseQuery>;
export type GetUserContactPermissionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetUserContactPermissionsQuery, GraphqlTypes.GetUserContactPermissionsQueryVariables>;
export const UploadAssistedTemplateDocument = gql`
    mutation UploadAssistedTemplate($encodedFiles: [EncodedFileInput!]!) {
  uploadAssistedTemplateOps {
    uploadAssistedTemplate(encodedFiles: $encodedFiles) {
      success
    }
  }
}
    `;
export type UploadAssistedTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.UploadAssistedTemplateMutation, GraphqlTypes.UploadAssistedTemplateMutationVariables>;

/**
 * __useUploadAssistedTemplateMutation__
 *
 * To run a mutation, you first call `useUploadAssistedTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAssistedTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAssistedTemplateMutation, { data, loading, error }] = useUploadAssistedTemplateMutation({
 *   variables: {
 *      encodedFiles: // value for 'encodedFiles'
 *   },
 * });
 */
export function useUploadAssistedTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UploadAssistedTemplateMutation, GraphqlTypes.UploadAssistedTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UploadAssistedTemplateMutation, GraphqlTypes.UploadAssistedTemplateMutationVariables>(UploadAssistedTemplateDocument, options);
      }
export type UploadAssistedTemplateMutationHookResult = ReturnType<typeof useUploadAssistedTemplateMutation>;
export type UploadAssistedTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.UploadAssistedTemplateMutation>;
export type UploadAssistedTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UploadAssistedTemplateMutation, GraphqlTypes.UploadAssistedTemplateMutationVariables>;
export const GetReportingStatusDocument = gql`
    query GetReportingStatus {
  objectGroups(authorizedClass: entity) {
    edges {
      node {
        id
        title
        isReadyForReporting
        minimumReportingPeriod
      }
    }
  }
}
    `;

/**
 * __useGetReportingStatusQuery__
 *
 * To run a query within a React component, call `useGetReportingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportingStatusQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetReportingStatusQuery, GraphqlTypes.GetReportingStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReportingStatusQuery, GraphqlTypes.GetReportingStatusQueryVariables>(GetReportingStatusDocument, options);
      }
export function useGetReportingStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReportingStatusQuery, GraphqlTypes.GetReportingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReportingStatusQuery, GraphqlTypes.GetReportingStatusQueryVariables>(GetReportingStatusDocument, options);
        }
// @ts-ignore
export function useGetReportingStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingStatusQuery, GraphqlTypes.GetReportingStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportingStatusQuery, GraphqlTypes.GetReportingStatusQueryVariables>;
export function useGetReportingStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingStatusQuery, GraphqlTypes.GetReportingStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportingStatusQuery | undefined, GraphqlTypes.GetReportingStatusQueryVariables>;
export function useGetReportingStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingStatusQuery, GraphqlTypes.GetReportingStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReportingStatusQuery, GraphqlTypes.GetReportingStatusQueryVariables>(GetReportingStatusDocument, options);
        }
export type GetReportingStatusQueryHookResult = ReturnType<typeof useGetReportingStatusQuery>;
export type GetReportingStatusLazyQueryHookResult = ReturnType<typeof useGetReportingStatusLazyQuery>;
export type GetReportingStatusSuspenseQueryHookResult = ReturnType<typeof useGetReportingStatusSuspenseQuery>;
export type GetReportingStatusQueryResult = Apollo.QueryResult<GraphqlTypes.GetReportingStatusQuery, GraphqlTypes.GetReportingStatusQueryVariables>;
export const FinishUpReportingDocument = gql`
    mutation FinishUpReporting($entityGroupId: ID!, $currentReportingPeriod: Period!) {
  finishUpOps {
    finishUpReporting(
      entityGroupId: $entityGroupId
      currentReportingPeriod: $currentReportingPeriod
    ) {
      success
    }
  }
}
    `;
export type FinishUpReportingMutationFn = Apollo.MutationFunction<GraphqlTypes.FinishUpReportingMutation, GraphqlTypes.FinishUpReportingMutationVariables>;

/**
 * __useFinishUpReportingMutation__
 *
 * To run a mutation, you first call `useFinishUpReportingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishUpReportingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishUpReportingMutation, { data, loading, error }] = useFinishUpReportingMutation({
 *   variables: {
 *      entityGroupId: // value for 'entityGroupId'
 *      currentReportingPeriod: // value for 'currentReportingPeriod'
 *   },
 * });
 */
export function useFinishUpReportingMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FinishUpReportingMutation, GraphqlTypes.FinishUpReportingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FinishUpReportingMutation, GraphqlTypes.FinishUpReportingMutationVariables>(FinishUpReportingDocument, options);
      }
export type FinishUpReportingMutationHookResult = ReturnType<typeof useFinishUpReportingMutation>;
export type FinishUpReportingMutationResult = Apollo.MutationResult<GraphqlTypes.FinishUpReportingMutation>;
export type FinishUpReportingMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FinishUpReportingMutation, GraphqlTypes.FinishUpReportingMutationVariables>;
export const GetReportingPeriodSummaryDocument = gql`
    query GetReportingPeriodSummary($entityGroupId: ID!, $period: Period!) {
  reportingPeriodSummary(entityGroupId: $entityGroupId, period: $period) {
    haveUnpublishedTransactions
    entityStatuses {
      id
      name
      assetsUpdated
      transactionsUpdated
      isReportingComplete
    }
  }
}
    `;

/**
 * __useGetReportingPeriodSummaryQuery__
 *
 * To run a query within a React component, call `useGetReportingPeriodSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingPeriodSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingPeriodSummaryQuery({
 *   variables: {
 *      entityGroupId: // value for 'entityGroupId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetReportingPeriodSummaryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetReportingPeriodSummaryQuery, GraphqlTypes.GetReportingPeriodSummaryQueryVariables> & ({ variables: GraphqlTypes.GetReportingPeriodSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReportingPeriodSummaryQuery, GraphqlTypes.GetReportingPeriodSummaryQueryVariables>(GetReportingPeriodSummaryDocument, options);
      }
export function useGetReportingPeriodSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReportingPeriodSummaryQuery, GraphqlTypes.GetReportingPeriodSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReportingPeriodSummaryQuery, GraphqlTypes.GetReportingPeriodSummaryQueryVariables>(GetReportingPeriodSummaryDocument, options);
        }
// @ts-ignore
export function useGetReportingPeriodSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingPeriodSummaryQuery, GraphqlTypes.GetReportingPeriodSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportingPeriodSummaryQuery, GraphqlTypes.GetReportingPeriodSummaryQueryVariables>;
export function useGetReportingPeriodSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingPeriodSummaryQuery, GraphqlTypes.GetReportingPeriodSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportingPeriodSummaryQuery | undefined, GraphqlTypes.GetReportingPeriodSummaryQueryVariables>;
export function useGetReportingPeriodSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingPeriodSummaryQuery, GraphqlTypes.GetReportingPeriodSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReportingPeriodSummaryQuery, GraphqlTypes.GetReportingPeriodSummaryQueryVariables>(GetReportingPeriodSummaryDocument, options);
        }
export type GetReportingPeriodSummaryQueryHookResult = ReturnType<typeof useGetReportingPeriodSummaryQuery>;
export type GetReportingPeriodSummaryLazyQueryHookResult = ReturnType<typeof useGetReportingPeriodSummaryLazyQuery>;
export type GetReportingPeriodSummarySuspenseQueryHookResult = ReturnType<typeof useGetReportingPeriodSummarySuspenseQuery>;
export type GetReportingPeriodSummaryQueryResult = Apollo.QueryResult<GraphqlTypes.GetReportingPeriodSummaryQuery, GraphqlTypes.GetReportingPeriodSummaryQueryVariables>;
export const UpdateAllEntitiesDocument = gql`
    mutation UpdateAllEntities($entityGroupId: ID!) {
  uploadEntityOps {
    markEntitiesUpdated(entityGroupId: $entityGroupId) {
      success
    }
  }
}
    `;
export type UpdateAllEntitiesMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateAllEntitiesMutation, GraphqlTypes.UpdateAllEntitiesMutationVariables>;

/**
 * __useUpdateAllEntitiesMutation__
 *
 * To run a mutation, you first call `useUpdateAllEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllEntitiesMutation, { data, loading, error }] = useUpdateAllEntitiesMutation({
 *   variables: {
 *      entityGroupId: // value for 'entityGroupId'
 *   },
 * });
 */
export function useUpdateAllEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateAllEntitiesMutation, GraphqlTypes.UpdateAllEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateAllEntitiesMutation, GraphqlTypes.UpdateAllEntitiesMutationVariables>(UpdateAllEntitiesDocument, options);
      }
export type UpdateAllEntitiesMutationHookResult = ReturnType<typeof useUpdateAllEntitiesMutation>;
export type UpdateAllEntitiesMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateAllEntitiesMutation>;
export type UpdateAllEntitiesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateAllEntitiesMutation, GraphqlTypes.UpdateAllEntitiesMutationVariables>;
export const GetShortReportingSummaryDocument = gql`
    query GetShortReportingSummary {
  objectGroups(authorizedClass: entity) {
    edges {
      node {
        id
        title
        investmentEntities(investorOwnedOnly: true) {
          edges {
            node {
              id
              name
              reportingPeriod
              canEdit
              createdAt
              status
              assetsIndirect {
                edges {
                  node {
                    id
                    name
                    canEdit
                    dateSold
                    isSold
                    createdAt
                    entityId
                  }
                }
              }
              owningInvestorPositionsDeprecated {
                id
                account {
                  id
                  name
                }
                activeInOwnReportingPeriod
                reportRequestType
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetShortReportingSummaryQuery__
 *
 * To run a query within a React component, call `useGetShortReportingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShortReportingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShortReportingSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShortReportingSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetShortReportingSummaryQuery, GraphqlTypes.GetShortReportingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetShortReportingSummaryQuery, GraphqlTypes.GetShortReportingSummaryQueryVariables>(GetShortReportingSummaryDocument, options);
      }
export function useGetShortReportingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetShortReportingSummaryQuery, GraphqlTypes.GetShortReportingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetShortReportingSummaryQuery, GraphqlTypes.GetShortReportingSummaryQueryVariables>(GetShortReportingSummaryDocument, options);
        }
// @ts-ignore
export function useGetShortReportingSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetShortReportingSummaryQuery, GraphqlTypes.GetShortReportingSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetShortReportingSummaryQuery, GraphqlTypes.GetShortReportingSummaryQueryVariables>;
export function useGetShortReportingSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetShortReportingSummaryQuery, GraphqlTypes.GetShortReportingSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetShortReportingSummaryQuery | undefined, GraphqlTypes.GetShortReportingSummaryQueryVariables>;
export function useGetShortReportingSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetShortReportingSummaryQuery, GraphqlTypes.GetShortReportingSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetShortReportingSummaryQuery, GraphqlTypes.GetShortReportingSummaryQueryVariables>(GetShortReportingSummaryDocument, options);
        }
export type GetShortReportingSummaryQueryHookResult = ReturnType<typeof useGetShortReportingSummaryQuery>;
export type GetShortReportingSummaryLazyQueryHookResult = ReturnType<typeof useGetShortReportingSummaryLazyQuery>;
export type GetShortReportingSummarySuspenseQueryHookResult = ReturnType<typeof useGetShortReportingSummarySuspenseQuery>;
export type GetShortReportingSummaryQueryResult = Apollo.QueryResult<GraphqlTypes.GetShortReportingSummaryQuery, GraphqlTypes.GetShortReportingSummaryQueryVariables>;
export const GetEntityGroupPeriodDocument = gql`
    query GetEntityGroupPeriod($entityGroupId: ID!) {
  objectGroup(authorizedClass: entity, id: $entityGroupId) {
    id
    minimumReportingPeriod
  }
}
    `;

/**
 * __useGetEntityGroupPeriodQuery__
 *
 * To run a query within a React component, call `useGetEntityGroupPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityGroupPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityGroupPeriodQuery({
 *   variables: {
 *      entityGroupId: // value for 'entityGroupId'
 *   },
 * });
 */
export function useGetEntityGroupPeriodQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityGroupPeriodQuery, GraphqlTypes.GetEntityGroupPeriodQueryVariables> & ({ variables: GraphqlTypes.GetEntityGroupPeriodQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityGroupPeriodQuery, GraphqlTypes.GetEntityGroupPeriodQueryVariables>(GetEntityGroupPeriodDocument, options);
      }
export function useGetEntityGroupPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityGroupPeriodQuery, GraphqlTypes.GetEntityGroupPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityGroupPeriodQuery, GraphqlTypes.GetEntityGroupPeriodQueryVariables>(GetEntityGroupPeriodDocument, options);
        }
// @ts-ignore
export function useGetEntityGroupPeriodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityGroupPeriodQuery, GraphqlTypes.GetEntityGroupPeriodQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityGroupPeriodQuery, GraphqlTypes.GetEntityGroupPeriodQueryVariables>;
export function useGetEntityGroupPeriodSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityGroupPeriodQuery, GraphqlTypes.GetEntityGroupPeriodQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityGroupPeriodQuery | undefined, GraphqlTypes.GetEntityGroupPeriodQueryVariables>;
export function useGetEntityGroupPeriodSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityGroupPeriodQuery, GraphqlTypes.GetEntityGroupPeriodQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityGroupPeriodQuery, GraphqlTypes.GetEntityGroupPeriodQueryVariables>(GetEntityGroupPeriodDocument, options);
        }
export type GetEntityGroupPeriodQueryHookResult = ReturnType<typeof useGetEntityGroupPeriodQuery>;
export type GetEntityGroupPeriodLazyQueryHookResult = ReturnType<typeof useGetEntityGroupPeriodLazyQuery>;
export type GetEntityGroupPeriodSuspenseQueryHookResult = ReturnType<typeof useGetEntityGroupPeriodSuspenseQuery>;
export type GetEntityGroupPeriodQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityGroupPeriodQuery, GraphqlTypes.GetEntityGroupPeriodQueryVariables>;
export const GetSingleEntityGroupDocument = gql`
    query GetSingleEntityGroup($period: Period!, $entityGroupId: ID!) {
  objectGroup(authorizedClass: entity, id: $entityGroupId) {
    id
    title
    isReadyForReporting
    minimumReportingPeriod
    investmentEntities(investorOwnedOnly: true) {
      edges {
        node {
          id
          name
          reportingPeriod
          canEdit
          updatedInReportingPeriod(period: $period)
          createdAt
          status
          assetsIndirect {
            edges {
              node {
                id
                name
                canEdit
                dateSold
                isSold
                updatedInReportingPeriod(period: $period)
                createdAt
                entityId
              }
            }
          }
          owningInvestorPositionsDeprecated {
            id
            activeInReportingPeriod(period: $period)
            account {
              id
              name
            }
            reportRequestType
            transactions(period: $period) {
              edges {
                node {
                  id
                  batch {
                    id
                    published
                  }
                }
              }
            }
            distributions(period: $period) {
              edges {
                node {
                  id
                  batch {
                    id
                    published
                  }
                }
              }
            }
            netIncomes(period: $period) {
              edges {
                node {
                  id
                  batch {
                    id
                    published
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSingleEntityGroupQuery__
 *
 * To run a query within a React component, call `useGetSingleEntityGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleEntityGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleEntityGroupQuery({
 *   variables: {
 *      period: // value for 'period'
 *      entityGroupId: // value for 'entityGroupId'
 *   },
 * });
 */
export function useGetSingleEntityGroupQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSingleEntityGroupQuery, GraphqlTypes.GetSingleEntityGroupQueryVariables> & ({ variables: GraphqlTypes.GetSingleEntityGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSingleEntityGroupQuery, GraphqlTypes.GetSingleEntityGroupQueryVariables>(GetSingleEntityGroupDocument, options);
      }
export function useGetSingleEntityGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSingleEntityGroupQuery, GraphqlTypes.GetSingleEntityGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSingleEntityGroupQuery, GraphqlTypes.GetSingleEntityGroupQueryVariables>(GetSingleEntityGroupDocument, options);
        }
// @ts-ignore
export function useGetSingleEntityGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleEntityGroupQuery, GraphqlTypes.GetSingleEntityGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleEntityGroupQuery, GraphqlTypes.GetSingleEntityGroupQueryVariables>;
export function useGetSingleEntityGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleEntityGroupQuery, GraphqlTypes.GetSingleEntityGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSingleEntityGroupQuery | undefined, GraphqlTypes.GetSingleEntityGroupQueryVariables>;
export function useGetSingleEntityGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSingleEntityGroupQuery, GraphqlTypes.GetSingleEntityGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSingleEntityGroupQuery, GraphqlTypes.GetSingleEntityGroupQueryVariables>(GetSingleEntityGroupDocument, options);
        }
export type GetSingleEntityGroupQueryHookResult = ReturnType<typeof useGetSingleEntityGroupQuery>;
export type GetSingleEntityGroupLazyQueryHookResult = ReturnType<typeof useGetSingleEntityGroupLazyQuery>;
export type GetSingleEntityGroupSuspenseQueryHookResult = ReturnType<typeof useGetSingleEntityGroupSuspenseQuery>;
export type GetSingleEntityGroupQueryResult = Apollo.QueryResult<GraphqlTypes.GetSingleEntityGroupQuery, GraphqlTypes.GetSingleEntityGroupQueryVariables>;
export const GetCurrentArenaInfoDocument = gql`
    query GetCurrentArenaInfo {
  currentArena {
    id
    name
  }
}
    `;

/**
 * __useGetCurrentArenaInfoQuery__
 *
 * To run a query within a React component, call `useGetCurrentArenaInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentArenaInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentArenaInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentArenaInfoQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrentArenaInfoQuery, GraphqlTypes.GetCurrentArenaInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrentArenaInfoQuery, GraphqlTypes.GetCurrentArenaInfoQueryVariables>(GetCurrentArenaInfoDocument, options);
      }
export function useGetCurrentArenaInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrentArenaInfoQuery, GraphqlTypes.GetCurrentArenaInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrentArenaInfoQuery, GraphqlTypes.GetCurrentArenaInfoQueryVariables>(GetCurrentArenaInfoDocument, options);
        }
// @ts-ignore
export function useGetCurrentArenaInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaInfoQuery, GraphqlTypes.GetCurrentArenaInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentArenaInfoQuery, GraphqlTypes.GetCurrentArenaInfoQueryVariables>;
export function useGetCurrentArenaInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaInfoQuery, GraphqlTypes.GetCurrentArenaInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentArenaInfoQuery | undefined, GraphqlTypes.GetCurrentArenaInfoQueryVariables>;
export function useGetCurrentArenaInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaInfoQuery, GraphqlTypes.GetCurrentArenaInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrentArenaInfoQuery, GraphqlTypes.GetCurrentArenaInfoQueryVariables>(GetCurrentArenaInfoDocument, options);
        }
export type GetCurrentArenaInfoQueryHookResult = ReturnType<typeof useGetCurrentArenaInfoQuery>;
export type GetCurrentArenaInfoLazyQueryHookResult = ReturnType<typeof useGetCurrentArenaInfoLazyQuery>;
export type GetCurrentArenaInfoSuspenseQueryHookResult = ReturnType<typeof useGetCurrentArenaInfoSuspenseQuery>;
export type GetCurrentArenaInfoQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrentArenaInfoQuery, GraphqlTypes.GetCurrentArenaInfoQueryVariables>;
export const GetGpxiOccurredEventTypesDocument = gql`
    query GetGpxiOccurredEventTypes {
  occurredEventTypes
}
    `;

/**
 * __useGetGpxiOccurredEventTypesQuery__
 *
 * To run a query within a React component, call `useGetGpxiOccurredEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpxiOccurredEventTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpxiOccurredEventTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGpxiOccurredEventTypesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetGpxiOccurredEventTypesQuery, GraphqlTypes.GetGpxiOccurredEventTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGpxiOccurredEventTypesQuery, GraphqlTypes.GetGpxiOccurredEventTypesQueryVariables>(GetGpxiOccurredEventTypesDocument, options);
      }
export function useGetGpxiOccurredEventTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGpxiOccurredEventTypesQuery, GraphqlTypes.GetGpxiOccurredEventTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGpxiOccurredEventTypesQuery, GraphqlTypes.GetGpxiOccurredEventTypesQueryVariables>(GetGpxiOccurredEventTypesDocument, options);
        }
// @ts-ignore
export function useGetGpxiOccurredEventTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpxiOccurredEventTypesQuery, GraphqlTypes.GetGpxiOccurredEventTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpxiOccurredEventTypesQuery, GraphqlTypes.GetGpxiOccurredEventTypesQueryVariables>;
export function useGetGpxiOccurredEventTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpxiOccurredEventTypesQuery, GraphqlTypes.GetGpxiOccurredEventTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpxiOccurredEventTypesQuery | undefined, GraphqlTypes.GetGpxiOccurredEventTypesQueryVariables>;
export function useGetGpxiOccurredEventTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpxiOccurredEventTypesQuery, GraphqlTypes.GetGpxiOccurredEventTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGpxiOccurredEventTypesQuery, GraphqlTypes.GetGpxiOccurredEventTypesQueryVariables>(GetGpxiOccurredEventTypesDocument, options);
        }
export type GetGpxiOccurredEventTypesQueryHookResult = ReturnType<typeof useGetGpxiOccurredEventTypesQuery>;
export type GetGpxiOccurredEventTypesLazyQueryHookResult = ReturnType<typeof useGetGpxiOccurredEventTypesLazyQuery>;
export type GetGpxiOccurredEventTypesSuspenseQueryHookResult = ReturnType<typeof useGetGpxiOccurredEventTypesSuspenseQuery>;
export type GetGpxiOccurredEventTypesQueryResult = Apollo.QueryResult<GraphqlTypes.GetGpxiOccurredEventTypesQuery, GraphqlTypes.GetGpxiOccurredEventTypesQueryVariables>;
export const GetGpxiLogDocument = gql`
    query GetGpxiLog($id: ID!) {
  gpxiLog(id: $id) {
    log
    linkedObjects {
      objectType
      url
      label
    }
  }
}
    `;

/**
 * __useGetGpxiLogQuery__
 *
 * To run a query within a React component, call `useGetGpxiLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpxiLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpxiLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGpxiLogQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetGpxiLogQuery, GraphqlTypes.GetGpxiLogQueryVariables> & ({ variables: GraphqlTypes.GetGpxiLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGpxiLogQuery, GraphqlTypes.GetGpxiLogQueryVariables>(GetGpxiLogDocument, options);
      }
export function useGetGpxiLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGpxiLogQuery, GraphqlTypes.GetGpxiLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGpxiLogQuery, GraphqlTypes.GetGpxiLogQueryVariables>(GetGpxiLogDocument, options);
        }
// @ts-ignore
export function useGetGpxiLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpxiLogQuery, GraphqlTypes.GetGpxiLogQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpxiLogQuery, GraphqlTypes.GetGpxiLogQueryVariables>;
export function useGetGpxiLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpxiLogQuery, GraphqlTypes.GetGpxiLogQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpxiLogQuery | undefined, GraphqlTypes.GetGpxiLogQueryVariables>;
export function useGetGpxiLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpxiLogQuery, GraphqlTypes.GetGpxiLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGpxiLogQuery, GraphqlTypes.GetGpxiLogQueryVariables>(GetGpxiLogDocument, options);
        }
export type GetGpxiLogQueryHookResult = ReturnType<typeof useGetGpxiLogQuery>;
export type GetGpxiLogLazyQueryHookResult = ReturnType<typeof useGetGpxiLogLazyQuery>;
export type GetGpxiLogSuspenseQueryHookResult = ReturnType<typeof useGetGpxiLogSuspenseQuery>;
export type GetGpxiLogQueryResult = Apollo.QueryResult<GraphqlTypes.GetGpxiLogQuery, GraphqlTypes.GetGpxiLogQueryVariables>;
export const GetGpxiLogsDocument = gql`
    query GetGpxiLogs($first: Int, $filters: GpxiLogFilters, $after: String) {
  currentArena {
    timezone
  }
  gpxiLogs(filters: $filters, first: $first, after: $after) {
    count
    edges {
      node {
        id
        date
        direction
        eventType
        status
        validRecords
        invalidRecords
        createdAt
        sessionId
        requestId
        auditLogUrl
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetGpxiLogsQuery__
 *
 * To run a query within a React component, call `useGetGpxiLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpxiLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpxiLogsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetGpxiLogsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetGpxiLogsQuery, GraphqlTypes.GetGpxiLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGpxiLogsQuery, GraphqlTypes.GetGpxiLogsQueryVariables>(GetGpxiLogsDocument, options);
      }
export function useGetGpxiLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGpxiLogsQuery, GraphqlTypes.GetGpxiLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGpxiLogsQuery, GraphqlTypes.GetGpxiLogsQueryVariables>(GetGpxiLogsDocument, options);
        }
// @ts-ignore
export function useGetGpxiLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpxiLogsQuery, GraphqlTypes.GetGpxiLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpxiLogsQuery, GraphqlTypes.GetGpxiLogsQueryVariables>;
export function useGetGpxiLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpxiLogsQuery, GraphqlTypes.GetGpxiLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpxiLogsQuery | undefined, GraphqlTypes.GetGpxiLogsQueryVariables>;
export function useGetGpxiLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpxiLogsQuery, GraphqlTypes.GetGpxiLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGpxiLogsQuery, GraphqlTypes.GetGpxiLogsQueryVariables>(GetGpxiLogsDocument, options);
        }
export type GetGpxiLogsQueryHookResult = ReturnType<typeof useGetGpxiLogsQuery>;
export type GetGpxiLogsLazyQueryHookResult = ReturnType<typeof useGetGpxiLogsLazyQuery>;
export type GetGpxiLogsSuspenseQueryHookResult = ReturnType<typeof useGetGpxiLogsSuspenseQuery>;
export type GetGpxiLogsQueryResult = Apollo.QueryResult<GraphqlTypes.GetGpxiLogsQuery, GraphqlTypes.GetGpxiLogsQueryVariables>;
export const GetUserInvestranAccessDocument = gql`
    query GetUserInvestranAccess {
  currentUser {
    hasInvestranAccess
  }
}
    `;

/**
 * __useGetUserInvestranAccessQuery__
 *
 * To run a query within a React component, call `useGetUserInvestranAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInvestranAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInvestranAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInvestranAccessQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetUserInvestranAccessQuery, GraphqlTypes.GetUserInvestranAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUserInvestranAccessQuery, GraphqlTypes.GetUserInvestranAccessQueryVariables>(GetUserInvestranAccessDocument, options);
      }
export function useGetUserInvestranAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUserInvestranAccessQuery, GraphqlTypes.GetUserInvestranAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUserInvestranAccessQuery, GraphqlTypes.GetUserInvestranAccessQueryVariables>(GetUserInvestranAccessDocument, options);
        }
// @ts-ignore
export function useGetUserInvestranAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserInvestranAccessQuery, GraphqlTypes.GetUserInvestranAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserInvestranAccessQuery, GraphqlTypes.GetUserInvestranAccessQueryVariables>;
export function useGetUserInvestranAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserInvestranAccessQuery, GraphqlTypes.GetUserInvestranAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserInvestranAccessQuery | undefined, GraphqlTypes.GetUserInvestranAccessQueryVariables>;
export function useGetUserInvestranAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserInvestranAccessQuery, GraphqlTypes.GetUserInvestranAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUserInvestranAccessQuery, GraphqlTypes.GetUserInvestranAccessQueryVariables>(GetUserInvestranAccessDocument, options);
        }
export type GetUserInvestranAccessQueryHookResult = ReturnType<typeof useGetUserInvestranAccessQuery>;
export type GetUserInvestranAccessLazyQueryHookResult = ReturnType<typeof useGetUserInvestranAccessLazyQuery>;
export type GetUserInvestranAccessSuspenseQueryHookResult = ReturnType<typeof useGetUserInvestranAccessSuspenseQuery>;
export type GetUserInvestranAccessQueryResult = Apollo.QueryResult<GraphqlTypes.GetUserInvestranAccessQuery, GraphqlTypes.GetUserInvestranAccessQueryVariables>;
export const SaveImportTemplateDocument = gql`
    mutation saveImportTemplate($id: ID, $name: String, $mapping: JSONString!) {
  importOps {
    saveTemplate(id: $id, name: $name, mapping: $mapping) {
      template {
        id
        name
        mapping
      }
    }
  }
}
    `;
export type SaveImportTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.SaveImportTemplateMutation, GraphqlTypes.SaveImportTemplateMutationVariables>;

/**
 * __useSaveImportTemplateMutation__
 *
 * To run a mutation, you first call `useSaveImportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveImportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveImportTemplateMutation, { data, loading, error }] = useSaveImportTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      mapping: // value for 'mapping'
 *   },
 * });
 */
export function useSaveImportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SaveImportTemplateMutation, GraphqlTypes.SaveImportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SaveImportTemplateMutation, GraphqlTypes.SaveImportTemplateMutationVariables>(SaveImportTemplateDocument, options);
      }
export type SaveImportTemplateMutationHookResult = ReturnType<typeof useSaveImportTemplateMutation>;
export type SaveImportTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.SaveImportTemplateMutation>;
export type SaveImportTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SaveImportTemplateMutation, GraphqlTypes.SaveImportTemplateMutationVariables>;
export const GenerateImportPreviewDocument = gql`
    mutation generateImportPreview($fileUuid: String!, $mapping: JSONString!, $sheetName: String!, $itemName: String, $entityGroupId: ID) {
  importOps {
    generatePreview(
      fileUuid: $fileUuid
      mapping: $mapping
      sheetName: $sheetName
      itemName: $itemName
      entityGroupId: $entityGroupId
    ) {
      job {
        id
      }
    }
  }
}
    `;
export type GenerateImportPreviewMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateImportPreviewMutation, GraphqlTypes.GenerateImportPreviewMutationVariables>;

/**
 * __useGenerateImportPreviewMutation__
 *
 * To run a mutation, you first call `useGenerateImportPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateImportPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateImportPreviewMutation, { data, loading, error }] = useGenerateImportPreviewMutation({
 *   variables: {
 *      fileUuid: // value for 'fileUuid'
 *      mapping: // value for 'mapping'
 *      sheetName: // value for 'sheetName'
 *      itemName: // value for 'itemName'
 *      entityGroupId: // value for 'entityGroupId'
 *   },
 * });
 */
export function useGenerateImportPreviewMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateImportPreviewMutation, GraphqlTypes.GenerateImportPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateImportPreviewMutation, GraphqlTypes.GenerateImportPreviewMutationVariables>(GenerateImportPreviewDocument, options);
      }
export type GenerateImportPreviewMutationHookResult = ReturnType<typeof useGenerateImportPreviewMutation>;
export type GenerateImportPreviewMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateImportPreviewMutation>;
export type GenerateImportPreviewMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateImportPreviewMutation, GraphqlTypes.GenerateImportPreviewMutationVariables>;
export const GetSpreadsheetFieldsDocument = gql`
    query GetSpreadsheetFields($fileUuid: String!, $sheetName: String!, $itemName: String) {
  spreadsheetFieldWrapper(
    fileUuid: $fileUuid
    sheetName: $sheetName
    itemName: $itemName
  ) {
    spreadsheetFields {
      header
      column
      firstLines
    }
  }
}
    `;

/**
 * __useGetSpreadsheetFieldsQuery__
 *
 * To run a query within a React component, call `useGetSpreadsheetFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpreadsheetFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpreadsheetFieldsQuery({
 *   variables: {
 *      fileUuid: // value for 'fileUuid'
 *      sheetName: // value for 'sheetName'
 *      itemName: // value for 'itemName'
 *   },
 * });
 */
export function useGetSpreadsheetFieldsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSpreadsheetFieldsQuery, GraphqlTypes.GetSpreadsheetFieldsQueryVariables> & ({ variables: GraphqlTypes.GetSpreadsheetFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSpreadsheetFieldsQuery, GraphqlTypes.GetSpreadsheetFieldsQueryVariables>(GetSpreadsheetFieldsDocument, options);
      }
export function useGetSpreadsheetFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSpreadsheetFieldsQuery, GraphqlTypes.GetSpreadsheetFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSpreadsheetFieldsQuery, GraphqlTypes.GetSpreadsheetFieldsQueryVariables>(GetSpreadsheetFieldsDocument, options);
        }
// @ts-ignore
export function useGetSpreadsheetFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSpreadsheetFieldsQuery, GraphqlTypes.GetSpreadsheetFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSpreadsheetFieldsQuery, GraphqlTypes.GetSpreadsheetFieldsQueryVariables>;
export function useGetSpreadsheetFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSpreadsheetFieldsQuery, GraphqlTypes.GetSpreadsheetFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSpreadsheetFieldsQuery | undefined, GraphqlTypes.GetSpreadsheetFieldsQueryVariables>;
export function useGetSpreadsheetFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSpreadsheetFieldsQuery, GraphqlTypes.GetSpreadsheetFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSpreadsheetFieldsQuery, GraphqlTypes.GetSpreadsheetFieldsQueryVariables>(GetSpreadsheetFieldsDocument, options);
        }
export type GetSpreadsheetFieldsQueryHookResult = ReturnType<typeof useGetSpreadsheetFieldsQuery>;
export type GetSpreadsheetFieldsLazyQueryHookResult = ReturnType<typeof useGetSpreadsheetFieldsLazyQuery>;
export type GetSpreadsheetFieldsSuspenseQueryHookResult = ReturnType<typeof useGetSpreadsheetFieldsSuspenseQuery>;
export type GetSpreadsheetFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetSpreadsheetFieldsQuery, GraphqlTypes.GetSpreadsheetFieldsQueryVariables>;
export const GetImportPreviewWithWarningsDocument = gql`
    query GetImportPreviewWithWarnings($previewId: ID!) {
  importPreview(previewId: $previewId) {
    assetsAndEntities {
      id
    }
    missingDataWarnings(first: 5) {
      edges {
        node {
          name
        }
      }
    }
    navOwnershipWarnings {
      name
    }
  }
}
    `;

/**
 * __useGetImportPreviewWithWarningsQuery__
 *
 * To run a query within a React component, call `useGetImportPreviewWithWarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportPreviewWithWarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportPreviewWithWarningsQuery({
 *   variables: {
 *      previewId: // value for 'previewId'
 *   },
 * });
 */
export function useGetImportPreviewWithWarningsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetImportPreviewWithWarningsQuery, GraphqlTypes.GetImportPreviewWithWarningsQueryVariables> & ({ variables: GraphqlTypes.GetImportPreviewWithWarningsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetImportPreviewWithWarningsQuery, GraphqlTypes.GetImportPreviewWithWarningsQueryVariables>(GetImportPreviewWithWarningsDocument, options);
      }
export function useGetImportPreviewWithWarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetImportPreviewWithWarningsQuery, GraphqlTypes.GetImportPreviewWithWarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetImportPreviewWithWarningsQuery, GraphqlTypes.GetImportPreviewWithWarningsQueryVariables>(GetImportPreviewWithWarningsDocument, options);
        }
// @ts-ignore
export function useGetImportPreviewWithWarningsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportPreviewWithWarningsQuery, GraphqlTypes.GetImportPreviewWithWarningsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportPreviewWithWarningsQuery, GraphqlTypes.GetImportPreviewWithWarningsQueryVariables>;
export function useGetImportPreviewWithWarningsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportPreviewWithWarningsQuery, GraphqlTypes.GetImportPreviewWithWarningsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportPreviewWithWarningsQuery | undefined, GraphqlTypes.GetImportPreviewWithWarningsQueryVariables>;
export function useGetImportPreviewWithWarningsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportPreviewWithWarningsQuery, GraphqlTypes.GetImportPreviewWithWarningsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetImportPreviewWithWarningsQuery, GraphqlTypes.GetImportPreviewWithWarningsQueryVariables>(GetImportPreviewWithWarningsDocument, options);
        }
export type GetImportPreviewWithWarningsQueryHookResult = ReturnType<typeof useGetImportPreviewWithWarningsQuery>;
export type GetImportPreviewWithWarningsLazyQueryHookResult = ReturnType<typeof useGetImportPreviewWithWarningsLazyQuery>;
export type GetImportPreviewWithWarningsSuspenseQueryHookResult = ReturnType<typeof useGetImportPreviewWithWarningsSuspenseQuery>;
export type GetImportPreviewWithWarningsQueryResult = Apollo.QueryResult<GraphqlTypes.GetImportPreviewWithWarningsQuery, GraphqlTypes.GetImportPreviewWithWarningsQueryVariables>;
export const GetSupportEmailDocument = gql`
    query GetSupportEmail {
  currentArena {
    id
    supportEmail
  }
}
    `;

/**
 * __useGetSupportEmailQuery__
 *
 * To run a query within a React component, call `useGetSupportEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportEmailQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportEmailQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetSupportEmailQuery, GraphqlTypes.GetSupportEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSupportEmailQuery, GraphqlTypes.GetSupportEmailQueryVariables>(GetSupportEmailDocument, options);
      }
export function useGetSupportEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSupportEmailQuery, GraphqlTypes.GetSupportEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSupportEmailQuery, GraphqlTypes.GetSupportEmailQueryVariables>(GetSupportEmailDocument, options);
        }
// @ts-ignore
export function useGetSupportEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSupportEmailQuery, GraphqlTypes.GetSupportEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSupportEmailQuery, GraphqlTypes.GetSupportEmailQueryVariables>;
export function useGetSupportEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSupportEmailQuery, GraphqlTypes.GetSupportEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSupportEmailQuery | undefined, GraphqlTypes.GetSupportEmailQueryVariables>;
export function useGetSupportEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSupportEmailQuery, GraphqlTypes.GetSupportEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSupportEmailQuery, GraphqlTypes.GetSupportEmailQueryVariables>(GetSupportEmailDocument, options);
        }
export type GetSupportEmailQueryHookResult = ReturnType<typeof useGetSupportEmailQuery>;
export type GetSupportEmailLazyQueryHookResult = ReturnType<typeof useGetSupportEmailLazyQuery>;
export type GetSupportEmailSuspenseQueryHookResult = ReturnType<typeof useGetSupportEmailSuspenseQuery>;
export type GetSupportEmailQueryResult = Apollo.QueryResult<GraphqlTypes.GetSupportEmailQuery, GraphqlTypes.GetSupportEmailQueryVariables>;
export const GetImportPreviewWarningsDocument = gql`
    query GetImportPreviewWarnings($previewId: ID!) {
  importPreview(previewId: $previewId) {
    id
    assetsAndEntities {
      id
    }
    missingDataWarnings(first: 5) {
      edges {
        node {
          rows
          name
          nav {
            monies
          }
          percentOwned
        }
      }
      pageInfo {
        hasNextPage
      }
    }
    navOwnershipWarnings {
      rows
      name
      nav {
        monies
      }
      navAtShare {
        monies
      }
      percentAcquired
      percentDisposed
      percentOwned
    }
  }
}
    `;

/**
 * __useGetImportPreviewWarningsQuery__
 *
 * To run a query within a React component, call `useGetImportPreviewWarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportPreviewWarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportPreviewWarningsQuery({
 *   variables: {
 *      previewId: // value for 'previewId'
 *   },
 * });
 */
export function useGetImportPreviewWarningsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetImportPreviewWarningsQuery, GraphqlTypes.GetImportPreviewWarningsQueryVariables> & ({ variables: GraphqlTypes.GetImportPreviewWarningsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetImportPreviewWarningsQuery, GraphqlTypes.GetImportPreviewWarningsQueryVariables>(GetImportPreviewWarningsDocument, options);
      }
export function useGetImportPreviewWarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetImportPreviewWarningsQuery, GraphqlTypes.GetImportPreviewWarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetImportPreviewWarningsQuery, GraphqlTypes.GetImportPreviewWarningsQueryVariables>(GetImportPreviewWarningsDocument, options);
        }
// @ts-ignore
export function useGetImportPreviewWarningsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportPreviewWarningsQuery, GraphqlTypes.GetImportPreviewWarningsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportPreviewWarningsQuery, GraphqlTypes.GetImportPreviewWarningsQueryVariables>;
export function useGetImportPreviewWarningsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportPreviewWarningsQuery, GraphqlTypes.GetImportPreviewWarningsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportPreviewWarningsQuery | undefined, GraphqlTypes.GetImportPreviewWarningsQueryVariables>;
export function useGetImportPreviewWarningsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportPreviewWarningsQuery, GraphqlTypes.GetImportPreviewWarningsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetImportPreviewWarningsQuery, GraphqlTypes.GetImportPreviewWarningsQueryVariables>(GetImportPreviewWarningsDocument, options);
        }
export type GetImportPreviewWarningsQueryHookResult = ReturnType<typeof useGetImportPreviewWarningsQuery>;
export type GetImportPreviewWarningsLazyQueryHookResult = ReturnType<typeof useGetImportPreviewWarningsLazyQuery>;
export type GetImportPreviewWarningsSuspenseQueryHookResult = ReturnType<typeof useGetImportPreviewWarningsSuspenseQuery>;
export type GetImportPreviewWarningsQueryResult = Apollo.QueryResult<GraphqlTypes.GetImportPreviewWarningsQuery, GraphqlTypes.GetImportPreviewWarningsQueryVariables>;
export const GetAllMissingDataWarningsDocument = gql`
    query GetAllMissingDataWarnings($previewId: ID!) {
  importPreview(previewId: $previewId) {
    id
    missingDataWarnings(first: 3000) {
      edges {
        node {
          rows
          name
          nav {
            monies
          }
          percentOwned
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllMissingDataWarningsQuery__
 *
 * To run a query within a React component, call `useGetAllMissingDataWarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMissingDataWarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMissingDataWarningsQuery({
 *   variables: {
 *      previewId: // value for 'previewId'
 *   },
 * });
 */
export function useGetAllMissingDataWarningsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAllMissingDataWarningsQuery, GraphqlTypes.GetAllMissingDataWarningsQueryVariables> & ({ variables: GraphqlTypes.GetAllMissingDataWarningsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllMissingDataWarningsQuery, GraphqlTypes.GetAllMissingDataWarningsQueryVariables>(GetAllMissingDataWarningsDocument, options);
      }
export function useGetAllMissingDataWarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllMissingDataWarningsQuery, GraphqlTypes.GetAllMissingDataWarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllMissingDataWarningsQuery, GraphqlTypes.GetAllMissingDataWarningsQueryVariables>(GetAllMissingDataWarningsDocument, options);
        }
// @ts-ignore
export function useGetAllMissingDataWarningsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllMissingDataWarningsQuery, GraphqlTypes.GetAllMissingDataWarningsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllMissingDataWarningsQuery, GraphqlTypes.GetAllMissingDataWarningsQueryVariables>;
export function useGetAllMissingDataWarningsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllMissingDataWarningsQuery, GraphqlTypes.GetAllMissingDataWarningsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllMissingDataWarningsQuery | undefined, GraphqlTypes.GetAllMissingDataWarningsQueryVariables>;
export function useGetAllMissingDataWarningsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllMissingDataWarningsQuery, GraphqlTypes.GetAllMissingDataWarningsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllMissingDataWarningsQuery, GraphqlTypes.GetAllMissingDataWarningsQueryVariables>(GetAllMissingDataWarningsDocument, options);
        }
export type GetAllMissingDataWarningsQueryHookResult = ReturnType<typeof useGetAllMissingDataWarningsQuery>;
export type GetAllMissingDataWarningsLazyQueryHookResult = ReturnType<typeof useGetAllMissingDataWarningsLazyQuery>;
export type GetAllMissingDataWarningsSuspenseQueryHookResult = ReturnType<typeof useGetAllMissingDataWarningsSuspenseQuery>;
export type GetAllMissingDataWarningsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllMissingDataWarningsQuery, GraphqlTypes.GetAllMissingDataWarningsQueryVariables>;
export const FinalizeImportDocument = gql`
    mutation finalizeImport($fileUuid: String!, $mapping: JSONString!, $sheetName: String!, $itemName: String, $entityGroupId: ID) {
  importOps {
    finalizeImport(
      fileUuid: $fileUuid
      mapping: $mapping
      sheetName: $sheetName
      itemName: $itemName
      entityGroupId: $entityGroupId
    ) {
      job {
        id
      }
    }
  }
}
    `;
export type FinalizeImportMutationFn = Apollo.MutationFunction<GraphqlTypes.FinalizeImportMutation, GraphqlTypes.FinalizeImportMutationVariables>;

/**
 * __useFinalizeImportMutation__
 *
 * To run a mutation, you first call `useFinalizeImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeImportMutation, { data, loading, error }] = useFinalizeImportMutation({
 *   variables: {
 *      fileUuid: // value for 'fileUuid'
 *      mapping: // value for 'mapping'
 *      sheetName: // value for 'sheetName'
 *      itemName: // value for 'itemName'
 *      entityGroupId: // value for 'entityGroupId'
 *   },
 * });
 */
export function useFinalizeImportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FinalizeImportMutation, GraphqlTypes.FinalizeImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FinalizeImportMutation, GraphqlTypes.FinalizeImportMutationVariables>(FinalizeImportDocument, options);
      }
export type FinalizeImportMutationHookResult = ReturnType<typeof useFinalizeImportMutation>;
export type FinalizeImportMutationResult = Apollo.MutationResult<GraphqlTypes.FinalizeImportMutation>;
export type FinalizeImportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FinalizeImportMutation, GraphqlTypes.FinalizeImportMutationVariables>;
export const GetImportPreviewDocument = gql`
    query GetImportPreview($previewId: ID!) {
  importPreview(previewId: $previewId) {
    assetsAndEntities {
      type
      id
      name
      deleted
      fieldChanges {
        name
        oldValue
        newValue
      }
      children {
        name
        asOfDate
        period {
          year
          monthOrQuarterAbbr
        }
        deleted
        fieldChanges {
          name
          oldValue
          newValue
        }
      }
    }
  }
}
    `;

/**
 * __useGetImportPreviewQuery__
 *
 * To run a query within a React component, call `useGetImportPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportPreviewQuery({
 *   variables: {
 *      previewId: // value for 'previewId'
 *   },
 * });
 */
export function useGetImportPreviewQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetImportPreviewQuery, GraphqlTypes.GetImportPreviewQueryVariables> & ({ variables: GraphqlTypes.GetImportPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetImportPreviewQuery, GraphqlTypes.GetImportPreviewQueryVariables>(GetImportPreviewDocument, options);
      }
export function useGetImportPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetImportPreviewQuery, GraphqlTypes.GetImportPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetImportPreviewQuery, GraphqlTypes.GetImportPreviewQueryVariables>(GetImportPreviewDocument, options);
        }
// @ts-ignore
export function useGetImportPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportPreviewQuery, GraphqlTypes.GetImportPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportPreviewQuery, GraphqlTypes.GetImportPreviewQueryVariables>;
export function useGetImportPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportPreviewQuery, GraphqlTypes.GetImportPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportPreviewQuery | undefined, GraphqlTypes.GetImportPreviewQueryVariables>;
export function useGetImportPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportPreviewQuery, GraphqlTypes.GetImportPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetImportPreviewQuery, GraphqlTypes.GetImportPreviewQueryVariables>(GetImportPreviewDocument, options);
        }
export type GetImportPreviewQueryHookResult = ReturnType<typeof useGetImportPreviewQuery>;
export type GetImportPreviewLazyQueryHookResult = ReturnType<typeof useGetImportPreviewLazyQuery>;
export type GetImportPreviewSuspenseQueryHookResult = ReturnType<typeof useGetImportPreviewSuspenseQuery>;
export type GetImportPreviewQueryResult = Apollo.QueryResult<GraphqlTypes.GetImportPreviewQuery, GraphqlTypes.GetImportPreviewQueryVariables>;
export const ParseSpreadsheetDocument = gql`
    mutation parseSpreadsheet($fileUuid: String!, $sheetName: String!, $itemName: String) {
  importOps {
    parseSpreadsheet(
      fileUuid: $fileUuid
      sheetName: $sheetName
      itemName: $itemName
    ) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on ParseSpreadsheetObject {
        fileUuid
      }
    }
  }
}
    `;
export type ParseSpreadsheetMutationFn = Apollo.MutationFunction<GraphqlTypes.ParseSpreadsheetMutation, GraphqlTypes.ParseSpreadsheetMutationVariables>;

/**
 * __useParseSpreadsheetMutation__
 *
 * To run a mutation, you first call `useParseSpreadsheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParseSpreadsheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parseSpreadsheetMutation, { data, loading, error }] = useParseSpreadsheetMutation({
 *   variables: {
 *      fileUuid: // value for 'fileUuid'
 *      sheetName: // value for 'sheetName'
 *      itemName: // value for 'itemName'
 *   },
 * });
 */
export function useParseSpreadsheetMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ParseSpreadsheetMutation, GraphqlTypes.ParseSpreadsheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ParseSpreadsheetMutation, GraphqlTypes.ParseSpreadsheetMutationVariables>(ParseSpreadsheetDocument, options);
      }
export type ParseSpreadsheetMutationHookResult = ReturnType<typeof useParseSpreadsheetMutation>;
export type ParseSpreadsheetMutationResult = Apollo.MutationResult<GraphqlTypes.ParseSpreadsheetMutation>;
export type ParseSpreadsheetMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ParseSpreadsheetMutation, GraphqlTypes.ParseSpreadsheetMutationVariables>;
export const GetImportTemplatesDocument = gql`
    query GetImportTemplates {
  fieldsMappingTemplates {
    edges {
      node {
        id
        name
        mapping
      }
    }
  }
}
    `;

/**
 * __useGetImportTemplatesQuery__
 *
 * To run a query within a React component, call `useGetImportTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetImportTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetImportTemplatesQuery, GraphqlTypes.GetImportTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetImportTemplatesQuery, GraphqlTypes.GetImportTemplatesQueryVariables>(GetImportTemplatesDocument, options);
      }
export function useGetImportTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetImportTemplatesQuery, GraphqlTypes.GetImportTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetImportTemplatesQuery, GraphqlTypes.GetImportTemplatesQueryVariables>(GetImportTemplatesDocument, options);
        }
// @ts-ignore
export function useGetImportTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportTemplatesQuery, GraphqlTypes.GetImportTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportTemplatesQuery, GraphqlTypes.GetImportTemplatesQueryVariables>;
export function useGetImportTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportTemplatesQuery, GraphqlTypes.GetImportTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportTemplatesQuery | undefined, GraphqlTypes.GetImportTemplatesQueryVariables>;
export function useGetImportTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportTemplatesQuery, GraphqlTypes.GetImportTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetImportTemplatesQuery, GraphqlTypes.GetImportTemplatesQueryVariables>(GetImportTemplatesDocument, options);
        }
export type GetImportTemplatesQueryHookResult = ReturnType<typeof useGetImportTemplatesQuery>;
export type GetImportTemplatesLazyQueryHookResult = ReturnType<typeof useGetImportTemplatesLazyQuery>;
export type GetImportTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetImportTemplatesSuspenseQuery>;
export type GetImportTemplatesQueryResult = Apollo.QueryResult<GraphqlTypes.GetImportTemplatesQuery, GraphqlTypes.GetImportTemplatesQueryVariables>;
export const GetJsqFieldsDocument = gql`
    query GetJSQFields {
  jsqFieldWrapper {
    jsqFields {
      jsqKey
      name
      description
      section
      type
      isAmount
    }
  }
}
    `;

/**
 * __useGetJsqFieldsQuery__
 *
 * To run a query within a React component, call `useGetJsqFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJsqFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJsqFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJsqFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetJsqFieldsQuery, GraphqlTypes.GetJsqFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetJsqFieldsQuery, GraphqlTypes.GetJsqFieldsQueryVariables>(GetJsqFieldsDocument, options);
      }
export function useGetJsqFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetJsqFieldsQuery, GraphqlTypes.GetJsqFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetJsqFieldsQuery, GraphqlTypes.GetJsqFieldsQueryVariables>(GetJsqFieldsDocument, options);
        }
// @ts-ignore
export function useGetJsqFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetJsqFieldsQuery, GraphqlTypes.GetJsqFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetJsqFieldsQuery, GraphqlTypes.GetJsqFieldsQueryVariables>;
export function useGetJsqFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetJsqFieldsQuery, GraphqlTypes.GetJsqFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetJsqFieldsQuery | undefined, GraphqlTypes.GetJsqFieldsQueryVariables>;
export function useGetJsqFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetJsqFieldsQuery, GraphqlTypes.GetJsqFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetJsqFieldsQuery, GraphqlTypes.GetJsqFieldsQueryVariables>(GetJsqFieldsDocument, options);
        }
export type GetJsqFieldsQueryHookResult = ReturnType<typeof useGetJsqFieldsQuery>;
export type GetJsqFieldsLazyQueryHookResult = ReturnType<typeof useGetJsqFieldsLazyQuery>;
export type GetJsqFieldsSuspenseQueryHookResult = ReturnType<typeof useGetJsqFieldsSuspenseQuery>;
export type GetJsqFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetJsqFieldsQuery, GraphqlTypes.GetJsqFieldsQueryVariables>;
export const GetIsGpLiteDocument = gql`
    query GetIsGpLite {
  currentArena {
    id
    supportEmail
    supportPhone
    isGpLite
  }
}
    `;

/**
 * __useGetIsGpLiteQuery__
 *
 * To run a query within a React component, call `useGetIsGpLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsGpLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsGpLiteQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIsGpLiteQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetIsGpLiteQuery, GraphqlTypes.GetIsGpLiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetIsGpLiteQuery, GraphqlTypes.GetIsGpLiteQueryVariables>(GetIsGpLiteDocument, options);
      }
export function useGetIsGpLiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetIsGpLiteQuery, GraphqlTypes.GetIsGpLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetIsGpLiteQuery, GraphqlTypes.GetIsGpLiteQueryVariables>(GetIsGpLiteDocument, options);
        }
// @ts-ignore
export function useGetIsGpLiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIsGpLiteQuery, GraphqlTypes.GetIsGpLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIsGpLiteQuery, GraphqlTypes.GetIsGpLiteQueryVariables>;
export function useGetIsGpLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIsGpLiteQuery, GraphqlTypes.GetIsGpLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIsGpLiteQuery | undefined, GraphqlTypes.GetIsGpLiteQueryVariables>;
export function useGetIsGpLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIsGpLiteQuery, GraphqlTypes.GetIsGpLiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetIsGpLiteQuery, GraphqlTypes.GetIsGpLiteQueryVariables>(GetIsGpLiteDocument, options);
        }
export type GetIsGpLiteQueryHookResult = ReturnType<typeof useGetIsGpLiteQuery>;
export type GetIsGpLiteLazyQueryHookResult = ReturnType<typeof useGetIsGpLiteLazyQuery>;
export type GetIsGpLiteSuspenseQueryHookResult = ReturnType<typeof useGetIsGpLiteSuspenseQuery>;
export type GetIsGpLiteQueryResult = Apollo.QueryResult<GraphqlTypes.GetIsGpLiteQuery, GraphqlTypes.GetIsGpLiteQueryVariables>;
export const GetDefaultConfigDocument = gql`
    query GetDefaultConfig {
  currentArena {
    id
    importTemplateConfig {
      loans
      acquisitions
      dispositions
      assetAddresses
      productTypes
      currencies {
        code
      }
    }
  }
}
    `;

/**
 * __useGetDefaultConfigQuery__
 *
 * To run a query within a React component, call `useGetDefaultConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultConfigQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDefaultConfigQuery, GraphqlTypes.GetDefaultConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDefaultConfigQuery, GraphqlTypes.GetDefaultConfigQueryVariables>(GetDefaultConfigDocument, options);
      }
export function useGetDefaultConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDefaultConfigQuery, GraphqlTypes.GetDefaultConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDefaultConfigQuery, GraphqlTypes.GetDefaultConfigQueryVariables>(GetDefaultConfigDocument, options);
        }
// @ts-ignore
export function useGetDefaultConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDefaultConfigQuery, GraphqlTypes.GetDefaultConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDefaultConfigQuery, GraphqlTypes.GetDefaultConfigQueryVariables>;
export function useGetDefaultConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDefaultConfigQuery, GraphqlTypes.GetDefaultConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDefaultConfigQuery | undefined, GraphqlTypes.GetDefaultConfigQueryVariables>;
export function useGetDefaultConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDefaultConfigQuery, GraphqlTypes.GetDefaultConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDefaultConfigQuery, GraphqlTypes.GetDefaultConfigQueryVariables>(GetDefaultConfigDocument, options);
        }
export type GetDefaultConfigQueryHookResult = ReturnType<typeof useGetDefaultConfigQuery>;
export type GetDefaultConfigLazyQueryHookResult = ReturnType<typeof useGetDefaultConfigLazyQuery>;
export type GetDefaultConfigSuspenseQueryHookResult = ReturnType<typeof useGetDefaultConfigSuspenseQuery>;
export type GetDefaultConfigQueryResult = Apollo.QueryResult<GraphqlTypes.GetDefaultConfigQuery, GraphqlTypes.GetDefaultConfigQueryVariables>;
export const GetCurrenciesForSelectFieldDocument = gql`
    query GetCurrenciesForSelectField {
  currencies {
    value: code
    label: fullName
  }
}
    `;

/**
 * __useGetCurrenciesForSelectFieldQuery__
 *
 * To run a query within a React component, call `useGetCurrenciesForSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrenciesForSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrenciesForSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrenciesForSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrenciesForSelectFieldQuery, GraphqlTypes.GetCurrenciesForSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrenciesForSelectFieldQuery, GraphqlTypes.GetCurrenciesForSelectFieldQueryVariables>(GetCurrenciesForSelectFieldDocument, options);
      }
export function useGetCurrenciesForSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrenciesForSelectFieldQuery, GraphqlTypes.GetCurrenciesForSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrenciesForSelectFieldQuery, GraphqlTypes.GetCurrenciesForSelectFieldQueryVariables>(GetCurrenciesForSelectFieldDocument, options);
        }
// @ts-ignore
export function useGetCurrenciesForSelectFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrenciesForSelectFieldQuery, GraphqlTypes.GetCurrenciesForSelectFieldQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrenciesForSelectFieldQuery, GraphqlTypes.GetCurrenciesForSelectFieldQueryVariables>;
export function useGetCurrenciesForSelectFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrenciesForSelectFieldQuery, GraphqlTypes.GetCurrenciesForSelectFieldQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrenciesForSelectFieldQuery | undefined, GraphqlTypes.GetCurrenciesForSelectFieldQueryVariables>;
export function useGetCurrenciesForSelectFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrenciesForSelectFieldQuery, GraphqlTypes.GetCurrenciesForSelectFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrenciesForSelectFieldQuery, GraphqlTypes.GetCurrenciesForSelectFieldQueryVariables>(GetCurrenciesForSelectFieldDocument, options);
        }
export type GetCurrenciesForSelectFieldQueryHookResult = ReturnType<typeof useGetCurrenciesForSelectFieldQuery>;
export type GetCurrenciesForSelectFieldLazyQueryHookResult = ReturnType<typeof useGetCurrenciesForSelectFieldLazyQuery>;
export type GetCurrenciesForSelectFieldSuspenseQueryHookResult = ReturnType<typeof useGetCurrenciesForSelectFieldSuspenseQuery>;
export type GetCurrenciesForSelectFieldQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrenciesForSelectFieldQuery, GraphqlTypes.GetCurrenciesForSelectFieldQueryVariables>;
export const DownloadAllTransactionsDocument = gql`
    mutation DownloadAllTransactions($input: DownloadAllInput!) {
  transactionOps {
    downloadAll(objectInput: $input) {
      job {
        id
      }
    }
  }
}
    `;
export type DownloadAllTransactionsMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadAllTransactionsMutation, GraphqlTypes.DownloadAllTransactionsMutationVariables>;

/**
 * __useDownloadAllTransactionsMutation__
 *
 * To run a mutation, you first call `useDownloadAllTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAllTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAllTransactionsMutation, { data, loading, error }] = useDownloadAllTransactionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadAllTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadAllTransactionsMutation, GraphqlTypes.DownloadAllTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadAllTransactionsMutation, GraphqlTypes.DownloadAllTransactionsMutationVariables>(DownloadAllTransactionsDocument, options);
      }
export type DownloadAllTransactionsMutationHookResult = ReturnType<typeof useDownloadAllTransactionsMutation>;
export type DownloadAllTransactionsMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadAllTransactionsMutation>;
export type DownloadAllTransactionsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadAllTransactionsMutation, GraphqlTypes.DownloadAllTransactionsMutationVariables>;
export const GetTransactionDownloadUrlDocument = gql`
    query GetTransactionDownloadUrl($input: ID!) {
  transactionDownloadUrl(asyncJobId: $input)
}
    `;

/**
 * __useGetTransactionDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetTransactionDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionDownloadUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTransactionDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTransactionDownloadUrlQuery, GraphqlTypes.GetTransactionDownloadUrlQueryVariables> & ({ variables: GraphqlTypes.GetTransactionDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTransactionDownloadUrlQuery, GraphqlTypes.GetTransactionDownloadUrlQueryVariables>(GetTransactionDownloadUrlDocument, options);
      }
export function useGetTransactionDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTransactionDownloadUrlQuery, GraphqlTypes.GetTransactionDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTransactionDownloadUrlQuery, GraphqlTypes.GetTransactionDownloadUrlQueryVariables>(GetTransactionDownloadUrlDocument, options);
        }
// @ts-ignore
export function useGetTransactionDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionDownloadUrlQuery, GraphqlTypes.GetTransactionDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionDownloadUrlQuery, GraphqlTypes.GetTransactionDownloadUrlQueryVariables>;
export function useGetTransactionDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionDownloadUrlQuery, GraphqlTypes.GetTransactionDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionDownloadUrlQuery | undefined, GraphqlTypes.GetTransactionDownloadUrlQueryVariables>;
export function useGetTransactionDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionDownloadUrlQuery, GraphqlTypes.GetTransactionDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTransactionDownloadUrlQuery, GraphqlTypes.GetTransactionDownloadUrlQueryVariables>(GetTransactionDownloadUrlDocument, options);
        }
export type GetTransactionDownloadUrlQueryHookResult = ReturnType<typeof useGetTransactionDownloadUrlQuery>;
export type GetTransactionDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetTransactionDownloadUrlLazyQuery>;
export type GetTransactionDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetTransactionDownloadUrlSuspenseQuery>;
export type GetTransactionDownloadUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetTransactionDownloadUrlQuery, GraphqlTypes.GetTransactionDownloadUrlQueryVariables>;
export const DownloadAllPositionsDocument = gql`
    mutation DownloadAllPositions($includeTaxIds: Boolean!, $includePaymentInfo: Boolean!, $showPositionTotalsByEntity: Boolean!) {
  positionOps {
    downloadAll(
      includeTaxIds: $includeTaxIds
      includePaymentInfo: $includePaymentInfo
      showPositionTotalsByEntity: $showPositionTotalsByEntity
    ) {
      job {
        id
      }
    }
  }
}
    `;
export type DownloadAllPositionsMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadAllPositionsMutation, GraphqlTypes.DownloadAllPositionsMutationVariables>;

/**
 * __useDownloadAllPositionsMutation__
 *
 * To run a mutation, you first call `useDownloadAllPositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAllPositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAllPositionsMutation, { data, loading, error }] = useDownloadAllPositionsMutation({
 *   variables: {
 *      includeTaxIds: // value for 'includeTaxIds'
 *      includePaymentInfo: // value for 'includePaymentInfo'
 *      showPositionTotalsByEntity: // value for 'showPositionTotalsByEntity'
 *   },
 * });
 */
export function useDownloadAllPositionsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadAllPositionsMutation, GraphqlTypes.DownloadAllPositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadAllPositionsMutation, GraphqlTypes.DownloadAllPositionsMutationVariables>(DownloadAllPositionsDocument, options);
      }
export type DownloadAllPositionsMutationHookResult = ReturnType<typeof useDownloadAllPositionsMutation>;
export type DownloadAllPositionsMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadAllPositionsMutation>;
export type DownloadAllPositionsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadAllPositionsMutation, GraphqlTypes.DownloadAllPositionsMutationVariables>;
export const GetPositionDownloadUrlDocument = gql`
    query GetPositionDownloadUrl($input: ID!) {
  positionDownloadUrl(asyncJobId: $input)
}
    `;

/**
 * __useGetPositionDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetPositionDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionDownloadUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPositionDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionDownloadUrlQuery, GraphqlTypes.GetPositionDownloadUrlQueryVariables> & ({ variables: GraphqlTypes.GetPositionDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionDownloadUrlQuery, GraphqlTypes.GetPositionDownloadUrlQueryVariables>(GetPositionDownloadUrlDocument, options);
      }
export function useGetPositionDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionDownloadUrlQuery, GraphqlTypes.GetPositionDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionDownloadUrlQuery, GraphqlTypes.GetPositionDownloadUrlQueryVariables>(GetPositionDownloadUrlDocument, options);
        }
// @ts-ignore
export function useGetPositionDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionDownloadUrlQuery, GraphqlTypes.GetPositionDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionDownloadUrlQuery, GraphqlTypes.GetPositionDownloadUrlQueryVariables>;
export function useGetPositionDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionDownloadUrlQuery, GraphqlTypes.GetPositionDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionDownloadUrlQuery | undefined, GraphqlTypes.GetPositionDownloadUrlQueryVariables>;
export function useGetPositionDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionDownloadUrlQuery, GraphqlTypes.GetPositionDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionDownloadUrlQuery, GraphqlTypes.GetPositionDownloadUrlQueryVariables>(GetPositionDownloadUrlDocument, options);
        }
export type GetPositionDownloadUrlQueryHookResult = ReturnType<typeof useGetPositionDownloadUrlQuery>;
export type GetPositionDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetPositionDownloadUrlLazyQuery>;
export type GetPositionDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetPositionDownloadUrlSuspenseQuery>;
export type GetPositionDownloadUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionDownloadUrlQuery, GraphqlTypes.GetPositionDownloadUrlQueryVariables>;
export const GetImportExportVisibilityDocument = gql`
    query GetImportExportVisibility {
  currentArena {
    id
    isGpLite
    packagingEdition {
      id
      name
    }
    features {
      hasFundAdmin
      hasManagementLedgerAndFees
      hasYardiImImport
      hasNetIncomeSettings
    }
  }
  transactionImportVisibility {
    allEntitiesShowOwnershipAsCommitment
    downloadGlobalData
    manageAccount
    manageInvestors
    navUsed
    privilegedManager
    viewAccount
    publishTransactions
  }
  userPermissions {
    canViewEntityGroups
    canViewContactGroups
  }
}
    `;

/**
 * __useGetImportExportVisibilityQuery__
 *
 * To run a query within a React component, call `useGetImportExportVisibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportExportVisibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportExportVisibilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetImportExportVisibilityQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetImportExportVisibilityQuery, GraphqlTypes.GetImportExportVisibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetImportExportVisibilityQuery, GraphqlTypes.GetImportExportVisibilityQueryVariables>(GetImportExportVisibilityDocument, options);
      }
export function useGetImportExportVisibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetImportExportVisibilityQuery, GraphqlTypes.GetImportExportVisibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetImportExportVisibilityQuery, GraphqlTypes.GetImportExportVisibilityQueryVariables>(GetImportExportVisibilityDocument, options);
        }
// @ts-ignore
export function useGetImportExportVisibilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportExportVisibilityQuery, GraphqlTypes.GetImportExportVisibilityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportExportVisibilityQuery, GraphqlTypes.GetImportExportVisibilityQueryVariables>;
export function useGetImportExportVisibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportExportVisibilityQuery, GraphqlTypes.GetImportExportVisibilityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportExportVisibilityQuery | undefined, GraphqlTypes.GetImportExportVisibilityQueryVariables>;
export function useGetImportExportVisibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportExportVisibilityQuery, GraphqlTypes.GetImportExportVisibilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetImportExportVisibilityQuery, GraphqlTypes.GetImportExportVisibilityQueryVariables>(GetImportExportVisibilityDocument, options);
        }
export type GetImportExportVisibilityQueryHookResult = ReturnType<typeof useGetImportExportVisibilityQuery>;
export type GetImportExportVisibilityLazyQueryHookResult = ReturnType<typeof useGetImportExportVisibilityLazyQuery>;
export type GetImportExportVisibilitySuspenseQueryHookResult = ReturnType<typeof useGetImportExportVisibilitySuspenseQuery>;
export type GetImportExportVisibilityQueryResult = Apollo.QueryResult<GraphqlTypes.GetImportExportVisibilityQuery, GraphqlTypes.GetImportExportVisibilityQueryVariables>;
export const ExportScheduleOfInvestmentDocument = gql`
    mutation ExportScheduleOfInvestment($entityIds: [ID]!, $filterDate: Date) {
  entityOps {
    exportSoi(entityIds: $entityIds, filterDate: $filterDate) {
      job {
        id
      }
    }
  }
}
    `;
export type ExportScheduleOfInvestmentMutationFn = Apollo.MutationFunction<GraphqlTypes.ExportScheduleOfInvestmentMutation, GraphqlTypes.ExportScheduleOfInvestmentMutationVariables>;

/**
 * __useExportScheduleOfInvestmentMutation__
 *
 * To run a mutation, you first call `useExportScheduleOfInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportScheduleOfInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportScheduleOfInvestmentMutation, { data, loading, error }] = useExportScheduleOfInvestmentMutation({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *      filterDate: // value for 'filterDate'
 *   },
 * });
 */
export function useExportScheduleOfInvestmentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExportScheduleOfInvestmentMutation, GraphqlTypes.ExportScheduleOfInvestmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExportScheduleOfInvestmentMutation, GraphqlTypes.ExportScheduleOfInvestmentMutationVariables>(ExportScheduleOfInvestmentDocument, options);
      }
export type ExportScheduleOfInvestmentMutationHookResult = ReturnType<typeof useExportScheduleOfInvestmentMutation>;
export type ExportScheduleOfInvestmentMutationResult = Apollo.MutationResult<GraphqlTypes.ExportScheduleOfInvestmentMutation>;
export type ExportScheduleOfInvestmentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExportScheduleOfInvestmentMutation, GraphqlTypes.ExportScheduleOfInvestmentMutationVariables>;
export const GetInvestmentEntityOpcosDocument = gql`
    query GetInvestmentEntityOpcos($entityId: ID!, $filterDate: Date) {
  investmentEntity(id: $entityId) {
    soiDisplayConfig {
      showSoiInLpPortal
      hideDateColumn
      hideUnitsColumn
      hideCostPerUnitColumn
      hideValuePerUnitColumn
      hideCostColumn
      hideFairValueColumn
      hideUnrealizedValueColumn
    }
    opCosIndirect(filterDate: $filterDate) {
      opcoId
      name
      soi {
        totals {
          ...SecurityFields
        }
        securities {
          name
          totals {
            ...SecurityFields
          }
          lots {
            totals {
              ...SecurityFields
            }
          }
        }
      }
      owningPositions {
        id
        status
        entityCurrency
      }
    }
  }
}
    ${SecurityFieldsFragmentDoc}`;

/**
 * __useGetInvestmentEntityOpcosQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntityOpcosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntityOpcosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntityOpcosQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      filterDate: // value for 'filterDate'
 *   },
 * });
 */
export function useGetInvestmentEntityOpcosQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntityOpcosQuery, GraphqlTypes.GetInvestmentEntityOpcosQueryVariables> & ({ variables: GraphqlTypes.GetInvestmentEntityOpcosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntityOpcosQuery, GraphqlTypes.GetInvestmentEntityOpcosQueryVariables>(GetInvestmentEntityOpcosDocument, options);
      }
export function useGetInvestmentEntityOpcosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntityOpcosQuery, GraphqlTypes.GetInvestmentEntityOpcosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntityOpcosQuery, GraphqlTypes.GetInvestmentEntityOpcosQueryVariables>(GetInvestmentEntityOpcosDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntityOpcosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityOpcosQuery, GraphqlTypes.GetInvestmentEntityOpcosQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityOpcosQuery, GraphqlTypes.GetInvestmentEntityOpcosQueryVariables>;
export function useGetInvestmentEntityOpcosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityOpcosQuery, GraphqlTypes.GetInvestmentEntityOpcosQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityOpcosQuery | undefined, GraphqlTypes.GetInvestmentEntityOpcosQueryVariables>;
export function useGetInvestmentEntityOpcosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityOpcosQuery, GraphqlTypes.GetInvestmentEntityOpcosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntityOpcosQuery, GraphqlTypes.GetInvestmentEntityOpcosQueryVariables>(GetInvestmentEntityOpcosDocument, options);
        }
export type GetInvestmentEntityOpcosQueryHookResult = ReturnType<typeof useGetInvestmentEntityOpcosQuery>;
export type GetInvestmentEntityOpcosLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntityOpcosLazyQuery>;
export type GetInvestmentEntityOpcosSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntityOpcosSuspenseQuery>;
export type GetInvestmentEntityOpcosQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntityOpcosQuery, GraphqlTypes.GetInvestmentEntityOpcosQueryVariables>;
export const GetEntityAccountingSoiExportUrlDocument = gql`
    query GetEntityAccountingSoiExportUrl($jobId: ID!) {
  entityAccountingSoiExportUrl(asyncJobId: $jobId)
}
    `;

/**
 * __useGetEntityAccountingSoiExportUrlQuery__
 *
 * To run a query within a React component, call `useGetEntityAccountingSoiExportUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityAccountingSoiExportUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityAccountingSoiExportUrlQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetEntityAccountingSoiExportUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityAccountingSoiExportUrlQuery, GraphqlTypes.GetEntityAccountingSoiExportUrlQueryVariables> & ({ variables: GraphqlTypes.GetEntityAccountingSoiExportUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityAccountingSoiExportUrlQuery, GraphqlTypes.GetEntityAccountingSoiExportUrlQueryVariables>(GetEntityAccountingSoiExportUrlDocument, options);
      }
export function useGetEntityAccountingSoiExportUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityAccountingSoiExportUrlQuery, GraphqlTypes.GetEntityAccountingSoiExportUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityAccountingSoiExportUrlQuery, GraphqlTypes.GetEntityAccountingSoiExportUrlQueryVariables>(GetEntityAccountingSoiExportUrlDocument, options);
        }
// @ts-ignore
export function useGetEntityAccountingSoiExportUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityAccountingSoiExportUrlQuery, GraphqlTypes.GetEntityAccountingSoiExportUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityAccountingSoiExportUrlQuery, GraphqlTypes.GetEntityAccountingSoiExportUrlQueryVariables>;
export function useGetEntityAccountingSoiExportUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityAccountingSoiExportUrlQuery, GraphqlTypes.GetEntityAccountingSoiExportUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityAccountingSoiExportUrlQuery | undefined, GraphqlTypes.GetEntityAccountingSoiExportUrlQueryVariables>;
export function useGetEntityAccountingSoiExportUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityAccountingSoiExportUrlQuery, GraphqlTypes.GetEntityAccountingSoiExportUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityAccountingSoiExportUrlQuery, GraphqlTypes.GetEntityAccountingSoiExportUrlQueryVariables>(GetEntityAccountingSoiExportUrlDocument, options);
        }
export type GetEntityAccountingSoiExportUrlQueryHookResult = ReturnType<typeof useGetEntityAccountingSoiExportUrlQuery>;
export type GetEntityAccountingSoiExportUrlLazyQueryHookResult = ReturnType<typeof useGetEntityAccountingSoiExportUrlLazyQuery>;
export type GetEntityAccountingSoiExportUrlSuspenseQueryHookResult = ReturnType<typeof useGetEntityAccountingSoiExportUrlSuspenseQuery>;
export type GetEntityAccountingSoiExportUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityAccountingSoiExportUrlQuery, GraphqlTypes.GetEntityAccountingSoiExportUrlQueryVariables>;
export const GetOwnedInvestmentEntitiesDocument = gql`
    query GetOwnedInvestmentEntities($entityId: ID!) {
  investmentEntity(id: $entityId) {
    id
    name
    ownedEntities {
      id
      name
    }
  }
}
    `;

/**
 * __useGetOwnedInvestmentEntitiesQuery__
 *
 * To run a query within a React component, call `useGetOwnedInvestmentEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnedInvestmentEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnedInvestmentEntitiesQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetOwnedInvestmentEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOwnedInvestmentEntitiesQuery, GraphqlTypes.GetOwnedInvestmentEntitiesQueryVariables> & ({ variables: GraphqlTypes.GetOwnedInvestmentEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOwnedInvestmentEntitiesQuery, GraphqlTypes.GetOwnedInvestmentEntitiesQueryVariables>(GetOwnedInvestmentEntitiesDocument, options);
      }
export function useGetOwnedInvestmentEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOwnedInvestmentEntitiesQuery, GraphqlTypes.GetOwnedInvestmentEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOwnedInvestmentEntitiesQuery, GraphqlTypes.GetOwnedInvestmentEntitiesQueryVariables>(GetOwnedInvestmentEntitiesDocument, options);
        }
// @ts-ignore
export function useGetOwnedInvestmentEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOwnedInvestmentEntitiesQuery, GraphqlTypes.GetOwnedInvestmentEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOwnedInvestmentEntitiesQuery, GraphqlTypes.GetOwnedInvestmentEntitiesQueryVariables>;
export function useGetOwnedInvestmentEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOwnedInvestmentEntitiesQuery, GraphqlTypes.GetOwnedInvestmentEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOwnedInvestmentEntitiesQuery | undefined, GraphqlTypes.GetOwnedInvestmentEntitiesQueryVariables>;
export function useGetOwnedInvestmentEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOwnedInvestmentEntitiesQuery, GraphqlTypes.GetOwnedInvestmentEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOwnedInvestmentEntitiesQuery, GraphqlTypes.GetOwnedInvestmentEntitiesQueryVariables>(GetOwnedInvestmentEntitiesDocument, options);
        }
export type GetOwnedInvestmentEntitiesQueryHookResult = ReturnType<typeof useGetOwnedInvestmentEntitiesQuery>;
export type GetOwnedInvestmentEntitiesLazyQueryHookResult = ReturnType<typeof useGetOwnedInvestmentEntitiesLazyQuery>;
export type GetOwnedInvestmentEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetOwnedInvestmentEntitiesSuspenseQuery>;
export type GetOwnedInvestmentEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetOwnedInvestmentEntitiesQuery, GraphqlTypes.GetOwnedInvestmentEntitiesQueryVariables>;
export const CreateAssetDocument = gql`
    mutation CreateAsset($entityId: ID!, $name: String!) {
  assetOps {
    createAsset(entityId: $entityId, name: $name) {
      asset {
        id
        name
        entity {
          id
        }
      }
    }
  }
}
    `;
export type CreateAssetMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateAssetMutation, GraphqlTypes.CreateAssetMutationVariables>;

/**
 * __useCreateAssetMutation__
 *
 * To run a mutation, you first call `useCreateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetMutation, { data, loading, error }] = useCreateAssetMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateAssetMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateAssetMutation, GraphqlTypes.CreateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateAssetMutation, GraphqlTypes.CreateAssetMutationVariables>(CreateAssetDocument, options);
      }
export type CreateAssetMutationHookResult = ReturnType<typeof useCreateAssetMutation>;
export type CreateAssetMutationResult = Apollo.MutationResult<GraphqlTypes.CreateAssetMutation>;
export type CreateAssetMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateAssetMutation, GraphqlTypes.CreateAssetMutationVariables>;
export const GetInvestmentEntityAccessGroupDocument = gql`
    query GetInvestmentEntityAccessGroup($entityId: ID!) {
  investmentEntity(id: $entityId) {
    entityAccessGroups {
      isFundAdmin
    }
  }
}
    `;

/**
 * __useGetInvestmentEntityAccessGroupQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntityAccessGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntityAccessGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntityAccessGroupQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetInvestmentEntityAccessGroupQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntityAccessGroupQuery, GraphqlTypes.GetInvestmentEntityAccessGroupQueryVariables> & ({ variables: GraphqlTypes.GetInvestmentEntityAccessGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntityAccessGroupQuery, GraphqlTypes.GetInvestmentEntityAccessGroupQueryVariables>(GetInvestmentEntityAccessGroupDocument, options);
      }
export function useGetInvestmentEntityAccessGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntityAccessGroupQuery, GraphqlTypes.GetInvestmentEntityAccessGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntityAccessGroupQuery, GraphqlTypes.GetInvestmentEntityAccessGroupQueryVariables>(GetInvestmentEntityAccessGroupDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntityAccessGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityAccessGroupQuery, GraphqlTypes.GetInvestmentEntityAccessGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityAccessGroupQuery, GraphqlTypes.GetInvestmentEntityAccessGroupQueryVariables>;
export function useGetInvestmentEntityAccessGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityAccessGroupQuery, GraphqlTypes.GetInvestmentEntityAccessGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityAccessGroupQuery | undefined, GraphqlTypes.GetInvestmentEntityAccessGroupQueryVariables>;
export function useGetInvestmentEntityAccessGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityAccessGroupQuery, GraphqlTypes.GetInvestmentEntityAccessGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntityAccessGroupQuery, GraphqlTypes.GetInvestmentEntityAccessGroupQueryVariables>(GetInvestmentEntityAccessGroupDocument, options);
        }
export type GetInvestmentEntityAccessGroupQueryHookResult = ReturnType<typeof useGetInvestmentEntityAccessGroupQuery>;
export type GetInvestmentEntityAccessGroupLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntityAccessGroupLazyQuery>;
export type GetInvestmentEntityAccessGroupSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntityAccessGroupSuspenseQuery>;
export type GetInvestmentEntityAccessGroupQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntityAccessGroupQuery, GraphqlTypes.GetInvestmentEntityAccessGroupQueryVariables>;
export const SetInvestmentEntityTwrStartingPeriodDocument = gql`
    mutation SetInvestmentEntityTWRStartingPeriod($objectType: String!, $objectId: ID!, $period: String, $year: Int) {
  entityOps {
    setTwrStartingPeriod(
      objectType: $objectType
      objectId: $objectId
      period: $period
      year: $year
    ) {
      objectId
      startDate
    }
  }
}
    `;
export type SetInvestmentEntityTwrStartingPeriodMutationFn = Apollo.MutationFunction<GraphqlTypes.SetInvestmentEntityTwrStartingPeriodMutation, GraphqlTypes.SetInvestmentEntityTwrStartingPeriodMutationVariables>;

/**
 * __useSetInvestmentEntityTwrStartingPeriodMutation__
 *
 * To run a mutation, you first call `useSetInvestmentEntityTwrStartingPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInvestmentEntityTwrStartingPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInvestmentEntityTwrStartingPeriodMutation, { data, loading, error }] = useSetInvestmentEntityTwrStartingPeriodMutation({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *      period: // value for 'period'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useSetInvestmentEntityTwrStartingPeriodMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetInvestmentEntityTwrStartingPeriodMutation, GraphqlTypes.SetInvestmentEntityTwrStartingPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetInvestmentEntityTwrStartingPeriodMutation, GraphqlTypes.SetInvestmentEntityTwrStartingPeriodMutationVariables>(SetInvestmentEntityTwrStartingPeriodDocument, options);
      }
export type SetInvestmentEntityTwrStartingPeriodMutationHookResult = ReturnType<typeof useSetInvestmentEntityTwrStartingPeriodMutation>;
export type SetInvestmentEntityTwrStartingPeriodMutationResult = Apollo.MutationResult<GraphqlTypes.SetInvestmentEntityTwrStartingPeriodMutation>;
export type SetInvestmentEntityTwrStartingPeriodMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetInvestmentEntityTwrStartingPeriodMutation, GraphqlTypes.SetInvestmentEntityTwrStartingPeriodMutationVariables>;
export const UploadEntityPhotosDocument = gql`
    mutation UploadEntityPhotos($input: UploadPhotoInput!) {
  entityOps {
    uploadEntityPhotos(uploadPhotoInput: $input) {
      photos {
        ...PhotoFields
      }
    }
  }
}
    ${PhotoFieldsFragmentDoc}`;
export type UploadEntityPhotosMutationFn = Apollo.MutationFunction<GraphqlTypes.UploadEntityPhotosMutation, GraphqlTypes.UploadEntityPhotosMutationVariables>;

/**
 * __useUploadEntityPhotosMutation__
 *
 * To run a mutation, you first call `useUploadEntityPhotosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEntityPhotosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEntityPhotosMutation, { data, loading, error }] = useUploadEntityPhotosMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadEntityPhotosMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UploadEntityPhotosMutation, GraphqlTypes.UploadEntityPhotosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UploadEntityPhotosMutation, GraphqlTypes.UploadEntityPhotosMutationVariables>(UploadEntityPhotosDocument, options);
      }
export type UploadEntityPhotosMutationHookResult = ReturnType<typeof useUploadEntityPhotosMutation>;
export type UploadEntityPhotosMutationResult = Apollo.MutationResult<GraphqlTypes.UploadEntityPhotosMutation>;
export type UploadEntityPhotosMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UploadEntityPhotosMutation, GraphqlTypes.UploadEntityPhotosMutationVariables>;
export const GetEntityPhotosDocument = gql`
    query GetEntityPhotos($entityId: ID!) {
  investmentEntity(id: $entityId) {
    id
    canEdit
    canLimitedEdit
    name
    primaryPhotoId
    photos {
      edges {
        node {
          ...PhotoFields
        }
      }
    }
  }
}
    ${PhotoFieldsFragmentDoc}`;

/**
 * __useGetEntityPhotosQuery__
 *
 * To run a query within a React component, call `useGetEntityPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityPhotosQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityPhotosQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityPhotosQuery, GraphqlTypes.GetEntityPhotosQueryVariables> & ({ variables: GraphqlTypes.GetEntityPhotosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityPhotosQuery, GraphqlTypes.GetEntityPhotosQueryVariables>(GetEntityPhotosDocument, options);
      }
export function useGetEntityPhotosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityPhotosQuery, GraphqlTypes.GetEntityPhotosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityPhotosQuery, GraphqlTypes.GetEntityPhotosQueryVariables>(GetEntityPhotosDocument, options);
        }
// @ts-ignore
export function useGetEntityPhotosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPhotosQuery, GraphqlTypes.GetEntityPhotosQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityPhotosQuery, GraphqlTypes.GetEntityPhotosQueryVariables>;
export function useGetEntityPhotosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPhotosQuery, GraphqlTypes.GetEntityPhotosQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityPhotosQuery | undefined, GraphqlTypes.GetEntityPhotosQueryVariables>;
export function useGetEntityPhotosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPhotosQuery, GraphqlTypes.GetEntityPhotosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityPhotosQuery, GraphqlTypes.GetEntityPhotosQueryVariables>(GetEntityPhotosDocument, options);
        }
export type GetEntityPhotosQueryHookResult = ReturnType<typeof useGetEntityPhotosQuery>;
export type GetEntityPhotosLazyQueryHookResult = ReturnType<typeof useGetEntityPhotosLazyQuery>;
export type GetEntityPhotosSuspenseQueryHookResult = ReturnType<typeof useGetEntityPhotosSuspenseQuery>;
export type GetEntityPhotosQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityPhotosQuery, GraphqlTypes.GetEntityPhotosQueryVariables>;
export const GetLegacyMenuDocument = gql`
    query GetLegacyMenu {
  currentArena {
    id
    isOnlineSubscriptionProvisioned
  }
}
    `;

/**
 * __useGetLegacyMenuQuery__
 *
 * To run a query within a React component, call `useGetLegacyMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLegacyMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLegacyMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLegacyMenuQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetLegacyMenuQuery, GraphqlTypes.GetLegacyMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLegacyMenuQuery, GraphqlTypes.GetLegacyMenuQueryVariables>(GetLegacyMenuDocument, options);
      }
export function useGetLegacyMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLegacyMenuQuery, GraphqlTypes.GetLegacyMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLegacyMenuQuery, GraphqlTypes.GetLegacyMenuQueryVariables>(GetLegacyMenuDocument, options);
        }
// @ts-ignore
export function useGetLegacyMenuSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLegacyMenuQuery, GraphqlTypes.GetLegacyMenuQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLegacyMenuQuery, GraphqlTypes.GetLegacyMenuQueryVariables>;
export function useGetLegacyMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLegacyMenuQuery, GraphqlTypes.GetLegacyMenuQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLegacyMenuQuery | undefined, GraphqlTypes.GetLegacyMenuQueryVariables>;
export function useGetLegacyMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLegacyMenuQuery, GraphqlTypes.GetLegacyMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLegacyMenuQuery, GraphqlTypes.GetLegacyMenuQueryVariables>(GetLegacyMenuDocument, options);
        }
export type GetLegacyMenuQueryHookResult = ReturnType<typeof useGetLegacyMenuQuery>;
export type GetLegacyMenuLazyQueryHookResult = ReturnType<typeof useGetLegacyMenuLazyQuery>;
export type GetLegacyMenuSuspenseQueryHookResult = ReturnType<typeof useGetLegacyMenuSuspenseQuery>;
export type GetLegacyMenuQueryResult = Apollo.QueryResult<GraphqlTypes.GetLegacyMenuQuery, GraphqlTypes.GetLegacyMenuQueryVariables>;
export const GetSupportContactInfoDocument = gql`
    query GetSupportContactInfo {
  currentArena {
    id
    supportEmail
    supportPhone
  }
}
    `;

/**
 * __useGetSupportContactInfoQuery__
 *
 * To run a query within a React component, call `useGetSupportContactInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportContactInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportContactInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportContactInfoQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetSupportContactInfoQuery, GraphqlTypes.GetSupportContactInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSupportContactInfoQuery, GraphqlTypes.GetSupportContactInfoQueryVariables>(GetSupportContactInfoDocument, options);
      }
export function useGetSupportContactInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSupportContactInfoQuery, GraphqlTypes.GetSupportContactInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSupportContactInfoQuery, GraphqlTypes.GetSupportContactInfoQueryVariables>(GetSupportContactInfoDocument, options);
        }
// @ts-ignore
export function useGetSupportContactInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSupportContactInfoQuery, GraphqlTypes.GetSupportContactInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSupportContactInfoQuery, GraphqlTypes.GetSupportContactInfoQueryVariables>;
export function useGetSupportContactInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSupportContactInfoQuery, GraphqlTypes.GetSupportContactInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSupportContactInfoQuery | undefined, GraphqlTypes.GetSupportContactInfoQueryVariables>;
export function useGetSupportContactInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSupportContactInfoQuery, GraphqlTypes.GetSupportContactInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSupportContactInfoQuery, GraphqlTypes.GetSupportContactInfoQueryVariables>(GetSupportContactInfoDocument, options);
        }
export type GetSupportContactInfoQueryHookResult = ReturnType<typeof useGetSupportContactInfoQuery>;
export type GetSupportContactInfoLazyQueryHookResult = ReturnType<typeof useGetSupportContactInfoLazyQuery>;
export type GetSupportContactInfoSuspenseQueryHookResult = ReturnType<typeof useGetSupportContactInfoSuspenseQuery>;
export type GetSupportContactInfoQueryResult = Apollo.QueryResult<GraphqlTypes.GetSupportContactInfoQuery, GraphqlTypes.GetSupportContactInfoQueryVariables>;
export const GeneratePerfMetricsDocument = gql`
    mutation GeneratePerfMetrics($entityId: ID) {
  perfMetricOps {
    generatePerfMetrics(entityId: $entityId) {
      perfMetricsJob {
        id
      }
    }
  }
}
    `;
export type GeneratePerfMetricsMutationFn = Apollo.MutationFunction<GraphqlTypes.GeneratePerfMetricsMutation, GraphqlTypes.GeneratePerfMetricsMutationVariables>;

/**
 * __useGeneratePerfMetricsMutation__
 *
 * To run a mutation, you first call `useGeneratePerfMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePerfMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePerfMetricsMutation, { data, loading, error }] = useGeneratePerfMetricsMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGeneratePerfMetricsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GeneratePerfMetricsMutation, GraphqlTypes.GeneratePerfMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GeneratePerfMetricsMutation, GraphqlTypes.GeneratePerfMetricsMutationVariables>(GeneratePerfMetricsDocument, options);
      }
export type GeneratePerfMetricsMutationHookResult = ReturnType<typeof useGeneratePerfMetricsMutation>;
export type GeneratePerfMetricsMutationResult = Apollo.MutationResult<GraphqlTypes.GeneratePerfMetricsMutation>;
export type GeneratePerfMetricsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GeneratePerfMetricsMutation, GraphqlTypes.GeneratePerfMetricsMutationVariables>;
export const GetOutOfDatePerfMetricsWarningDocument = gql`
    query GetOutOfDatePerfMetricsWarning {
  perfWarnings {
    defaultAsOfDateAggregatedWarnings {
      entities {
        id
        gpDisplayName
      }
      batches {
        ...TransactionInstanceBatchFields
      }
      perfAsOfDate
      perfLatestTransactionDate
    }
    customAsOfDateEntities {
      edges {
        node {
          id
          gpDisplayName
          perfWarnings {
            batches {
              ...TransactionInstanceBatchFields
            }
            perfAsOfDate
            perfLatestTransactionDate
          }
        }
      }
    }
  }
}
    ${TransactionInstanceBatchFieldsFragmentDoc}`;

/**
 * __useGetOutOfDatePerfMetricsWarningQuery__
 *
 * To run a query within a React component, call `useGetOutOfDatePerfMetricsWarningQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutOfDatePerfMetricsWarningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutOfDatePerfMetricsWarningQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOutOfDatePerfMetricsWarningQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetOutOfDatePerfMetricsWarningQuery, GraphqlTypes.GetOutOfDatePerfMetricsWarningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOutOfDatePerfMetricsWarningQuery, GraphqlTypes.GetOutOfDatePerfMetricsWarningQueryVariables>(GetOutOfDatePerfMetricsWarningDocument, options);
      }
export function useGetOutOfDatePerfMetricsWarningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOutOfDatePerfMetricsWarningQuery, GraphqlTypes.GetOutOfDatePerfMetricsWarningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOutOfDatePerfMetricsWarningQuery, GraphqlTypes.GetOutOfDatePerfMetricsWarningQueryVariables>(GetOutOfDatePerfMetricsWarningDocument, options);
        }
// @ts-ignore
export function useGetOutOfDatePerfMetricsWarningSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOutOfDatePerfMetricsWarningQuery, GraphqlTypes.GetOutOfDatePerfMetricsWarningQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOutOfDatePerfMetricsWarningQuery, GraphqlTypes.GetOutOfDatePerfMetricsWarningQueryVariables>;
export function useGetOutOfDatePerfMetricsWarningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOutOfDatePerfMetricsWarningQuery, GraphqlTypes.GetOutOfDatePerfMetricsWarningQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOutOfDatePerfMetricsWarningQuery | undefined, GraphqlTypes.GetOutOfDatePerfMetricsWarningQueryVariables>;
export function useGetOutOfDatePerfMetricsWarningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOutOfDatePerfMetricsWarningQuery, GraphqlTypes.GetOutOfDatePerfMetricsWarningQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOutOfDatePerfMetricsWarningQuery, GraphqlTypes.GetOutOfDatePerfMetricsWarningQueryVariables>(GetOutOfDatePerfMetricsWarningDocument, options);
        }
export type GetOutOfDatePerfMetricsWarningQueryHookResult = ReturnType<typeof useGetOutOfDatePerfMetricsWarningQuery>;
export type GetOutOfDatePerfMetricsWarningLazyQueryHookResult = ReturnType<typeof useGetOutOfDatePerfMetricsWarningLazyQuery>;
export type GetOutOfDatePerfMetricsWarningSuspenseQueryHookResult = ReturnType<typeof useGetOutOfDatePerfMetricsWarningSuspenseQuery>;
export type GetOutOfDatePerfMetricsWarningQueryResult = Apollo.QueryResult<GraphqlTypes.GetOutOfDatePerfMetricsWarningQuery, GraphqlTypes.GetOutOfDatePerfMetricsWarningQueryVariables>;
export const GetEntityHasCustomAsOfDateDocument = gql`
    query GetEntityHasCustomAsOfDate($entityId: ID!) {
  investmentEntity(id: $entityId) {
    id
    isPerfMetricsAsOfDateOverridden
  }
}
    `;

/**
 * __useGetEntityHasCustomAsOfDateQuery__
 *
 * To run a query within a React component, call `useGetEntityHasCustomAsOfDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityHasCustomAsOfDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityHasCustomAsOfDateQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityHasCustomAsOfDateQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityHasCustomAsOfDateQuery, GraphqlTypes.GetEntityHasCustomAsOfDateQueryVariables> & ({ variables: GraphqlTypes.GetEntityHasCustomAsOfDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityHasCustomAsOfDateQuery, GraphqlTypes.GetEntityHasCustomAsOfDateQueryVariables>(GetEntityHasCustomAsOfDateDocument, options);
      }
export function useGetEntityHasCustomAsOfDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityHasCustomAsOfDateQuery, GraphqlTypes.GetEntityHasCustomAsOfDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityHasCustomAsOfDateQuery, GraphqlTypes.GetEntityHasCustomAsOfDateQueryVariables>(GetEntityHasCustomAsOfDateDocument, options);
        }
// @ts-ignore
export function useGetEntityHasCustomAsOfDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityHasCustomAsOfDateQuery, GraphqlTypes.GetEntityHasCustomAsOfDateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityHasCustomAsOfDateQuery, GraphqlTypes.GetEntityHasCustomAsOfDateQueryVariables>;
export function useGetEntityHasCustomAsOfDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityHasCustomAsOfDateQuery, GraphqlTypes.GetEntityHasCustomAsOfDateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityHasCustomAsOfDateQuery | undefined, GraphqlTypes.GetEntityHasCustomAsOfDateQueryVariables>;
export function useGetEntityHasCustomAsOfDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityHasCustomAsOfDateQuery, GraphqlTypes.GetEntityHasCustomAsOfDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityHasCustomAsOfDateQuery, GraphqlTypes.GetEntityHasCustomAsOfDateQueryVariables>(GetEntityHasCustomAsOfDateDocument, options);
        }
export type GetEntityHasCustomAsOfDateQueryHookResult = ReturnType<typeof useGetEntityHasCustomAsOfDateQuery>;
export type GetEntityHasCustomAsOfDateLazyQueryHookResult = ReturnType<typeof useGetEntityHasCustomAsOfDateLazyQuery>;
export type GetEntityHasCustomAsOfDateSuspenseQueryHookResult = ReturnType<typeof useGetEntityHasCustomAsOfDateSuspenseQuery>;
export type GetEntityHasCustomAsOfDateQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityHasCustomAsOfDateQuery, GraphqlTypes.GetEntityHasCustomAsOfDateQueryVariables>;
export const SetPositionTwrStartingPeriodDocument = gql`
    mutation SetPositionTWRStartingPeriod($objectType: String!, $objectId: ID!, $period: String, $year: Int) {
  positionOps {
    setTwrStartingPeriod(
      objectType: $objectType
      objectId: $objectId
      period: $period
      year: $year
    ) {
      objectId
      startDate
    }
  }
}
    `;
export type SetPositionTwrStartingPeriodMutationFn = Apollo.MutationFunction<GraphqlTypes.SetPositionTwrStartingPeriodMutation, GraphqlTypes.SetPositionTwrStartingPeriodMutationVariables>;

/**
 * __useSetPositionTwrStartingPeriodMutation__
 *
 * To run a mutation, you first call `useSetPositionTwrStartingPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPositionTwrStartingPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPositionTwrStartingPeriodMutation, { data, loading, error }] = useSetPositionTwrStartingPeriodMutation({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *      period: // value for 'period'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useSetPositionTwrStartingPeriodMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetPositionTwrStartingPeriodMutation, GraphqlTypes.SetPositionTwrStartingPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetPositionTwrStartingPeriodMutation, GraphqlTypes.SetPositionTwrStartingPeriodMutationVariables>(SetPositionTwrStartingPeriodDocument, options);
      }
export type SetPositionTwrStartingPeriodMutationHookResult = ReturnType<typeof useSetPositionTwrStartingPeriodMutation>;
export type SetPositionTwrStartingPeriodMutationResult = Apollo.MutationResult<GraphqlTypes.SetPositionTwrStartingPeriodMutation>;
export type SetPositionTwrStartingPeriodMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetPositionTwrStartingPeriodMutation, GraphqlTypes.SetPositionTwrStartingPeriodMutationVariables>;
export const CreateTwrPeriodMetricDocument = gql`
    mutation CreateTwrPeriodMetric($objectType: String!, $objectId: ID!, $period: String!, $year: Int!, $objectInput: CreateOrUpdateTwrPeriodMetricInput!) {
  twrPeriodMetricOps {
    createTwrPeriodMetric(
      objectType: $objectType
      objectId: $objectId
      period: $period
      year: $year
      objectInput: $objectInput
    ) {
      twrPeriodMetricId
    }
  }
}
    `;
export type CreateTwrPeriodMetricMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateTwrPeriodMetricMutation, GraphqlTypes.CreateTwrPeriodMetricMutationVariables>;

/**
 * __useCreateTwrPeriodMetricMutation__
 *
 * To run a mutation, you first call `useCreateTwrPeriodMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTwrPeriodMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTwrPeriodMetricMutation, { data, loading, error }] = useCreateTwrPeriodMetricMutation({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *      period: // value for 'period'
 *      year: // value for 'year'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useCreateTwrPeriodMetricMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateTwrPeriodMetricMutation, GraphqlTypes.CreateTwrPeriodMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateTwrPeriodMetricMutation, GraphqlTypes.CreateTwrPeriodMetricMutationVariables>(CreateTwrPeriodMetricDocument, options);
      }
export type CreateTwrPeriodMetricMutationHookResult = ReturnType<typeof useCreateTwrPeriodMetricMutation>;
export type CreateTwrPeriodMetricMutationResult = Apollo.MutationResult<GraphqlTypes.CreateTwrPeriodMetricMutation>;
export type CreateTwrPeriodMetricMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateTwrPeriodMetricMutation, GraphqlTypes.CreateTwrPeriodMetricMutationVariables>;
export const RevertTwrPeriodMetricDocument = gql`
    mutation RevertTwrPeriodMetric($twrPeriodMetricId: ID!) {
  twrPeriodMetricOps {
    revertTwrPeriodMetricRow(twrPeriodMetricId: $twrPeriodMetricId) {
      twrPeriodMetricId
      isDeleted
    }
  }
}
    `;
export type RevertTwrPeriodMetricMutationFn = Apollo.MutationFunction<GraphqlTypes.RevertTwrPeriodMetricMutation, GraphqlTypes.RevertTwrPeriodMetricMutationVariables>;

/**
 * __useRevertTwrPeriodMetricMutation__
 *
 * To run a mutation, you first call `useRevertTwrPeriodMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertTwrPeriodMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertTwrPeriodMetricMutation, { data, loading, error }] = useRevertTwrPeriodMetricMutation({
 *   variables: {
 *      twrPeriodMetricId: // value for 'twrPeriodMetricId'
 *   },
 * });
 */
export function useRevertTwrPeriodMetricMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RevertTwrPeriodMetricMutation, GraphqlTypes.RevertTwrPeriodMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RevertTwrPeriodMetricMutation, GraphqlTypes.RevertTwrPeriodMetricMutationVariables>(RevertTwrPeriodMetricDocument, options);
      }
export type RevertTwrPeriodMetricMutationHookResult = ReturnType<typeof useRevertTwrPeriodMetricMutation>;
export type RevertTwrPeriodMetricMutationResult = Apollo.MutationResult<GraphqlTypes.RevertTwrPeriodMetricMutation>;
export type RevertTwrPeriodMetricMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RevertTwrPeriodMetricMutation, GraphqlTypes.RevertTwrPeriodMetricMutationVariables>;
export const UpdateTwrPeriodMetricDocument = gql`
    mutation UpdateTwrPeriodMetric($objectInput: CreateOrUpdateTwrPeriodMetricInput!, $twrPeriodMetricId: ID!) {
  twrPeriodMetricOps {
    updateTwrPeriodMetric(
      objectInput: $objectInput
      twrPeriodMetricId: $twrPeriodMetricId
    ) {
      twrPeriodMetricId
    }
  }
}
    `;
export type UpdateTwrPeriodMetricMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateTwrPeriodMetricMutation, GraphqlTypes.UpdateTwrPeriodMetricMutationVariables>;

/**
 * __useUpdateTwrPeriodMetricMutation__
 *
 * To run a mutation, you first call `useUpdateTwrPeriodMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTwrPeriodMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTwrPeriodMetricMutation, { data, loading, error }] = useUpdateTwrPeriodMetricMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *      twrPeriodMetricId: // value for 'twrPeriodMetricId'
 *   },
 * });
 */
export function useUpdateTwrPeriodMetricMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateTwrPeriodMetricMutation, GraphqlTypes.UpdateTwrPeriodMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateTwrPeriodMetricMutation, GraphqlTypes.UpdateTwrPeriodMetricMutationVariables>(UpdateTwrPeriodMetricDocument, options);
      }
export type UpdateTwrPeriodMetricMutationHookResult = ReturnType<typeof useUpdateTwrPeriodMetricMutation>;
export type UpdateTwrPeriodMetricMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateTwrPeriodMetricMutation>;
export type UpdateTwrPeriodMetricMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateTwrPeriodMetricMutation, GraphqlTypes.UpdateTwrPeriodMetricMutationVariables>;
export const GetPositionTwrMetricsDocument = gql`
    query GetPositionTwrMetrics($positionId: ID!) {
  position(id: $positionId) {
    id
    investmentEntity {
      id
      canEdit
    }
    twrEndDate
    twrStartDate
    twrCompoundingPeriod
    entityCurrency
    twrPeriodMetrics {
      id
      headers
      metrics {
        ...TwrPeriodMetric
      }
    }
    twrSummaryMetrics {
      id
      header {
        periodColumnName
        metricsColumnNames
      }
      rows {
        period
        metrics
      }
    }
  }
}
    ${TwrPeriodMetricFragmentDoc}`;

/**
 * __useGetPositionTwrMetricsQuery__
 *
 * To run a query within a React component, call `useGetPositionTwrMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionTwrMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionTwrMetricsQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useGetPositionTwrMetricsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionTwrMetricsQuery, GraphqlTypes.GetPositionTwrMetricsQueryVariables> & ({ variables: GraphqlTypes.GetPositionTwrMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionTwrMetricsQuery, GraphqlTypes.GetPositionTwrMetricsQueryVariables>(GetPositionTwrMetricsDocument, options);
      }
export function useGetPositionTwrMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionTwrMetricsQuery, GraphqlTypes.GetPositionTwrMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionTwrMetricsQuery, GraphqlTypes.GetPositionTwrMetricsQueryVariables>(GetPositionTwrMetricsDocument, options);
        }
// @ts-ignore
export function useGetPositionTwrMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionTwrMetricsQuery, GraphqlTypes.GetPositionTwrMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionTwrMetricsQuery, GraphqlTypes.GetPositionTwrMetricsQueryVariables>;
export function useGetPositionTwrMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionTwrMetricsQuery, GraphqlTypes.GetPositionTwrMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionTwrMetricsQuery | undefined, GraphqlTypes.GetPositionTwrMetricsQueryVariables>;
export function useGetPositionTwrMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionTwrMetricsQuery, GraphqlTypes.GetPositionTwrMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionTwrMetricsQuery, GraphqlTypes.GetPositionTwrMetricsQueryVariables>(GetPositionTwrMetricsDocument, options);
        }
export type GetPositionTwrMetricsQueryHookResult = ReturnType<typeof useGetPositionTwrMetricsQuery>;
export type GetPositionTwrMetricsLazyQueryHookResult = ReturnType<typeof useGetPositionTwrMetricsLazyQuery>;
export type GetPositionTwrMetricsSuspenseQueryHookResult = ReturnType<typeof useGetPositionTwrMetricsSuspenseQuery>;
export type GetPositionTwrMetricsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionTwrMetricsQuery, GraphqlTypes.GetPositionTwrMetricsQueryVariables>;
export const GetStaffInvestmentEntityTwrMetricsDocument = gql`
    query GetStaffInvestmentEntityTwrMetrics($accountId: ID!) {
  investmentEntity(id: $accountId) {
    id
    canEdit
    twrStartDate
    twrEndDate
    twrCompoundingPeriod
    perfMetricsPublished
    showTwrNetworkPortalOnly
    currency {
      id
      code
    }
    twrPeriodMetrics {
      id
      headers
      metrics {
        ...TwrPeriodMetric
      }
    }
    twrSummaryMetrics {
      id
      header {
        periodColumnName
        metricsColumnNames
      }
      rows {
        period
        metrics
      }
    }
  }
}
    ${TwrPeriodMetricFragmentDoc}`;

/**
 * __useGetStaffInvestmentEntityTwrMetricsQuery__
 *
 * To run a query within a React component, call `useGetStaffInvestmentEntityTwrMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffInvestmentEntityTwrMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffInvestmentEntityTwrMetricsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetStaffInvestmentEntityTwrMetricsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQuery, GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQueryVariables> & ({ variables: GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQuery, GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQueryVariables>(GetStaffInvestmentEntityTwrMetricsDocument, options);
      }
export function useGetStaffInvestmentEntityTwrMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQuery, GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQuery, GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQueryVariables>(GetStaffInvestmentEntityTwrMetricsDocument, options);
        }
// @ts-ignore
export function useGetStaffInvestmentEntityTwrMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQuery, GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQuery, GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQueryVariables>;
export function useGetStaffInvestmentEntityTwrMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQuery, GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQuery | undefined, GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQueryVariables>;
export function useGetStaffInvestmentEntityTwrMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQuery, GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQuery, GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQueryVariables>(GetStaffInvestmentEntityTwrMetricsDocument, options);
        }
export type GetStaffInvestmentEntityTwrMetricsQueryHookResult = ReturnType<typeof useGetStaffInvestmentEntityTwrMetricsQuery>;
export type GetStaffInvestmentEntityTwrMetricsLazyQueryHookResult = ReturnType<typeof useGetStaffInvestmentEntityTwrMetricsLazyQuery>;
export type GetStaffInvestmentEntityTwrMetricsSuspenseQueryHookResult = ReturnType<typeof useGetStaffInvestmentEntityTwrMetricsSuspenseQuery>;
export type GetStaffInvestmentEntityTwrMetricsQueryResult = Apollo.QueryResult<GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQuery, GraphqlTypes.GetStaffInvestmentEntityTwrMetricsQueryVariables>;
export const CreateNetNoticeLinkDocument = gql`
    mutation CreateNetNoticeLink($distributionBatchId: Int!, $capitalCallBatchId: Int!) {
  distributionOps {
    createNetNoticeLinkage(
      distributionBatchId: $distributionBatchId
      capitalCallBatchId: $capitalCallBatchId
    ) {
      matched
      ccOnly
      distOnly
      netCapitalCalls
      netDistributions
    }
  }
}
    `;
export type CreateNetNoticeLinkMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateNetNoticeLinkMutation, GraphqlTypes.CreateNetNoticeLinkMutationVariables>;

/**
 * __useCreateNetNoticeLinkMutation__
 *
 * To run a mutation, you first call `useCreateNetNoticeLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNetNoticeLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNetNoticeLinkMutation, { data, loading, error }] = useCreateNetNoticeLinkMutation({
 *   variables: {
 *      distributionBatchId: // value for 'distributionBatchId'
 *      capitalCallBatchId: // value for 'capitalCallBatchId'
 *   },
 * });
 */
export function useCreateNetNoticeLinkMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateNetNoticeLinkMutation, GraphqlTypes.CreateNetNoticeLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateNetNoticeLinkMutation, GraphqlTypes.CreateNetNoticeLinkMutationVariables>(CreateNetNoticeLinkDocument, options);
      }
export type CreateNetNoticeLinkMutationHookResult = ReturnType<typeof useCreateNetNoticeLinkMutation>;
export type CreateNetNoticeLinkMutationResult = Apollo.MutationResult<GraphqlTypes.CreateNetNoticeLinkMutation>;
export type CreateNetNoticeLinkMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateNetNoticeLinkMutation, GraphqlTypes.CreateNetNoticeLinkMutationVariables>;
export const RemoveNetNoticeLinkDocument = gql`
    mutation RemoveNetNoticeLink($distributionBatchId: Int, $capitalCallBatchId: Int) {
  distributionOps {
    removeNetNoticeLinkage(
      distributionBatchId: $distributionBatchId
      capitalCallBatchId: $capitalCallBatchId
    ) {
      unlinked
    }
  }
}
    `;
export type RemoveNetNoticeLinkMutationFn = Apollo.MutationFunction<GraphqlTypes.RemoveNetNoticeLinkMutation, GraphqlTypes.RemoveNetNoticeLinkMutationVariables>;

/**
 * __useRemoveNetNoticeLinkMutation__
 *
 * To run a mutation, you first call `useRemoveNetNoticeLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNetNoticeLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNetNoticeLinkMutation, { data, loading, error }] = useRemoveNetNoticeLinkMutation({
 *   variables: {
 *      distributionBatchId: // value for 'distributionBatchId'
 *      capitalCallBatchId: // value for 'capitalCallBatchId'
 *   },
 * });
 */
export function useRemoveNetNoticeLinkMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RemoveNetNoticeLinkMutation, GraphqlTypes.RemoveNetNoticeLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RemoveNetNoticeLinkMutation, GraphqlTypes.RemoveNetNoticeLinkMutationVariables>(RemoveNetNoticeLinkDocument, options);
      }
export type RemoveNetNoticeLinkMutationHookResult = ReturnType<typeof useRemoveNetNoticeLinkMutation>;
export type RemoveNetNoticeLinkMutationResult = Apollo.MutationResult<GraphqlTypes.RemoveNetNoticeLinkMutation>;
export type RemoveNetNoticeLinkMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RemoveNetNoticeLinkMutation, GraphqlTypes.RemoveNetNoticeLinkMutationVariables>;
export const GetDistributionForNetNoticeDocument = gql`
    query GetDistributionForNetNotice($entityId: ID!, $batchStatus: String!) {
  getNetNoticeLinkageDistributions(entityId: $entityId, batchStatus: $batchStatus) {
    ...DistributionBatchFields
    status
    instances {
      id
    }
  }
}
    ${DistributionBatchFieldsFragmentDoc}`;

/**
 * __useGetDistributionForNetNoticeQuery__
 *
 * To run a query within a React component, call `useGetDistributionForNetNoticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionForNetNoticeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionForNetNoticeQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      batchStatus: // value for 'batchStatus'
 *   },
 * });
 */
export function useGetDistributionForNetNoticeQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDistributionForNetNoticeQuery, GraphqlTypes.GetDistributionForNetNoticeQueryVariables> & ({ variables: GraphqlTypes.GetDistributionForNetNoticeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDistributionForNetNoticeQuery, GraphqlTypes.GetDistributionForNetNoticeQueryVariables>(GetDistributionForNetNoticeDocument, options);
      }
export function useGetDistributionForNetNoticeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDistributionForNetNoticeQuery, GraphqlTypes.GetDistributionForNetNoticeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDistributionForNetNoticeQuery, GraphqlTypes.GetDistributionForNetNoticeQueryVariables>(GetDistributionForNetNoticeDocument, options);
        }
// @ts-ignore
export function useGetDistributionForNetNoticeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionForNetNoticeQuery, GraphqlTypes.GetDistributionForNetNoticeQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionForNetNoticeQuery, GraphqlTypes.GetDistributionForNetNoticeQueryVariables>;
export function useGetDistributionForNetNoticeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionForNetNoticeQuery, GraphqlTypes.GetDistributionForNetNoticeQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionForNetNoticeQuery | undefined, GraphqlTypes.GetDistributionForNetNoticeQueryVariables>;
export function useGetDistributionForNetNoticeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionForNetNoticeQuery, GraphqlTypes.GetDistributionForNetNoticeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDistributionForNetNoticeQuery, GraphqlTypes.GetDistributionForNetNoticeQueryVariables>(GetDistributionForNetNoticeDocument, options);
        }
export type GetDistributionForNetNoticeQueryHookResult = ReturnType<typeof useGetDistributionForNetNoticeQuery>;
export type GetDistributionForNetNoticeLazyQueryHookResult = ReturnType<typeof useGetDistributionForNetNoticeLazyQuery>;
export type GetDistributionForNetNoticeSuspenseQueryHookResult = ReturnType<typeof useGetDistributionForNetNoticeSuspenseQuery>;
export type GetDistributionForNetNoticeQueryResult = Apollo.QueryResult<GraphqlTypes.GetDistributionForNetNoticeQuery, GraphqlTypes.GetDistributionForNetNoticeQueryVariables>;
export const GetCapitalCallForNetNoticeDocument = gql`
    query GetCapitalCallForNetNotice($entityId: ID!, $batchStatus: String!) {
  getNetNoticeLinkageCapitalCalls(entityId: $entityId, batchStatus: $batchStatus) {
    ...CapitalCallBatchFields
    status
    instances {
      id
    }
  }
}
    ${CapitalCallBatchFieldsFragmentDoc}`;

/**
 * __useGetCapitalCallForNetNoticeQuery__
 *
 * To run a query within a React component, call `useGetCapitalCallForNetNoticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapitalCallForNetNoticeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapitalCallForNetNoticeQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      batchStatus: // value for 'batchStatus'
 *   },
 * });
 */
export function useGetCapitalCallForNetNoticeQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCapitalCallForNetNoticeQuery, GraphqlTypes.GetCapitalCallForNetNoticeQueryVariables> & ({ variables: GraphqlTypes.GetCapitalCallForNetNoticeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCapitalCallForNetNoticeQuery, GraphqlTypes.GetCapitalCallForNetNoticeQueryVariables>(GetCapitalCallForNetNoticeDocument, options);
      }
export function useGetCapitalCallForNetNoticeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCapitalCallForNetNoticeQuery, GraphqlTypes.GetCapitalCallForNetNoticeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCapitalCallForNetNoticeQuery, GraphqlTypes.GetCapitalCallForNetNoticeQueryVariables>(GetCapitalCallForNetNoticeDocument, options);
        }
// @ts-ignore
export function useGetCapitalCallForNetNoticeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallForNetNoticeQuery, GraphqlTypes.GetCapitalCallForNetNoticeQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalCallForNetNoticeQuery, GraphqlTypes.GetCapitalCallForNetNoticeQueryVariables>;
export function useGetCapitalCallForNetNoticeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallForNetNoticeQuery, GraphqlTypes.GetCapitalCallForNetNoticeQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalCallForNetNoticeQuery | undefined, GraphqlTypes.GetCapitalCallForNetNoticeQueryVariables>;
export function useGetCapitalCallForNetNoticeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallForNetNoticeQuery, GraphqlTypes.GetCapitalCallForNetNoticeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCapitalCallForNetNoticeQuery, GraphqlTypes.GetCapitalCallForNetNoticeQueryVariables>(GetCapitalCallForNetNoticeDocument, options);
        }
export type GetCapitalCallForNetNoticeQueryHookResult = ReturnType<typeof useGetCapitalCallForNetNoticeQuery>;
export type GetCapitalCallForNetNoticeLazyQueryHookResult = ReturnType<typeof useGetCapitalCallForNetNoticeLazyQuery>;
export type GetCapitalCallForNetNoticeSuspenseQueryHookResult = ReturnType<typeof useGetCapitalCallForNetNoticeSuspenseQuery>;
export type GetCapitalCallForNetNoticeQueryResult = Apollo.QueryResult<GraphqlTypes.GetCapitalCallForNetNoticeQuery, GraphqlTypes.GetCapitalCallForNetNoticeQueryVariables>;
export const GetUploadFileEntityGroupsDocument = gql`
    query GetUploadFileEntityGroups($entityGroupId: ID!) {
  uploadFileEntityGroups(entityGroupId: $entityGroupId) {
    groupId
    groupName
    entities {
      entity {
        id
        name
        isPartial
      }
      positionCount
      firstPositionId
    }
  }
}
    `;

/**
 * __useGetUploadFileEntityGroupsQuery__
 *
 * To run a query within a React component, call `useGetUploadFileEntityGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadFileEntityGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadFileEntityGroupsQuery({
 *   variables: {
 *      entityGroupId: // value for 'entityGroupId'
 *   },
 * });
 */
export function useGetUploadFileEntityGroupsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUploadFileEntityGroupsQuery, GraphqlTypes.GetUploadFileEntityGroupsQueryVariables> & ({ variables: GraphqlTypes.GetUploadFileEntityGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUploadFileEntityGroupsQuery, GraphqlTypes.GetUploadFileEntityGroupsQueryVariables>(GetUploadFileEntityGroupsDocument, options);
      }
export function useGetUploadFileEntityGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUploadFileEntityGroupsQuery, GraphqlTypes.GetUploadFileEntityGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUploadFileEntityGroupsQuery, GraphqlTypes.GetUploadFileEntityGroupsQueryVariables>(GetUploadFileEntityGroupsDocument, options);
        }
// @ts-ignore
export function useGetUploadFileEntityGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUploadFileEntityGroupsQuery, GraphqlTypes.GetUploadFileEntityGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUploadFileEntityGroupsQuery, GraphqlTypes.GetUploadFileEntityGroupsQueryVariables>;
export function useGetUploadFileEntityGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUploadFileEntityGroupsQuery, GraphqlTypes.GetUploadFileEntityGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUploadFileEntityGroupsQuery | undefined, GraphqlTypes.GetUploadFileEntityGroupsQueryVariables>;
export function useGetUploadFileEntityGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUploadFileEntityGroupsQuery, GraphqlTypes.GetUploadFileEntityGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUploadFileEntityGroupsQuery, GraphqlTypes.GetUploadFileEntityGroupsQueryVariables>(GetUploadFileEntityGroupsDocument, options);
        }
export type GetUploadFileEntityGroupsQueryHookResult = ReturnType<typeof useGetUploadFileEntityGroupsQuery>;
export type GetUploadFileEntityGroupsLazyQueryHookResult = ReturnType<typeof useGetUploadFileEntityGroupsLazyQuery>;
export type GetUploadFileEntityGroupsSuspenseQueryHookResult = ReturnType<typeof useGetUploadFileEntityGroupsSuspenseQuery>;
export type GetUploadFileEntityGroupsQueryResult = Apollo.QueryResult<GraphqlTypes.GetUploadFileEntityGroupsQuery, GraphqlTypes.GetUploadFileEntityGroupsQueryVariables>;
export const GetEntityContributionStoredTotalsDocument = gql`
    query GetEntityContributionStoredTotals($entityId: ID!) {
  investmentEntity(id: $entityId) {
    id
    currency {
      id
      code
    }
    contributionStoredTotals {
      amount {
        monies
      }
      batchDate
    }
  }
}
    `;

/**
 * __useGetEntityContributionStoredTotalsQuery__
 *
 * To run a query within a React component, call `useGetEntityContributionStoredTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityContributionStoredTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityContributionStoredTotalsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityContributionStoredTotalsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityContributionStoredTotalsQuery, GraphqlTypes.GetEntityContributionStoredTotalsQueryVariables> & ({ variables: GraphqlTypes.GetEntityContributionStoredTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityContributionStoredTotalsQuery, GraphqlTypes.GetEntityContributionStoredTotalsQueryVariables>(GetEntityContributionStoredTotalsDocument, options);
      }
export function useGetEntityContributionStoredTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityContributionStoredTotalsQuery, GraphqlTypes.GetEntityContributionStoredTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityContributionStoredTotalsQuery, GraphqlTypes.GetEntityContributionStoredTotalsQueryVariables>(GetEntityContributionStoredTotalsDocument, options);
        }
// @ts-ignore
export function useGetEntityContributionStoredTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityContributionStoredTotalsQuery, GraphqlTypes.GetEntityContributionStoredTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityContributionStoredTotalsQuery, GraphqlTypes.GetEntityContributionStoredTotalsQueryVariables>;
export function useGetEntityContributionStoredTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityContributionStoredTotalsQuery, GraphqlTypes.GetEntityContributionStoredTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityContributionStoredTotalsQuery | undefined, GraphqlTypes.GetEntityContributionStoredTotalsQueryVariables>;
export function useGetEntityContributionStoredTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityContributionStoredTotalsQuery, GraphqlTypes.GetEntityContributionStoredTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityContributionStoredTotalsQuery, GraphqlTypes.GetEntityContributionStoredTotalsQueryVariables>(GetEntityContributionStoredTotalsDocument, options);
        }
export type GetEntityContributionStoredTotalsQueryHookResult = ReturnType<typeof useGetEntityContributionStoredTotalsQuery>;
export type GetEntityContributionStoredTotalsLazyQueryHookResult = ReturnType<typeof useGetEntityContributionStoredTotalsLazyQuery>;
export type GetEntityContributionStoredTotalsSuspenseQueryHookResult = ReturnType<typeof useGetEntityContributionStoredTotalsSuspenseQuery>;
export type GetEntityContributionStoredTotalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityContributionStoredTotalsQuery, GraphqlTypes.GetEntityContributionStoredTotalsQueryVariables>;
export const GetEntityDistributionStoredTotalsDocument = gql`
    query GetEntityDistributionStoredTotals($entityId: ID!) {
  investmentEntity(id: $entityId) {
    id
    currency {
      id
      code
    }
    distributionStoredTotals {
      amount {
        monies
      }
      batchDate
    }
  }
}
    `;

/**
 * __useGetEntityDistributionStoredTotalsQuery__
 *
 * To run a query within a React component, call `useGetEntityDistributionStoredTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityDistributionStoredTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityDistributionStoredTotalsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityDistributionStoredTotalsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityDistributionStoredTotalsQuery, GraphqlTypes.GetEntityDistributionStoredTotalsQueryVariables> & ({ variables: GraphqlTypes.GetEntityDistributionStoredTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityDistributionStoredTotalsQuery, GraphqlTypes.GetEntityDistributionStoredTotalsQueryVariables>(GetEntityDistributionStoredTotalsDocument, options);
      }
export function useGetEntityDistributionStoredTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityDistributionStoredTotalsQuery, GraphqlTypes.GetEntityDistributionStoredTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityDistributionStoredTotalsQuery, GraphqlTypes.GetEntityDistributionStoredTotalsQueryVariables>(GetEntityDistributionStoredTotalsDocument, options);
        }
// @ts-ignore
export function useGetEntityDistributionStoredTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDistributionStoredTotalsQuery, GraphqlTypes.GetEntityDistributionStoredTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityDistributionStoredTotalsQuery, GraphqlTypes.GetEntityDistributionStoredTotalsQueryVariables>;
export function useGetEntityDistributionStoredTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDistributionStoredTotalsQuery, GraphqlTypes.GetEntityDistributionStoredTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityDistributionStoredTotalsQuery | undefined, GraphqlTypes.GetEntityDistributionStoredTotalsQueryVariables>;
export function useGetEntityDistributionStoredTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDistributionStoredTotalsQuery, GraphqlTypes.GetEntityDistributionStoredTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityDistributionStoredTotalsQuery, GraphqlTypes.GetEntityDistributionStoredTotalsQueryVariables>(GetEntityDistributionStoredTotalsDocument, options);
        }
export type GetEntityDistributionStoredTotalsQueryHookResult = ReturnType<typeof useGetEntityDistributionStoredTotalsQuery>;
export type GetEntityDistributionStoredTotalsLazyQueryHookResult = ReturnType<typeof useGetEntityDistributionStoredTotalsLazyQuery>;
export type GetEntityDistributionStoredTotalsSuspenseQueryHookResult = ReturnType<typeof useGetEntityDistributionStoredTotalsSuspenseQuery>;
export type GetEntityDistributionStoredTotalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityDistributionStoredTotalsQuery, GraphqlTypes.GetEntityDistributionStoredTotalsQueryVariables>;
export const GetEntityNetIncomeStoredTotalsDocument = gql`
    query GetEntityNetIncomeStoredTotals($entityId: ID!) {
  investmentEntity(id: $entityId) {
    id
    currency {
      id
      code
    }
    netIncomeStoredTotals {
      amount {
        monies
      }
      batchDate
    }
  }
}
    `;

/**
 * __useGetEntityNetIncomeStoredTotalsQuery__
 *
 * To run a query within a React component, call `useGetEntityNetIncomeStoredTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityNetIncomeStoredTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityNetIncomeStoredTotalsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityNetIncomeStoredTotalsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityNetIncomeStoredTotalsQuery, GraphqlTypes.GetEntityNetIncomeStoredTotalsQueryVariables> & ({ variables: GraphqlTypes.GetEntityNetIncomeStoredTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityNetIncomeStoredTotalsQuery, GraphqlTypes.GetEntityNetIncomeStoredTotalsQueryVariables>(GetEntityNetIncomeStoredTotalsDocument, options);
      }
export function useGetEntityNetIncomeStoredTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityNetIncomeStoredTotalsQuery, GraphqlTypes.GetEntityNetIncomeStoredTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityNetIncomeStoredTotalsQuery, GraphqlTypes.GetEntityNetIncomeStoredTotalsQueryVariables>(GetEntityNetIncomeStoredTotalsDocument, options);
        }
// @ts-ignore
export function useGetEntityNetIncomeStoredTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityNetIncomeStoredTotalsQuery, GraphqlTypes.GetEntityNetIncomeStoredTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityNetIncomeStoredTotalsQuery, GraphqlTypes.GetEntityNetIncomeStoredTotalsQueryVariables>;
export function useGetEntityNetIncomeStoredTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityNetIncomeStoredTotalsQuery, GraphqlTypes.GetEntityNetIncomeStoredTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityNetIncomeStoredTotalsQuery | undefined, GraphqlTypes.GetEntityNetIncomeStoredTotalsQueryVariables>;
export function useGetEntityNetIncomeStoredTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityNetIncomeStoredTotalsQuery, GraphqlTypes.GetEntityNetIncomeStoredTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityNetIncomeStoredTotalsQuery, GraphqlTypes.GetEntityNetIncomeStoredTotalsQueryVariables>(GetEntityNetIncomeStoredTotalsDocument, options);
        }
export type GetEntityNetIncomeStoredTotalsQueryHookResult = ReturnType<typeof useGetEntityNetIncomeStoredTotalsQuery>;
export type GetEntityNetIncomeStoredTotalsLazyQueryHookResult = ReturnType<typeof useGetEntityNetIncomeStoredTotalsLazyQuery>;
export type GetEntityNetIncomeStoredTotalsSuspenseQueryHookResult = ReturnType<typeof useGetEntityNetIncomeStoredTotalsSuspenseQuery>;
export type GetEntityNetIncomeStoredTotalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityNetIncomeStoredTotalsQuery, GraphqlTypes.GetEntityNetIncomeStoredTotalsQueryVariables>;
export const GetEntityRedemptionStoredTotalsDocument = gql`
    query GetEntityRedemptionStoredTotals($entityId: ID!) {
  investmentEntity(id: $entityId) {
    id
    currency {
      id
      code
    }
    redemptionStoredTotals {
      amount {
        monies
      }
      batchDate
    }
  }
}
    `;

/**
 * __useGetEntityRedemptionStoredTotalsQuery__
 *
 * To run a query within a React component, call `useGetEntityRedemptionStoredTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityRedemptionStoredTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityRedemptionStoredTotalsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityRedemptionStoredTotalsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityRedemptionStoredTotalsQuery, GraphqlTypes.GetEntityRedemptionStoredTotalsQueryVariables> & ({ variables: GraphqlTypes.GetEntityRedemptionStoredTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityRedemptionStoredTotalsQuery, GraphqlTypes.GetEntityRedemptionStoredTotalsQueryVariables>(GetEntityRedemptionStoredTotalsDocument, options);
      }
export function useGetEntityRedemptionStoredTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityRedemptionStoredTotalsQuery, GraphqlTypes.GetEntityRedemptionStoredTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityRedemptionStoredTotalsQuery, GraphqlTypes.GetEntityRedemptionStoredTotalsQueryVariables>(GetEntityRedemptionStoredTotalsDocument, options);
        }
// @ts-ignore
export function useGetEntityRedemptionStoredTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityRedemptionStoredTotalsQuery, GraphqlTypes.GetEntityRedemptionStoredTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityRedemptionStoredTotalsQuery, GraphqlTypes.GetEntityRedemptionStoredTotalsQueryVariables>;
export function useGetEntityRedemptionStoredTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityRedemptionStoredTotalsQuery, GraphqlTypes.GetEntityRedemptionStoredTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityRedemptionStoredTotalsQuery | undefined, GraphqlTypes.GetEntityRedemptionStoredTotalsQueryVariables>;
export function useGetEntityRedemptionStoredTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityRedemptionStoredTotalsQuery, GraphqlTypes.GetEntityRedemptionStoredTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityRedemptionStoredTotalsQuery, GraphqlTypes.GetEntityRedemptionStoredTotalsQueryVariables>(GetEntityRedemptionStoredTotalsDocument, options);
        }
export type GetEntityRedemptionStoredTotalsQueryHookResult = ReturnType<typeof useGetEntityRedemptionStoredTotalsQuery>;
export type GetEntityRedemptionStoredTotalsLazyQueryHookResult = ReturnType<typeof useGetEntityRedemptionStoredTotalsLazyQuery>;
export type GetEntityRedemptionStoredTotalsSuspenseQueryHookResult = ReturnType<typeof useGetEntityRedemptionStoredTotalsSuspenseQuery>;
export type GetEntityRedemptionStoredTotalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityRedemptionStoredTotalsQuery, GraphqlTypes.GetEntityRedemptionStoredTotalsQueryVariables>;
export const GetReviewEntityTotalsDocument = gql`
    query GetReviewEntityTotals($entityId: ID!, $period: Period, $periodOptions: EntityTotalsPeriodOptions, $includePublishStatus: Boolean) {
  investmentEntity(id: $entityId) {
    id
    currency {
      id
      code
    }
    name
    entityTransactionTotals(
      period: $period
      periodOptions: $periodOptions
      includePublishStatus: $includePublishStatus
    ) {
      lifetimeCapitalContributed {
        monies
      }
      lifetimeCapitalOut {
        monies
      }
      lifetimeAmountDistributed {
        monies
      }
      lifetimeAmountPassedThrough {
        monies
      }
      capitalAccountBalance {
        monies
      }
      asOfDate
      hasAnyPublished
      hasAnyUnpublished
    }
    twrPeriodMetrics(period: $period) {
      metrics {
        ...GpLiteTwrPeriodMetric
      }
    }
  }
}
    ${GpLiteTwrPeriodMetricFragmentDoc}`;

/**
 * __useGetReviewEntityTotalsQuery__
 *
 * To run a query within a React component, call `useGetReviewEntityTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewEntityTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewEntityTotalsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      period: // value for 'period'
 *      periodOptions: // value for 'periodOptions'
 *      includePublishStatus: // value for 'includePublishStatus'
 *   },
 * });
 */
export function useGetReviewEntityTotalsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetReviewEntityTotalsQuery, GraphqlTypes.GetReviewEntityTotalsQueryVariables> & ({ variables: GraphqlTypes.GetReviewEntityTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReviewEntityTotalsQuery, GraphqlTypes.GetReviewEntityTotalsQueryVariables>(GetReviewEntityTotalsDocument, options);
      }
export function useGetReviewEntityTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReviewEntityTotalsQuery, GraphqlTypes.GetReviewEntityTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReviewEntityTotalsQuery, GraphqlTypes.GetReviewEntityTotalsQueryVariables>(GetReviewEntityTotalsDocument, options);
        }
// @ts-ignore
export function useGetReviewEntityTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewEntityTotalsQuery, GraphqlTypes.GetReviewEntityTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReviewEntityTotalsQuery, GraphqlTypes.GetReviewEntityTotalsQueryVariables>;
export function useGetReviewEntityTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewEntityTotalsQuery, GraphqlTypes.GetReviewEntityTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReviewEntityTotalsQuery | undefined, GraphqlTypes.GetReviewEntityTotalsQueryVariables>;
export function useGetReviewEntityTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewEntityTotalsQuery, GraphqlTypes.GetReviewEntityTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReviewEntityTotalsQuery, GraphqlTypes.GetReviewEntityTotalsQueryVariables>(GetReviewEntityTotalsDocument, options);
        }
export type GetReviewEntityTotalsQueryHookResult = ReturnType<typeof useGetReviewEntityTotalsQuery>;
export type GetReviewEntityTotalsLazyQueryHookResult = ReturnType<typeof useGetReviewEntityTotalsLazyQuery>;
export type GetReviewEntityTotalsSuspenseQueryHookResult = ReturnType<typeof useGetReviewEntityTotalsSuspenseQuery>;
export type GetReviewEntityTotalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetReviewEntityTotalsQuery, GraphqlTypes.GetReviewEntityTotalsQueryVariables>;
export const GetGpLiteEntityNetIncomesDocument = gql`
    query getGpLiteEntityNetIncomes($entityId: ID!, $period: Period!) {
  investmentEntity(id: $entityId) {
    id
    netIncomeStoredTotals(period: $period) {
      amount {
        monies
      }
      niType
    }
  }
}
    `;

/**
 * __useGetGpLiteEntityNetIncomesQuery__
 *
 * To run a query within a React component, call `useGetGpLiteEntityNetIncomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpLiteEntityNetIncomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpLiteEntityNetIncomesQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetGpLiteEntityNetIncomesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetGpLiteEntityNetIncomesQuery, GraphqlTypes.GetGpLiteEntityNetIncomesQueryVariables> & ({ variables: GraphqlTypes.GetGpLiteEntityNetIncomesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGpLiteEntityNetIncomesQuery, GraphqlTypes.GetGpLiteEntityNetIncomesQueryVariables>(GetGpLiteEntityNetIncomesDocument, options);
      }
export function useGetGpLiteEntityNetIncomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGpLiteEntityNetIncomesQuery, GraphqlTypes.GetGpLiteEntityNetIncomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGpLiteEntityNetIncomesQuery, GraphqlTypes.GetGpLiteEntityNetIncomesQueryVariables>(GetGpLiteEntityNetIncomesDocument, options);
        }
// @ts-ignore
export function useGetGpLiteEntityNetIncomesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpLiteEntityNetIncomesQuery, GraphqlTypes.GetGpLiteEntityNetIncomesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpLiteEntityNetIncomesQuery, GraphqlTypes.GetGpLiteEntityNetIncomesQueryVariables>;
export function useGetGpLiteEntityNetIncomesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpLiteEntityNetIncomesQuery, GraphqlTypes.GetGpLiteEntityNetIncomesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpLiteEntityNetIncomesQuery | undefined, GraphqlTypes.GetGpLiteEntityNetIncomesQueryVariables>;
export function useGetGpLiteEntityNetIncomesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpLiteEntityNetIncomesQuery, GraphqlTypes.GetGpLiteEntityNetIncomesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGpLiteEntityNetIncomesQuery, GraphqlTypes.GetGpLiteEntityNetIncomesQueryVariables>(GetGpLiteEntityNetIncomesDocument, options);
        }
export type GetGpLiteEntityNetIncomesQueryHookResult = ReturnType<typeof useGetGpLiteEntityNetIncomesQuery>;
export type GetGpLiteEntityNetIncomesLazyQueryHookResult = ReturnType<typeof useGetGpLiteEntityNetIncomesLazyQuery>;
export type GetGpLiteEntityNetIncomesSuspenseQueryHookResult = ReturnType<typeof useGetGpLiteEntityNetIncomesSuspenseQuery>;
export type GetGpLiteEntityNetIncomesQueryResult = Apollo.QueryResult<GraphqlTypes.GetGpLiteEntityNetIncomesQuery, GraphqlTypes.GetGpLiteEntityNetIncomesQueryVariables>;
export const GetPositionOwnershipDocument = gql`
    query GetPositionOwnership($positionId: ID!, $period: Period!) {
  position(id: $positionId) {
    id
    gpLiteTransactionTotals(period: $period) {
      percentOwnership: percentOwnershipAsOfEndDate
      endDateTransactionTotals {
        amountCommitted {
          monies
        }
      }
    }
  }
}
    `;

/**
 * __useGetPositionOwnershipQuery__
 *
 * To run a query within a React component, call `useGetPositionOwnershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionOwnershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionOwnershipQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetPositionOwnershipQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionOwnershipQuery, GraphqlTypes.GetPositionOwnershipQueryVariables> & ({ variables: GraphqlTypes.GetPositionOwnershipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionOwnershipQuery, GraphqlTypes.GetPositionOwnershipQueryVariables>(GetPositionOwnershipDocument, options);
      }
export function useGetPositionOwnershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionOwnershipQuery, GraphqlTypes.GetPositionOwnershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionOwnershipQuery, GraphqlTypes.GetPositionOwnershipQueryVariables>(GetPositionOwnershipDocument, options);
        }
// @ts-ignore
export function useGetPositionOwnershipSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionOwnershipQuery, GraphqlTypes.GetPositionOwnershipQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionOwnershipQuery, GraphqlTypes.GetPositionOwnershipQueryVariables>;
export function useGetPositionOwnershipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionOwnershipQuery, GraphqlTypes.GetPositionOwnershipQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionOwnershipQuery | undefined, GraphqlTypes.GetPositionOwnershipQueryVariables>;
export function useGetPositionOwnershipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionOwnershipQuery, GraphqlTypes.GetPositionOwnershipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionOwnershipQuery, GraphqlTypes.GetPositionOwnershipQueryVariables>(GetPositionOwnershipDocument, options);
        }
export type GetPositionOwnershipQueryHookResult = ReturnType<typeof useGetPositionOwnershipQuery>;
export type GetPositionOwnershipLazyQueryHookResult = ReturnType<typeof useGetPositionOwnershipLazyQuery>;
export type GetPositionOwnershipSuspenseQueryHookResult = ReturnType<typeof useGetPositionOwnershipSuspenseQuery>;
export type GetPositionOwnershipQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionOwnershipQuery, GraphqlTypes.GetPositionOwnershipQueryVariables>;
export const GetGpLitePositionDocument = gql`
    query GetGpLitePosition($positionId: ID!, $period: Period!) {
  position(id: $positionId) {
    id
    account {
      name
    }
    entityCurrency
    reportRequestType
    isIlpaGpReporting
    contributions(period: $period) {
      edges {
        node {
          id
          batch {
            effectiveDate
          }
          details {
            edges {
              node {
                id
                amount {
                  monies
                }
                transactionType {
                  id
                  affectsCommitment
                  excludeFromMetrics
                }
              }
            }
          }
        }
      }
    }
    redemptions(period: $period) {
      edges {
        node {
          id
          batch {
            effectiveDate
          }
          details {
            edges {
              node {
                id
                amount {
                  monies
                }
                transactionType {
                  id
                  affectsCommitment
                  excludeFromMetrics
                }
              }
            }
          }
        }
      }
    }
    distributions(period: $period) {
      edges {
        node {
          id
          batch {
            effectiveDate
          }
          amountDistributed {
            monies
          }
          amountRecallable {
            monies
          }
        }
      }
    }
    netIncomes(period: $period) {
      edges {
        node {
          id
          batch {
            effectiveDate
          }
          amount {
            monies
          }
        }
      }
    }
    gpLiteTransactionTotals(period: $period) {
      reportingPeriodStartDate
      reportingPeriodEndDate
      hasHistoricalTransactions
      publishStatusOfTransactions
      publishStatusOfDistributions
      publishStatusOfNetIncomes
      contributionsInPeriod {
        monies
      }
      redemptionsInPeriod {
        monies
      }
      distributionsInPeriod {
        monies
      }
      netIncomesInPeriod {
        monies
      }
      startDateTransactionTotals {
        capitalAccountBalance {
          monies
        }
        lifetimeCapitalContributed {
          monies
        }
        lifetimeCapitalOut {
          monies
        }
        lifetimeAmountDistributed {
          monies
        }
        lifetimeAmountPassedThrough {
          monies
        }
        amountRecallable {
          monies
        }
      }
      endDateTransactionTotals {
        unfundedCommitment {
          monies
        }
        capitalAccountBalance {
          monies
        }
        remainingRecallable {
          monies
        }
      }
    }
    twrPeriodMetrics(period: $period) {
      metrics {
        ...GpLiteTwrPeriodMetric
      }
    }
  }
}
    ${GpLiteTwrPeriodMetricFragmentDoc}`;

/**
 * __useGetGpLitePositionQuery__
 *
 * To run a query within a React component, call `useGetGpLitePositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpLitePositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpLitePositionQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetGpLitePositionQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetGpLitePositionQuery, GraphqlTypes.GetGpLitePositionQueryVariables> & ({ variables: GraphqlTypes.GetGpLitePositionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGpLitePositionQuery, GraphqlTypes.GetGpLitePositionQueryVariables>(GetGpLitePositionDocument, options);
      }
export function useGetGpLitePositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGpLitePositionQuery, GraphqlTypes.GetGpLitePositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGpLitePositionQuery, GraphqlTypes.GetGpLitePositionQueryVariables>(GetGpLitePositionDocument, options);
        }
// @ts-ignore
export function useGetGpLitePositionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpLitePositionQuery, GraphqlTypes.GetGpLitePositionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpLitePositionQuery, GraphqlTypes.GetGpLitePositionQueryVariables>;
export function useGetGpLitePositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpLitePositionQuery, GraphqlTypes.GetGpLitePositionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpLitePositionQuery | undefined, GraphqlTypes.GetGpLitePositionQueryVariables>;
export function useGetGpLitePositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpLitePositionQuery, GraphqlTypes.GetGpLitePositionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGpLitePositionQuery, GraphqlTypes.GetGpLitePositionQueryVariables>(GetGpLitePositionDocument, options);
        }
export type GetGpLitePositionQueryHookResult = ReturnType<typeof useGetGpLitePositionQuery>;
export type GetGpLitePositionLazyQueryHookResult = ReturnType<typeof useGetGpLitePositionLazyQuery>;
export type GetGpLitePositionSuspenseQueryHookResult = ReturnType<typeof useGetGpLitePositionSuspenseQuery>;
export type GetGpLitePositionQueryResult = Apollo.QueryResult<GraphqlTypes.GetGpLitePositionQuery, GraphqlTypes.GetGpLitePositionQueryVariables>;
export const GetGpLitePositionNetIncomesDocument = gql`
    query GetGpLitePositionNetIncomes($positionId: ID!, $period: Period!) {
  position(id: $positionId) {
    id
    netIncomes(period: $period) {
      edges {
        node {
          id
          details(publishedOnly: false) {
            edges {
              node {
                id
                transactionType {
                  id
                  niType
                }
                amount {
                  monies
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetGpLitePositionNetIncomesQuery__
 *
 * To run a query within a React component, call `useGetGpLitePositionNetIncomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpLitePositionNetIncomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpLitePositionNetIncomesQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetGpLitePositionNetIncomesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetGpLitePositionNetIncomesQuery, GraphqlTypes.GetGpLitePositionNetIncomesQueryVariables> & ({ variables: GraphqlTypes.GetGpLitePositionNetIncomesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGpLitePositionNetIncomesQuery, GraphqlTypes.GetGpLitePositionNetIncomesQueryVariables>(GetGpLitePositionNetIncomesDocument, options);
      }
export function useGetGpLitePositionNetIncomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGpLitePositionNetIncomesQuery, GraphqlTypes.GetGpLitePositionNetIncomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGpLitePositionNetIncomesQuery, GraphqlTypes.GetGpLitePositionNetIncomesQueryVariables>(GetGpLitePositionNetIncomesDocument, options);
        }
// @ts-ignore
export function useGetGpLitePositionNetIncomesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpLitePositionNetIncomesQuery, GraphqlTypes.GetGpLitePositionNetIncomesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpLitePositionNetIncomesQuery, GraphqlTypes.GetGpLitePositionNetIncomesQueryVariables>;
export function useGetGpLitePositionNetIncomesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpLitePositionNetIncomesQuery, GraphqlTypes.GetGpLitePositionNetIncomesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpLitePositionNetIncomesQuery | undefined, GraphqlTypes.GetGpLitePositionNetIncomesQueryVariables>;
export function useGetGpLitePositionNetIncomesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpLitePositionNetIncomesQuery, GraphqlTypes.GetGpLitePositionNetIncomesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGpLitePositionNetIncomesQuery, GraphqlTypes.GetGpLitePositionNetIncomesQueryVariables>(GetGpLitePositionNetIncomesDocument, options);
        }
export type GetGpLitePositionNetIncomesQueryHookResult = ReturnType<typeof useGetGpLitePositionNetIncomesQuery>;
export type GetGpLitePositionNetIncomesLazyQueryHookResult = ReturnType<typeof useGetGpLitePositionNetIncomesLazyQuery>;
export type GetGpLitePositionNetIncomesSuspenseQueryHookResult = ReturnType<typeof useGetGpLitePositionNetIncomesSuspenseQuery>;
export type GetGpLitePositionNetIncomesQueryResult = Apollo.QueryResult<GraphqlTypes.GetGpLitePositionNetIncomesQuery, GraphqlTypes.GetGpLitePositionNetIncomesQueryVariables>;
export const PublishTransactionDataDocument = gql`
    mutation publishTransactionData($fileIds: [ID!]!, $entityGroupId: ID!) {
  publishTransactionDataOps {
    publishTransactionData(fileIds: $fileIds, entityGroupId: $entityGroupId) {
      job {
        id
      }
    }
  }
}
    `;
export type PublishTransactionDataMutationFn = Apollo.MutationFunction<GraphqlTypes.PublishTransactionDataMutation, GraphqlTypes.PublishTransactionDataMutationVariables>;

/**
 * __usePublishTransactionDataMutation__
 *
 * To run a mutation, you first call `usePublishTransactionDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishTransactionDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishTransactionDataMutation, { data, loading, error }] = usePublishTransactionDataMutation({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *      entityGroupId: // value for 'entityGroupId'
 *   },
 * });
 */
export function usePublishTransactionDataMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PublishTransactionDataMutation, GraphqlTypes.PublishTransactionDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PublishTransactionDataMutation, GraphqlTypes.PublishTransactionDataMutationVariables>(PublishTransactionDataDocument, options);
      }
export type PublishTransactionDataMutationHookResult = ReturnType<typeof usePublishTransactionDataMutation>;
export type PublishTransactionDataMutationResult = Apollo.MutationResult<GraphqlTypes.PublishTransactionDataMutation>;
export type PublishTransactionDataMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PublishTransactionDataMutation, GraphqlTypes.PublishTransactionDataMutationVariables>;
export const DeleteFilesDocument = gql`
    mutation deleteFiles($fileIds: [ID!]!) {
  deleteUploadFileOps {
    deleteUploadFileAndTransactions(fileIds: $fileIds) {
      job {
        id
      }
    }
  }
}
    `;
export type DeleteFilesMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteFilesMutation, GraphqlTypes.DeleteFilesMutationVariables>;

/**
 * __useDeleteFilesMutation__
 *
 * To run a mutation, you first call `useDeleteFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilesMutation, { data, loading, error }] = useDeleteFilesMutation({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useDeleteFilesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteFilesMutation, GraphqlTypes.DeleteFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteFilesMutation, GraphqlTypes.DeleteFilesMutationVariables>(DeleteFilesDocument, options);
      }
export type DeleteFilesMutationHookResult = ReturnType<typeof useDeleteFilesMutation>;
export type DeleteFilesMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteFilesMutation>;
export type DeleteFilesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteFilesMutation, GraphqlTypes.DeleteFilesMutationVariables>;
export const GetUploadFileEntityGroupDocument = gql`
    query GetUploadFileEntityGroup($entityGroupId: ID!, $positionId: ID, $entityId: ID) {
  objectGroup(authorizedClass: entity, id: $entityGroupId) {
    id
    minimumReportingPeriod
  }
  uploadFileEntityGroup(
    entityGroupId: $entityGroupId
    positionId: $positionId
    entityId: $entityId
  ) {
    groupId
    groupName
    totalTransactions
    totalDistributions
    totalNetIncome
    entities {
      entity {
        id
        name
        isPartial
        owningInvestorPositionsDeprecated {
          id
          reportRequestType
          isIlpaGpReporting
          account {
            name
          }
        }
      }
      files {
        id
        fileName
        sheetName
        batchType
        createdAt
        createdByUser {
          emailAddress
          title
          firstName
          lastName
          middleName
        }
      }
    }
  }
}
    `;

/**
 * __useGetUploadFileEntityGroupQuery__
 *
 * To run a query within a React component, call `useGetUploadFileEntityGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadFileEntityGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadFileEntityGroupQuery({
 *   variables: {
 *      entityGroupId: // value for 'entityGroupId'
 *      positionId: // value for 'positionId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetUploadFileEntityGroupQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUploadFileEntityGroupQuery, GraphqlTypes.GetUploadFileEntityGroupQueryVariables> & ({ variables: GraphqlTypes.GetUploadFileEntityGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUploadFileEntityGroupQuery, GraphqlTypes.GetUploadFileEntityGroupQueryVariables>(GetUploadFileEntityGroupDocument, options);
      }
export function useGetUploadFileEntityGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUploadFileEntityGroupQuery, GraphqlTypes.GetUploadFileEntityGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUploadFileEntityGroupQuery, GraphqlTypes.GetUploadFileEntityGroupQueryVariables>(GetUploadFileEntityGroupDocument, options);
        }
// @ts-ignore
export function useGetUploadFileEntityGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUploadFileEntityGroupQuery, GraphqlTypes.GetUploadFileEntityGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUploadFileEntityGroupQuery, GraphqlTypes.GetUploadFileEntityGroupQueryVariables>;
export function useGetUploadFileEntityGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUploadFileEntityGroupQuery, GraphqlTypes.GetUploadFileEntityGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUploadFileEntityGroupQuery | undefined, GraphqlTypes.GetUploadFileEntityGroupQueryVariables>;
export function useGetUploadFileEntityGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUploadFileEntityGroupQuery, GraphqlTypes.GetUploadFileEntityGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUploadFileEntityGroupQuery, GraphqlTypes.GetUploadFileEntityGroupQueryVariables>(GetUploadFileEntityGroupDocument, options);
        }
export type GetUploadFileEntityGroupQueryHookResult = ReturnType<typeof useGetUploadFileEntityGroupQuery>;
export type GetUploadFileEntityGroupLazyQueryHookResult = ReturnType<typeof useGetUploadFileEntityGroupLazyQuery>;
export type GetUploadFileEntityGroupSuspenseQueryHookResult = ReturnType<typeof useGetUploadFileEntityGroupSuspenseQuery>;
export type GetUploadFileEntityGroupQueryResult = Apollo.QueryResult<GraphqlTypes.GetUploadFileEntityGroupQuery, GraphqlTypes.GetUploadFileEntityGroupQueryVariables>;
export const GetFilesDocument = gql`
    query GetFiles($entityGroupId: ID!, $positionId: ID, $entityId: ID, $objectType: JSQObjectType, $includePrior: Boolean, $includeCurrent: Boolean, $transactionSign: String) {
  uploadTransactionFiles(
    entityGroupId: $entityGroupId
    positionId: $positionId
    entityId: $entityId
    objectType: $objectType
    includePrior: $includePrior
    includeCurrent: $includeCurrent
    transactionSign: $transactionSign
  ) {
    edges {
      node {
        id
        fileName
        sheetName
        batchType
        createdAt
        createdByUser {
          emailAddress
          title
          firstName
          middleName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useGetFilesQuery__
 *
 * To run a query within a React component, call `useGetFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesQuery({
 *   variables: {
 *      entityGroupId: // value for 'entityGroupId'
 *      positionId: // value for 'positionId'
 *      entityId: // value for 'entityId'
 *      objectType: // value for 'objectType'
 *      includePrior: // value for 'includePrior'
 *      includeCurrent: // value for 'includeCurrent'
 *      transactionSign: // value for 'transactionSign'
 *   },
 * });
 */
export function useGetFilesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFilesQuery, GraphqlTypes.GetFilesQueryVariables> & ({ variables: GraphqlTypes.GetFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFilesQuery, GraphqlTypes.GetFilesQueryVariables>(GetFilesDocument, options);
      }
export function useGetFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFilesQuery, GraphqlTypes.GetFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFilesQuery, GraphqlTypes.GetFilesQueryVariables>(GetFilesDocument, options);
        }
// @ts-ignore
export function useGetFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFilesQuery, GraphqlTypes.GetFilesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFilesQuery, GraphqlTypes.GetFilesQueryVariables>;
export function useGetFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFilesQuery, GraphqlTypes.GetFilesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFilesQuery | undefined, GraphqlTypes.GetFilesQueryVariables>;
export function useGetFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFilesQuery, GraphqlTypes.GetFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFilesQuery, GraphqlTypes.GetFilesQueryVariables>(GetFilesDocument, options);
        }
export type GetFilesQueryHookResult = ReturnType<typeof useGetFilesQuery>;
export type GetFilesLazyQueryHookResult = ReturnType<typeof useGetFilesLazyQuery>;
export type GetFilesSuspenseQueryHookResult = ReturnType<typeof useGetFilesSuspenseQuery>;
export type GetFilesQueryResult = Apollo.QueryResult<GraphqlTypes.GetFilesQuery, GraphqlTypes.GetFilesQueryVariables>;
export const UpdateEmbeddedRecipientDocument = gql`
    mutation UpdateEmbeddedRecipient($arenaGlobalId: ID!, $subscriptionId: ID!, $token: String!, $event: String!) {
  subscriptionOps {
    updateEmbeddedRecipient(
      arenaGlobalId: $arenaGlobalId
      subscriptionId: $subscriptionId
      token: $token
      event: $event
    ) {
      success
    }
  }
}
    `;
export type UpdateEmbeddedRecipientMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateEmbeddedRecipientMutation, GraphqlTypes.UpdateEmbeddedRecipientMutationVariables>;

/**
 * __useUpdateEmbeddedRecipientMutation__
 *
 * To run a mutation, you first call `useUpdateEmbeddedRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmbeddedRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmbeddedRecipientMutation, { data, loading, error }] = useUpdateEmbeddedRecipientMutation({
 *   variables: {
 *      arenaGlobalId: // value for 'arenaGlobalId'
 *      subscriptionId: // value for 'subscriptionId'
 *      token: // value for 'token'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useUpdateEmbeddedRecipientMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateEmbeddedRecipientMutation, GraphqlTypes.UpdateEmbeddedRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateEmbeddedRecipientMutation, GraphqlTypes.UpdateEmbeddedRecipientMutationVariables>(UpdateEmbeddedRecipientDocument, options);
      }
export type UpdateEmbeddedRecipientMutationHookResult = ReturnType<typeof useUpdateEmbeddedRecipientMutation>;
export type UpdateEmbeddedRecipientMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateEmbeddedRecipientMutation>;
export type UpdateEmbeddedRecipientMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateEmbeddedRecipientMutation, GraphqlTypes.UpdateEmbeddedRecipientMutationVariables>;
export const GetCountersignInfoDocument = gql`
    query GetCountersignInfo($id: ID!) {
  subscription(id: $id) {
    id
    prospect {
      id
      offeringName
      title
      recipientView {
        url
        isComplete
      }
      additionalDocuments {
        lpDocumentVersionId
        lpDocumentName
        lpDocumentUploadedDate
      }
    }
  }
}
    `;

/**
 * __useGetCountersignInfoQuery__
 *
 * To run a query within a React component, call `useGetCountersignInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountersignInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountersignInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCountersignInfoQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCountersignInfoQuery, GraphqlTypes.GetCountersignInfoQueryVariables> & ({ variables: GraphqlTypes.GetCountersignInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCountersignInfoQuery, GraphqlTypes.GetCountersignInfoQueryVariables>(GetCountersignInfoDocument, options);
      }
export function useGetCountersignInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCountersignInfoQuery, GraphqlTypes.GetCountersignInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCountersignInfoQuery, GraphqlTypes.GetCountersignInfoQueryVariables>(GetCountersignInfoDocument, options);
        }
// @ts-ignore
export function useGetCountersignInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountersignInfoQuery, GraphqlTypes.GetCountersignInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountersignInfoQuery, GraphqlTypes.GetCountersignInfoQueryVariables>;
export function useGetCountersignInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountersignInfoQuery, GraphqlTypes.GetCountersignInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountersignInfoQuery | undefined, GraphqlTypes.GetCountersignInfoQueryVariables>;
export function useGetCountersignInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountersignInfoQuery, GraphqlTypes.GetCountersignInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCountersignInfoQuery, GraphqlTypes.GetCountersignInfoQueryVariables>(GetCountersignInfoDocument, options);
        }
export type GetCountersignInfoQueryHookResult = ReturnType<typeof useGetCountersignInfoQuery>;
export type GetCountersignInfoLazyQueryHookResult = ReturnType<typeof useGetCountersignInfoLazyQuery>;
export type GetCountersignInfoSuspenseQueryHookResult = ReturnType<typeof useGetCountersignInfoSuspenseQuery>;
export type GetCountersignInfoQueryResult = Apollo.QueryResult<GraphqlTypes.GetCountersignInfoQuery, GraphqlTypes.GetCountersignInfoQueryVariables>;
export const GetCountersignSoboDetailsDocument = gql`
    query GetCountersignSoboDetails($id: ID!) {
  subscription(id: $id) {
    id
    soboUserId
    soboUserEmailAddress
  }
  currentArena {
    id
    docusignUserId
  }
}
    `;

/**
 * __useGetCountersignSoboDetailsQuery__
 *
 * To run a query within a React component, call `useGetCountersignSoboDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountersignSoboDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountersignSoboDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCountersignSoboDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCountersignSoboDetailsQuery, GraphqlTypes.GetCountersignSoboDetailsQueryVariables> & ({ variables: GraphqlTypes.GetCountersignSoboDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCountersignSoboDetailsQuery, GraphqlTypes.GetCountersignSoboDetailsQueryVariables>(GetCountersignSoboDetailsDocument, options);
      }
export function useGetCountersignSoboDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCountersignSoboDetailsQuery, GraphqlTypes.GetCountersignSoboDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCountersignSoboDetailsQuery, GraphqlTypes.GetCountersignSoboDetailsQueryVariables>(GetCountersignSoboDetailsDocument, options);
        }
// @ts-ignore
export function useGetCountersignSoboDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountersignSoboDetailsQuery, GraphqlTypes.GetCountersignSoboDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountersignSoboDetailsQuery, GraphqlTypes.GetCountersignSoboDetailsQueryVariables>;
export function useGetCountersignSoboDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountersignSoboDetailsQuery, GraphqlTypes.GetCountersignSoboDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountersignSoboDetailsQuery | undefined, GraphqlTypes.GetCountersignSoboDetailsQueryVariables>;
export function useGetCountersignSoboDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountersignSoboDetailsQuery, GraphqlTypes.GetCountersignSoboDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCountersignSoboDetailsQuery, GraphqlTypes.GetCountersignSoboDetailsQueryVariables>(GetCountersignSoboDetailsDocument, options);
        }
export type GetCountersignSoboDetailsQueryHookResult = ReturnType<typeof useGetCountersignSoboDetailsQuery>;
export type GetCountersignSoboDetailsLazyQueryHookResult = ReturnType<typeof useGetCountersignSoboDetailsLazyQuery>;
export type GetCountersignSoboDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCountersignSoboDetailsSuspenseQuery>;
export type GetCountersignSoboDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetCountersignSoboDetailsQuery, GraphqlTypes.GetCountersignSoboDetailsQueryVariables>;
export const GetReportingPermissionsDocument = gql`
    query GetReportingPermissions {
  userPermissions {
    canViewEntityGroups
    canViewAccountGroups
    canViewContactGroups
    canViewOffering
  }
}
    `;

/**
 * __useGetReportingPermissionsQuery__
 *
 * To run a query within a React component, call `useGetReportingPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportingPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetReportingPermissionsQuery, GraphqlTypes.GetReportingPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReportingPermissionsQuery, GraphqlTypes.GetReportingPermissionsQueryVariables>(GetReportingPermissionsDocument, options);
      }
export function useGetReportingPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReportingPermissionsQuery, GraphqlTypes.GetReportingPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReportingPermissionsQuery, GraphqlTypes.GetReportingPermissionsQueryVariables>(GetReportingPermissionsDocument, options);
        }
// @ts-ignore
export function useGetReportingPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingPermissionsQuery, GraphqlTypes.GetReportingPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportingPermissionsQuery, GraphqlTypes.GetReportingPermissionsQueryVariables>;
export function useGetReportingPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingPermissionsQuery, GraphqlTypes.GetReportingPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportingPermissionsQuery | undefined, GraphqlTypes.GetReportingPermissionsQueryVariables>;
export function useGetReportingPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingPermissionsQuery, GraphqlTypes.GetReportingPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReportingPermissionsQuery, GraphqlTypes.GetReportingPermissionsQueryVariables>(GetReportingPermissionsDocument, options);
        }
export type GetReportingPermissionsQueryHookResult = ReturnType<typeof useGetReportingPermissionsQuery>;
export type GetReportingPermissionsLazyQueryHookResult = ReturnType<typeof useGetReportingPermissionsLazyQuery>;
export type GetReportingPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetReportingPermissionsSuspenseQuery>;
export type GetReportingPermissionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetReportingPermissionsQuery, GraphqlTypes.GetReportingPermissionsQueryVariables>;
export const SetLastViewedDashboardDocument = gql`
    mutation SetLastViewedDashboard($dashboardId: Int!) {
  userOps {
    setLastViewedDashboard(dashboardId: $dashboardId) {
      user {
        id
        lastViewedDashboardId
      }
    }
  }
}
    `;
export type SetLastViewedDashboardMutationFn = Apollo.MutationFunction<GraphqlTypes.SetLastViewedDashboardMutation, GraphqlTypes.SetLastViewedDashboardMutationVariables>;

/**
 * __useSetLastViewedDashboardMutation__
 *
 * To run a mutation, you first call `useSetLastViewedDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLastViewedDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLastViewedDashboardMutation, { data, loading, error }] = useSetLastViewedDashboardMutation({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useSetLastViewedDashboardMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetLastViewedDashboardMutation, GraphqlTypes.SetLastViewedDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetLastViewedDashboardMutation, GraphqlTypes.SetLastViewedDashboardMutationVariables>(SetLastViewedDashboardDocument, options);
      }
export type SetLastViewedDashboardMutationHookResult = ReturnType<typeof useSetLastViewedDashboardMutation>;
export type SetLastViewedDashboardMutationResult = Apollo.MutationResult<GraphqlTypes.SetLastViewedDashboardMutation>;
export type SetLastViewedDashboardMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetLastViewedDashboardMutation, GraphqlTypes.SetLastViewedDashboardMutationVariables>;
export const GetCurrentDashboardUserDocument = gql`
    query GetCurrentDashboardUser {
  currentUser {
    id
    lastViewedDashboardId
  }
}
    `;

/**
 * __useGetCurrentDashboardUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentDashboardUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentDashboardUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentDashboardUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentDashboardUserQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrentDashboardUserQuery, GraphqlTypes.GetCurrentDashboardUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrentDashboardUserQuery, GraphqlTypes.GetCurrentDashboardUserQueryVariables>(GetCurrentDashboardUserDocument, options);
      }
export function useGetCurrentDashboardUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrentDashboardUserQuery, GraphqlTypes.GetCurrentDashboardUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrentDashboardUserQuery, GraphqlTypes.GetCurrentDashboardUserQueryVariables>(GetCurrentDashboardUserDocument, options);
        }
// @ts-ignore
export function useGetCurrentDashboardUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentDashboardUserQuery, GraphqlTypes.GetCurrentDashboardUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentDashboardUserQuery, GraphqlTypes.GetCurrentDashboardUserQueryVariables>;
export function useGetCurrentDashboardUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentDashboardUserQuery, GraphqlTypes.GetCurrentDashboardUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentDashboardUserQuery | undefined, GraphqlTypes.GetCurrentDashboardUserQueryVariables>;
export function useGetCurrentDashboardUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentDashboardUserQuery, GraphqlTypes.GetCurrentDashboardUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrentDashboardUserQuery, GraphqlTypes.GetCurrentDashboardUserQueryVariables>(GetCurrentDashboardUserDocument, options);
        }
export type GetCurrentDashboardUserQueryHookResult = ReturnType<typeof useGetCurrentDashboardUserQuery>;
export type GetCurrentDashboardUserLazyQueryHookResult = ReturnType<typeof useGetCurrentDashboardUserLazyQuery>;
export type GetCurrentDashboardUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentDashboardUserSuspenseQuery>;
export type GetCurrentDashboardUserQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrentDashboardUserQuery, GraphqlTypes.GetCurrentDashboardUserQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($id: ID!) {
  staffUser(userId: $id) {
    id
    firstName
    lastName
    fullName
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUserQuery, GraphqlTypes.GetUserQueryVariables> & ({ variables: GraphqlTypes.GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUserQuery, GraphqlTypes.GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUserQuery, GraphqlTypes.GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUserQuery, GraphqlTypes.GetUserQueryVariables>(GetUserDocument, options);
        }
// @ts-ignore
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserQuery, GraphqlTypes.GetUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserQuery, GraphqlTypes.GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserQuery, GraphqlTypes.GetUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserQuery | undefined, GraphqlTypes.GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserQuery, GraphqlTypes.GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUserQuery, GraphqlTypes.GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GraphqlTypes.GetUserQuery, GraphqlTypes.GetUserQueryVariables>;
export const GetReportingDashboardArenaFeatureFlagsDocument = gql`
    query GetReportingDashboardArenaFeatureFlags($arenaDomain: String!) {
  arenaFeatures(arenaDomain: $arenaDomain) {
    hasReportDashboardM3
    hasReportDashboardM4
  }
}
    `;

/**
 * __useGetReportingDashboardArenaFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetReportingDashboardArenaFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingDashboardArenaFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingDashboardArenaFeatureFlagsQuery({
 *   variables: {
 *      arenaDomain: // value for 'arenaDomain'
 *   },
 * });
 */
export function useGetReportingDashboardArenaFeatureFlagsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQuery, GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQueryVariables> & ({ variables: GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQuery, GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQueryVariables>(GetReportingDashboardArenaFeatureFlagsDocument, options);
      }
export function useGetReportingDashboardArenaFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQuery, GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQuery, GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQueryVariables>(GetReportingDashboardArenaFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useGetReportingDashboardArenaFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQuery, GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQuery, GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQueryVariables>;
export function useGetReportingDashboardArenaFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQuery, GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQuery | undefined, GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQueryVariables>;
export function useGetReportingDashboardArenaFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQuery, GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQuery, GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQueryVariables>(GetReportingDashboardArenaFeatureFlagsDocument, options);
        }
export type GetReportingDashboardArenaFeatureFlagsQueryHookResult = ReturnType<typeof useGetReportingDashboardArenaFeatureFlagsQuery>;
export type GetReportingDashboardArenaFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetReportingDashboardArenaFeatureFlagsLazyQuery>;
export type GetReportingDashboardArenaFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useGetReportingDashboardArenaFeatureFlagsSuspenseQuery>;
export type GetReportingDashboardArenaFeatureFlagsQueryResult = Apollo.QueryResult<GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQuery, GraphqlTypes.GetReportingDashboardArenaFeatureFlagsQueryVariables>;
export const GetCapitalCallTransactionTypesDocument = gql`
    query GetCapitalCallTransactionTypes {
  contributionTypes: transactionTypes(signEffect: positive, isSubType: true) {
    id
    name
    sortOrder
  }
}
    `;

/**
 * __useGetCapitalCallTransactionTypesQuery__
 *
 * To run a query within a React component, call `useGetCapitalCallTransactionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapitalCallTransactionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapitalCallTransactionTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCapitalCallTransactionTypesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCapitalCallTransactionTypesQuery, GraphqlTypes.GetCapitalCallTransactionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCapitalCallTransactionTypesQuery, GraphqlTypes.GetCapitalCallTransactionTypesQueryVariables>(GetCapitalCallTransactionTypesDocument, options);
      }
export function useGetCapitalCallTransactionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCapitalCallTransactionTypesQuery, GraphqlTypes.GetCapitalCallTransactionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCapitalCallTransactionTypesQuery, GraphqlTypes.GetCapitalCallTransactionTypesQueryVariables>(GetCapitalCallTransactionTypesDocument, options);
        }
// @ts-ignore
export function useGetCapitalCallTransactionTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallTransactionTypesQuery, GraphqlTypes.GetCapitalCallTransactionTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalCallTransactionTypesQuery, GraphqlTypes.GetCapitalCallTransactionTypesQueryVariables>;
export function useGetCapitalCallTransactionTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallTransactionTypesQuery, GraphqlTypes.GetCapitalCallTransactionTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalCallTransactionTypesQuery | undefined, GraphqlTypes.GetCapitalCallTransactionTypesQueryVariables>;
export function useGetCapitalCallTransactionTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalCallTransactionTypesQuery, GraphqlTypes.GetCapitalCallTransactionTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCapitalCallTransactionTypesQuery, GraphqlTypes.GetCapitalCallTransactionTypesQueryVariables>(GetCapitalCallTransactionTypesDocument, options);
        }
export type GetCapitalCallTransactionTypesQueryHookResult = ReturnType<typeof useGetCapitalCallTransactionTypesQuery>;
export type GetCapitalCallTransactionTypesLazyQueryHookResult = ReturnType<typeof useGetCapitalCallTransactionTypesLazyQuery>;
export type GetCapitalCallTransactionTypesSuspenseQueryHookResult = ReturnType<typeof useGetCapitalCallTransactionTypesSuspenseQuery>;
export type GetCapitalCallTransactionTypesQueryResult = Apollo.QueryResult<GraphqlTypes.GetCapitalCallTransactionTypesQuery, GraphqlTypes.GetCapitalCallTransactionTypesQueryVariables>;
export const GetFundraiseReadinessStatusDocument = gql`
    query GetFundraiseReadinessStatus {
  emailSettings {
    id
    smtpPasswordIsSet
  }
  currentArena {
    id
    docusignSoboUserStatus
    subscriptionDocumentCategory {
      name
    }
  }
}
    `;

/**
 * __useGetFundraiseReadinessStatusQuery__
 *
 * To run a query within a React component, call `useGetFundraiseReadinessStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundraiseReadinessStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundraiseReadinessStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFundraiseReadinessStatusQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetFundraiseReadinessStatusQuery, GraphqlTypes.GetFundraiseReadinessStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFundraiseReadinessStatusQuery, GraphqlTypes.GetFundraiseReadinessStatusQueryVariables>(GetFundraiseReadinessStatusDocument, options);
      }
export function useGetFundraiseReadinessStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFundraiseReadinessStatusQuery, GraphqlTypes.GetFundraiseReadinessStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFundraiseReadinessStatusQuery, GraphqlTypes.GetFundraiseReadinessStatusQueryVariables>(GetFundraiseReadinessStatusDocument, options);
        }
// @ts-ignore
export function useGetFundraiseReadinessStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundraiseReadinessStatusQuery, GraphqlTypes.GetFundraiseReadinessStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundraiseReadinessStatusQuery, GraphqlTypes.GetFundraiseReadinessStatusQueryVariables>;
export function useGetFundraiseReadinessStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundraiseReadinessStatusQuery, GraphqlTypes.GetFundraiseReadinessStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundraiseReadinessStatusQuery | undefined, GraphqlTypes.GetFundraiseReadinessStatusQueryVariables>;
export function useGetFundraiseReadinessStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundraiseReadinessStatusQuery, GraphqlTypes.GetFundraiseReadinessStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFundraiseReadinessStatusQuery, GraphqlTypes.GetFundraiseReadinessStatusQueryVariables>(GetFundraiseReadinessStatusDocument, options);
        }
export type GetFundraiseReadinessStatusQueryHookResult = ReturnType<typeof useGetFundraiseReadinessStatusQuery>;
export type GetFundraiseReadinessStatusLazyQueryHookResult = ReturnType<typeof useGetFundraiseReadinessStatusLazyQuery>;
export type GetFundraiseReadinessStatusSuspenseQueryHookResult = ReturnType<typeof useGetFundraiseReadinessStatusSuspenseQuery>;
export type GetFundraiseReadinessStatusQueryResult = Apollo.QueryResult<GraphqlTypes.GetFundraiseReadinessStatusQuery, GraphqlTypes.GetFundraiseReadinessStatusQueryVariables>;
export const GetDocumentCategoriesForArenaDocument = gql`
    query GetDocumentCategoriesForArena($filters: DocumentCategoriesFilters) {
  documentCategories(filters: $filters) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetDocumentCategoriesForArenaQuery__
 *
 * To run a query within a React component, call `useGetDocumentCategoriesForArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentCategoriesForArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentCategoriesForArenaQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDocumentCategoriesForArenaQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentCategoriesForArenaQuery, GraphqlTypes.GetDocumentCategoriesForArenaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentCategoriesForArenaQuery, GraphqlTypes.GetDocumentCategoriesForArenaQueryVariables>(GetDocumentCategoriesForArenaDocument, options);
      }
export function useGetDocumentCategoriesForArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForArenaQuery, GraphqlTypes.GetDocumentCategoriesForArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentCategoriesForArenaQuery, GraphqlTypes.GetDocumentCategoriesForArenaQueryVariables>(GetDocumentCategoriesForArenaDocument, options);
        }
// @ts-ignore
export function useGetDocumentCategoriesForArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForArenaQuery, GraphqlTypes.GetDocumentCategoriesForArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentCategoriesForArenaQuery, GraphqlTypes.GetDocumentCategoriesForArenaQueryVariables>;
export function useGetDocumentCategoriesForArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForArenaQuery, GraphqlTypes.GetDocumentCategoriesForArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentCategoriesForArenaQuery | undefined, GraphqlTypes.GetDocumentCategoriesForArenaQueryVariables>;
export function useGetDocumentCategoriesForArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForArenaQuery, GraphqlTypes.GetDocumentCategoriesForArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentCategoriesForArenaQuery, GraphqlTypes.GetDocumentCategoriesForArenaQueryVariables>(GetDocumentCategoriesForArenaDocument, options);
        }
export type GetDocumentCategoriesForArenaQueryHookResult = ReturnType<typeof useGetDocumentCategoriesForArenaQuery>;
export type GetDocumentCategoriesForArenaLazyQueryHookResult = ReturnType<typeof useGetDocumentCategoriesForArenaLazyQuery>;
export type GetDocumentCategoriesForArenaSuspenseQueryHookResult = ReturnType<typeof useGetDocumentCategoriesForArenaSuspenseQuery>;
export type GetDocumentCategoriesForArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentCategoriesForArenaQuery, GraphqlTypes.GetDocumentCategoriesForArenaQueryVariables>;
export const GetRedemptionPaymentOptionsDocument = gql`
    query GetRedemptionPaymentOptions($accountId: ID!, $positionId: ID!) {
  account(id: $accountId) {
    id
    paymentPrefs {
      id
      paymentMethod
      bankInfoRedacted
      verificationStatus
      checkAddrCity
      checkAddrRegion
      checkAddrState {
        id
        name
      }
    }
  }
  position(id: $positionId) {
    id
    paymentPref {
      id
    }
  }
}
    `;

/**
 * __useGetRedemptionPaymentOptionsQuery__
 *
 * To run a query within a React component, call `useGetRedemptionPaymentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRedemptionPaymentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRedemptionPaymentOptionsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useGetRedemptionPaymentOptionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetRedemptionPaymentOptionsQuery, GraphqlTypes.GetRedemptionPaymentOptionsQueryVariables> & ({ variables: GraphqlTypes.GetRedemptionPaymentOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRedemptionPaymentOptionsQuery, GraphqlTypes.GetRedemptionPaymentOptionsQueryVariables>(GetRedemptionPaymentOptionsDocument, options);
      }
export function useGetRedemptionPaymentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRedemptionPaymentOptionsQuery, GraphqlTypes.GetRedemptionPaymentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRedemptionPaymentOptionsQuery, GraphqlTypes.GetRedemptionPaymentOptionsQueryVariables>(GetRedemptionPaymentOptionsDocument, options);
        }
// @ts-ignore
export function useGetRedemptionPaymentOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRedemptionPaymentOptionsQuery, GraphqlTypes.GetRedemptionPaymentOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRedemptionPaymentOptionsQuery, GraphqlTypes.GetRedemptionPaymentOptionsQueryVariables>;
export function useGetRedemptionPaymentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRedemptionPaymentOptionsQuery, GraphqlTypes.GetRedemptionPaymentOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRedemptionPaymentOptionsQuery | undefined, GraphqlTypes.GetRedemptionPaymentOptionsQueryVariables>;
export function useGetRedemptionPaymentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRedemptionPaymentOptionsQuery, GraphqlTypes.GetRedemptionPaymentOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRedemptionPaymentOptionsQuery, GraphqlTypes.GetRedemptionPaymentOptionsQueryVariables>(GetRedemptionPaymentOptionsDocument, options);
        }
export type GetRedemptionPaymentOptionsQueryHookResult = ReturnType<typeof useGetRedemptionPaymentOptionsQuery>;
export type GetRedemptionPaymentOptionsLazyQueryHookResult = ReturnType<typeof useGetRedemptionPaymentOptionsLazyQuery>;
export type GetRedemptionPaymentOptionsSuspenseQueryHookResult = ReturnType<typeof useGetRedemptionPaymentOptionsSuspenseQuery>;
export type GetRedemptionPaymentOptionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetRedemptionPaymentOptionsQuery, GraphqlTypes.GetRedemptionPaymentOptionsQueryVariables>;
export const SearchInvestorPositionsDocument = gql`
    query SearchInvestorPositions($entityId: ID!, $term: String!, $first: Int, $after: String) {
  searchPositions(term: $term, entityId: $entityId, first: $first, after: $after) {
    count
    edges {
      node {
        id
        __typename
        account {
          id
          name
        }
        amountCommitted {
          monies
        }
        unitCountOwnership
        investorGroup {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useSearchInvestorPositionsQuery__
 *
 * To run a query within a React component, call `useSearchInvestorPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInvestorPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInvestorPositionsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      term: // value for 'term'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchInvestorPositionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchInvestorPositionsQuery, GraphqlTypes.SearchInvestorPositionsQueryVariables> & ({ variables: GraphqlTypes.SearchInvestorPositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchInvestorPositionsQuery, GraphqlTypes.SearchInvestorPositionsQueryVariables>(SearchInvestorPositionsDocument, options);
      }
export function useSearchInvestorPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchInvestorPositionsQuery, GraphqlTypes.SearchInvestorPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchInvestorPositionsQuery, GraphqlTypes.SearchInvestorPositionsQueryVariables>(SearchInvestorPositionsDocument, options);
        }
// @ts-ignore
export function useSearchInvestorPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchInvestorPositionsQuery, GraphqlTypes.SearchInvestorPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchInvestorPositionsQuery, GraphqlTypes.SearchInvestorPositionsQueryVariables>;
export function useSearchInvestorPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchInvestorPositionsQuery, GraphqlTypes.SearchInvestorPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchInvestorPositionsQuery | undefined, GraphqlTypes.SearchInvestorPositionsQueryVariables>;
export function useSearchInvestorPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchInvestorPositionsQuery, GraphqlTypes.SearchInvestorPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchInvestorPositionsQuery, GraphqlTypes.SearchInvestorPositionsQueryVariables>(SearchInvestorPositionsDocument, options);
        }
export type SearchInvestorPositionsQueryHookResult = ReturnType<typeof useSearchInvestorPositionsQuery>;
export type SearchInvestorPositionsLazyQueryHookResult = ReturnType<typeof useSearchInvestorPositionsLazyQuery>;
export type SearchInvestorPositionsSuspenseQueryHookResult = ReturnType<typeof useSearchInvestorPositionsSuspenseQuery>;
export type SearchInvestorPositionsQueryResult = Apollo.QueryResult<GraphqlTypes.SearchInvestorPositionsQuery, GraphqlTypes.SearchInvestorPositionsQueryVariables>;
export const GetEntityAndEntityCollectionsDocument = gql`
    query GetEntityAndEntityCollections($searchTerm: String!) {
  entityAndEntityCollections(searchTerm: $searchTerm) {
    entities {
      objectId
      name
      entityCollectionName
    }
    entityCollections {
      objectId
      name
      numEntities
    }
  }
}
    `;

/**
 * __useGetEntityAndEntityCollectionsQuery__
 *
 * To run a query within a React component, call `useGetEntityAndEntityCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityAndEntityCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityAndEntityCollectionsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetEntityAndEntityCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityAndEntityCollectionsQuery, GraphqlTypes.GetEntityAndEntityCollectionsQueryVariables> & ({ variables: GraphqlTypes.GetEntityAndEntityCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityAndEntityCollectionsQuery, GraphqlTypes.GetEntityAndEntityCollectionsQueryVariables>(GetEntityAndEntityCollectionsDocument, options);
      }
export function useGetEntityAndEntityCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityAndEntityCollectionsQuery, GraphqlTypes.GetEntityAndEntityCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityAndEntityCollectionsQuery, GraphqlTypes.GetEntityAndEntityCollectionsQueryVariables>(GetEntityAndEntityCollectionsDocument, options);
        }
// @ts-ignore
export function useGetEntityAndEntityCollectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityAndEntityCollectionsQuery, GraphqlTypes.GetEntityAndEntityCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityAndEntityCollectionsQuery, GraphqlTypes.GetEntityAndEntityCollectionsQueryVariables>;
export function useGetEntityAndEntityCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityAndEntityCollectionsQuery, GraphqlTypes.GetEntityAndEntityCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityAndEntityCollectionsQuery | undefined, GraphqlTypes.GetEntityAndEntityCollectionsQueryVariables>;
export function useGetEntityAndEntityCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityAndEntityCollectionsQuery, GraphqlTypes.GetEntityAndEntityCollectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityAndEntityCollectionsQuery, GraphqlTypes.GetEntityAndEntityCollectionsQueryVariables>(GetEntityAndEntityCollectionsDocument, options);
        }
export type GetEntityAndEntityCollectionsQueryHookResult = ReturnType<typeof useGetEntityAndEntityCollectionsQuery>;
export type GetEntityAndEntityCollectionsLazyQueryHookResult = ReturnType<typeof useGetEntityAndEntityCollectionsLazyQuery>;
export type GetEntityAndEntityCollectionsSuspenseQueryHookResult = ReturnType<typeof useGetEntityAndEntityCollectionsSuspenseQuery>;
export type GetEntityAndEntityCollectionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityAndEntityCollectionsQuery, GraphqlTypes.GetEntityAndEntityCollectionsQueryVariables>;
export const GetEntityDocument = gql`
    query GetEntity($entityId: ID!) {
  investmentEntity(id: $entityId) {
    id
    name
    currency {
      code
    }
  }
}
    `;

/**
 * __useGetEntityQuery__
 *
 * To run a query within a React component, call `useGetEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityQuery, GraphqlTypes.GetEntityQueryVariables> & ({ variables: GraphqlTypes.GetEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityQuery, GraphqlTypes.GetEntityQueryVariables>(GetEntityDocument, options);
      }
export function useGetEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityQuery, GraphqlTypes.GetEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityQuery, GraphqlTypes.GetEntityQueryVariables>(GetEntityDocument, options);
        }
// @ts-ignore
export function useGetEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityQuery, GraphqlTypes.GetEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityQuery, GraphqlTypes.GetEntityQueryVariables>;
export function useGetEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityQuery, GraphqlTypes.GetEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityQuery | undefined, GraphqlTypes.GetEntityQueryVariables>;
export function useGetEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityQuery, GraphqlTypes.GetEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityQuery, GraphqlTypes.GetEntityQueryVariables>(GetEntityDocument, options);
        }
export type GetEntityQueryHookResult = ReturnType<typeof useGetEntityQuery>;
export type GetEntityLazyQueryHookResult = ReturnType<typeof useGetEntityLazyQuery>;
export type GetEntitySuspenseQueryHookResult = ReturnType<typeof useGetEntitySuspenseQuery>;
export type GetEntityQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityQuery, GraphqlTypes.GetEntityQueryVariables>;
export const GetEntityCollectionDocument = gql`
    query GetEntityCollection($entityCollectionId: ID!) {
  entityCollection(id: $entityCollectionId) {
    id
    name
    entities(fundAdministeredOnly: true) {
      edges {
        node {
          id
          name
          currency {
            code
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEntityCollectionQuery__
 *
 * To run a query within a React component, call `useGetEntityCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityCollectionQuery({
 *   variables: {
 *      entityCollectionId: // value for 'entityCollectionId'
 *   },
 * });
 */
export function useGetEntityCollectionQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityCollectionQuery, GraphqlTypes.GetEntityCollectionQueryVariables> & ({ variables: GraphqlTypes.GetEntityCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityCollectionQuery, GraphqlTypes.GetEntityCollectionQueryVariables>(GetEntityCollectionDocument, options);
      }
export function useGetEntityCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityCollectionQuery, GraphqlTypes.GetEntityCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityCollectionQuery, GraphqlTypes.GetEntityCollectionQueryVariables>(GetEntityCollectionDocument, options);
        }
// @ts-ignore
export function useGetEntityCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityCollectionQuery, GraphqlTypes.GetEntityCollectionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityCollectionQuery, GraphqlTypes.GetEntityCollectionQueryVariables>;
export function useGetEntityCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityCollectionQuery, GraphqlTypes.GetEntityCollectionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityCollectionQuery | undefined, GraphqlTypes.GetEntityCollectionQueryVariables>;
export function useGetEntityCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityCollectionQuery, GraphqlTypes.GetEntityCollectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityCollectionQuery, GraphqlTypes.GetEntityCollectionQueryVariables>(GetEntityCollectionDocument, options);
        }
export type GetEntityCollectionQueryHookResult = ReturnType<typeof useGetEntityCollectionQuery>;
export type GetEntityCollectionLazyQueryHookResult = ReturnType<typeof useGetEntityCollectionLazyQuery>;
export type GetEntityCollectionSuspenseQueryHookResult = ReturnType<typeof useGetEntityCollectionSuspenseQuery>;
export type GetEntityCollectionQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityCollectionQuery, GraphqlTypes.GetEntityCollectionQueryVariables>;
export const CreateZendeskTicketDocument = gql`
    mutation createZendeskTicket($type: FundAdminServiceType!, $keyValues: JSONString!, $objects: JSONString, $fundAdminDocumentVersions: [FundAdminServiceDocumentVersion]) {
  zendeskMutationOps {
    createZendeskTicket(
      fundAdminServiceType: $type
      keyValues: $keyValues
      objects: $objects
      fundAdminDocumentVersions: $fundAdminDocumentVersions
    ) {
      fundAdminServiceRecord {
        id
        externalTicketIdentifier
        requestType
        details
        status
        isPublished
      }
    }
  }
}
    `;
export type CreateZendeskTicketMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateZendeskTicketMutation, GraphqlTypes.CreateZendeskTicketMutationVariables>;

/**
 * __useCreateZendeskTicketMutation__
 *
 * To run a mutation, you first call `useCreateZendeskTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZendeskTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZendeskTicketMutation, { data, loading, error }] = useCreateZendeskTicketMutation({
 *   variables: {
 *      type: // value for 'type'
 *      keyValues: // value for 'keyValues'
 *      objects: // value for 'objects'
 *      fundAdminDocumentVersions: // value for 'fundAdminDocumentVersions'
 *   },
 * });
 */
export function useCreateZendeskTicketMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateZendeskTicketMutation, GraphqlTypes.CreateZendeskTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateZendeskTicketMutation, GraphqlTypes.CreateZendeskTicketMutationVariables>(CreateZendeskTicketDocument, options);
      }
export type CreateZendeskTicketMutationHookResult = ReturnType<typeof useCreateZendeskTicketMutation>;
export type CreateZendeskTicketMutationResult = Apollo.MutationResult<GraphqlTypes.CreateZendeskTicketMutation>;
export type CreateZendeskTicketMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateZendeskTicketMutation, GraphqlTypes.CreateZendeskTicketMutationVariables>;
export const GetFundAdminDeliverablesModuleFlagDocument = gql`
    query GetFundAdminDeliverablesModuleFlag {
  currentArena {
    features {
      showFundAdminDeliverablesModule
    }
  }
}
    `;

/**
 * __useGetFundAdminDeliverablesModuleFlagQuery__
 *
 * To run a query within a React component, call `useGetFundAdminDeliverablesModuleFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundAdminDeliverablesModuleFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundAdminDeliverablesModuleFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFundAdminDeliverablesModuleFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetFundAdminDeliverablesModuleFlagQuery, GraphqlTypes.GetFundAdminDeliverablesModuleFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFundAdminDeliverablesModuleFlagQuery, GraphqlTypes.GetFundAdminDeliverablesModuleFlagQueryVariables>(GetFundAdminDeliverablesModuleFlagDocument, options);
      }
export function useGetFundAdminDeliverablesModuleFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFundAdminDeliverablesModuleFlagQuery, GraphqlTypes.GetFundAdminDeliverablesModuleFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFundAdminDeliverablesModuleFlagQuery, GraphqlTypes.GetFundAdminDeliverablesModuleFlagQueryVariables>(GetFundAdminDeliverablesModuleFlagDocument, options);
        }
// @ts-ignore
export function useGetFundAdminDeliverablesModuleFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdminDeliverablesModuleFlagQuery, GraphqlTypes.GetFundAdminDeliverablesModuleFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundAdminDeliverablesModuleFlagQuery, GraphqlTypes.GetFundAdminDeliverablesModuleFlagQueryVariables>;
export function useGetFundAdminDeliverablesModuleFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdminDeliverablesModuleFlagQuery, GraphqlTypes.GetFundAdminDeliverablesModuleFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundAdminDeliverablesModuleFlagQuery | undefined, GraphqlTypes.GetFundAdminDeliverablesModuleFlagQueryVariables>;
export function useGetFundAdminDeliverablesModuleFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdminDeliverablesModuleFlagQuery, GraphqlTypes.GetFundAdminDeliverablesModuleFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFundAdminDeliverablesModuleFlagQuery, GraphqlTypes.GetFundAdminDeliverablesModuleFlagQueryVariables>(GetFundAdminDeliverablesModuleFlagDocument, options);
        }
export type GetFundAdminDeliverablesModuleFlagQueryHookResult = ReturnType<typeof useGetFundAdminDeliverablesModuleFlagQuery>;
export type GetFundAdminDeliverablesModuleFlagLazyQueryHookResult = ReturnType<typeof useGetFundAdminDeliverablesModuleFlagLazyQuery>;
export type GetFundAdminDeliverablesModuleFlagSuspenseQueryHookResult = ReturnType<typeof useGetFundAdminDeliverablesModuleFlagSuspenseQuery>;
export type GetFundAdminDeliverablesModuleFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GetFundAdminDeliverablesModuleFlagQuery, GraphqlTypes.GetFundAdminDeliverablesModuleFlagQueryVariables>;
export const CreateServiceRequestCommentDocument = gql`
    mutation CreateServiceRequestComment($fundAdminServiceId: Int!, $comment: String!) {
  fundAdminServiceRequestOps {
    addComment(commentBody: $comment, fundAdminServiceId: $fundAdminServiceId) {
      fundAdminServiceActivities {
        id
      }
    }
  }
}
    `;
export type CreateServiceRequestCommentMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateServiceRequestCommentMutation, GraphqlTypes.CreateServiceRequestCommentMutationVariables>;

/**
 * __useCreateServiceRequestCommentMutation__
 *
 * To run a mutation, you first call `useCreateServiceRequestCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceRequestCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceRequestCommentMutation, { data, loading, error }] = useCreateServiceRequestCommentMutation({
 *   variables: {
 *      fundAdminServiceId: // value for 'fundAdminServiceId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateServiceRequestCommentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateServiceRequestCommentMutation, GraphqlTypes.CreateServiceRequestCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateServiceRequestCommentMutation, GraphqlTypes.CreateServiceRequestCommentMutationVariables>(CreateServiceRequestCommentDocument, options);
      }
export type CreateServiceRequestCommentMutationHookResult = ReturnType<typeof useCreateServiceRequestCommentMutation>;
export type CreateServiceRequestCommentMutationResult = Apollo.MutationResult<GraphqlTypes.CreateServiceRequestCommentMutation>;
export type CreateServiceRequestCommentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateServiceRequestCommentMutation, GraphqlTypes.CreateServiceRequestCommentMutationVariables>;
export const UploadFundAdminServiceDocumentsDocument = gql`
    mutation UploadFundAdminServiceDocuments($fundAdminServiceId: Int!, $documentVersions: [FundAdminServiceDocumentVersion]!) {
  fundAdminServiceRequestOps {
    uploadDocuments(
      fundAdminServiceId: $fundAdminServiceId
      documentVersions: $documentVersions
    ) {
      fundAdminServiceDocuments {
        id
        documentVersionId
      }
    }
  }
}
    `;
export type UploadFundAdminServiceDocumentsMutationFn = Apollo.MutationFunction<GraphqlTypes.UploadFundAdminServiceDocumentsMutation, GraphqlTypes.UploadFundAdminServiceDocumentsMutationVariables>;

/**
 * __useUploadFundAdminServiceDocumentsMutation__
 *
 * To run a mutation, you first call `useUploadFundAdminServiceDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFundAdminServiceDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFundAdminServiceDocumentsMutation, { data, loading, error }] = useUploadFundAdminServiceDocumentsMutation({
 *   variables: {
 *      fundAdminServiceId: // value for 'fundAdminServiceId'
 *      documentVersions: // value for 'documentVersions'
 *   },
 * });
 */
export function useUploadFundAdminServiceDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UploadFundAdminServiceDocumentsMutation, GraphqlTypes.UploadFundAdminServiceDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UploadFundAdminServiceDocumentsMutation, GraphqlTypes.UploadFundAdminServiceDocumentsMutationVariables>(UploadFundAdminServiceDocumentsDocument, options);
      }
export type UploadFundAdminServiceDocumentsMutationHookResult = ReturnType<typeof useUploadFundAdminServiceDocumentsMutation>;
export type UploadFundAdminServiceDocumentsMutationResult = Apollo.MutationResult<GraphqlTypes.UploadFundAdminServiceDocumentsMutation>;
export type UploadFundAdminServiceDocumentsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UploadFundAdminServiceDocumentsMutation, GraphqlTypes.UploadFundAdminServiceDocumentsMutationVariables>;
export const GetCurrentStaffUserDocument = gql`
    query GetCurrentStaffUser {
  currentUser {
    id
    emailAddress
    firstName
    lastName
    fullName
    roles {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentStaffUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentStaffUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentStaffUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentStaffUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentStaffUserQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrentStaffUserQuery, GraphqlTypes.GetCurrentStaffUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrentStaffUserQuery, GraphqlTypes.GetCurrentStaffUserQueryVariables>(GetCurrentStaffUserDocument, options);
      }
export function useGetCurrentStaffUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrentStaffUserQuery, GraphqlTypes.GetCurrentStaffUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrentStaffUserQuery, GraphqlTypes.GetCurrentStaffUserQueryVariables>(GetCurrentStaffUserDocument, options);
        }
// @ts-ignore
export function useGetCurrentStaffUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentStaffUserQuery, GraphqlTypes.GetCurrentStaffUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentStaffUserQuery, GraphqlTypes.GetCurrentStaffUserQueryVariables>;
export function useGetCurrentStaffUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentStaffUserQuery, GraphqlTypes.GetCurrentStaffUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentStaffUserQuery | undefined, GraphqlTypes.GetCurrentStaffUserQueryVariables>;
export function useGetCurrentStaffUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentStaffUserQuery, GraphqlTypes.GetCurrentStaffUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrentStaffUserQuery, GraphqlTypes.GetCurrentStaffUserQueryVariables>(GetCurrentStaffUserDocument, options);
        }
export type GetCurrentStaffUserQueryHookResult = ReturnType<typeof useGetCurrentStaffUserQuery>;
export type GetCurrentStaffUserLazyQueryHookResult = ReturnType<typeof useGetCurrentStaffUserLazyQuery>;
export type GetCurrentStaffUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentStaffUserSuspenseQuery>;
export type GetCurrentStaffUserQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrentStaffUserQuery, GraphqlTypes.GetCurrentStaffUserQueryVariables>;
export const GetDocumentDownloadZipUrlDocument = gql`
    query GetDocumentDownloadZipUrl($asyncJobId: ID!) {
  documentDownloadZipUrl(asyncJobId: $asyncJobId)
}
    `;

/**
 * __useGetDocumentDownloadZipUrlQuery__
 *
 * To run a query within a React component, call `useGetDocumentDownloadZipUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentDownloadZipUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentDownloadZipUrlQuery({
 *   variables: {
 *      asyncJobId: // value for 'asyncJobId'
 *   },
 * });
 */
export function useGetDocumentDownloadZipUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentDownloadZipUrlQuery, GraphqlTypes.GetDocumentDownloadZipUrlQueryVariables> & ({ variables: GraphqlTypes.GetDocumentDownloadZipUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentDownloadZipUrlQuery, GraphqlTypes.GetDocumentDownloadZipUrlQueryVariables>(GetDocumentDownloadZipUrlDocument, options);
      }
export function useGetDocumentDownloadZipUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentDownloadZipUrlQuery, GraphqlTypes.GetDocumentDownloadZipUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentDownloadZipUrlQuery, GraphqlTypes.GetDocumentDownloadZipUrlQueryVariables>(GetDocumentDownloadZipUrlDocument, options);
        }
// @ts-ignore
export function useGetDocumentDownloadZipUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentDownloadZipUrlQuery, GraphqlTypes.GetDocumentDownloadZipUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentDownloadZipUrlQuery, GraphqlTypes.GetDocumentDownloadZipUrlQueryVariables>;
export function useGetDocumentDownloadZipUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentDownloadZipUrlQuery, GraphqlTypes.GetDocumentDownloadZipUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentDownloadZipUrlQuery | undefined, GraphqlTypes.GetDocumentDownloadZipUrlQueryVariables>;
export function useGetDocumentDownloadZipUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentDownloadZipUrlQuery, GraphqlTypes.GetDocumentDownloadZipUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentDownloadZipUrlQuery, GraphqlTypes.GetDocumentDownloadZipUrlQueryVariables>(GetDocumentDownloadZipUrlDocument, options);
        }
export type GetDocumentDownloadZipUrlQueryHookResult = ReturnType<typeof useGetDocumentDownloadZipUrlQuery>;
export type GetDocumentDownloadZipUrlLazyQueryHookResult = ReturnType<typeof useGetDocumentDownloadZipUrlLazyQuery>;
export type GetDocumentDownloadZipUrlSuspenseQueryHookResult = ReturnType<typeof useGetDocumentDownloadZipUrlSuspenseQuery>;
export type GetDocumentDownloadZipUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentDownloadZipUrlQuery, GraphqlTypes.GetDocumentDownloadZipUrlQueryVariables>;
export const GetEntitiesWithGroupsDocument = gql`
    query GetEntitiesWithGroups {
  investmentEntities {
    edges {
      node {
        entityAccessGroups {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __useGetEntitiesWithGroupsQuery__
 *
 * To run a query within a React component, call `useGetEntitiesWithGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitiesWithGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitiesWithGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEntitiesWithGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEntitiesWithGroupsQuery, GraphqlTypes.GetEntitiesWithGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntitiesWithGroupsQuery, GraphqlTypes.GetEntitiesWithGroupsQueryVariables>(GetEntitiesWithGroupsDocument, options);
      }
export function useGetEntitiesWithGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntitiesWithGroupsQuery, GraphqlTypes.GetEntitiesWithGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntitiesWithGroupsQuery, GraphqlTypes.GetEntitiesWithGroupsQueryVariables>(GetEntitiesWithGroupsDocument, options);
        }
// @ts-ignore
export function useGetEntitiesWithGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesWithGroupsQuery, GraphqlTypes.GetEntitiesWithGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesWithGroupsQuery, GraphqlTypes.GetEntitiesWithGroupsQueryVariables>;
export function useGetEntitiesWithGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesWithGroupsQuery, GraphqlTypes.GetEntitiesWithGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesWithGroupsQuery | undefined, GraphqlTypes.GetEntitiesWithGroupsQueryVariables>;
export function useGetEntitiesWithGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesWithGroupsQuery, GraphqlTypes.GetEntitiesWithGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntitiesWithGroupsQuery, GraphqlTypes.GetEntitiesWithGroupsQueryVariables>(GetEntitiesWithGroupsDocument, options);
        }
export type GetEntitiesWithGroupsQueryHookResult = ReturnType<typeof useGetEntitiesWithGroupsQuery>;
export type GetEntitiesWithGroupsLazyQueryHookResult = ReturnType<typeof useGetEntitiesWithGroupsLazyQuery>;
export type GetEntitiesWithGroupsSuspenseQueryHookResult = ReturnType<typeof useGetEntitiesWithGroupsSuspenseQuery>;
export type GetEntitiesWithGroupsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntitiesWithGroupsQuery, GraphqlTypes.GetEntitiesWithGroupsQueryVariables>;
export const GetEntitySubTypesDocument = gql`
    query GetEntitySubTypes {
  entitySubTypes(sort: NAME_ASC) {
    edges {
      type: node {
        id
        name
        hidden
      }
    }
  }
}
    `;

/**
 * __useGetEntitySubTypesQuery__
 *
 * To run a query within a React component, call `useGetEntitySubTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitySubTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitySubTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEntitySubTypesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEntitySubTypesQuery, GraphqlTypes.GetEntitySubTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntitySubTypesQuery, GraphqlTypes.GetEntitySubTypesQueryVariables>(GetEntitySubTypesDocument, options);
      }
export function useGetEntitySubTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntitySubTypesQuery, GraphqlTypes.GetEntitySubTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntitySubTypesQuery, GraphqlTypes.GetEntitySubTypesQueryVariables>(GetEntitySubTypesDocument, options);
        }
// @ts-ignore
export function useGetEntitySubTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitySubTypesQuery, GraphqlTypes.GetEntitySubTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitySubTypesQuery, GraphqlTypes.GetEntitySubTypesQueryVariables>;
export function useGetEntitySubTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitySubTypesQuery, GraphqlTypes.GetEntitySubTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitySubTypesQuery | undefined, GraphqlTypes.GetEntitySubTypesQueryVariables>;
export function useGetEntitySubTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitySubTypesQuery, GraphqlTypes.GetEntitySubTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntitySubTypesQuery, GraphqlTypes.GetEntitySubTypesQueryVariables>(GetEntitySubTypesDocument, options);
        }
export type GetEntitySubTypesQueryHookResult = ReturnType<typeof useGetEntitySubTypesQuery>;
export type GetEntitySubTypesLazyQueryHookResult = ReturnType<typeof useGetEntitySubTypesLazyQuery>;
export type GetEntitySubTypesSuspenseQueryHookResult = ReturnType<typeof useGetEntitySubTypesSuspenseQuery>;
export type GetEntitySubTypesQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntitySubTypesQuery, GraphqlTypes.GetEntitySubTypesQueryVariables>;
export const SearchUsersDocument = gql`
    query SearchUsers($term: String!, $objectFilter: ObjectFilter) {
  searchUsers(term: $term, objectFilter: $objectFilter) {
    edges {
      node {
        ...UserFields
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      term: // value for 'term'
 *      objectFilter: // value for 'objectFilter'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchUsersQuery, GraphqlTypes.SearchUsersQueryVariables> & ({ variables: GraphqlTypes.SearchUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchUsersQuery, GraphqlTypes.SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchUsersQuery, GraphqlTypes.SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchUsersQuery, GraphqlTypes.SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
// @ts-ignore
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchUsersQuery, GraphqlTypes.SearchUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchUsersQuery, GraphqlTypes.SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchUsersQuery, GraphqlTypes.SearchUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchUsersQuery | undefined, GraphqlTypes.SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchUsersQuery, GraphqlTypes.SearchUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchUsersQuery, GraphqlTypes.SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<GraphqlTypes.SearchUsersQuery, GraphqlTypes.SearchUsersQueryVariables>;
export const SearchContactsDocument = gql`
    query SearchContacts($term: String!, $thumbnailWidth: Int = 64, $thumbnailHeight: Int = 64, $objectFilter: ObjectFilter) {
  searchContacts(term: $term, objectFilter: $objectFilter) {
    edges {
      node {
        ...ContactFields
      }
    }
  }
}
    ${ContactFieldsFragmentDoc}`;

/**
 * __useSearchContactsQuery__
 *
 * To run a query within a React component, call `useSearchContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      thumbnailWidth: // value for 'thumbnailWidth'
 *      thumbnailHeight: // value for 'thumbnailHeight'
 *      objectFilter: // value for 'objectFilter'
 *   },
 * });
 */
export function useSearchContactsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchContactsQuery, GraphqlTypes.SearchContactsQueryVariables> & ({ variables: GraphqlTypes.SearchContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchContactsQuery, GraphqlTypes.SearchContactsQueryVariables>(SearchContactsDocument, options);
      }
export function useSearchContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchContactsQuery, GraphqlTypes.SearchContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchContactsQuery, GraphqlTypes.SearchContactsQueryVariables>(SearchContactsDocument, options);
        }
// @ts-ignore
export function useSearchContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchContactsQuery, GraphqlTypes.SearchContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchContactsQuery, GraphqlTypes.SearchContactsQueryVariables>;
export function useSearchContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchContactsQuery, GraphqlTypes.SearchContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchContactsQuery | undefined, GraphqlTypes.SearchContactsQueryVariables>;
export function useSearchContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchContactsQuery, GraphqlTypes.SearchContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchContactsQuery, GraphqlTypes.SearchContactsQueryVariables>(SearchContactsDocument, options);
        }
export type SearchContactsQueryHookResult = ReturnType<typeof useSearchContactsQuery>;
export type SearchContactsLazyQueryHookResult = ReturnType<typeof useSearchContactsLazyQuery>;
export type SearchContactsSuspenseQueryHookResult = ReturnType<typeof useSearchContactsSuspenseQuery>;
export type SearchContactsQueryResult = Apollo.QueryResult<GraphqlTypes.SearchContactsQuery, GraphqlTypes.SearchContactsQueryVariables>;
export const SearchOfferingsDocument = gql`
    query SearchOfferings($term: String!) {
  searchOfferings(term: $term) {
    edges {
      node {
        ...OfferingFields
      }
    }
  }
}
    ${OfferingFieldsFragmentDoc}`;

/**
 * __useSearchOfferingsQuery__
 *
 * To run a query within a React component, call `useSearchOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOfferingsQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchOfferingsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchOfferingsQuery, GraphqlTypes.SearchOfferingsQueryVariables> & ({ variables: GraphqlTypes.SearchOfferingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchOfferingsQuery, GraphqlTypes.SearchOfferingsQueryVariables>(SearchOfferingsDocument, options);
      }
export function useSearchOfferingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchOfferingsQuery, GraphqlTypes.SearchOfferingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchOfferingsQuery, GraphqlTypes.SearchOfferingsQueryVariables>(SearchOfferingsDocument, options);
        }
// @ts-ignore
export function useSearchOfferingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchOfferingsQuery, GraphqlTypes.SearchOfferingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchOfferingsQuery, GraphqlTypes.SearchOfferingsQueryVariables>;
export function useSearchOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchOfferingsQuery, GraphqlTypes.SearchOfferingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchOfferingsQuery | undefined, GraphqlTypes.SearchOfferingsQueryVariables>;
export function useSearchOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchOfferingsQuery, GraphqlTypes.SearchOfferingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchOfferingsQuery, GraphqlTypes.SearchOfferingsQueryVariables>(SearchOfferingsDocument, options);
        }
export type SearchOfferingsQueryHookResult = ReturnType<typeof useSearchOfferingsQuery>;
export type SearchOfferingsLazyQueryHookResult = ReturnType<typeof useSearchOfferingsLazyQuery>;
export type SearchOfferingsSuspenseQueryHookResult = ReturnType<typeof useSearchOfferingsSuspenseQuery>;
export type SearchOfferingsQueryResult = Apollo.QueryResult<GraphqlTypes.SearchOfferingsQuery, GraphqlTypes.SearchOfferingsQueryVariables>;
export const SearchOfferingsExtendedDocument = gql`
    query SearchOfferingsExtended($term: String!) {
  searchAllOfferings(term: $term) {
    edges {
      node {
        ...OfferingFieldsExtended
      }
    }
  }
}
    ${OfferingFieldsExtendedFragmentDoc}`;

/**
 * __useSearchOfferingsExtendedQuery__
 *
 * To run a query within a React component, call `useSearchOfferingsExtendedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOfferingsExtendedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOfferingsExtendedQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchOfferingsExtendedQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchOfferingsExtendedQuery, GraphqlTypes.SearchOfferingsExtendedQueryVariables> & ({ variables: GraphqlTypes.SearchOfferingsExtendedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchOfferingsExtendedQuery, GraphqlTypes.SearchOfferingsExtendedQueryVariables>(SearchOfferingsExtendedDocument, options);
      }
export function useSearchOfferingsExtendedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchOfferingsExtendedQuery, GraphqlTypes.SearchOfferingsExtendedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchOfferingsExtendedQuery, GraphqlTypes.SearchOfferingsExtendedQueryVariables>(SearchOfferingsExtendedDocument, options);
        }
// @ts-ignore
export function useSearchOfferingsExtendedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchOfferingsExtendedQuery, GraphqlTypes.SearchOfferingsExtendedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchOfferingsExtendedQuery, GraphqlTypes.SearchOfferingsExtendedQueryVariables>;
export function useSearchOfferingsExtendedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchOfferingsExtendedQuery, GraphqlTypes.SearchOfferingsExtendedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchOfferingsExtendedQuery | undefined, GraphqlTypes.SearchOfferingsExtendedQueryVariables>;
export function useSearchOfferingsExtendedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchOfferingsExtendedQuery, GraphqlTypes.SearchOfferingsExtendedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchOfferingsExtendedQuery, GraphqlTypes.SearchOfferingsExtendedQueryVariables>(SearchOfferingsExtendedDocument, options);
        }
export type SearchOfferingsExtendedQueryHookResult = ReturnType<typeof useSearchOfferingsExtendedQuery>;
export type SearchOfferingsExtendedLazyQueryHookResult = ReturnType<typeof useSearchOfferingsExtendedLazyQuery>;
export type SearchOfferingsExtendedSuspenseQueryHookResult = ReturnType<typeof useSearchOfferingsExtendedSuspenseQuery>;
export type SearchOfferingsExtendedQueryResult = Apollo.QueryResult<GraphqlTypes.SearchOfferingsExtendedQuery, GraphqlTypes.SearchOfferingsExtendedQueryVariables>;
export const SearchAccountsDocument = gql`
    query SearchAccounts($term: String!, $objectFilter: ObjectFilter) {
  searchAccounts(term: $term, objectFilter: $objectFilter) {
    edges {
      node {
        ...AccountFields
      }
    }
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useSearchAccountsQuery__
 *
 * To run a query within a React component, call `useSearchAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAccountsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      objectFilter: // value for 'objectFilter'
 *   },
 * });
 */
export function useSearchAccountsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchAccountsQuery, GraphqlTypes.SearchAccountsQueryVariables> & ({ variables: GraphqlTypes.SearchAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchAccountsQuery, GraphqlTypes.SearchAccountsQueryVariables>(SearchAccountsDocument, options);
      }
export function useSearchAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchAccountsQuery, GraphqlTypes.SearchAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchAccountsQuery, GraphqlTypes.SearchAccountsQueryVariables>(SearchAccountsDocument, options);
        }
// @ts-ignore
export function useSearchAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchAccountsQuery, GraphqlTypes.SearchAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchAccountsQuery, GraphqlTypes.SearchAccountsQueryVariables>;
export function useSearchAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchAccountsQuery, GraphqlTypes.SearchAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchAccountsQuery | undefined, GraphqlTypes.SearchAccountsQueryVariables>;
export function useSearchAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchAccountsQuery, GraphqlTypes.SearchAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchAccountsQuery, GraphqlTypes.SearchAccountsQueryVariables>(SearchAccountsDocument, options);
        }
export type SearchAccountsQueryHookResult = ReturnType<typeof useSearchAccountsQuery>;
export type SearchAccountsLazyQueryHookResult = ReturnType<typeof useSearchAccountsLazyQuery>;
export type SearchAccountsSuspenseQueryHookResult = ReturnType<typeof useSearchAccountsSuspenseQuery>;
export type SearchAccountsQueryResult = Apollo.QueryResult<GraphqlTypes.SearchAccountsQuery, GraphqlTypes.SearchAccountsQueryVariables>;
export const SearchUsersAndContactsDocument = gql`
    query SearchUsersAndContacts($term: String!, $thumbnailWidth: Int = 64, $thumbnailHeight: Int = 64, $objectFilter: ObjectFilter) {
  searchUsers(term: $term, objectFilter: $objectFilter) {
    edges {
      node {
        ...UserFields
      }
    }
  }
  searchContacts(term: $term, objectFilter: $objectFilter) {
    edges {
      node {
        ...ContactFields
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${ContactFieldsFragmentDoc}`;

/**
 * __useSearchUsersAndContactsQuery__
 *
 * To run a query within a React component, call `useSearchUsersAndContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersAndContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersAndContactsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      thumbnailWidth: // value for 'thumbnailWidth'
 *      thumbnailHeight: // value for 'thumbnailHeight'
 *      objectFilter: // value for 'objectFilter'
 *   },
 * });
 */
export function useSearchUsersAndContactsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchUsersAndContactsQuery, GraphqlTypes.SearchUsersAndContactsQueryVariables> & ({ variables: GraphqlTypes.SearchUsersAndContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchUsersAndContactsQuery, GraphqlTypes.SearchUsersAndContactsQueryVariables>(SearchUsersAndContactsDocument, options);
      }
export function useSearchUsersAndContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchUsersAndContactsQuery, GraphqlTypes.SearchUsersAndContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchUsersAndContactsQuery, GraphqlTypes.SearchUsersAndContactsQueryVariables>(SearchUsersAndContactsDocument, options);
        }
// @ts-ignore
export function useSearchUsersAndContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchUsersAndContactsQuery, GraphqlTypes.SearchUsersAndContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchUsersAndContactsQuery, GraphqlTypes.SearchUsersAndContactsQueryVariables>;
export function useSearchUsersAndContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchUsersAndContactsQuery, GraphqlTypes.SearchUsersAndContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchUsersAndContactsQuery | undefined, GraphqlTypes.SearchUsersAndContactsQueryVariables>;
export function useSearchUsersAndContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchUsersAndContactsQuery, GraphqlTypes.SearchUsersAndContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchUsersAndContactsQuery, GraphqlTypes.SearchUsersAndContactsQueryVariables>(SearchUsersAndContactsDocument, options);
        }
export type SearchUsersAndContactsQueryHookResult = ReturnType<typeof useSearchUsersAndContactsQuery>;
export type SearchUsersAndContactsLazyQueryHookResult = ReturnType<typeof useSearchUsersAndContactsLazyQuery>;
export type SearchUsersAndContactsSuspenseQueryHookResult = ReturnType<typeof useSearchUsersAndContactsSuspenseQuery>;
export type SearchUsersAndContactsQueryResult = Apollo.QueryResult<GraphqlTypes.SearchUsersAndContactsQuery, GraphqlTypes.SearchUsersAndContactsQueryVariables>;
export const CreateOrUpdateAssetOwnwershipShareTimeSeriesDocument = gql`
    mutation CreateOrUpdateAssetOwnwershipShareTimeSeries($assetId: ID!, $asOfDate: Date, $objectInput: AssetOwnershipShareTimeSeriesInput!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    createOrUpdateAssetOwnershipShareTimeSeries(
      assetId: $assetId
      asOfDate: $asOfDate
      objectInput: $objectInput
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        ...AssetLatestTimeSeries
        ...AssetTimeSeries
      }
    }
  }
}
    ${AssetLatestTimeSeriesFragmentDoc}
${AssetTimeSeriesFragmentDoc}`;
export type CreateOrUpdateAssetOwnwershipShareTimeSeriesMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateOrUpdateAssetOwnwershipShareTimeSeriesMutation, GraphqlTypes.CreateOrUpdateAssetOwnwershipShareTimeSeriesMutationVariables>;

/**
 * __useCreateOrUpdateAssetOwnwershipShareTimeSeriesMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateAssetOwnwershipShareTimeSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateAssetOwnwershipShareTimeSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateAssetOwnwershipShareTimeSeriesMutation, { data, loading, error }] = useCreateOrUpdateAssetOwnwershipShareTimeSeriesMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      asOfDate: // value for 'asOfDate'
 *      objectInput: // value for 'objectInput'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useCreateOrUpdateAssetOwnwershipShareTimeSeriesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateOrUpdateAssetOwnwershipShareTimeSeriesMutation, GraphqlTypes.CreateOrUpdateAssetOwnwershipShareTimeSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateOrUpdateAssetOwnwershipShareTimeSeriesMutation, GraphqlTypes.CreateOrUpdateAssetOwnwershipShareTimeSeriesMutationVariables>(CreateOrUpdateAssetOwnwershipShareTimeSeriesDocument, options);
      }
export type CreateOrUpdateAssetOwnwershipShareTimeSeriesMutationHookResult = ReturnType<typeof useCreateOrUpdateAssetOwnwershipShareTimeSeriesMutation>;
export type CreateOrUpdateAssetOwnwershipShareTimeSeriesMutationResult = Apollo.MutationResult<GraphqlTypes.CreateOrUpdateAssetOwnwershipShareTimeSeriesMutation>;
export type CreateOrUpdateAssetOwnwershipShareTimeSeriesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateOrUpdateAssetOwnwershipShareTimeSeriesMutation, GraphqlTypes.CreateOrUpdateAssetOwnwershipShareTimeSeriesMutationVariables>;
export const DeleteAssetOwnwershipShareTimeSeriesDocument = gql`
    mutation DeleteAssetOwnwershipShareTimeSeries($assetId: ID!, $asOfDate: Date!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    deleteAssetOwnershipShareTimeSeries(
      assetId: $assetId
      asOfDate: $asOfDate
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        ...AssetLatestTimeSeries
        ...AssetTimeSeries
      }
    }
  }
}
    ${AssetLatestTimeSeriesFragmentDoc}
${AssetTimeSeriesFragmentDoc}`;
export type DeleteAssetOwnwershipShareTimeSeriesMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteAssetOwnwershipShareTimeSeriesMutation, GraphqlTypes.DeleteAssetOwnwershipShareTimeSeriesMutationVariables>;

/**
 * __useDeleteAssetOwnwershipShareTimeSeriesMutation__
 *
 * To run a mutation, you first call `useDeleteAssetOwnwershipShareTimeSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetOwnwershipShareTimeSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetOwnwershipShareTimeSeriesMutation, { data, loading, error }] = useDeleteAssetOwnwershipShareTimeSeriesMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      asOfDate: // value for 'asOfDate'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useDeleteAssetOwnwershipShareTimeSeriesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteAssetOwnwershipShareTimeSeriesMutation, GraphqlTypes.DeleteAssetOwnwershipShareTimeSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteAssetOwnwershipShareTimeSeriesMutation, GraphqlTypes.DeleteAssetOwnwershipShareTimeSeriesMutationVariables>(DeleteAssetOwnwershipShareTimeSeriesDocument, options);
      }
export type DeleteAssetOwnwershipShareTimeSeriesMutationHookResult = ReturnType<typeof useDeleteAssetOwnwershipShareTimeSeriesMutation>;
export type DeleteAssetOwnwershipShareTimeSeriesMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteAssetOwnwershipShareTimeSeriesMutation>;
export type DeleteAssetOwnwershipShareTimeSeriesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteAssetOwnwershipShareTimeSeriesMutation, GraphqlTypes.DeleteAssetOwnwershipShareTimeSeriesMutationVariables>;
export const GetAssetOwnershipShareDocument = gql`
    query GetAssetOwnershipShare($assetId: ID!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  asset(id: $assetId) {
    id
    name
    canEdit
    canLimitedEdit
    ...AssetLatestTimeSeries
    ...AssetTimeSeries
  }
}
    ${AssetLatestTimeSeriesFragmentDoc}
${AssetTimeSeriesFragmentDoc}`;

/**
 * __useGetAssetOwnershipShareQuery__
 *
 * To run a query within a React component, call `useGetAssetOwnershipShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetOwnershipShareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetOwnershipShareQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetAssetOwnershipShareQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAssetOwnershipShareQuery, GraphqlTypes.GetAssetOwnershipShareQueryVariables> & ({ variables: GraphqlTypes.GetAssetOwnershipShareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetOwnershipShareQuery, GraphqlTypes.GetAssetOwnershipShareQueryVariables>(GetAssetOwnershipShareDocument, options);
      }
export function useGetAssetOwnershipShareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetOwnershipShareQuery, GraphqlTypes.GetAssetOwnershipShareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetOwnershipShareQuery, GraphqlTypes.GetAssetOwnershipShareQueryVariables>(GetAssetOwnershipShareDocument, options);
        }
// @ts-ignore
export function useGetAssetOwnershipShareSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetOwnershipShareQuery, GraphqlTypes.GetAssetOwnershipShareQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetOwnershipShareQuery, GraphqlTypes.GetAssetOwnershipShareQueryVariables>;
export function useGetAssetOwnershipShareSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetOwnershipShareQuery, GraphqlTypes.GetAssetOwnershipShareQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetOwnershipShareQuery | undefined, GraphqlTypes.GetAssetOwnershipShareQueryVariables>;
export function useGetAssetOwnershipShareSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetOwnershipShareQuery, GraphqlTypes.GetAssetOwnershipShareQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetOwnershipShareQuery, GraphqlTypes.GetAssetOwnershipShareQueryVariables>(GetAssetOwnershipShareDocument, options);
        }
export type GetAssetOwnershipShareQueryHookResult = ReturnType<typeof useGetAssetOwnershipShareQuery>;
export type GetAssetOwnershipShareLazyQueryHookResult = ReturnType<typeof useGetAssetOwnershipShareLazyQuery>;
export type GetAssetOwnershipShareSuspenseQueryHookResult = ReturnType<typeof useGetAssetOwnershipShareSuspenseQuery>;
export type GetAssetOwnershipShareQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetOwnershipShareQuery, GraphqlTypes.GetAssetOwnershipShareQueryVariables>;
export const GetCurrentArenaDocument = gql`
    query GetCurrentArena {
  currentArena {
    id
    name
    jsqHostname
    features {
      hasAdvancedPermissions
      hasDocumentCategoryAdvancedPermissions
      hasLegacyEntityEquityFields
      hasCustomerEmailServer
      hasEmailServiceProviderMailgun
      supportsCustomDataFields
      hasOperatingCompanies
      hasSso
      hasFundAdmin
      showFaAccountingTab
      hasGlDataForSoi
      hasExternalAuthentication
      hasPositionPaymentPrefStaffApprovals
      hasHubspotIntegration
      hasPreqinIntegration
      hasBulkCountersign
      hasSftpDocumentPosting
      hasMarketLensIntegration
    }
    supportEmail
    supportPhone
    isGpLite
    timezone
    aiEnabled
    packagingEdition {
      id
      name
      label
    }
    paymentPermission {
      requirePositionPaymentPrefStaffApprovals
      requireNoteOnStaffPaymentInstructionChange
    }
    labelDisplaySettings {
      id
      fieldName
      singular
      plural
      variants {
        id
        variantName
        investmentEntities {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentArenaQuery__
 *
 * To run a query within a React component, call `useGetCurrentArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentArenaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentArenaQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrentArenaQuery, GraphqlTypes.GetCurrentArenaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrentArenaQuery, GraphqlTypes.GetCurrentArenaQueryVariables>(GetCurrentArenaDocument, options);
      }
export function useGetCurrentArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrentArenaQuery, GraphqlTypes.GetCurrentArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrentArenaQuery, GraphqlTypes.GetCurrentArenaQueryVariables>(GetCurrentArenaDocument, options);
        }
// @ts-ignore
export function useGetCurrentArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaQuery, GraphqlTypes.GetCurrentArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentArenaQuery, GraphqlTypes.GetCurrentArenaQueryVariables>;
export function useGetCurrentArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaQuery, GraphqlTypes.GetCurrentArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentArenaQuery | undefined, GraphqlTypes.GetCurrentArenaQueryVariables>;
export function useGetCurrentArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaQuery, GraphqlTypes.GetCurrentArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrentArenaQuery, GraphqlTypes.GetCurrentArenaQueryVariables>(GetCurrentArenaDocument, options);
        }
export type GetCurrentArenaQueryHookResult = ReturnType<typeof useGetCurrentArenaQuery>;
export type GetCurrentArenaLazyQueryHookResult = ReturnType<typeof useGetCurrentArenaLazyQuery>;
export type GetCurrentArenaSuspenseQueryHookResult = ReturnType<typeof useGetCurrentArenaSuspenseQuery>;
export type GetCurrentArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrentArenaQuery, GraphqlTypes.GetCurrentArenaQueryVariables>;
export const PublishAssetDocument = gql`
    mutation PublishAsset($assetId: ID!, $publish: Boolean!) {
  assetOps {
    publish(assetId: $assetId, publish: $publish) {
      asset {
        id
        published
      }
    }
  }
}
    `;
export type PublishAssetMutationFn = Apollo.MutationFunction<GraphqlTypes.PublishAssetMutation, GraphqlTypes.PublishAssetMutationVariables>;

/**
 * __usePublishAssetMutation__
 *
 * To run a mutation, you first call `usePublishAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishAssetMutation, { data, loading, error }] = usePublishAssetMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      publish: // value for 'publish'
 *   },
 * });
 */
export function usePublishAssetMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PublishAssetMutation, GraphqlTypes.PublishAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PublishAssetMutation, GraphqlTypes.PublishAssetMutationVariables>(PublishAssetDocument, options);
      }
export type PublishAssetMutationHookResult = ReturnType<typeof usePublishAssetMutation>;
export type PublishAssetMutationResult = Apollo.MutationResult<GraphqlTypes.PublishAssetMutation>;
export type PublishAssetMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PublishAssetMutation, GraphqlTypes.PublishAssetMutationVariables>;
export const GetAssetForHeaderDocument = gql`
    query GetAssetForHeader($assetId: ID!, $thumbnailWidth: Int = 50, $thumbnailHeight: Int = 50, $photoOption: Int = 4) {
  asset(id: $assetId) {
    id
    name
    published
    canEdit
    canLimitedEdit
    ...AssetThumbnail
    ...AssetLocations
    entity {
      id
      name
      published
      isSpv
    }
  }
}
    ${AssetThumbnailFragmentDoc}
${AssetLocationsFragmentDoc}`;

/**
 * __useGetAssetForHeaderQuery__
 *
 * To run a query within a React component, call `useGetAssetForHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetForHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetForHeaderQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      thumbnailWidth: // value for 'thumbnailWidth'
 *      thumbnailHeight: // value for 'thumbnailHeight'
 *      photoOption: // value for 'photoOption'
 *   },
 * });
 */
export function useGetAssetForHeaderQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAssetForHeaderQuery, GraphqlTypes.GetAssetForHeaderQueryVariables> & ({ variables: GraphqlTypes.GetAssetForHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetForHeaderQuery, GraphqlTypes.GetAssetForHeaderQueryVariables>(GetAssetForHeaderDocument, options);
      }
export function useGetAssetForHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetForHeaderQuery, GraphqlTypes.GetAssetForHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetForHeaderQuery, GraphqlTypes.GetAssetForHeaderQueryVariables>(GetAssetForHeaderDocument, options);
        }
// @ts-ignore
export function useGetAssetForHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetForHeaderQuery, GraphqlTypes.GetAssetForHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetForHeaderQuery, GraphqlTypes.GetAssetForHeaderQueryVariables>;
export function useGetAssetForHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetForHeaderQuery, GraphqlTypes.GetAssetForHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetForHeaderQuery | undefined, GraphqlTypes.GetAssetForHeaderQueryVariables>;
export function useGetAssetForHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetForHeaderQuery, GraphqlTypes.GetAssetForHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetForHeaderQuery, GraphqlTypes.GetAssetForHeaderQueryVariables>(GetAssetForHeaderDocument, options);
        }
export type GetAssetForHeaderQueryHookResult = ReturnType<typeof useGetAssetForHeaderQuery>;
export type GetAssetForHeaderLazyQueryHookResult = ReturnType<typeof useGetAssetForHeaderLazyQuery>;
export type GetAssetForHeaderSuspenseQueryHookResult = ReturnType<typeof useGetAssetForHeaderSuspenseQuery>;
export type GetAssetForHeaderQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetForHeaderQuery, GraphqlTypes.GetAssetForHeaderQueryVariables>;
export const PublishEntityOverviewAndFinancialsDocument = gql`
    mutation PublishEntityOverviewAndFinancials($entityId: ID!, $publish: Boolean!) {
  entityOps {
    publishFinancials(entityId: $entityId, publish: $publish) {
      entity {
        id
        overviewAndFinancialsPublished
      }
    }
  }
}
    `;
export type PublishEntityOverviewAndFinancialsMutationFn = Apollo.MutationFunction<GraphqlTypes.PublishEntityOverviewAndFinancialsMutation, GraphqlTypes.PublishEntityOverviewAndFinancialsMutationVariables>;

/**
 * __usePublishEntityOverviewAndFinancialsMutation__
 *
 * To run a mutation, you first call `usePublishEntityOverviewAndFinancialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishEntityOverviewAndFinancialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishEntityOverviewAndFinancialsMutation, { data, loading, error }] = usePublishEntityOverviewAndFinancialsMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      publish: // value for 'publish'
 *   },
 * });
 */
export function usePublishEntityOverviewAndFinancialsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PublishEntityOverviewAndFinancialsMutation, GraphqlTypes.PublishEntityOverviewAndFinancialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PublishEntityOverviewAndFinancialsMutation, GraphqlTypes.PublishEntityOverviewAndFinancialsMutationVariables>(PublishEntityOverviewAndFinancialsDocument, options);
      }
export type PublishEntityOverviewAndFinancialsMutationHookResult = ReturnType<typeof usePublishEntityOverviewAndFinancialsMutation>;
export type PublishEntityOverviewAndFinancialsMutationResult = Apollo.MutationResult<GraphqlTypes.PublishEntityOverviewAndFinancialsMutation>;
export type PublishEntityOverviewAndFinancialsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PublishEntityOverviewAndFinancialsMutation, GraphqlTypes.PublishEntityOverviewAndFinancialsMutationVariables>;
export const GetEntityThumbnailDocument = gql`
    query GetEntityThumbnail($objectId: ID!, $thumbnailWidth: Int = 50, $thumbnailHeight: Int = 50, $photoOption: Int = 4) {
  investmentEntity(id: $objectId) {
    id
    thumbnail {
      id
      photoUrl(width: $thumbnailWidth, height: $thumbnailHeight, option: $photoOption)
    }
  }
}
    `;

/**
 * __useGetEntityThumbnailQuery__
 *
 * To run a query within a React component, call `useGetEntityThumbnailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityThumbnailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityThumbnailQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      thumbnailWidth: // value for 'thumbnailWidth'
 *      thumbnailHeight: // value for 'thumbnailHeight'
 *      photoOption: // value for 'photoOption'
 *   },
 * });
 */
export function useGetEntityThumbnailQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityThumbnailQuery, GraphqlTypes.GetEntityThumbnailQueryVariables> & ({ variables: GraphqlTypes.GetEntityThumbnailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityThumbnailQuery, GraphqlTypes.GetEntityThumbnailQueryVariables>(GetEntityThumbnailDocument, options);
      }
export function useGetEntityThumbnailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityThumbnailQuery, GraphqlTypes.GetEntityThumbnailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityThumbnailQuery, GraphqlTypes.GetEntityThumbnailQueryVariables>(GetEntityThumbnailDocument, options);
        }
// @ts-ignore
export function useGetEntityThumbnailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityThumbnailQuery, GraphqlTypes.GetEntityThumbnailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityThumbnailQuery, GraphqlTypes.GetEntityThumbnailQueryVariables>;
export function useGetEntityThumbnailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityThumbnailQuery, GraphqlTypes.GetEntityThumbnailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityThumbnailQuery | undefined, GraphqlTypes.GetEntityThumbnailQueryVariables>;
export function useGetEntityThumbnailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityThumbnailQuery, GraphqlTypes.GetEntityThumbnailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityThumbnailQuery, GraphqlTypes.GetEntityThumbnailQueryVariables>(GetEntityThumbnailDocument, options);
        }
export type GetEntityThumbnailQueryHookResult = ReturnType<typeof useGetEntityThumbnailQuery>;
export type GetEntityThumbnailLazyQueryHookResult = ReturnType<typeof useGetEntityThumbnailLazyQuery>;
export type GetEntityThumbnailSuspenseQueryHookResult = ReturnType<typeof useGetEntityThumbnailSuspenseQuery>;
export type GetEntityThumbnailQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityThumbnailQuery, GraphqlTypes.GetEntityThumbnailQueryVariables>;
export const CreateAssetAcquisitionDocument = gql`
    mutation CreateAssetAcquisition($assetId: ID!, $objectInput: AssetAcquisitionInput!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    createAssetAcquisition(
      assetId: $assetId
      objectInput: $objectInput
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        name
        percentOwned
        ...AssetAcquisitions
      }
    }
  }
}
    ${AssetAcquisitionsFragmentDoc}`;
export type CreateAssetAcquisitionMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateAssetAcquisitionMutation, GraphqlTypes.CreateAssetAcquisitionMutationVariables>;

/**
 * __useCreateAssetAcquisitionMutation__
 *
 * To run a mutation, you first call `useCreateAssetAcquisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetAcquisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetAcquisitionMutation, { data, loading, error }] = useCreateAssetAcquisitionMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      objectInput: // value for 'objectInput'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useCreateAssetAcquisitionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateAssetAcquisitionMutation, GraphqlTypes.CreateAssetAcquisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateAssetAcquisitionMutation, GraphqlTypes.CreateAssetAcquisitionMutationVariables>(CreateAssetAcquisitionDocument, options);
      }
export type CreateAssetAcquisitionMutationHookResult = ReturnType<typeof useCreateAssetAcquisitionMutation>;
export type CreateAssetAcquisitionMutationResult = Apollo.MutationResult<GraphqlTypes.CreateAssetAcquisitionMutation>;
export type CreateAssetAcquisitionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateAssetAcquisitionMutation, GraphqlTypes.CreateAssetAcquisitionMutationVariables>;
export const UpdateAssetAcquisitionDocument = gql`
    mutation UpdateAssetAcquisition($assetId: ID!, $acquisitionId: ID!, $objectInput: AssetAcquisitionInput!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    updateAssetAcquisition(
      assetId: $assetId
      objectId: $acquisitionId
      objectInput: $objectInput
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        name
        percentOwned
        ...AssetAcquisitions
      }
    }
  }
}
    ${AssetAcquisitionsFragmentDoc}`;
export type UpdateAssetAcquisitionMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateAssetAcquisitionMutation, GraphqlTypes.UpdateAssetAcquisitionMutationVariables>;

/**
 * __useUpdateAssetAcquisitionMutation__
 *
 * To run a mutation, you first call `useUpdateAssetAcquisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetAcquisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetAcquisitionMutation, { data, loading, error }] = useUpdateAssetAcquisitionMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      acquisitionId: // value for 'acquisitionId'
 *      objectInput: // value for 'objectInput'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useUpdateAssetAcquisitionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateAssetAcquisitionMutation, GraphqlTypes.UpdateAssetAcquisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateAssetAcquisitionMutation, GraphqlTypes.UpdateAssetAcquisitionMutationVariables>(UpdateAssetAcquisitionDocument, options);
      }
export type UpdateAssetAcquisitionMutationHookResult = ReturnType<typeof useUpdateAssetAcquisitionMutation>;
export type UpdateAssetAcquisitionMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateAssetAcquisitionMutation>;
export type UpdateAssetAcquisitionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateAssetAcquisitionMutation, GraphqlTypes.UpdateAssetAcquisitionMutationVariables>;
export const DeleteAssetAcquisitionDocument = gql`
    mutation DeleteAssetAcquisition($acquisitionId: ID!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    deleteAssetAcquisition(
      objectId: $acquisitionId
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        name
        percentOwned
        ...AssetAcquisitions
      }
    }
  }
}
    ${AssetAcquisitionsFragmentDoc}`;
export type DeleteAssetAcquisitionMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteAssetAcquisitionMutation, GraphqlTypes.DeleteAssetAcquisitionMutationVariables>;

/**
 * __useDeleteAssetAcquisitionMutation__
 *
 * To run a mutation, you first call `useDeleteAssetAcquisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetAcquisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetAcquisitionMutation, { data, loading, error }] = useDeleteAssetAcquisitionMutation({
 *   variables: {
 *      acquisitionId: // value for 'acquisitionId'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useDeleteAssetAcquisitionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteAssetAcquisitionMutation, GraphqlTypes.DeleteAssetAcquisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteAssetAcquisitionMutation, GraphqlTypes.DeleteAssetAcquisitionMutationVariables>(DeleteAssetAcquisitionDocument, options);
      }
export type DeleteAssetAcquisitionMutationHookResult = ReturnType<typeof useDeleteAssetAcquisitionMutation>;
export type DeleteAssetAcquisitionMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteAssetAcquisitionMutation>;
export type DeleteAssetAcquisitionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteAssetAcquisitionMutation, GraphqlTypes.DeleteAssetAcquisitionMutationVariables>;
export const DeleteLegacyFieldFromAssetAcquisitionDocument = gql`
    mutation DeleteLegacyFieldFromAssetAcquisition($acquisitionId: ID!, $fieldName: String!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    deleteLegacyFieldFromAssetAcquisition(
      objectId: $acquisitionId
      fieldName: $fieldName
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        name
        percentOwned
        ...AssetAcquisitions
      }
    }
  }
}
    ${AssetAcquisitionsFragmentDoc}`;
export type DeleteLegacyFieldFromAssetAcquisitionMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteLegacyFieldFromAssetAcquisitionMutation, GraphqlTypes.DeleteLegacyFieldFromAssetAcquisitionMutationVariables>;

/**
 * __useDeleteLegacyFieldFromAssetAcquisitionMutation__
 *
 * To run a mutation, you first call `useDeleteLegacyFieldFromAssetAcquisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLegacyFieldFromAssetAcquisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLegacyFieldFromAssetAcquisitionMutation, { data, loading, error }] = useDeleteLegacyFieldFromAssetAcquisitionMutation({
 *   variables: {
 *      acquisitionId: // value for 'acquisitionId'
 *      fieldName: // value for 'fieldName'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useDeleteLegacyFieldFromAssetAcquisitionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteLegacyFieldFromAssetAcquisitionMutation, GraphqlTypes.DeleteLegacyFieldFromAssetAcquisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteLegacyFieldFromAssetAcquisitionMutation, GraphqlTypes.DeleteLegacyFieldFromAssetAcquisitionMutationVariables>(DeleteLegacyFieldFromAssetAcquisitionDocument, options);
      }
export type DeleteLegacyFieldFromAssetAcquisitionMutationHookResult = ReturnType<typeof useDeleteLegacyFieldFromAssetAcquisitionMutation>;
export type DeleteLegacyFieldFromAssetAcquisitionMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteLegacyFieldFromAssetAcquisitionMutation>;
export type DeleteLegacyFieldFromAssetAcquisitionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteLegacyFieldFromAssetAcquisitionMutation, GraphqlTypes.DeleteLegacyFieldFromAssetAcquisitionMutationVariables>;
export const GetAcquisitionsDocument = gql`
    query GetAcquisitions($assetId: ID!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  asset(id: $assetId) {
    id
    name
    canEdit
    canLimitedEdit
    percentOwned
    totalNetSqft
    totalGrossSqft
    currency {
      id
      code
      symbol
      fullName
      flagUnicode
    }
    entity {
      id
      currency {
        id
        code
        symbol
        fullName
        flagUnicode
      }
    }
    ...AssetAcquisitions
  }
}
    ${AssetAcquisitionsFragmentDoc}`;

/**
 * __useGetAcquisitionsQuery__
 *
 * To run a query within a React component, call `useGetAcquisitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcquisitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcquisitionsQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetAcquisitionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAcquisitionsQuery, GraphqlTypes.GetAcquisitionsQueryVariables> & ({ variables: GraphqlTypes.GetAcquisitionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAcquisitionsQuery, GraphqlTypes.GetAcquisitionsQueryVariables>(GetAcquisitionsDocument, options);
      }
export function useGetAcquisitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAcquisitionsQuery, GraphqlTypes.GetAcquisitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAcquisitionsQuery, GraphqlTypes.GetAcquisitionsQueryVariables>(GetAcquisitionsDocument, options);
        }
// @ts-ignore
export function useGetAcquisitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAcquisitionsQuery, GraphqlTypes.GetAcquisitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAcquisitionsQuery, GraphqlTypes.GetAcquisitionsQueryVariables>;
export function useGetAcquisitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAcquisitionsQuery, GraphqlTypes.GetAcquisitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAcquisitionsQuery | undefined, GraphqlTypes.GetAcquisitionsQueryVariables>;
export function useGetAcquisitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAcquisitionsQuery, GraphqlTypes.GetAcquisitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAcquisitionsQuery, GraphqlTypes.GetAcquisitionsQueryVariables>(GetAcquisitionsDocument, options);
        }
export type GetAcquisitionsQueryHookResult = ReturnType<typeof useGetAcquisitionsQuery>;
export type GetAcquisitionsLazyQueryHookResult = ReturnType<typeof useGetAcquisitionsLazyQuery>;
export type GetAcquisitionsSuspenseQueryHookResult = ReturnType<typeof useGetAcquisitionsSuspenseQuery>;
export type GetAcquisitionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAcquisitionsQuery, GraphqlTypes.GetAcquisitionsQueryVariables>;
export const GetChartDataDocument = gql`
    query GetChartData($positionId: ID, $isActive: Boolean) {
  chartData(positionId: $positionId) {
    assetChartData(isActive: $isActive) {
      geoChartData {
        label
        value
      }
      productTypeChartData {
        label
        value
      }
    }
  }
}
    `;

/**
 * __useGetChartDataQuery__
 *
 * To run a query within a React component, call `useGetChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChartDataQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useGetChartDataQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetChartDataQuery, GraphqlTypes.GetChartDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetChartDataQuery, GraphqlTypes.GetChartDataQueryVariables>(GetChartDataDocument, options);
      }
export function useGetChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetChartDataQuery, GraphqlTypes.GetChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetChartDataQuery, GraphqlTypes.GetChartDataQueryVariables>(GetChartDataDocument, options);
        }
// @ts-ignore
export function useGetChartDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChartDataQuery, GraphqlTypes.GetChartDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetChartDataQuery, GraphqlTypes.GetChartDataQueryVariables>;
export function useGetChartDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChartDataQuery, GraphqlTypes.GetChartDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetChartDataQuery | undefined, GraphqlTypes.GetChartDataQueryVariables>;
export function useGetChartDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChartDataQuery, GraphqlTypes.GetChartDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetChartDataQuery, GraphqlTypes.GetChartDataQueryVariables>(GetChartDataDocument, options);
        }
export type GetChartDataQueryHookResult = ReturnType<typeof useGetChartDataQuery>;
export type GetChartDataLazyQueryHookResult = ReturnType<typeof useGetChartDataLazyQuery>;
export type GetChartDataSuspenseQueryHookResult = ReturnType<typeof useGetChartDataSuspenseQuery>;
export type GetChartDataQueryResult = Apollo.QueryResult<GraphqlTypes.GetChartDataQuery, GraphqlTypes.GetChartDataQueryVariables>;
export const UpdateEntityEquityBalancesDocument = gql`
    mutation UpdateEntityEquityBalances($objectId: ID!, $objectInput: EntityEquityBalanceInput!) {
  entityOps {
    updateEntityEquityBalances(objectId: $objectId, objectInput: $objectInput) {
      entity {
        id
        initialEquityBalance {
          monies
        }
        finalEquityBalance {
          monies
        }
      }
    }
  }
}
    `;
export type UpdateEntityEquityBalancesMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateEntityEquityBalancesMutation, GraphqlTypes.UpdateEntityEquityBalancesMutationVariables>;

/**
 * __useUpdateEntityEquityBalancesMutation__
 *
 * To run a mutation, you first call `useUpdateEntityEquityBalancesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityEquityBalancesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityEquityBalancesMutation, { data, loading, error }] = useUpdateEntityEquityBalancesMutation({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateEntityEquityBalancesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateEntityEquityBalancesMutation, GraphqlTypes.UpdateEntityEquityBalancesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateEntityEquityBalancesMutation, GraphqlTypes.UpdateEntityEquityBalancesMutationVariables>(UpdateEntityEquityBalancesDocument, options);
      }
export type UpdateEntityEquityBalancesMutationHookResult = ReturnType<typeof useUpdateEntityEquityBalancesMutation>;
export type UpdateEntityEquityBalancesMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateEntityEquityBalancesMutation>;
export type UpdateEntityEquityBalancesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateEntityEquityBalancesMutation, GraphqlTypes.UpdateEntityEquityBalancesMutationVariables>;
export const UpdateCapAndValTimeSeriesDocument = gql`
    mutation UpdateCapAndValTimeSeries($objectId: ID!, $objectInput: EntityCapAndValTimeSeriesInput!, $oldAsOfDate: DateTime, $entityTimeSeriesTypeNames: [FieldName!]!, $projectionTimeSeriesTypeNames: [FieldName!]!) {
  entityOps {
    updateCapAndValTimeSeries(
      objectId: $objectId
      objectInput: $objectInput
      oldAsOfDate: $oldAsOfDate
      entityTimeSeriesTypeNames: $entityTimeSeriesTypeNames
      projectionTimeSeriesTypeNames: $projectionTimeSeriesTypeNames
    ) {
      entity {
        id
        timeSeries(timeSeriesTypeNames: $entityTimeSeriesTypeNames) {
          asOfDate
          values {
            ...TimeSeriesFields
          }
        }
        timeSeriesProjections(timeSeriesTypeNames: $projectionTimeSeriesTypeNames) {
          asOfDate
          values {
            ...TimeSeriesFields
          }
        }
        latestTimeSeries(timeSeriesTypeNames: $entityTimeSeriesTypeNames) {
          asOfDate
          values {
            ...TimeSeriesFields
          }
        }
        latestTimeSeriesProjections(timeSeriesTypeNames: $projectionTimeSeriesTypeNames) {
          asOfDate
          values {
            ...TimeSeriesFields
          }
        }
      }
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;
export type UpdateCapAndValTimeSeriesMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateCapAndValTimeSeriesMutation, GraphqlTypes.UpdateCapAndValTimeSeriesMutationVariables>;

/**
 * __useUpdateCapAndValTimeSeriesMutation__
 *
 * To run a mutation, you first call `useUpdateCapAndValTimeSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCapAndValTimeSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCapAndValTimeSeriesMutation, { data, loading, error }] = useUpdateCapAndValTimeSeriesMutation({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      objectInput: // value for 'objectInput'
 *      oldAsOfDate: // value for 'oldAsOfDate'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *      projectionTimeSeriesTypeNames: // value for 'projectionTimeSeriesTypeNames'
 *   },
 * });
 */
export function useUpdateCapAndValTimeSeriesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateCapAndValTimeSeriesMutation, GraphqlTypes.UpdateCapAndValTimeSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateCapAndValTimeSeriesMutation, GraphqlTypes.UpdateCapAndValTimeSeriesMutationVariables>(UpdateCapAndValTimeSeriesDocument, options);
      }
export type UpdateCapAndValTimeSeriesMutationHookResult = ReturnType<typeof useUpdateCapAndValTimeSeriesMutation>;
export type UpdateCapAndValTimeSeriesMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateCapAndValTimeSeriesMutation>;
export type UpdateCapAndValTimeSeriesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateCapAndValTimeSeriesMutation, GraphqlTypes.UpdateCapAndValTimeSeriesMutationVariables>;
export const DeleteCapAndValTimeSeriesDocument = gql`
    mutation DeleteCapAndValTimeSeries($entityId: ID!, $asOfDate: DateTime!, $entityTimeSeriesTypeNames: [FieldName!]!, $projectionTimeSeriesTypeNames: [FieldName!]!) {
  entityOps {
    deleteTimeSeries(
      entityId: $entityId
      asOfDate: $asOfDate
      entityTimeSeriesTypeNames: $entityTimeSeriesTypeNames
      projectionTimeSeriesTypeNames: $projectionTimeSeriesTypeNames
    ) {
      entity {
        id
        timeSeries(timeSeriesTypeNames: $entityTimeSeriesTypeNames) {
          asOfDate
          values {
            ...TimeSeriesFields
          }
        }
        timeSeriesProjections(timeSeriesTypeNames: $projectionTimeSeriesTypeNames) {
          asOfDate
          values {
            ...TimeSeriesFields
          }
        }
        latestTimeSeries(timeSeriesTypeNames: $entityTimeSeriesTypeNames) {
          asOfDate
          values {
            ...TimeSeriesFields
          }
        }
        latestTimeSeriesProjections(timeSeriesTypeNames: $projectionTimeSeriesTypeNames) {
          asOfDate
          values {
            ...TimeSeriesFields
          }
        }
      }
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;
export type DeleteCapAndValTimeSeriesMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteCapAndValTimeSeriesMutation, GraphqlTypes.DeleteCapAndValTimeSeriesMutationVariables>;

/**
 * __useDeleteCapAndValTimeSeriesMutation__
 *
 * To run a mutation, you first call `useDeleteCapAndValTimeSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCapAndValTimeSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCapAndValTimeSeriesMutation, { data, loading, error }] = useDeleteCapAndValTimeSeriesMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      asOfDate: // value for 'asOfDate'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *      projectionTimeSeriesTypeNames: // value for 'projectionTimeSeriesTypeNames'
 *   },
 * });
 */
export function useDeleteCapAndValTimeSeriesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteCapAndValTimeSeriesMutation, GraphqlTypes.DeleteCapAndValTimeSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteCapAndValTimeSeriesMutation, GraphqlTypes.DeleteCapAndValTimeSeriesMutationVariables>(DeleteCapAndValTimeSeriesDocument, options);
      }
export type DeleteCapAndValTimeSeriesMutationHookResult = ReturnType<typeof useDeleteCapAndValTimeSeriesMutation>;
export type DeleteCapAndValTimeSeriesMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteCapAndValTimeSeriesMutation>;
export type DeleteCapAndValTimeSeriesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteCapAndValTimeSeriesMutation, GraphqlTypes.DeleteCapAndValTimeSeriesMutationVariables>;
export const GetCapitalizationAndValuationDocument = gql`
    query GetCapitalizationAndValuation($entityId: ID!, $entityTimeSeriesTypeNames: [FieldName!]!, $projectionTimeSeriesTypeNames: [FieldName!]!, $loanTimeSeriesTypeNames: [FieldName!]!, $plCategories: [FieldName!]!) {
  investmentEntity(id: $entityId) {
    id
    name
    canEdit
    canLimitedEdit
    totalNetSqft
    isOperatingCompany
    currency {
      ...CurrencyFields
    }
    latestTimeSeries(timeSeriesTypeNames: $entityTimeSeriesTypeNames) {
      asOfDate
      values {
        ...TimeSeriesFields
      }
    }
    latestTimeSeriesProjections(timeSeriesTypeNames: $projectionTimeSeriesTypeNames) {
      asOfDate
      values {
        ...TimeSeriesFields
      }
    }
    timeSeries(timeSeriesTypeNames: $entityTimeSeriesTypeNames) {
      asOfDate
      values {
        ...TimeSeriesFields
      }
    }
    timeSeriesProjections(timeSeriesTypeNames: $projectionTimeSeriesTypeNames) {
      asOfDate
      values {
        ...TimeSeriesFields
      }
    }
    profitLossPeriods(plCategories: $plCategories) {
      year
      period
      entries {
        ...ProfitLossEntryFields
      }
    }
    showPerfMetricsOnAsset
    loans {
      edges {
        node {
          id
          maturityDate
          extendedMaturityDate
          lienPosition
          loanType
          initialAmount {
            monies
          }
          finalAmount {
            monies
          }
          assetAllocations {
            assetId
            assetName
            allocationPct
          }
          timeSeries(timeSeriesTypeNames: $loanTimeSeriesTypeNames) {
            asOfDate
            values {
              ...TimeSeriesFields
            }
          }
          latestTimeSeries(timeSeriesTypeNames: $loanTimeSeriesTypeNames) {
            asOfDate
            values {
              ...TimeSeriesFields
            }
          }
        }
      }
    }
    assets {
      edges {
        node {
          id
          percentOwned
        }
      }
    }
    initialEquityBalance {
      monies
    }
    currentEquityBalance {
      monies
    }
    finalEquityBalance {
      monies
    }
    contributed {
      monies
    }
    distributed {
      monies
    }
  }
}
    ${CurrencyFieldsFragmentDoc}
${TimeSeriesFieldsFragmentDoc}
${ProfitLossEntryFieldsFragmentDoc}`;

/**
 * __useGetCapitalizationAndValuationQuery__
 *
 * To run a query within a React component, call `useGetCapitalizationAndValuationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapitalizationAndValuationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapitalizationAndValuationQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *      projectionTimeSeriesTypeNames: // value for 'projectionTimeSeriesTypeNames'
 *      loanTimeSeriesTypeNames: // value for 'loanTimeSeriesTypeNames'
 *      plCategories: // value for 'plCategories'
 *   },
 * });
 */
export function useGetCapitalizationAndValuationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCapitalizationAndValuationQuery, GraphqlTypes.GetCapitalizationAndValuationQueryVariables> & ({ variables: GraphqlTypes.GetCapitalizationAndValuationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCapitalizationAndValuationQuery, GraphqlTypes.GetCapitalizationAndValuationQueryVariables>(GetCapitalizationAndValuationDocument, options);
      }
export function useGetCapitalizationAndValuationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCapitalizationAndValuationQuery, GraphqlTypes.GetCapitalizationAndValuationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCapitalizationAndValuationQuery, GraphqlTypes.GetCapitalizationAndValuationQueryVariables>(GetCapitalizationAndValuationDocument, options);
        }
// @ts-ignore
export function useGetCapitalizationAndValuationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalizationAndValuationQuery, GraphqlTypes.GetCapitalizationAndValuationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalizationAndValuationQuery, GraphqlTypes.GetCapitalizationAndValuationQueryVariables>;
export function useGetCapitalizationAndValuationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalizationAndValuationQuery, GraphqlTypes.GetCapitalizationAndValuationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalizationAndValuationQuery | undefined, GraphqlTypes.GetCapitalizationAndValuationQueryVariables>;
export function useGetCapitalizationAndValuationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalizationAndValuationQuery, GraphqlTypes.GetCapitalizationAndValuationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCapitalizationAndValuationQuery, GraphqlTypes.GetCapitalizationAndValuationQueryVariables>(GetCapitalizationAndValuationDocument, options);
        }
export type GetCapitalizationAndValuationQueryHookResult = ReturnType<typeof useGetCapitalizationAndValuationQuery>;
export type GetCapitalizationAndValuationLazyQueryHookResult = ReturnType<typeof useGetCapitalizationAndValuationLazyQuery>;
export type GetCapitalizationAndValuationSuspenseQueryHookResult = ReturnType<typeof useGetCapitalizationAndValuationSuspenseQuery>;
export type GetCapitalizationAndValuationQueryResult = Apollo.QueryResult<GraphqlTypes.GetCapitalizationAndValuationQuery, GraphqlTypes.GetCapitalizationAndValuationQueryVariables>;
export const GetCapitalizationAndValuationHistoryDocument = gql`
    query GetCapitalizationAndValuationHistory($entityId: ID!, $entityTimeSeriesTypeNames: [FieldName!]!, $projectionTimeSeriesTypeNames: [FieldName!]!) {
  investmentEntity(id: $entityId) {
    id
    name
    timeSeries(timeSeriesTypeNames: $entityTimeSeriesTypeNames) {
      asOfDate
      values {
        ...TimeSeriesFields
      }
    }
    timeSeriesProjections(timeSeriesTypeNames: $projectionTimeSeriesTypeNames) {
      asOfDate
      values {
        ...TimeSeriesFields
      }
    }
  }
}
    ${TimeSeriesFieldsFragmentDoc}`;

/**
 * __useGetCapitalizationAndValuationHistoryQuery__
 *
 * To run a query within a React component, call `useGetCapitalizationAndValuationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapitalizationAndValuationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapitalizationAndValuationHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *      projectionTimeSeriesTypeNames: // value for 'projectionTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetCapitalizationAndValuationHistoryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCapitalizationAndValuationHistoryQuery, GraphqlTypes.GetCapitalizationAndValuationHistoryQueryVariables> & ({ variables: GraphqlTypes.GetCapitalizationAndValuationHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCapitalizationAndValuationHistoryQuery, GraphqlTypes.GetCapitalizationAndValuationHistoryQueryVariables>(GetCapitalizationAndValuationHistoryDocument, options);
      }
export function useGetCapitalizationAndValuationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCapitalizationAndValuationHistoryQuery, GraphqlTypes.GetCapitalizationAndValuationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCapitalizationAndValuationHistoryQuery, GraphqlTypes.GetCapitalizationAndValuationHistoryQueryVariables>(GetCapitalizationAndValuationHistoryDocument, options);
        }
// @ts-ignore
export function useGetCapitalizationAndValuationHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalizationAndValuationHistoryQuery, GraphqlTypes.GetCapitalizationAndValuationHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalizationAndValuationHistoryQuery, GraphqlTypes.GetCapitalizationAndValuationHistoryQueryVariables>;
export function useGetCapitalizationAndValuationHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalizationAndValuationHistoryQuery, GraphqlTypes.GetCapitalizationAndValuationHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCapitalizationAndValuationHistoryQuery | undefined, GraphqlTypes.GetCapitalizationAndValuationHistoryQueryVariables>;
export function useGetCapitalizationAndValuationHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCapitalizationAndValuationHistoryQuery, GraphqlTypes.GetCapitalizationAndValuationHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCapitalizationAndValuationHistoryQuery, GraphqlTypes.GetCapitalizationAndValuationHistoryQueryVariables>(GetCapitalizationAndValuationHistoryDocument, options);
        }
export type GetCapitalizationAndValuationHistoryQueryHookResult = ReturnType<typeof useGetCapitalizationAndValuationHistoryQuery>;
export type GetCapitalizationAndValuationHistoryLazyQueryHookResult = ReturnType<typeof useGetCapitalizationAndValuationHistoryLazyQuery>;
export type GetCapitalizationAndValuationHistorySuspenseQueryHookResult = ReturnType<typeof useGetCapitalizationAndValuationHistorySuspenseQuery>;
export type GetCapitalizationAndValuationHistoryQueryResult = Apollo.QueryResult<GraphqlTypes.GetCapitalizationAndValuationHistoryQuery, GraphqlTypes.GetCapitalizationAndValuationHistoryQueryVariables>;
export const GetAssetLoansDocument = gql`
    query GetAssetLoans($assetId: ID!, $loanTimeSeriesTypeNames: [FieldName!]!, $loanProjectionTypeNames: [FieldName!]!) {
  asset(id: $assetId) {
    id
    entity {
      id
      canEdit
      canLimitedEdit
      currency {
        ...CurrencyFields
      }
    }
    loans {
      edges {
        node {
          ...FieldsForLoanDisplay
        }
      }
    }
  }
}
    ${CurrencyFieldsFragmentDoc}
${FieldsForLoanDisplayFragmentDoc}`;

/**
 * __useGetAssetLoansQuery__
 *
 * To run a query within a React component, call `useGetAssetLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetLoansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetLoansQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      loanTimeSeriesTypeNames: // value for 'loanTimeSeriesTypeNames'
 *      loanProjectionTypeNames: // value for 'loanProjectionTypeNames'
 *   },
 * });
 */
export function useGetAssetLoansQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAssetLoansQuery, GraphqlTypes.GetAssetLoansQueryVariables> & ({ variables: GraphqlTypes.GetAssetLoansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetLoansQuery, GraphqlTypes.GetAssetLoansQueryVariables>(GetAssetLoansDocument, options);
      }
export function useGetAssetLoansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetLoansQuery, GraphqlTypes.GetAssetLoansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetLoansQuery, GraphqlTypes.GetAssetLoansQueryVariables>(GetAssetLoansDocument, options);
        }
// @ts-ignore
export function useGetAssetLoansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetLoansQuery, GraphqlTypes.GetAssetLoansQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetLoansQuery, GraphqlTypes.GetAssetLoansQueryVariables>;
export function useGetAssetLoansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetLoansQuery, GraphqlTypes.GetAssetLoansQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetLoansQuery | undefined, GraphqlTypes.GetAssetLoansQueryVariables>;
export function useGetAssetLoansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetLoansQuery, GraphqlTypes.GetAssetLoansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetLoansQuery, GraphqlTypes.GetAssetLoansQueryVariables>(GetAssetLoansDocument, options);
        }
export type GetAssetLoansQueryHookResult = ReturnType<typeof useGetAssetLoansQuery>;
export type GetAssetLoansLazyQueryHookResult = ReturnType<typeof useGetAssetLoansLazyQuery>;
export type GetAssetLoansSuspenseQueryHookResult = ReturnType<typeof useGetAssetLoansSuspenseQuery>;
export type GetAssetLoansQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetLoansQuery, GraphqlTypes.GetAssetLoansQueryVariables>;
export const GetEntityLoansDocument = gql`
    query GetEntityLoans($entityId: ID!, $loanTimeSeriesTypeNames: [FieldName!]!, $loanProjectionTypeNames: [FieldName!]!) {
  investmentEntity(id: $entityId) {
    id
    canEdit
    canLimitedEdit
    currency {
      ...CurrencyFields
    }
    loans {
      edges {
        node {
          ...FieldsForLoanDisplay
        }
      }
    }
  }
}
    ${CurrencyFieldsFragmentDoc}
${FieldsForLoanDisplayFragmentDoc}`;

/**
 * __useGetEntityLoansQuery__
 *
 * To run a query within a React component, call `useGetEntityLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityLoansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityLoansQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      loanTimeSeriesTypeNames: // value for 'loanTimeSeriesTypeNames'
 *      loanProjectionTypeNames: // value for 'loanProjectionTypeNames'
 *   },
 * });
 */
export function useGetEntityLoansQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityLoansQuery, GraphqlTypes.GetEntityLoansQueryVariables> & ({ variables: GraphqlTypes.GetEntityLoansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityLoansQuery, GraphqlTypes.GetEntityLoansQueryVariables>(GetEntityLoansDocument, options);
      }
export function useGetEntityLoansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityLoansQuery, GraphqlTypes.GetEntityLoansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityLoansQuery, GraphqlTypes.GetEntityLoansQueryVariables>(GetEntityLoansDocument, options);
        }
// @ts-ignore
export function useGetEntityLoansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityLoansQuery, GraphqlTypes.GetEntityLoansQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityLoansQuery, GraphqlTypes.GetEntityLoansQueryVariables>;
export function useGetEntityLoansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityLoansQuery, GraphqlTypes.GetEntityLoansQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityLoansQuery | undefined, GraphqlTypes.GetEntityLoansQueryVariables>;
export function useGetEntityLoansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityLoansQuery, GraphqlTypes.GetEntityLoansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityLoansQuery, GraphqlTypes.GetEntityLoansQueryVariables>(GetEntityLoansDocument, options);
        }
export type GetEntityLoansQueryHookResult = ReturnType<typeof useGetEntityLoansQuery>;
export type GetEntityLoansLazyQueryHookResult = ReturnType<typeof useGetEntityLoansLazyQuery>;
export type GetEntityLoansSuspenseQueryHookResult = ReturnType<typeof useGetEntityLoansSuspenseQuery>;
export type GetEntityLoansQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityLoansQuery, GraphqlTypes.GetEntityLoansQueryVariables>;
export const GetLoanHistoricalsDocument = gql`
    query GetLoanHistoricals($loanId: ID!, $loanTimeSeriesTypeNames: [FieldName!]!, $loanProjectionTypeNames: [FieldName!]!) {
  loan(id: $loanId) {
    id
    ...LoanHistoricalTimeSeries
  }
}
    ${LoanHistoricalTimeSeriesFragmentDoc}`;

/**
 * __useGetLoanHistoricalsQuery__
 *
 * To run a query within a React component, call `useGetLoanHistoricalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanHistoricalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanHistoricalsQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      loanTimeSeriesTypeNames: // value for 'loanTimeSeriesTypeNames'
 *      loanProjectionTypeNames: // value for 'loanProjectionTypeNames'
 *   },
 * });
 */
export function useGetLoanHistoricalsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetLoanHistoricalsQuery, GraphqlTypes.GetLoanHistoricalsQueryVariables> & ({ variables: GraphqlTypes.GetLoanHistoricalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLoanHistoricalsQuery, GraphqlTypes.GetLoanHistoricalsQueryVariables>(GetLoanHistoricalsDocument, options);
      }
export function useGetLoanHistoricalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLoanHistoricalsQuery, GraphqlTypes.GetLoanHistoricalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLoanHistoricalsQuery, GraphqlTypes.GetLoanHistoricalsQueryVariables>(GetLoanHistoricalsDocument, options);
        }
// @ts-ignore
export function useGetLoanHistoricalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLoanHistoricalsQuery, GraphqlTypes.GetLoanHistoricalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLoanHistoricalsQuery, GraphqlTypes.GetLoanHistoricalsQueryVariables>;
export function useGetLoanHistoricalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLoanHistoricalsQuery, GraphqlTypes.GetLoanHistoricalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLoanHistoricalsQuery | undefined, GraphqlTypes.GetLoanHistoricalsQueryVariables>;
export function useGetLoanHistoricalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLoanHistoricalsQuery, GraphqlTypes.GetLoanHistoricalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLoanHistoricalsQuery, GraphqlTypes.GetLoanHistoricalsQueryVariables>(GetLoanHistoricalsDocument, options);
        }
export type GetLoanHistoricalsQueryHookResult = ReturnType<typeof useGetLoanHistoricalsQuery>;
export type GetLoanHistoricalsLazyQueryHookResult = ReturnType<typeof useGetLoanHistoricalsLazyQuery>;
export type GetLoanHistoricalsSuspenseQueryHookResult = ReturnType<typeof useGetLoanHistoricalsSuspenseQuery>;
export type GetLoanHistoricalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetLoanHistoricalsQuery, GraphqlTypes.GetLoanHistoricalsQueryVariables>;
export const GetEntitiesForLoanDropdownDocument = gql`
    query GetEntitiesForLoanDropdown($entityId: ID!) {
  investmentEntitiesUnsorted(editableOnly: true, sort: [NAME_ASC]) {
    edges {
      node {
        id
        name
        currency {
          ...CurrencyFields
        }
      }
    }
  }
  investmentEntity(id: $entityId) {
    id
    currency {
      ...CurrencyFields
    }
    allEntitiesInGraph(editableOnly: true) {
      id
      name
      canEdit
      currency {
        ...CurrencyFields
      }
    }
    allAssetsInGraph(editableOnly: true) {
      id
      name
    }
  }
}
    ${CurrencyFieldsFragmentDoc}`;

/**
 * __useGetEntitiesForLoanDropdownQuery__
 *
 * To run a query within a React component, call `useGetEntitiesForLoanDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitiesForLoanDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitiesForLoanDropdownQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntitiesForLoanDropdownQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntitiesForLoanDropdownQuery, GraphqlTypes.GetEntitiesForLoanDropdownQueryVariables> & ({ variables: GraphqlTypes.GetEntitiesForLoanDropdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntitiesForLoanDropdownQuery, GraphqlTypes.GetEntitiesForLoanDropdownQueryVariables>(GetEntitiesForLoanDropdownDocument, options);
      }
export function useGetEntitiesForLoanDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntitiesForLoanDropdownQuery, GraphqlTypes.GetEntitiesForLoanDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntitiesForLoanDropdownQuery, GraphqlTypes.GetEntitiesForLoanDropdownQueryVariables>(GetEntitiesForLoanDropdownDocument, options);
        }
// @ts-ignore
export function useGetEntitiesForLoanDropdownSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesForLoanDropdownQuery, GraphqlTypes.GetEntitiesForLoanDropdownQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesForLoanDropdownQuery, GraphqlTypes.GetEntitiesForLoanDropdownQueryVariables>;
export function useGetEntitiesForLoanDropdownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesForLoanDropdownQuery, GraphqlTypes.GetEntitiesForLoanDropdownQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesForLoanDropdownQuery | undefined, GraphqlTypes.GetEntitiesForLoanDropdownQueryVariables>;
export function useGetEntitiesForLoanDropdownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesForLoanDropdownQuery, GraphqlTypes.GetEntitiesForLoanDropdownQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntitiesForLoanDropdownQuery, GraphqlTypes.GetEntitiesForLoanDropdownQueryVariables>(GetEntitiesForLoanDropdownDocument, options);
        }
export type GetEntitiesForLoanDropdownQueryHookResult = ReturnType<typeof useGetEntitiesForLoanDropdownQuery>;
export type GetEntitiesForLoanDropdownLazyQueryHookResult = ReturnType<typeof useGetEntitiesForLoanDropdownLazyQuery>;
export type GetEntitiesForLoanDropdownSuspenseQueryHookResult = ReturnType<typeof useGetEntitiesForLoanDropdownSuspenseQuery>;
export type GetEntitiesForLoanDropdownQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntitiesForLoanDropdownQuery, GraphqlTypes.GetEntitiesForLoanDropdownQueryVariables>;
export const GetQ2AssetDataEnhancementsV2FeatureFlagDocument = gql`
    query GetQ2AssetDataEnhancementsV2FeatureFlag {
  devFeatures {
    q2AssetDataEnhancementsV2
  }
}
    `;

/**
 * __useGetQ2AssetDataEnhancementsV2FeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetQ2AssetDataEnhancementsV2FeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQ2AssetDataEnhancementsV2FeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQ2AssetDataEnhancementsV2FeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQ2AssetDataEnhancementsV2FeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQuery, GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQuery, GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQueryVariables>(GetQ2AssetDataEnhancementsV2FeatureFlagDocument, options);
      }
export function useGetQ2AssetDataEnhancementsV2FeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQuery, GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQuery, GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQueryVariables>(GetQ2AssetDataEnhancementsV2FeatureFlagDocument, options);
        }
// @ts-ignore
export function useGetQ2AssetDataEnhancementsV2FeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQuery, GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQuery, GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQueryVariables>;
export function useGetQ2AssetDataEnhancementsV2FeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQuery, GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQuery | undefined, GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQueryVariables>;
export function useGetQ2AssetDataEnhancementsV2FeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQuery, GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQuery, GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQueryVariables>(GetQ2AssetDataEnhancementsV2FeatureFlagDocument, options);
        }
export type GetQ2AssetDataEnhancementsV2FeatureFlagQueryHookResult = ReturnType<typeof useGetQ2AssetDataEnhancementsV2FeatureFlagQuery>;
export type GetQ2AssetDataEnhancementsV2FeatureFlagLazyQueryHookResult = ReturnType<typeof useGetQ2AssetDataEnhancementsV2FeatureFlagLazyQuery>;
export type GetQ2AssetDataEnhancementsV2FeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetQ2AssetDataEnhancementsV2FeatureFlagSuspenseQuery>;
export type GetQ2AssetDataEnhancementsV2FeatureFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQuery, GraphqlTypes.GetQ2AssetDataEnhancementsV2FeatureFlagQueryVariables>;
export const CreateLoanDocument = gql`
    mutation CreateLoan($objectInput: LoanInput!, $loanTimeSeriesTypeNames: [FieldName!]!, $loanProjectionTypeNames: [FieldName!]!) {
  assetOps {
    createLoan(objectInput: $objectInput) {
      loan {
        ...FieldsForLoanDisplay
      }
    }
  }
}
    ${FieldsForLoanDisplayFragmentDoc}`;
export type CreateLoanMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateLoanMutation, GraphqlTypes.CreateLoanMutationVariables>;

/**
 * __useCreateLoanMutation__
 *
 * To run a mutation, you first call `useCreateLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoanMutation, { data, loading, error }] = useCreateLoanMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *      loanTimeSeriesTypeNames: // value for 'loanTimeSeriesTypeNames'
 *      loanProjectionTypeNames: // value for 'loanProjectionTypeNames'
 *   },
 * });
 */
export function useCreateLoanMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateLoanMutation, GraphqlTypes.CreateLoanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateLoanMutation, GraphqlTypes.CreateLoanMutationVariables>(CreateLoanDocument, options);
      }
export type CreateLoanMutationHookResult = ReturnType<typeof useCreateLoanMutation>;
export type CreateLoanMutationResult = Apollo.MutationResult<GraphqlTypes.CreateLoanMutation>;
export type CreateLoanMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateLoanMutation, GraphqlTypes.CreateLoanMutationVariables>;
export const UpdateLoanDocument = gql`
    mutation UpdateLoan($loanId: ID!, $objectInput: LoanInput!) {
  assetOps {
    updateLoan(loanId: $loanId, objectInput: $objectInput) {
      loan {
        ...LoanFields
      }
    }
  }
}
    ${LoanFieldsFragmentDoc}`;
export type UpdateLoanMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateLoanMutation, GraphqlTypes.UpdateLoanMutationVariables>;

/**
 * __useUpdateLoanMutation__
 *
 * To run a mutation, you first call `useUpdateLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoanMutation, { data, loading, error }] = useUpdateLoanMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateLoanMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateLoanMutation, GraphqlTypes.UpdateLoanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateLoanMutation, GraphqlTypes.UpdateLoanMutationVariables>(UpdateLoanDocument, options);
      }
export type UpdateLoanMutationHookResult = ReturnType<typeof useUpdateLoanMutation>;
export type UpdateLoanMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateLoanMutation>;
export type UpdateLoanMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateLoanMutation, GraphqlTypes.UpdateLoanMutationVariables>;
export const DeleteLoanDocument = gql`
    mutation DeleteLoan($loanId: ID!) {
  assetOps {
    deleteLoan(loanId: $loanId) {
      success
    }
  }
}
    `;
export type DeleteLoanMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteLoanMutation, GraphqlTypes.DeleteLoanMutationVariables>;

/**
 * __useDeleteLoanMutation__
 *
 * To run a mutation, you first call `useDeleteLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLoanMutation, { data, loading, error }] = useDeleteLoanMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useDeleteLoanMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteLoanMutation, GraphqlTypes.DeleteLoanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteLoanMutation, GraphqlTypes.DeleteLoanMutationVariables>(DeleteLoanDocument, options);
      }
export type DeleteLoanMutationHookResult = ReturnType<typeof useDeleteLoanMutation>;
export type DeleteLoanMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteLoanMutation>;
export type DeleteLoanMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteLoanMutation, GraphqlTypes.DeleteLoanMutationVariables>;
export const UpsertLoanTimeSeriesDocument = gql`
    mutation UpsertLoanTimeSeries($loanId: ID!, $objectInput: LoanTimeSeriesInput!, $loanTimeSeriesTypeNames: [FieldName!]!, $loanProjectionTypeNames: [FieldName!]!) {
  assetOps {
    upsertLoanTimeSeries(loanId: $loanId, objectInput: $objectInput) {
      loan {
        id
        ...LoanCurrentTimeSeries
        ...LoanHistoricalTimeSeries
      }
    }
  }
}
    ${LoanCurrentTimeSeriesFragmentDoc}
${LoanHistoricalTimeSeriesFragmentDoc}`;
export type UpsertLoanTimeSeriesMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertLoanTimeSeriesMutation, GraphqlTypes.UpsertLoanTimeSeriesMutationVariables>;

/**
 * __useUpsertLoanTimeSeriesMutation__
 *
 * To run a mutation, you first call `useUpsertLoanTimeSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLoanTimeSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLoanTimeSeriesMutation, { data, loading, error }] = useUpsertLoanTimeSeriesMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      objectInput: // value for 'objectInput'
 *      loanTimeSeriesTypeNames: // value for 'loanTimeSeriesTypeNames'
 *      loanProjectionTypeNames: // value for 'loanProjectionTypeNames'
 *   },
 * });
 */
export function useUpsertLoanTimeSeriesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertLoanTimeSeriesMutation, GraphqlTypes.UpsertLoanTimeSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertLoanTimeSeriesMutation, GraphqlTypes.UpsertLoanTimeSeriesMutationVariables>(UpsertLoanTimeSeriesDocument, options);
      }
export type UpsertLoanTimeSeriesMutationHookResult = ReturnType<typeof useUpsertLoanTimeSeriesMutation>;
export type UpsertLoanTimeSeriesMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertLoanTimeSeriesMutation>;
export type UpsertLoanTimeSeriesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertLoanTimeSeriesMutation, GraphqlTypes.UpsertLoanTimeSeriesMutationVariables>;
export const DeleteLoanTimeSeriesEntryDocument = gql`
    mutation DeleteLoanTimeSeriesEntry($loanId: ID!, $asOfDate: Date!, $loanTimeSeriesTypeNames: [FieldName!]!, $loanProjectionTypeNames: [FieldName!]!) {
  assetOps {
    deleteLoanTimeSeries(
      loanId: $loanId
      asOfDate: $asOfDate
      loanTimeSeriesTypeNames: $loanTimeSeriesTypeNames
      loanProjectionTypeNames: $loanProjectionTypeNames
    ) {
      loan {
        id
        ...LoanCurrentTimeSeries
        ...LoanHistoricalTimeSeries
      }
    }
  }
}
    ${LoanCurrentTimeSeriesFragmentDoc}
${LoanHistoricalTimeSeriesFragmentDoc}`;
export type DeleteLoanTimeSeriesEntryMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteLoanTimeSeriesEntryMutation, GraphqlTypes.DeleteLoanTimeSeriesEntryMutationVariables>;

/**
 * __useDeleteLoanTimeSeriesEntryMutation__
 *
 * To run a mutation, you first call `useDeleteLoanTimeSeriesEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLoanTimeSeriesEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLoanTimeSeriesEntryMutation, { data, loading, error }] = useDeleteLoanTimeSeriesEntryMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      asOfDate: // value for 'asOfDate'
 *      loanTimeSeriesTypeNames: // value for 'loanTimeSeriesTypeNames'
 *      loanProjectionTypeNames: // value for 'loanProjectionTypeNames'
 *   },
 * });
 */
export function useDeleteLoanTimeSeriesEntryMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteLoanTimeSeriesEntryMutation, GraphqlTypes.DeleteLoanTimeSeriesEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteLoanTimeSeriesEntryMutation, GraphqlTypes.DeleteLoanTimeSeriesEntryMutationVariables>(DeleteLoanTimeSeriesEntryDocument, options);
      }
export type DeleteLoanTimeSeriesEntryMutationHookResult = ReturnType<typeof useDeleteLoanTimeSeriesEntryMutation>;
export type DeleteLoanTimeSeriesEntryMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteLoanTimeSeriesEntryMutation>;
export type DeleteLoanTimeSeriesEntryMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteLoanTimeSeriesEntryMutation, GraphqlTypes.DeleteLoanTimeSeriesEntryMutationVariables>;
export const CreateOrUpdateLoanMetricPeriodValuesDocument = gql`
    mutation CreateOrUpdateLoanMetricPeriodValues($loanId: ID!, $period: Period, $objectInput: UpdateLoanMetricPeriodEntryInput!) {
  assetOps {
    createOrUpdateLoanMetricPeriodValues(
      loanId: $loanId
      period: $period
      objectInput: $objectInput
    ) {
      loan {
        id
        ...LoanMetricPeriods
      }
    }
  }
}
    ${LoanMetricPeriodsFragmentDoc}`;
export type CreateOrUpdateLoanMetricPeriodValuesMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateOrUpdateLoanMetricPeriodValuesMutation, GraphqlTypes.CreateOrUpdateLoanMetricPeriodValuesMutationVariables>;

/**
 * __useCreateOrUpdateLoanMetricPeriodValuesMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateLoanMetricPeriodValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateLoanMetricPeriodValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateLoanMetricPeriodValuesMutation, { data, loading, error }] = useCreateOrUpdateLoanMetricPeriodValuesMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      period: // value for 'period'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useCreateOrUpdateLoanMetricPeriodValuesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateOrUpdateLoanMetricPeriodValuesMutation, GraphqlTypes.CreateOrUpdateLoanMetricPeriodValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateOrUpdateLoanMetricPeriodValuesMutation, GraphqlTypes.CreateOrUpdateLoanMetricPeriodValuesMutationVariables>(CreateOrUpdateLoanMetricPeriodValuesDocument, options);
      }
export type CreateOrUpdateLoanMetricPeriodValuesMutationHookResult = ReturnType<typeof useCreateOrUpdateLoanMetricPeriodValuesMutation>;
export type CreateOrUpdateLoanMetricPeriodValuesMutationResult = Apollo.MutationResult<GraphqlTypes.CreateOrUpdateLoanMetricPeriodValuesMutation>;
export type CreateOrUpdateLoanMetricPeriodValuesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateOrUpdateLoanMetricPeriodValuesMutation, GraphqlTypes.CreateOrUpdateLoanMetricPeriodValuesMutationVariables>;
export const DeleteLoanPeriodDocument = gql`
    mutation DeleteLoanPeriod($loanId: ID!, $period: Period!) {
  assetOps {
    deleteLoanPeriod(loanId: $loanId, period: $period) {
      loan {
        id
        ...LoanMetricPeriods
      }
    }
  }
}
    ${LoanMetricPeriodsFragmentDoc}`;
export type DeleteLoanPeriodMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteLoanPeriodMutation, GraphqlTypes.DeleteLoanPeriodMutationVariables>;

/**
 * __useDeleteLoanPeriodMutation__
 *
 * To run a mutation, you first call `useDeleteLoanPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLoanPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLoanPeriodMutation, { data, loading, error }] = useDeleteLoanPeriodMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useDeleteLoanPeriodMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteLoanPeriodMutation, GraphqlTypes.DeleteLoanPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteLoanPeriodMutation, GraphqlTypes.DeleteLoanPeriodMutationVariables>(DeleteLoanPeriodDocument, options);
      }
export type DeleteLoanPeriodMutationHookResult = ReturnType<typeof useDeleteLoanPeriodMutation>;
export type DeleteLoanPeriodMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteLoanPeriodMutation>;
export type DeleteLoanPeriodMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteLoanPeriodMutation, GraphqlTypes.DeleteLoanPeriodMutationVariables>;
export const GetAssetDisclosuresGlobalPortalDocument = gql`
    query GetAssetDisclosuresGlobalPortal {
  viewableArenas {
    edges {
      node {
        id
        assetDisclosureText
      }
    }
  }
}
    `;

/**
 * __useGetAssetDisclosuresGlobalPortalQuery__
 *
 * To run a query within a React component, call `useGetAssetDisclosuresGlobalPortalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetDisclosuresGlobalPortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetDisclosuresGlobalPortalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssetDisclosuresGlobalPortalQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAssetDisclosuresGlobalPortalQuery, GraphqlTypes.GetAssetDisclosuresGlobalPortalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetDisclosuresGlobalPortalQuery, GraphqlTypes.GetAssetDisclosuresGlobalPortalQueryVariables>(GetAssetDisclosuresGlobalPortalDocument, options);
      }
export function useGetAssetDisclosuresGlobalPortalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetDisclosuresGlobalPortalQuery, GraphqlTypes.GetAssetDisclosuresGlobalPortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetDisclosuresGlobalPortalQuery, GraphqlTypes.GetAssetDisclosuresGlobalPortalQueryVariables>(GetAssetDisclosuresGlobalPortalDocument, options);
        }
// @ts-ignore
export function useGetAssetDisclosuresGlobalPortalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetDisclosuresGlobalPortalQuery, GraphqlTypes.GetAssetDisclosuresGlobalPortalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetDisclosuresGlobalPortalQuery, GraphqlTypes.GetAssetDisclosuresGlobalPortalQueryVariables>;
export function useGetAssetDisclosuresGlobalPortalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetDisclosuresGlobalPortalQuery, GraphqlTypes.GetAssetDisclosuresGlobalPortalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetDisclosuresGlobalPortalQuery | undefined, GraphqlTypes.GetAssetDisclosuresGlobalPortalQueryVariables>;
export function useGetAssetDisclosuresGlobalPortalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetDisclosuresGlobalPortalQuery, GraphqlTypes.GetAssetDisclosuresGlobalPortalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetDisclosuresGlobalPortalQuery, GraphqlTypes.GetAssetDisclosuresGlobalPortalQueryVariables>(GetAssetDisclosuresGlobalPortalDocument, options);
        }
export type GetAssetDisclosuresGlobalPortalQueryHookResult = ReturnType<typeof useGetAssetDisclosuresGlobalPortalQuery>;
export type GetAssetDisclosuresGlobalPortalLazyQueryHookResult = ReturnType<typeof useGetAssetDisclosuresGlobalPortalLazyQuery>;
export type GetAssetDisclosuresGlobalPortalSuspenseQueryHookResult = ReturnType<typeof useGetAssetDisclosuresGlobalPortalSuspenseQuery>;
export type GetAssetDisclosuresGlobalPortalQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetDisclosuresGlobalPortalQuery, GraphqlTypes.GetAssetDisclosuresGlobalPortalQueryVariables>;
export const GetAssetDisclosuresSinglePortalDocument = gql`
    query GetAssetDisclosuresSinglePortal {
  currentArena {
    id
    assetDisclosureText
  }
}
    `;

/**
 * __useGetAssetDisclosuresSinglePortalQuery__
 *
 * To run a query within a React component, call `useGetAssetDisclosuresSinglePortalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetDisclosuresSinglePortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetDisclosuresSinglePortalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssetDisclosuresSinglePortalQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAssetDisclosuresSinglePortalQuery, GraphqlTypes.GetAssetDisclosuresSinglePortalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetDisclosuresSinglePortalQuery, GraphqlTypes.GetAssetDisclosuresSinglePortalQueryVariables>(GetAssetDisclosuresSinglePortalDocument, options);
      }
export function useGetAssetDisclosuresSinglePortalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetDisclosuresSinglePortalQuery, GraphqlTypes.GetAssetDisclosuresSinglePortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetDisclosuresSinglePortalQuery, GraphqlTypes.GetAssetDisclosuresSinglePortalQueryVariables>(GetAssetDisclosuresSinglePortalDocument, options);
        }
// @ts-ignore
export function useGetAssetDisclosuresSinglePortalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetDisclosuresSinglePortalQuery, GraphqlTypes.GetAssetDisclosuresSinglePortalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetDisclosuresSinglePortalQuery, GraphqlTypes.GetAssetDisclosuresSinglePortalQueryVariables>;
export function useGetAssetDisclosuresSinglePortalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetDisclosuresSinglePortalQuery, GraphqlTypes.GetAssetDisclosuresSinglePortalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetDisclosuresSinglePortalQuery | undefined, GraphqlTypes.GetAssetDisclosuresSinglePortalQueryVariables>;
export function useGetAssetDisclosuresSinglePortalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetDisclosuresSinglePortalQuery, GraphqlTypes.GetAssetDisclosuresSinglePortalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetDisclosuresSinglePortalQuery, GraphqlTypes.GetAssetDisclosuresSinglePortalQueryVariables>(GetAssetDisclosuresSinglePortalDocument, options);
        }
export type GetAssetDisclosuresSinglePortalQueryHookResult = ReturnType<typeof useGetAssetDisclosuresSinglePortalQuery>;
export type GetAssetDisclosuresSinglePortalLazyQueryHookResult = ReturnType<typeof useGetAssetDisclosuresSinglePortalLazyQuery>;
export type GetAssetDisclosuresSinglePortalSuspenseQueryHookResult = ReturnType<typeof useGetAssetDisclosuresSinglePortalSuspenseQuery>;
export type GetAssetDisclosuresSinglePortalQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetDisclosuresSinglePortalQuery, GraphqlTypes.GetAssetDisclosuresSinglePortalQueryVariables>;
export const CreateAssetDispositionDocument = gql`
    mutation CreateAssetDisposition($assetId: ID!, $objectInput: AssetDispositionInput!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    createAssetDisposition(
      assetId: $assetId
      objectInput: $objectInput
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        name
        percentOwned
        ...AssetDispositions
      }
    }
  }
}
    ${AssetDispositionsFragmentDoc}`;
export type CreateAssetDispositionMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateAssetDispositionMutation, GraphqlTypes.CreateAssetDispositionMutationVariables>;

/**
 * __useCreateAssetDispositionMutation__
 *
 * To run a mutation, you first call `useCreateAssetDispositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetDispositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetDispositionMutation, { data, loading, error }] = useCreateAssetDispositionMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      objectInput: // value for 'objectInput'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useCreateAssetDispositionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateAssetDispositionMutation, GraphqlTypes.CreateAssetDispositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateAssetDispositionMutation, GraphqlTypes.CreateAssetDispositionMutationVariables>(CreateAssetDispositionDocument, options);
      }
export type CreateAssetDispositionMutationHookResult = ReturnType<typeof useCreateAssetDispositionMutation>;
export type CreateAssetDispositionMutationResult = Apollo.MutationResult<GraphqlTypes.CreateAssetDispositionMutation>;
export type CreateAssetDispositionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateAssetDispositionMutation, GraphqlTypes.CreateAssetDispositionMutationVariables>;
export const UpdateAssetDispositionDocument = gql`
    mutation UpdateAssetDisposition($assetId: ID!, $dispositionId: ID!, $objectInput: AssetDispositionInput!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    updateAssetDisposition(
      assetId: $assetId
      objectId: $dispositionId
      objectInput: $objectInput
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        name
        percentOwned
        ...AssetDispositions
      }
    }
  }
}
    ${AssetDispositionsFragmentDoc}`;
export type UpdateAssetDispositionMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateAssetDispositionMutation, GraphqlTypes.UpdateAssetDispositionMutationVariables>;

/**
 * __useUpdateAssetDispositionMutation__
 *
 * To run a mutation, you first call `useUpdateAssetDispositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetDispositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetDispositionMutation, { data, loading, error }] = useUpdateAssetDispositionMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      dispositionId: // value for 'dispositionId'
 *      objectInput: // value for 'objectInput'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useUpdateAssetDispositionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateAssetDispositionMutation, GraphqlTypes.UpdateAssetDispositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateAssetDispositionMutation, GraphqlTypes.UpdateAssetDispositionMutationVariables>(UpdateAssetDispositionDocument, options);
      }
export type UpdateAssetDispositionMutationHookResult = ReturnType<typeof useUpdateAssetDispositionMutation>;
export type UpdateAssetDispositionMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateAssetDispositionMutation>;
export type UpdateAssetDispositionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateAssetDispositionMutation, GraphqlTypes.UpdateAssetDispositionMutationVariables>;
export const DeleteAssetDispositionDocument = gql`
    mutation DeleteAssetDisposition($dispositionId: ID!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    deleteAssetDisposition(
      objectId: $dispositionId
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        name
        percentOwned
        ...AssetDispositions
      }
    }
  }
}
    ${AssetDispositionsFragmentDoc}`;
export type DeleteAssetDispositionMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteAssetDispositionMutation, GraphqlTypes.DeleteAssetDispositionMutationVariables>;

/**
 * __useDeleteAssetDispositionMutation__
 *
 * To run a mutation, you first call `useDeleteAssetDispositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetDispositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetDispositionMutation, { data, loading, error }] = useDeleteAssetDispositionMutation({
 *   variables: {
 *      dispositionId: // value for 'dispositionId'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useDeleteAssetDispositionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteAssetDispositionMutation, GraphqlTypes.DeleteAssetDispositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteAssetDispositionMutation, GraphqlTypes.DeleteAssetDispositionMutationVariables>(DeleteAssetDispositionDocument, options);
      }
export type DeleteAssetDispositionMutationHookResult = ReturnType<typeof useDeleteAssetDispositionMutation>;
export type DeleteAssetDispositionMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteAssetDispositionMutation>;
export type DeleteAssetDispositionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteAssetDispositionMutation, GraphqlTypes.DeleteAssetDispositionMutationVariables>;
export const DeleteLegacyFieldFromAssetDispositionDocument = gql`
    mutation DeleteLegacyFieldFromAssetDisposition($dispositionId: ID!, $fieldName: String!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    deleteLegacyFieldFromAssetDisposition(
      objectId: $dispositionId
      fieldName: $fieldName
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        name
        percentOwned
        ...AssetDispositions
      }
    }
  }
}
    ${AssetDispositionsFragmentDoc}`;
export type DeleteLegacyFieldFromAssetDispositionMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteLegacyFieldFromAssetDispositionMutation, GraphqlTypes.DeleteLegacyFieldFromAssetDispositionMutationVariables>;

/**
 * __useDeleteLegacyFieldFromAssetDispositionMutation__
 *
 * To run a mutation, you first call `useDeleteLegacyFieldFromAssetDispositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLegacyFieldFromAssetDispositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLegacyFieldFromAssetDispositionMutation, { data, loading, error }] = useDeleteLegacyFieldFromAssetDispositionMutation({
 *   variables: {
 *      dispositionId: // value for 'dispositionId'
 *      fieldName: // value for 'fieldName'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useDeleteLegacyFieldFromAssetDispositionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteLegacyFieldFromAssetDispositionMutation, GraphqlTypes.DeleteLegacyFieldFromAssetDispositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteLegacyFieldFromAssetDispositionMutation, GraphqlTypes.DeleteLegacyFieldFromAssetDispositionMutationVariables>(DeleteLegacyFieldFromAssetDispositionDocument, options);
      }
export type DeleteLegacyFieldFromAssetDispositionMutationHookResult = ReturnType<typeof useDeleteLegacyFieldFromAssetDispositionMutation>;
export type DeleteLegacyFieldFromAssetDispositionMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteLegacyFieldFromAssetDispositionMutation>;
export type DeleteLegacyFieldFromAssetDispositionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteLegacyFieldFromAssetDispositionMutation, GraphqlTypes.DeleteLegacyFieldFromAssetDispositionMutationVariables>;
export const GetDispositionsDocument = gql`
    query GetDispositions($assetId: ID!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  asset(id: $assetId) {
    id
    name
    canEdit
    canLimitedEdit
    percentOwned
    totalNetSqft
    totalGrossSqft
    currency {
      ...CurrencyFields
    }
    entity {
      id
      currency {
        ...CurrencyFields
      }
    }
    ...AssetDispositions
  }
}
    ${CurrencyFieldsFragmentDoc}
${AssetDispositionsFragmentDoc}`;

/**
 * __useGetDispositionsQuery__
 *
 * To run a query within a React component, call `useGetDispositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDispositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDispositionsQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetDispositionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDispositionsQuery, GraphqlTypes.GetDispositionsQueryVariables> & ({ variables: GraphqlTypes.GetDispositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDispositionsQuery, GraphqlTypes.GetDispositionsQueryVariables>(GetDispositionsDocument, options);
      }
export function useGetDispositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDispositionsQuery, GraphqlTypes.GetDispositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDispositionsQuery, GraphqlTypes.GetDispositionsQueryVariables>(GetDispositionsDocument, options);
        }
// @ts-ignore
export function useGetDispositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDispositionsQuery, GraphqlTypes.GetDispositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDispositionsQuery, GraphqlTypes.GetDispositionsQueryVariables>;
export function useGetDispositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDispositionsQuery, GraphqlTypes.GetDispositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDispositionsQuery | undefined, GraphqlTypes.GetDispositionsQueryVariables>;
export function useGetDispositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDispositionsQuery, GraphqlTypes.GetDispositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDispositionsQuery, GraphqlTypes.GetDispositionsQueryVariables>(GetDispositionsDocument, options);
        }
export type GetDispositionsQueryHookResult = ReturnType<typeof useGetDispositionsQuery>;
export type GetDispositionsLazyQueryHookResult = ReturnType<typeof useGetDispositionsLazyQuery>;
export type GetDispositionsSuspenseQueryHookResult = ReturnType<typeof useGetDispositionsSuspenseQuery>;
export type GetDispositionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDispositionsQuery, GraphqlTypes.GetDispositionsQueryVariables>;
export const UpdateEntitySummaryDocument = gql`
    mutation UpdateEntitySummary($objectId: ID!, $objectInput: EntitySummaryInput!) {
  entityOps {
    updateEntitySummary(objectId: $objectId, objectInput: $objectInput) {
      entity {
        id
        description
        inheritedDescription {
          description
          entityId
          entityName
        }
      }
    }
  }
}
    `;
export type UpdateEntitySummaryMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateEntitySummaryMutation, GraphqlTypes.UpdateEntitySummaryMutationVariables>;

/**
 * __useUpdateEntitySummaryMutation__
 *
 * To run a mutation, you first call `useUpdateEntitySummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntitySummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntitySummaryMutation, { data, loading, error }] = useUpdateEntitySummaryMutation({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateEntitySummaryMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateEntitySummaryMutation, GraphqlTypes.UpdateEntitySummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateEntitySummaryMutation, GraphqlTypes.UpdateEntitySummaryMutationVariables>(UpdateEntitySummaryDocument, options);
      }
export type UpdateEntitySummaryMutationHookResult = ReturnType<typeof useUpdateEntitySummaryMutation>;
export type UpdateEntitySummaryMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateEntitySummaryMutation>;
export type UpdateEntitySummaryMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateEntitySummaryMutation, GraphqlTypes.UpdateEntitySummaryMutationVariables>;
export const GetLocationsForEntityDocument = gql`
    query GetLocationsForEntity($entityId: ID!) {
  investmentEntity(id: $entityId) {
    id
    name
    description
    inheritedDescription {
      description
      entityId
      entityName
    }
    assetsIndirect {
      edges {
        node {
          id
          name
          isSold
          saleDate
          ...AssetLocations
        }
      }
    }
  }
}
    ${AssetLocationsFragmentDoc}`;

/**
 * __useGetLocationsForEntityQuery__
 *
 * To run a query within a React component, call `useGetLocationsForEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsForEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsForEntityQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetLocationsForEntityQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetLocationsForEntityQuery, GraphqlTypes.GetLocationsForEntityQueryVariables> & ({ variables: GraphqlTypes.GetLocationsForEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLocationsForEntityQuery, GraphqlTypes.GetLocationsForEntityQueryVariables>(GetLocationsForEntityDocument, options);
      }
export function useGetLocationsForEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLocationsForEntityQuery, GraphqlTypes.GetLocationsForEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLocationsForEntityQuery, GraphqlTypes.GetLocationsForEntityQueryVariables>(GetLocationsForEntityDocument, options);
        }
// @ts-ignore
export function useGetLocationsForEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLocationsForEntityQuery, GraphqlTypes.GetLocationsForEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLocationsForEntityQuery, GraphqlTypes.GetLocationsForEntityQueryVariables>;
export function useGetLocationsForEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLocationsForEntityQuery, GraphqlTypes.GetLocationsForEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLocationsForEntityQuery | undefined, GraphqlTypes.GetLocationsForEntityQueryVariables>;
export function useGetLocationsForEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLocationsForEntityQuery, GraphqlTypes.GetLocationsForEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLocationsForEntityQuery, GraphqlTypes.GetLocationsForEntityQueryVariables>(GetLocationsForEntityDocument, options);
        }
export type GetLocationsForEntityQueryHookResult = ReturnType<typeof useGetLocationsForEntityQuery>;
export type GetLocationsForEntityLazyQueryHookResult = ReturnType<typeof useGetLocationsForEntityLazyQuery>;
export type GetLocationsForEntitySuspenseQueryHookResult = ReturnType<typeof useGetLocationsForEntitySuspenseQuery>;
export type GetLocationsForEntityQueryResult = Apollo.QueryResult<GraphqlTypes.GetLocationsForEntityQuery, GraphqlTypes.GetLocationsForEntityQueryVariables>;
export const CreateOrUpdateInvestmentCashFlowsDocument = gql`
    mutation CreateOrUpdateInvestmentCashFlows($entityId: ID!, $objectInput: UpdateInvestmentCashFlowsInput!, $orgPeriod: String, $orgYear: Int) {
  assetOps {
    createOrUpdateInvestmentCashFlows(
      objectId: $entityId
      objectInput: $objectInput
      orgPeriod: $orgPeriod
      orgYear: $orgYear
    ) {
      entity {
        id
      }
    }
  }
}
    `;
export type CreateOrUpdateInvestmentCashFlowsMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateOrUpdateInvestmentCashFlowsMutation, GraphqlTypes.CreateOrUpdateInvestmentCashFlowsMutationVariables>;

/**
 * __useCreateOrUpdateInvestmentCashFlowsMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateInvestmentCashFlowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateInvestmentCashFlowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateInvestmentCashFlowsMutation, { data, loading, error }] = useCreateOrUpdateInvestmentCashFlowsMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      objectInput: // value for 'objectInput'
 *      orgPeriod: // value for 'orgPeriod'
 *      orgYear: // value for 'orgYear'
 *   },
 * });
 */
export function useCreateOrUpdateInvestmentCashFlowsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateOrUpdateInvestmentCashFlowsMutation, GraphqlTypes.CreateOrUpdateInvestmentCashFlowsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateOrUpdateInvestmentCashFlowsMutation, GraphqlTypes.CreateOrUpdateInvestmentCashFlowsMutationVariables>(CreateOrUpdateInvestmentCashFlowsDocument, options);
      }
export type CreateOrUpdateInvestmentCashFlowsMutationHookResult = ReturnType<typeof useCreateOrUpdateInvestmentCashFlowsMutation>;
export type CreateOrUpdateInvestmentCashFlowsMutationResult = Apollo.MutationResult<GraphqlTypes.CreateOrUpdateInvestmentCashFlowsMutation>;
export type CreateOrUpdateInvestmentCashFlowsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateOrUpdateInvestmentCashFlowsMutation, GraphqlTypes.CreateOrUpdateInvestmentCashFlowsMutationVariables>;
export const DeleteInvestmentCashFlowsDocument = gql`
    mutation DeleteInvestmentCashFlows($entityId: ID!, $period: String!, $year: Int!) {
  assetOps {
    deleteInvestmentCashFlows(
      globalEntityId: $entityId
      period: $period
      year: $year
    ) {
      entity {
        id
      }
    }
  }
}
    `;
export type DeleteInvestmentCashFlowsMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteInvestmentCashFlowsMutation, GraphqlTypes.DeleteInvestmentCashFlowsMutationVariables>;

/**
 * __useDeleteInvestmentCashFlowsMutation__
 *
 * To run a mutation, you first call `useDeleteInvestmentCashFlowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvestmentCashFlowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvestmentCashFlowsMutation, { data, loading, error }] = useDeleteInvestmentCashFlowsMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      period: // value for 'period'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useDeleteInvestmentCashFlowsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteInvestmentCashFlowsMutation, GraphqlTypes.DeleteInvestmentCashFlowsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteInvestmentCashFlowsMutation, GraphqlTypes.DeleteInvestmentCashFlowsMutationVariables>(DeleteInvestmentCashFlowsDocument, options);
      }
export type DeleteInvestmentCashFlowsMutationHookResult = ReturnType<typeof useDeleteInvestmentCashFlowsMutation>;
export type DeleteInvestmentCashFlowsMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteInvestmentCashFlowsMutation>;
export type DeleteInvestmentCashFlowsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteInvestmentCashFlowsMutation, GraphqlTypes.DeleteInvestmentCashFlowsMutationVariables>;
export const GetInvestmentCashFlowsDocument = gql`
    query GetInvestmentCashFlows($objectId: ID!, $plCategories: [FieldName]!, $entityTimeSeriesTypeNames: [FieldName]!) {
  investmentEntity(id: $objectId) {
    id
    name
    canEdit
    canLimitedEdit
    isOperatingCompany
    currency {
      id
      code
      symbol
      fullName
    }
    ...EntityProfitLossPeriods
    ...EntityTimeSeries
  }
}
    ${EntityProfitLossPeriodsFragmentDoc}
${EntityTimeSeriesFragmentDoc}`;

/**
 * __useGetInvestmentCashFlowsQuery__
 *
 * To run a query within a React component, call `useGetInvestmentCashFlowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentCashFlowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentCashFlowsQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      plCategories: // value for 'plCategories'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetInvestmentCashFlowsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentCashFlowsQuery, GraphqlTypes.GetInvestmentCashFlowsQueryVariables> & ({ variables: GraphqlTypes.GetInvestmentCashFlowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentCashFlowsQuery, GraphqlTypes.GetInvestmentCashFlowsQueryVariables>(GetInvestmentCashFlowsDocument, options);
      }
export function useGetInvestmentCashFlowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentCashFlowsQuery, GraphqlTypes.GetInvestmentCashFlowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentCashFlowsQuery, GraphqlTypes.GetInvestmentCashFlowsQueryVariables>(GetInvestmentCashFlowsDocument, options);
        }
// @ts-ignore
export function useGetInvestmentCashFlowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentCashFlowsQuery, GraphqlTypes.GetInvestmentCashFlowsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentCashFlowsQuery, GraphqlTypes.GetInvestmentCashFlowsQueryVariables>;
export function useGetInvestmentCashFlowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentCashFlowsQuery, GraphqlTypes.GetInvestmentCashFlowsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentCashFlowsQuery | undefined, GraphqlTypes.GetInvestmentCashFlowsQueryVariables>;
export function useGetInvestmentCashFlowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentCashFlowsQuery, GraphqlTypes.GetInvestmentCashFlowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentCashFlowsQuery, GraphqlTypes.GetInvestmentCashFlowsQueryVariables>(GetInvestmentCashFlowsDocument, options);
        }
export type GetInvestmentCashFlowsQueryHookResult = ReturnType<typeof useGetInvestmentCashFlowsQuery>;
export type GetInvestmentCashFlowsLazyQueryHookResult = ReturnType<typeof useGetInvestmentCashFlowsLazyQuery>;
export type GetInvestmentCashFlowsSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentCashFlowsSuspenseQuery>;
export type GetInvestmentCashFlowsQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentCashFlowsQuery, GraphqlTypes.GetInvestmentCashFlowsQueryVariables>;
export const UpsertAssetKeyDatesProjectionsDocument = gql`
    mutation UpsertAssetKeyDatesProjections($assetId: ID!, $editingAsOfDate: DateTime!, $asOfDate: DateTime!, $objectInput: [AssetKeyDatesValueInput!]!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    upsertAssetKeyDatesProjections(
      assetId: $assetId
      editingAsOfDate: $editingAsOfDate
      asOfDate: $asOfDate
      objectInput: $objectInput
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        ...AssetLatestTimeSeriesProjections
        ...AssetTimeSeriesProjections
      }
    }
  }
}
    ${AssetLatestTimeSeriesProjectionsFragmentDoc}
${AssetTimeSeriesProjectionsFragmentDoc}`;
export type UpsertAssetKeyDatesProjectionsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertAssetKeyDatesProjectionsMutation, GraphqlTypes.UpsertAssetKeyDatesProjectionsMutationVariables>;

/**
 * __useUpsertAssetKeyDatesProjectionsMutation__
 *
 * To run a mutation, you first call `useUpsertAssetKeyDatesProjectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAssetKeyDatesProjectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAssetKeyDatesProjectionsMutation, { data, loading, error }] = useUpsertAssetKeyDatesProjectionsMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      editingAsOfDate: // value for 'editingAsOfDate'
 *      asOfDate: // value for 'asOfDate'
 *      objectInput: // value for 'objectInput'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useUpsertAssetKeyDatesProjectionsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertAssetKeyDatesProjectionsMutation, GraphqlTypes.UpsertAssetKeyDatesProjectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertAssetKeyDatesProjectionsMutation, GraphqlTypes.UpsertAssetKeyDatesProjectionsMutationVariables>(UpsertAssetKeyDatesProjectionsDocument, options);
      }
export type UpsertAssetKeyDatesProjectionsMutationHookResult = ReturnType<typeof useUpsertAssetKeyDatesProjectionsMutation>;
export type UpsertAssetKeyDatesProjectionsMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertAssetKeyDatesProjectionsMutation>;
export type UpsertAssetKeyDatesProjectionsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertAssetKeyDatesProjectionsMutation, GraphqlTypes.UpsertAssetKeyDatesProjectionsMutationVariables>;
export const DeleteAssetKeyDatesProjectionsDocument = gql`
    mutation DeleteAssetKeyDatesProjections($assetId: ID!, $asOfDate: DateTime!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    deleteAssetKeyDatesProjections(
      assetId: $assetId
      asOfDate: $asOfDate
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        ...AssetLatestTimeSeriesProjections
        ...AssetTimeSeriesProjections
      }
    }
  }
}
    ${AssetLatestTimeSeriesProjectionsFragmentDoc}
${AssetTimeSeriesProjectionsFragmentDoc}`;
export type DeleteAssetKeyDatesProjectionsMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteAssetKeyDatesProjectionsMutation, GraphqlTypes.DeleteAssetKeyDatesProjectionsMutationVariables>;

/**
 * __useDeleteAssetKeyDatesProjectionsMutation__
 *
 * To run a mutation, you first call `useDeleteAssetKeyDatesProjectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetKeyDatesProjectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetKeyDatesProjectionsMutation, { data, loading, error }] = useDeleteAssetKeyDatesProjectionsMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      asOfDate: // value for 'asOfDate'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useDeleteAssetKeyDatesProjectionsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteAssetKeyDatesProjectionsMutation, GraphqlTypes.DeleteAssetKeyDatesProjectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteAssetKeyDatesProjectionsMutation, GraphqlTypes.DeleteAssetKeyDatesProjectionsMutationVariables>(DeleteAssetKeyDatesProjectionsDocument, options);
      }
export type DeleteAssetKeyDatesProjectionsMutationHookResult = ReturnType<typeof useDeleteAssetKeyDatesProjectionsMutation>;
export type DeleteAssetKeyDatesProjectionsMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteAssetKeyDatesProjectionsMutation>;
export type DeleteAssetKeyDatesProjectionsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteAssetKeyDatesProjectionsMutation, GraphqlTypes.DeleteAssetKeyDatesProjectionsMutationVariables>;
export const UpsertAssetKeyDatesActualsDocument = gql`
    mutation UpsertAssetKeyDatesActuals($assetId: ID!, $objectInput: [AssetKeyDatesValueInput!]) {
  assetOps {
    upsertAssetKeyDatesActuals(assetId: $assetId, objectInput: $objectInput) {
      asset {
        id
        ...AssetKeyDatesActuals
      }
    }
  }
}
    ${AssetKeyDatesActualsFragmentDoc}`;
export type UpsertAssetKeyDatesActualsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertAssetKeyDatesActualsMutation, GraphqlTypes.UpsertAssetKeyDatesActualsMutationVariables>;

/**
 * __useUpsertAssetKeyDatesActualsMutation__
 *
 * To run a mutation, you first call `useUpsertAssetKeyDatesActualsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAssetKeyDatesActualsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAssetKeyDatesActualsMutation, { data, loading, error }] = useUpsertAssetKeyDatesActualsMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpsertAssetKeyDatesActualsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertAssetKeyDatesActualsMutation, GraphqlTypes.UpsertAssetKeyDatesActualsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertAssetKeyDatesActualsMutation, GraphqlTypes.UpsertAssetKeyDatesActualsMutationVariables>(UpsertAssetKeyDatesActualsDocument, options);
      }
export type UpsertAssetKeyDatesActualsMutationHookResult = ReturnType<typeof useUpsertAssetKeyDatesActualsMutation>;
export type UpsertAssetKeyDatesActualsMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertAssetKeyDatesActualsMutation>;
export type UpsertAssetKeyDatesActualsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertAssetKeyDatesActualsMutation, GraphqlTypes.UpsertAssetKeyDatesActualsMutationVariables>;
export const GetAssetKeyDatesDocument = gql`
    query GetAssetKeyDates($assetId: ID!, $assetTimeSeriesTypeNames: [FieldName]!) {
  asset(id: $assetId) {
    id
    name
    canEdit
    canLimitedEdit
    ...AssetKeyDatesActuals
    ...AssetLatestTimeSeriesProjections
  }
}
    ${AssetKeyDatesActualsFragmentDoc}
${AssetLatestTimeSeriesProjectionsFragmentDoc}`;

/**
 * __useGetAssetKeyDatesQuery__
 *
 * To run a query within a React component, call `useGetAssetKeyDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetKeyDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetKeyDatesQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetAssetKeyDatesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAssetKeyDatesQuery, GraphqlTypes.GetAssetKeyDatesQueryVariables> & ({ variables: GraphqlTypes.GetAssetKeyDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetKeyDatesQuery, GraphqlTypes.GetAssetKeyDatesQueryVariables>(GetAssetKeyDatesDocument, options);
      }
export function useGetAssetKeyDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetKeyDatesQuery, GraphqlTypes.GetAssetKeyDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetKeyDatesQuery, GraphqlTypes.GetAssetKeyDatesQueryVariables>(GetAssetKeyDatesDocument, options);
        }
// @ts-ignore
export function useGetAssetKeyDatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetKeyDatesQuery, GraphqlTypes.GetAssetKeyDatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetKeyDatesQuery, GraphqlTypes.GetAssetKeyDatesQueryVariables>;
export function useGetAssetKeyDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetKeyDatesQuery, GraphqlTypes.GetAssetKeyDatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetKeyDatesQuery | undefined, GraphqlTypes.GetAssetKeyDatesQueryVariables>;
export function useGetAssetKeyDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetKeyDatesQuery, GraphqlTypes.GetAssetKeyDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetKeyDatesQuery, GraphqlTypes.GetAssetKeyDatesQueryVariables>(GetAssetKeyDatesDocument, options);
        }
export type GetAssetKeyDatesQueryHookResult = ReturnType<typeof useGetAssetKeyDatesQuery>;
export type GetAssetKeyDatesLazyQueryHookResult = ReturnType<typeof useGetAssetKeyDatesLazyQuery>;
export type GetAssetKeyDatesSuspenseQueryHookResult = ReturnType<typeof useGetAssetKeyDatesSuspenseQuery>;
export type GetAssetKeyDatesQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetKeyDatesQuery, GraphqlTypes.GetAssetKeyDatesQueryVariables>;
export const GetKeyDatesHistoricalsDocument = gql`
    query GetKeyDatesHistoricals($assetId: ID!, $assetTimeSeriesTypeNames: [FieldName]!) {
  asset(id: $assetId) {
    id
    ...AssetTimeSeriesProjections
  }
}
    ${AssetTimeSeriesProjectionsFragmentDoc}`;

/**
 * __useGetKeyDatesHistoricalsQuery__
 *
 * To run a query within a React component, call `useGetKeyDatesHistoricalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeyDatesHistoricalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeyDatesHistoricalsQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetKeyDatesHistoricalsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetKeyDatesHistoricalsQuery, GraphqlTypes.GetKeyDatesHistoricalsQueryVariables> & ({ variables: GraphqlTypes.GetKeyDatesHistoricalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetKeyDatesHistoricalsQuery, GraphqlTypes.GetKeyDatesHistoricalsQueryVariables>(GetKeyDatesHistoricalsDocument, options);
      }
export function useGetKeyDatesHistoricalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetKeyDatesHistoricalsQuery, GraphqlTypes.GetKeyDatesHistoricalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetKeyDatesHistoricalsQuery, GraphqlTypes.GetKeyDatesHistoricalsQueryVariables>(GetKeyDatesHistoricalsDocument, options);
        }
// @ts-ignore
export function useGetKeyDatesHistoricalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKeyDatesHistoricalsQuery, GraphqlTypes.GetKeyDatesHistoricalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetKeyDatesHistoricalsQuery, GraphqlTypes.GetKeyDatesHistoricalsQueryVariables>;
export function useGetKeyDatesHistoricalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKeyDatesHistoricalsQuery, GraphqlTypes.GetKeyDatesHistoricalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetKeyDatesHistoricalsQuery | undefined, GraphqlTypes.GetKeyDatesHistoricalsQueryVariables>;
export function useGetKeyDatesHistoricalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKeyDatesHistoricalsQuery, GraphqlTypes.GetKeyDatesHistoricalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetKeyDatesHistoricalsQuery, GraphqlTypes.GetKeyDatesHistoricalsQueryVariables>(GetKeyDatesHistoricalsDocument, options);
        }
export type GetKeyDatesHistoricalsQueryHookResult = ReturnType<typeof useGetKeyDatesHistoricalsQuery>;
export type GetKeyDatesHistoricalsLazyQueryHookResult = ReturnType<typeof useGetKeyDatesHistoricalsLazyQuery>;
export type GetKeyDatesHistoricalsSuspenseQueryHookResult = ReturnType<typeof useGetKeyDatesHistoricalsSuspenseQuery>;
export type GetKeyDatesHistoricalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetKeyDatesHistoricalsQuery, GraphqlTypes.GetKeyDatesHistoricalsQueryVariables>;
export const GetLeasingDocument = gql`
    query GetLeasing($assetId: ID!, $assetTimeSeriesTypeNames: [FieldName]!) {
  asset(id: $assetId) {
    id
    name
    ...AssetTimeSeries
    entity {
      id
      canEdit
      canLimitedEdit
    }
  }
}
    ${AssetTimeSeriesFragmentDoc}`;

/**
 * __useGetLeasingQuery__
 *
 * To run a query within a React component, call `useGetLeasingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeasingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeasingQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetLeasingQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetLeasingQuery, GraphqlTypes.GetLeasingQueryVariables> & ({ variables: GraphqlTypes.GetLeasingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLeasingQuery, GraphqlTypes.GetLeasingQueryVariables>(GetLeasingDocument, options);
      }
export function useGetLeasingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLeasingQuery, GraphqlTypes.GetLeasingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLeasingQuery, GraphqlTypes.GetLeasingQueryVariables>(GetLeasingDocument, options);
        }
// @ts-ignore
export function useGetLeasingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLeasingQuery, GraphqlTypes.GetLeasingQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLeasingQuery, GraphqlTypes.GetLeasingQueryVariables>;
export function useGetLeasingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLeasingQuery, GraphqlTypes.GetLeasingQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLeasingQuery | undefined, GraphqlTypes.GetLeasingQueryVariables>;
export function useGetLeasingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLeasingQuery, GraphqlTypes.GetLeasingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLeasingQuery, GraphqlTypes.GetLeasingQueryVariables>(GetLeasingDocument, options);
        }
export type GetLeasingQueryHookResult = ReturnType<typeof useGetLeasingQuery>;
export type GetLeasingLazyQueryHookResult = ReturnType<typeof useGetLeasingLazyQuery>;
export type GetLeasingSuspenseQueryHookResult = ReturnType<typeof useGetLeasingSuspenseQuery>;
export type GetLeasingQueryResult = Apollo.QueryResult<GraphqlTypes.GetLeasingQuery, GraphqlTypes.GetLeasingQueryVariables>;
export const DeleteAssetLocationDocument = gql`
    mutation DeleteAssetLocation($assetId: ID!, $locationId: ID!) {
  assetOps {
    deleteLocation(assetId: $assetId, objectId: $locationId) {
      result {
        ...DeleteAssetLocationFields
      }
    }
  }
}
    ${DeleteAssetLocationFieldsFragmentDoc}`;
export type DeleteAssetLocationMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteAssetLocationMutation, GraphqlTypes.DeleteAssetLocationMutationVariables>;

/**
 * __useDeleteAssetLocationMutation__
 *
 * To run a mutation, you first call `useDeleteAssetLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetLocationMutation, { data, loading, error }] = useDeleteAssetLocationMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useDeleteAssetLocationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteAssetLocationMutation, GraphqlTypes.DeleteAssetLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteAssetLocationMutation, GraphqlTypes.DeleteAssetLocationMutationVariables>(DeleteAssetLocationDocument, options);
      }
export type DeleteAssetLocationMutationHookResult = ReturnType<typeof useDeleteAssetLocationMutation>;
export type DeleteAssetLocationMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteAssetLocationMutation>;
export type DeleteAssetLocationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteAssetLocationMutation, GraphqlTypes.DeleteAssetLocationMutationVariables>;
export const CreateAssetLocationDocument = gql`
    mutation CreateAssetLocation($assetId: ID!, $objectInput: AssetLocationInput!) {
  assetOps {
    createLocation(objectId: $assetId, objectInput: $objectInput) {
      location {
        ...LocationFields
        asset {
          id
        }
      }
    }
  }
}
    ${LocationFieldsFragmentDoc}`;
export type CreateAssetLocationMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateAssetLocationMutation, GraphqlTypes.CreateAssetLocationMutationVariables>;

/**
 * __useCreateAssetLocationMutation__
 *
 * To run a mutation, you first call `useCreateAssetLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetLocationMutation, { data, loading, error }] = useCreateAssetLocationMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useCreateAssetLocationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateAssetLocationMutation, GraphqlTypes.CreateAssetLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateAssetLocationMutation, GraphqlTypes.CreateAssetLocationMutationVariables>(CreateAssetLocationDocument, options);
      }
export type CreateAssetLocationMutationHookResult = ReturnType<typeof useCreateAssetLocationMutation>;
export type CreateAssetLocationMutationResult = Apollo.MutationResult<GraphqlTypes.CreateAssetLocationMutation>;
export type CreateAssetLocationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateAssetLocationMutation, GraphqlTypes.CreateAssetLocationMutationVariables>;
export const UpdateAssetLocationDocument = gql`
    mutation UpdateAssetLocation($assetId: ID!, $locationId: ID!, $objectInput: AssetLocationInput!) {
  assetOps {
    updateLocation(
      assetId: $assetId
      objectId: $locationId
      objectInput: $objectInput
    ) {
      location {
        ...LocationFields
        asset {
          id
        }
      }
    }
  }
}
    ${LocationFieldsFragmentDoc}`;
export type UpdateAssetLocationMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateAssetLocationMutation, GraphqlTypes.UpdateAssetLocationMutationVariables>;

/**
 * __useUpdateAssetLocationMutation__
 *
 * To run a mutation, you first call `useUpdateAssetLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetLocationMutation, { data, loading, error }] = useUpdateAssetLocationMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      locationId: // value for 'locationId'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateAssetLocationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateAssetLocationMutation, GraphqlTypes.UpdateAssetLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateAssetLocationMutation, GraphqlTypes.UpdateAssetLocationMutationVariables>(UpdateAssetLocationDocument, options);
      }
export type UpdateAssetLocationMutationHookResult = ReturnType<typeof useUpdateAssetLocationMutation>;
export type UpdateAssetLocationMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateAssetLocationMutation>;
export type UpdateAssetLocationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateAssetLocationMutation, GraphqlTypes.UpdateAssetLocationMutationVariables>;
export const GetLocationsDocument = gql`
    query GetLocations($assetId: ID!) {
  asset(id: $assetId) {
    id
    name
    canEdit
    canLimitedEdit
    isSold
    saleDate
    ...AssetLocations
    ...AssetStateCBSA
  }
}
    ${AssetLocationsFragmentDoc}
${AssetStateCbsaFragmentDoc}`;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useGetLocationsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetLocationsQuery, GraphqlTypes.GetLocationsQueryVariables> & ({ variables: GraphqlTypes.GetLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLocationsQuery, GraphqlTypes.GetLocationsQueryVariables>(GetLocationsDocument, options);
      }
export function useGetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLocationsQuery, GraphqlTypes.GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLocationsQuery, GraphqlTypes.GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
// @ts-ignore
export function useGetLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLocationsQuery, GraphqlTypes.GetLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLocationsQuery, GraphqlTypes.GetLocationsQueryVariables>;
export function useGetLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLocationsQuery, GraphqlTypes.GetLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLocationsQuery | undefined, GraphqlTypes.GetLocationsQueryVariables>;
export function useGetLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLocationsQuery, GraphqlTypes.GetLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLocationsQuery, GraphqlTypes.GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export type GetLocationsQueryHookResult = ReturnType<typeof useGetLocationsQuery>;
export type GetLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationsLazyQuery>;
export type GetLocationsSuspenseQueryHookResult = ReturnType<typeof useGetLocationsSuspenseQuery>;
export type GetLocationsQueryResult = Apollo.QueryResult<GraphqlTypes.GetLocationsQuery, GraphqlTypes.GetLocationsQueryVariables>;
export const GetCountriesDocument = gql`
    query GetCountries {
  countries {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
// @ts-ignore
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>;
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountriesQuery | undefined, GraphqlTypes.GetCountriesQueryVariables>;
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>;
export const GetStatesDocument = gql`
    query GetStates {
  states {
    edges {
      node {
        id
        code
        name
      }
    }
  }
}
    `;

/**
 * __useGetStatesQuery__
 *
 * To run a query within a React component, call `useGetStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetStatesQuery, GraphqlTypes.GetStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetStatesQuery, GraphqlTypes.GetStatesQueryVariables>(GetStatesDocument, options);
      }
export function useGetStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetStatesQuery, GraphqlTypes.GetStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetStatesQuery, GraphqlTypes.GetStatesQueryVariables>(GetStatesDocument, options);
        }
// @ts-ignore
export function useGetStatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStatesQuery, GraphqlTypes.GetStatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStatesQuery, GraphqlTypes.GetStatesQueryVariables>;
export function useGetStatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStatesQuery, GraphqlTypes.GetStatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStatesQuery | undefined, GraphqlTypes.GetStatesQueryVariables>;
export function useGetStatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStatesQuery, GraphqlTypes.GetStatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetStatesQuery, GraphqlTypes.GetStatesQueryVariables>(GetStatesDocument, options);
        }
export type GetStatesQueryHookResult = ReturnType<typeof useGetStatesQuery>;
export type GetStatesLazyQueryHookResult = ReturnType<typeof useGetStatesLazyQuery>;
export type GetStatesSuspenseQueryHookResult = ReturnType<typeof useGetStatesSuspenseQuery>;
export type GetStatesQueryResult = Apollo.QueryResult<GraphqlTypes.GetStatesQuery, GraphqlTypes.GetStatesQueryVariables>;
export const UpdateOpCoStatusTimeSeriesDocument = gql`
    mutation UpdateOpCoStatusTimeSeries($entityId: ID!, $objectInput: [UpdateOpCoStatusTimeSeriesInput!]!, $entityTimeSeriesTypeNames: [FieldName!]!) {
  entityOps {
    updateOpCoStatusTimeSeries(
      entityId: $entityId
      objectInput: $objectInput
      entityTimeSeriesTypeNames: $entityTimeSeriesTypeNames
    ) {
      entity {
        id
        name
        ...EntityTimeSeries
      }
    }
  }
}
    ${EntityTimeSeriesFragmentDoc}`;
export type UpdateOpCoStatusTimeSeriesMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateOpCoStatusTimeSeriesMutation, GraphqlTypes.UpdateOpCoStatusTimeSeriesMutationVariables>;

/**
 * __useUpdateOpCoStatusTimeSeriesMutation__
 *
 * To run a mutation, you first call `useUpdateOpCoStatusTimeSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpCoStatusTimeSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpCoStatusTimeSeriesMutation, { data, loading, error }] = useUpdateOpCoStatusTimeSeriesMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      objectInput: // value for 'objectInput'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *   },
 * });
 */
export function useUpdateOpCoStatusTimeSeriesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateOpCoStatusTimeSeriesMutation, GraphqlTypes.UpdateOpCoStatusTimeSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateOpCoStatusTimeSeriesMutation, GraphqlTypes.UpdateOpCoStatusTimeSeriesMutationVariables>(UpdateOpCoStatusTimeSeriesDocument, options);
      }
export type UpdateOpCoStatusTimeSeriesMutationHookResult = ReturnType<typeof useUpdateOpCoStatusTimeSeriesMutation>;
export type UpdateOpCoStatusTimeSeriesMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateOpCoStatusTimeSeriesMutation>;
export type UpdateOpCoStatusTimeSeriesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateOpCoStatusTimeSeriesMutation, GraphqlTypes.UpdateOpCoStatusTimeSeriesMutationVariables>;
export const DeleteOpCoStatusTimeSeriesDocument = gql`
    mutation DeleteOpCoStatusTimeSeries($entityId: ID!, $asOfDate: DateTime!, $entityTimeSeriesTypeNames: [FieldName!]!, $projectionTimeSeriesTypeNames: [FieldName!]!) {
  entityOps {
    deleteTimeSeries(
      entityId: $entityId
      asOfDate: $asOfDate
      entityTimeSeriesTypeNames: $entityTimeSeriesTypeNames
      projectionTimeSeriesTypeNames: $projectionTimeSeriesTypeNames
    ) {
      entity {
        id
        name
        ...EntityLatestTimeSeries
        ...EntityTimeSeries
      }
    }
  }
}
    ${EntityLatestTimeSeriesFragmentDoc}
${EntityTimeSeriesFragmentDoc}`;
export type DeleteOpCoStatusTimeSeriesMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteOpCoStatusTimeSeriesMutation, GraphqlTypes.DeleteOpCoStatusTimeSeriesMutationVariables>;

/**
 * __useDeleteOpCoStatusTimeSeriesMutation__
 *
 * To run a mutation, you first call `useDeleteOpCoStatusTimeSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOpCoStatusTimeSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOpCoStatusTimeSeriesMutation, { data, loading, error }] = useDeleteOpCoStatusTimeSeriesMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      asOfDate: // value for 'asOfDate'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *      projectionTimeSeriesTypeNames: // value for 'projectionTimeSeriesTypeNames'
 *   },
 * });
 */
export function useDeleteOpCoStatusTimeSeriesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteOpCoStatusTimeSeriesMutation, GraphqlTypes.DeleteOpCoStatusTimeSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteOpCoStatusTimeSeriesMutation, GraphqlTypes.DeleteOpCoStatusTimeSeriesMutationVariables>(DeleteOpCoStatusTimeSeriesDocument, options);
      }
export type DeleteOpCoStatusTimeSeriesMutationHookResult = ReturnType<typeof useDeleteOpCoStatusTimeSeriesMutation>;
export type DeleteOpCoStatusTimeSeriesMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteOpCoStatusTimeSeriesMutation>;
export type DeleteOpCoStatusTimeSeriesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteOpCoStatusTimeSeriesMutation, GraphqlTypes.DeleteOpCoStatusTimeSeriesMutationVariables>;
export const GetOpCoStatusDocument = gql`
    query GetOpCoStatus($entityId: ID!, $entityTimeSeriesTypeNames: [FieldName]!) {
  investmentEntity(id: $entityId) {
    id
    name
    canEdit
    canLimitedEdit
    ...EntityTimeSeries
  }
}
    ${EntityTimeSeriesFragmentDoc}`;

/**
 * __useGetOpCoStatusQuery__
 *
 * To run a query within a React component, call `useGetOpCoStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpCoStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpCoStatusQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetOpCoStatusQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOpCoStatusQuery, GraphqlTypes.GetOpCoStatusQueryVariables> & ({ variables: GraphqlTypes.GetOpCoStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOpCoStatusQuery, GraphqlTypes.GetOpCoStatusQueryVariables>(GetOpCoStatusDocument, options);
      }
export function useGetOpCoStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOpCoStatusQuery, GraphqlTypes.GetOpCoStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOpCoStatusQuery, GraphqlTypes.GetOpCoStatusQueryVariables>(GetOpCoStatusDocument, options);
        }
// @ts-ignore
export function useGetOpCoStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOpCoStatusQuery, GraphqlTypes.GetOpCoStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOpCoStatusQuery, GraphqlTypes.GetOpCoStatusQueryVariables>;
export function useGetOpCoStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOpCoStatusQuery, GraphqlTypes.GetOpCoStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOpCoStatusQuery | undefined, GraphqlTypes.GetOpCoStatusQueryVariables>;
export function useGetOpCoStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOpCoStatusQuery, GraphqlTypes.GetOpCoStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOpCoStatusQuery, GraphqlTypes.GetOpCoStatusQueryVariables>(GetOpCoStatusDocument, options);
        }
export type GetOpCoStatusQueryHookResult = ReturnType<typeof useGetOpCoStatusQuery>;
export type GetOpCoStatusLazyQueryHookResult = ReturnType<typeof useGetOpCoStatusLazyQuery>;
export type GetOpCoStatusSuspenseQueryHookResult = ReturnType<typeof useGetOpCoStatusSuspenseQuery>;
export type GetOpCoStatusQueryResult = Apollo.QueryResult<GraphqlTypes.GetOpCoStatusQuery, GraphqlTypes.GetOpCoStatusQueryVariables>;
export const GetOpCoStatusHistoricalsDocument = gql`
    query GetOpCoStatusHistoricals($entityId: ID!, $entityTimeSeriesTypeNames: [FieldName]!) {
  investmentEntity(id: $entityId) {
    id
    ...EntityTimeSeries
  }
}
    ${EntityTimeSeriesFragmentDoc}`;

/**
 * __useGetOpCoStatusHistoricalsQuery__
 *
 * To run a query within a React component, call `useGetOpCoStatusHistoricalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpCoStatusHistoricalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpCoStatusHistoricalsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetOpCoStatusHistoricalsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOpCoStatusHistoricalsQuery, GraphqlTypes.GetOpCoStatusHistoricalsQueryVariables> & ({ variables: GraphqlTypes.GetOpCoStatusHistoricalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOpCoStatusHistoricalsQuery, GraphqlTypes.GetOpCoStatusHistoricalsQueryVariables>(GetOpCoStatusHistoricalsDocument, options);
      }
export function useGetOpCoStatusHistoricalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOpCoStatusHistoricalsQuery, GraphqlTypes.GetOpCoStatusHistoricalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOpCoStatusHistoricalsQuery, GraphqlTypes.GetOpCoStatusHistoricalsQueryVariables>(GetOpCoStatusHistoricalsDocument, options);
        }
// @ts-ignore
export function useGetOpCoStatusHistoricalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOpCoStatusHistoricalsQuery, GraphqlTypes.GetOpCoStatusHistoricalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOpCoStatusHistoricalsQuery, GraphqlTypes.GetOpCoStatusHistoricalsQueryVariables>;
export function useGetOpCoStatusHistoricalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOpCoStatusHistoricalsQuery, GraphqlTypes.GetOpCoStatusHistoricalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOpCoStatusHistoricalsQuery | undefined, GraphqlTypes.GetOpCoStatusHistoricalsQueryVariables>;
export function useGetOpCoStatusHistoricalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOpCoStatusHistoricalsQuery, GraphqlTypes.GetOpCoStatusHistoricalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOpCoStatusHistoricalsQuery, GraphqlTypes.GetOpCoStatusHistoricalsQueryVariables>(GetOpCoStatusHistoricalsDocument, options);
        }
export type GetOpCoStatusHistoricalsQueryHookResult = ReturnType<typeof useGetOpCoStatusHistoricalsQuery>;
export type GetOpCoStatusHistoricalsLazyQueryHookResult = ReturnType<typeof useGetOpCoStatusHistoricalsLazyQuery>;
export type GetOpCoStatusHistoricalsSuspenseQueryHookResult = ReturnType<typeof useGetOpCoStatusHistoricalsSuspenseQuery>;
export type GetOpCoStatusHistoricalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetOpCoStatusHistoricalsQuery, GraphqlTypes.GetOpCoStatusHistoricalsQueryVariables>;
export const UpdateOperatingMetricsTimeSeriesDocument = gql`
    mutation UpdateOperatingMetricsTimeSeries($entityId: ID!, $objectInput: [UpdateOperatingMetricsTimeSeriesInput!]!, $entityTimeSeriesTypeNames: [FieldName!]!) {
  entityOps {
    updateOperatingMetricsTimeSeries(
      entityId: $entityId
      objectInput: $objectInput
      entityTimeSeriesTypeNames: $entityTimeSeriesTypeNames
    ) {
      entity {
        id
        name
        ...EntityTimeSeries
      }
    }
  }
}
    ${EntityTimeSeriesFragmentDoc}`;
export type UpdateOperatingMetricsTimeSeriesMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateOperatingMetricsTimeSeriesMutation, GraphqlTypes.UpdateOperatingMetricsTimeSeriesMutationVariables>;

/**
 * __useUpdateOperatingMetricsTimeSeriesMutation__
 *
 * To run a mutation, you first call `useUpdateOperatingMetricsTimeSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOperatingMetricsTimeSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOperatingMetricsTimeSeriesMutation, { data, loading, error }] = useUpdateOperatingMetricsTimeSeriesMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      objectInput: // value for 'objectInput'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *   },
 * });
 */
export function useUpdateOperatingMetricsTimeSeriesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateOperatingMetricsTimeSeriesMutation, GraphqlTypes.UpdateOperatingMetricsTimeSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateOperatingMetricsTimeSeriesMutation, GraphqlTypes.UpdateOperatingMetricsTimeSeriesMutationVariables>(UpdateOperatingMetricsTimeSeriesDocument, options);
      }
export type UpdateOperatingMetricsTimeSeriesMutationHookResult = ReturnType<typeof useUpdateOperatingMetricsTimeSeriesMutation>;
export type UpdateOperatingMetricsTimeSeriesMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateOperatingMetricsTimeSeriesMutation>;
export type UpdateOperatingMetricsTimeSeriesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateOperatingMetricsTimeSeriesMutation, GraphqlTypes.UpdateOperatingMetricsTimeSeriesMutationVariables>;
export const DeleteOperatingMetricsTimeSeriesDocument = gql`
    mutation DeleteOperatingMetricsTimeSeries($entityId: ID!, $asOfDate: DateTime!, $entityTimeSeriesTypeNames: [FieldName!]!, $projectionTimeSeriesTypeNames: [FieldName!]!) {
  entityOps {
    deleteTimeSeries(
      entityId: $entityId
      asOfDate: $asOfDate
      entityTimeSeriesTypeNames: $entityTimeSeriesTypeNames
      projectionTimeSeriesTypeNames: $projectionTimeSeriesTypeNames
    ) {
      entity {
        id
        name
        ...EntityLatestTimeSeries
        ...EntityTimeSeries
      }
    }
  }
}
    ${EntityLatestTimeSeriesFragmentDoc}
${EntityTimeSeriesFragmentDoc}`;
export type DeleteOperatingMetricsTimeSeriesMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteOperatingMetricsTimeSeriesMutation, GraphqlTypes.DeleteOperatingMetricsTimeSeriesMutationVariables>;

/**
 * __useDeleteOperatingMetricsTimeSeriesMutation__
 *
 * To run a mutation, you first call `useDeleteOperatingMetricsTimeSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOperatingMetricsTimeSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOperatingMetricsTimeSeriesMutation, { data, loading, error }] = useDeleteOperatingMetricsTimeSeriesMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      asOfDate: // value for 'asOfDate'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *      projectionTimeSeriesTypeNames: // value for 'projectionTimeSeriesTypeNames'
 *   },
 * });
 */
export function useDeleteOperatingMetricsTimeSeriesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteOperatingMetricsTimeSeriesMutation, GraphqlTypes.DeleteOperatingMetricsTimeSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteOperatingMetricsTimeSeriesMutation, GraphqlTypes.DeleteOperatingMetricsTimeSeriesMutationVariables>(DeleteOperatingMetricsTimeSeriesDocument, options);
      }
export type DeleteOperatingMetricsTimeSeriesMutationHookResult = ReturnType<typeof useDeleteOperatingMetricsTimeSeriesMutation>;
export type DeleteOperatingMetricsTimeSeriesMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteOperatingMetricsTimeSeriesMutation>;
export type DeleteOperatingMetricsTimeSeriesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteOperatingMetricsTimeSeriesMutation, GraphqlTypes.DeleteOperatingMetricsTimeSeriesMutationVariables>;
export const GetOperatingMetricsDocument = gql`
    query GetOperatingMetrics($entityId: ID!, $entityTimeSeriesTypeNames: [FieldName!]!) {
  investmentEntity(id: $entityId) {
    id
    name
    canEdit
    canLimitedEdit
    ...EntityTimeSeries
    currency {
      ...CurrencyFields
    }
  }
}
    ${EntityTimeSeriesFragmentDoc}
${CurrencyFieldsFragmentDoc}`;

/**
 * __useGetOperatingMetricsQuery__
 *
 * To run a query within a React component, call `useGetOperatingMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperatingMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperatingMetricsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetOperatingMetricsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOperatingMetricsQuery, GraphqlTypes.GetOperatingMetricsQueryVariables> & ({ variables: GraphqlTypes.GetOperatingMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOperatingMetricsQuery, GraphqlTypes.GetOperatingMetricsQueryVariables>(GetOperatingMetricsDocument, options);
      }
export function useGetOperatingMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOperatingMetricsQuery, GraphqlTypes.GetOperatingMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOperatingMetricsQuery, GraphqlTypes.GetOperatingMetricsQueryVariables>(GetOperatingMetricsDocument, options);
        }
// @ts-ignore
export function useGetOperatingMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOperatingMetricsQuery, GraphqlTypes.GetOperatingMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOperatingMetricsQuery, GraphqlTypes.GetOperatingMetricsQueryVariables>;
export function useGetOperatingMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOperatingMetricsQuery, GraphqlTypes.GetOperatingMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOperatingMetricsQuery | undefined, GraphqlTypes.GetOperatingMetricsQueryVariables>;
export function useGetOperatingMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOperatingMetricsQuery, GraphqlTypes.GetOperatingMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOperatingMetricsQuery, GraphqlTypes.GetOperatingMetricsQueryVariables>(GetOperatingMetricsDocument, options);
        }
export type GetOperatingMetricsQueryHookResult = ReturnType<typeof useGetOperatingMetricsQuery>;
export type GetOperatingMetricsLazyQueryHookResult = ReturnType<typeof useGetOperatingMetricsLazyQuery>;
export type GetOperatingMetricsSuspenseQueryHookResult = ReturnType<typeof useGetOperatingMetricsSuspenseQuery>;
export type GetOperatingMetricsQueryResult = Apollo.QueryResult<GraphqlTypes.GetOperatingMetricsQuery, GraphqlTypes.GetOperatingMetricsQueryVariables>;
export const GetOperatingMetricsHistoricalsDocument = gql`
    query GetOperatingMetricsHistoricals($entityId: ID!, $entityTimeSeriesTypeNames: [FieldName!]!) {
  investmentEntity(id: $entityId) {
    id
    ...EntityTimeSeries
  }
}
    ${EntityTimeSeriesFragmentDoc}`;

/**
 * __useGetOperatingMetricsHistoricalsQuery__
 *
 * To run a query within a React component, call `useGetOperatingMetricsHistoricalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperatingMetricsHistoricalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperatingMetricsHistoricalsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetOperatingMetricsHistoricalsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOperatingMetricsHistoricalsQuery, GraphqlTypes.GetOperatingMetricsHistoricalsQueryVariables> & ({ variables: GraphqlTypes.GetOperatingMetricsHistoricalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOperatingMetricsHistoricalsQuery, GraphqlTypes.GetOperatingMetricsHistoricalsQueryVariables>(GetOperatingMetricsHistoricalsDocument, options);
      }
export function useGetOperatingMetricsHistoricalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOperatingMetricsHistoricalsQuery, GraphqlTypes.GetOperatingMetricsHistoricalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOperatingMetricsHistoricalsQuery, GraphqlTypes.GetOperatingMetricsHistoricalsQueryVariables>(GetOperatingMetricsHistoricalsDocument, options);
        }
// @ts-ignore
export function useGetOperatingMetricsHistoricalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOperatingMetricsHistoricalsQuery, GraphqlTypes.GetOperatingMetricsHistoricalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOperatingMetricsHistoricalsQuery, GraphqlTypes.GetOperatingMetricsHistoricalsQueryVariables>;
export function useGetOperatingMetricsHistoricalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOperatingMetricsHistoricalsQuery, GraphqlTypes.GetOperatingMetricsHistoricalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOperatingMetricsHistoricalsQuery | undefined, GraphqlTypes.GetOperatingMetricsHistoricalsQueryVariables>;
export function useGetOperatingMetricsHistoricalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOperatingMetricsHistoricalsQuery, GraphqlTypes.GetOperatingMetricsHistoricalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOperatingMetricsHistoricalsQuery, GraphqlTypes.GetOperatingMetricsHistoricalsQueryVariables>(GetOperatingMetricsHistoricalsDocument, options);
        }
export type GetOperatingMetricsHistoricalsQueryHookResult = ReturnType<typeof useGetOperatingMetricsHistoricalsQuery>;
export type GetOperatingMetricsHistoricalsLazyQueryHookResult = ReturnType<typeof useGetOperatingMetricsHistoricalsLazyQuery>;
export type GetOperatingMetricsHistoricalsSuspenseQueryHookResult = ReturnType<typeof useGetOperatingMetricsHistoricalsSuspenseQuery>;
export type GetOperatingMetricsHistoricalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetOperatingMetricsHistoricalsQuery, GraphqlTypes.GetOperatingMetricsHistoricalsQueryVariables>;
export const UpdateExtensionFieldValueDocument = gql`
    mutation UpdateExtensionFieldValue($assetId: ID!, $objectInput: [ExtensionFieldValueInput!]!) {
  assetOps {
    updateExtensionFieldValue(assetId: $assetId, objectInput: $objectInput) {
      asset {
        id
        ...ExtensionFields
      }
    }
  }
}
    ${ExtensionFieldsFragmentDoc}`;
export type UpdateExtensionFieldValueMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateExtensionFieldValueMutation, GraphqlTypes.UpdateExtensionFieldValueMutationVariables>;

/**
 * __useUpdateExtensionFieldValueMutation__
 *
 * To run a mutation, you first call `useUpdateExtensionFieldValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExtensionFieldValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExtensionFieldValueMutation, { data, loading, error }] = useUpdateExtensionFieldValueMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateExtensionFieldValueMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateExtensionFieldValueMutation, GraphqlTypes.UpdateExtensionFieldValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateExtensionFieldValueMutation, GraphqlTypes.UpdateExtensionFieldValueMutationVariables>(UpdateExtensionFieldValueDocument, options);
      }
export type UpdateExtensionFieldValueMutationHookResult = ReturnType<typeof useUpdateExtensionFieldValueMutation>;
export type UpdateExtensionFieldValueMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateExtensionFieldValueMutation>;
export type UpdateExtensionFieldValueMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateExtensionFieldValueMutation, GraphqlTypes.UpdateExtensionFieldValueMutationVariables>;
export const GetOtherDetailsDocument = gql`
    query GetOtherDetails($assetId: ID!) {
  asset(id: $assetId) {
    id
    name
    canEdit
    canLimitedEdit
    ...ExtensionFields
  }
}
    ${ExtensionFieldsFragmentDoc}`;

/**
 * __useGetOtherDetailsQuery__
 *
 * To run a query within a React component, call `useGetOtherDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtherDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtherDetailsQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useGetOtherDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOtherDetailsQuery, GraphqlTypes.GetOtherDetailsQueryVariables> & ({ variables: GraphqlTypes.GetOtherDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOtherDetailsQuery, GraphqlTypes.GetOtherDetailsQueryVariables>(GetOtherDetailsDocument, options);
      }
export function useGetOtherDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOtherDetailsQuery, GraphqlTypes.GetOtherDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOtherDetailsQuery, GraphqlTypes.GetOtherDetailsQueryVariables>(GetOtherDetailsDocument, options);
        }
// @ts-ignore
export function useGetOtherDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOtherDetailsQuery, GraphqlTypes.GetOtherDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOtherDetailsQuery, GraphqlTypes.GetOtherDetailsQueryVariables>;
export function useGetOtherDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOtherDetailsQuery, GraphqlTypes.GetOtherDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOtherDetailsQuery | undefined, GraphqlTypes.GetOtherDetailsQueryVariables>;
export function useGetOtherDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOtherDetailsQuery, GraphqlTypes.GetOtherDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOtherDetailsQuery, GraphqlTypes.GetOtherDetailsQueryVariables>(GetOtherDetailsDocument, options);
        }
export type GetOtherDetailsQueryHookResult = ReturnType<typeof useGetOtherDetailsQuery>;
export type GetOtherDetailsLazyQueryHookResult = ReturnType<typeof useGetOtherDetailsLazyQuery>;
export type GetOtherDetailsSuspenseQueryHookResult = ReturnType<typeof useGetOtherDetailsSuspenseQuery>;
export type GetOtherDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetOtherDetailsQuery, GraphqlTypes.GetOtherDetailsQueryVariables>;
export const UpdateAssetOverviewDocument = gql`
    mutation UpdateAssetOverview($assetId: ID!, $objectInput: AssetOverviewInput!) {
  assetOps {
    updateAssetOverview(assetId: $assetId, objectInput: $objectInput) {
      asset {
        id
        ...AssetOverview
        entity {
          id
          currency {
            ...CurrencyFields
          }
        }
      }
    }
  }
}
    ${AssetOverviewFragmentDoc}
${CurrencyFieldsFragmentDoc}`;
export type UpdateAssetOverviewMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateAssetOverviewMutation, GraphqlTypes.UpdateAssetOverviewMutationVariables>;

/**
 * __useUpdateAssetOverviewMutation__
 *
 * To run a mutation, you first call `useUpdateAssetOverviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetOverviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetOverviewMutation, { data, loading, error }] = useUpdateAssetOverviewMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateAssetOverviewMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateAssetOverviewMutation, GraphqlTypes.UpdateAssetOverviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateAssetOverviewMutation, GraphqlTypes.UpdateAssetOverviewMutationVariables>(UpdateAssetOverviewDocument, options);
      }
export type UpdateAssetOverviewMutationHookResult = ReturnType<typeof useUpdateAssetOverviewMutation>;
export type UpdateAssetOverviewMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateAssetOverviewMutation>;
export type UpdateAssetOverviewMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateAssetOverviewMutation, GraphqlTypes.UpdateAssetOverviewMutationVariables>;
export const DeleteAssetDocument = gql`
    mutation DeleteAsset($assetId: ID!) {
  assetOps {
    deleteAsset(assetId: $assetId) {
      result {
        ...DeleteAssetFields
      }
    }
  }
}
    ${DeleteAssetFieldsFragmentDoc}`;
export type DeleteAssetMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteAssetMutation, GraphqlTypes.DeleteAssetMutationVariables>;

/**
 * __useDeleteAssetMutation__
 *
 * To run a mutation, you first call `useDeleteAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetMutation, { data, loading, error }] = useDeleteAssetMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useDeleteAssetMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteAssetMutation, GraphqlTypes.DeleteAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteAssetMutation, GraphqlTypes.DeleteAssetMutationVariables>(DeleteAssetDocument, options);
      }
export type DeleteAssetMutationHookResult = ReturnType<typeof useDeleteAssetMutation>;
export type DeleteAssetMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteAssetMutation>;
export type DeleteAssetMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteAssetMutation, GraphqlTypes.DeleteAssetMutationVariables>;
export const GetAssetOverviewDocument = gql`
    query GetAssetOverview($assetId: ID!) {
  asset(id: $assetId) {
    id
    canEdit
    canLimitedEdit
    totalNetSqft
    ...AssetOverview
  }
}
    ${AssetOverviewFragmentDoc}`;

/**
 * __useGetAssetOverviewQuery__
 *
 * To run a query within a React component, call `useGetAssetOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetOverviewQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useGetAssetOverviewQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAssetOverviewQuery, GraphqlTypes.GetAssetOverviewQueryVariables> & ({ variables: GraphqlTypes.GetAssetOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetOverviewQuery, GraphqlTypes.GetAssetOverviewQueryVariables>(GetAssetOverviewDocument, options);
      }
export function useGetAssetOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetOverviewQuery, GraphqlTypes.GetAssetOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetOverviewQuery, GraphqlTypes.GetAssetOverviewQueryVariables>(GetAssetOverviewDocument, options);
        }
// @ts-ignore
export function useGetAssetOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetOverviewQuery, GraphqlTypes.GetAssetOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetOverviewQuery, GraphqlTypes.GetAssetOverviewQueryVariables>;
export function useGetAssetOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetOverviewQuery, GraphqlTypes.GetAssetOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetOverviewQuery | undefined, GraphqlTypes.GetAssetOverviewQueryVariables>;
export function useGetAssetOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetOverviewQuery, GraphqlTypes.GetAssetOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetOverviewQuery, GraphqlTypes.GetAssetOverviewQueryVariables>(GetAssetOverviewDocument, options);
        }
export type GetAssetOverviewQueryHookResult = ReturnType<typeof useGetAssetOverviewQuery>;
export type GetAssetOverviewLazyQueryHookResult = ReturnType<typeof useGetAssetOverviewLazyQuery>;
export type GetAssetOverviewSuspenseQueryHookResult = ReturnType<typeof useGetAssetOverviewSuspenseQuery>;
export type GetAssetOverviewQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetOverviewQuery, GraphqlTypes.GetAssetOverviewQueryVariables>;
export const UpdatePerformanceMetricsDocument = gql`
    mutation UpdatePerformanceMetrics($entityId: ID!, $objectInput: UpdatePerformanceMetricsInput!, $entityTimeSeriesTypeNames: [FieldName!]!) {
  entityOps {
    updatePerformanceMetrics(
      entityId: $entityId
      objectInput: $objectInput
      entityTimeSeriesTypeNames: $entityTimeSeriesTypeNames
    ) {
      entity {
        id
        perfMetricsPublished
        showPerfMetricsOnAsset
        ...EntityPerformanceMetrics
        ...EntityLatestTimeSeries
        ...EntityLatestTimeSeriesProjections
        ...EntityTimeSeries
        ...EntityTimeSeriesProjections
      }
    }
  }
}
    ${EntityPerformanceMetricsFragmentDoc}
${EntityLatestTimeSeriesFragmentDoc}
${EntityLatestTimeSeriesProjectionsFragmentDoc}
${EntityTimeSeriesFragmentDoc}
${EntityTimeSeriesProjectionsFragmentDoc}`;
export type UpdatePerformanceMetricsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePerformanceMetricsMutation, GraphqlTypes.UpdatePerformanceMetricsMutationVariables>;

/**
 * __useUpdatePerformanceMetricsMutation__
 *
 * To run a mutation, you first call `useUpdatePerformanceMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePerformanceMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePerformanceMetricsMutation, { data, loading, error }] = useUpdatePerformanceMetricsMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      objectInput: // value for 'objectInput'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *   },
 * });
 */
export function useUpdatePerformanceMetricsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePerformanceMetricsMutation, GraphqlTypes.UpdatePerformanceMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePerformanceMetricsMutation, GraphqlTypes.UpdatePerformanceMetricsMutationVariables>(UpdatePerformanceMetricsDocument, options);
      }
export type UpdatePerformanceMetricsMutationHookResult = ReturnType<typeof useUpdatePerformanceMetricsMutation>;
export type UpdatePerformanceMetricsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePerformanceMetricsMutation>;
export type UpdatePerformanceMetricsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePerformanceMetricsMutation, GraphqlTypes.UpdatePerformanceMetricsMutationVariables>;
export const DeletePerformanceMetricsDocument = gql`
    mutation DeletePerformanceMetrics($entityId: ID!, $asOfDate: DateTime!, $entityTimeSeriesTypeNames: [FieldName!]!, $projectionTimeSeriesTypeNames: [FieldName!]!) {
  entityOps {
    deleteTimeSeries(
      entityId: $entityId
      asOfDate: $asOfDate
      entityTimeSeriesTypeNames: $entityTimeSeriesTypeNames
      projectionTimeSeriesTypeNames: $projectionTimeSeriesTypeNames
    ) {
      entity {
        id
        ...EntityPerformanceMetrics
        ...EntityLatestTimeSeries
        ...EntityLatestTimeSeriesProjections
        ...EntityTimeSeries
        ...EntityTimeSeriesProjections
      }
    }
  }
}
    ${EntityPerformanceMetricsFragmentDoc}
${EntityLatestTimeSeriesFragmentDoc}
${EntityLatestTimeSeriesProjectionsFragmentDoc}
${EntityTimeSeriesFragmentDoc}
${EntityTimeSeriesProjectionsFragmentDoc}`;
export type DeletePerformanceMetricsMutationFn = Apollo.MutationFunction<GraphqlTypes.DeletePerformanceMetricsMutation, GraphqlTypes.DeletePerformanceMetricsMutationVariables>;

/**
 * __useDeletePerformanceMetricsMutation__
 *
 * To run a mutation, you first call `useDeletePerformanceMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePerformanceMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePerformanceMetricsMutation, { data, loading, error }] = useDeletePerformanceMetricsMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      asOfDate: // value for 'asOfDate'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *      projectionTimeSeriesTypeNames: // value for 'projectionTimeSeriesTypeNames'
 *   },
 * });
 */
export function useDeletePerformanceMetricsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeletePerformanceMetricsMutation, GraphqlTypes.DeletePerformanceMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeletePerformanceMetricsMutation, GraphqlTypes.DeletePerformanceMetricsMutationVariables>(DeletePerformanceMetricsDocument, options);
      }
export type DeletePerformanceMetricsMutationHookResult = ReturnType<typeof useDeletePerformanceMetricsMutation>;
export type DeletePerformanceMetricsMutationResult = Apollo.MutationResult<GraphqlTypes.DeletePerformanceMetricsMutation>;
export type DeletePerformanceMetricsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeletePerformanceMetricsMutation, GraphqlTypes.DeletePerformanceMetricsMutationVariables>;
export const GetEntityPerformanceMetricsDocument = gql`
    query GetEntityPerformanceMetrics($objectId: ID!, $entityTimeSeriesTypeNames: [FieldName]!) {
  investmentEntity(id: $objectId) {
    id
    name
    canEdit
    canLimitedEdit
    perfMetricsPublished
    showPerfMetricsOnAsset
    ...EntityPerformanceMetrics
    ...EntityLatestTimeSeries
    ...EntityLatestTimeSeriesProjections
    ...EntityTimeSeries
    ...EntityTimeSeriesProjections
  }
}
    ${EntityPerformanceMetricsFragmentDoc}
${EntityLatestTimeSeriesFragmentDoc}
${EntityLatestTimeSeriesProjectionsFragmentDoc}
${EntityTimeSeriesFragmentDoc}
${EntityTimeSeriesProjectionsFragmentDoc}`;

/**
 * __useGetEntityPerformanceMetricsQuery__
 *
 * To run a query within a React component, call `useGetEntityPerformanceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityPerformanceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityPerformanceMetricsQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetEntityPerformanceMetricsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityPerformanceMetricsQuery, GraphqlTypes.GetEntityPerformanceMetricsQueryVariables> & ({ variables: GraphqlTypes.GetEntityPerformanceMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityPerformanceMetricsQuery, GraphqlTypes.GetEntityPerformanceMetricsQueryVariables>(GetEntityPerformanceMetricsDocument, options);
      }
export function useGetEntityPerformanceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityPerformanceMetricsQuery, GraphqlTypes.GetEntityPerformanceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityPerformanceMetricsQuery, GraphqlTypes.GetEntityPerformanceMetricsQueryVariables>(GetEntityPerformanceMetricsDocument, options);
        }
// @ts-ignore
export function useGetEntityPerformanceMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPerformanceMetricsQuery, GraphqlTypes.GetEntityPerformanceMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityPerformanceMetricsQuery, GraphqlTypes.GetEntityPerformanceMetricsQueryVariables>;
export function useGetEntityPerformanceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPerformanceMetricsQuery, GraphqlTypes.GetEntityPerformanceMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityPerformanceMetricsQuery | undefined, GraphqlTypes.GetEntityPerformanceMetricsQueryVariables>;
export function useGetEntityPerformanceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPerformanceMetricsQuery, GraphqlTypes.GetEntityPerformanceMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityPerformanceMetricsQuery, GraphqlTypes.GetEntityPerformanceMetricsQueryVariables>(GetEntityPerformanceMetricsDocument, options);
        }
export type GetEntityPerformanceMetricsQueryHookResult = ReturnType<typeof useGetEntityPerformanceMetricsQuery>;
export type GetEntityPerformanceMetricsLazyQueryHookResult = ReturnType<typeof useGetEntityPerformanceMetricsLazyQuery>;
export type GetEntityPerformanceMetricsSuspenseQueryHookResult = ReturnType<typeof useGetEntityPerformanceMetricsSuspenseQuery>;
export type GetEntityPerformanceMetricsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityPerformanceMetricsQuery, GraphqlTypes.GetEntityPerformanceMetricsQueryVariables>;
export const GetHistoricalEntityPerformanceMetricsDocument = gql`
    query GetHistoricalEntityPerformanceMetrics($objectId: ID!, $entityTimeSeriesTypeNames: [FieldName]!) {
  investmentEntity(id: $objectId) {
    id
    name
    ...EntityTimeSeries
    ...EntityTimeSeriesProjections
  }
}
    ${EntityTimeSeriesFragmentDoc}
${EntityTimeSeriesProjectionsFragmentDoc}`;

/**
 * __useGetHistoricalEntityPerformanceMetricsQuery__
 *
 * To run a query within a React component, call `useGetHistoricalEntityPerformanceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricalEntityPerformanceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricalEntityPerformanceMetricsQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      entityTimeSeriesTypeNames: // value for 'entityTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetHistoricalEntityPerformanceMetricsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetHistoricalEntityPerformanceMetricsQuery, GraphqlTypes.GetHistoricalEntityPerformanceMetricsQueryVariables> & ({ variables: GraphqlTypes.GetHistoricalEntityPerformanceMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetHistoricalEntityPerformanceMetricsQuery, GraphqlTypes.GetHistoricalEntityPerformanceMetricsQueryVariables>(GetHistoricalEntityPerformanceMetricsDocument, options);
      }
export function useGetHistoricalEntityPerformanceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetHistoricalEntityPerformanceMetricsQuery, GraphqlTypes.GetHistoricalEntityPerformanceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetHistoricalEntityPerformanceMetricsQuery, GraphqlTypes.GetHistoricalEntityPerformanceMetricsQueryVariables>(GetHistoricalEntityPerformanceMetricsDocument, options);
        }
// @ts-ignore
export function useGetHistoricalEntityPerformanceMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHistoricalEntityPerformanceMetricsQuery, GraphqlTypes.GetHistoricalEntityPerformanceMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetHistoricalEntityPerformanceMetricsQuery, GraphqlTypes.GetHistoricalEntityPerformanceMetricsQueryVariables>;
export function useGetHistoricalEntityPerformanceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHistoricalEntityPerformanceMetricsQuery, GraphqlTypes.GetHistoricalEntityPerformanceMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetHistoricalEntityPerformanceMetricsQuery | undefined, GraphqlTypes.GetHistoricalEntityPerformanceMetricsQueryVariables>;
export function useGetHistoricalEntityPerformanceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHistoricalEntityPerformanceMetricsQuery, GraphqlTypes.GetHistoricalEntityPerformanceMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetHistoricalEntityPerformanceMetricsQuery, GraphqlTypes.GetHistoricalEntityPerformanceMetricsQueryVariables>(GetHistoricalEntityPerformanceMetricsDocument, options);
        }
export type GetHistoricalEntityPerformanceMetricsQueryHookResult = ReturnType<typeof useGetHistoricalEntityPerformanceMetricsQuery>;
export type GetHistoricalEntityPerformanceMetricsLazyQueryHookResult = ReturnType<typeof useGetHistoricalEntityPerformanceMetricsLazyQuery>;
export type GetHistoricalEntityPerformanceMetricsSuspenseQueryHookResult = ReturnType<typeof useGetHistoricalEntityPerformanceMetricsSuspenseQuery>;
export type GetHistoricalEntityPerformanceMetricsQueryResult = Apollo.QueryResult<GraphqlTypes.GetHistoricalEntityPerformanceMetricsQuery, GraphqlTypes.GetHistoricalEntityPerformanceMetricsQueryVariables>;
export const UploadAssetPhotosDocument = gql`
    mutation UploadAssetPhotos($input: UploadPhotoInput!) {
  assetOps {
    uploadAssetPhotos(uploadPhotoInput: $input) {
      photos {
        ...PhotoFields
      }
    }
  }
}
    ${PhotoFieldsFragmentDoc}`;
export type UploadAssetPhotosMutationFn = Apollo.MutationFunction<GraphqlTypes.UploadAssetPhotosMutation, GraphqlTypes.UploadAssetPhotosMutationVariables>;

/**
 * __useUploadAssetPhotosMutation__
 *
 * To run a mutation, you first call `useUploadAssetPhotosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAssetPhotosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAssetPhotosMutation, { data, loading, error }] = useUploadAssetPhotosMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadAssetPhotosMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UploadAssetPhotosMutation, GraphqlTypes.UploadAssetPhotosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UploadAssetPhotosMutation, GraphqlTypes.UploadAssetPhotosMutationVariables>(UploadAssetPhotosDocument, options);
      }
export type UploadAssetPhotosMutationHookResult = ReturnType<typeof useUploadAssetPhotosMutation>;
export type UploadAssetPhotosMutationResult = Apollo.MutationResult<GraphqlTypes.UploadAssetPhotosMutation>;
export type UploadAssetPhotosMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UploadAssetPhotosMutation, GraphqlTypes.UploadAssetPhotosMutationVariables>;
export const GetPhotosDocument = gql`
    query GetPhotos($assetId: ID!) {
  asset(id: $assetId) {
    id
    canEdit
    canLimitedEdit
    name
    primaryPhotoId
    ...AssetPhotos
  }
}
    ${AssetPhotosFragmentDoc}`;

/**
 * __useGetPhotosQuery__
 *
 * To run a query within a React component, call `useGetPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhotosQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useGetPhotosQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPhotosQuery, GraphqlTypes.GetPhotosQueryVariables> & ({ variables: GraphqlTypes.GetPhotosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPhotosQuery, GraphqlTypes.GetPhotosQueryVariables>(GetPhotosDocument, options);
      }
export function useGetPhotosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPhotosQuery, GraphqlTypes.GetPhotosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPhotosQuery, GraphqlTypes.GetPhotosQueryVariables>(GetPhotosDocument, options);
        }
// @ts-ignore
export function useGetPhotosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPhotosQuery, GraphqlTypes.GetPhotosQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPhotosQuery, GraphqlTypes.GetPhotosQueryVariables>;
export function useGetPhotosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPhotosQuery, GraphqlTypes.GetPhotosQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPhotosQuery | undefined, GraphqlTypes.GetPhotosQueryVariables>;
export function useGetPhotosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPhotosQuery, GraphqlTypes.GetPhotosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPhotosQuery, GraphqlTypes.GetPhotosQueryVariables>(GetPhotosDocument, options);
        }
export type GetPhotosQueryHookResult = ReturnType<typeof useGetPhotosQuery>;
export type GetPhotosLazyQueryHookResult = ReturnType<typeof useGetPhotosLazyQuery>;
export type GetPhotosSuspenseQueryHookResult = ReturnType<typeof useGetPhotosSuspenseQuery>;
export type GetPhotosQueryResult = Apollo.QueryResult<GraphqlTypes.GetPhotosQuery, GraphqlTypes.GetPhotosQueryVariables>;
export const UpsertProductTypeAndSizeDocument = gql`
    mutation UpsertProductTypeAndSize($assetId: ID!, $objectInput: ProductTypeAndSizeInput!, $objectId: ID) {
  assetOps {
    upsertProductTypeAndSize(
      assetId: $assetId
      objectInput: $objectInput
      objectId: $objectId
    ) {
      productTypeAndSize {
        ...ProductTypeAndSizeFields
        asset {
          id
        }
      }
    }
  }
}
    ${ProductTypeAndSizeFieldsFragmentDoc}`;
export type UpsertProductTypeAndSizeMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertProductTypeAndSizeMutation, GraphqlTypes.UpsertProductTypeAndSizeMutationVariables>;

/**
 * __useUpsertProductTypeAndSizeMutation__
 *
 * To run a mutation, you first call `useUpsertProductTypeAndSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProductTypeAndSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProductTypeAndSizeMutation, { data, loading, error }] = useUpsertProductTypeAndSizeMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      objectInput: // value for 'objectInput'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useUpsertProductTypeAndSizeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertProductTypeAndSizeMutation, GraphqlTypes.UpsertProductTypeAndSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertProductTypeAndSizeMutation, GraphqlTypes.UpsertProductTypeAndSizeMutationVariables>(UpsertProductTypeAndSizeDocument, options);
      }
export type UpsertProductTypeAndSizeMutationHookResult = ReturnType<typeof useUpsertProductTypeAndSizeMutation>;
export type UpsertProductTypeAndSizeMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertProductTypeAndSizeMutation>;
export type UpsertProductTypeAndSizeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertProductTypeAndSizeMutation, GraphqlTypes.UpsertProductTypeAndSizeMutationVariables>;
export const DeleteProductTypeAndSizeDocument = gql`
    mutation DeleteProductTypeAndSize($assetId: ID!, $objectId: ID!) {
  assetOps {
    deleteProductTypeAndSize(assetId: $assetId, objectId: $objectId) {
      productTypeAndSize {
        id
        asset {
          id
        }
      }
    }
  }
}
    `;
export type DeleteProductTypeAndSizeMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteProductTypeAndSizeMutation, GraphqlTypes.DeleteProductTypeAndSizeMutationVariables>;

/**
 * __useDeleteProductTypeAndSizeMutation__
 *
 * To run a mutation, you first call `useDeleteProductTypeAndSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductTypeAndSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductTypeAndSizeMutation, { data, loading, error }] = useDeleteProductTypeAndSizeMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useDeleteProductTypeAndSizeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteProductTypeAndSizeMutation, GraphqlTypes.DeleteProductTypeAndSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteProductTypeAndSizeMutation, GraphqlTypes.DeleteProductTypeAndSizeMutationVariables>(DeleteProductTypeAndSizeDocument, options);
      }
export type DeleteProductTypeAndSizeMutationHookResult = ReturnType<typeof useDeleteProductTypeAndSizeMutation>;
export type DeleteProductTypeAndSizeMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteProductTypeAndSizeMutation>;
export type DeleteProductTypeAndSizeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteProductTypeAndSizeMutation, GraphqlTypes.DeleteProductTypeAndSizeMutationVariables>;
export const GetProductTypesDocument = gql`
    query GetProductTypes($assetId: ID!) {
  asset(id: $assetId) {
    id
    name
    canEdit
    canLimitedEdit
    totalNetSqft
    totalGrossSqft
    ...AssetProductTypes
  }
}
    ${AssetProductTypesFragmentDoc}`;

/**
 * __useGetProductTypesQuery__
 *
 * To run a query within a React component, call `useGetProductTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductTypesQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useGetProductTypesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProductTypesQuery, GraphqlTypes.GetProductTypesQueryVariables> & ({ variables: GraphqlTypes.GetProductTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProductTypesQuery, GraphqlTypes.GetProductTypesQueryVariables>(GetProductTypesDocument, options);
      }
export function useGetProductTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProductTypesQuery, GraphqlTypes.GetProductTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProductTypesQuery, GraphqlTypes.GetProductTypesQueryVariables>(GetProductTypesDocument, options);
        }
// @ts-ignore
export function useGetProductTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProductTypesQuery, GraphqlTypes.GetProductTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProductTypesQuery, GraphqlTypes.GetProductTypesQueryVariables>;
export function useGetProductTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProductTypesQuery, GraphqlTypes.GetProductTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProductTypesQuery | undefined, GraphqlTypes.GetProductTypesQueryVariables>;
export function useGetProductTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProductTypesQuery, GraphqlTypes.GetProductTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProductTypesQuery, GraphqlTypes.GetProductTypesQueryVariables>(GetProductTypesDocument, options);
        }
export type GetProductTypesQueryHookResult = ReturnType<typeof useGetProductTypesQuery>;
export type GetProductTypesLazyQueryHookResult = ReturnType<typeof useGetProductTypesLazyQuery>;
export type GetProductTypesSuspenseQueryHookResult = ReturnType<typeof useGetProductTypesSuspenseQuery>;
export type GetProductTypesQueryResult = Apollo.QueryResult<GraphqlTypes.GetProductTypesQuery, GraphqlTypes.GetProductTypesQueryVariables>;
export const UpdateProjectStatsTimeSeriesDocument = gql`
    mutation UpdateProjectStatsTimeSeries($assetId: ID!, $objectInput: [UpdateProjectStatsTimeSeriesInput!]!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    updateProjectStatsTimeSeries(
      assetId: $assetId
      objectInput: $objectInput
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        name
        ...AssetTimeSeries
      }
    }
  }
}
    ${AssetTimeSeriesFragmentDoc}`;
export type UpdateProjectStatsTimeSeriesMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateProjectStatsTimeSeriesMutation, GraphqlTypes.UpdateProjectStatsTimeSeriesMutationVariables>;

/**
 * __useUpdateProjectStatsTimeSeriesMutation__
 *
 * To run a mutation, you first call `useUpdateProjectStatsTimeSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectStatsTimeSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectStatsTimeSeriesMutation, { data, loading, error }] = useUpdateProjectStatsTimeSeriesMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      objectInput: // value for 'objectInput'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useUpdateProjectStatsTimeSeriesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateProjectStatsTimeSeriesMutation, GraphqlTypes.UpdateProjectStatsTimeSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateProjectStatsTimeSeriesMutation, GraphqlTypes.UpdateProjectStatsTimeSeriesMutationVariables>(UpdateProjectStatsTimeSeriesDocument, options);
      }
export type UpdateProjectStatsTimeSeriesMutationHookResult = ReturnType<typeof useUpdateProjectStatsTimeSeriesMutation>;
export type UpdateProjectStatsTimeSeriesMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateProjectStatsTimeSeriesMutation>;
export type UpdateProjectStatsTimeSeriesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateProjectStatsTimeSeriesMutation, GraphqlTypes.UpdateProjectStatsTimeSeriesMutationVariables>;
export const GetProjectStatsDocument = gql`
    query GetProjectStats($assetId: ID!, $assetTimeSeriesTypeNames: [FieldName]!) {
  asset(id: $assetId) {
    id
    name
    canEdit
    canLimitedEdit
    currency {
      ...CurrencyFields
    }
    entity {
      id
      currency {
        ...CurrencyFields
      }
    }
    ...AssetTimeSeries
    acquisitions {
      edges {
        node {
          id
          price {
            monies
          }
        }
      }
    }
  }
}
    ${CurrencyFieldsFragmentDoc}
${AssetTimeSeriesFragmentDoc}`;

/**
 * __useGetProjectStatsQuery__
 *
 * To run a query within a React component, call `useGetProjectStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectStatsQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetProjectStatsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProjectStatsQuery, GraphqlTypes.GetProjectStatsQueryVariables> & ({ variables: GraphqlTypes.GetProjectStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProjectStatsQuery, GraphqlTypes.GetProjectStatsQueryVariables>(GetProjectStatsDocument, options);
      }
export function useGetProjectStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProjectStatsQuery, GraphqlTypes.GetProjectStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProjectStatsQuery, GraphqlTypes.GetProjectStatsQueryVariables>(GetProjectStatsDocument, options);
        }
// @ts-ignore
export function useGetProjectStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProjectStatsQuery, GraphqlTypes.GetProjectStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProjectStatsQuery, GraphqlTypes.GetProjectStatsQueryVariables>;
export function useGetProjectStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProjectStatsQuery, GraphqlTypes.GetProjectStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProjectStatsQuery | undefined, GraphqlTypes.GetProjectStatsQueryVariables>;
export function useGetProjectStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProjectStatsQuery, GraphqlTypes.GetProjectStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProjectStatsQuery, GraphqlTypes.GetProjectStatsQueryVariables>(GetProjectStatsDocument, options);
        }
export type GetProjectStatsQueryHookResult = ReturnType<typeof useGetProjectStatsQuery>;
export type GetProjectStatsLazyQueryHookResult = ReturnType<typeof useGetProjectStatsLazyQuery>;
export type GetProjectStatsSuspenseQueryHookResult = ReturnType<typeof useGetProjectStatsSuspenseQuery>;
export type GetProjectStatsQueryResult = Apollo.QueryResult<GraphqlTypes.GetProjectStatsQuery, GraphqlTypes.GetProjectStatsQueryVariables>;
export const GetProjectStatsHistoricalsDocument = gql`
    query GetProjectStatsHistoricals($assetId: ID!, $assetTimeSeriesTypeNames: [FieldName]!) {
  asset(id: $assetId) {
    id
    ...AssetTimeSeries
  }
}
    ${AssetTimeSeriesFragmentDoc}`;

/**
 * __useGetProjectStatsHistoricalsQuery__
 *
 * To run a query within a React component, call `useGetProjectStatsHistoricalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectStatsHistoricalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectStatsHistoricalsQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetProjectStatsHistoricalsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProjectStatsHistoricalsQuery, GraphqlTypes.GetProjectStatsHistoricalsQueryVariables> & ({ variables: GraphqlTypes.GetProjectStatsHistoricalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProjectStatsHistoricalsQuery, GraphqlTypes.GetProjectStatsHistoricalsQueryVariables>(GetProjectStatsHistoricalsDocument, options);
      }
export function useGetProjectStatsHistoricalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProjectStatsHistoricalsQuery, GraphqlTypes.GetProjectStatsHistoricalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProjectStatsHistoricalsQuery, GraphqlTypes.GetProjectStatsHistoricalsQueryVariables>(GetProjectStatsHistoricalsDocument, options);
        }
// @ts-ignore
export function useGetProjectStatsHistoricalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProjectStatsHistoricalsQuery, GraphqlTypes.GetProjectStatsHistoricalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProjectStatsHistoricalsQuery, GraphqlTypes.GetProjectStatsHistoricalsQueryVariables>;
export function useGetProjectStatsHistoricalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProjectStatsHistoricalsQuery, GraphqlTypes.GetProjectStatsHistoricalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProjectStatsHistoricalsQuery | undefined, GraphqlTypes.GetProjectStatsHistoricalsQueryVariables>;
export function useGetProjectStatsHistoricalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProjectStatsHistoricalsQuery, GraphqlTypes.GetProjectStatsHistoricalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProjectStatsHistoricalsQuery, GraphqlTypes.GetProjectStatsHistoricalsQueryVariables>(GetProjectStatsHistoricalsDocument, options);
        }
export type GetProjectStatsHistoricalsQueryHookResult = ReturnType<typeof useGetProjectStatsHistoricalsQuery>;
export type GetProjectStatsHistoricalsLazyQueryHookResult = ReturnType<typeof useGetProjectStatsHistoricalsLazyQuery>;
export type GetProjectStatsHistoricalsSuspenseQueryHookResult = ReturnType<typeof useGetProjectStatsHistoricalsSuspenseQuery>;
export type GetProjectStatsHistoricalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetProjectStatsHistoricalsQuery, GraphqlTypes.GetProjectStatsHistoricalsQueryVariables>;
export const GetAssetUpdatesDocument = gql`
    query GetAssetUpdates($assetId: ID!, $assetTimeSeriesTypeNames: [FieldName]!) {
  asset(id: $assetId) {
    id
    name
    canEdit
    canLimitedEdit
    ...AssetTimeSeries
  }
}
    ${AssetTimeSeriesFragmentDoc}`;

/**
 * __useGetAssetUpdatesQuery__
 *
 * To run a query within a React component, call `useGetAssetUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetUpdatesQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetAssetUpdatesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAssetUpdatesQuery, GraphqlTypes.GetAssetUpdatesQueryVariables> & ({ variables: GraphqlTypes.GetAssetUpdatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetUpdatesQuery, GraphqlTypes.GetAssetUpdatesQueryVariables>(GetAssetUpdatesDocument, options);
      }
export function useGetAssetUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetUpdatesQuery, GraphqlTypes.GetAssetUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetUpdatesQuery, GraphqlTypes.GetAssetUpdatesQueryVariables>(GetAssetUpdatesDocument, options);
        }
// @ts-ignore
export function useGetAssetUpdatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetUpdatesQuery, GraphqlTypes.GetAssetUpdatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetUpdatesQuery, GraphqlTypes.GetAssetUpdatesQueryVariables>;
export function useGetAssetUpdatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetUpdatesQuery, GraphqlTypes.GetAssetUpdatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetUpdatesQuery | undefined, GraphqlTypes.GetAssetUpdatesQueryVariables>;
export function useGetAssetUpdatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetUpdatesQuery, GraphqlTypes.GetAssetUpdatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetUpdatesQuery, GraphqlTypes.GetAssetUpdatesQueryVariables>(GetAssetUpdatesDocument, options);
        }
export type GetAssetUpdatesQueryHookResult = ReturnType<typeof useGetAssetUpdatesQuery>;
export type GetAssetUpdatesLazyQueryHookResult = ReturnType<typeof useGetAssetUpdatesLazyQuery>;
export type GetAssetUpdatesSuspenseQueryHookResult = ReturnType<typeof useGetAssetUpdatesSuspenseQuery>;
export type GetAssetUpdatesQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetUpdatesQuery, GraphqlTypes.GetAssetUpdatesQueryVariables>;
export const UpsertValuationTimeSeriesDocument = gql`
    mutation UpsertValuationTimeSeries($assetId: ID!, $oldAsOfDate: DateTime, $objectInput: ValuationTimeSeriesInput!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    upsertValuationTimeSeries(
      assetId: $assetId
      oldAsOfDate: $oldAsOfDate
      objectInput: $objectInput
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        name
        ...AssetLatestTimeSeries
        ...AssetTimeSeries
      }
    }
  }
}
    ${AssetLatestTimeSeriesFragmentDoc}
${AssetTimeSeriesFragmentDoc}`;
export type UpsertValuationTimeSeriesMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertValuationTimeSeriesMutation, GraphqlTypes.UpsertValuationTimeSeriesMutationVariables>;

/**
 * __useUpsertValuationTimeSeriesMutation__
 *
 * To run a mutation, you first call `useUpsertValuationTimeSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertValuationTimeSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertValuationTimeSeriesMutation, { data, loading, error }] = useUpsertValuationTimeSeriesMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      oldAsOfDate: // value for 'oldAsOfDate'
 *      objectInput: // value for 'objectInput'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useUpsertValuationTimeSeriesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertValuationTimeSeriesMutation, GraphqlTypes.UpsertValuationTimeSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertValuationTimeSeriesMutation, GraphqlTypes.UpsertValuationTimeSeriesMutationVariables>(UpsertValuationTimeSeriesDocument, options);
      }
export type UpsertValuationTimeSeriesMutationHookResult = ReturnType<typeof useUpsertValuationTimeSeriesMutation>;
export type UpsertValuationTimeSeriesMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertValuationTimeSeriesMutation>;
export type UpsertValuationTimeSeriesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertValuationTimeSeriesMutation, GraphqlTypes.UpsertValuationTimeSeriesMutationVariables>;
export const GetValuationDocument = gql`
    query GetValuation($assetId: ID!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  asset(id: $assetId) {
    id
    name
    canEdit
    canLimitedEdit
    percentOwned
    totalNetSqft
    totalGrossSqft
    currency {
      ...CurrencyFields
    }
    entity {
      id
      currency {
        ...CurrencyFields
      }
    }
    ...AssetLatestTimeSeries
    ...AssetTimeSeries
  }
}
    ${CurrencyFieldsFragmentDoc}
${AssetLatestTimeSeriesFragmentDoc}
${AssetTimeSeriesFragmentDoc}`;

/**
 * __useGetValuationQuery__
 *
 * To run a query within a React component, call `useGetValuationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuationQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetValuationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetValuationQuery, GraphqlTypes.GetValuationQueryVariables> & ({ variables: GraphqlTypes.GetValuationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetValuationQuery, GraphqlTypes.GetValuationQueryVariables>(GetValuationDocument, options);
      }
export function useGetValuationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetValuationQuery, GraphqlTypes.GetValuationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetValuationQuery, GraphqlTypes.GetValuationQueryVariables>(GetValuationDocument, options);
        }
// @ts-ignore
export function useGetValuationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetValuationQuery, GraphqlTypes.GetValuationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetValuationQuery, GraphqlTypes.GetValuationQueryVariables>;
export function useGetValuationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetValuationQuery, GraphqlTypes.GetValuationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetValuationQuery | undefined, GraphqlTypes.GetValuationQueryVariables>;
export function useGetValuationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetValuationQuery, GraphqlTypes.GetValuationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetValuationQuery, GraphqlTypes.GetValuationQueryVariables>(GetValuationDocument, options);
        }
export type GetValuationQueryHookResult = ReturnType<typeof useGetValuationQuery>;
export type GetValuationLazyQueryHookResult = ReturnType<typeof useGetValuationLazyQuery>;
export type GetValuationSuspenseQueryHookResult = ReturnType<typeof useGetValuationSuspenseQuery>;
export type GetValuationQueryResult = Apollo.QueryResult<GraphqlTypes.GetValuationQuery, GraphqlTypes.GetValuationQueryVariables>;
export const GetValuationHistoryDocument = gql`
    query GetValuationHistory($assetId: ID!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  asset(id: $assetId) {
    id
    name
    ...AssetTimeSeries
  }
}
    ${AssetTimeSeriesFragmentDoc}`;

/**
 * __useGetValuationHistoryQuery__
 *
 * To run a query within a React component, call `useGetValuationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuationHistoryQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetValuationHistoryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetValuationHistoryQuery, GraphqlTypes.GetValuationHistoryQueryVariables> & ({ variables: GraphqlTypes.GetValuationHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetValuationHistoryQuery, GraphqlTypes.GetValuationHistoryQueryVariables>(GetValuationHistoryDocument, options);
      }
export function useGetValuationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetValuationHistoryQuery, GraphqlTypes.GetValuationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetValuationHistoryQuery, GraphqlTypes.GetValuationHistoryQueryVariables>(GetValuationHistoryDocument, options);
        }
// @ts-ignore
export function useGetValuationHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetValuationHistoryQuery, GraphqlTypes.GetValuationHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetValuationHistoryQuery, GraphqlTypes.GetValuationHistoryQueryVariables>;
export function useGetValuationHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetValuationHistoryQuery, GraphqlTypes.GetValuationHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetValuationHistoryQuery | undefined, GraphqlTypes.GetValuationHistoryQueryVariables>;
export function useGetValuationHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetValuationHistoryQuery, GraphqlTypes.GetValuationHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetValuationHistoryQuery, GraphqlTypes.GetValuationHistoryQueryVariables>(GetValuationHistoryDocument, options);
        }
export type GetValuationHistoryQueryHookResult = ReturnType<typeof useGetValuationHistoryQuery>;
export type GetValuationHistoryLazyQueryHookResult = ReturnType<typeof useGetValuationHistoryLazyQuery>;
export type GetValuationHistorySuspenseQueryHookResult = ReturnType<typeof useGetValuationHistorySuspenseQuery>;
export type GetValuationHistoryQueryResult = Apollo.QueryResult<GraphqlTypes.GetValuationHistoryQuery, GraphqlTypes.GetValuationHistoryQueryVariables>;
export const UpdateTimeSeriesDocument = gql`
    mutation UpdateTimeSeries($assetId: ID!, $objectInput: [UpdateTimeSeriesInput!]!) {
  assetOps {
    updateTimeSeries(objectId: $assetId, objectInput: $objectInput) {
      objectId
      timeSeriesData {
        asOfDate
        values {
          typeName
          label
          dataType
          ...TimeSeriesString
          ...TimeSeriesFloat
          ...TimeSeriesDate
          ...TimeSeriesInt
          ...TimeSeriesWallet
        }
      }
      asset {
        id
      }
    }
  }
}
    ${TimeSeriesStringFragmentDoc}
${TimeSeriesFloatFragmentDoc}
${TimeSeriesDateFragmentDoc}
${TimeSeriesIntFragmentDoc}
${TimeSeriesWalletFragmentDoc}`;
export type UpdateTimeSeriesMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateTimeSeriesMutation, GraphqlTypes.UpdateTimeSeriesMutationVariables>;

/**
 * __useUpdateTimeSeriesMutation__
 *
 * To run a mutation, you first call `useUpdateTimeSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeSeriesMutation, { data, loading, error }] = useUpdateTimeSeriesMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateTimeSeriesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateTimeSeriesMutation, GraphqlTypes.UpdateTimeSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateTimeSeriesMutation, GraphqlTypes.UpdateTimeSeriesMutationVariables>(UpdateTimeSeriesDocument, options);
      }
export type UpdateTimeSeriesMutationHookResult = ReturnType<typeof useUpdateTimeSeriesMutation>;
export type UpdateTimeSeriesMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateTimeSeriesMutation>;
export type UpdateTimeSeriesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateTimeSeriesMutation, GraphqlTypes.UpdateTimeSeriesMutationVariables>;
export const DeleteAssetTimeSeriesDocument = gql`
    mutation DeleteAssetTimeSeries($assetId: ID!, $asOfDate: DateTime!, $assetTimeSeriesTypeNames: [FieldName!]!) {
  assetOps {
    deleteTimeSeries(
      assetId: $assetId
      asOfDate: $asOfDate
      assetTimeSeriesTypeNames: $assetTimeSeriesTypeNames
    ) {
      asset {
        id
        name
        ...AssetLatestTimeSeries
        ...AssetTimeSeries
      }
    }
  }
}
    ${AssetLatestTimeSeriesFragmentDoc}
${AssetTimeSeriesFragmentDoc}`;
export type DeleteAssetTimeSeriesMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteAssetTimeSeriesMutation, GraphqlTypes.DeleteAssetTimeSeriesMutationVariables>;

/**
 * __useDeleteAssetTimeSeriesMutation__
 *
 * To run a mutation, you first call `useDeleteAssetTimeSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetTimeSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetTimeSeriesMutation, { data, loading, error }] = useDeleteAssetTimeSeriesMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      asOfDate: // value for 'asOfDate'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useDeleteAssetTimeSeriesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteAssetTimeSeriesMutation, GraphqlTypes.DeleteAssetTimeSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteAssetTimeSeriesMutation, GraphqlTypes.DeleteAssetTimeSeriesMutationVariables>(DeleteAssetTimeSeriesDocument, options);
      }
export type DeleteAssetTimeSeriesMutationHookResult = ReturnType<typeof useDeleteAssetTimeSeriesMutation>;
export type DeleteAssetTimeSeriesMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteAssetTimeSeriesMutation>;
export type DeleteAssetTimeSeriesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteAssetTimeSeriesMutation, GraphqlTypes.DeleteAssetTimeSeriesMutationVariables>;
export const GetAssetDocument = gql`
    query GetAsset($objectId: ID!, $assetTimeSeriesTypeNames: [FieldName]!) {
  asset(id: $objectId) {
    id
    ...AssetTimeSeries
  }
}
    ${AssetTimeSeriesFragmentDoc}`;

/**
 * __useGetAssetQuery__
 *
 * To run a query within a React component, call `useGetAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      assetTimeSeriesTypeNames: // value for 'assetTimeSeriesTypeNames'
 *   },
 * });
 */
export function useGetAssetQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAssetQuery, GraphqlTypes.GetAssetQueryVariables> & ({ variables: GraphqlTypes.GetAssetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetQuery, GraphqlTypes.GetAssetQueryVariables>(GetAssetDocument, options);
      }
export function useGetAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetQuery, GraphqlTypes.GetAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetQuery, GraphqlTypes.GetAssetQueryVariables>(GetAssetDocument, options);
        }
// @ts-ignore
export function useGetAssetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetQuery, GraphqlTypes.GetAssetQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetQuery, GraphqlTypes.GetAssetQueryVariables>;
export function useGetAssetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetQuery, GraphqlTypes.GetAssetQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetQuery | undefined, GraphqlTypes.GetAssetQueryVariables>;
export function useGetAssetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetQuery, GraphqlTypes.GetAssetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetQuery, GraphqlTypes.GetAssetQueryVariables>(GetAssetDocument, options);
        }
export type GetAssetQueryHookResult = ReturnType<typeof useGetAssetQuery>;
export type GetAssetLazyQueryHookResult = ReturnType<typeof useGetAssetLazyQuery>;
export type GetAssetSuspenseQueryHookResult = ReturnType<typeof useGetAssetSuspenseQuery>;
export type GetAssetQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetQuery, GraphqlTypes.GetAssetQueryVariables>;
export const GetCurrenciesDocument = gql`
    query GetCurrencies {
  currencies {
    ...CurrencyFields
  }
}
    ${CurrencyFieldsFragmentDoc}`;

/**
 * __useGetCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrenciesQuery, GraphqlTypes.GetCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrenciesQuery, GraphqlTypes.GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
      }
export function useGetCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrenciesQuery, GraphqlTypes.GetCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrenciesQuery, GraphqlTypes.GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
        }
// @ts-ignore
export function useGetCurrenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrenciesQuery, GraphqlTypes.GetCurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrenciesQuery, GraphqlTypes.GetCurrenciesQueryVariables>;
export function useGetCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrenciesQuery, GraphqlTypes.GetCurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrenciesQuery | undefined, GraphqlTypes.GetCurrenciesQueryVariables>;
export function useGetCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrenciesQuery, GraphqlTypes.GetCurrenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrenciesQuery, GraphqlTypes.GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
        }
export type GetCurrenciesQueryHookResult = ReturnType<typeof useGetCurrenciesQuery>;
export type GetCurrenciesLazyQueryHookResult = ReturnType<typeof useGetCurrenciesLazyQuery>;
export type GetCurrenciesSuspenseQueryHookResult = ReturnType<typeof useGetCurrenciesSuspenseQuery>;
export type GetCurrenciesQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrenciesQuery, GraphqlTypes.GetCurrenciesQueryVariables>;
export const EditArenaDocument = gql`
    mutation EditArena($arenaId: ID!, $input: EditArenaInput!) {
  arenaOps {
    edit(objectId: $arenaId, objectInput: $input) {
      result {
        ...EditArenaFields
      }
    }
  }
}
    ${EditArenaFieldsFragmentDoc}`;
export type EditArenaMutationFn = Apollo.MutationFunction<GraphqlTypes.EditArenaMutation, GraphqlTypes.EditArenaMutationVariables>;

/**
 * __useEditArenaMutation__
 *
 * To run a mutation, you first call `useEditArenaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditArenaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editArenaMutation, { data, loading, error }] = useEditArenaMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditArenaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditArenaMutation, GraphqlTypes.EditArenaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditArenaMutation, GraphqlTypes.EditArenaMutationVariables>(EditArenaDocument, options);
      }
export type EditArenaMutationHookResult = ReturnType<typeof useEditArenaMutation>;
export type EditArenaMutationResult = Apollo.MutationResult<GraphqlTypes.EditArenaMutation>;
export type EditArenaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditArenaMutation, GraphqlTypes.EditArenaMutationVariables>;
export const DeactivateArenaDocument = gql`
    mutation DeactivateArena($arenaId: ID!) {
  arenaOps {
    deactivate(objectId: $arenaId) {
      arena {
        ...ArenaFields
      }
    }
  }
}
    ${ArenaFieldsFragmentDoc}`;
export type DeactivateArenaMutationFn = Apollo.MutationFunction<GraphqlTypes.DeactivateArenaMutation, GraphqlTypes.DeactivateArenaMutationVariables>;

/**
 * __useDeactivateArenaMutation__
 *
 * To run a mutation, you first call `useDeactivateArenaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateArenaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateArenaMutation, { data, loading, error }] = useDeactivateArenaMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useDeactivateArenaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeactivateArenaMutation, GraphqlTypes.DeactivateArenaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeactivateArenaMutation, GraphqlTypes.DeactivateArenaMutationVariables>(DeactivateArenaDocument, options);
      }
export type DeactivateArenaMutationHookResult = ReturnType<typeof useDeactivateArenaMutation>;
export type DeactivateArenaMutationResult = Apollo.MutationResult<GraphqlTypes.DeactivateArenaMutation>;
export type DeactivateArenaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeactivateArenaMutation, GraphqlTypes.DeactivateArenaMutationVariables>;
export const ReactivateArenaDocument = gql`
    mutation ReactivateArena($arenaId: ID!) {
  arenaOps {
    reactivate(objectId: $arenaId) {
      arena {
        ...ArenaFields
      }
    }
  }
}
    ${ArenaFieldsFragmentDoc}`;
export type ReactivateArenaMutationFn = Apollo.MutationFunction<GraphqlTypes.ReactivateArenaMutation, GraphqlTypes.ReactivateArenaMutationVariables>;

/**
 * __useReactivateArenaMutation__
 *
 * To run a mutation, you first call `useReactivateArenaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateArenaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateArenaMutation, { data, loading, error }] = useReactivateArenaMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useReactivateArenaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReactivateArenaMutation, GraphqlTypes.ReactivateArenaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReactivateArenaMutation, GraphqlTypes.ReactivateArenaMutationVariables>(ReactivateArenaDocument, options);
      }
export type ReactivateArenaMutationHookResult = ReturnType<typeof useReactivateArenaMutation>;
export type ReactivateArenaMutationResult = Apollo.MutationResult<GraphqlTypes.ReactivateArenaMutation>;
export type ReactivateArenaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReactivateArenaMutation, GraphqlTypes.ReactivateArenaMutationVariables>;
export const GetInvestmentEntityDocument = gql`
    query GetInvestmentEntity($entityId: ID!) {
  investmentEntity(id: $entityId) {
    id
    name
    canEdit
    canLimitedEdit
    entityAccessGroups {
      id
      title
      isFundAdmin
    }
    isInvestmentEntity
    isOperatingCompany
    overviewAndFinancialsPublished
    overviewAndFinancialsVisible
    published
    isSpv
    showPerfMetricsOnAsset
    showTimeWeightedReturns
    showTwrOnAsset
    thumbnail {
      id
      photoUrl
    }
    assetsIndirect {
      edges {
        node {
          id
          name
          isSold
          published
          visible
          entity {
            id
            name
            arenaId
            published
            overviewAndFinancialsPublished
            overviewAndFinancialsVisible
            isSpv
            showPerfMetricsOnAsset
            showTimeWeightedReturns
            showTwrOnAsset
          }
        }
      }
    }
    opCosIndirect {
      opcoId
      parentEntityId
      name
      published
      overviewAndFinancialsVisible
      owningPositions {
        id
        status
        entityCurrency
      }
    }
    ...SubAndOwnedEntities
    hasInvestorPositions
  }
}
    ${SubAndOwnedEntitiesFragmentDoc}`;

/**
 * __useGetInvestmentEntityQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntityQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetInvestmentEntityQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntityQuery, GraphqlTypes.GetInvestmentEntityQueryVariables> & ({ variables: GraphqlTypes.GetInvestmentEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntityQuery, GraphqlTypes.GetInvestmentEntityQueryVariables>(GetInvestmentEntityDocument, options);
      }
export function useGetInvestmentEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntityQuery, GraphqlTypes.GetInvestmentEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntityQuery, GraphqlTypes.GetInvestmentEntityQueryVariables>(GetInvestmentEntityDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityQuery, GraphqlTypes.GetInvestmentEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityQuery, GraphqlTypes.GetInvestmentEntityQueryVariables>;
export function useGetInvestmentEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityQuery, GraphqlTypes.GetInvestmentEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityQuery | undefined, GraphqlTypes.GetInvestmentEntityQueryVariables>;
export function useGetInvestmentEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityQuery, GraphqlTypes.GetInvestmentEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntityQuery, GraphqlTypes.GetInvestmentEntityQueryVariables>(GetInvestmentEntityDocument, options);
        }
export type GetInvestmentEntityQueryHookResult = ReturnType<typeof useGetInvestmentEntityQuery>;
export type GetInvestmentEntityLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntityLazyQuery>;
export type GetInvestmentEntitySuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntitySuspenseQuery>;
export type GetInvestmentEntityQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntityQuery, GraphqlTypes.GetInvestmentEntityQueryVariables>;
export const GetAsyncJobDocument = gql`
    query GetAsyncJob($jobId: ID!, $arenaId: ID) {
  asyncJob(id: $jobId, managerArenaId: $arenaId) {
    ...AsyncJobFields
  }
}
    ${AsyncJobFieldsFragmentDoc}`;

/**
 * __useGetAsyncJobQuery__
 *
 * To run a query within a React component, call `useGetAsyncJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAsyncJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAsyncJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetAsyncJobQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables> & ({ variables: GraphqlTypes.GetAsyncJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>(GetAsyncJobDocument, options);
      }
export function useGetAsyncJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>(GetAsyncJobDocument, options);
        }
// @ts-ignore
export function useGetAsyncJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>;
export function useGetAsyncJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAsyncJobQuery | undefined, GraphqlTypes.GetAsyncJobQueryVariables>;
export function useGetAsyncJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>(GetAsyncJobDocument, options);
        }
export type GetAsyncJobQueryHookResult = ReturnType<typeof useGetAsyncJobQuery>;
export type GetAsyncJobLazyQueryHookResult = ReturnType<typeof useGetAsyncJobLazyQuery>;
export type GetAsyncJobSuspenseQueryHookResult = ReturnType<typeof useGetAsyncJobSuspenseQuery>;
export type GetAsyncJobQueryResult = Apollo.QueryResult<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>;
export const GetAsyncJobProgressDocument = gql`
    query GetAsyncJobProgress($jobId: ID!, $arenaId: ID) {
  asyncJob(id: $jobId, managerArenaId: $arenaId) {
    id
    jobType
    status
    startTime
    endTime
    progress {
      processedCount
      totalCount
    }
    redisData
  }
}
    `;

/**
 * __useGetAsyncJobProgressQuery__
 *
 * To run a query within a React component, call `useGetAsyncJobProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAsyncJobProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAsyncJobProgressQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetAsyncJobProgressQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables> & ({ variables: GraphqlTypes.GetAsyncJobProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>(GetAsyncJobProgressDocument, options);
      }
export function useGetAsyncJobProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>(GetAsyncJobProgressDocument, options);
        }
// @ts-ignore
export function useGetAsyncJobProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>;
export function useGetAsyncJobProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAsyncJobProgressQuery | undefined, GraphqlTypes.GetAsyncJobProgressQueryVariables>;
export function useGetAsyncJobProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>(GetAsyncJobProgressDocument, options);
        }
export type GetAsyncJobProgressQueryHookResult = ReturnType<typeof useGetAsyncJobProgressQuery>;
export type GetAsyncJobProgressLazyQueryHookResult = ReturnType<typeof useGetAsyncJobProgressLazyQuery>;
export type GetAsyncJobProgressSuspenseQueryHookResult = ReturnType<typeof useGetAsyncJobProgressSuspenseQuery>;
export type GetAsyncJobProgressQueryResult = Apollo.QueryResult<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>;
export const GetCountryCodesDocument = gql`
    query GetCountryCodes {
  countries {
    edges {
      node {
        id
        code
        alpha2code
        name
      }
    }
  }
}
    `;

/**
 * __useGetCountryCodesQuery__
 *
 * To run a query within a React component, call `useGetCountryCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryCodesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>(GetCountryCodesDocument, options);
      }
export function useGetCountryCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>(GetCountryCodesDocument, options);
        }
// @ts-ignore
export function useGetCountryCodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>;
export function useGetCountryCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountryCodesQuery | undefined, GraphqlTypes.GetCountryCodesQueryVariables>;
export function useGetCountryCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>(GetCountryCodesDocument, options);
        }
export type GetCountryCodesQueryHookResult = ReturnType<typeof useGetCountryCodesQuery>;
export type GetCountryCodesLazyQueryHookResult = ReturnType<typeof useGetCountryCodesLazyQuery>;
export type GetCountryCodesSuspenseQueryHookResult = ReturnType<typeof useGetCountryCodesSuspenseQuery>;
export type GetCountryCodesQueryResult = Apollo.QueryResult<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>;
export const DownloadAllAssetsDocument = gql`
    mutation DownloadAllAssets($gpEntityIdList: [ID], $gpStaticDataOnly: Boolean, $gpActiveAssetsOnly: Boolean, $gpEntityDataOnly: Boolean, $includeExternalId: Boolean) {
  assetOps {
    downloadAllAssets(
      gpEntityIdList: $gpEntityIdList
      gpStaticDataOnly: $gpStaticDataOnly
      gpActiveAssetsOnly: $gpActiveAssetsOnly
      gpEntityDataOnly: $gpEntityDataOnly
      includeExternalId: $includeExternalId
    ) {
      job {
        id
      }
    }
  }
}
    `;
export type DownloadAllAssetsMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadAllAssetsMutation, GraphqlTypes.DownloadAllAssetsMutationVariables>;

/**
 * __useDownloadAllAssetsMutation__
 *
 * To run a mutation, you first call `useDownloadAllAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAllAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAllAssetsMutation, { data, loading, error }] = useDownloadAllAssetsMutation({
 *   variables: {
 *      gpEntityIdList: // value for 'gpEntityIdList'
 *      gpStaticDataOnly: // value for 'gpStaticDataOnly'
 *      gpActiveAssetsOnly: // value for 'gpActiveAssetsOnly'
 *      gpEntityDataOnly: // value for 'gpEntityDataOnly'
 *      includeExternalId: // value for 'includeExternalId'
 *   },
 * });
 */
export function useDownloadAllAssetsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadAllAssetsMutation, GraphqlTypes.DownloadAllAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadAllAssetsMutation, GraphqlTypes.DownloadAllAssetsMutationVariables>(DownloadAllAssetsDocument, options);
      }
export type DownloadAllAssetsMutationHookResult = ReturnType<typeof useDownloadAllAssetsMutation>;
export type DownloadAllAssetsMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadAllAssetsMutation>;
export type DownloadAllAssetsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadAllAssetsMutation, GraphqlTypes.DownloadAllAssetsMutationVariables>;
export const GetAssetDownloadUrlDocument = gql`
    query GetAssetDownloadUrl($input: ID!) {
  assetDownloadUrl(asyncJobId: $input)
}
    `;

/**
 * __useGetAssetDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetAssetDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetDownloadUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssetDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAssetDownloadUrlQuery, GraphqlTypes.GetAssetDownloadUrlQueryVariables> & ({ variables: GraphqlTypes.GetAssetDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssetDownloadUrlQuery, GraphqlTypes.GetAssetDownloadUrlQueryVariables>(GetAssetDownloadUrlDocument, options);
      }
export function useGetAssetDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssetDownloadUrlQuery, GraphqlTypes.GetAssetDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssetDownloadUrlQuery, GraphqlTypes.GetAssetDownloadUrlQueryVariables>(GetAssetDownloadUrlDocument, options);
        }
// @ts-ignore
export function useGetAssetDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetDownloadUrlQuery, GraphqlTypes.GetAssetDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetDownloadUrlQuery, GraphqlTypes.GetAssetDownloadUrlQueryVariables>;
export function useGetAssetDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetDownloadUrlQuery, GraphqlTypes.GetAssetDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssetDownloadUrlQuery | undefined, GraphqlTypes.GetAssetDownloadUrlQueryVariables>;
export function useGetAssetDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssetDownloadUrlQuery, GraphqlTypes.GetAssetDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssetDownloadUrlQuery, GraphqlTypes.GetAssetDownloadUrlQueryVariables>(GetAssetDownloadUrlDocument, options);
        }
export type GetAssetDownloadUrlQueryHookResult = ReturnType<typeof useGetAssetDownloadUrlQuery>;
export type GetAssetDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetAssetDownloadUrlLazyQuery>;
export type GetAssetDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetAssetDownloadUrlSuspenseQuery>;
export type GetAssetDownloadUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssetDownloadUrlQuery, GraphqlTypes.GetAssetDownloadUrlQueryVariables>;
export const GetGpTemplateDownloadUrlDocument = gql`
    query GetGpTemplateDownloadUrl($input: ID!) {
  gpTemplateDownloadUrl(asyncJobId: $input)
}
    `;

/**
 * __useGetGpTemplateDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetGpTemplateDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpTemplateDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpTemplateDownloadUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetGpTemplateDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetGpTemplateDownloadUrlQuery, GraphqlTypes.GetGpTemplateDownloadUrlQueryVariables> & ({ variables: GraphqlTypes.GetGpTemplateDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGpTemplateDownloadUrlQuery, GraphqlTypes.GetGpTemplateDownloadUrlQueryVariables>(GetGpTemplateDownloadUrlDocument, options);
      }
export function useGetGpTemplateDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGpTemplateDownloadUrlQuery, GraphqlTypes.GetGpTemplateDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGpTemplateDownloadUrlQuery, GraphqlTypes.GetGpTemplateDownloadUrlQueryVariables>(GetGpTemplateDownloadUrlDocument, options);
        }
// @ts-ignore
export function useGetGpTemplateDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpTemplateDownloadUrlQuery, GraphqlTypes.GetGpTemplateDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpTemplateDownloadUrlQuery, GraphqlTypes.GetGpTemplateDownloadUrlQueryVariables>;
export function useGetGpTemplateDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpTemplateDownloadUrlQuery, GraphqlTypes.GetGpTemplateDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpTemplateDownloadUrlQuery | undefined, GraphqlTypes.GetGpTemplateDownloadUrlQueryVariables>;
export function useGetGpTemplateDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpTemplateDownloadUrlQuery, GraphqlTypes.GetGpTemplateDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGpTemplateDownloadUrlQuery, GraphqlTypes.GetGpTemplateDownloadUrlQueryVariables>(GetGpTemplateDownloadUrlDocument, options);
        }
export type GetGpTemplateDownloadUrlQueryHookResult = ReturnType<typeof useGetGpTemplateDownloadUrlQuery>;
export type GetGpTemplateDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetGpTemplateDownloadUrlLazyQuery>;
export type GetGpTemplateDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetGpTemplateDownloadUrlSuspenseQuery>;
export type GetGpTemplateDownloadUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetGpTemplateDownloadUrlQuery, GraphqlTypes.GetGpTemplateDownloadUrlQueryVariables>;
export const GetDistributionDocument = gql`
    query GetDistribution($distributionId: ID!) {
  distribution(id: $distributionId) {
    ...DistributionFields
  }
}
    ${DistributionFieldsFragmentDoc}`;

/**
 * __useGetDistributionQuery__
 *
 * To run a query within a React component, call `useGetDistributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionQuery({
 *   variables: {
 *      distributionId: // value for 'distributionId'
 *   },
 * });
 */
export function useGetDistributionQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDistributionQuery, GraphqlTypes.GetDistributionQueryVariables> & ({ variables: GraphqlTypes.GetDistributionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDistributionQuery, GraphqlTypes.GetDistributionQueryVariables>(GetDistributionDocument, options);
      }
export function useGetDistributionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDistributionQuery, GraphqlTypes.GetDistributionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDistributionQuery, GraphqlTypes.GetDistributionQueryVariables>(GetDistributionDocument, options);
        }
// @ts-ignore
export function useGetDistributionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionQuery, GraphqlTypes.GetDistributionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionQuery, GraphqlTypes.GetDistributionQueryVariables>;
export function useGetDistributionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionQuery, GraphqlTypes.GetDistributionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionQuery | undefined, GraphqlTypes.GetDistributionQueryVariables>;
export function useGetDistributionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionQuery, GraphqlTypes.GetDistributionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDistributionQuery, GraphqlTypes.GetDistributionQueryVariables>(GetDistributionDocument, options);
        }
export type GetDistributionQueryHookResult = ReturnType<typeof useGetDistributionQuery>;
export type GetDistributionLazyQueryHookResult = ReturnType<typeof useGetDistributionLazyQuery>;
export type GetDistributionSuspenseQueryHookResult = ReturnType<typeof useGetDistributionSuspenseQuery>;
export type GetDistributionQueryResult = Apollo.QueryResult<GraphqlTypes.GetDistributionQuery, GraphqlTypes.GetDistributionQueryVariables>;
export const GetDistributionsByPositionIdDocument = gql`
    query GetDistributionsByPositionId($positionId: ID!, $sort: [GlobalDistributionQuerySortEnum] = [DATE_DISTRIBUTED_DESC, ID_DESC]) {
  distributions(positionId: $positionId, sort: $sort) {
    totalDistributed {
      monies
    }
    edges {
      node {
        ...DistributionFields
      }
    }
  }
}
    ${DistributionFieldsFragmentDoc}`;

/**
 * __useGetDistributionsByPositionIdQuery__
 *
 * To run a query within a React component, call `useGetDistributionsByPositionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionsByPositionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionsByPositionIdQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetDistributionsByPositionIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDistributionsByPositionIdQuery, GraphqlTypes.GetDistributionsByPositionIdQueryVariables> & ({ variables: GraphqlTypes.GetDistributionsByPositionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDistributionsByPositionIdQuery, GraphqlTypes.GetDistributionsByPositionIdQueryVariables>(GetDistributionsByPositionIdDocument, options);
      }
export function useGetDistributionsByPositionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDistributionsByPositionIdQuery, GraphqlTypes.GetDistributionsByPositionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDistributionsByPositionIdQuery, GraphqlTypes.GetDistributionsByPositionIdQueryVariables>(GetDistributionsByPositionIdDocument, options);
        }
// @ts-ignore
export function useGetDistributionsByPositionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionsByPositionIdQuery, GraphqlTypes.GetDistributionsByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionsByPositionIdQuery, GraphqlTypes.GetDistributionsByPositionIdQueryVariables>;
export function useGetDistributionsByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionsByPositionIdQuery, GraphqlTypes.GetDistributionsByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionsByPositionIdQuery | undefined, GraphqlTypes.GetDistributionsByPositionIdQueryVariables>;
export function useGetDistributionsByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionsByPositionIdQuery, GraphqlTypes.GetDistributionsByPositionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDistributionsByPositionIdQuery, GraphqlTypes.GetDistributionsByPositionIdQueryVariables>(GetDistributionsByPositionIdDocument, options);
        }
export type GetDistributionsByPositionIdQueryHookResult = ReturnType<typeof useGetDistributionsByPositionIdQuery>;
export type GetDistributionsByPositionIdLazyQueryHookResult = ReturnType<typeof useGetDistributionsByPositionIdLazyQuery>;
export type GetDistributionsByPositionIdSuspenseQueryHookResult = ReturnType<typeof useGetDistributionsByPositionIdSuspenseQuery>;
export type GetDistributionsByPositionIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetDistributionsByPositionIdQuery, GraphqlTypes.GetDistributionsByPositionIdQueryVariables>;
export const GetDocumentCategoriesDocument = gql`
    query GetDocumentCategories($filters: DocumentCategoriesFilters) {
  documentCategories(filters: $filters) {
    edges {
      node {
        ...DocumentCategoryFields
      }
    }
  }
}
    ${DocumentCategoryFieldsFragmentDoc}`;

/**
 * __useGetDocumentCategoriesQuery__
 *
 * To run a query within a React component, call `useGetDocumentCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentCategoriesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDocumentCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentCategoriesQuery, GraphqlTypes.GetDocumentCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentCategoriesQuery, GraphqlTypes.GetDocumentCategoriesQueryVariables>(GetDocumentCategoriesDocument, options);
      }
export function useGetDocumentCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentCategoriesQuery, GraphqlTypes.GetDocumentCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentCategoriesQuery, GraphqlTypes.GetDocumentCategoriesQueryVariables>(GetDocumentCategoriesDocument, options);
        }
// @ts-ignore
export function useGetDocumentCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesQuery, GraphqlTypes.GetDocumentCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentCategoriesQuery, GraphqlTypes.GetDocumentCategoriesQueryVariables>;
export function useGetDocumentCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesQuery, GraphqlTypes.GetDocumentCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentCategoriesQuery | undefined, GraphqlTypes.GetDocumentCategoriesQueryVariables>;
export function useGetDocumentCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesQuery, GraphqlTypes.GetDocumentCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentCategoriesQuery, GraphqlTypes.GetDocumentCategoriesQueryVariables>(GetDocumentCategoriesDocument, options);
        }
export type GetDocumentCategoriesQueryHookResult = ReturnType<typeof useGetDocumentCategoriesQuery>;
export type GetDocumentCategoriesLazyQueryHookResult = ReturnType<typeof useGetDocumentCategoriesLazyQuery>;
export type GetDocumentCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetDocumentCategoriesSuspenseQuery>;
export type GetDocumentCategoriesQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentCategoriesQuery, GraphqlTypes.GetDocumentCategoriesQueryVariables>;
export const GetEmailDistributionListsDocument = gql`
    query GetEmailDistributionLists($arenaId: ID) {
  emailDistributionLists(arenaId: $arenaId) {
    edges {
      node {
        ...EmailDistributionListFields
      }
    }
  }
}
    ${EmailDistributionListFieldsFragmentDoc}`;

/**
 * __useGetEmailDistributionListsQuery__
 *
 * To run a query within a React component, call `useGetEmailDistributionListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailDistributionListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailDistributionListsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetEmailDistributionListsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEmailDistributionListsQuery, GraphqlTypes.GetEmailDistributionListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEmailDistributionListsQuery, GraphqlTypes.GetEmailDistributionListsQueryVariables>(GetEmailDistributionListsDocument, options);
      }
export function useGetEmailDistributionListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEmailDistributionListsQuery, GraphqlTypes.GetEmailDistributionListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEmailDistributionListsQuery, GraphqlTypes.GetEmailDistributionListsQueryVariables>(GetEmailDistributionListsDocument, options);
        }
// @ts-ignore
export function useGetEmailDistributionListsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailDistributionListsQuery, GraphqlTypes.GetEmailDistributionListsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailDistributionListsQuery, GraphqlTypes.GetEmailDistributionListsQueryVariables>;
export function useGetEmailDistributionListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailDistributionListsQuery, GraphqlTypes.GetEmailDistributionListsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailDistributionListsQuery | undefined, GraphqlTypes.GetEmailDistributionListsQueryVariables>;
export function useGetEmailDistributionListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailDistributionListsQuery, GraphqlTypes.GetEmailDistributionListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEmailDistributionListsQuery, GraphqlTypes.GetEmailDistributionListsQueryVariables>(GetEmailDistributionListsDocument, options);
        }
export type GetEmailDistributionListsQueryHookResult = ReturnType<typeof useGetEmailDistributionListsQuery>;
export type GetEmailDistributionListsLazyQueryHookResult = ReturnType<typeof useGetEmailDistributionListsLazyQuery>;
export type GetEmailDistributionListsSuspenseQueryHookResult = ReturnType<typeof useGetEmailDistributionListsSuspenseQuery>;
export type GetEmailDistributionListsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEmailDistributionListsQuery, GraphqlTypes.GetEmailDistributionListsQueryVariables>;
export const SearchEntityCollectionsDocument = gql`
    query SearchEntityCollections {
  entityCollections(sort: NAME_ASC) {
    edges {
      collection: node {
        ...EntityCollectionFields
      }
    }
  }
}
    ${EntityCollectionFieldsFragmentDoc}`;

/**
 * __useSearchEntityCollectionsQuery__
 *
 * To run a query within a React component, call `useSearchEntityCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEntityCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEntityCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchEntityCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.SearchEntityCollectionsQuery, GraphqlTypes.SearchEntityCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchEntityCollectionsQuery, GraphqlTypes.SearchEntityCollectionsQueryVariables>(SearchEntityCollectionsDocument, options);
      }
export function useSearchEntityCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchEntityCollectionsQuery, GraphqlTypes.SearchEntityCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchEntityCollectionsQuery, GraphqlTypes.SearchEntityCollectionsQueryVariables>(SearchEntityCollectionsDocument, options);
        }
// @ts-ignore
export function useSearchEntityCollectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchEntityCollectionsQuery, GraphqlTypes.SearchEntityCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchEntityCollectionsQuery, GraphqlTypes.SearchEntityCollectionsQueryVariables>;
export function useSearchEntityCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchEntityCollectionsQuery, GraphqlTypes.SearchEntityCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchEntityCollectionsQuery | undefined, GraphqlTypes.SearchEntityCollectionsQueryVariables>;
export function useSearchEntityCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchEntityCollectionsQuery, GraphqlTypes.SearchEntityCollectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchEntityCollectionsQuery, GraphqlTypes.SearchEntityCollectionsQueryVariables>(SearchEntityCollectionsDocument, options);
        }
export type SearchEntityCollectionsQueryHookResult = ReturnType<typeof useSearchEntityCollectionsQuery>;
export type SearchEntityCollectionsLazyQueryHookResult = ReturnType<typeof useSearchEntityCollectionsLazyQuery>;
export type SearchEntityCollectionsSuspenseQueryHookResult = ReturnType<typeof useSearchEntityCollectionsSuspenseQuery>;
export type SearchEntityCollectionsQueryResult = Apollo.QueryResult<GraphqlTypes.SearchEntityCollectionsQuery, GraphqlTypes.SearchEntityCollectionsQueryVariables>;
export const CreateEntitySubTypeDocument = gql`
    mutation CreateEntitySubType($input: CreateEntitySubTypeInput!) {
  entitySubTypeOps {
    create(objectInput: $input) {
      entityType {
        id
      }
    }
  }
}
    `;
export type CreateEntitySubTypeMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateEntitySubTypeMutation, GraphqlTypes.CreateEntitySubTypeMutationVariables>;

/**
 * __useCreateEntitySubTypeMutation__
 *
 * To run a mutation, you first call `useCreateEntitySubTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntitySubTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntitySubTypeMutation, { data, loading, error }] = useCreateEntitySubTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntitySubTypeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateEntitySubTypeMutation, GraphqlTypes.CreateEntitySubTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateEntitySubTypeMutation, GraphqlTypes.CreateEntitySubTypeMutationVariables>(CreateEntitySubTypeDocument, options);
      }
export type CreateEntitySubTypeMutationHookResult = ReturnType<typeof useCreateEntitySubTypeMutation>;
export type CreateEntitySubTypeMutationResult = Apollo.MutationResult<GraphqlTypes.CreateEntitySubTypeMutation>;
export type CreateEntitySubTypeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateEntitySubTypeMutation, GraphqlTypes.CreateEntitySubTypeMutationVariables>;
export const SearchEntitySubTypesDocument = gql`
    query SearchEntitySubTypes {
  entitySubTypes(sort: NAME_ASC) {
    edges {
      entitySubType: node {
        ...EntitySubTypeFields
      }
    }
  }
}
    ${EntitySubTypeFieldsFragmentDoc}`;

/**
 * __useSearchEntitySubTypesQuery__
 *
 * To run a query within a React component, call `useSearchEntitySubTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEntitySubTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEntitySubTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchEntitySubTypesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.SearchEntitySubTypesQuery, GraphqlTypes.SearchEntitySubTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchEntitySubTypesQuery, GraphqlTypes.SearchEntitySubTypesQueryVariables>(SearchEntitySubTypesDocument, options);
      }
export function useSearchEntitySubTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchEntitySubTypesQuery, GraphqlTypes.SearchEntitySubTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchEntitySubTypesQuery, GraphqlTypes.SearchEntitySubTypesQueryVariables>(SearchEntitySubTypesDocument, options);
        }
// @ts-ignore
export function useSearchEntitySubTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchEntitySubTypesQuery, GraphqlTypes.SearchEntitySubTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchEntitySubTypesQuery, GraphqlTypes.SearchEntitySubTypesQueryVariables>;
export function useSearchEntitySubTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchEntitySubTypesQuery, GraphqlTypes.SearchEntitySubTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchEntitySubTypesQuery | undefined, GraphqlTypes.SearchEntitySubTypesQueryVariables>;
export function useSearchEntitySubTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchEntitySubTypesQuery, GraphqlTypes.SearchEntitySubTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchEntitySubTypesQuery, GraphqlTypes.SearchEntitySubTypesQueryVariables>(SearchEntitySubTypesDocument, options);
        }
export type SearchEntitySubTypesQueryHookResult = ReturnType<typeof useSearchEntitySubTypesQuery>;
export type SearchEntitySubTypesLazyQueryHookResult = ReturnType<typeof useSearchEntitySubTypesLazyQuery>;
export type SearchEntitySubTypesSuspenseQueryHookResult = ReturnType<typeof useSearchEntitySubTypesSuspenseQuery>;
export type SearchEntitySubTypesQueryResult = Apollo.QueryResult<GraphqlTypes.SearchEntitySubTypesQuery, GraphqlTypes.SearchEntitySubTypesQueryVariables>;
export const EditGlobalUserDocument = gql`
    mutation EditGlobalUser($input: EditGlobalUserInput!) {
  globalUserOps {
    editGlobalUser(objectInput: $input) {
      user {
        id
        emailAddress
        firstName
        middleName
        lastName
        title
        salutationName
        jobTitle
        companyName
        phones {
          id
          phoneType
          phoneNumber
        }
        addresses {
          id
          addressType
          street
          street2
          street3
          city
          state {
            objectName
            objectId
          }
          region
          postalCode
          country {
            objectName
            objectId
          }
        }
        defaultCurrency
        notificationCampaignFrequencies {
          id
          notificationCampaign {
            id
            name
          }
          frequency
        }
        currencies {
          ...CurrencyFields
        }
      }
      passwordError
    }
  }
}
    ${CurrencyFieldsFragmentDoc}`;
export type EditGlobalUserMutationFn = Apollo.MutationFunction<GraphqlTypes.EditGlobalUserMutation, GraphqlTypes.EditGlobalUserMutationVariables>;

/**
 * __useEditGlobalUserMutation__
 *
 * To run a mutation, you first call `useEditGlobalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGlobalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGlobalUserMutation, { data, loading, error }] = useEditGlobalUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditGlobalUserMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditGlobalUserMutation, GraphqlTypes.EditGlobalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditGlobalUserMutation, GraphqlTypes.EditGlobalUserMutationVariables>(EditGlobalUserDocument, options);
      }
export type EditGlobalUserMutationHookResult = ReturnType<typeof useEditGlobalUserMutation>;
export type EditGlobalUserMutationResult = Apollo.MutationResult<GraphqlTypes.EditGlobalUserMutation>;
export type EditGlobalUserMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditGlobalUserMutation, GraphqlTypes.EditGlobalUserMutationVariables>;
export const ActivateGlobalUserDocument = gql`
    mutation ActivateGlobalUser {
  activateGlobalUser {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on ActivateGlobalUserObject {
      user {
        id
      }
    }
  }
}
    `;
export type ActivateGlobalUserMutationFn = Apollo.MutationFunction<GraphqlTypes.ActivateGlobalUserMutation, GraphqlTypes.ActivateGlobalUserMutationVariables>;

/**
 * __useActivateGlobalUserMutation__
 *
 * To run a mutation, you first call `useActivateGlobalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateGlobalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateGlobalUserMutation, { data, loading, error }] = useActivateGlobalUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useActivateGlobalUserMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ActivateGlobalUserMutation, GraphqlTypes.ActivateGlobalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ActivateGlobalUserMutation, GraphqlTypes.ActivateGlobalUserMutationVariables>(ActivateGlobalUserDocument, options);
      }
export type ActivateGlobalUserMutationHookResult = ReturnType<typeof useActivateGlobalUserMutation>;
export type ActivateGlobalUserMutationResult = Apollo.MutationResult<GraphqlTypes.ActivateGlobalUserMutation>;
export type ActivateGlobalUserMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ActivateGlobalUserMutation, GraphqlTypes.ActivateGlobalUserMutationVariables>;
export const SendTwoStepAuthCodeDocument = gql`
    mutation SendTwoStepAuthCode($objectInput: SendTwoStepAuthCodeInput) {
  sendTwoStepAuthCode(objectInput: $objectInput) {
    errorCode
    message
  }
}
    `;
export type SendTwoStepAuthCodeMutationFn = Apollo.MutationFunction<GraphqlTypes.SendTwoStepAuthCodeMutation, GraphqlTypes.SendTwoStepAuthCodeMutationVariables>;

/**
 * __useSendTwoStepAuthCodeMutation__
 *
 * To run a mutation, you first call `useSendTwoStepAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTwoStepAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTwoStepAuthCodeMutation, { data, loading, error }] = useSendTwoStepAuthCodeMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useSendTwoStepAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SendTwoStepAuthCodeMutation, GraphqlTypes.SendTwoStepAuthCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SendTwoStepAuthCodeMutation, GraphqlTypes.SendTwoStepAuthCodeMutationVariables>(SendTwoStepAuthCodeDocument, options);
      }
export type SendTwoStepAuthCodeMutationHookResult = ReturnType<typeof useSendTwoStepAuthCodeMutation>;
export type SendTwoStepAuthCodeMutationResult = Apollo.MutationResult<GraphqlTypes.SendTwoStepAuthCodeMutation>;
export type SendTwoStepAuthCodeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SendTwoStepAuthCodeMutation, GraphqlTypes.SendTwoStepAuthCodeMutationVariables>;
export const VerifyTwoStepAuthCodeDocument = gql`
    mutation VerifyTwoStepAuthCode($objectInput: VerifyTwoStepAuthCodeInput!) {
  verifyTwoStepAuthCode(objectInput: $objectInput) {
    errorCode
    message
  }
}
    `;
export type VerifyTwoStepAuthCodeMutationFn = Apollo.MutationFunction<GraphqlTypes.VerifyTwoStepAuthCodeMutation, GraphqlTypes.VerifyTwoStepAuthCodeMutationVariables>;

/**
 * __useVerifyTwoStepAuthCodeMutation__
 *
 * To run a mutation, you first call `useVerifyTwoStepAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTwoStepAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTwoStepAuthCodeMutation, { data, loading, error }] = useVerifyTwoStepAuthCodeMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useVerifyTwoStepAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.VerifyTwoStepAuthCodeMutation, GraphqlTypes.VerifyTwoStepAuthCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.VerifyTwoStepAuthCodeMutation, GraphqlTypes.VerifyTwoStepAuthCodeMutationVariables>(VerifyTwoStepAuthCodeDocument, options);
      }
export type VerifyTwoStepAuthCodeMutationHookResult = ReturnType<typeof useVerifyTwoStepAuthCodeMutation>;
export type VerifyTwoStepAuthCodeMutationResult = Apollo.MutationResult<GraphqlTypes.VerifyTwoStepAuthCodeMutation>;
export type VerifyTwoStepAuthCodeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.VerifyTwoStepAuthCodeMutation, GraphqlTypes.VerifyTwoStepAuthCodeMutationVariables>;
export const UpdateSmsTwoStepAuthSettingsDocument = gql`
    mutation UpdateSmsTwoStepAuthSettings($objectInput: UpdateSmsTwoStepAuthSettingsInput!) {
  globalUserOps {
    updateSmsTwoStepAuthSettings(objectInput: $objectInput) {
      user {
        id
        twoFaPhoneNumber
        hasUnlinkedLocalUsers
        requiresTwoFaUpgrade
      }
    }
  }
}
    `;
export type UpdateSmsTwoStepAuthSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateSmsTwoStepAuthSettingsMutation, GraphqlTypes.UpdateSmsTwoStepAuthSettingsMutationVariables>;

/**
 * __useUpdateSmsTwoStepAuthSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSmsTwoStepAuthSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSmsTwoStepAuthSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSmsTwoStepAuthSettingsMutation, { data, loading, error }] = useUpdateSmsTwoStepAuthSettingsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateSmsTwoStepAuthSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateSmsTwoStepAuthSettingsMutation, GraphqlTypes.UpdateSmsTwoStepAuthSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateSmsTwoStepAuthSettingsMutation, GraphqlTypes.UpdateSmsTwoStepAuthSettingsMutationVariables>(UpdateSmsTwoStepAuthSettingsDocument, options);
      }
export type UpdateSmsTwoStepAuthSettingsMutationHookResult = ReturnType<typeof useUpdateSmsTwoStepAuthSettingsMutation>;
export type UpdateSmsTwoStepAuthSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateSmsTwoStepAuthSettingsMutation>;
export type UpdateSmsTwoStepAuthSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateSmsTwoStepAuthSettingsMutation, GraphqlTypes.UpdateSmsTwoStepAuthSettingsMutationVariables>;
export const SendEmailAddressVerificationDocument = gql`
    mutation SendEmailAddressVerification($emailAddress: String!) {
  globalUserOps {
    sendEmailAddressVerification(emailAddress: $emailAddress) {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on SendEmailAddressVerificationObject {
        user {
          id
        }
      }
    }
  }
}
    `;
export type SendEmailAddressVerificationMutationFn = Apollo.MutationFunction<GraphqlTypes.SendEmailAddressVerificationMutation, GraphqlTypes.SendEmailAddressVerificationMutationVariables>;

/**
 * __useSendEmailAddressVerificationMutation__
 *
 * To run a mutation, you first call `useSendEmailAddressVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailAddressVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailAddressVerificationMutation, { data, loading, error }] = useSendEmailAddressVerificationMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useSendEmailAddressVerificationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SendEmailAddressVerificationMutation, GraphqlTypes.SendEmailAddressVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SendEmailAddressVerificationMutation, GraphqlTypes.SendEmailAddressVerificationMutationVariables>(SendEmailAddressVerificationDocument, options);
      }
export type SendEmailAddressVerificationMutationHookResult = ReturnType<typeof useSendEmailAddressVerificationMutation>;
export type SendEmailAddressVerificationMutationResult = Apollo.MutationResult<GraphqlTypes.SendEmailAddressVerificationMutation>;
export type SendEmailAddressVerificationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SendEmailAddressVerificationMutation, GraphqlTypes.SendEmailAddressVerificationMutationVariables>;
export const ConfirmNewEmailDocument = gql`
    mutation ConfirmNewEmail($objectInput: ConfirmNewEmailInput!) {
  confirmNewEmail(objectInput: $objectInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on ConfirmNewEmailObject {
      newArenaIds
      user {
        id
        emailAddress
      }
    }
  }
}
    `;
export type ConfirmNewEmailMutationFn = Apollo.MutationFunction<GraphqlTypes.ConfirmNewEmailMutation, GraphqlTypes.ConfirmNewEmailMutationVariables>;

/**
 * __useConfirmNewEmailMutation__
 *
 * To run a mutation, you first call `useConfirmNewEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmNewEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmNewEmailMutation, { data, loading, error }] = useConfirmNewEmailMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useConfirmNewEmailMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ConfirmNewEmailMutation, GraphqlTypes.ConfirmNewEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ConfirmNewEmailMutation, GraphqlTypes.ConfirmNewEmailMutationVariables>(ConfirmNewEmailDocument, options);
      }
export type ConfirmNewEmailMutationHookResult = ReturnType<typeof useConfirmNewEmailMutation>;
export type ConfirmNewEmailMutationResult = Apollo.MutationResult<GraphqlTypes.ConfirmNewEmailMutation>;
export type ConfirmNewEmailMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ConfirmNewEmailMutation, GraphqlTypes.ConfirmNewEmailMutationVariables>;
export const LinkUsersDocument = gql`
    mutation LinkUsers($phoneNumbers: [String]) {
  globalUserOps {
    linkUsers(phoneNumbers: $phoneNumbers) {
      arenaIds
      user {
        id
        newLinkedArenaIds
      }
    }
  }
}
    `;
export type LinkUsersMutationFn = Apollo.MutationFunction<GraphqlTypes.LinkUsersMutation, GraphqlTypes.LinkUsersMutationVariables>;

/**
 * __useLinkUsersMutation__
 *
 * To run a mutation, you first call `useLinkUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkUsersMutation, { data, loading, error }] = useLinkUsersMutation({
 *   variables: {
 *      phoneNumbers: // value for 'phoneNumbers'
 *   },
 * });
 */
export function useLinkUsersMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.LinkUsersMutation, GraphqlTypes.LinkUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.LinkUsersMutation, GraphqlTypes.LinkUsersMutationVariables>(LinkUsersDocument, options);
      }
export type LinkUsersMutationHookResult = ReturnType<typeof useLinkUsersMutation>;
export type LinkUsersMutationResult = Apollo.MutationResult<GraphqlTypes.LinkUsersMutation>;
export type LinkUsersMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.LinkUsersMutation, GraphqlTypes.LinkUsersMutationVariables>;
export const CreateEntityCollectionDocument = gql`
    mutation CreateEntityCollection($input: CreateEntityCollectionInput!) {
  entityCollectionOps {
    create(objectInput: $input) {
      entityCollection {
        id
      }
    }
  }
}
    `;
export type CreateEntityCollectionMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateEntityCollectionMutation, GraphqlTypes.CreateEntityCollectionMutationVariables>;

/**
 * __useCreateEntityCollectionMutation__
 *
 * To run a mutation, you first call `useCreateEntityCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityCollectionMutation, { data, loading, error }] = useCreateEntityCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntityCollectionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateEntityCollectionMutation, GraphqlTypes.CreateEntityCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateEntityCollectionMutation, GraphqlTypes.CreateEntityCollectionMutationVariables>(CreateEntityCollectionDocument, options);
      }
export type CreateEntityCollectionMutationHookResult = ReturnType<typeof useCreateEntityCollectionMutation>;
export type CreateEntityCollectionMutationResult = Apollo.MutationResult<GraphqlTypes.CreateEntityCollectionMutation>;
export type CreateEntityCollectionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateEntityCollectionMutation, GraphqlTypes.CreateEntityCollectionMutationVariables>;
export const DeleteEntityCollectionDocument = gql`
    mutation DeleteEntityCollection($id: ID!) {
  entityCollectionOps {
    delete(objectId: $id) {
      deletedId
    }
  }
}
    `;
export type DeleteEntityCollectionMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteEntityCollectionMutation, GraphqlTypes.DeleteEntityCollectionMutationVariables>;

/**
 * __useDeleteEntityCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteEntityCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityCollectionMutation, { data, loading, error }] = useDeleteEntityCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEntityCollectionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteEntityCollectionMutation, GraphqlTypes.DeleteEntityCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteEntityCollectionMutation, GraphqlTypes.DeleteEntityCollectionMutationVariables>(DeleteEntityCollectionDocument, options);
      }
export type DeleteEntityCollectionMutationHookResult = ReturnType<typeof useDeleteEntityCollectionMutation>;
export type DeleteEntityCollectionMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteEntityCollectionMutation>;
export type DeleteEntityCollectionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteEntityCollectionMutation, GraphqlTypes.DeleteEntityCollectionMutationVariables>;
export const UpdateOpCoDetailsDocument = gql`
    mutation updateOpCoDetails($opCoDetails: OperatingCompanyDetailsInput!) {
  updateOpCoDetails(opCoDetails: $opCoDetails) {
    opCoDetails {
      ...OperatingCompanyDetailsFields
    }
  }
}
    ${OperatingCompanyDetailsFieldsFragmentDoc}`;
export type UpdateOpCoDetailsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateOpCoDetailsMutation, GraphqlTypes.UpdateOpCoDetailsMutationVariables>;

/**
 * __useUpdateOpCoDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateOpCoDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpCoDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpCoDetailsMutation, { data, loading, error }] = useUpdateOpCoDetailsMutation({
 *   variables: {
 *      opCoDetails: // value for 'opCoDetails'
 *   },
 * });
 */
export function useUpdateOpCoDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateOpCoDetailsMutation, GraphqlTypes.UpdateOpCoDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateOpCoDetailsMutation, GraphqlTypes.UpdateOpCoDetailsMutationVariables>(UpdateOpCoDetailsDocument, options);
      }
export type UpdateOpCoDetailsMutationHookResult = ReturnType<typeof useUpdateOpCoDetailsMutation>;
export type UpdateOpCoDetailsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateOpCoDetailsMutation>;
export type UpdateOpCoDetailsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateOpCoDetailsMutation, GraphqlTypes.UpdateOpCoDetailsMutationVariables>;
export const GetOperatingCompanyDocument = gql`
    query GetOperatingCompany($entityId: ID!) {
  investmentEntity(id: $entityId) {
    id
    name
    opCoDetails {
      ...OperatingCompanyDetailsFields
    }
  }
}
    ${OperatingCompanyDetailsFieldsFragmentDoc}`;

/**
 * __useGetOperatingCompanyQuery__
 *
 * To run a query within a React component, call `useGetOperatingCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperatingCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperatingCompanyQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetOperatingCompanyQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOperatingCompanyQuery, GraphqlTypes.GetOperatingCompanyQueryVariables> & ({ variables: GraphqlTypes.GetOperatingCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOperatingCompanyQuery, GraphqlTypes.GetOperatingCompanyQueryVariables>(GetOperatingCompanyDocument, options);
      }
export function useGetOperatingCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOperatingCompanyQuery, GraphqlTypes.GetOperatingCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOperatingCompanyQuery, GraphqlTypes.GetOperatingCompanyQueryVariables>(GetOperatingCompanyDocument, options);
        }
// @ts-ignore
export function useGetOperatingCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOperatingCompanyQuery, GraphqlTypes.GetOperatingCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOperatingCompanyQuery, GraphqlTypes.GetOperatingCompanyQueryVariables>;
export function useGetOperatingCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOperatingCompanyQuery, GraphqlTypes.GetOperatingCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOperatingCompanyQuery | undefined, GraphqlTypes.GetOperatingCompanyQueryVariables>;
export function useGetOperatingCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOperatingCompanyQuery, GraphqlTypes.GetOperatingCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOperatingCompanyQuery, GraphqlTypes.GetOperatingCompanyQueryVariables>(GetOperatingCompanyDocument, options);
        }
export type GetOperatingCompanyQueryHookResult = ReturnType<typeof useGetOperatingCompanyQuery>;
export type GetOperatingCompanyLazyQueryHookResult = ReturnType<typeof useGetOperatingCompanyLazyQuery>;
export type GetOperatingCompanySuspenseQueryHookResult = ReturnType<typeof useGetOperatingCompanySuspenseQuery>;
export type GetOperatingCompanyQueryResult = Apollo.QueryResult<GraphqlTypes.GetOperatingCompanyQuery, GraphqlTypes.GetOperatingCompanyQueryVariables>;
export const GetPortalPieChartDataDocument = gql`
    query GetPortalPieChartData($arenaId: ID, $chartType: ChartWidgetTypeEnum!, $chartIndex: Int, $dimension: String, $measure: String, $entityStatus: PortalPieChartEntityStatusEnum) {
  portalPieChartData(
    arenaId: $arenaId
    chartType: $chartType
    chartIndex: $chartIndex
    dimension: $dimension
    measure: $measure
    entityStatus: $entityStatus
  ) {
    chartIndex
    slices {
      name
      x
      y
    }
  }
}
    `;

/**
 * __useGetPortalPieChartDataQuery__
 *
 * To run a query within a React component, call `useGetPortalPieChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalPieChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalPieChartDataQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      chartType: // value for 'chartType'
 *      chartIndex: // value for 'chartIndex'
 *      dimension: // value for 'dimension'
 *      measure: // value for 'measure'
 *      entityStatus: // value for 'entityStatus'
 *   },
 * });
 */
export function useGetPortalPieChartDataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPortalPieChartDataQuery, GraphqlTypes.GetPortalPieChartDataQueryVariables> & ({ variables: GraphqlTypes.GetPortalPieChartDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPortalPieChartDataQuery, GraphqlTypes.GetPortalPieChartDataQueryVariables>(GetPortalPieChartDataDocument, options);
      }
export function useGetPortalPieChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPortalPieChartDataQuery, GraphqlTypes.GetPortalPieChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPortalPieChartDataQuery, GraphqlTypes.GetPortalPieChartDataQueryVariables>(GetPortalPieChartDataDocument, options);
        }
// @ts-ignore
export function useGetPortalPieChartDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalPieChartDataQuery, GraphqlTypes.GetPortalPieChartDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalPieChartDataQuery, GraphqlTypes.GetPortalPieChartDataQueryVariables>;
export function useGetPortalPieChartDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalPieChartDataQuery, GraphqlTypes.GetPortalPieChartDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalPieChartDataQuery | undefined, GraphqlTypes.GetPortalPieChartDataQueryVariables>;
export function useGetPortalPieChartDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalPieChartDataQuery, GraphqlTypes.GetPortalPieChartDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPortalPieChartDataQuery, GraphqlTypes.GetPortalPieChartDataQueryVariables>(GetPortalPieChartDataDocument, options);
        }
export type GetPortalPieChartDataQueryHookResult = ReturnType<typeof useGetPortalPieChartDataQuery>;
export type GetPortalPieChartDataLazyQueryHookResult = ReturnType<typeof useGetPortalPieChartDataLazyQuery>;
export type GetPortalPieChartDataSuspenseQueryHookResult = ReturnType<typeof useGetPortalPieChartDataSuspenseQuery>;
export type GetPortalPieChartDataQueryResult = Apollo.QueryResult<GraphqlTypes.GetPortalPieChartDataQuery, GraphqlTypes.GetPortalPieChartDataQueryVariables>;
export const CreateOrUpdateReportingTemplateAllocationTypeMappingDocument = gql`
    mutation CreateOrUpdateReportingTemplateAllocationTypeMapping($reportTemplateId: ID!, $reportTemplateAllocationTypeMapInput: [ReportTemplateAllocationTypeMapInput!]!) {
  reportTemplateOps {
    createOrUpdateReportTemplateAllocationTypeMap(
      reportTemplateId: $reportTemplateId
      reportTemplateAllocationTypeMapInput: $reportTemplateAllocationTypeMapInput
    ) {
      allocationTypeMap {
        id
        transactionTypeId
        reportTemplateAllocationType {
          id
          label
          transactionType
        }
      }
    }
  }
}
    `;
export type CreateOrUpdateReportingTemplateAllocationTypeMappingMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateOrUpdateReportingTemplateAllocationTypeMappingMutation, GraphqlTypes.CreateOrUpdateReportingTemplateAllocationTypeMappingMutationVariables>;

/**
 * __useCreateOrUpdateReportingTemplateAllocationTypeMappingMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateReportingTemplateAllocationTypeMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateReportingTemplateAllocationTypeMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateReportingTemplateAllocationTypeMappingMutation, { data, loading, error }] = useCreateOrUpdateReportingTemplateAllocationTypeMappingMutation({
 *   variables: {
 *      reportTemplateId: // value for 'reportTemplateId'
 *      reportTemplateAllocationTypeMapInput: // value for 'reportTemplateAllocationTypeMapInput'
 *   },
 * });
 */
export function useCreateOrUpdateReportingTemplateAllocationTypeMappingMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateOrUpdateReportingTemplateAllocationTypeMappingMutation, GraphqlTypes.CreateOrUpdateReportingTemplateAllocationTypeMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateOrUpdateReportingTemplateAllocationTypeMappingMutation, GraphqlTypes.CreateOrUpdateReportingTemplateAllocationTypeMappingMutationVariables>(CreateOrUpdateReportingTemplateAllocationTypeMappingDocument, options);
      }
export type CreateOrUpdateReportingTemplateAllocationTypeMappingMutationHookResult = ReturnType<typeof useCreateOrUpdateReportingTemplateAllocationTypeMappingMutation>;
export type CreateOrUpdateReportingTemplateAllocationTypeMappingMutationResult = Apollo.MutationResult<GraphqlTypes.CreateOrUpdateReportingTemplateAllocationTypeMappingMutation>;
export type CreateOrUpdateReportingTemplateAllocationTypeMappingMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateOrUpdateReportingTemplateAllocationTypeMappingMutation, GraphqlTypes.CreateOrUpdateReportingTemplateAllocationTypeMappingMutationVariables>;
export const GetReportTemplatesDocument = gql`
    query GetReportTemplates {
  reportTemplates {
    id
    label
    allocationTypes {
      id
      name
      label
      transactionType
    }
    allocationTypeMappings {
      id
      transactionType
      transactionTypeId
      reportTemplateAllocationType {
        id
        label
        transactionType
      }
    }
  }
}
    `;

/**
 * __useGetReportTemplatesQuery__
 *
 * To run a query within a React component, call `useGetReportTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetReportTemplatesQuery, GraphqlTypes.GetReportTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReportTemplatesQuery, GraphqlTypes.GetReportTemplatesQueryVariables>(GetReportTemplatesDocument, options);
      }
export function useGetReportTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReportTemplatesQuery, GraphqlTypes.GetReportTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReportTemplatesQuery, GraphqlTypes.GetReportTemplatesQueryVariables>(GetReportTemplatesDocument, options);
        }
// @ts-ignore
export function useGetReportTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplatesQuery, GraphqlTypes.GetReportTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplatesQuery, GraphqlTypes.GetReportTemplatesQueryVariables>;
export function useGetReportTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplatesQuery, GraphqlTypes.GetReportTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplatesQuery | undefined, GraphqlTypes.GetReportTemplatesQueryVariables>;
export function useGetReportTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplatesQuery, GraphqlTypes.GetReportTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReportTemplatesQuery, GraphqlTypes.GetReportTemplatesQueryVariables>(GetReportTemplatesDocument, options);
        }
export type GetReportTemplatesQueryHookResult = ReturnType<typeof useGetReportTemplatesQuery>;
export type GetReportTemplatesLazyQueryHookResult = ReturnType<typeof useGetReportTemplatesLazyQuery>;
export type GetReportTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetReportTemplatesSuspenseQuery>;
export type GetReportTemplatesQueryResult = Apollo.QueryResult<GraphqlTypes.GetReportTemplatesQuery, GraphqlTypes.GetReportTemplatesQueryVariables>;
export const GetReportTemplateDownloadUrlDocument = gql`
    query GetReportTemplateDownloadUrl($input: ID!) {
  thirdPartyReportTemplateDownloadUrl(asyncJobId: $input)
}
    `;

/**
 * __useGetReportTemplateDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetReportTemplateDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTemplateDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTemplateDownloadUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReportTemplateDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetReportTemplateDownloadUrlQuery, GraphqlTypes.GetReportTemplateDownloadUrlQueryVariables> & ({ variables: GraphqlTypes.GetReportTemplateDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReportTemplateDownloadUrlQuery, GraphqlTypes.GetReportTemplateDownloadUrlQueryVariables>(GetReportTemplateDownloadUrlDocument, options);
      }
export function useGetReportTemplateDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReportTemplateDownloadUrlQuery, GraphqlTypes.GetReportTemplateDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReportTemplateDownloadUrlQuery, GraphqlTypes.GetReportTemplateDownloadUrlQueryVariables>(GetReportTemplateDownloadUrlDocument, options);
        }
// @ts-ignore
export function useGetReportTemplateDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateDownloadUrlQuery, GraphqlTypes.GetReportTemplateDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplateDownloadUrlQuery, GraphqlTypes.GetReportTemplateDownloadUrlQueryVariables>;
export function useGetReportTemplateDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateDownloadUrlQuery, GraphqlTypes.GetReportTemplateDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplateDownloadUrlQuery | undefined, GraphqlTypes.GetReportTemplateDownloadUrlQueryVariables>;
export function useGetReportTemplateDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateDownloadUrlQuery, GraphqlTypes.GetReportTemplateDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReportTemplateDownloadUrlQuery, GraphqlTypes.GetReportTemplateDownloadUrlQueryVariables>(GetReportTemplateDownloadUrlDocument, options);
        }
export type GetReportTemplateDownloadUrlQueryHookResult = ReturnType<typeof useGetReportTemplateDownloadUrlQuery>;
export type GetReportTemplateDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetReportTemplateDownloadUrlLazyQuery>;
export type GetReportTemplateDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetReportTemplateDownloadUrlSuspenseQuery>;
export type GetReportTemplateDownloadUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetReportTemplateDownloadUrlQuery, GraphqlTypes.GetReportTemplateDownloadUrlQueryVariables>;
export const GetReportTemplateIsFullyMappedDocument = gql`
    query GetReportTemplateIsFullyMapped($reportTemplateId: ID!, $positionId: ID!, $period: Period!) {
  reportTemplateIsFullyMapped(
    reportTemplateId: $reportTemplateId
    positionId: $positionId
    period: $period
  )
}
    `;

/**
 * __useGetReportTemplateIsFullyMappedQuery__
 *
 * To run a query within a React component, call `useGetReportTemplateIsFullyMappedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTemplateIsFullyMappedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTemplateIsFullyMappedQuery({
 *   variables: {
 *      reportTemplateId: // value for 'reportTemplateId'
 *      positionId: // value for 'positionId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetReportTemplateIsFullyMappedQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetReportTemplateIsFullyMappedQuery, GraphqlTypes.GetReportTemplateIsFullyMappedQueryVariables> & ({ variables: GraphqlTypes.GetReportTemplateIsFullyMappedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReportTemplateIsFullyMappedQuery, GraphqlTypes.GetReportTemplateIsFullyMappedQueryVariables>(GetReportTemplateIsFullyMappedDocument, options);
      }
export function useGetReportTemplateIsFullyMappedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReportTemplateIsFullyMappedQuery, GraphqlTypes.GetReportTemplateIsFullyMappedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReportTemplateIsFullyMappedQuery, GraphqlTypes.GetReportTemplateIsFullyMappedQueryVariables>(GetReportTemplateIsFullyMappedDocument, options);
        }
// @ts-ignore
export function useGetReportTemplateIsFullyMappedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateIsFullyMappedQuery, GraphqlTypes.GetReportTemplateIsFullyMappedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplateIsFullyMappedQuery, GraphqlTypes.GetReportTemplateIsFullyMappedQueryVariables>;
export function useGetReportTemplateIsFullyMappedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateIsFullyMappedQuery, GraphqlTypes.GetReportTemplateIsFullyMappedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplateIsFullyMappedQuery | undefined, GraphqlTypes.GetReportTemplateIsFullyMappedQueryVariables>;
export function useGetReportTemplateIsFullyMappedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateIsFullyMappedQuery, GraphqlTypes.GetReportTemplateIsFullyMappedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReportTemplateIsFullyMappedQuery, GraphqlTypes.GetReportTemplateIsFullyMappedQueryVariables>(GetReportTemplateIsFullyMappedDocument, options);
        }
export type GetReportTemplateIsFullyMappedQueryHookResult = ReturnType<typeof useGetReportTemplateIsFullyMappedQuery>;
export type GetReportTemplateIsFullyMappedLazyQueryHookResult = ReturnType<typeof useGetReportTemplateIsFullyMappedLazyQuery>;
export type GetReportTemplateIsFullyMappedSuspenseQueryHookResult = ReturnType<typeof useGetReportTemplateIsFullyMappedSuspenseQuery>;
export type GetReportTemplateIsFullyMappedQueryResult = Apollo.QueryResult<GraphqlTypes.GetReportTemplateIsFullyMappedQuery, GraphqlTypes.GetReportTemplateIsFullyMappedQueryVariables>;
export const GetPrivateEdgeTemplateExportFeatureFlagDocument = gql`
    query getPrivateEdgeTemplateExportFeatureFlag {
  devFeatures {
    privateEdgeTemplateExport
  }
}
    `;

/**
 * __useGetPrivateEdgeTemplateExportFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetPrivateEdgeTemplateExportFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivateEdgeTemplateExportFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivateEdgeTemplateExportFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPrivateEdgeTemplateExportFeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQuery, GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQuery, GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQueryVariables>(GetPrivateEdgeTemplateExportFeatureFlagDocument, options);
      }
export function useGetPrivateEdgeTemplateExportFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQuery, GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQuery, GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQueryVariables>(GetPrivateEdgeTemplateExportFeatureFlagDocument, options);
        }
// @ts-ignore
export function useGetPrivateEdgeTemplateExportFeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQuery, GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQuery, GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQueryVariables>;
export function useGetPrivateEdgeTemplateExportFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQuery, GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQuery | undefined, GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQueryVariables>;
export function useGetPrivateEdgeTemplateExportFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQuery, GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQuery, GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQueryVariables>(GetPrivateEdgeTemplateExportFeatureFlagDocument, options);
        }
export type GetPrivateEdgeTemplateExportFeatureFlagQueryHookResult = ReturnType<typeof useGetPrivateEdgeTemplateExportFeatureFlagQuery>;
export type GetPrivateEdgeTemplateExportFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetPrivateEdgeTemplateExportFeatureFlagLazyQuery>;
export type GetPrivateEdgeTemplateExportFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetPrivateEdgeTemplateExportFeatureFlagSuspenseQuery>;
export type GetPrivateEdgeTemplateExportFeatureFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQuery, GraphqlTypes.GetPrivateEdgeTemplateExportFeatureFlagQueryVariables>;
export const SearchTagsDocument = gql`
    query SearchTags($jsqObjectType: JSQObjectType!, $objectIds: [ID!]) {
  tags(jsqObjectType: $jsqObjectType, objectIds: $objectIds) {
    edges {
      tag: node {
        ...TagFields
      }
    }
  }
}
    ${TagFieldsFragmentDoc}`;

/**
 * __useSearchTagsQuery__
 *
 * To run a query within a React component, call `useSearchTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTagsQuery({
 *   variables: {
 *      jsqObjectType: // value for 'jsqObjectType'
 *      objectIds: // value for 'objectIds'
 *   },
 * });
 */
export function useSearchTagsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchTagsQuery, GraphqlTypes.SearchTagsQueryVariables> & ({ variables: GraphqlTypes.SearchTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchTagsQuery, GraphqlTypes.SearchTagsQueryVariables>(SearchTagsDocument, options);
      }
export function useSearchTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchTagsQuery, GraphqlTypes.SearchTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchTagsQuery, GraphqlTypes.SearchTagsQueryVariables>(SearchTagsDocument, options);
        }
// @ts-ignore
export function useSearchTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTagsQuery, GraphqlTypes.SearchTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchTagsQuery, GraphqlTypes.SearchTagsQueryVariables>;
export function useSearchTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTagsQuery, GraphqlTypes.SearchTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchTagsQuery | undefined, GraphqlTypes.SearchTagsQueryVariables>;
export function useSearchTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTagsQuery, GraphqlTypes.SearchTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchTagsQuery, GraphqlTypes.SearchTagsQueryVariables>(SearchTagsDocument, options);
        }
export type SearchTagsQueryHookResult = ReturnType<typeof useSearchTagsQuery>;
export type SearchTagsLazyQueryHookResult = ReturnType<typeof useSearchTagsLazyQuery>;
export type SearchTagsSuspenseQueryHookResult = ReturnType<typeof useSearchTagsSuspenseQuery>;
export type SearchTagsQueryResult = Apollo.QueryResult<GraphqlTypes.SearchTagsQuery, GraphqlTypes.SearchTagsQueryVariables>;
export const GetTransactionTypesDocument = gql`
    query GetTransactionTypes {
  distributionTypes {
    id
    name
    sortOrder
    isReturnOfCapital
    isWithholding
    excludeFromYield
  }
  contributionTypes: transactionTypes(signEffect: positive) {
    id
    name
    sortOrder
    isPositive
    isNegative
    isSubType
    affectsOwnership
    affectsCommitment
    excludeFromMetrics
  }
  redemptionTypes: transactionTypes(signEffect: negative) {
    id
    name
    sortOrder
    isPositive
    isNegative
    isSubType
    affectsOwnership
    affectsCommitment
    excludeFromMetrics
  }
  netIncomeTypes {
    id
    name
    sortOrder
  }
  navTypes {
    id
    name
    sortOrder
  }
}
    `;

/**
 * __useGetTransactionTypesQuery__
 *
 * To run a query within a React component, call `useGetTransactionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransactionTypesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>(GetTransactionTypesDocument, options);
      }
export function useGetTransactionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>(GetTransactionTypesDocument, options);
        }
// @ts-ignore
export function useGetTransactionTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>;
export function useGetTransactionTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionTypesQuery | undefined, GraphqlTypes.GetTransactionTypesQueryVariables>;
export function useGetTransactionTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>(GetTransactionTypesDocument, options);
        }
export type GetTransactionTypesQueryHookResult = ReturnType<typeof useGetTransactionTypesQuery>;
export type GetTransactionTypesLazyQueryHookResult = ReturnType<typeof useGetTransactionTypesLazyQuery>;
export type GetTransactionTypesSuspenseQueryHookResult = ReturnType<typeof useGetTransactionTypesSuspenseQuery>;
export type GetTransactionTypesQueryResult = Apollo.QueryResult<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>;
export const GetEntityTwrMetricsDocument = gql`
    query GetEntityTwrMetrics($entityId: ID!) {
  investmentEntity(id: $entityId) {
    id
    twrEndDate
    showTwrNetworkPortalOnly
    perfMetricsPublished
    twrPeriodMetrics {
      ...PortalTwrPeriodHeaderAndMetrics
    }
    twrSummaryMetrics {
      ...PortalTwrSummaryHeaderAndMetrics
    }
  }
}
    ${PortalTwrPeriodHeaderAndMetricsFragmentDoc}
${PortalTwrSummaryHeaderAndMetricsFragmentDoc}`;

/**
 * __useGetEntityTwrMetricsQuery__
 *
 * To run a query within a React component, call `useGetEntityTwrMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityTwrMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityTwrMetricsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityTwrMetricsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityTwrMetricsQuery, GraphqlTypes.GetEntityTwrMetricsQueryVariables> & ({ variables: GraphqlTypes.GetEntityTwrMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityTwrMetricsQuery, GraphqlTypes.GetEntityTwrMetricsQueryVariables>(GetEntityTwrMetricsDocument, options);
      }
export function useGetEntityTwrMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityTwrMetricsQuery, GraphqlTypes.GetEntityTwrMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityTwrMetricsQuery, GraphqlTypes.GetEntityTwrMetricsQueryVariables>(GetEntityTwrMetricsDocument, options);
        }
// @ts-ignore
export function useGetEntityTwrMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityTwrMetricsQuery, GraphqlTypes.GetEntityTwrMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityTwrMetricsQuery, GraphqlTypes.GetEntityTwrMetricsQueryVariables>;
export function useGetEntityTwrMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityTwrMetricsQuery, GraphqlTypes.GetEntityTwrMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityTwrMetricsQuery | undefined, GraphqlTypes.GetEntityTwrMetricsQueryVariables>;
export function useGetEntityTwrMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityTwrMetricsQuery, GraphqlTypes.GetEntityTwrMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityTwrMetricsQuery, GraphqlTypes.GetEntityTwrMetricsQueryVariables>(GetEntityTwrMetricsDocument, options);
        }
export type GetEntityTwrMetricsQueryHookResult = ReturnType<typeof useGetEntityTwrMetricsQuery>;
export type GetEntityTwrMetricsLazyQueryHookResult = ReturnType<typeof useGetEntityTwrMetricsLazyQuery>;
export type GetEntityTwrMetricsSuspenseQueryHookResult = ReturnType<typeof useGetEntityTwrMetricsSuspenseQuery>;
export type GetEntityTwrMetricsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityTwrMetricsQuery, GraphqlTypes.GetEntityTwrMetricsQueryVariables>;
export const UpdateUserPromptViewedDocument = gql`
    mutation UpdateUserPromptViewed($promptName: PromptNameEnum!) {
  userPromptsOps {
    updateUserPromptViewed(promptName: $promptName) {
      userPromptViewed {
        id
      }
    }
  }
}
    `;
export type UpdateUserPromptViewedMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateUserPromptViewedMutation, GraphqlTypes.UpdateUserPromptViewedMutationVariables>;

/**
 * __useUpdateUserPromptViewedMutation__
 *
 * To run a mutation, you first call `useUpdateUserPromptViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPromptViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPromptViewedMutation, { data, loading, error }] = useUpdateUserPromptViewedMutation({
 *   variables: {
 *      promptName: // value for 'promptName'
 *   },
 * });
 */
export function useUpdateUserPromptViewedMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateUserPromptViewedMutation, GraphqlTypes.UpdateUserPromptViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateUserPromptViewedMutation, GraphqlTypes.UpdateUserPromptViewedMutationVariables>(UpdateUserPromptViewedDocument, options);
      }
export type UpdateUserPromptViewedMutationHookResult = ReturnType<typeof useUpdateUserPromptViewedMutation>;
export type UpdateUserPromptViewedMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateUserPromptViewedMutation>;
export type UpdateUserPromptViewedMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateUserPromptViewedMutation, GraphqlTypes.UpdateUserPromptViewedMutationVariables>;
export const GetUncompletedUserPromptsDocument = gql`
    query GetUncompletedUserPrompts {
  uncompletedUserPrompts
}
    `;

/**
 * __useGetUncompletedUserPromptsQuery__
 *
 * To run a query within a React component, call `useGetUncompletedUserPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUncompletedUserPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUncompletedUserPromptsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUncompletedUserPromptsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetUncompletedUserPromptsQuery, GraphqlTypes.GetUncompletedUserPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUncompletedUserPromptsQuery, GraphqlTypes.GetUncompletedUserPromptsQueryVariables>(GetUncompletedUserPromptsDocument, options);
      }
export function useGetUncompletedUserPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUncompletedUserPromptsQuery, GraphqlTypes.GetUncompletedUserPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUncompletedUserPromptsQuery, GraphqlTypes.GetUncompletedUserPromptsQueryVariables>(GetUncompletedUserPromptsDocument, options);
        }
// @ts-ignore
export function useGetUncompletedUserPromptsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUncompletedUserPromptsQuery, GraphqlTypes.GetUncompletedUserPromptsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUncompletedUserPromptsQuery, GraphqlTypes.GetUncompletedUserPromptsQueryVariables>;
export function useGetUncompletedUserPromptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUncompletedUserPromptsQuery, GraphqlTypes.GetUncompletedUserPromptsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUncompletedUserPromptsQuery | undefined, GraphqlTypes.GetUncompletedUserPromptsQueryVariables>;
export function useGetUncompletedUserPromptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUncompletedUserPromptsQuery, GraphqlTypes.GetUncompletedUserPromptsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUncompletedUserPromptsQuery, GraphqlTypes.GetUncompletedUserPromptsQueryVariables>(GetUncompletedUserPromptsDocument, options);
        }
export type GetUncompletedUserPromptsQueryHookResult = ReturnType<typeof useGetUncompletedUserPromptsQuery>;
export type GetUncompletedUserPromptsLazyQueryHookResult = ReturnType<typeof useGetUncompletedUserPromptsLazyQuery>;
export type GetUncompletedUserPromptsSuspenseQueryHookResult = ReturnType<typeof useGetUncompletedUserPromptsSuspenseQuery>;
export type GetUncompletedUserPromptsQueryResult = Apollo.QueryResult<GraphqlTypes.GetUncompletedUserPromptsQuery, GraphqlTypes.GetUncompletedUserPromptsQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($arenaId: ID, $firstName: String!, $lastName: String!, $emailAddress: String!, $newsletterSubscribed: Boolean, $newsletterSubscriptionType: NewsletterSubscriptionTypes, $sendActivationEmail: Boolean, $roles: [String!], $groups: [String!], $isGlobal: Boolean) {
  userOps {
    createUser(
      arenaId: $arenaId
      firstName: $firstName
      lastName: $lastName
      emailAddress: $emailAddress
      newsletterSubscribed: $newsletterSubscribed
      newsletterSubscriptionType: $newsletterSubscriptionType
      sendActivationEmail: $sendActivationEmail
      roles: $roles
      groups: $groups
      isGlobal: $isGlobal
    ) {
      user {
        ...UserFields
        sessionLogs {
          edges {
            node {
              id
              startTime
            }
          }
        }
        roles {
          edges {
            node {
              ...RoleFields
            }
          }
        }
        groups {
          edges {
            node {
              ...GroupFields
            }
          }
        }
        arena {
          id
          name
        }
        contact {
          fullName
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${RoleFieldsFragmentDoc}
${GroupFieldsFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateUserMutation, GraphqlTypes.CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      emailAddress: // value for 'emailAddress'
 *      newsletterSubscribed: // value for 'newsletterSubscribed'
 *      newsletterSubscriptionType: // value for 'newsletterSubscriptionType'
 *      sendActivationEmail: // value for 'sendActivationEmail'
 *      roles: // value for 'roles'
 *      groups: // value for 'groups'
 *      isGlobal: // value for 'isGlobal'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateUserMutation, GraphqlTypes.CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateUserMutation, GraphqlTypes.CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<GraphqlTypes.CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateUserMutation, GraphqlTypes.CreateUserMutationVariables>;
export const EditUserDocument = gql`
    mutation EditUser($userId: ID!, $arenaId: ID, $input: EditUserInput!) {
  userOps {
    editUser(objectId: $userId, arenaId: $arenaId, objectInput: $input) {
      user {
        ...UserFields
        sessionLogs {
          edges {
            node {
              id
              startTime
            }
          }
        }
        roles {
          edges {
            node {
              ...RoleFields
            }
          }
        }
        groups {
          edges {
            node {
              ...GroupFields
            }
          }
        }
        arena {
          id
          name
        }
        contact {
          fullName
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${RoleFieldsFragmentDoc}
${GroupFieldsFragmentDoc}`;
export type EditUserMutationFn = Apollo.MutationFunction<GraphqlTypes.EditUserMutation, GraphqlTypes.EditUserMutationVariables>;

/**
 * __useEditUserMutation__
 *
 * To run a mutation, you first call `useEditUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserMutation, { data, loading, error }] = useEditUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      arenaId: // value for 'arenaId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUserMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditUserMutation, GraphqlTypes.EditUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditUserMutation, GraphqlTypes.EditUserMutationVariables>(EditUserDocument, options);
      }
export type EditUserMutationHookResult = ReturnType<typeof useEditUserMutation>;
export type EditUserMutationResult = Apollo.MutationResult<GraphqlTypes.EditUserMutation>;
export type EditUserMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditUserMutation, GraphqlTypes.EditUserMutationVariables>;
export const GenerateTotpDocument = gql`
    mutation GenerateTotp($userId: ID!) {
  userOps {
    generateTotp(objectId: $userId) {
      totpKey
      qrCode
    }
  }
}
    `;
export type GenerateTotpMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateTotpMutation, GraphqlTypes.GenerateTotpMutationVariables>;

/**
 * __useGenerateTotpMutation__
 *
 * To run a mutation, you first call `useGenerateTotpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTotpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTotpMutation, { data, loading, error }] = useGenerateTotpMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGenerateTotpMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateTotpMutation, GraphqlTypes.GenerateTotpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateTotpMutation, GraphqlTypes.GenerateTotpMutationVariables>(GenerateTotpDocument, options);
      }
export type GenerateTotpMutationHookResult = ReturnType<typeof useGenerateTotpMutation>;
export type GenerateTotpMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateTotpMutation>;
export type GenerateTotpMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateTotpMutation, GraphqlTypes.GenerateTotpMutationVariables>;
export const DownloadTwrDataDocument = gql`
    mutation DownloadTwrData($globalUserId: ID!) {
  userOps {
    generateTwrData(globalUserId: $globalUserId) {
      job {
        id
      }
    }
  }
}
    `;
export type DownloadTwrDataMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadTwrDataMutation, GraphqlTypes.DownloadTwrDataMutationVariables>;

/**
 * __useDownloadTwrDataMutation__
 *
 * To run a mutation, you first call `useDownloadTwrDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadTwrDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadTwrDataMutation, { data, loading, error }] = useDownloadTwrDataMutation({
 *   variables: {
 *      globalUserId: // value for 'globalUserId'
 *   },
 * });
 */
export function useDownloadTwrDataMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadTwrDataMutation, GraphqlTypes.DownloadTwrDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadTwrDataMutation, GraphqlTypes.DownloadTwrDataMutationVariables>(DownloadTwrDataDocument, options);
      }
export type DownloadTwrDataMutationHookResult = ReturnType<typeof useDownloadTwrDataMutation>;
export type DownloadTwrDataMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadTwrDataMutation>;
export type DownloadTwrDataMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadTwrDataMutation, GraphqlTypes.DownloadTwrDataMutationVariables>;
export const DowngradeStaffOrHybridUserToEmail2FaDocument = gql`
    mutation DowngradeStaffOrHybridUserToEmail2FA($object_input: DowngradeStaffOrHybridUserToEmail2FAInput!) {
  userOps {
    downgradeStaffOrHybridUserToEmail2fa(objectInput: $object_input) {
      ... on DowngradeStaffOrHybridUserToEmail2FAObject {
        isSuccess
      }
      ... on MutationErrorResponse {
        errorCode
        message
      }
    }
  }
}
    `;
export type DowngradeStaffOrHybridUserToEmail2FaMutationFn = Apollo.MutationFunction<GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutation, GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutationVariables>;

/**
 * __useDowngradeStaffOrHybridUserToEmail2FaMutation__
 *
 * To run a mutation, you first call `useDowngradeStaffOrHybridUserToEmail2FaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDowngradeStaffOrHybridUserToEmail2FaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downgradeStaffOrHybridUserToEmail2FaMutation, { data, loading, error }] = useDowngradeStaffOrHybridUserToEmail2FaMutation({
 *   variables: {
 *      object_input: // value for 'object_input'
 *   },
 * });
 */
export function useDowngradeStaffOrHybridUserToEmail2FaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutation, GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutation, GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutationVariables>(DowngradeStaffOrHybridUserToEmail2FaDocument, options);
      }
export type DowngradeStaffOrHybridUserToEmail2FaMutationHookResult = ReturnType<typeof useDowngradeStaffOrHybridUserToEmail2FaMutation>;
export type DowngradeStaffOrHybridUserToEmail2FaMutationResult = Apollo.MutationResult<GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutation>;
export type DowngradeStaffOrHybridUserToEmail2FaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutation, GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutationVariables>;
export const GeneratePresignedUrlsDocument = gql`
    mutation generatePresignedUrls($urlGeneratorInput: [PresignedUrlInput]!) {
  generatePresignedUrls(urlGeneratorInput: $urlGeneratorInput) {
    presignedUrlObjs {
      s3Url
      objectKey
      fileName
    }
  }
}
    `;
export type GeneratePresignedUrlsMutationFn = Apollo.MutationFunction<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>;

/**
 * __useGeneratePresignedUrlsMutation__
 *
 * To run a mutation, you first call `useGeneratePresignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePresignedUrlsMutation, { data, loading, error }] = useGeneratePresignedUrlsMutation({
 *   variables: {
 *      urlGeneratorInput: // value for 'urlGeneratorInput'
 *   },
 * });
 */
export function useGeneratePresignedUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>(GeneratePresignedUrlsDocument, options);
      }
export type GeneratePresignedUrlsMutationHookResult = ReturnType<typeof useGeneratePresignedUrlsMutation>;
export type GeneratePresignedUrlsMutationResult = Apollo.MutationResult<GraphqlTypes.GeneratePresignedUrlsMutation>;
export type GeneratePresignedUrlsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>;
export const GetZenDeskFeatureFlagDocument = gql`
    query GetZenDeskFeatureFlag {
  devFeatures {
    lpZendeskMessagingWidget
  }
}
    `;

/**
 * __useGetZenDeskFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetZenDeskFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZenDeskFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZenDeskFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetZenDeskFeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetZenDeskFeatureFlagQuery, GraphqlTypes.GetZenDeskFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetZenDeskFeatureFlagQuery, GraphqlTypes.GetZenDeskFeatureFlagQueryVariables>(GetZenDeskFeatureFlagDocument, options);
      }
export function useGetZenDeskFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetZenDeskFeatureFlagQuery, GraphqlTypes.GetZenDeskFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetZenDeskFeatureFlagQuery, GraphqlTypes.GetZenDeskFeatureFlagQueryVariables>(GetZenDeskFeatureFlagDocument, options);
        }
// @ts-ignore
export function useGetZenDeskFeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetZenDeskFeatureFlagQuery, GraphqlTypes.GetZenDeskFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetZenDeskFeatureFlagQuery, GraphqlTypes.GetZenDeskFeatureFlagQueryVariables>;
export function useGetZenDeskFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetZenDeskFeatureFlagQuery, GraphqlTypes.GetZenDeskFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetZenDeskFeatureFlagQuery | undefined, GraphqlTypes.GetZenDeskFeatureFlagQueryVariables>;
export function useGetZenDeskFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetZenDeskFeatureFlagQuery, GraphqlTypes.GetZenDeskFeatureFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetZenDeskFeatureFlagQuery, GraphqlTypes.GetZenDeskFeatureFlagQueryVariables>(GetZenDeskFeatureFlagDocument, options);
        }
export type GetZenDeskFeatureFlagQueryHookResult = ReturnType<typeof useGetZenDeskFeatureFlagQuery>;
export type GetZenDeskFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetZenDeskFeatureFlagLazyQuery>;
export type GetZenDeskFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetZenDeskFeatureFlagSuspenseQuery>;
export type GetZenDeskFeatureFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GetZenDeskFeatureFlagQuery, GraphqlTypes.GetZenDeskFeatureFlagQueryVariables>;